(function () {
  'use strict';

  angular
    .module('user', ['ngAnimate', 'ngCookies', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr',
      'ngMaterial', 'ngTouch', 'angular-carousel', 'angulartics', 'angulartics.google.analytics',
      'angular-google-gapi', 'hc.marked', 'smoothScroll', 'rzModule', 'ui.utils.masks', 'ngIntlTelInput', 'ngImgCrop', 'textAngular',
      'uiGmapgoogle-maps', 'ngFileUpload', 'ngclipboard', 'ezfb', 'hl.sticky', '720kb.socialshare', 'ngDialog', 'ui.mask', 'ui.router.title',
      'ngMeta', 'credit-cards', 'uiCropper', 'ui.carousel', 'monospaced.qrcode'
    ]);

})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('terms-and-conditions', {
          url: '/terminos-y-condiciones',
          templateUrl: 'app/views/terms/termsAndConditions/termsAndConditions.html',
          controller: 'TermsAndConditionsController',
          controllerAs: 'terms-and-conditions',
          resolve: {
            termsAndConditions: function (AboutUsService) {
              return AboutUsService.getTermsAndConditions();
            }
          },
          data: {
            'meta': {
              'title': 'Términos y Condiciones',
                'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('TermsAndConditionsController', function ($scope, $state, termsAndConditions) {

      $scope.termsAndConditions = termsAndConditions;
      console.log('terminos', $scope.termsAndConditions );


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('privacy-policy', {
          url: '/politica-tratamiento-datos',
          templateUrl: 'app/views/terms/privacyPolicy/privacyPolicy.html',
          controller: 'PrivacyPolicyController',
          controllerAs: 'privacy-policy',
          resolve: {
            privatePolicy: function (AboutUsService) {
              return AboutUsService.getPrivatePolicy();
            }
          },
          data: {
            'meta': {
              'title': 'Política de Tratamiento de Datos',
                'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('PrivacyPolicyController', function ($scope, $state, $rootScope, privatePolicy) {

      $scope.privatePolicy = privatePolicy;
      console.log('privacy');


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('recovery-email-password', {
          url: '/recuperar-email-contrasena/:emailToken',
          templateUrl: 'app/views/password/recoveryEmailPassword/recoveryEmailPassword.html',
          controller: 'RecoveryEmailPasswordController',
          controllerAs: 'recovery-email-password',
          resolve: {
            emailToken: function ($stateParams) {
              return $stateParams.emailToken;
            },
            checkTokenResp: function (passwordService, emailToken) {
              return passwordService.checkPasswordEmailToken(emailToken);
            }
          },
          data: {
            'meta': {
              'title': 'Recuperar contraseña',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('RecoveryEmailPasswordController', function ($scope, $state, $rootScope, passwordService, emailToken, checkTokenResp) {


      console.log('recovery-email-password', checkTokenResp);
      if (checkTokenResp.valid) {
        $scope.show_form = true;
      }
      else {
        $scope.show_invalid = true;
      }

      $scope.changePassword = function (isValid) {
        if (isValid) {
          passwordService.changePasswordEmail($scope.password, emailToken, checkTokenResp.token).then(function (data) {
            // $state.go('home');
            if (data.changed) {
              $scope.show_menu = true;
              $scope.show_form = false;
            }
          }, function (err) {
            $scope.show_invalid = true;
            $scope.show_form = false;
          });
        }
      };

      $scope.goToHome = function () {
        $state.go('home', {}, {reload: true});
      };

      $scope.goToCow = function () {
        $state.go('cow-create');
      };


      $scope.goToForgotPassword = function () {
        $state.go('forgot-password');
      };


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('recovery-cellphone-password', {
          url: '/recuperar-celular-contrasena/:cellphoneToken',
          templateUrl: 'app/views/password/recoveryCellphonePassword/recoveryCellphonePassword.html',
          controller: 'RecoveryCellphonePasswordController',
          controllerAs: 'recovery-cellphone-password',
          resolve: {
            cellphoneToken: function ($stateParams) {
              return $stateParams.cellphoneToken;
            },
            checkTokenResp: function (passwordService, cellphoneToken) {
              return passwordService.checkPasswordCellphoneToken(cellphoneToken);
            }
          },
          data: {
            'meta': {
              'title': 'Recuperar contraseña',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('RecoveryCellphonePasswordController', function ($scope, $state, $rootScope, passwordService, cellphoneToken, checkTokenResp) {


      console.log('recovery-cellphone-password');
      if (checkTokenResp.valid) {
        $scope.show_form = true;
      } else {
        $scope.show_invalid = true;
      }

      $scope.changePassword = function (isValid) {
        if (isValid) {
          passwordService.changePasswordCellphone($scope.password, cellphoneToken, checkTokenResp.token).then(function (data) {
            if (data.changed) {
              $scope.show_menu = true;
              $scope.show_form = false;
            }
          }, function (err) {
            $scope.show_invalid = true;
            $scope.show_form = false;
          });
        }
      };

      $scope.goToHome = function () {
        $state.go('home', {}, {
          reload: true
        });
      };

      $scope.goToCow = function () {
        $state.go('cow-create');
      };

      $scope.goToForgotPassword = function () {
        $state.go('forgot-password');
      };

    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('forgot-password', {
          url: '/olvide-contrasena',
          templateUrl: 'app/views/password/forgotPassword/forgotPassword.html',
          controller: 'ForgotPasswordController',
          controllerAs: 'forgot-password',
          resolve: {},
          data: {
            'meta': {
              'title': 'Olvide mi contraseña',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('ForgotPasswordController', function ($scope, $state, $rootScope, passwordService) {


      console.log('forgot-password');
      $scope.forgotPasswordEmail = function (isValid) {
        if (isValid) {
          passwordService.forgotPasswordEmail($scope.email).then(function (data) {
            if (data.email_sent) {
              $scope.emailSended = true;
              $scope.emailSendedMessage = "Correo enviado";
              $scope.errorEmailSended = false;
            }
            else {
              $scope.emailSended = false;
              $scope.errorEmailSended = true;
              $scope.errorEmailMessage = "El correo electrónico no es correcto o te encuentras registrado con tu cuenta de Google o Facebook";
            }
          }, function (err) {
            $scope.errorEmailSended = true;
            $scope.errorEmailMessage = "Se presento un error, por favor inténtalo mas tarde.";
          });
        }
      };

      $scope.forgotPasswordCellphone = function (isValid) {
        if (isValid) {
          passwordService.forgotPasswordCellphone($scope.cellphone).then(function () {
            $scope.cellphoneSended = true;
            $scope.cellphoneSendedMessage = "Mensaje de texto enviado al número celular registrado.";
            $scope.errorCellphoneSended = false;
          }, function (err) {
            $scope.errorCellphoneSended = true;
            $scope.errorCellphoneMessage = "Se presento un error, por favor inténtalo mas tarde.";
          });
        }
      };

      $scope.confirmCellphoneCode = function (isValid) {
        if (isValid) {
          $state.go('recovery-cellphone-password', {
            cellphoneToken: $scope.cellphone_code
          });
        }
      };


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('fep-cow-participate', {
          url: '/participante-alcancia-fep/:cowId?id_pago',
          templateUrl: 'app/views/fep/fepParticipate/fepParticipate.html',
          controller: 'FepParticipateController',
          controllerAs: 'fep-participate',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            paymentId: function ($stateParams) {
              return $stateParams.id_pago;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCowPublic(cowId);
            },
            matrixCommissions: function (paymentService) {
              return paymentService.getMatrixComissionsList();
            }
          },
          data: {
            'meta': {
              'title': 'Participar Alcancía FEP',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('FepParticipateController', function ($scope, $state, $rootScope, usersService, $stateParams, cowId, $log, cow, toastr, participationService,
                                                   ruteCode, urlPart1, urlPart2, $window, minPaymentValue, matrixCommissions, paymentService,
                                                   $mdDialog, paymentId, smoothScroll, additionalParticipantFee, psePaymentCode, ccPaymentCode,
                                                   maxPaymentValue) {

      $state.go('fep404', {reload: true});

      if (cow.deleted) {
        $state.go('cow-deleted', {
          cowId: cowId
        });
      }
      if (cow.closed) {
        $state.go('fep-cow', {
          cowId: cowId
        });
      }

      $scope.minPaymentValue = minPaymentValue;
      $scope.maxPaymentValue = maxPaymentValue;

      $scope.today = moment();
      $scope.actualMonth = $scope.today.month();
      $scope.actualYear = $scope.today.year() - 2000;

      $scope.cow_event = cow;
      console.log($scope.cow_event);

      $scope.matrixCommissions = matrixCommissions;
      // console.log($scope.matrixCommissions);

      $scope.user_participation = {
        cow_id: cowId,
        send_promotional_emails: true,
        fixed_participants: "1",
        force_payment_pending: false,
        save_credit_card: false
      };

      $scope.user_participation.participantsOptions = [];

      $scope.additionalValues = [];

      $scope.previous_payment = 0;

      $scope.valueToGoal = $scope.cow_event.cow_goal - $scope.cow_event.total_value_to_date_left;
      console.log($scope.valueToGoal);

      $scope.createUpdateArrayParticipantsOptions = function () {
        var lenght = parseInt($scope.user_participation.fixed_participants);
        var i;
        for (i = 0; i < lenght; i++) {
          var elementTemp = {
            id: i
          };
          $scope.user_participation.participantsOptions.push(elementTemp);
        }
      };

      $scope.createUpdateArrayParticipantsOptions();
      // $scope.optionsParticipants = [$scope.user_participation.fixed_participants];
      console.log($scope.user_participation.participantsOptions);

      $scope.payment_redirect = false;

      $scope.total_amount_readonly = false;

      $scope.commission_value_matrix = 0.10;

      $scope.discount_value = 0;

      $scope.cow_has_gift_code = false;

      $scope.user_participation.document_type = 1;

      $scope.gift_code_obj = {};

      $scope.acceptTermsConditions = false;

      if ($scope.cow_event.gift_code) {
        $scope.cow_has_gift_code = true;
        if ($scope.cow_event.gift_code.type == 0 || $scope.cow_event.gift_code.type == 1 ||
          $scope.cow_event.gift_code.type == 2) {
          $scope.gift_code_obj = $scope.cow_event.gift_code;
          $scope.user_participation.gift_code = $scope.gift_code_obj.slug;
        }
      }

      $scope.additionalParticipantFee = additionalParticipantFee;
      $scope.multiple_participants_fee = 0;

      if ($scope.cow_event.marketplace) {
        $scope.minPaymentValue = 1;
        $scope.maxPaymentValue = $scope.cow_event.cow_goal - $scope.cow_event.total_value;
      }

      $scope.calculateCommissionAmmountPercentange = function () {
        $scope.commission_value_all = $scope.user_participation.total_value * $scope.commission_value_matrix;

        if ($scope.cow_event.marketplace) {
          $scope.commission_value_all = 0;
        }

        if ($scope.gift_code_obj.valid) {
          if ($scope.gift_code_obj.type == 0) {
            $scope.discount_value = $scope.gift_code_obj.percentage_value * $scope.commission_value_all;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          }
          else if ($scope.gift_code_obj.type == 1) {
            $scope.discount_value = $scope.gift_code_obj.int_value;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          }
          else if ($scope.gift_code_obj.type == 2) {
            $scope.discount_value = 0;
            $scope.commission_value_all = $scope.gift_code_obj.int_value;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          }
          if ($scope.cow_event.commission_added) {
            $scope.commission_value = $scope.commission_value_all;
            $scope.total_value_commission = $scope.user_participation.total_value + $scope.commission_value - $scope.discount_value
              + $scope.multiple_participants_fee;
          } else if ($scope.cow_event.commission_deducted) {
            $scope.commission_value = $scope.commission_value_all - $scope.discount_value + $scope.multiple_participants_fee;
            $scope.total_value_commission = $scope.user_participation.total_value;
          }
        }
        else {
          if ($scope.cow_event.commission_added) {
            $scope.commission_value = $scope.commission_value_all;
            $scope.total_value_commission = $scope.user_participation.total_value + $scope.commission_value + $scope.multiple_participants_fee;
          } else if ($scope.cow_event.commission_deducted) {
            $scope.commission_value = $scope.commission_value_all + $scope.multiple_participants_fee;
            $scope.total_value_commission = $scope.user_participation.total_value;
          }
        }
      };

      $scope.calculateCommissionAmmountFixed = function () {
        $scope.commission_value_all = $scope.commission_value_matrix;

        if ($scope.cow_event.marketplace) {
          $scope.commission_value_all = 0;
        }

        if ($scope.gift_code_obj.valid) {
          if ($scope.gift_code_obj.type == 0) {
            $scope.discount_value = $scope.gift_code_obj.percentage_value * $scope.commission_value_matrix;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          }
          else if ($scope.gift_code_obj.type == 1) {
            $scope.discount_value = $scope.gift_code_obj.int_value;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          }
          else if ($scope.gift_code_obj.type == 2) {
            $scope.discount_value = 0;
            $scope.commission_value_all = $scope.gift_code_obj.int_value;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          }

          if ($scope.cow_event.commission_added) {
            $scope.commission_value = $scope.commission_value_all;
            $scope.total_value_commission = $scope.user_participation.total_value + $scope.commission_value - $scope.discount_value
              + $scope.multiple_participants_fee;
          } else if ($scope.cow_event.commission_deducted) {
            $scope.commission_value = $scope.commission_value_all - $scope.discount_value + $scope.multiple_participants_fee;
            $scope.total_value_commission = $scope.user_participation.total_value;
          }
        }
        else {
          if ($scope.cow_event.commission_added) {
            $scope.commission_value = $scope.commission_value_all;
            $scope.total_value_commission = $scope.user_participation.total_value + $scope.commission_value + $scope.multiple_participants_fee;
          } else if ($scope.cow_event.commission_deducted) {
            $scope.commission_value = $scope.commission_value_all + $scope.multiple_participants_fee;
            $scope.total_value_commission = $scope.user_participation.total_value;
          }
        }

      };

      $scope.getOptionAdditionalValue = function (optionType, optionId) {

        var optionTypeTemp = _.find($scope.cow_event.options.custom_options, function (o) {
          return o.option_type.id == optionType;
        });

        var optionIdTemp = _.find(optionTypeTemp.options, function (op) {
          return op.id == optionId;
        });

        return optionIdTemp;
      };

      $scope.totalValueChanged = function () {

        if ($scope.cow_event.participation_fixed) {
          $scope.user_participation.total_value = $scope.cow_event.participant_value_fixed * $scope.user_participation.fixed_participants;
          $scope.multiple_participants_fee = $scope.additionalParticipantFee * ($scope.user_participation.fixed_participants - 1);
        };

        if ($scope.cow_event.options && $scope.cow_event.has_options && $scope.cow_event.participation_fixed) {
          $scope.additionalValues = [];
          _.forEach($scope.user_participation.participantsOptions, function (value) {
            var participantAdditionalValue = 0

            _.forEach(value.options, function (value_opt) {
              console.log(value.options);
              var value_opt_array = value_opt.split('-');
              var optionType = value_opt_array[0];
              var optionId = value_opt_array[1];

              var optionFound = $scope.getOptionAdditionalValue(optionType, optionId);
              console.log(optionFound);

              $scope.user_participation.total_value += optionFound.additional_value;

              participantAdditionalValue += optionFound.additional_value;
            });

            var additionalValueObj = {
              additionalValue: participantAdditionalValue
            };

            $scope.additionalValues.push(additionalValueObj);
            console.log($scope.additionalValues);
          });
        };

        if ($scope.user_participation.total_value >= $scope.minPaymentValue && $scope.user_participation.total_value <= $scope.maxPaymentValue) {
          var commTemp = _.find($scope.matrixCommissions, function (o) {
            return o.min_value <= $scope.user_participation.total_value && o.max_value > $scope.user_participation.total_value;
          });
          if ($scope.gift_code_obj.max_value < $scope.user_participation.total_value || $scope.gift_code_obj.min_value > $scope.user_participation.total_value) {
            $scope.gift_code_obj = {};
            $scope.gift_code = '';
            delete $scope.user_participation.gift_code;
          }
          if (commTemp) {
            if (commTemp.fixed) {
              $scope.commission_value_matrix = commTemp.fixed_value;
              $scope.calculateCommissionAmmountFixed();
            } else if (commTemp.percentage) {
              $scope.commission_value_matrix = commTemp.percentage_value;
              $scope.calculateCommissionAmmountPercentange();
            } else {
              $scope.commission_value_matrix = 0.10;
              $scope.calculateCommissionAmmountPercentange();
            }
          } else {
            $scope.commission_value_matrix = 0.10;
            $scope.calculateCommissionAmmountPercentange();
          }
        }
      };

      if ($scope.cow_event.participation_fixed) {
        $scope.user_participation.total_value = $scope.cow_event.participant_value_fixed;
        $scope.totalAmountReadOnly = true;
        $scope.totalValueChanged();
      } else if ($scope.cow_event.participation_suggested) {
        $scope.user_participation.total_value = $scope.cow_event.participant_value_suggested;
        $scope.totalValueChanged();
      }

      usersService.getUserData().then(function (data) {
        $scope.user = data.user;
        console.log($scope.user);
        $scope.user_participation.first_name = $scope.user.user.first_name;
        $scope.user_participation.last_name = $scope.user.user.last_name;
        $scope.user_participation.email = $scope.user.user.email;
        $scope.user_participation.document_number = $scope.user.document_number;
        $scope.user_participation.document_full_number = $scope.user.document_full_number;
        $scope.user_participation.save_credit_card = true;
        if ($scope.user.document_type == 1 || $scope.user.document_type == 2 ||
          $scope.user.document_type == 3 || $scope.user.document_type == 4) {
          $scope.user_participation.document_type = $scope.user.document_type;
        }
        if ($scope.user.cellphone) {
          $scope.user_participation.cellphone = $scope.user.cellphone.toString();
        }

        // if (!$scope.cow_event.options && !$scope.cow_event.has_options) {
        //   $scope.submitPersonalForm($scope.personalInfoForm.$valid);
        // }

        paymentService.getUserCreditCards().then(function (data) {
          $scope.userCreditCards = data.credit_cards;
          console.log(data);

        }, function (err) {
        });
      }, function (err) {
      });


      if (paymentId) {
        paymentService.getPaymentData(paymentId).then(function (data) {
          $scope.participant_data = data.payment_data.participant;
          console.log($scope.participant_data);

          $scope.user_participation.first_name = $scope.participant_data.first_name;
          $scope.user_participation.last_name = $scope.participant_data.last_name;
          if ($scope.participant_data.document_type == 1 || $scope.participant_data.document_type == 2 ||
            $scope.participant_data.document_type == 3 || $scope.user.document_type == 4) {
            $scope.user_participation.document_type = $scope.participant_data.document_type;
          }
          $scope.user_participation.document_number = $scope.participant_data.document_number;
          $scope.user_participation.document_full_number = $scope.user.document_full_number;
          $scope.user_participation.email = $scope.participant_data.email;
          $scope.user_participation.cellphone = $scope.participant_data.cellphone.toString();

          $scope.submitPersonalForm($scope.personalInfoForm.$valid);
        });
      }

      $scope.setDocumentNumber = function () {
        if ($scope.user_participation.document_full_number) {
          $scope.user_participation.document_number = $scope.user_participation.document_full_number.replace(/[^0-9]/g, '');
        }
      };

      $scope.setDocumentFullNumber = function () {
        if ($scope.user_participation.document_number) {
          $scope.user_participation.document_full_number = $scope.user_participation.document_number;
        }
      };

      $scope.participateCow = function (isValid) {
        if (isValid) {
          $scope.createParticipation();
        }
        else {
          var element = document.getElementById('top-scroll');
          smoothScroll(element);
        }
      };

      $scope.createParticipation = function () {
        participationService.createParticipation(
          $scope.user_participation
        ).then(function (data) {
          // console.log('updated', data);
          if (data.pending) {
            $scope.toastPending();
            $scope.previous_payment = data.previous_payment
          }
          else if (!data.valid && data.blacklist) {
            toastr.info('Ha ocurrido un error con los datos suministrados, comunicate con nosotros para más información.');
          }
          else {
            if ($scope.pseCollapsed == false) {
              var url_final = urlPart1 + ruteCode + urlPart2 + data.zona_virtual_id;
              // location.href = url_final;
              $scope.payment_redirect = true;
              $window.location.href = url_final;
              // console.log(url_final);
            }
            else {
              console.log(data);
              $state.go('payment-respond', {id_pago: data.payment_id});
            }

          }
        }, function (err) {
          console.log('err login', err);
          toastr.error('Si el error persiste, comunicate con nosotros.', 'Error creando la solicitud.');
        });
      };


      $scope.checkPreviousParticipation = function () {
        $state.go('payment-respond', {id_pago: $scope.previous_payment});
      };

      $scope.toastPending = function () {
        $scope.payment_pending = true;
        toastr.info('En este momento tienes un pago pendiente, inténtalo mas tarde.', 'Pago pendiente');
      };

      $scope.applyCoupon = function () {
        if ($scope.gift_code == '' || $scope.gift_code == undefined) {
          if ($scope.user_participation.total_value < $scope.minPaymentValue && $scope.user_participation.total_value < $scope.maxPaymentValue) {
            toastr.info('Primero debes ingresar un valor');
          }
          else {
            toastr.info('Debes ingresar el código promocional con mayúsculas y minúsculas');
          }
        }
        else if (($scope.user_participation.total_value < $scope.minPaymentValue && $scope.user_participation.total_value > $scope.maxPaymentValue) || $scope.user_participation.total_value == undefined) {
          toastr.info('Primero debes ingresar un valor');
        }
        else {
          var data_gift_code = {
            gift_code: $scope.gift_code,
            payment_value: $scope.user_participation.total_value
          };
          paymentService.validateGiftCode(data_gift_code).then(function (data) {
            console.log(data);
            $scope.gift_code_obj = data;
            $scope.totalValueChanged();
            $scope.user_participation.gift_code = $scope.gift_code_obj.slug;
            toastr.success('Código aplicado con éxito');
          }, function (err) {
            console.log('err login', err);
            toastr.error('El código no es válido o se encuentra mal escrito');
          });
        }

      };

      $scope.scrollToTop = function () {
        var element = document.getElementById('top-scroll');
        smoothScroll(element);
      };

      $scope.$watch('user_participation.total_value', function (newValue, oldValue) {

        if (newValue == 0) {
          delete $scope.user_participation.total_value;
          console.log('loggi');
        }
      });

      $scope.$watch('user_participation.fixed_participants', function (newValue, oldValue) {

        console.log(newValue);
        console.log(oldValue);
        console.log($scope.user_participation.participantsOptions);

        if (newValue > oldValue) {
          var diff = newValue - oldValue;
          var i;
          for (i = 0; i < diff; i++) {
            var elementTemp = {
              id: ($scope.user_participation.participantsOptions.length)
            };
            $scope.user_participation.participantsOptions.push(elementTemp);
          };
        }
        else if (newValue < oldValue) {
          var diff = newValue;
          console.log(diff);
          var i;
          for (i = $scope.user_participation.participantsOptions.length; i >= diff; i--) {
            $scope.user_participation.participantsOptions.splice(i, 1);
          };
        }

        $scope.totalValueChanged();
      });

      $scope.showPersonalInfoForm = true;
      $scope.submitPersonalForm = function (isValid) {
        if (isValid) {
          $scope.showPersonalInfoForm = false;
        }
      };

      $scope.submitPayment = function () {
        $scope.personalInfoForm.$setSubmitted();
        $scope.participationForm.$setSubmitted();


        $scope.personalInfoValid = $scope.personalInfoForm.$valid;
        $scope.participationValid = $scope.participationForm.$valid;
        $scope.amex = $scope.ccForm.ccNumber.$ccEagerType == 'American Express';

        $scope.personalAndParticipationInfoValid = $scope.personalInfoValid && $scope.participationValid;

        console.log($scope.personalInfoValid);
        console.log($scope.participationValid);
        console.log($scope.personalAndParticipationInfoValid);


        if ($scope.user_participation.total_value < $scope.minPaymentValue || $scope.user_participation.total_value > $scope.maxPaymentValue) {
          $scope.personalAndParticipationInfoValid = false;
        }

        if ($scope.user_participation.total_value > $scope.valueToGoal) {
          $scope.personalAndParticipationInfoValid = false;
        }

        if (($scope.valueToGoal - $scope.minPaymentValue) < $scope.user_participation.total_value &&
          $scope.user_participation.total_value < $scope.valueToGoal) {
          $scope.personalAndParticipationInfoValid = false;
        }

        if ($scope.personalAndParticipationInfoValid && !$scope.amex) {
          if ($scope.ccCollapsed == true && $scope.pseCollapsed == true) {
            toastr.info('Debes seleccionar un método de pago', 'Método de pago');
          }
          else if ($scope.ccCollapsed == false) {
            $scope.ccForm.$setSubmitted();
            $scope.ccValid = $scope.ccForm.$valid;
            console.log($scope.ccValid);
            // console.log($scope.ccForm);
            if ($scope.ccValid && !$scope.creditCardSelected) {
              $scope.user_participation.payment_method = ccPaymentCode;
              $scope.user_participation.card.type = $scope.ccForm.ccNumber.$ccType;
              $scope.user_participation.pay_with_token = false;
              $scope.isCcSummary();
              $scope.showPaymentMethods();
            }
            else if ($scope.creditCardSelected) {
              $scope.user_participation.payment_method = ccPaymentCode;
              $scope.user_participation.credit_card_token = $scope.creditCardSelected;
              $scope.user_participation.pay_with_token = true;
              $scope.isCcTokenSummary();
              $scope.showPaymentMethods();
            }
          }
          else if ($scope.pseCollapsed == false) {
            $scope.user_participation.payment_method = psePaymentCode;
            $scope.isPSESummary();
            $scope.showPaymentMethods();
          }
        }
        else {
          toastr.info('Por favor verifica todos los campos', 'Participación incorrecta');
          $scope.scrollToTop();
        }
      };

      $scope.showPersonalInfoFormEdit = function () {
        $scope.showPersonalInfoForm = true;
      };

      $scope.pseCollapsed = true;
      $scope.paymentMethodToPse = function () {
        $scope.pseCollapsed = !$scope.pseCollapsed;
        $scope.ccCollapsed = true;
        if ($scope.creditCardSelected) {
          $scope.creditCardSelected.checked = false;
          delete $scope.creditCardSelected;
        }
      };

      $scope.ccCollapsed = true;
      $scope.paymentMethodToCc = function () {
        $scope.ccCollapsed = !$scope.ccCollapsed;
        $scope.pseCollapsed = true;
      };

      $scope.checkedChanged = function (creditCard) {
        _.forEach($scope.userCreditCards, function (value) {
          if (creditCard.id == value.id) {
            console.log(value);
            if (value.checked == true) {
              console.log("as");
              $scope.creditCardSelected = value;
            }
            else {
              console.log("ad");
              delete $scope.creditCardSelected;
            }
          } else {
            value.checked = false;
          }
        });
      };


      $scope.showPaymentMethods = function () {
        $scope.showSummary = true;
        $scope.showPersonalDataForm = false;
        $scope.scrollToTop();
      };

      $scope.confirmPayment = function () {
        if ($scope.acceptTermsConditions) {
          $scope.participateCow(true);
        }
        else {
          toastr.info("Debes aceptar los términos y condiciones y política de tratamiento de datos")
        }
      };

      $scope.backToPersonalDataForm = function () {
        $scope.showSummary = false;
        $scope.showPersonalDataForm = true;
      };

      $scope.isPSESummary = function () {
        $scope.pseSummary = true;
        $scope.ccSummary = false;
        $scope.ccTokenSummary = false;
      };

      $scope.isCcSummary = function () {
        $scope.pseSummary = false;
        $scope.ccSummary = true;
        $scope.ccTokenSummary = false;
        // $scope.strCcNumber = $scope.ccForm.ccNumber.toString();
        $scope.strCcNumber = $scope.user_participation.card.number;
        $scope.ccLastNumbers = $scope.strCcNumber.substring(12, 16);
      };

      $scope.isCcTokenSummary = function () {
        $scope.pseSummary = false;
        $scope.ccSummary = false;
        $scope.ccTokenSummary = true;
      };

      $scope.showPersonalDataForm = true;

      $scope.goToFepCow = function (cowId) {
        $state.go('fep-cow', {cowId: cowId}, {reload: true});
      };

    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('fep-login', {
          url: '/iniciar-sesion-alcancia-fep?response_url',
          templateUrl: 'app/views/fep/fepLogin/fepLogin.html',
          controller: 'FepLoginController',
          controllerAs: 'fep-login',
          resolve: {},
          data: {
            'meta': {
              'title': 'Iniciar sesión',
              'description': 'Inicia sesión con Facebook o Google en ArmaTuVaca.com.'
            }
          }
        })
    })
    .controller('FepLoginController', function ($scope, $state, $rootScope, $stateParams, usersService, GAuth, toastr) {

      $scope.showNoFepCow = false;

      $scope.checkIsLogged = function () {
        usersService.isLoggedIn().then(function (data) {
          if (data.login) {
            $scope.goToFepCow();
          }
        }, function (err) {
          toastr.error('Error iniciando sesión');
        });
      };

      $scope.checkIsLogged();

      $scope.user = {};

      $scope.loginUser = function (isValid) {
        if (isValid) {
          usersService.login($scope.user.email,
            $scope.user.password
          ).then(function (data) {
              $scope.goToFepCow();
          }, function (err) {
            $scope.errorSended = true;
            $scope.errorMessage = "Usuario y/o contraseña incorrectos";
          });
        }
      };

      $scope.loginFb = function () {
        var send_welcome_email = false;
        usersService.loginFb(send_welcome_email).then(function (data) {
          $scope.goToFepCow();
        }, function (err) {
          $rootScope.errorSended = true;
          $scope.errorMessage = "Usuario y/o contraseña incorrectos";
        });
      };

      $scope.loginGg = function () {
        var send_welcome_email = false;
        GAuth.login().then(function (user) {
          GAuth.getToken().then(function(token_response){
            usersService.loginGg(token_response.access_token, send_welcome_email).then(function (data) {
              $scope.goToFepCow();
            }, function (err) {
              $rootScope.errorSended = true;
              $scope.errorMessage = "Usuario y/o contraseña incorrectos";
            });
          }, function () {
            console.log('token error');
          });
        }, function () {
          console.log('login fail');
        });
      };
      
      $scope.goToFepCow = function () {
        usersService.getFepCow().then(function (data) {
          console.log(data);

          if (data.exist === true) {
            var cowId = data.fep_cow_id;
            $state.go('fep-cow-admin', {cowId: cowId}, {reload: true});
          }
          else {
            $scope.showNoFepCow = true;
            if($stateParams.response_url){
              document.location.href = $stateParams.response_url;
            }
          }
        })
      }

    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('fep-cow', {
          url: '/alcancia-fep/:cowId',
          templateUrl: 'app/views/fep/fepCow/fepCow.html',
          controller: 'FepCowController',
          controllerAs: 'fep-cow-controller',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCowPublic(cowId);
            },
            data: function (ngMeta, cow, atvURL, fepCowPublicURL, cowId, fbAPI) {

              var imgUrl = cow.main_img.substring(8);
              ngMeta.setTitle(cow.name);
              ngMeta.setTag('description', 'Alcancía FEP 2019');
              ngMeta.setTag('og:url', atvURL + fepCowPublicURL + cowId);
              ngMeta.setTag('og:title', cow.name);
              ngMeta.setTag('og:type', 'website');
              ngMeta.setTag('og:description', 'Alcancía FEP 2019');
              ngMeta.setTag('og:image', cow.main_img);
              ngMeta.setTag('fb:app_id', fbAPI);
              ngMeta.setTag('twitter:url', atvURL + fepCowPublicURL + cowId);
              ngMeta.setTag('twitter:title', cow.name);
              ngMeta.setTag('twitter:description', 'Alcancía FEP 2019');
              ngMeta.setTag('twitter:image', cow.main_img);
              ngMeta.setTag('robots', 'noindex, nofollow');
            }
          },
          meta: {
            disableUpdate: true
          }
        })
    })
    .controller('FepCowController', function ($scope, $state, $rootScope, usersService, $stateParams, $log, cowBusinessTypeFEP,
                                           cowId, cow, toastr, atvURL, fepCowPublicURL, ngDialog, paymentService) {
      if (cow.deleted) {
        $state.go('fep-cow-deleted', {
          cowId: cowId
        });
      }

      if (cow.is_business !== true || cow.business_type !== cowBusinessTypeFEP) {
        $state.go('cow', {cowId: cowId}, {reload: true});
      }

      $scope.cow_event = cow;
      console.log($scope.cow_event);
      $scope.cowclosed = cow.closed;

      var eventDate = new Date($scope.cow_event.event_date);
      $scope.eventDateString = eventDate.getDate() + "/" + (eventDate.getMonth() + 1) + "/" + eventDate.getFullYear();


      $scope.cowPublicURLComplete = atvURL + fepCowPublicURL + cowId;
      $scope.cowPublicURLCompleteCopy = atvURL + fepCowPublicURL + cowId;

      $scope.fepCowCompleted = $scope.cow_event.total_value_to_date_left >= $scope.cow_event.cow_goal;

      $scope.modalParticipants = function (contacts) {
        paymentService.getCowEventParticipantsPublicList(cowId).then(function (data) {
            console.log(data);
            ngDialog.open({
              template: 'participantsModal-1',
              data: {
                cow: $scope.cow_event,
                participants: data
              }
            });
          },
          function (err) {
            toastr.error('Error obteniendo los participantes');
          });

      };
      if ($scope.cow_event.show_location_point) {
        $scope.map = {
          center: {
            latitude: $scope.cow_event.location_point.latitude,
            longitude: $scope.cow_event.location_point.longitude
          },
          zoom: 16
        };
        $scope.marker = {
          id: 0,
          coords: {
            latitude: $scope.cow_event.location_point.latitude,
            longitude: $scope.cow_event.location_point.longitude
          },
          options: {
            draggable: false,
            icon: 'assets/images/map-pin.png'
          }
        };
      }

      $scope.goToFepCowParticipate = function (cowId) {
        $state.go('fep-cow-participate', {cowId: cowId}, {reload: true});
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('fep-cow-temp', {
          url: '/crear-alcancia-fep?ticket_type?num_tickets',
          templateUrl: 'app/views/fep/fepCowTempLogin/fepCowTempLogin.html',
          controller: 'FepCowTempController',
          controllerAs: 'fep-cow-temp',
          resolve: {
            ticket_type: function ($stateParams) {
              return $stateParams.ticket_type;
            },
            num_tickets: function ($stateParams) {
              return $stateParams.num_tickets;
            }
          },
          data: {
            'meta': {
              'title': 'Crear Alcancía FEP',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('FepCowTempController', function ($scope, $state, $rootScope, usersService, $stateParams,$log, toastr,
                                                  cowEventService, GAuth, $window, ngDialog, ticket_type, num_tickets) {

      $state.go('fep404', {reload: true});

      if (ticket_type == 0) {
        ticket_type = 2;
      }
      else if (ticket_type == 1) {
        ticket_type = 3;
      }

      $scope.checkIsLogged = function () {
        usersService.isLoggedIn().then(function (data) {
          if (data.login) {
            usersService.logout();
          }
        }, function (err) {
          toastr.error('Error iniciando sesión');
        });
      };

      $scope.checkIsLogged();

      $scope.fepCowExist = false;

      $scope.checkUserFepCow = function () {
        usersService.getFepCow().then(function (data) {
          if (data.valid === true && data.exist === true) {
            $scope.fepCowId = data.fep_cow_id;
            console.log($scope.fepCowId);
            $scope.fepCowExist = true;
          }
          else if(data.valid === false && data.exist === true) {
            toastr.error('Error obteniendo alcancía del usuario');
          }
          else {
            $scope.createFepUserCow();
          }
        }, function (err) {
          toastr.error('Error obteniendo alcancía del usuario');
        })
      };

      $scope.todayDate = new Date();
      $scope.maxDate = new Date(
        $scope.todayDate.getFullYear() - 18,
        $scope.todayDate.getMonth(),
        $scope.todayDate.getDate());
      $scope.todayDate_format = $scope.maxDate.getDay() + '/' + $scope.maxDate.getMonth() + '/' + $scope.maxDate.getFullYear();

      $scope.user = {};

      $scope.registerNewUser = function (isValid) {
        if ($scope.user.born_date && $scope.showDateError) {
          toastr.info('Por favor ingresa una fecha de nacimiento valida', 'Registro incompleto');
        } else if (isValid) {
          var send_welcome_email = false;
          usersService.registerNewUser($scope.user.first_name,
            $scope.user.last_name,
            $scope.user.born_date,
            $scope.user.email,
            $scope.user.password,
            send_welcome_email
          ).then(function () {
            $scope.createFepUserCow();
          }, function (err) {
            try {
              if (err.data.error_text_msg) {
                $scope.errorSended = true;
                $scope.errorMessage = err.data.error_text_msg;
              } else {
                $scope.errorSended = true;
                $scope.errorMessage = "Se presentó un error intentando realizar el registro, inténtalo mas tarde. Sí el error persiste, comunicate con nosotros.";
              }
            } catch (err) {
              $scope.errorSended = true;
              $scope.errorMessage = "Se presentó un error intentando realizar el registro, inténtalo mas tarde. Sí el error persiste, comunicate con nosotros.";
            }
          });
        }
      };

      $scope.loginFb = function () {
        var send_welcome_email = false;
        usersService.loginFb(send_welcome_email).then(function (data) {
          $scope.checkUserFepCow();
        }, function (err) {
          $rootScope.errorSended = true;
          $rootScope.errorMessage = "Usuario y/o contraseña incorrectos";
        });
      };

      $scope.loginGg = function () {
        var send_welcome_email = false;
        GAuth.login().then(function (user) {
          GAuth.getToken().then(function(token_response){
            usersService.loginGg(token_response.access_token, send_welcome_email).then(function (data) {
              $scope.checkUserFepCow();
            }, function (err) {
              $rootScope.errorSended = true;
              $scope.errorMessage = "Usuario y/o contraseña incorrectos";
            });
          }, function () {
            console.log('token error');
          });

        }, function () {
          console.log('login fail');
        });
      };

      $scope.loginUser = function (isValid) {
        if (isValid) {
          usersService.login($scope.user.email,
            $scope.user.password
          ).then(function () {
            $scope.checkUserFepCow();
          }, function (err) {
            $rootScope.errorSended = true;
            $rootScope.errorMessage = "Usuario y/o contraseña incorrectos";
          });
        }
      };

      $scope.createFepUserCow = function () {
        cowEventService.createFepCow(ticket_type, num_tickets).then(function (data) {
          console.log(data);
          if (data.valid === false && data.blacklist === true) {
            toastr.error('Hubo un problema validando tus datos, contáctate con nosotros', 'Error de validación')
          }
          else {
            var cowId = data.cow_id;
            $state.go('fep-cow-admin', {cowId: cowId}, {reload: true});
          }
        }, function (err) {
          usersService.logout();
          toastr.error('Si el error persiste, comunicate con nosotros.', 'Error creando la Vaca');
        });
      };

      $scope.showDateError = false;
      $scope.dateBornValidator = function (isCompleted) {
        if ($scope.user.born_date && isCompleted) {
          if ($scope.user.born_date > $scope.maxDate) {
            $scope.showDateError = true;
          }
        } else {
          $scope.showDateError = false;
        }
      };

      $scope.goToFepCow = function () {
        $state.go('fep-cow-admin', {cowId: $scope.fepCowId}, {reload: true});
      };

      $scope.showBenefitsInfo = function () {
        ngDialog.open({
          template: 'atvBenefitsInfoModal',
          data: {},
          controller: 'ATVBenefitsInfoModalCtrl'
        });
      };
      // $scope.showBenefitsInfo();
    })
    .controller('ATVBenefitsInfoModalCtrl', function ($scope, ngDialog, cowEventService, toastr) {
      $scope.closeBenefitsInfoModal = function (closeId) {
        ngDialog.close(closeId);
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('fep-cow-admin', {
          url: '/administrar-alcancia-fep/:cowId',
          templateUrl: 'app/views/fep/fepCowAdmin/fepCowAdmin.html',
          controller: 'FepCowAdminController',
          controllerAs: 'fep-cow-admin',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCow(cowId);
            }
          },
          data: {
            'meta': {
              'title': 'Administrador Alcancia Fep',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('FepCowAdminController', function ($scope, $state, $rootScope, usersService, $stateParams,
                                                cowId, $log, cow, toastr, atvURL, cowPublicURL,
                                                fbAPI, cowEventService, ngDialog, GAuth, paymentService, ivaAtvTax,
                                                fepSingleTicketSlug, fepSingleTicketPrice, cowBusinessTypeFEP,
                                                fepSingleTicketStage2Slug, fepSingleTicketStage2Price) {

      console.log(cow);

      if (cow.is_business !== true || cow.business_type !== cowBusinessTypeFEP) {
        $state.go('cow', {cowId: cowId}, {reload: true});
      }

      $scope.ivaAtvTax = ivaAtvTax;

      $scope.cow_event = cow;
      $scope.cowclosed = cow.closed;
      $scope.cowclosed_moneyrequest = cow.closed_money_request;

      $scope.fepTicketBooked = $scope.cow_event.total_value_to_date_left >= ($scope.cow_event.cow_goal * 0.1);

      $scope.requestUserCellphone = function (user, cowId) {
        ngDialog.open({
          template: 'requestCellphoneModal',
          data: {
            user: user,
            cowId: cowId
          },
          controller: 'RequestCellphoneModalCtrl'
        });
      };

      $scope.requestUserDocument = function (user, cowId) {
        ngDialog.open({
          template: 'requestDocumentNumberModal',
          data: {
            user: user,
            cowId: cowId
          },
          controller: 'RequestDocumentNumberModalModalCtrl'
        });
      };

      $scope.checkUserAdmin = function () {
        if (cow.deleted) {
          $state.go('fep-cow-deleted', {
            cowId: cowId
          });
        }
        else {
          usersService.getUserData().then(function (data) {
            if (data.user.id != cow.user) {
              $state.go('fep-cow', {
                cowId: cowId
              });
            }
            else if (data.user.document_number == null && $scope.fepTicketBooked) {
              $scope.requestUserDocument(data.user, cowId);
            }
            else if (data.user.cellphone == null) {
              $scope.requestUserCellphone(data.user, cowId);
            }
            $scope.adminUser = true;
            $scope.userDocument = data.user.document_number;
          }, function (err) {
            $scope.adminUser = false;
            console.log('no login');
          });
        }
      };

      $scope.checkUserAdmin();

      var eventDate = new Date($scope.cow_event.event_date);
      $scope.eventDateString = eventDate.getDate() + "/" + (eventDate.getMonth() + 1) + "/" + eventDate.getFullYear();

      $scope.cowPublicURLComplete = atvURL + cowPublicURL + cowId;
      $scope.cowPublicURLCompleteCopy = atvURL + cowPublicURL + cowId;

      $scope.main_img_raw = $scope.cow_event.main_img_raw;

      if ($scope.cow_event.description != null && $scope.cow_event.description != '') {
        $scope.cowNewdescription = $scope.cow_event.description;
      }

      $scope.fepDays = ['Viernes', 'Sábado', 'Domingo'];

      $scope.fepCowCompleted = $scope.cow_event.total_value_to_date_left >= $scope.cow_event.cow_goal;

      if ($scope.cow_event.cow_type.slug === fepSingleTicketSlug) {
        $scope.fepSingleTicket = true;
        $scope.fepNumTickets = Math.ceil($scope.cow_event.cow_goal / fepSingleTicketPrice);
      }
      else if ($scope.cow_event.cow_type.slug === fepSingleTicketStage2Slug) {
        $scope.fepSingleTicket = true;
        $scope.fepNumTickets = Math.ceil($scope.cow_event.cow_goal / fepSingleTicketStage2Price);
      }

      if ($scope.cow_event.additional_info != null && $scope.cow_event.additional_info != '') {
        $scope.fepTicketDayConfirmed = JSON.parse($scope.cow_event.additional_info).ticketConfirmed;
      }
      else {
        $scope.fepTicketDayConfirmed = false;
      }

      if ($scope.fepTicketDayConfirmed) {
        $scope.fepTicketsArray = JSON.parse($scope.cow_event.additional_info).ticketArray;
      }
      else {
        $scope.fepTicketsArray = [];
        for (var i=1; i <= $scope.fepNumTickets; i++) {
          var ticket = {
            id: i,
            selectedDay: ''
          };
          $scope.fepTicketsArray.push(ticket);
        }
      }

      $scope.selectFepTicketDay = function (ticket, selectedDay) {
        $scope.fepTicketsArray[ticket - 1] = {id: ticket, selectedDay: selectedDay};
      };

      $scope.submitFepTicketDay = function (isValid) {
        if (!isValid) {
          toastr.error('Debes seleccionar el día de tu boleta')
        }
        else {
          var fepTicketDayObject = {
            ticketConfirmed: true,
            ticketArray: $scope.fepTicketsArray
          };
          var fepTicketsJson = angular.toJson(fepTicketDayObject);
          console.log(fepTicketsJson);
          ngDialog.open({
            template: 'confirmFepTicketDayModal',
            data: {
              cowId: $scope.cow_event.cow_event_id,
              fepTicketsJson: fepTicketsJson
            },
            controller: 'ConfirmFepTicketDayModalCtrl'
          });
        }
      };

      $scope.contactList = function () {
        cowEventService.getCowEventGuestList(cowId).then(function (data) {
          ngDialog.open({
            template: 'contactListModal-1',
            data: {
              guestList: data,
              cowId: cowId
            },
            controller: 'ContactListModalCtrl'
          });
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de obtener la lista de invitados');
        });
      };

      $scope.downloadParticipantsList = function () {
        cowEventService.downloadParticipantsList(cowId).then(function (data) {
          var hiddenElement = document.createElement('a');
          hiddenElement.href = data.data.file_list;
          hiddenElement.download = 'Lista de participantes.xlsx';
          document.body.appendChild(hiddenElement);
          hiddenElement.click();
          document.body.removeChild(hiddenElement);
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error generando el archivo');
        });
      };

      $scope.openCloseCowEventModal = function () {
        ngDialog.open({
          template: 'confirmationCloseCowEventModal-1',
          data: {
            cowId: cowId
          },
          controller: 'CloseCowEventModalCtrl'
        });
      };

      $scope.openReopenCowEventModal = function () {
        console.log('open modal');
        if ($scope.cow_event.closed_money_request) {
          ngDialog.open({
            template: 'notAllowReOpenCowModal-1',
            data: {},
            controller: 'NotAllowReOpenCowModalCtrl'
          });
        } else {
          ngDialog.open({
            template: 'confirmationReopenCowEventModal-1',
            data: {
              cowId: cowId
            },
            controller: 'ReopenCowEventModalCtrl'
          });
        }
      };

      $scope.goToPublicFepCow = function () {
        $state.go('fep-cow', {
          cowId: cowId
        });
      };

      $scope.loginUser = function (isValid) {
        if (isValid) {
          usersService.login($scope.user.email,
            $scope.user.password
          ).then(function (data) {
            $state.reload();
          }, function (err) {
            $scope.errorSended = true;
            $scope.errorMessage = "Usuario y/o contraseña incorrectos";
          });
        }
      };

      $scope.loginFb = function () {
        var send_welcome_email = false;
        usersService.loginFb(send_welcome_email).then(function (data) {
          $state.reload();
        }, function (err) {
          $rootScope.errorSended = true;
          $scope.errorMessage = "Usuario y/o contraseña incorrectos";
        });
      };

      $scope.loginGg = function () {
        var send_welcome_email = false;
        GAuth.login().then(function (user) {
          GAuth.getToken().then(function(token_response){
            usersService.loginGg(token_response.access_token, send_welcome_email).then(function (data) {
              $state.reload();
            }, function (err) {
              $rootScope.errorSended = true;
              $scope.errorMessage = "Usuario y/o contraseña incorrectos";
            });
          }, function () {
            console.log('token error');
          });
        }, function () {
          console.log('login fail');
        });
      };

      $scope.modalParticipants = function (contacts) {
        paymentService.getCowEventParticipantsOrganizerList(cowId).then(function (data) {
            console.log(data);
            ngDialog.open({
              template: 'participantsModal-1',
              data: {
                cow: $scope.cow_event,
                participants: data
              }
            });
          },
          function (err) {
            toastr.error('Error obteniendo los participantes');
          });

      };

      if ($scope.cow_event.show_location_point) {
        $scope.map = {
          center: {
            latitude: $scope.cow_event.location_point.latitude,
            longitude: $scope.cow_event.location_point.longitude
          },
          zoom: 16
        };
        $scope.marker = {
          id: 0,
          coords: {
            latitude: $scope.cow_event.location_point.latitude,
            longitude: $scope.cow_event.location_point.longitude
          },
          options: {
            draggable: false,
            icon: 'assets/images/map-pin.png'
          }
        };
      }

      $scope.goToFepCowParticipate = function (cowId) {
        $state.go('fep-cow-participate', {cowId: cowId}, {reload: true});
      };

      $scope.useFepCow = function () {
        ngDialog.open({
          template: 'useFepCowInfo',
          controller: 'UseFepCowModalCtrl'
        });
      };
    })
    .controller('ContactListModalCtrl', function ($scope, ngDialog, cowEventService, toastr) {

      $scope.confirmationDg;
      $scope.deleteGuest = function (guest, cowId) {
        $scope.confirmationDg = ngDialog.open({
          template: 'confirmationModal-1',
          data: {
            guest: guest,
            cowId: cowId
          },
          controller: 'ContactListModalCtrl'
        });
      };

      $scope.closeSecond = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.confirmationDeleteGuest = function (guest, closeId, cowId) {

        cowEventService.deleteCowEventGuest(guest.id).then(function (data) {
          ngDialog.close();
          cowEventService.getCowEventGuestList(cowId).then(function (data) {
            ngDialog.open({
              template: 'contactListModal-1',
              data: {
                guestList: data,
                cowId: cowId
              },
              controller: 'ContactListModalCtrl'
            });
          }, function (err) {
            console.log('err login', err);
            toastr.error('Error tratando de obtener la lista de invitados');
          });
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de eliminar el contacto');
        });

      };
    })
    .controller('CloseCowEventModalCtrl', function ($scope, ngDialog, cowEventService, toastr, $state) {


      $scope.closeThird = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.confirmationCloseCowEvent = function (cowId) {
        console.log(cowId);
        var cowTempData = {};
        cowTempData.id = cowId;
        cowTempData.closed = true;
        cowEventService.cowEventPartialUpdate(cowTempData).then(function (data) {
          // $scope.cow_event = data;
          ngDialog.close();
          $state.reload();
          toastr.success('Alcancía cerrada');
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de cerra la alcancía');
        });

      };


    })
    .controller('ReopenCowEventModalCtrl', function ($scope, ngDialog, cowEventService, toastr, $state) {
      $scope.closeFourth = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.confirmationReopenCowEvent = function (cowId) {
        console.log(cowId);
        var cowTempData = {};
        cowTempData.id = cowId;
        cowTempData.closed = false;
        cowEventService.cowEventPartialUpdate(cowTempData).then(function (data) {
          // $scope.cow_event = data;
          ngDialog.close();
          $state.reload();
          toastr.success('Alcancía re-abierta');
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando re-abrir la alcancía');
        });

      };
    })
    .controller('NotAllowReOpenCowModalCtrl', function ($scope, ngDialog, cowEventService, toastr, $state) {
      $scope.closeFifth = function (closeId) {
        ngDialog.close(closeId);
      };
    })
    .controller('RequestCellphoneModalCtrl', function ($scope, ngDialog, cowEventService, toastr, $state, usersService) {

      $scope.submitUserCellphone = function (valid) {
        if (valid) {
          console.log($scope.user.cellphone);
          usersService.updateCellphone($scope.user.cellphone, $scope.ngDialogData.cowId).then(function () {
            toastr.success("¡Número celular agregado con éxito!");
            ngDialog.close();
          }, function (err) {
            if (err.status == 409) {
              toastr.error("Este número celular ya se encuentra asociado a otra cuenta");
            }
            else {
              toastr.error("Se presentó un error actualizando tus datos, inténtalo mas tarde");
              ngDialog.close();
            }

          });
        }
      };
    })
    .controller('RequestDocumentNumberModalModalCtrl', function ($scope, ngDialog, cowEventService, toastr, $state, usersService) {

      $scope.submitUserDocument = function (valid) {
        if (valid) {
          ngDialog.close();
          usersService.updateDocument($scope.user.document).then(function () {
            toastr.success("¡Número de documento registrado con éxito!");
            $state.reload();
          }, function (err) {
            if (err.status == 409) {
              toastr.error("Este documento ya se encuentra asociado a otra alcancía");
            }
            else {
              toastr.error("Se presentó un error actualizando tus datos, inténtalo mas tarde");
            }
          });
        }
      };
    })
    .controller('UseFepCowModalCtrl', function ($scope, ngDialog) {

      $scope.closeUseFepCowModal = function (closeId) {
        ngDialog.close(closeId);
      };
    })
    .controller('ConfirmFepTicketDayModalCtrl', function ($scope, $state, ngDialog, toastr, cowEventService) {

      $scope.confirmFepTicketDay = function () {
        console.log($scope.ngDialogData.fepTicketsJson);

        ngDialog.close();

        cowEventService.updateCowAdditionalInfo($scope.ngDialogData.cowId, $scope.ngDialogData.fepTicketsJson).then(function (data) {
          toastr.success('Días confirmados con éxito');
          $state.reload();
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de confirmar los días');
        });
      };

      $scope.closeFepTicketDayModal = function (closeId) {
        ngDialog.close(closeId);
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('fep-cow-deleted', {
          url: '/alcancia-fep-eliminada/:cowId',
          templateUrl: 'app/views/fep/fepCowDeleted/fepCowDeleted.html',
          controller: 'FepCowDeletedController',
          controllerAs: 'fep-cow-deleted',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCowPublic(cowId);
            }
          },
          data: {
            'meta': {
              'title': 'Alcancía eliminada',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('FepCowDeletedController', function ($scope, $state, $rootScope, usersService, $stateParams, cowId, cow) {

      if (!cow.deleted) {
        $state.go('fep-cow', {cowId: cowId});
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('fep404', {
          url: '/fep404',
          templateUrl: 'app/views/fep/fep404/fep404.html',
          controller: 'FepNotFoundController',
          controllerAs: 'fep404',
          resolve: {},
          data: {
            'meta': {
              'title': 'Alcancía FEP 404',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('FepNotFoundController', function ($scope, $state, $rootScope, $analytics) {
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('credibanco-participate', {
          url: '/yo-me-quedo-en-mi-negocio/donar/:cowId?id_pago',
          templateUrl: 'app/views/credibanco/credibancoParticipate/credibancoParticipate.html',
          controller: 'CredibancoParticipateController',
          controllerAs: 'credibanco-participate',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            paymentId: function ($stateParams) {
              return $stateParams.id_pago;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCowPublic(cowId);
            },
            matrixCommissions: function (paymentService) {
              return paymentService.getMatrixComissionsList();
            }
          },
          data: {
            'meta': {
              'title': 'Yo Me Quedo En Mi Negocio - ArmaTuVaca',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CredibancoParticipateController', function ($scope, $state, $rootScope, usersService, $stateParams, cowId, $log, cow, toastr, participationService,
                                                   ruteCode, urlPart1, urlPart2, $window, minPaymentValue, matrixCommissions, paymentService,
                                                   $mdDialog, paymentId, smoothScroll, additionalParticipantFee, psePaymentCode, ccPaymentCode, efectyPaymentCode,
                                                   maxPaymentValue, cowBusinessTypeCredibanco) {
      //$window.fbq('trackCustom', 'EntraParticipar');

      if (cow.deleted) {
        $state.go('cow-deleted', {
          cowId: cowId
        });
      }
      if (cow.closed) {
        $state.go('cow', {
          cowId: cowId
        });
      }
      if (cow.is_promo) {
        $state.go('cow', {
          cowId: cowId
        });
      }

      if (cow.is_business !== true || cow.business_type !== cowBusinessTypeCredibanco) {
        $state.go('cow', {cowId: cowId});
      }

      $scope.goToCredibancoCow = function () {
        $state.go('credibanco-cow', {cowId: cowId});
      }

      $scope.minPaymentValue = minPaymentValue;
      $scope.maxPaymentValue = maxPaymentValue;

      $scope.today = moment();
      $scope.actualMonth = $scope.today.month();
      $scope.actualYear = $scope.today.year() - 2000;

      $scope.cow_event = cow;
      console.log($scope.cow_event);

      $scope.matrixCommissions = matrixCommissions;
      // console.log($scope.matrixCommissions);

      $scope.user_participation = {
        cow_id: cowId,
        send_promotional_emails: true,
        fixed_participants: "1",
        force_payment_pending: false,
        save_credit_card: false
      };

      $scope.user_participation.participantsOptions = [];

      $scope.additionalValues = [];

      $scope.previous_payment = 0;

      $scope.createUpdateArrayParticipantsOptions = function () {
        var lenght = parseInt($scope.user_participation.fixed_participants);
        var i;
        for (i = 0; i < lenght; i++) {
          var elementTemp = {
            id: i
          };
          $scope.user_participation.participantsOptions.push(elementTemp);
        }
      };

      $scope.createUpdateArrayParticipantsOptions();
      // $scope.optionsParticipants = [$scope.user_participation.fixed_participants];
      console.log($scope.user_participation.participantsOptions);

      $scope.payment_redirect = false;

      $scope.total_amount_readonly = false;

      $scope.commission_value_matrix = 0.10;

      $scope.discount_value = 0;

      $scope.cow_has_gift_code = false;

      $scope.user_participation.document_type = 1;

      $scope.gift_code_obj = {};

      $scope.acceptTermsConditions = false;

      if ($scope.cow_event.gift_code) {
        $scope.cow_has_gift_code = true;
        if ($scope.cow_event.gift_code.type === 0 || $scope.cow_event.gift_code.type === 1 ||
          $scope.cow_event.gift_code.type === 2) {
          $scope.gift_code_obj = $scope.cow_event.gift_code;
          $scope.user_participation.gift_code = $scope.gift_code_obj.slug;
        }
      }

      $scope.additionalParticipantFee = additionalParticipantFee;
      $scope.multiple_participants_fee = 0;

      if ($scope.cow_event.marketplace) {
        $scope.minPaymentValue = 1;
        $scope.maxPaymentValue = $scope.cow_event.cow_goal - $scope.cow_event.total_value;
      }

      $scope.calculateCommissionAmmountPercentange = function () {
        $scope.commission_value_all = $scope.user_participation.total_value * $scope.commission_value_matrix;

        if ($scope.cow_event.marketplace) {
          $scope.commission_value_all = 0;
        }

        if ($scope.gift_code_obj.valid) {
          if ($scope.gift_code_obj.type === 0) {
            $scope.discount_value = $scope.gift_code_obj.percentage_value * $scope.commission_value_all;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          }
          else if ($scope.gift_code_obj.type === 1) {
            $scope.discount_value = $scope.gift_code_obj.int_value;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          }
          else if ($scope.gift_code_obj.type === 2) {
            $scope.discount_value = 0;
            $scope.commission_value_all = $scope.gift_code_obj.int_value;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          }
          if ($scope.cow_event.commission_added) {
            $scope.commission_value = $scope.commission_value_all;
            $scope.total_value_commission = $scope.user_participation.total_value + $scope.commission_value - $scope.discount_value
              + $scope.multiple_participants_fee;
          } else if ($scope.cow_event.commission_deducted) {
            $scope.commission_value = $scope.commission_value_all - $scope.discount_value + $scope.multiple_participants_fee;
            $scope.total_value_commission = $scope.user_participation.total_value;
          }
        }
        else {
          if ($scope.cow_event.commission_added) {
            $scope.commission_value = $scope.commission_value_all;
            $scope.total_value_commission = $scope.user_participation.total_value + $scope.commission_value + $scope.multiple_participants_fee;
          } else if ($scope.cow_event.commission_deducted) {
            $scope.commission_value = $scope.commission_value_all + $scope.multiple_participants_fee;
            $scope.total_value_commission = $scope.user_participation.total_value;
          }
        }
      };

      $scope.calculateCommissionAmmountFixed = function () {
        $scope.commission_value_all = $scope.commission_value_matrix;

        if ($scope.cow_event.marketplace) {
          $scope.commission_value_all = 0;
        }

        if ($scope.gift_code_obj.valid) {
          if ($scope.gift_code_obj.type == 0) {
            $scope.discount_value = $scope.gift_code_obj.percentage_value * $scope.commission_value_matrix;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          }
          else if ($scope.gift_code_obj.type == 1) {
            $scope.discount_value = $scope.gift_code_obj.int_value;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          }
          else if ($scope.gift_code_obj.type == 2) {
            $scope.discount_value = 0;
            $scope.commission_value_all = $scope.gift_code_obj.int_value;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          }

          if ($scope.cow_event.commission_added) {
            $scope.commission_value = $scope.commission_value_all;
            $scope.total_value_commission = $scope.user_participation.total_value + $scope.commission_value - $scope.discount_value
              + $scope.multiple_participants_fee;
          } else if ($scope.cow_event.commission_deducted) {
            $scope.commission_value = $scope.commission_value_all - $scope.discount_value + $scope.multiple_participants_fee;
            $scope.total_value_commission = $scope.user_participation.total_value;
          }
        }
        else {
          if ($scope.cow_event.commission_added) {
            $scope.commission_value = $scope.commission_value_all;
            $scope.total_value_commission = $scope.user_participation.total_value + $scope.commission_value + $scope.multiple_participants_fee;
          } else if ($scope.cow_event.commission_deducted) {
            $scope.commission_value = $scope.commission_value_all + $scope.multiple_participants_fee;
            $scope.total_value_commission = $scope.user_participation.total_value;
          }
        }

      };

      $scope.getOptionAdditionalValue = function (optionType, optionId) {

        var optionTypeTemp = _.find($scope.cow_event.options.custom_options, function (o) {
          return o.option_type.id == optionType;
        });

        var optionIdTemp = _.find(optionTypeTemp.options, function (op) {
          return op.id == optionId;
        });

        return optionIdTemp;
      };

      $scope.totalValueChanged = function () {

        if ($scope.cow_event.participation_fixed) {
          $scope.user_participation.total_value = $scope.cow_event.participant_value_fixed * $scope.user_participation.fixed_participants;
          $scope.multiple_participants_fee = $scope.additionalParticipantFee * ($scope.user_participation.fixed_participants - 1);
        };

        if ($scope.cow_event.options && $scope.cow_event.has_options && $scope.cow_event.participation_fixed) {
          $scope.additionalValues = [];
          _.forEach($scope.user_participation.participantsOptions, function (value) {
            var participantAdditionalValue = 0

            _.forEach(value.options, function (value_opt) {
              console.log(value.options);
              var value_opt_array = value_opt.split('-');
              var optionType = value_opt_array[0];
              var optionId = value_opt_array[1];

              var optionFound = $scope.getOptionAdditionalValue(optionType, optionId);
              console.log(optionFound);

              $scope.user_participation.total_value += optionFound.additional_value;

              participantAdditionalValue += optionFound.additional_value;
            });

            var additionalValueObj = {
              additionalValue: participantAdditionalValue
            };

            $scope.additionalValues.push(additionalValueObj);
            console.log($scope.additionalValues);
          });
        };

        if ($scope.user_participation.total_value >= $scope.minPaymentValue && $scope.user_participation.total_value <= $scope.maxPaymentValue) {
          var commTemp = _.find($scope.matrixCommissions, function (o) {
            return o.min_value <= $scope.user_participation.total_value && o.max_value > $scope.user_participation.total_value;
          });
          if ($scope.gift_code_obj.max_value < $scope.user_participation.total_value || $scope.gift_code_obj.min_value > $scope.user_participation.total_value) {
            $scope.gift_code_obj = {};
            $scope.gift_code = '';
            delete $scope.user_participation.gift_code;
          }
          if (commTemp) {
            if (commTemp.fixed) {
              $scope.commission_value_matrix = commTemp.fixed_value;
              $scope.calculateCommissionAmmountFixed();
            } else if (commTemp.percentage) {
              $scope.commission_value_matrix = commTemp.percentage_value;
              $scope.calculateCommissionAmmountPercentange();
            } else {
              $scope.commission_value_matrix = 0.10;
              $scope.calculateCommissionAmmountPercentange();
            }
          } else {
            $scope.commission_value_matrix = 0.10;
            $scope.calculateCommissionAmmountPercentange();
          }
        }
      };

      if ($scope.cow_event.participation_fixed) {
        $scope.user_participation.total_value = $scope.cow_event.participant_value_fixed;
        $scope.totalAmountReadOnly = true;
        $scope.totalValueChanged();
      } else if ($scope.cow_event.participation_suggested) {
        $scope.user_participation.total_value = $scope.cow_event.participant_value_suggested;
        $scope.totalValueChanged();
      }

      usersService.getUserData().then(function (data) {
        $scope.user = data.user;
        console.log($scope.user);
        $scope.user_participation.first_name = $scope.user.user.first_name;
        $scope.user_participation.last_name = $scope.user.user.last_name;
        $scope.user_participation.email = $scope.user.user.email;
        $scope.user_participation.document_number = $scope.user.document_number;
        $scope.user_participation.document_full_number = $scope.user.document_full_number;
        $scope.user_participation.save_credit_card = true;
        if ($scope.user.document_type === 1 || $scope.user.document_type === 2 ||
          $scope.user.document_type === 3 || $scope.user.document_type === 4) {
          $scope.user_participation.document_type = $scope.user.document_type;
        }
        if ($scope.user.cellphone) {
          $scope.user_participation.cellphone = $scope.user.cellphone.toString();
        }

        // if (!$scope.cow_event.options && !$scope.cow_event.has_options) {
        //   $scope.submitPersonalForm($scope.personalInfoForm.$valid);
        // }

        paymentService.getUserCreditCards().then(function (data) {
          $scope.userCreditCards = data.credit_cards;
          console.log(data);

        }, function (err) {
        });
      }, function (err) {
      });


      if (paymentId) {
        paymentService.getPaymentData(paymentId).then(function (data) {
          $scope.participant_data = data.payment_data.participant;
          console.log($scope.participant_data);

          $scope.user_participation.first_name = $scope.participant_data.first_name;
          $scope.user_participation.last_name = $scope.participant_data.last_name;
          if ($scope.participant_data.document_type === 1 || $scope.participant_data.document_type === 2 ||
            $scope.participant_data.document_type === 3 || $scope.user.document_type === 4) {
            $scope.user_participation.document_type = $scope.participant_data.document_type;
          }
          $scope.user_participation.document_number = $scope.participant_data.document_number;
          $scope.user_participation.document_full_number = $scope.user.document_full_number;
          $scope.user_participation.email = $scope.participant_data.email;
          $scope.user_participation.cellphone = $scope.participant_data.cellphone.toString();

          $scope.submitPersonalForm($scope.personalInfoForm.$valid);
        });
      }

      $scope.setDocumentNumber = function () {
        if ($scope.user_participation.document_full_number) {
          $scope.user_participation.document_number = $scope.user_participation.document_full_number.replace(/[^0-9]/g, '');
        }
      };

      $scope.setDocumentFullNumber = function () {
        if ($scope.user_participation.document_number) {
          $scope.user_participation.document_full_number = $scope.user_participation.document_number;
        }
      };

      $scope.participateCow = function (isValid) {
        if (isValid) {
          $scope.createParticipation();
        }
        else {
          var element = document.getElementById('top-scroll');
          smoothScroll(element);
        }
      };

      $scope.createParticipation = function () {
        participationService.createParticipation(
          $scope.user_participation
        ).then(function (data) {
          // console.log('updated', data);
          if (data.pending) {
            $scope.toastPending();
            $scope.previous_payment = data.previous_payment
          }
          else if (!data.valid && data.blacklist) {
            toastr.info('Ha ocurrido un error con los datos suministrados, comunicate con nosotros para más información.');
          }
          else {
            if ($scope.pseCollapsed == false) {
              var url_final = urlPart1 + ruteCode + urlPart2 + data.zona_virtual_id;
              // location.href = url_final;
              $scope.payment_redirect = true;
              $window.location.href = url_final;
              // console.log(url_final);
            }
            else {
              console.log(data);
              $state.go('payment-respond', {id_pago: data.payment_id});
            }

          }
        }, function (err) {
          console.log('err login', err);
          toastr.error('Si el error persiste, comunicate con nosotros.', 'Error creando la solicitud.');
        });
      };


      $scope.checkPreviousParticipation = function () {
        $state.go('payment-respond', {id_pago: $scope.previous_payment});
      };

      $scope.toastPending = function () {
        $scope.payment_pending = true;
        toastr.info('En este momento tienes un pago pendiente, inténtalo mas tarde.', 'Pago pendiente');
      };

      $scope.applyCoupon = function () {
        if ($scope.gift_code === '' || $scope.gift_code === undefined) {
          if ($scope.user_participation.total_value < $scope.minPaymentValue && $scope.user_participation.total_value < $scope.maxPaymentValue) {
            toastr.info('Primero debes ingresar un valor');
          }
          else {
            toastr.info('Debes ingresar el código promocional con mayúsculas y minúsculas');
          }
        }
        else if (($scope.user_participation.total_value < $scope.minPaymentValue && $scope.user_participation.total_value > $scope.maxPaymentValue) || $scope.user_participation.total_value === undefined) {
          toastr.info('Primero debes ingresar un valor');
        }
        else {
          var data_gift_code = {
            gift_code: $scope.gift_code,
            payment_value: $scope.user_participation.total_value
          };
          paymentService.validateGiftCode(data_gift_code).then(function (data) {
            console.log(data);
            $scope.gift_code_obj = data;
            $scope.totalValueChanged();
            $scope.user_participation.gift_code = $scope.gift_code_obj.slug;
            toastr.success('Código aplicado con éxito');
          }, function (err) {
            console.log('err login', err);
            toastr.error('El código no es válido o se encuentra mal escrito');
          });
        }

      };

      $scope.scrollToTop = function () {
        var element = document.getElementById('top-scroll');
        smoothScroll(element);
      };

      $scope.$watch('user_participation.total_value', function (newValue, oldValue) {

        if (newValue === 0) {
          delete $scope.user_participation.total_value;
          console.log('loggi');
        }
      });

      $scope.$watch('user_participation.fixed_participants', function (newValue, oldValue) {

        console.log(newValue);
        console.log(oldValue);
        console.log($scope.user_participation.participantsOptions);

        if (newValue > oldValue) {
          var diff = newValue - oldValue;
          var i;
          for (i = 0; i < diff; i++) {
            var elementTemp = {
              id: ($scope.user_participation.participantsOptions.length)
            };
            $scope.user_participation.participantsOptions.push(elementTemp);
          }
        }
        else if (newValue < oldValue) {
          var diff = newValue;
          console.log(diff);
          var i;
          for (i = $scope.user_participation.participantsOptions.length; i >= diff; i--) {
            $scope.user_participation.participantsOptions.splice(i, 1);
          }
        }

        $scope.totalValueChanged();
      });

      $scope.showPersonalInfoForm = true;
      $scope.submitPersonalForm = function (isValid) {
        if (isValid) {
          $scope.showPersonalInfoForm = false;
        }
      };

      $scope.submitPayment = function () {
        $scope.personalInfoForm.$setSubmitted();
        $scope.participationForm.$setSubmitted();

        $scope.personalInfoValid = $scope.personalInfoForm.$valid;
        $scope.participationValid = $scope.participationForm.$valid;

        $scope.personalAndParticipationInfoValid = $scope.personalInfoValid && $scope.participationValid;

        console.log($scope.personalInfoValid);
        console.log($scope.participationValid);
        console.log($scope.personalAndParticipationInfoValid);

        if ($scope.user_participation.total_value < $scope.minPaymentValue || $scope.user_participation.total_value > $scope.maxPaymentValue) {
          $scope.personalAndParticipationInfoValid = false;
        }

        if ($scope.personalAndParticipationInfoValid) {
          if ($scope.ccCollapsed === true && $scope.pseCollapsed === true && $scope.efectyCollapsed === true) {
            toastr.info('Debes seleccionar un método de pago', 'Método de pago');
          }
          else if ($scope.ccCollapsed === false) {
            $scope.ccForm.$setSubmitted();
            $scope.ccValid = $scope.ccForm.$valid;
            console.log($scope.ccValid);

            $scope.invalid_card_type = $scope.ccForm.ccNumber.$ccEagerType !== 'MasterCard' &&
              $scope.ccForm.ccNumber.$ccEagerType !== 'Visa' &&
              $scope.ccForm.ccNumber.$ccEagerType !== 'Diners Club';

            if ($scope.creditCardSelected) {
              $scope.user_participation.payment_method = ccPaymentCode;
              $scope.user_participation.credit_card_token = $scope.creditCardSelected;
              $scope.user_participation.pay_with_token = true;
              $scope.isCcTokenSummary();
              $scope.showPaymentMethods();
            }
            else if (!$scope.ccValid || $scope.invalid_card_type) {
              toastr.info('Verifica los datos de la tarjeta', 'Tarjeta Inválida');
            }
            else if ($scope.ccValid && !$scope.creditCardSelected) {
              $scope.user_participation.payment_method = ccPaymentCode;
              $scope.user_participation.card.type = $scope.ccForm.ccNumber.$ccType;
              $scope.user_participation.pay_with_token = false;
              $scope.isCcSummary();
              $scope.showPaymentMethods();
            }
          }
          else if ($scope.pseCollapsed === false) {
            $scope.user_participation.payment_method = psePaymentCode;
            $scope.isPSESummary();
            $scope.showPaymentMethods();
          }
          else if ($scope.efectyCollapsed === false) {
            $scope.user_participation.payment_method = efectyPaymentCode;
            $scope.isEfectySummary();
            $scope.showPaymentMethods();
          }
        }
        else {
          toastr.info('Por favor verifica todos los campos', 'Participación incompleta');
          $scope.scrollToTop();
        }
      };

      $scope.showPersonalInfoFormEdit = function () {
        $scope.showPersonalInfoForm = true;
      };

      $scope.efectyCollapsed = true;
      $scope.paymentMethodToEfecty = function () {
        $scope.efectyCollapsed = !$scope.efectyCollapsed;
        $scope.pseCollapsed = true;
        $scope.ccCollapsed = true;
        if ($scope.creditCardSelected) {
          $scope.creditCardSelected.checked = false;
          delete $scope.creditCardSelected;
        }
      };

      $scope.pseCollapsed = true;
      $scope.paymentMethodToPse = function () {
        $scope.pseCollapsed = !$scope.pseCollapsed;
        $scope.efectyCollapsed = true;
        $scope.ccCollapsed = true;
        if ($scope.creditCardSelected) {
          $scope.creditCardSelected.checked = false;
          delete $scope.creditCardSelected;
        }
      };

      $scope.ccCollapsed = true;
      $scope.paymentMethodToCc = function () {
        $scope.ccCollapsed = !$scope.ccCollapsed;
        $scope.pseCollapsed = true;
        $scope.efectyCollapsed = true;
      };

      $scope.checkedChanged = function (creditCard) {
        _.forEach($scope.userCreditCards, function (value) {
          if (creditCard.id == value.id) {
            console.log(value);
            if (value.checked == true) {
              console.log("as");
              $scope.creditCardSelected = value;
            }
            else {
              console.log("ad");
              delete $scope.creditCardSelected;
            }
          } else {
            value.checked = false;
          }
        });
      };

      $scope.showPaymentMethods = function () {
        $scope.showSummary = true;
        $scope.showPersonalDataForm = false;
        $scope.scrollToTop();
      };

      $scope.confirmPayment = function () {
        if ($scope.acceptTermsConditions) {
          $scope.participateCow(true);
        }
        else {
          toastr.info("Debes aceptar los términos y condiciones y política de tratamiento de datos")
        }
      };

      $scope.backToPersonalDataForm = function () {
        $scope.showSummary = false;
        $scope.showPersonalDataForm = true;
      };

      $scope.isEfectySummary = function () {
        $scope.efectySummary = true;
        $scope.pseSummary = false;
        $scope.ccSummary = false;
        $scope.ccTokenSummary = false;
      };

      $scope.isPSESummary = function () {
        $scope.pseSummary = true;
        $scope.efectySummary = false;
        $scope.ccSummary = false;
        $scope.ccTokenSummary = false;
      };

      $scope.isCcSummary = function () {
        $scope.efectySummary = false;
        $scope.pseSummary = false;
        $scope.ccSummary = true;
        $scope.ccTokenSummary = false;
        // $scope.strCcNumber = $scope.ccForm.ccNumber.toString();
        $scope.strCcNumber = $scope.user_participation.card.number;
        $scope.ccLastNumbers = $scope.strCcNumber.substring(12, 16);
      };

      $scope.isCcTokenSummary = function () {
        $scope.efectySummary = false;
        $scope.pseSummary = false;
        $scope.ccSummary = false;
        $scope.ccTokenSummary = true;
      };

      $scope.showPersonalDataForm = true;

    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('credibanco-cow', {
          url: '/yo-me-quedo-en-mi-negocio/:cowId',
          templateUrl: 'app/views/credibanco/credibancoCow/credibancoCow.html',
          controller: 'credibancoCowController',
          controllerAs: 'credibanco-cow-controller',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCowPublic(cowId);
            },
            data: function (ngMeta, cow, atvURL, cowPublicURL, cowId, fbAPI) {

              var imgUrl = cow.main_img.substring(8);
              ngMeta.setTitle(cow.name);
              ngMeta.setTag('description', 'Yo Me Quedo En Mi Negocio - ArmaTuVaca.');
              ngMeta.setTag('og:url', atvURL + cowPublicURL + cowId);
              ngMeta.setTag('og:title', cow.name);
              ngMeta.setTag('og:type', 'website');
              ngMeta.setTag('og:description', 'Arma Tu Vaca online de forma fácil, rapida y segura.');
              ngMeta.setTag('og:image', cow.main_img);
              ngMeta.setTag('fb:app_id', fbAPI);
              ngMeta.setTag('twitter:url', atvURL + cowPublicURL + cowId);
              ngMeta.setTag('twitter:title', cow.name);
              ngMeta.setTag('twitter:description', 'Arma Tu Vaca online de forma fácil, rapida y segura.');
              ngMeta.setTag('twitter:image', cow.main_img);
              ngMeta.setTag('robots', 'noindex, nofollow');
            }
          },
          meta: {
            disableUpdate: true
          }
        })
    })
    .controller('credibancoCowController', function ($scope, $state, $rootScope, usersService, $stateParams,
                                                     cowId, $log, cow, toastr, atvURL, cowPublicURL, ngDialog,
                                                     paymentService, cowBusinessTypeCredibanco) {

      console.log('CrediCow!!!');
      if (cow.deleted) {
        $state.go('cow-deleted', {
          cowId: cowId
        });
      }

      if (cow.is_business !== true || cow.business_type !== cowBusinessTypeCredibanco) {
        $state.go('cow', {cowId: cowId}, {reload: true});
      }

      $scope.cow_event = cow;
      $scope.cowclosed = cow.closed;

      $scope.cowBusinessTypeCredibanco = cowBusinessTypeCredibanco;

      var eventDate = new Date($scope.cow_event.event_date);
      $scope.eventDateString = eventDate.getDate() + "/" + (eventDate.getMonth() + 1) + "/" + eventDate.getFullYear();

      $scope.cowPublicURLComplete = atvURL + cowPublicURL + cowId;
      $scope.cowPublicURLCompleteCopy = atvURL + cowPublicURL + cowId;

      $scope.goToCredibancoParticipate = function () {
        $state.go('credibanco-participate', {cowId: cowId}, {reload: true});
      }

      $scope.modalParticipants = function (contacts) {
        paymentService.getCowEventParticipantsPublicList(cowId).then(function (data) {
            console.log(data);
            ngDialog.open({
              template: 'participantsModal-1',
              data: {
                cow: $scope.cow_event,
                participants: data
              }
            });
          },
          function (err) {
            toastr.error('Error obteniendo los participantes');
          });

      };

      if ($scope.cow_event.show_location_point) {
        $scope.map = {
          center: {
            latitude: $scope.cow_event.location_point.latitude,
            longitude: $scope.cow_event.location_point.longitude
          },
          zoom: 16
        };
        $scope.marker = {
          id: 0,
          coords: {
            latitude: $scope.cow_event.location_point.latitude,
            longitude: $scope.cow_event.location_point.longitude
          },
          options: {
            draggable: false,
            icon: 'assets/images/map-pin.png'
          }
        };
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('fepFooter', fepFooter)
    .controller('FepFooterController', FepFooterController);

  /** @ngInject */
  function fepFooter() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/fep/fepFooter/fepFooter.html',
      scope: {
      },
      controller: FepFooterController,
      controllerAs: 'fepfooter'
    };
    return directive;
  }

  /** @ngInject */
  function FepFooterController($scope, moment, $log, AboutUsService, ngDialog, toastr) {

    AboutUsService.getMediaLinks().then(function (data) {
      $scope.mediaLinks = data;
      $scope.mediaLinksContainers = [];

      var currentIndex = 0;
      var mediaLinksGroup = [];

      $scope.mediaLinks.sort(function (a, b) {
        return a.priority - b.priority;
      });

      for(var i = 0; i < $scope.mediaLinks.length; i++) {
        mediaLinksGroup.push($scope.mediaLinks[i]);
        if ((i+1)%4 === 0) {
          $scope.mediaLinksContainers.push({
            id: currentIndex,
            content: mediaLinksGroup,
            class: "col-md-"+(12/mediaLinksGroup.length)
          });
          currentIndex++;
          mediaLinksGroup = [];
        }
      }
      if (mediaLinksGroup.length > 0) {
        $scope.mediaLinksContainers.push({
          id: currentIndex,
          content: mediaLinksGroup,
          class: "col-md-"+(12/mediaLinksGroup.length)
        });
      }
    });

    $scope.businessContact = {};

    $scope.openAtvBusinessContact = function () {
      ngDialog.open({
        template: 'atvBusinessContactModal',
        data: {
        },
        controller: 'FooterController'
      });
    };

    $scope.submitAtvBusinessContact = function () {
      console.log($scope.businessContact);
      AboutUsService.submitBusinessContactForm($scope.businessContact).then(function (data) {
        toastr.success('Formulario enviado con éxito');
        ngDialog.close();
      }, function (err) {
        console.log(err);
        toastr.error('Intentalo nuevamente mas tarde', 'Error enviando el formulario');
      })
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('fepNavbar', fepNavbar);

  /** @ngInject */
  function fepNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/fep/fepNavbar/fepNavbar.html',
      scope: {
        creationDate: '='
      },
      controller: FepNavbarController,
      controllerAs: 'fepnavbar'
    };

    return directive;

    /** @ngInject */
    function FepNavbarController($scope, $mdSidenav, $rootScope, usersService, $state, smoothScroll) {

      $scope.toggleRight = function () {
        $mdSidenav('left')
          .toggle()
          .then(function () {
          });
      };

      $scope.checkUserData = function () {
        usersService.getUserData().then(function (data) {
          $scope.logged = true;
          $scope.user = data.user;
          usersService.getFepCow().then(function (data) {
            $scope.fepCowValue = data.fep_cow_value;
          });
        }, function (err) {
          $scope.logged = false;
        });
      };

      $rootScope.$on('loggedIn', function () {
        $scope.checkUserData();
      });

      $rootScope.$on('loggedOut', function () {
        $scope.checkUserData();
      });

      $scope.isOpenRight = function () {
        return $mdSidenav('left').isOpen();
      };

      $scope.close = function () {
        $mdSidenav('left').close()
          .then(function () {
          });
      };

      $scope.logOut = function () {
        usersService.logout();
        $state.go('fep-login',{}, {reload: true});
      };

      $scope.checkUserData();
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('credibancoNavbar', credibancoNavbar);

  /** @ngInject */
  function credibancoNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/credibanco/credibancoNavbar/credibancoNavbar.html',
      scope: {
        creationDate: '='
      },
      controller: CredibancoNavbarController,
      controllerAs: 'credibanco-navbar'
    };

    return directive;

    /** @ngInject */
    function CredibancoNavbarController($scope, $mdSidenav, $rootScope, $state, smoothScroll) {

      $scope.toggleRight = function () {
        $mdSidenav('left')
          .toggle()
          .then(function () {
          });
      };

      $scope.isOpenRight = function () {
        return $mdSidenav('left').isOpen();
      };

      $scope.close = function () {
        $mdSidenav('left').close()
          .then(function () {
          });
      };

      $scope.goToHome = function () {
        $state.go('home');
      };

      $scope.scrollToTopOrGoHome = function () {
        if ($state.current.name == "home") {
          var element = document.getElementById('top-scroll');
          smoothScroll(element);
        } else {
          $state.go('home');
        }
      };

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('fepCowShare', fepCowShare);


  /** @ngInject */
  function fepCowShare() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/fep/fepCowShare/fepCowShare.html',
      scope: {
        cow: '='
      },
      controller: FepCowShareController,
      controllerAs: 'fep-cow-share'
    };

    return directive;

    /** @ngInject */
    function FepCowShareController($scope, $rootScope, atvURL, fepCowPublicURL, toastr, Socialshare, fbAPI, $state) {

      $scope.cow_event = $scope.cow;

      $scope.cowPublicURLComplete = atvURL + fepCowPublicURL + $scope.cow_event.cow_event_id;
      $scope.cowPublicURLCompleteCopy = atvURL + fepCowPublicURL + $scope.cow_event.cow_event_id;

      $scope.copyLink = function () {
        toastr.success('El link de tu alcancía se ha guardado en el portapapeles', 'Link guardado');
      };

      $scope.shareFb = function () {
        Socialshare.share({
          'provider': 'facebook',
          'attrs': {
            'socialshareUrl': $scope.cowPublicURLComplete,
            'socialshareType': 'share',
            'socialshareVia': fbAPI,
            'socialshareText': $scope.cow_event.name,
            'socialshareMedia': $scope.cow_event.main_img,
            'socialshareDescription': 'Alcancía FEP 2019',
            'socialshareCaption': $scope.cow_event.name,
            'socialsharePopupHeight': 300,
            'socialsharePopupWidth': 400
          }
        });
      };

      $scope.shareTw = function () {
        Socialshare.share({
          'provider': 'twitter',
          'attrs': {
            'socialshareHashtags': "FEP, alcanciaFEP",
            'socialshareVia': "festereopicnic",
            'socialshareText': $scope.cow_event.name,
            'socialshareUrl': $scope.cowPublicURLComplete,
            'socialsharePopupHeight': 250,
            'socialsharePopupWidth': 500
          }
        });
      };

      $scope.shareLinkedin = function () {
        Socialshare.share({
          'provider': 'linkedin',
          'attrs': {
            'socialshareText': $scope.cow_event.name,
            'socialshareUrl': $scope.cowPublicURLComplete,
            'socialshareDescription' : $scope.cow_event.name,
            'socialshareSource' : 'armatuvaca'
          }
        });
      };

      $scope.shareWa = function () {
        Socialshare.share({
          'provider': 'whatsapp',
          'attrs': {
            'socialshareText': $scope.cow_event.name + " ",
            'socialshareUrl': $scope.cowPublicURLComplete
          }
        });
      };

      $scope.shareFbMessenger = function () {
        Socialshare.share({
          'provider': 'facebook-messenger',
          'attrs': {
            'socialshareUrl': $scope.cowPublicURLComplete
          }
        });
      };
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('credibancoFooter', credibancoFooter)
    .controller('CredibancoFooterController', CredibancoFooterController);

  /** @ngInject */
  function credibancoFooter() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/credibanco/credibancoFooter/credibancoFooter.html',
      scope: {
      },
      controller: CredibancoFooterController,
      controllerAs: 'credibanco-footer'
    };
    return directive;
  }

  /** @ngInject */
  function CredibancoFooterController($scope, moment, $log) {
    console.log('credifooter');
  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('welcome', {
          url: '/bienvenido-armar-vaca-online',
          templateUrl: 'app/views/welcome/welcome.html',
          controller: 'WelcomeController',
          controllerAs: 'welcome',
          resolve: {},
          data: {
            'meta': {
              'title': 'Bienvenido',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('WelcomeController', function ($scope, $state, $rootScope) {

      $rootScope.loginAllowed();


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('send-money-cow', {
          url: '/enviar-dinero',
          templateUrl: 'app/views/sendMoneyCow/sendMoneyCow.html',
          controller: 'SendMoneyCowController',
          controllerAs: 'send-money-cow',
          resolve: {},
          data: {
            'meta': {
              'title': 'Enviar dinero a un amigo',
              'robots': 'noindex'
            }
          }
        })
    })
    .controller('SendMoneyCowController', function ($scope, $state,cowEventService, toastr) {

      $scope.via = 0;

      $scope.user_participation = {
        total_value: null,
        send_money_type: '0',
        send_email: null,
        send_sms: null,
        via: '4'
      };

      $scope.sendMoneyCow = function (isValid) {
        if (isValid) {
          cowEventService.sendMoneyCowCreate(JSON.stringify($scope.user_participation)).then(function (data) {
            var cowId = data.data.cow_id;
            $state.go('cow-participate', {
              cowId: cowId,
              via: $scope.user_participation.via,
              send_token: data.data.send_token
            });
          }, function (err) {
            if(err.data.error == 'user_without_document'){
              toastr.error('Para enviar dinero, debes registrar tu documento de identidad en tu cuenta.', 'Error de Validación');
            }else if(err.data.error == 'invalid_user_document'){
              toastr.error('Para enviar dinero, debes tener un documento de identidad válido. Debes registrarlo en tu cuenta.', 'Error de Validación');
            }else{
              toastr.error('Si el error persiste, comunicate con nosotros.', 'Error creando la Vaca');
            }            
          });
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-get-money-status', {
          url: '/recolectar-monto-vaca-status/:getMoneyRequestId',
          templateUrl: 'app/views/requestStatus/requestStatus.html',
          controller: 'RequestStatusController',
          controllerAs: 'cow-get-money-request',
          resolve: {
            getMoneyRequestId: function ($stateParams) {
              return $stateParams.getMoneyRequestId;
            },
            user: function (usersService) {
              return usersService.getUserData();
            },
            getMoneyRequest: function (getMoneyRequestId, cowEventService) {
              return cowEventService.cowGetMoneyRequest(getMoneyRequestId);
            }
          },
          data: {
            'meta': {
              'title': 'Estado de la solicitud',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('RequestStatusController', function ($scope, $state, $rootScope, usersService, $stateParams, $log, toastr, cowEventService, user,
                                                     getMoneyRequestId, getMoneyRequest) {

      console.log('cow get money request');
      $scope.request = getMoneyRequest;

    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('register', {
          url: '/registro-vaca-online?response_url',
          templateUrl: 'app/views/register/register.html',
          controller: 'RegisterController',
          controllerAs: 'register',
          resolve: {},
          data: {
            'meta': {
              'title': 'Registro',
              'description': 'Regístrate con Facebook o Google en Armatuvaca.com.'
            }
          }
        })
    })
    .controller('RegisterController', function ($scope, $state, $rootScope, $stateParams, usersService, GAuth, $analytics, toastr, key_site_gg, key_site_gg_v2) {

      $rootScope.loggedNotAllowed();
      // $analytics.pageTrack('/register');

      $scope.todayDate = new Date();
      $scope.maxDate = new Date(
        $scope.todayDate.getFullYear() - 18,
        $scope.todayDate.getMonth(),
        $scope.todayDate.getDate());
      $scope.todayDate_format = $scope.maxDate.getDay() + '/' + $scope.maxDate.getMonth() + '/' + $scope.maxDate.getFullYear();

      $scope.user = {};
      $scope.secondValidation = false;

      $scope.registerNewUser = function (isValid) {
        if ($scope.user.born_date && $scope.showDateError) {
          toastr.info('Por favor ingresa una fecha de nacimiento valida', 'Registro incompleto');
        } else if (!$scope.acceptTermsConditions) {
          toastr.info('Por favor acepta los términos y condiciones para registrarte.', 'Registro incompleto');
        } else if (isValid) {
          grecaptcha.ready(function () {
            grecaptcha.execute(key_site_gg, { action: 'Register' }).then(function (token) {
              var send_welcome_email = true;
              usersService.registerNewUser($scope.user.first_name,
                $scope.user.last_name,
                $scope.user.born_date,
                $scope.user.email,
                $scope.user.password,
                send_welcome_email,
                token
              ).then(function () {
                if ($stateParams.response_url) {
                  document.location.href = $stateParams.response_url;
                } else {
                  $state.go('first-login');
                }
              }, function (err) {
                  if (err.data.error_text_msg) {
                    $scope.errorSended = true;
                    $scope.errorMessage = err.data.error_text_msg;
                  }
                  else if (err.status == 401) {
                    $scope.secondValidation = true;
                    grecaptcha.render('container_recaptchaV2',{
                      'sitekey': key_site_gg_v2,
                      'callback': function (e){
                        usersService.registerNewUser($scope.user.first_name,
                          $scope.user.last_name,
                          $scope.user.born_date,
                          $scope.user.email,
                          $scope.user.password,
                          send_welcome_email,
                          e,
                          $scope.secondValidation
                        ).then(function () {
                          if ($stateParams.response_url) {
                            document.location.href = $stateParams.response_url;
                          } else {
                            $state.go('first-login');
                          }
                        }, function(err){
                          if (err.data.error_text_msg) {
                            $scope.errorSended = true;
                            $scope.errorMessage = err.data.error_text_msg;
                            $scope.secondValidation = false;
                          }else{
                            $scope.errorSended = true;
                            $scope.errorMessage = "¡Error validando tu identidad!";}
                          
                        });
                      }
                    });
                  }
                  else {
                    $scope.errorSended = true;
                    $scope.errorMessage = "Se presentó un error intentando realizar el registro, inténtalo mas tarde. Sí el error persiste, comunicate con nosotros.";
                  }
              });
            });
          });

        }
      };

      $scope.loginFb = function () {
        var send_welcome_email = true;
        usersService.loginFb(send_welcome_email).then(function (data) {
          if ($stateParams.response_url) {
            document.location.href = $stateParams.response_url;
          } else {
            $state.go('first-login');
          }
        }, function (err) {
          $rootScope.errorSocialSent = true;
          $rootScope.errorMessage = "Error en la autenticación";
        });
      };

      $scope.loginGg = function () {
        var send_welcome_email = true;
        GAuth.login().then(function (user) {
          GAuth.getToken().then(function (token_response) {
            usersService.loginGg(token_response.access_token, send_welcome_email).then(function (data) {
              if ($stateParams.response_url) {
                document.location.href = $stateParams.response_url;
              } else {
                $state.go('first-login');
              }
            }, function (err) {
              $rootScope.errorSocialSent = true;
              $scope.errorMessage = "Error en la autenticación";
            });
          }, function () {
            console.log('token error');
          });
        }, function () {
          console.log('login fail');
        });
      };


      $scope.showDateError = false;
      $scope.dateBornValidator = function (isCompleted) {
        if ($scope.user.born_date && isCompleted) {
          if ($scope.user.born_date > $scope.maxDate) {
            $scope.showDateError = true;
          }
        } else {
          $scope.showDateError = false;
        }
      };

    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('public-cow', {
          url: '/vacanes',
          templateUrl: 'app/views/publicCow/publicCow.html',
          controller: 'PublicCowController',
          controllerAs: 'public-cow',
          resolve: {
            cowsEventPublic: function (cowEventService) {
              return cowEventService.getPublicCows({});
            },
            cowsPublicCategory: function (cowEventService) {
              return cowEventService.getCategoryCows();
            }
          },
          data: {
            'meta': {
              'title': 'Vacanes | Crowdfunding Online de Armatuvaca',
              'description': 'Vacanes es un espacio para resaltar las Vacas que tienen la meta de ayudar a quien más lo necesite. ¡Inicia tu campaña de Crowdfunding con Armatuvaca!',
              'og:url': 'https://armatuvaca.com/vacanes',
              'og:title': 'Vacanes | Crowdfunding Online de Armatuvaca',
              'og:type': 'website',
              'og:description': 'Vacanes es un espacio para resaltar las Vacas que tienen la meta de ayudar a quien más lo necesite. ¡Inicia tu campaña de Crowdfunding con Armatuvaca!',
              'og:image': 'https://armatuvaca.com/assets/images/vacanes/vacanes_meta.png',
              'twitter:url': 'https://armatuvaca.com/vacanes',
              'twitter:title': 'Vacanes | Crowdfunding Online de Armatuvaca',
              'twitter:description': 'Vacanes es un espacio para resaltar las Vacas que tienen la meta de ayudar a quien más lo necesite. ¡Inicia tu campaña de Crowdfunding con Armatuvaca!',
              'twitter:image': 'https://armatuvaca.com/assets/images/vacanes/vacanes_meta.png'
            }
          }
        })
    })
    .controller('PublicCowController', function ($scope, $state, $rootScope, usersService, cowsEventPublic, cowsPublicCategory) {
      $scope.cows = cowsEventPublic;
      $scope.cowsPublicCategory = cowsPublicCategory;
      $scope.goToCreatePublicCow = function () {
        $state.go('cow-create', {is_public: true});
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('product', {
          url: '/p/:slug',
          templateUrl: 'app/views/product/product.html',
          controller: 'ProductController',
          controllerAs: 'product-controller',
          resolve: {
            slug: function ($stateParams) {
              return $stateParams.slug;
            },
            product: function (marketplaceService, slug) {
              return marketplaceService.getProduct(slug);
            }
          }
        })
    })
    .controller('ProductController', function ($scope, $state, $rootScope, usersService, $stateParams, slug,
                                               cowEventService, toastr, $analytics, product) {

      console.log('product');
      console.log(slug);
      console.log(product);

      var idInit = 0;
      _.forEach(product.product_photos, function (value_req) {
        value_req.id = idInit;
        idInit++;
        value_req.background_style = {
          "background": "url(\'" + value_req.photo + "\') no-repeat",
          "background-position": "center",
          "background-size": "cover"
        };
      });

      $scope.product = product;

      $scope.myInterval = 5000;
      $scope.noWrapSlides = false;
      $scope.active = 0;


      $scope.createCowMarketplace = function (product, group) {
        var slug = product.slug;

        if ($rootScope.isLogged) {
          cowEventService.createCowEventMarketplace(slug, group).then(function (data) {
            console.log(data);
            $analytics.eventTrack('cow-created-user', {category: 'cow-created-user', value: 1});
            var cowId = data.cow_id;
            $rootScope.scrapeFbCowEvent(cowId);
            $state.go('cow-admin', {
              cowId: cowId
            });
          }, function (err) {
            console.log('err login', err);
            toastr.error('Si el error persiste, comunicate con nosotros.', 'Error creando la Vaca');
          });
        } else {
          cowEventService.createCowEventMarketplace(slug, group).then(function (data) {
            console.log(data);
            $analytics.eventTrack('cow-created-temp', {category: 'cow-created-temp', value: 1});
            var cowId = data.cow_id;
            $rootScope.scrapeFbCowEvent(cowId);
            $state.go('cow-temp', {
              cowId: cowId
            });
          }, function (err) {
            console.log('err login', err);
            toastr.error('Si el error persiste, comunicate con nosotros.', 'Error creando la Vaca');
          });
        }

      };


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('prices', {
          url: '/tarifas-hacer-una-vaca-online',
          templateUrl: 'app/views/prices/prices.html',
          controller: 'PricesController',
          controllerAs: 'prices',
          resolve: {
            matrixCommissions: function (paymentService) {
              return paymentService.getMatrixComissionsList();
            }
          },
          data: {
            'meta': {
              'title': 'Tarifas para hacer la Vaca Online',
                'description': 'Conoce cuánto cuesta armar una Vaca Online.'
            }
          }
        })
    })
    .controller('PricesController', function ($scope, $state, $rootScope, usersService, matrixCommissions, ngDialog,
                                              highValueCowPercentageFee, efectyCashoutFee, smoothScroll, businessCowTypeSlug,
                                              publicCowPercentageFee) {

      console.log('prices');

      $scope.matrixCommissions = matrixCommissions;

      $scope.highValueCowPercentageFee = (highValueCowPercentageFee * 100).toFixed(2);

      $scope.efectyCashoutFee = efectyCashoutFee * 100;

      $scope.publicCowFee = (publicCowPercentageFee * 100).toFixed(2);

      $scope.goToCalculator = function (fee) {
        $scope.selectedFee = fee;

        var element = document.getElementById('feeMessageContainer');
        smoothScroll(element);
      };

      $scope.goCreateCow = function (fee) {
        if (fee === 2) {
          $state.go('cow-create', {cow_type: businessCowTypeSlug});
        }

        else if (fee === 3) {
          $state.go('cow-create', {is_public: true});
        }

        else {
          $state.go('cow-create');
        }

        // fbq('trackCustom', 'CrearVaca', {button: 'prices'});
      };

      // $scope.atvIsFree = true;
      // if ($scope.atvIsFree) {
      //   ngDialog.open({
      //     template: 'atvFreeModal',
      //     controller: 'atvFreeModalCtrl',
      //     className: 'atvFree ngdialog-theme-default',
      //     showClose: false,
      //     closeByEscape: false,
      //     closeByDocument: false
      //   });
      // }
    })
    // .controller('atvFreeModalCtrl', function ($scope, $state, ngDialog) {
    //     $scope.closeAtvFreeDialog = function (dialogId) {
    //       $state.go('home');
    //       ngDialog.close(dialogId);
    //     }
    // })
  ;
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('payment-respond', {
          url: '/respuesta-pago?id_pago',
          templateUrl: 'app/views/paymentRespond/paymentRespond.html',
          controller: 'PaymentRespondController',
          controllerAs: 'payment-respond',
          resolve: {
            paymentId: function ($stateParams) {
              return $stateParams.id_pago;
            },
            paymentResp: function (paymentId, paymentService) {
              if (paymentId) {
                return paymentService.checkPaymentStatus(paymentId);
              }
              else {
                return 'none';
              }
            }
          },
          data: {
            'meta': {
              'title': 'Respuesta del pago',
                'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('PaymentRespondController', function ($scope, $state, $window, paymentService, $stateParams, paymentId,
                                                      paymentResp, fepURL) {
      console.log('payment respondd');

      console.log(paymentResp);
      if (paymentResp != 'none') {
        $scope.paymentResp = paymentResp.payment_data;

        if ($scope.paymentResp.cow_event.is_business === true && $scope.paymentResp.cow_event.business_type === 2) {
          $scope.isFepCow = true;
        }

        if ($scope.paymentResp.cow_event.branded_subtype != null && $scope.paymentResp.cow_event.branded_subtype.branded_type.slug === "FEP2020") {
          $window.location.href = fepURL + "respuesta-pago?id_pago=" + paymentId
        }
      }

      $scope.retryFepPayment = function (cowId) {
        $state.go('fep-cow-participate', {cowId: cowId}, {reload: true});
      };

      $scope.goToFepCow = function (cowId) {
        $state.go('fep-cow', {cowId: cowId}, {reload: true});
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-participate', {
          url: '/participante/:cowId?id_pago&via&send_token',
          templateUrl: 'app/views/participate/participate.html',
          controller: 'ParticipateController',
          controllerAs: 'participate',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            paymentId: function ($stateParams) {
              return $stateParams.id_pago;
            },
            viaPayment: function ($stateParams) {
              return $stateParams.via
            },
            sendToken: function ($stateParams) {
              return $stateParams.send_token

            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCowPublic(cowId);
            },
            matrixCommissions: function (paymentService) {
              return paymentService.getMatrixComissionsList();
            },
            notifyAlert: function (AboutUsService) {
              return AboutUsService.getNotifyAlerts();
            },
            paymentMethods: function (paymentService) {
              return paymentService.getPaymentMethods();
            },
            pseBanks: function (participationService) {
              return participationService.getPseBanks();
            }
          },
          data: {
            'meta': {
              'title': 'Participar',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('ParticipateController', function ($scope, $state, $rootScope, usersService, $stateParams, cowId, $log,
      cow, toastr, participationService, ruteCode, urlPart1, urlPart2,
      $window, minPaymentValue, matrixCommissions, paymentService,
      $mdDialog, paymentId, smoothScroll, additionalParticipantFee,
      psePaymentCode, ccPaymentCode, efectyPaymentCode, maxPaymentValue, maxPaymentValueCC,
      cowBusinessTypePolitical, ngDialog, cowBusinessTypeCredibanco,
      notifyAlert, paymentMethods, pricingPlanPro, pricingPlanFree,
      creditCardFee, ivaValue, maxTotalValueFreePlan, paymentSlugPse,
      paymentSlugTc, paymentSlugEfecty, atvURL, efectyTier1Limit, efectyTier2Limit,
      efectyTier1Fee, efectyTier2Fee, viaPayment, sendToken, key_site_gg,
      pseBanks, key_site_gg_v2) {
      //PSE Integration
      $scope.pseBanks = pseBanks;
      $scope.pseOptions = {
        pseBankSelected: "0",
        psePersonTypeSelected: "N"
      }
      //$window.fbq('trackCustom', 'EntraParticipar');

      $scope.notifyAlert = notifyAlert;
      $scope.reminder_payment = {
        enabled: false
      };
      $scope.secondValidation = false;

      $scope.verifyUserLoggedIn = function () {
        if (!$scope.user) {
          $scope.reminder_payment.enabled = false;
          ngDialog.open({
            template: 'reminderPaymentOption',
            scope: $scope,
            showClose: false,
            closeByEscape: false,
            closeByNavigation: true,
            closeByDocument: true
          });
        }
      };

      $scope.acceptLoginUser = function (closeId) {
        ngDialog.close(closeId);
        $state.go('login', {
          response_url: atvURL + 'participante/' + cowId
        });
      };


      $scope.efectyActive = _.find(paymentMethods, function (o) {
        return o.slug === paymentSlugEfecty;
      });

      $scope.pseActive = _.find(paymentMethods, function (o) {
        return o.slug === paymentSlugPse;
      });

      $scope.tcActive = _.find(paymentMethods, function (o) {
        return o.slug === paymentSlugTc;
      });

      if ($scope.notifyAlert.length > 0) {
        ngDialog.open({
          template: 'notifyAlertDialog',
          scope: $scope,
          showClose: false,
          closeByEscape: false,
          closeByNavigation: true,
          closeByDocument: false
        });
      }
      $scope.acceptNotifyAlert = function (closeId) {
        ngDialog.close(closeId);
      };

      if (cow.deleted) {
        $state.go('cow-deleted', {
          cowId: cowId
        });
      }
      if (cow.closed) {
        $state.go('cow', {
          cowId: cowId
        });
      }
      if (cow.is_promo) {
        $state.go('cow', {
          cowId: cowId
        });
      }

      if (cow.is_business === true && cow.business_type === cowBusinessTypeCredibanco) {
        $state.go('credibanco-cow', { cowId: cowId });
      }

      $scope.cow_event = cow;
      $scope.cowIsPlanPro = $scope.cow_event.pricing_plan === null || $scope.cow_event.pricing_plan.slug !== pricingPlanFree;

      $scope.minPaymentValue = minPaymentValue;
      $scope.maxPaymentValue = maxPaymentValue;
      $scope.maxPaymentValueCC = maxPaymentValueCC;
      if (!$scope.cowIsPlanPro) {
        $scope.maxPaymentValue = maxTotalValueFreePlan - $scope.cow_event.total_value;
      }

      $scope.today = moment();
      $scope.actualMonth = $scope.today.month();
      $scope.actualYear = $scope.today.year() - 2000;

      $scope.matrixCommissions = matrixCommissions;

      $scope.user_participation = {
        cow_id: cowId,
        send_promotional_emails: true,
        fixed_participants: "1",
        force_payment_pending: false,
        save_credit_card: false
      };

      $scope.user_participation.participantsOptions = [];

      $scope.additionalValues = [];

      $scope.previous_payment = 0;

      if ($scope.cow_event.business_type === cowBusinessTypePolitical) {
        ngDialog.open({
          template: 'politicalTermsDialog',
          scope: $scope,
          showClose: false,
          closeByEscape: false,
          closeByNavigation: true,
          closeByDocument: false
        });
      }

      $scope.acceptPoliticalTerms = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.createUpdateArrayParticipantsOptions = function () {
        var lenght = parseInt($scope.user_participation.fixed_participants);
        var i;
        for (i = 0; i < lenght; i++) {
          var elementTemp = {
            id: i
          };
          $scope.user_participation.participantsOptions.push(elementTemp);
        }
      };

      $scope.createUpdateArrayParticipantsOptions();

      // $scope.optionsParticipants = [$scope.user_participation.fixed_participants];

      $scope.payment_redirect = false;

      $scope.total_amount_readonly = false;

      $scope.commission_value_matrix = 0;

      $scope.discount_value = 0;

      $scope.cow_has_gift_code = false;

      $scope.user_participation.document_type = 1;

      $scope.gift_code_obj = {};

      $scope.acceptTermsConditions = false;

      if ($scope.cow_event.gift_code) {
        $scope.cow_has_gift_code = true;
        if ($scope.cow_event.gift_code.type === 0 || $scope.cow_event.gift_code.type === 1 || $scope.cow_event.gift_code.type === 2) {
          $scope.gift_code_obj = $scope.cow_event.gift_code;
          $scope.user_participation.gift_code = $scope.gift_code_obj.slug;
        }
      }

      $scope.additionalParticipantFee = additionalParticipantFee;
      $scope.multiple_participants_fee = 0;

      if ($scope.cow_event.marketplace) {
        $scope.minPaymentValue = 1;
        $scope.maxPaymentValue = $scope.cow_event.cow_goal - $scope.cow_event.total_value;
      }

      $scope.calculateCommissionAmountPercentage = function () {
        $scope.commission_value_all = $scope.user_participation.total_value * $scope.commission_value_matrix;

        if (!$scope.ccCollapsed && $scope.cow_event.pricing_plan !== null) {
          $scope.commission_value_all += ($scope.user_participation.total_value * creditCardFee * (1 + ivaValue));
        }

        if (!$scope.efectyCollapsed) {
          if ($scope.user_participation.total_value <= efectyTier1Limit) {
            $scope.commission_value_all += efectyTier1Fee * (1 + ivaValue);
          }
          else if ($scope.user_participation.total_value > efectyTier1Limit) {
            $scope.commission_value_all += efectyTier2Fee * (1 + ivaValue);
          }
        }

        if ($scope.cow_event.marketplace) {
          $scope.commission_value_all = 0;
        }

        if ($scope.gift_code_obj.valid) {
          if ($scope.gift_code_obj.type === 0) {
            $scope.discount_value = $scope.gift_code_obj.percentage_value * $scope.commission_value_all;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          } else if ($scope.gift_code_obj.type === 1) {
            $scope.discount_value = $scope.gift_code_obj.int_value;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          } else if ($scope.gift_code_obj.type === 2) {
            $scope.discount_value = 0;
            $scope.commission_value_all = $scope.gift_code_obj.int_value;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          }
          if ($scope.cow_event.commission_added) {
            $scope.commission_value = $scope.commission_value_all;
            $scope.total_value_commission = $scope.user_participation.total_value + $scope.commission_value - $scope.discount_value
              + $scope.multiple_participants_fee;
          } else if ($scope.cow_event.commission_deducted) {
            $scope.commission_value = $scope.commission_value_all - $scope.discount_value + $scope.multiple_participants_fee;
            $scope.total_value_commission = $scope.user_participation.total_value;
          }
        } else {
          if ($scope.cow_event.commission_added) {
            $scope.commission_value = $scope.commission_value_all;
            $scope.total_value_commission = $scope.user_participation.total_value + $scope.commission_value + $scope.multiple_participants_fee;
          } else if ($scope.cow_event.commission_deducted) {
            $scope.commission_value = $scope.commission_value_all + $scope.multiple_participants_fee;
            $scope.total_value_commission = $scope.user_participation.total_value;
          }
        }
      };

      $scope.calculateCommissionAmountFixed = function () {
        $scope.commission_value_all = $scope.commission_value_matrix;

        if (!$scope.ccCollapsed && $scope.cow_event.pricing_plan !== null) {
          $scope.commission_value_all += ($scope.user_participation.total_value * creditCardFee * (1 + ivaValue));
        }

        if (!$scope.efectyCollapsed) {
          if ($scope.user_participation.total_value <= efectyTier1Limit) {
            $scope.commission_value_all += efectyTier1Fee * (1 + ivaValue);
          }
          else if ($scope.user_participation.total_value > efectyTier1Limit) {
            $scope.commission_value_all += efectyTier2Fee * (1 + ivaValue);
          }
        }

        if ($scope.cow_event.marketplace) {
          $scope.commission_value_all = 0;
        }

        if ($scope.gift_code_obj.valid) {
          if ($scope.gift_code_obj.type === 0) {
            $scope.discount_value = $scope.gift_code_obj.percentage_value * $scope.commission_value_matrix;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          } else if ($scope.gift_code_obj.type === 1) {
            $scope.discount_value = $scope.gift_code_obj.int_value;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          } else if ($scope.gift_code_obj.type === 2) {
            $scope.discount_value = 0;
            $scope.commission_value_all = $scope.gift_code_obj.int_value;
            $scope.gift_code_obj.discount_value = $scope.discount_value;
          }

          if ($scope.cow_event.commission_added) {
            $scope.commission_value = $scope.commission_value_all;
            $scope.total_value_commission = $scope.user_participation.total_value + $scope.commission_value - $scope.discount_value
              + $scope.multiple_participants_fee;
          } else if ($scope.cow_event.commission_deducted) {
            $scope.commission_value = $scope.commission_value_all - $scope.discount_value + $scope.multiple_participants_fee;
            $scope.total_value_commission = $scope.user_participation.total_value;
          }
        } else {
          if ($scope.cow_event.commission_added) {
            $scope.commission_value = $scope.commission_value_all;
            $scope.total_value_commission = $scope.user_participation.total_value + $scope.commission_value + $scope.multiple_participants_fee;
          } else if ($scope.cow_event.commission_deducted) {
            $scope.commission_value = $scope.commission_value_all + $scope.multiple_participants_fee;
            $scope.total_value_commission = $scope.user_participation.total_value;
          }
        }
      };

      $scope.getOptionAdditionalValue = function (optionType, optionId) {
        var optionTypeTemp = _.find($scope.cow_event.options.custom_options, function (o) {
          return o.option_type.id == optionType;
        });
        var optionIdTemp = _.find(optionTypeTemp.options, function (op) {
          return op.id == optionId;
        });

        return optionIdTemp;
      };

      $scope.totalValueChanged = function () {

        if ($scope.cow_event.participation_fixed) {
          $scope.user_participation.total_value = $scope.cow_event.participant_value_fixed * $scope.user_participation.fixed_participants;
          $scope.multiple_participants_fee = $scope.additionalParticipantFee * ($scope.user_participation.fixed_participants - 1);
        }

        if ($scope.cow_event.options && $scope.cow_event.has_options && $scope.cow_event.participation_fixed) {
          $scope.additionalValues = [];
          _.forEach($scope.user_participation.participantsOptions, function (value) {
            var participantAdditionalValue = 0

            _.forEach(value.options, function (value_opt) {
              console.log(value.options);
              var value_opt_array = value_opt.split('-');
              var optionType = value_opt_array[0];
              var optionId = value_opt_array[1];

              var optionFound = $scope.getOptionAdditionalValue(optionType, optionId);

              $scope.user_participation.total_value += optionFound.additional_value;

              participantAdditionalValue += optionFound.additional_value;
            });

            var additionalValueObj = {
              additionalValue: participantAdditionalValue
            };

            $scope.additionalValues.push(additionalValueObj);
          });
        }

        if ($scope.user_participation.total_value >= $scope.minPaymentValue && $scope.user_participation.total_value <= $scope.maxPaymentValue) {
          var commTemp = _.find($scope.matrixCommissions, function (o) {
            return o.min_value <= $scope.user_participation.total_value && o.max_value > $scope.user_participation.total_value;
          });
          if ($scope.gift_code_obj.max_value < $scope.user_participation.total_value || $scope.gift_code_obj.min_value > $scope.user_participation.total_value) {
            $scope.gift_code_obj = {};
            $scope.gift_code = '';
            delete $scope.user_participation.gift_code;
          }
          if (commTemp) {
            if (commTemp.fixed) {
              $scope.commission_value_matrix = commTemp.fixed_value;
              $scope.calculateCommissionAmountFixed();
            } else if (commTemp.percentage) {
              $scope.commission_value_matrix = commTemp.percentage_value;
              $scope.calculateCommissionAmountPercentage();
            } else {
              $scope.commission_value_matrix = 0.10;
              $scope.calculateCommissionAmountPercentage();
            }
          } else {
            $scope.commission_value_matrix = 0.10;
            $scope.calculateCommissionAmountPercentage();
          }
        }
      };

      if ($scope.cow_event.participation_fixed) {
        $scope.user_participation.total_value = $scope.cow_event.participant_value_fixed;
        $scope.totalAmountReadOnly = true;
        $scope.totalValueChanged();
      } else if ($scope.cow_event.participation_suggested) {
        $scope.user_participation.total_value = $scope.cow_event.participant_value_suggested;
        $scope.totalValueChanged();
      }

      usersService.getUserData().then(function (data) {
        $scope.user = data.user;
        $scope.user_participation.first_name = $scope.user.user.first_name;
        $scope.user_participation.last_name = $scope.user.user.last_name;
        $scope.user_participation.email = $scope.user.user.email;
        $scope.user_participation.document_number = $scope.user.document_number;
        $scope.user_participation.document_full_number = $scope.user.document_full_number;
        $scope.user_participation.save_credit_card = true;
        if ($scope.user.document_type === 1 || $scope.user.document_type === 2 ||
          $scope.user.document_type === 3 || $scope.user.document_type === 4) {
          $scope.user_participation.document_type = $scope.user.document_type;
        }
        if ($scope.user.cellphone) {
          $scope.user_participation.cellphone = $scope.user.cellphone.toString();
        }

        // if (!$scope.cow_event.options && !$scope.cow_event.has_options) {
        //   $scope.submitPersonalForm($scope.personalInfoForm.$valid);
        // }

        paymentService.getUserCreditCards().then(function (data) {
          $scope.userCreditCards = data.credit_cards;
        }, function (err) {
        });
      }, function (err) {
      });

      if (paymentId) {
        paymentService.getPaymentData(paymentId).then(function (data) {
          $scope.participant_data = data.payment_data.participant;
          console.log($scope.participant_data);

          $scope.user_participation.first_name = $scope.participant_data.first_name;
          $scope.user_participation.last_name = $scope.participant_data.last_name;
          if ($scope.participant_data.document_type === 1 || $scope.participant_data.document_type === 2 ||
            $scope.participant_data.document_type === 3 || $scope.user.document_type === 4) {
            $scope.user_participation.document_type = $scope.participant_data.document_type;
          }
          $scope.user_participation.document_number = $scope.participant_data.document_number;
          $scope.user_participation.document_full_number = $scope.user.document_full_number;
          $scope.user_participation.email = $scope.participant_data.email;
          $scope.user_participation.cellphone = $scope.participant_data.cellphone.toString();

          $scope.submitPersonalForm($scope.personalInfoForm.$valid);
        });
      }

      $scope.setDocumentNumber = function () {
        if ($scope.user_participation.document_full_number) {
          $scope.user_participation.document_number = $scope.user_participation.document_full_number.replace(/[^0-9]/g, '');
        }
      };

      $scope.setDocumentFullNumber = function () {
        if ($scope.user_participation.document_number) {
          $scope.user_participation.document_full_number = $scope.user_participation.document_number;
        }
      };

      $scope.participateCow = function (isValid) {
        if (isValid) {
          $scope.createParticipation();
        } else {
          var element = document.getElementById('top-scroll');
          smoothScroll(element);
        }
      };

      $scope.createParticipation = function () {
        $scope.user_participation.pse_person = $scope.pseOptions.psePersonTypeSelected;
        $scope.user_participation.pse_bank = $scope.pseOptions.pseBankSelected;

        grecaptcha.ready(function () {
          grecaptcha.execute(key_site_gg, { action: 'Participation' }).then(function (token) {
            participationService.createParticipation(
              $scope.user_participation,
              token
            ).then(function (data) {
              if (data.pending) {
                $scope.toastPending();
                $scope.previous_payment = data.previous_payment
              } else if (!data.valid && data.blacklist) {
                toastr.info('Ha ocurrido un error con los datos suministrados, comunicate con nosotros para más información.');
              } else {
                if ($scope.pseCollapsed === false) {
                  var url_final = data.redirect_url;
                  $scope.payment_redirect = true;
                  $window.location.href = url_final;
                } else {
                  $state.go('payment-respond', { id_pago: data.payment_id });
                }
              }
            }, function (err) {
              if (err.status == 401) {
                $scope.secondValidation = true;
                grecaptcha.render('container_recaptchaV2', {
                  'sitekey': key_site_gg_v2,
                  'callback': function (e) {
                    if (grecaptcha.getResponse()) {
                      participationService.createParticipation($scope.user_participation, e, $scope.secondValidation).then(
                        function (data) {
                          if (data.pending) {
                            $scope.toastPending();
                            $scope.previous_payment = data.previous_payment
                          } else if (!data.valid && data.blacklist) {
                            toastr.info('Ha ocurrido un error con los datos suministrados, comunicate con nosotros para más información.');
                          } else {
                            if ($scope.pseCollapsed === false) {
                              var url_final = data.redirect_url;
                              $scope.payment_redirect = true;
                              $window.location.href = url_final;
                            } else {
                              $state.go('payment-respond', { id_pago: data.payment_id });
                            }
                          }
                        }, function (err) {
                          if (err.status == 401) {
                            toastr.error('¡Error validando tu identidad!.', 'Error creando la solicitud.');

                          } else {
                            $scope.secondValidation = false;
                            toastr.error('Si el error persiste, comunicate con nosotros.', 'Error creando la solicitud.');
                          }
                        }
                      );
                    }
                  }
                });
              }
            });
          });
        });
      };

      $scope.checkPreviousParticipation = function () {
        $state.go('payment-respond', { id_pago: $scope.previous_payment });
      };

      $scope.toastPending = function () {
        $scope.payment_pending = true;
        toastr.info('En este momento tienes un pago pendiente, inténtalo mas tarde.', 'Pago pendiente');
      };

      $scope.applyCoupon = function () {
        if ($scope.gift_code === '' || $scope.gift_code === undefined) {
          if ($scope.user_participation.total_value < $scope.minPaymentValue && $scope.user_participation.total_value < $scope.maxPaymentValue) {
            toastr.info('Primero debes ingresar un valor');
          } else {
            toastr.info('Debes ingresar el código promocional con mayúsculas y minúsculas');
          }
        } else if (($scope.user_participation.total_value < $scope.minPaymentValue && $scope.user_participation.total_value > $scope.maxPaymentValue) ||
          $scope.user_participation.total_value === undefined) {
          toastr.info('Primero debes ingresar un valor');
        } else {
          var data_gift_code = {
            gift_code: $scope.gift_code,
            payment_value: $scope.user_participation.total_value
          };
          paymentService.validateGiftCode(data_gift_code).then(function (data) {
            console.log(data);
            $scope.gift_code_obj = data;
            $scope.totalValueChanged();
            $scope.user_participation.gift_code = $scope.gift_code_obj.slug;
            toastr.success('Código aplicado con éxito');
          }, function (err) {
            console.log('err login', err);
            toastr.error('El código no es válido o se encuentra mal escrito');
          });
        }

      };

      $scope.scrollToTop = function () {
        var element = document.getElementById('top-scroll');
        smoothScroll(element);
      };

      $scope.$watch('user_participation.total_value', function (newValue, oldValue) {
        if (newValue === 0) {
          delete $scope.user_participation.total_value;
        }
      });

      $scope.$watch('user_participation.fixed_participants', function (newValue, oldValue) {
        if (newValue > oldValue) {
          var diff = newValue - oldValue;
          var i;
          for (i = 0; i < diff; i++) {
            var elementTemp = {
              id: ($scope.user_participation.participantsOptions.length)
            };
            $scope.user_participation.participantsOptions.push(elementTemp);
          }
        } else if (newValue < oldValue) {
          var diff = newValue;
          var i;
          for (i = $scope.user_participation.participantsOptions.length; i >= diff; i--) {
            $scope.user_participation.participantsOptions.splice(i, 1);
          }
        }
        $scope.totalValueChanged();
      });

      $scope.showPersonalInfoForm = true;
      $scope.submitPersonalForm = function (isValid) {
        if (isValid) {
          $scope.showPersonalInfoForm = false;
        }
      };

      $scope.submitPayment = function () {
        $scope.personalInfoForm.$setSubmitted();
        $scope.participationForm.$setSubmitted();

        $scope.personalInfoValid = $scope.personalInfoForm.$valid;
        $scope.participationValid = $scope.participationForm.$valid;

        $scope.personalAndParticipationInfoValid = $scope.personalInfoValid && $scope.participationValid;

        if ($scope.user_participation.total_value < $scope.minPaymentValue || $scope.user_participation.total_value > $scope.maxPaymentValue) {
          $scope.personalAndParticipationInfoValid = false;
        }

        //reminder payment
        if ($scope.reminder_payment.enabled) {
          $scope.user_participation.reminder_payment = true;
        }

        if ($scope.personalAndParticipationInfoValid) {
          if ($scope.ccCollapsed === true && $scope.pseCollapsed === true && $scope.efectyCollapsed === true) {
            toastr.info('Debes seleccionar un método de pago', 'Método de pago');
          } else if ($scope.ccCollapsed === false) {
            $scope.ccForm.$setSubmitted();
            $scope.ccValid = $scope.ccForm.$valid;

            $scope.invalid_card_type = $scope.ccForm.ccNumber.$ccEagerType !== 'MasterCard' &&
              $scope.ccForm.ccNumber.$ccEagerType !== 'Visa' &&
              $scope.ccForm.ccNumber.$ccEagerType !== 'Diners Club';

            if ($scope.creditCardSelected) {
              $scope.user_participation.payment_method = ccPaymentCode;
              $scope.user_participation.credit_card_token = $scope.creditCardSelected.id;
              $scope.user_participation.pay_with_token = true;
              $scope.isCcTokenSummary();
              $scope.showPaymentMethods();
            } else if (!$scope.ccValid || $scope.invalid_card_type) {
              toastr.info('Verifica los datos de la tarjeta', 'Tarjeta Inválida');
            } else if ($scope.ccValid && !$scope.creditCardSelected) {
              $scope.user_participation.payment_method = ccPaymentCode;
              $scope.user_participation.card.type = $scope.ccForm.ccNumber.$ccType;
              $scope.user_participation.pay_with_token = false;
              $scope.isCcSummary();
              $scope.showPaymentMethods();
            }
          } else if ($scope.pseCollapsed === false) {
            if ($scope.pseOptions.pseBankSelected !== "0") {
              $scope.user_participation.payment_method = psePaymentCode;
              $scope.isPSESummary();
              $scope.showPaymentMethods();
            } else {
              toastr.info('Selecciona el banco con el cual vas a pagar', 'PSE');
            }
          } else if ($scope.efectyCollapsed === false) {
            $scope.user_participation.payment_method = efectyPaymentCode;
            $scope.isEfectySummary();
            $scope.showPaymentMethods();
          }
        } else {
          toastr.info('Por favor verifica todos los campos', 'Participación incompleta');
          $scope.scrollToTop();
        }
      };

      $scope.showPersonalInfoFormEdit = function () {
        $scope.showPersonalInfoForm = true;
      };

      $scope.efectyCollapsed = true;
      $scope.paymentMethodToEfecty = function () {
        $scope.efectyCollapsed = !$scope.efectyCollapsed;
        $scope.pseCollapsed = true;
        $scope.ccCollapsed = true;
        $scope.maxPaymentValue = efectyTier2Limit;
        if ($scope.creditCardSelected) {
          $scope.creditCardSelected.checked = false;
          delete $scope.creditCardSelected;
        }
        $scope.totalValueChanged();
      };

      $scope.pseCollapsed = true;
      $scope.paymentMethodToPse = function () {
        $scope.pseCollapsed = !$scope.pseCollapsed;
        $scope.efectyCollapsed = true;
        $scope.ccCollapsed = true;
        $scope.maxPaymentValue = maxPaymentValue;
        if (!$scope.cowIsPlanPro) {
          $scope.maxPaymentValue = maxTotalValueFreePlan - $scope.cow_event.total_value;
        }
        if ($scope.creditCardSelected) {
          $scope.creditCardSelected.checked = false;
          delete $scope.creditCardSelected;
        }
        $scope.totalValueChanged();
      };

      if (!$scope.cowIsPlanPro) {
        $scope.paymentMethodToPse();
      }

      $scope.ccCollapsed = true;
      $scope.paymentMethodToCc = function () {
        $scope.ccCollapsed = !$scope.ccCollapsed;
        $scope.pseCollapsed = true;
        $scope.efectyCollapsed = true;
        $scope.maxPaymentValue = maxPaymentValueCC;
        $scope.totalValueChanged();
      };

      $scope.checkedChanged = function (creditCard) {
        _.forEach($scope.userCreditCards, function (value) {
          if (creditCard.id === value.id) {
            if (value.checked === true) {
              $scope.creditCardSelected = value;
            } else {
              delete $scope.creditCardSelected;
            }
          } else {
            value.checked = false;
          }
        });
      };

      $scope.showPaymentMethods = function () {
        $scope.showSummary = true;
        $scope.showPersonalDataForm = false;
        $scope.scrollToTop();
      };

      $scope.confirmPayment = function () {
        if ($scope.acceptTermsConditions) {
          $scope.participateCow(true);
        } else {
          toastr.info("Debes aceptar los términos y condiciones y política de tratamiento de datos")
        }
      };

      $scope.backToPersonalDataForm = function () {
        $scope.showSummary = false;
        $scope.showPersonalDataForm = true;
      };

      $scope.isEfectySummary = function () {
        $scope.efectySummary = true;
        $scope.pseSummary = false;
        $scope.ccSummary = false;
        $scope.ccTokenSummary = false;
      };

      $scope.isPSESummary = function () {
        $scope.pseSummary = true;
        $scope.efectySummary = false;
        $scope.ccSummary = false;
        $scope.ccTokenSummary = false;
      };

      $scope.isCcSummary = function () {
        $scope.efectySummary = false;
        $scope.pseSummary = false;
        $scope.ccSummary = true;
        $scope.ccTokenSummary = false;
        // $scope.strCcNumber = $scope.ccForm.ccNumber.toString();
        $scope.strCcNumber = $scope.user_participation.card.number;
        $scope.ccLastNumbers = $scope.strCcNumber.substring(12, 16);
      };

      $scope.isCcTokenSummary = function () {
        $scope.efectySummary = false;
        $scope.pseSummary = false;
        $scope.ccSummary = false;
        $scope.ccTokenSummary = true;
      };

      $scope.showPersonalDataForm = true;

      $scope.viaPayment = viaPayment;
      $scope.sendToken = sendToken;

      $scope.preloadViaPayment = function () {
        if (viaPayment) {
          switch (viaPayment) {
            case '5':
              $scope.paymentMethodToCc();
              break;
            case '4':
              $scope.paymentMethodToPse();
              $scope.pseCollapsed = false;

          }
        }
      };

      $scope.preloadSendToken = function () {
        if (sendToken) {
          $mdDialog.show({
            controller: ShowCowSendMoneyDialogController,
            templateUrl: 'app/views/participate/cowSendMoneyDialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            locals: {
              $state: $state,
              sendToken: sendToken
            }
          })
        }
      };


      function ShowCowSendMoneyDialogController($scope, $mdDialog, sendToken, atvURL, toastr) {
        $scope.completeURLSendToken = atvURL + "recibir-dinero-vaca/" + sendToken;

        $scope.copyLink = function () {
          toastr.success('El link se ha guardado en el portapapeles', 'Link guardado');
        };

        $scope.closeDialog = function () {
          $mdDialog.hide();
        }
      }

      $scope.preloadViaPayment();
      $scope.preloadSendToken();
    });
})();

(function () {
    'use strict';

    angular
        .module('user')
        .config(function ($stateProvider) {
            $stateProvider
                .state('membership-card-update', {
                    url: '/actualizar-carnet/:memberId',
                    templateUrl: 'app/views/membershipCardUpdate/membershipCardUpdate.html',
                    controller: 'MembershipCardUpdateController',
                    controllerAs: 'membership-card-update',
                    resolve: {
                        memberId: function ($stateParams) {
                            return $stateParams.memberId;
                        },
                        member: function (memberService, memberId) {
                            return memberService.getMemberData(memberId);
                        }
                    },
                    data: {
                        'meta': {
                            'title': 'Generar Carnet',
                            'robots': 'noindex, nofollow'
                        }
                    }
                })
        })
        .controller('MembershipCardUpdateController', function ($scope, $state, $rootScope, $stateParams, $log,
                                                                 toastr, memberService, memberId, member, ngDialog) {

            console.log('membership card');
            console.log(member);

            $scope.memberId = memberId;
            $scope.member = member.member_data;

            if ($scope.member.modified) {
                $scope.completedRegister = true;
            }

            if ($scope.member.payment) {
                $scope.mainOption = $scope.member.payment.cow_event.options.custom_options[0];
            }
            else if ($scope.member.cow_event) {
                $scope.mainOption = $scope.member.cow_event.options.custom_options[0];
            }

            if ($scope.member.member_img_raw == undefined) {
                $scope.member_img_raw = 'assets/images/utils/man-user.png';
            }
            else {
                $scope.member_img_raw = $scope.member.member_img_raw;
            }

            $scope.getMemberImage = function (imgUrl) {
                if (imgUrl) {
                    return {
                        "background": "url(\'" + imgUrl + "\') no-repeat",
                        "background-position": "center",
                        "background-size": "cover"
                    };
                } else {
                    return {
                        "background": "url('assets/images/utils/man-user.png') no-repeat",
                        "background-position": "center",
                        "background-size": "cover"
                    };
                }
            };

            $scope.clickChangeMemberImage = function () {
                angular.element('#fileInput').trigger('click');
            };

            var handleFileSelect = function (evt) {
                var file = evt.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (evt) {
                    $scope.$apply(function ($scope) {
                        $scope.member_img_raw = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };
            angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);

            $scope.updateMember = function (isValid) {
                console.log($scope.member);
                if (isValid) {
                    if ($scope.member_img_raw_file == undefined && $scope.member.member_img_raw == undefined){
                        toastr.info('Debes añadir una foto para el carné', 'Registro incompleto');
                    }
                    else {
                        $scope.openMemberConfirmation();
                    }
                }
            };

            $scope.openMemberConfirmation = function (type) {
                ngDialog.open({
                    template: 'confirmationUpdateMember',
                    scope: $scope
                });
            };

            $scope.closeMemberConfirmation = function (closeId) {
                ngDialog.close(closeId);
            };

            $scope.acceptMemberConfirmation = function (closeId) {
                ngDialog.close(closeId);

                var selectedOption = _.find($scope.mainOption.options, {
                    'id': $scope.member.selected_option
                });
                $scope.member.selected_option_value = selectedOption.name;

                $scope.member_data = JSON.stringify($scope.member);

                $scope.blob_member_img.name = 'random.' + $scope.blob_member_img.type.replace("image/", "");

                console.log($scope.member);

                memberService.updateMember($scope.member_data, $scope.blob_member_img, $scope.member_img_raw_file)
                    .then(function (data) {
                        toastr.success('Actualización exitosa!');

                        $scope.completedRegister = true;

                    }, function (err) {
                        console.log('err login', err);
                        toastr.error('Si el error persiste, comunicate con nosotros.', 'Error actualizando el registro');
                    });
            };
        });
})();

(function () {
    'use strict';

    angular
        .module('user')
        .config(function ($stateProvider) {
            $stateProvider
                .state('membership-card-payment', {
                    url: '/generar-carnet-participante/:paymentId',
                    templateUrl: 'app/views/membershipCardPayment/membershipCardPayment.html',
                    controller: 'MembershipCardPaymentController',
                    controllerAs: 'membership-card-payment',
                    resolve: {
                        paymentId: function ($stateParams) {
                            return $stateParams.paymentId;
                        },
                        payment: function (paymentService, paymentId) {
                            return paymentService.getPaymentData(paymentId);
                        }
                    },
                    data: {
                        'meta': {
                            'title': 'Generar Carnet',
                            'robots': 'noindex, nofollow'
                        }
                    }
                })
        })
        .controller('MembershipCardPaymentController', function ($scope, $state, $rootScope, $stateParams, $log,
                                                          toastr, memberService, paymentId, payment) {

            console.log('membership card');
            console.log(payment);

            $scope.paymentId = paymentId;
            $scope.payment = payment.payment_data;
            $scope.member = {};

            $scope.mainOption = $scope.payment.cow_event.options.custom_options[0];

            $scope.currentMember = 1;
            $scope.completedRegister = false;
            if ($scope.payment.members_registered > 0) {
                $scope.currentMember = $scope.payment.members_registered + 1;

                if ($scope.payment.members_registered >= $scope.payment.num_participants) {
                    $scope.completedRegister = true;
                }
            }

            $scope.allParticipants = [];
            for (var i=1; i <= $scope.payment.num_participants; i++) {
                if ($scope.payment.members_registered >= i) {
                    var participant = {
                        id: i,
                        completed: true
                    };
                }
                else {
                    var participant = {
                        id: i,
                        completed: false
                    };
                }
                $scope.allParticipants.push(participant);
            }

            if ($scope.member_img_raw == undefined) {
                $scope.member_img_raw = 'assets/images/utils/man-user.png';
            }

            $scope.showMemberImage = true;
            $scope.showMemberImageEdit = false;

            $scope.showImageEdit = function () {
                $scope.showMemberImage = false;
                $scope.showMemberImageEdit = true;
            };

            $scope.closeImageEdit = function () {
                $scope.showMemberImage = true;
                $scope.showMemberImageEdit = false;
            };

            $scope.getMemberImage = function (imgUrl) {
                if (imgUrl) {
                    return {
                        "background": "url(\'" + imgUrl + "\') no-repeat",
                        "background-position": "center",
                        "background-size": "cover"
                    };
                } else {
                    return {
                        "background": "url('assets/images/utils/man-user.png') no-repeat",
                        "background-position": "center",
                        "background-size": "cover"
                    };
                }
            };

            $scope.clickChangeMemberImage = function () {
                angular.element('#fileInput').trigger('click');
            };

            var handleFileSelect = function (evt) {
                var file = evt.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (evt) {
                    $scope.$apply(function ($scope) {
                        $scope.member_img_raw = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };
            angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);

            $scope.addMember = function (isValid) {
                if (isValid) {
                    $scope.member.payment_id = $scope.paymentId;
                    $scope.member.member_id = $scope.paymentId + '-' + $scope.currentMember;
                    var selectedOption = _.find($scope.mainOption.options, {
                        'id': $scope.member.selected_option
                    });
                    $scope.member.selected_option_value = selectedOption.name;

                    $scope.member_data = JSON.stringify($scope.member);

                    if ($scope.blob_member_img) {
                        $scope.blob_member_img.name = 'random.' + $scope.blob_member_img.type.replace("image/", "");
                    }

                    console.log($scope.member);

                    memberService.createMember($scope.member_data, $scope.blob_member_img, $scope.member_img_raw_file)
                        .then(function (data) {
                            toastr.success('Actualización exitosa!');

                            $scope.membershipCardForm.$setPristine();
                            $scope.membershipCardForm.$setUntouched();
                            $scope.member = {};
                            delete $scope.blob_member_img;
                            delete $scope.member_img_raw_file;
                            $scope.member_img_raw = 'assets/images/utils/man-user.png';

                            $scope.allParticipants[$scope.currentMember - 1].completed = true;

                            if ($scope.currentMember < $scope.payment.num_participants) {
                                $scope.currentMember += 1;
                            }
                            else {
                                $scope.completedRegister = true;
                            }

                        }, function (err) {
                            console.log('err login', err);
                            toastr.error('Si el error persiste, comunicate con nosotros.', 'Error generando el carné');
                        });
                }
            };
        });
})();

(function () {
    'use strict';

    angular
        .module('user')
        .config(function ($stateProvider) {
            $stateProvider
                .state('membership-card-cow', {
                    url: '/generar-carnet-vaca/:cowId',
                    templateUrl: 'app/views/membershipCardCow/membershipCardCow.html',
                    controller: 'MembershipCardCowController',
                    controllerAs: 'membership-card-cow',
                    resolve: {
                        cowId: function ($stateParams) {
                            return $stateParams.cowId;
                        },
                        cow: function (cowEventService, cowId) {
                            return cowEventService.getCowPublic(cowId);
                        }
                    },
                    data: {
                        'meta': {
                            'title': 'Generar Carnet',
                            'robots': 'noindex, nofollow'
                        }
                    }
                })
        })
        .controller('MembershipCardCowController', function ($scope, $state, $rootScope, $stateParams, $log,
                                                             toastr, memberService, cowId, cow) {

            console.log('membership card cow');
            console.log(cow);

            $scope.cowId = cowId;
            $scope.cow = cow;
            $scope.member = {};

            $scope.mainOption = $scope.cow.options.custom_options[0];

            if ($scope.member_img_raw == undefined) {
                $scope.member_img_raw = 'assets/images/utils/man-user.png';
            }

            $scope.clickChangeMemberImage = function () {
                angular.element('#fileInput').trigger('click');
            };

            var handleFileSelect = function (evt) {
                var file = evt.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (evt) {
                    $scope.$apply(function ($scope) {
                        $scope.member_img_raw = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };
            angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);

            $scope.addMember = function (isValid) {
                if (isValid) {
                    $scope.member.cow_id = $scope.cowId;
                    var selectedOption = _.find($scope.mainOption.options, {
                        'id': $scope.member.selected_option
                    });
                    $scope.member.selected_option_value = selectedOption.name;

                    $scope.member_data = JSON.stringify($scope.member);

                    if ($scope.blob_member_img) {
                        $scope.blob_member_img.name = 'random.' + $scope.blob_member_img.type.replace("image/", "");
                    }

                    console.log($scope.member);

                    memberService.createMember($scope.member_data, $scope.blob_member_img, $scope.member_img_raw_file)
                        .then(function (data) {
                            toastr.success('¡Actualización exitosa! El carné se ha enviado al correo registrado');

                            $scope.membershipCardForm.$setPristine();
                            $scope.membershipCardForm.$setUntouched();
                            $scope.member = {};
                            delete $scope.blob_member_img;
                            delete $scope.member_img_raw_file;
                            $scope.member_img_raw = 'assets/images/utils/man-user.png';

                        }, function (err) {
                            console.log('err login', err);
                            toastr.error('Si el error persiste, comunicate con nosotros.', 'Error generando el carné');
                        });
                }
            };

            $scope.goToAdmin = function () {
                $state.go('cow-admin', {
                    cowId: cowId
                }, {
                    reload: true
                });
            };
        });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('marketplace', {
          url: '/marketplace',
          templateUrl: 'app/views/marketplace/marketplace.html',
          controller: 'MarketplaceController',
          controllerAs: 'marketplace',
          resolve: {
            companiesCategories: function (marketplaceService) {
              return marketplaceService.getCompaniesList();
            }
          },
          data: {
            'meta': {
              'title': 'Marketplace'
            }
          }
        })
    })
    .controller('MarketplaceController', function (toastr, $scope, $rootScope, usersService, $state, companiesCategories) {

      console.log('marketplace');
      console.log(companiesCategories);

      $scope.companiesCategories = companiesCategories;


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('home', {
          url: '/',
          templateUrl: 'app/views/main/main.html',
          controller: 'MainController',
          controllerAs: 'main',
          data: {
            'meta': {
              'title': 'Armatuvaca | Recolecta dinero en grupo Online'
            }
          },
          resolve: {
            cows: function (cowEventService) {
              return cowEventService.getPublicCows({limit: 3});
            },
          }
        })
    })
    .controller('MainController', function ($timeout, toastr, $scope, $analytics, $rootScope, usersService, $state,
                                            $window, AboutUsService, cows, $animate, atvPayURL) {

      // $analytics.pageTrack('home');

      //Redirect logged user to Cash Dashboard
      // $rootScope.loggedNotAllowed();


      //Random number between 1 and 3 to set background image randomly
      var min = 1;
      var max = 4;
      var random = Math.floor(Math.random() * (+max - +min)) + +min;
      var randomImage = "url('/assets/images/home/BackFilter" + random + ".jpg')";
      $scope.backgroundImage = {"background-image": randomImage};

      $scope.media_slides = [];

      $scope.selected_atv_question = 1;


      //Values Calc
      $scope.current = 0;
      $scope.tax = 0;
      $scope.percentage = 0;
      $scope.total = 0;
      $scope.onChangeCalc = function (current, tax, percentage, total) {
        $scope.current = current;
        $scope.tax = tax;
        $scope.percentage = percentage;
        $scope.total = total;
        $scope.four_by_thousand_tax = current * 0.004;
      }

      // Bar First View Options
      $scope.selected_atv_bar = 1;
      $scope.onSelectedItem = function (item) {
        $scope.selected_atv_bar = item;
      }
      $scope.cta_options = [
        {
          title: "Congela el precio y abona a tu ritmo",
          desc: "Escoge tu experiencia, crea tu Alcancía, congela el precio, paga el resto a tu ritmo y ¡disfruta!",
          primary_cta: {
            name: "Crear Alcancía",
            action: function () {
              window.open("https://alcancias.armatuvaca.com", '_blank');
            }
          },
          secondary_cta: {
            name: "Ir a mi Alcancía",
            action: function () {
              window.open("https://alcancias.armatuvaca.com", '_blank');
            }
          },
          main_img: "assets/images/newhome/firstview/crowdfunding.png"
        },
        {
          title: "Reúne dinero en grupo y gana tiempo",
          desc: "La nueva forma de recaudar dinero para regalos, viajes y más. Planea, gestiona y transfiere en grupo.",
          primary_cta: {
            name: "Armatuvaca",
            action: function () {
              $state.go('cow-create', {cow_type: 'group'});
            }
          },
          secondary_cta: null,
          main_img: "assets/images/newhome/firstview/group.png"
        },
        // {
        //   title: "Gestiona pagos y cobros con tus amigos",
        //   desc: "Descubre la nueva manera de manejar tus finanzas personales: cobra y transfiere a otras cuentas sin pagar más.",
        //   primary_cta: {
        //     name: "Maneja tu Dinero",
        //     action: function () {
        //       $state.go('cow-create', {cow_type: 'wallet'});
        //     }
        //   },
        //   secondary_cta: null,
        //   main_img: "assets/images/newhome/firstview/wallet.png"
        // },
        {
          title: "Vende y cobra facilmente",
          desc: "Recibe pagos de forma rápida y segura. Ofrece a tus clientes alternativas de recaudo diferentes.",
          primary_cta: {
            name: "Aumenta tus Ventas",
            action: function () {
              window.open(atvPayURL, '_blank');
            }
          },
          secondary_cta: null,
          main_img: "assets/images/newhome/firstview/business.png"
        }
      ]

      // ATV Questions
      // $scope.atv_questions = [
      //   {
      //     id: 1,
      //     question: '¿Puedo pagar con tarjeta de crédito?',
      //     image: 'assets/images/vs/tc.png',
      //     cash_response: 'Hmmm. No',
      //     bank_response: 'Haz un avance y después transfiere ese dinero a la cuenta destino',
      //     atv_response: 'Obvio. Paga y ya',
      //     alt: 'tc'
      //   },
      //   {
      //     id: 2,
      //     question: '¿Puedo ver quién ha pagado?',
      //     image: 'assets/images/vs/ver.png',
      //     cash_response: 'Alista papel y lápiz, abre un excel ...',
      //     bank_response: 'Ingresa a tu cuenta a movimientos e identifica la descripción del movimiento. Sin embargo pídele a quién te envió el dinero que te mande la confirmación',
      //     atv_response: 'Haz clic en Participantes',
      //     alt: 'ver'
      //   },
      //   {
      //     id: 3,
      //     question: '¿Dónde guardo la plata de mi Vaca?',
      //     image: 'assets/images/vs/separar.png',
      //     cash_response: 'Colchón, bolsillo, cajón de la mesa de noche, en la nevera…',
      //     bank_response: 'El dinero que te transfieran entra a tu cuenta cada vez que alguien te pague. Lleva el registro de cada uno de los movimientos y anota cuáles corresponden al dinero de la Vaca.',
      //     atv_response: 'Tú nos dices a dónde quieres que te la enviemos',
      //     alt: 'separar'
      //   },
      //   {
      //     id: 4,
      //     question: '¿Me puedan pagar desde cualquier banco y que no me cueste?',
      //     image: 'assets/images/vs/transfer.png',
      //     cash_response: 'Ve hasta un cajero, retira la plata y ve a entregarla',
      //     bank_response: 'Algunos te piden inscribir cuentas o datos de la cuenta a la que transfieres. Cada banco te cobra algo distinto.',
      //     atv_response: 'Te pueden pagar gratis por PSE desde cualquier banco',
      //     alt: 'transfer'
      //   },
      //   {
      //     id: 5,
      //     question: '¿Tiene algún costo?',
      //     image: 'assets/images/vs/costo.png',
      //     cash_response: 'Tiempo, gasolina, inseguridad... que mamera',
      //     bank_response: 'Aprox: $6900 por cada transferencia interbancaria - Aprox: $6,400 por avance de tarjeta de crédito - 4x1000',
      //     atv_response: 'Al gratín (Ver Tarifas para mas información)',
      //     alt: 'costo'
      //   }
      // ];

      // Steps Create Cow
      $scope.list_steps = [
        {
          title: '1. Armatuvaca',
          description: 'Haz clic en Armar Vaca, selecciona la categoria y listo.',
          img: 'assets/images/newhome/armarvaca/crea_vaca.png'
        },
        {
          title: '2. Invita',
          description: 'Abre tu Vaca, da clic en el botón compartir y envia a tus amigos.',
          img: 'assets/images/newhome/armarvaca/comparte_vaca.png'
        },
        {
          title: '3. Paga',
          description: 'Los participantes pueden pagar con PSE, tarjeta o Efecty.',
          img: 'assets/images/newhome/armarvaca/paga_vaca.png'
        },
        {
          title: '4. Saca',
          description: 'Saca tu dinero a una cuenta en Colombia, Efecty u otras Wallets.',
          img: 'assets/images/newhome/armarvaca/sacar_dinero.png'
        }

      ];

      // Advantages ATV
      $scope.list_adventage = [
        {
          title: 'Manejamos tarifas cómodas y claras',
          description: 'Tenemos Vacas para cada ocasión, GRATIS* o PRO.',
          img: 'assets/images/newhome/ventajas/1_tarifas.png'
        },
        {
          title: 'Recibimos diversos métodos de pago',
          description: 'PSE, tarjetas débito y crédito, Efecty, Nequi, Daviplata, Movii y más.',
          img: 'assets/images/newhome/ventajas/2_pagos.png'
        },
        {
          title: 'Una plataforma para llevarla a todo lado',
          description: 'Usa tu Vaca desde cualquier dispositivo. Puedes ingresar a Armatuvaca, desde tu computador o celular, donde sea que estés.',
          img: 'assets/images/newhome/ventajas/3_movil.png'
        },
        {
          title: 'Armatuvaca es seguro y confiable',
          description: 'Tenemos certificación PCI y contamos con certificados de seguridad.',
          img: 'assets/images/newhome/ventajas/4_seguro.png'
        },
        {
          title: 'Flexible y transparente',
          description: 'Tus datos están seguros, y nunca serán compartidos con terceras personas sin tu consentimiento.',
          img: 'assets/images/newhome/ventajas/5_flexible.png'
        },
        {
          title: 'Recauda dinero para lo que quieras',
          description: 'Si no llegas a tu meta, igual puedes retirar los fondos que recaudaste.',
          img: 'assets/images/newhome/ventajas/6_recaudo.png'
        }
      ];

      // Statistics ATV
      $scope.list_statistics = [
        {
          description: 'más de<br><b>400K</b><br>pagos recibidos',
          img: 'assets/images/newhome/stats/card.png'
        },
        {
          description: 'Más de<br><b>1000</b><br>causas sociales creadas',
          img: 'assets/images/newhome/stats/help.png'
        },
        {
          description: 'más de<br><b>50K</b><br>Alcancías creadas',
          img: 'assets/images/newhome/stats/piggy.png'
        },
        {
          description: 'compartidas en más de<br><b>30</b><br>países',
          img: 'assets/images/newhome/stats/world.png'
        }
      ];

      // Slides ATV4Bussines
      $scope.atv_slides = [
        {
          id: 1,
          image: 'assets/images/newhome/banners_atv4bsnss/banner_fep2021.png'
        },
        {
          id: 2,
          image: 'assets/images/newhome/banners_atv4bsnss/banner_fep2019.png'
        },
        {
          id: 3,
          image: 'assets/images/newhome/banners_atv4bsnss/banner_knotfest.png'
        },
        {
          id: 4,
          image: 'assets/images/newhome/banners_atv4bsnss/banner_ahorock.png'
        },
        {
          id: 5,
          image: 'assets/images/newhome/banners_atv4bsnss/banner_proteccion.png'
        }
      ];


      $scope.myInterval = 5000;
      $scope.noWrapSlides = false;
      $scope.active = 0;

      $scope.cow_name = null;

      $scope.publicCows = cows.cows;

      $scope.goToCreateCow = function () {
        $state.go('cow-create');
        // fbq('trackCustom', 'CrearVaca', {button: 'main'});
      };

      $scope.goToCreateCowByEvent = function (cowEvent) {
        // console.log(cowEvent);
        $state.go('cow-create', {cowEventId: cowEvent.id});
      };

      $scope.getMediaLinks = function () {
        AboutUsService.getMediaLinks().then(function (data) {
          $scope.media_slides = data;
        });
      };

      $scope.resizeMainContainer = function () {
        var main_home_container = angular.element('.atv__home__first-view')[0];
        if ($window.innerWidth <= 996) {
          main_home_container.style.height = ($window.innerHeight - 40) + 'px';
        } else {
          main_home_container.style.height = ($window.innerHeight - 70) + 'px';
        }
      };


      $scope.autoScroll = function (e, container) {
        e.preventDefault();
        var offset = 0, y = 0, dy, call = setInterval(function () {
          if (Math.abs(dy = offset - y) > 1) y += dy / 20;
          else {
            clearInterval(call);
            y = offset;
          }
          document.documentElement.scrollTop = y - 60;
        }, 10);
        offset = document.getElementsByClassName(container)[0].offsetTop;
        y = document.documentElement.scrollTop;
      };

      $scope.clickQuestion = function (question_id) {
        $scope.selected_atv_question = question_id;
        $scope.animateBubbles();
      };

      $scope.animateBubbles = function () {
        var node = document.getElementsByClassName('vs-container-bubbles-item');
        for (var i = 0; i < node.length; i++) {
          if (i === 0) {
            node[i].classList.add('animated', 'bounceInRight');
          } else {
            node[i].classList.add('animated', 'bounceInLeft', 'delay-1s');
          }
        }

        function handleAnimationEnd() {
          for (var i = 0; i < node.length; i++) {
            (function (node, i) {
              setTimeout(function () {
                if (i === 0) {
                  node[i].classList.remove('animated', 'bounceInRight');
                } else {
                  node[i].classList.remove('animated', 'bounceInLeft', 'delay-1s');
                }
                node[i].removeEventListener('animationend', handleAnimationEnd);
              }, 1000);
            })(node, i);

          }
        }

        for (i = 0; i < node.length; i++) {
          node[i].addEventListener('animationend', handleAnimationEnd)
        }
      };

      $scope.getQuestionById = function (question_id) {
        for (var i = 0; i < $scope.atv_questions.length; i++) {
          if (question_id === $scope.atv_questions[i].id) {
            return $scope.atv_questions[i];
          }
        }
        return null;
      };

      // Init Resize Main Container
      // Destroy Event OnResize
      // Load Media Links
      $scope.getMediaLinks();
      $scope.goToPublicCows = function () {
        $state.go('public-cow');
      };

      $scope.createCowOpenMenu = function ($mdMenu, ev) {
        $mdMenu.open(ev);
      };

      $scope.enterKeyDownSubmit = function (event) {
        if (event.keyCode === 13) {
          setTimeout(function () {
            angular.element('#home-main-container-submit').trigger('click');
          });
        }
      }
      $scope.goToAtv4Bsnss = function () {
        $window.open('https://business.armatuvaca.com/', '_blank');
      }

    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('login', {
          url: '/iniciar-sesion?response_url',
          templateUrl: 'app/views/login/login.html',
          controller: 'LoginController',
          controllerAs: 'login',
          resolve: {},
          data: {
            'meta': {
              'title': 'Iniciar sesión',
              'description': 'Inicia sesión con Facebook o Google en Armatuvaca.com.'
            }
          }
        })
    })
    .controller('LoginController', function ($scope, $state, $rootScope, $stateParams, usersService, GAuth, toastr,
      GApi, $analytics, key_site_gg, key_site_gg_v2, secret_token_gg_r) {


      $rootScope.loggedNotAllowed();
      // $analytics.pageTrack('/login');

      $scope.user = {};
      $scope.secondValidation = false;

      $scope.register = function () {
        if ($stateParams.response_url) {
          $state.go('register', {
            response_url: $stateParams.response_url
          })
        } else {
          $state.go('register')
        }
      };

      $scope.loginUser = function (isValid) {
        if (isValid) {
          //Esto permite trater el token del reCaptcha de Google
          grecaptcha.ready(function () {
            grecaptcha.execute(key_site_gg, { action: 'Login' }).then(function (token) {
              //Servio de login
              usersService.login($scope.user.email, $scope.user.password, token).then(function (data) {
                if ($stateParams.response_url) {
                  document.location.href = $stateParams.response_url;
                } else {
                  $rootScope.loginDirect(data.cows_num);
                }
              }, function (err) {
                if(err.status == 401){
                $scope.secondValidation = true;
                  grecaptcha.render('container_recaptchaV2', {
                    'sitekey' : key_site_gg_v2,
                    'callback': function(e){
                      if(grecaptcha.getResponse()){
                        usersService.login($scope.user.email, $scope.user.password, e, $scope.secondValidation).then(function (data) {
                          if ($stateParams.response_url) {
                            document.location.href = $stateParams.response_url;
                          } else {
                            $rootScope.loginDirect(data.cows_num);
                          }
                        }, function (err) {
                          if(err.status == 400) {
                            $scope.errorSended = true;
                            $scope.errorMessage = "Usuario y/o contraseña incorrectos";
                            $scope.secondValidation = false;
                          }else{
                            $scope.errorSended = true;
                            $scope.errorMessage = "¡Error validando tu identidad!";  
                          }                          
                        });
                      }
                    }
                  });
                }else if(err.status == 400) {
                  $scope.errorSended = true;
                  $scope.errorMessage = "Usuario y/o contraseña incorrectos";
                }
              });
            });
          });

        }
      };


      $scope.loginFb = function () {
        var send_welcome_email = true;
        usersService.loginFb(send_welcome_email).then(function (data) {
          if (data.token !== 0) {
            if ($stateParams.response_url) {
              document.location.href = $stateParams.response_url;
            } else {
              $rootScope.loginDirect(data.cows_num);
            }
          } else {
            toastr.info('Regístrate con Google o con correo electrónico', 'No tienes cuenta');
            $rootScope.registerDirect();
          }
        }, function (err) {
          $rootScope.errorSended = true;
          $scope.errorMessage = "Usuario y/o contraseña incorrectos";
        });
      };

      $scope.loginGg = function () {
        var send_welcome_email = true;
        GAuth.login().then(function (user) {
          GAuth.getToken().then(function (token_response) {
            usersService.loginGg(token_response.access_token, send_welcome_email).then(function (data) {
              if ($stateParams.response_url) {
                document.location.href = $stateParams.response_url;
              } else {
                $rootScope.loginDirect(data.cows_num);
              }
            }, function (err) {
              $rootScope.errorSended = true;
              $scope.errorMessage = "Usuario y/o contraseña incorrectos";
            });
          }, function () {
            console.log('token error');
          });
        }, function () {
          console.log('login fail');
        });
      };


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('how-it-works', {
          url: '/como-funciona-hacer-una-vaca-online',
          templateUrl: 'app/views/howItWorks/howItWorks.html',
          controller: 'HowItWorksController',
          controllerAs: 'how-it-works',
          resolve: {},
          data: {
            'meta': {
              'title': '¿Cómo hacer una Vaca Online en Colombia?',
                'description': 'Aprende cómo funciona y cómo armar tu próxima Vaca Online.'
            }
          }
        })
    })
    .controller('HowItWorksController', function ($scope, $state, $rootScope, usersService) {

      console.log('how-it-works');

      // Steps Create Cow
      $scope.list_steps = [
        {
          title: '1. Armatuvaca',
          description: 'Haz clic en Armar Vaca, selecciona la categoria y listo.',
          img: 'assets/images/newhome/armarvaca/crea_vaca.png'
        },
        {
          title: '2. Invita',
          description: 'Abre tu Vaca, da clic en el botón compartir y envia a tus amigos.',
          img: 'assets/images/newhome/armarvaca/comparte_vaca.png'
        },
        {
          title: '3. Paga',
          description: 'Los participantes pueden pagar con PSE, tarjeta o Efecty.',
          img: 'assets/images/newhome/armarvaca/paga_vaca.png'
        },
        {
          title: '4. Saca',
          description: 'Saca tu dinero a una cuenta en Colombia, Efecty u otras Wallets.',
          img: 'assets/images/newhome/armarvaca/sacar_dinero.png'
        }

      ];

      $scope.goToCreateCow = function () {
        $state.go('cow-create');
        // fbq('trackCustom', 'CrearVaca', {button: 'calculator'});
      };

    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('frecuently-asked-questions', {
          url: '/preguntas-frecuentes',
          templateUrl: 'app/views/frecuentlyAskedQuestions/frecuentlyAskedQuestions.html',
          controller: 'frecuentlyAskedQuestionsController',
          controllerAs: 'frecuently-asked-questions',
          resolve: {
            questions: function (AboutUsService) {
              return AboutUsService.getFrecuentlyQuestions();
            }
          },
          data: {
            'meta': {
              'title': 'Preguntas frecuentes',
              'description': 'Si vas a armar una Vaca online y tienes preguntas, ingresa acá'
            }
          }
        })
    })
    .controller('frecuentlyAskedQuestionsController', function ($scope, $state, questions, $rootScope, smoothScroll, $timeout) {

      $scope.allQuestions = [];
      $scope.typeaheadItems = [];

      _.forEach(questions, function (value, key) {
        _.forEach(value.frecuently_questions, function (value_fq) {
          var question = {};
          question.id = value_fq.id;
          question.question_text = value_fq.question_text;
          question.answer_text = value_fq.answer_text;
          question.is_collapsed = true;
          question.element_id = "faq-"+ value_fq.id;

          var typeaheadItem = {};
          typeaheadItem.id = value_fq.id;
          typeaheadItem.question_text = value_fq.question_text;

          $scope.allQuestions.push(question);
          $scope.typeaheadItems.push(typeaheadItem);
        });
      });

      console.log($scope.allQuestions);

      $scope.uncollapseSingleFAQ = function (value) {
        value.is_collapsed = !value.is_collapsed;
      };

      $scope.typeaheadSelected = function (item, model, label) {
        _.forEach($scope.allQuestions, function (value) {
          if (value.id === item.id) {
            value.is_collapsed = false;

            var scrollToTime = function () {
              var element = document.getElementById(value.element_id);
              var options = {
                duration: 700,
                easing: 'easeInQuad',
                offset: 180
              };
              smoothScroll(element, options);
            };
            $timeout(scrollToTime, 100);

            $scope.typeahead_input = '';
          }
        });
      };

    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('first-login', {
          url: '/primer-inicio',
          templateUrl: 'app/views/firstLogin/firstLogin.html',
          controller: 'FirstLoginController',
          controllerAs: 'first-login',
          resolve: {
            user: function (usersService) {
              return usersService.getUserData();
            }
          },
          data: {
            'meta': {
              'title': 'Bienvenido',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('FirstLoginController', function ($scope, $state, $rootScope, user) {

      $rootScope.loginAllowed();


      $scope.user = user.user;
      console.log($scope.user);
    });
})();

/**
 * Created by lucas on 25/04/17.
 */

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('feedback-user', {
          url: '/calificanos/:campaign?usuario&calificacion',
          templateUrl: 'app/views/feedbackUser/feedbackUser.html',
          controller: 'FeedbackUserController',
          controllerAs: 'feedback-user',
          resolve: {
            userId: function ($stateParams) {
              return $stateParams.usuario;
            },
            campaignSlug: function ($stateParams) {
              return $stateParams.campaign;
            },
            gradeValue: function ($stateParams) {
              return $stateParams.calificacion;
            },
            feedbackInfo: function (userId, campaignSlug, gradeValue, feedbackService) {
              return feedbackService.addFeedbackUser(userId, campaignSlug, gradeValue);
            }
          },
          data: {
            'meta': {
              'title': 'Califícanos',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('FeedbackUserController', function ($scope, $state, $rootScope, userId, campaignSlug, feedbackInfo,
                                                    feedbackService) {

      console.log('feedbackUser');

      $scope.user_id = userId;
      $scope.campaign_slug = campaignSlug;

      $scope.grade_value = feedbackInfo.feedback_data.grade;
      $scope.feedback_title = "";
      $scope.feedback_comments = "";
      $scope.feedbackSaved = false;

      $scope.stars = [
        {value: 1, selected: false},
        {value: 2, selected: false},
        {value: 3, selected: false},
        {value: 4, selected: false},
        {value: 5, selected: false},
      ];

      $scope.loadStars = function () {
        if ($scope.grade_value != 0 || !scope.grade_value.isNull)
          for (var i = 0; i < $scope.grade_value; i++)
            $scope.stars[i].selected = true;
      };

      $scope.selectStar = function (star) {
        for (var i = 0; i < $scope.stars.length; i++)
          $scope.stars[i].selected = false;
        for (var i = 0; i < star.value; i++)
          $scope.stars[i].selected = true;

        $scope.grade_value = star.value;
      };

      $scope.fillStar = function (star, fill) {
        if (fill)
          for (var i = 0; i < star.value; i++)
            $scope.stars[i].selected = true;
        else
          for (var i = $scope.grade_value; i < $scope.stars.length; i++)
            $scope.stars[i].selected = false;
      };

      $scope.updateFeedback = function () {
        feedbackService.updateFeedbackUser($scope.user_id, $scope.campaign_slug, $scope.grade_value,
          $scope.feedback_title, $scope.feedback_comments)
        $scope.feedbackSaved = true;
      };

      $scope.goToCreateCow = function () {
        $state.go('cow-create');
      };


    });
})();

/**
 * Created by lucas on 5/04/17.
 */

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('feedback-payment', {
          url: '/calificar-pago?id_pago&calificacion',
          templateUrl: 'app/views/feedbackPayment/feedbackPayment.html',
          controller: 'FeedbackPaymentController',
          controllerAs: 'feedback-payment',
          resolve: {
            paymentId: function ($stateParams) {
              return $stateParams.id_pago;
            },
            gradeValue: function ($stateParams) {
              return $stateParams.calificacion;
            },
            feedbackInfo: function (paymentId, gradeValue, feedbackService) {
              return feedbackService.addFeedbackPayment(paymentId, gradeValue);
            }
          },
          data: {
            'meta': {
              'title': 'Califica tu pago',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('FeedbackPaymentController', function ($scope, $state, $rootScope, paymentId,
                                                       feedbackInfo, feedbackService) {

      console.log('feedbackPayment');

      $scope.payment_id = paymentId;
      $scope.payment_info = feedbackInfo.feedback_data.payment;
      $scope.grade_value = feedbackInfo.feedback_data.grade;
      $scope.feedback_title = "";
      $scope.feedback_comments = "";
      $scope.feedbackSaved = false;

      $scope.stars = [
        {value:1, selected:false},
        {value:2, selected:false},
        {value:3, selected:false},
        {value:4, selected:false},
        {value:5, selected:false},
      ];

      $scope.loadStars = function () {
        if($scope.grade_value != 0 || !scope.grade_value.isNull)
          for(var i=0; i < $scope.grade_value; i++)
            $scope.stars[i].selected = true;
      };

      $scope.selectStar = function (star) {
        for(var i=0; i < $scope.stars.length; i++)
          $scope.stars[i].selected = false;
        for(var i=0; i < star.value; i++)
          $scope.stars[i].selected = true;

        $scope.grade_value = star.value;
      };

      $scope.fillStar = function (star, fill) {
        if(fill)
          for(var i=0; i < star.value; i++)
            $scope.stars[i].selected = true;
        else
          for(var i = $scope.grade_value; i < $scope.stars.length; i++)
            $scope.stars[i].selected = false;
      };

      $scope.updateFeedback = function () {
        feedbackService.updateFeedbackPayment($scope.payment_id, $scope.grade_value, $scope.feedback_title,
          $scope.feedback_comments)
        $scope.feedbackSaved = true;
      };

      $scope.goToCreateCow = function () {
        $state.go('cow-create');
      };
    });
})();

/**
 * Created by lucas on 17/04/17.
 */

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('feedback-cow', {
          url: '/calificar-vaca?id_vaca&calificacion',
          templateUrl: 'app/views/feedbackCow/feedbackCow.html',
          controller: 'FeedbackCowController',
          controllerAs: 'feedback-cow',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.id_vaca;
            },
            gradeValue: function ($stateParams) {
              return $stateParams.calificacion;
            },
            feedbackInfo: function (cowId, gradeValue, feedbackService) {
              return feedbackService.addFeedbackCow(cowId, gradeValue);
            }
          },
          data: {
            'meta': {
              'title': 'Califica tu Vaca',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('FeedbackCowController', function ($scope, $state, $rootScope, cowId, feedbackInfo, feedbackService) {

      console.log('feedbackCow');

      $scope.cow_id = cowId;
      $scope.cow_info = feedbackInfo.feedback_data.cow_event;
      $scope.grade_value = feedbackInfo.feedback_data.grade;
      $scope.feedback_title = "";
      $scope.feedback_comments = "";
      $scope.feedbackSaved = false;

      $scope.stars = [
        {value:1, selected:false},
        {value:2, selected:false},
        {value:3, selected:false},
        {value:4, selected:false},
        {value:5, selected:false},
      ];

      $scope.loadStars = function () {
        if($scope.grade_value != 0 || !scope.grade_value.isNull)
          for(var i=0; i < $scope.grade_value; i++)
            $scope.stars[i].selected = true;
      };

      $scope.selectStar = function (star) {
        for(var i=0; i < $scope.stars.length; i++)
          $scope.stars[i].selected = false;
        for(var i=0; i < star.value; i++)
          $scope.stars[i].selected = true;

        $scope.grade_value = star.value;
      };

      $scope.fillStar = function (star, fill) {
        if(fill)
          for(var i=0; i < star.value; i++)
            $scope.stars[i].selected = true;
        else
          for(var i = $scope.grade_value; i < $scope.stars.length; i++)
            $scope.stars[i].selected = false;
      };

      $scope.updateFeedback = function () {
        feedbackService.updateFeedbackCow($scope.cow_id, $scope.grade_value, $scope.feedback_title,
          $scope.feedback_comments)
        $scope.feedbackSaved = true;
      };

      $scope.goToCreateCow = function () {
        $state.go('cow-create');
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('efecty', {
          url: '/efecty/:cashout_id',
          templateUrl: 'app/views/efecty/efecty.html',
          controller: 'EfectyController',
          controllerAs: 'efecty',
          resolve: {
            cashout_id: function ($stateParams) {
              return $stateParams.cashout_id;
            }
          },
          data: {
            'meta': {
              'title': 'Efecty con Armatuvaca',
              'robots': 'noindex'
            }
          }
        })
    })
    .controller('EfectyController', function ($scope, $state,cowEventService, cashout_id) {
      $scope.cashout_id = cashout_id;
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cows-user', {
          url: '/mis-vacas',
          templateUrl: 'app/views/cowsUser/cowsUser.html',
          controller: 'CowsUserController',
          controllerAs: 'cows-user',
          resolve: {
            cowsEventUser: function (cowEventService) {
              return cowEventService.getCowsEventUser();
            },
            userStats: function (usersService) {
              return usersService.getUserStats();

            }
          },
          data: {
            'meta': {
              'title': 'Mis Vacas',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CowsUserController', function ($scope, $state, $rootScope, usersService, $stateParams, $log, cowEventService,
                                                toastr, cowsEventUser, userStats, ngDialog) {

      console.log('cow-user');
      $rootScope.loginAllowed();

      $scope.cows = cowsEventUser;

      $scope.stats = userStats.user_stats;

      $scope.showNewPrincingModelInform = function () {
        ngDialog.open({
          template: 'newPrincingModelInform',
          controller: 'NewPrincingModelInformCtrl'
        });
      };
      // $scope.showNewPrincingModelInform();
    })
    .controller('NewPrincingModelInformCtrl', function ($scope, ngDialog) {
      $scope.closeNewPrincingModelInform = function (closeId) {
        ngDialog.close(closeId);
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-thanks', {
          url: '/agradecimientos/:cowId',
          templateUrl: 'app/views/cowThanks/cowThanks.html',
          controller: 'CowThanksController',
          controllerAs: 'cow-thanks',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCow(cowId);
            },
            contacts: function (usersService) {
              return usersService.getContactsUser();
            }
          },
          data: {
            'meta': {
              'title': 'Agradecer',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CowThanksController', function ($scope, $state, $rootScope, usersService, $stateParams, cowId, $log, cow,
                                                 toastr, atvURL, cowPublicURL, cowEventService, contacts, paymentService) {

      console.log('cow thanks');
      $rootScope.loginAllowed();

      if (cow.deleted) {
        $state.go('cow-deleted', {cowId: cowId});
      }

      $scope.cowPublicURLComplete = atvURL + cowPublicURL + cowId;

      $scope.cow = cow;

      $scope.thanksData = {
        message: '',
        include_previous: false,
        send_me_one: false,
        emails_list: [],
        cow_id: cowId
      };

      $scope.goToAdmin = function () {
        $state.go('cow-admin', {
          cowId: cowId
        }, {
          reload: true
        });
      };

      $scope.includePreviousChanged = function () {
        if ($scope.thanksData.include_previous) {
          paymentService.getCowEventParticipantsThanksList(cowId).then(function (data) {
              console.log(data);
              if (data.length == 0) {
                toastr.success('Todavía no le has enviado tu mensaje de agradecimeinto ningun participante');
              } else {
                $scope.thanksData.emails_list = data;
              }
            },
            function (err) {
              toastr.error('Error obteneindo los participantes');
            });
        } else {
          $scope.thanksData.emails_list = [];
        }
      };

      $scope.sendThanks = function () {
        cowEventService.sendThanks($scope.thanksData).then(function (data) {
            console.log(data);
            toastr.success('Correos de agradecimiento enviados');
          },
          function (err) {
            toastr.error('Error enviando los correos de agradecimiento');
          })
      };

      $scope.deleteContact = function (index) {
        $scope.thanksData.emails_list.splice(index, 1);
      };


    });
})();

(function () {
  "use strict";

  angular
    .module("user")
    .config(function ($stateProvider) {
      $stateProvider.state("cow-temp", {
        url: "/vaca-temporal",
        params: {
          cowId: null,
        },
        templateUrl: "app/views/cowTempLogin/cowTempLogin.html",
        controller: "CowTempController",
        controllerAs: "cow-temp",
        resolve: {
          cowId: function ($stateParams) {
            return $stateParams.cowId;
          },
        },
        data: {
          meta: {
            title: "Vaca temporal",
            robots: "noindex, nofollow",
          },
        },
      });
    })
    .controller(
      "CowTempController",
      function (
        $scope,
        $state,
        $rootScope,
        usersService,
        $stateParams,
        cowId,
        $log,
        toastr,
        cowEventService,
        GAuth,
        $analytics,
        $window,
        ngDialog,
        key_site_gg,
        key_site_gg_v2
      ) {
        $rootScope.loggedNotAllowed();

        //$window.fbq('trackCustom', 'CreaVacaTemp');
        //$window.fbq('track', 'Lead');
        $scope.active_tab_register = 0;
        $scope.register_status_selected = false;
        $scope.todayDate = new Date();
        $scope.maxDate = new Date(
          $scope.todayDate.getFullYear() - 18,
          $scope.todayDate.getMonth(),
          $scope.todayDate.getDate()
        );
        $scope.todayDate_format =
          $scope.maxDate.getDay() +
          "/" +
          $scope.maxDate.getMonth() +
          "/" +
          $scope.maxDate.getFullYear();

        $scope.user = {};
        $scope.secondValidation = false;

        $scope.registerNewUser = function (isValid) {
          if ($scope.user.born_date && $scope.showDateError) {
            toastr.info(
              "Por favor ingresa una fecha de nacimiento valida",
              "Registro incompleto"
            );
          } else if (isValid) {
            grecaptcha.ready(function () {
              grecaptcha
                .execute(key_site_gg, { action: "cow_temp_register" })
                .then(function (token) {
                  var send_welcome_email = true;
                  usersService
                    .registerNewUser(
                      $scope.user.first_name,
                      $scope.user.last_name,
                      $scope.user.born_date,
                      $scope.user.email,
                      $scope.user.password,
                      send_welcome_email,
                      token
                    )
                    .then(
                      function () {
                        $analytics.eventTrack("cow-created-temp-to-real", {
                          category: "cow-created-temp-to-real",
                          value: 1,
                        });
                        $scope.cowEventTempToUser();
                      },
                      function (err) {
                        if (err.status == 401) {
                          $scope.secondValidation = true;
                          grecaptcha.render("container_recaptchaV2", {
                            sitekey: key_site_gg_v2,
                            callback: function (e) {
                              var send_welcome_email = true;
                              if (grecaptcha.getResponse()) {
                                usersService
                                  .registerNewUser(
                                    $scope.user.first_name,
                                    $scope.user.last_name,
                                    $scope.user.born_date,
                                    $scope.user.email,
                                    $scope.user.password,
                                    send_welcome_email,
                                    e,
                                    $scope.secondValidation
                                  )
                                  .then(
                                    function () {
                                      $analytics.eventTrack(
                                        "cow-created-temp-to-real",
                                        {
                                          category: "cow-created-temp-to-real",
                                          value: 1,
                                        }
                                      );
                                      $scope.cowEventTempToUser();
                                    },
                                    function (err) {
                                      if (err.status == 401) {
                                        $scope.errorSended = true;
                                        $scope.errorMessage =
                                          "¡Error validando tu identidad!";
                                      } else {
                                        $scope.secondValidation = false;
                                        try {
                                          if (err.data.error_text_msg) {
                                            $scope.errorSended = true;
                                            $scope.errorMessage =
                                              err.data.error_text_msg;
                                          } else {
                                            $scope.errorSended = true;
                                            $scope.errorMessage =
                                              "Se presentó un error intentando realizar el registro, inténtalo mas tarde. Sí el error persiste, comunicate con nosotros.";
                                          }
                                        } catch (err) {
                                          $scope.errorSended = true;
                                          $scope.errorMessage =
                                            "Se presentó un error intentando realizar el registro, inténtalo mas tarde. Sí el error persiste, comunicate con nosotros.";
                                        }
                                      }
                                    }
                                  );
                              }
                            },
                          });
                        } else {
                          try {
                            if (err.data.error_text_msg) {
                              $scope.errorSended = true;
                              $scope.errorMessage = err.data.error_text_msg;
                            } else {
                              $scope.errorSended = true;
                              $scope.errorMessage =
                                "Se presentó un error intentando realizar el registro, inténtalo mas tarde. Sí el error persiste, comunicate con nosotros.";
                            }
                          } catch (err) {
                            $scope.errorSended = true;
                            $scope.errorMessage =
                              "Se presentó un error intentando realizar el registro, inténtalo mas tarde. Sí el error persiste, comunicate con nosotros.";
                          }
                        }
                      }
                    );
                });
            });
          }
        };

        $scope.loginFb = function () {
          var send_welcome_email = true;
          usersService.loginFb(send_welcome_email).then(
            function (data) {
              if (data.token !== 0) {
                $analytics.eventTrack("cow-created-temp-to-real", {
                  category: "cow-created-temp-to-real",
                  value: 1,
                });
                $scope.cowEventTempToUser();
              } else {
                toastr.info(
                  "Regístrate con Google o con correo electrónico",
                  "No tienes cuenta"
                );
                $scope.active_tab_register = 1;
              }
            },
            function (err) {
              $rootScope.errorSended = true;
              $rootScope.errorMessage = "Usuario y/o contraseña incorrectos";
            }
          );
        };

        $scope.loginGg = function () {
          var send_welcome_email = true;
          GAuth.login().then(
            function (user) {
              GAuth.getToken().then(
                function (token_response) {
                  usersService
                    .loginGg(token_response.access_token, send_welcome_email)
                    .then(
                      function (data) {
                        $analytics.eventTrack("cow-created-temp-to-real", {
                          category: "cow-created-temp-to-real",
                          value: 1,
                        });
                        $scope.cowEventTempToUser();
                      },
                      function (err) {
                        $rootScope.errorSended = true;
                        $scope.errorMessage =
                          "Usuario y/o contraseña incorrectos";
                      }
                    );
                },
                function () {
                  console.log("token error");
                }
              );
            },
            function () {
              console.log("login fail");
            }
          );
        };

        $scope.loginUser = function (isValid) {
          if (isValid) {
            grecaptcha.ready(function () {
              grecaptcha
                .execute(key_site_gg, { action: "cow_event_login" })
                .then(function (token) {
                  usersService
                    .login($scope.user.email, $scope.user.password, token)
                    .then(
                      function () {
                        $analytics.eventTrack("cow-created-temp-user", {
                          category: "cow-created-temp-user",
                          value: 1,
                        });
                        $scope.cowEventTempToUser();
                      },
                      function (err) {
                        if (err.status == 401) {
                          $scope.secondValidation = true;
                          grecaptcha.render("container_recaptchaV2", {
                            sitekey: key_site_gg_v2,
                            callback: function (e) {
                              if (grecaptcha.getResponse()) {
                                usersService
                                  .login(
                                    $scope.user.email,
                                    $scope.user.password,
                                    e,
                                    $scope.secondValidation
                                  )
                                  .then(
                                    function () {
                                      $analytics.eventTrack(
                                        "cow-created-temp-user",
                                        {
                                          category: "cow-created-temp-user",
                                          value: 1,
                                        }
                                      );
                                      $scope.cowEventTempToUser();
                                    },
                                    function (err) {
                                      if (err.status == 401) {
                                        $rootScope.errorSended = true;
                                        $rootScope.errorMessage =
                                          "¡Error validando tu identidad!";
                                      } else {
                                        $scope.secondValidation = false;
                                        $rootScope.errorSended = true;
                                        $rootScope.errorMessage =
                                          "Usuario y/o contraseña incorrectos";
                                      }
                                    }
                                  );
                              }
                            },
                          });
                        } else {
                          $rootScope.errorSended = true;
                          $rootScope.errorMessage =
                            "Usuario y/o contraseña incorrectos";
                        }
                      }
                    );
                });
            });
          }
        };

        $scope.chooseInitialOption = function (choice) {
          $scope.register_status_selected = true;
          if (choice == 1) $scope.active_tab_register = 1;
        };

        $scope.cowEventTempToUser = function () {
          cowEventService.cowEventTempToUser(cowId).then(
            function (data) {
              console.log(data);
              if (data.valid == false && data.blacklist == true) {
                toastr.error(
                  "Hubo un problema validando tus datos, contáctate con nosotros",
                  "Error de validación"
                );
              } else {
                $state.go("cow-admin", {
                  cowId: cowId,
                });
              }
            },
            function (err) {
              usersService.logout();
              toastr.error(
                "Si el error persiste, comunicate con nosotros.",
                "Error creando la Vaca"
              );
            }
          );
        };

        $scope.showDateError = false;
        $scope.dateBornValidator = function (isCompleted) {
          if ($scope.user.born_date && isCompleted) {
            if ($scope.user.born_date > $scope.maxDate) {
              $scope.showDateError = true;
            }
          } else {
            $scope.showDateError = false;
          }
        };

        $scope.showBenefitsInfo = function () {
          ngDialog.open({
            template: "atvBenefitsInfoModal",
            data: {},
            controller: "ATVBenefitsInfoModalCtrl",
          });
        };
        // $scope.showBenefitsInfo();
      }
    )
    .controller(
      "ATVBenefitsInfoModalCtrl",
      function ($scope, ngDialog, cowEventService, toastr) {
        $scope.closeBenefitsInfoModal = function (closeId) {
          ngDialog.close(closeId);
        };
      }
    );
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-resend', {
          url: '/reenviar-vaca/:cowId',
          templateUrl: 'app/views/cowResend/cowResend.html',
          controller: 'CowResendController',
          controllerAs: 'cow-resend',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCow(cowId);
            },
            guest_list: function (cowEventService, cowId) {
              return cowEventService.getCowEventGuestList(cowId);
            },
            user: function (usersService) {
              return usersService.getUserData();
            }
          },
          data: {
            'meta': {
              'title': 'Re-enviar invitaciones',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CowResendController', function ($scope, $state, $rootScope, usersService, $stateParams, cowId, $log,
                                                 cow, toastr, cowEventService, guest_list, atvURL, cowPublicURL, user) {

      console.log('cow resend');
      $rootScope.loginAllowed();

      console.log(user);
      if (cow.deleted) {
        $state.go('cow-deleted', {
          cowId: cowId
        });
      }
      if (cow.closed_money_request || cow.closed) {
        $state.go('cow-admin', {
          cowId: cowId
        });
        toastr.info('No puedes enviar recordatorios para una Vaca cerrada', 'Vaca cerrada');
      }

      $scope.cowPublicURLComplete = atvURL + cowPublicURL + cowId;

      $scope.cow = cow;

      $scope.cow_guest_list = guest_list;

      $scope.message = '<p>Hola<br style="font-size: 14px;text-align: justify;"/><br style="font-size: 14px;text-align: justify;"/>' + user.user.user.first_name +
        ', desea recordarte que estás invitado a participar en la Vaca ' + $scope.cow.name +
        ' :<br style="font-size: 14px;text-align: justify;"/><br style="font-size: 14px;text-align: justify;"/>Para ver los detalles de la Vaca, te invitamos a hacer clic en el siguiente enlace:<br style="font-size: 14px;text-align: justify;"/>' +
        $scope.cowPublicURLComplete + '<br style="font-size: 14px;text-align: justify;"/><br/></p>';


      $scope.deleteGuest = function (index) {
        $scope.cow_guest_list.splice(index, 1);
      };

      $scope.resend = function () {
        if ($scope.cow_guest_list.length == 0) {
          toastr.info('Debes tener mínimo un contacto');
        } else {
          var emails_to = [];

          _.forEach($scope.cow_guest_list, function (value) {
            emails_to.push(value.email);
          });


          var cow_data = {
            cow_id: cowId,
            message: $scope.message,
            emails_to: emails_to
          };
          cowEventService.resendInviteCowEvent(cow_data).then(function (data) {
            toastr.success('Recordatorios enviados exitosamente!');
          }, function (err) {
            console.log('err login', err);
            toastr.error('Error enviado los recordatorios, si el problema persiste comunicate con nosotros');
          });
        }
      };

      $scope.goToInvite = function () {
        $state.go('cow-invite', {
          cowId: cowId
        }, {
          reload: true
        });
      };

      $scope.goToAdmin = function () {
        $state.go('cow-admin', {
          cowId: cowId
        }, {
          reload: true
        });
      };


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-redeem', {
          url: '/redimir-comercio',
          templateUrl: 'app/views/cowMarketplaceRedeem/cowMarketplaceRedeem.html',
          controller: 'CowMarketplaceRedeemController',
          controllerAs: 'cow-marketplace-redeem-controller',
          resolve: {}
        })
    })
    .controller('CowMarketplaceRedeemController', function ($scope, $state, $rootScope, $stateParams,
                                                            $log, toastr, cowEventService) {

      console.log('cow redeem');

      $scope.searchCowCode = function (isValid) {
        console.log(isValid);

        if (isValid) {
          console.log($scope.cowCode);
          cowEventService.getCowPublic($scope.cowCode).then(function (data) {
            console.log(data);
            $scope.cowEvent = data;

          }, function (err) {
            toastr.error('Código invalido');
          });
        }

      };

      $scope.redeemCow = function () {
        console.log($scope.cowEvent);
        cowEventService.redeemCowEventMarketplace($scope.cowEvent.cow_event_id).then(function (data) {
          console.log(data);
          $scope.searchCowCode(true);
        }, function (err) {
          toastr.error('No se pudo redimir la Vaca');
        });
      };


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-invite', {
          url: '/invitar-participantes-a-la-vaca/:cowId',
          templateUrl: 'app/views/cowInviteNew/cowInviteNew.html',
          controller: 'CowInviteController',
          controllerAs: 'cow-invite',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCowPublic(cowId);
            }
          },
          data: {
            'meta': {
              'title': 'Invitar',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CowInviteController', function ($scope, $state, $rootScope, usersService, $stateParams, cowId, $log, cow, toastr, atvURL,
      cowPublicURL, GApi, ggAPI, GAuth, GData, Socialshare, fbAPI, cowEventService, ngDialog) {

      $rootScope.loginAllowed();

      if (cow.deleted) {
        $state.go('cow-deleted', {
          cowId: cowId
        });
      }
      if (cow.closed_money_request || cow.closed) {
        $state.go('cow', {
          cowId: cowId
        });
        toastr.info('No puedes realizar invitaciones a una Vaca cerrada', 'Vaca cerrada');
      }

      $scope.cowPublicURLComplete = atvURL + cowPublicURL + cowId;
      $scope.cowPublicURLCompleteCopy = atvURL + cowPublicURL + cowId;

      $scope.cow = cow;

      $scope.copyLink = function () {
        toastr.success('El link de la Vaca se ha guardado en el portapapeles', 'Link guardado');
      };

      $scope.openQR = function () {
        ngDialog.open({
          template: 'QRCodeModal',
          width: 300,
          data: {
            cowParticipateURL: $scope.cowPublicURLComplete
          }
        });
      }

      $scope.shareFb = function () {
        Socialshare.share({
          'provider': 'facebook',
          'attrs': {
            'socialshareUrl': $scope.cowPublicURLComplete,
            'socialshareType': 'share',
            'socialshareVia': fbAPI,
            'socialshareText': $scope.cow.name,
            'socialshareMedia': $scope.cow.main_img,
            'socialshareDescription': 'Armatuvaca online de forma fácil, rapida y segura.',
            'socialshareCaption': 'Armatuvaca: ' + $scope.cow.name,
            'socialsharePopupHeight': 300,
            'socialsharePopupWidth': 400
          }
        });
      };

      $scope.shareTw = function () {
        Socialshare.share({
          'provider': 'twitter',
          'attrs': {
            'socialshareHashtags': "armatuvaca, vacasonline",
            'socialshareVia': "armatuvaca",
            'socialshareText': $scope.cow.name,
            'socialshareUrl': $scope.cowPublicURLComplete,
            'socialsharePopupHeight': 250,
            'socialsharePopupWidth': 500
          }
        });
      };

      $scope.shareLinkedin = function () {
        Socialshare.share({
          'provider': 'linkedin',
          'attrs': {
            'socialshareText': $scope.cow.name,
            'socialshareUrl': $scope.cowPublicURLComplete,
            'socialshareDescription': $scope.cow.name,
            'socialshareSource': 'armatuvaca'
          }
        });
      };

    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-invite-legacy', {
          url: '/invitar-participantes-a-la-vaca-legacy/:cowId',
          templateUrl: 'app/views/cowInvite/cowInvite.html',
          controller: 'CowInviteControllerLegacy',
          controllerAs: 'cow-invite-legacy',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCow(cowId);
            },
            contacts: function (usersService) {
              return usersService.getContactsUser();
            }
          },
          data: {
            'meta': {
              'title': 'Invitar',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CowInviteControllerLegacy', function ($scope, $state, $rootScope, usersService, $stateParams, cowId, $log, cow, toastr, atvURL,
                                                 cowPublicURL, GApi, ggAPI, GAuth, GData, Socialshare, fbAPI, cowEventService, contacts, ngDialog) {

      console.log('cow invite');
      $rootScope.loginAllowed();

      if (cow.deleted) {
        $state.go('cow-deleted', {
          cowId: cowId
        });
      }
      if (cow.closed_money_request || cow.closed) {
        $state.go('cow-admin', {
          cowId: cowId
        });
        toastr.info('No puedes realizar invitaciones a una Vaca cerrada', 'Vaca cerrada');
      }

      $scope.cowPublicURLComplete = atvURL + cowPublicURL + cowId;
      $scope.cowPublicURLCompleteCopy = atvURL + cowPublicURL + cowId;

      $scope.cow = cow;
      $scope.user_contacts = contacts;

      $scope.invite_day_3_email = false;
      $scope.invite_week_1_email = false;
      $scope.invite_week_1_gmail = false;
      $scope.invite_day_3_gmail = false;
      $scope.invite_day_3_user_contact = false;
      $scope.invite_week_1_user_contact = false;

      $scope.contacts = [];
      $scope.contacts_gmail = [];
      $scope.textEmails = '';

      $scope.addEmails = function () {
        if ($scope.textEmails != '' && $scope.textEmails != null) {
          $scope.text_no_spaces = $scope.textEmails.replace(/\s+/g, '');
          $scope.text_no_spaces = $scope.text_no_spaces.replace(/,/g, ';');
          $scope.just_emails = $scope.text_no_spaces.split(';');

          _.forEach($scope.just_emails, function (value) {
            if (validateEmail(value) && !_.find($scope.contacts, function (o) {
                return o.email == value;
              })) {
              console.log(value);
              var contact_email = {
                img: 'assets/images/user/user-green.svg',
                name: value,
                email: value
              };
              $scope.contacts.push(contact_email);
            }
            else {
              toastr.error("Oops, separa las direcciones por 'coma' o 'punto y coma' y verifica que sean correctas");
            }
          });

          $scope.textEmails = '';
        }
      };

      $scope.deleteContact = function (index) {
        $scope.contacts.splice(index, 1);
      };


      function validateEmail(email) {
        var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
      };

      $scope.addEmailsByFile = function () {
        angular.element('#fileInputEmails').trigger('click');
      };

      $scope.cleanContactsList = function () {
        $scope.contacts = [];
      };

      $scope.shareFb = function () {
        Socialshare.share({
          'provider': 'facebook',
          'attrs': {
            'socialshareUrl': $scope.cowPublicURLComplete,
            'socialshareType': 'share',
            'socialshareVia': fbAPI,
            'socialshareText': $scope.cow.name,
            'socialshareMedia': $scope.cow.main_img,
            'socialshareDescription': 'Armatuvaca online de forma fácil, rapida y segura.',
            'socialshareCaption': 'Armatuvaca: ' + $scope.cow.name,
            'socialsharePopupHeight': 300,
            'socialsharePopupWidth': 400
          }
        });
      };

      $scope.shareTw = function () {
        Socialshare.share({
          'provider': 'twitter',
          'attrs': {
            'socialshareHashtags': "armatuvaca, vacasonline",
            'socialshareVia': "armatuvaca",
            'socialshareText': $scope.cow.name,
            'socialshareUrl': $scope.cowPublicURLComplete,
            'socialsharePopupHeight': 250,
            'socialsharePopupWidth': 500
          }
        });
      };

      $scope.shareGg = function () {
        Socialshare.share({
          'provider': 'google',
          'attrs': {
            'socialshareUrl': $scope.cowPublicURLComplete,
            'socialsharePopupHeight': 300,
            'socialsharePopupWidth': 500
          }
        });
      };

      // $scope.getGmailContacts = function () {
      //   GAuth.login().then(function (user) {
      //     var token_object = gapi.auth.getToken();
      //     $.get("https://www.google.com/m8/feeds/contacts/default/thin?alt=json&access_token=" + token_object.access_token + "&max-results=500&v=3.0",
      //       function (response) {
      //         var contact_list_temp = [];
      //         _.forEach(response.feed.entry, function (value) {
      //           var contact_email = {
      //             img: 'assets/images/user/user-green.svg',
      //             name: 'contact error',
      //             email: 'contact error'
      //           };
      //           if (value.gd$name && value.gd$email) {
      //             contact_email = {
      //               img: 'assets/images/user/user-green.svg',
      //               name: value.gd$name.gd$givenName.$t,
      //               email: value.gd$email[0].address,
      //               checked: false
      //             };
      //             contact_list_temp.push(contact_email);

      //           } else if (value.gd$email) {
      //             contact_email = {
      //               img: 'assets/images/user/user-green.svg',
      //               name: value.gd$email[0].address,
      //               email: value.gd$email[0].address,
      //               checked: false
      //             };
      //             contact_list_temp.push(contact_email);
      //           }
      //         });
      //         $scope.$apply(function () {
      //           $scope.contacts_gmail = contact_list_temp;
      //         });
      //       });
      //   }, function () {
      //     toastr.error('Error tratando de acceder a tus contactos', 'Error');
      //   });
      // };


      $scope.addContacts = function () {
        if ($scope.contacts.length > 200) {
          toastr.info('Puedes invitar a maximo 200 personas', 'Excediste la capacidad');
        } else if ($scope.contacts.length > 0) {
          var cow_data = {
            cow_id: cowId,
            contacts: $scope.contacts,
            invite_day_3: $scope.invite_day_3_email,
            invite_week_1: $scope.invite_week_1_email
          };
          cowEventService.cowEventAddContacts(cow_data).then(function (data) {
            if (data.contacts_not_added.length > 0) {
              $scope.modalContactsNotAdded(data.contacts_not_added);
            }
            $scope.contacts = [];
            toastr.success('Contactos invitados exitosamente!');
          }, function (err) {
            console.log('err login', err);
            toastr.error('Error agregando los contactos');
          });
        } else {
          toastr.info('Debes agregar mínimo un contacto');
        }
      };

      $scope.addContactsGmail = function () {
        if ($scope.contacts_gmail.length > 200) {
          toastr.info('Puedes invitar a maximo 200 personas', 'Excediste la capacidad');
        } else if ($scope.contacts_gmail.length > 0) {
          var contacts_selected = [];
          _.forEach($scope.contacts_gmail, function (value) {
            if (value.checked) {
              contacts_selected.push(value);
            }
          });
          var cow_data = {
            cow_id: cowId,
            contacts: contacts_selected,
            invite_day_3: $scope.invite_day_3_gmail,
            invite_week_1: $scope.invite_week_1_gmail
          };
          cowEventService.cowEventAddContacts(cow_data).then(function (data) {
            if (data.contacts_not_added.length > 0) {
              $scope.modalContactsNotAdded(data.contacts_not_added);
            }
            $scope.contacts = [];
            toastr.success('Contactos invitados exitosamente!');
            $scope.contacts_gmail = [];
            $scope.email_text_search = '';
          }, function (err) {
            console.log('err login', err);
            toastr.error('Error agregando los contactos');
          });
        } else {
          toastr.info('Debes agregar mínimo un contacto');
        }
      };

      $scope.addContactsUserContacts = function () {
        if ($scope.user_contacts.length > 200) {
          toastr.info('Puedes invitar a maximo 200 personas', 'Excediste la capacidad');
        } else if ($scope.user_contacts.length > 0) {
          var contacts_selected = [];
          _.forEach($scope.user_contacts, function (value) {
            if (value.checked) {
              contacts_selected.push(value);
            }
          });
          if (contacts_selected.length > 0) {
            var cow_data = {
              cow_id: cowId,
              contacts: contacts_selected,
              invite_day_3: $scope.invite_day_3_user_contact,
              invite_week_1: $scope.invite_week_1_user_contact
            };
            console.log(cow_data);
            cowEventService.cowEventAddContacts(cow_data).then(function (data) {
              if (data.contacts_not_added.length > 0) {
                $scope.modalContactsNotAdded(data.contacts_not_added);
              }
              toastr.success('Contactos invitados exitosamente!');
              $scope.email_text_search_user_contacts = '';
            }, function (err) {
              console.log('err login', err);
              toastr.error('Error agregando los contactos');
            });
          } else {
            toastr.info('Debes seleccionar mínimo un contacto');
          }
        } else {
          toastr.info('Debes agregar mínimo un contacto');
        }
      };

      $scope.modalContactsNotAdded = function (contacts) {
        ngDialog.open({
          template: 'contactsModal-1',
          data: {
            contacts: contacts
          }
        });
      };


      $scope.goToAdmin = function () {
        $state.go('cow-admin', {
          cowId: cowId
        }, {
          reload: true
        });
      };


      $scope.titleList = [
        'Correos',
        // 'Redes Sociales',
        'Contactos Gmail',
        'Mis Contactos'
      ];


      $scope.onTabChanges = function (currentTab) {
        $scope.tabSelected = currentTab;
        $scope.menuTabsCollapse = true;
      };

      $scope.openQR = function () {
        ngDialog.open({
          template: 'QRCodeModal',
          width: 300,
          data: {
            cowParticipateURL: $scope.cowPublicURLComplete
          }
        });
      }

    });
})();

(function () {
  "use strict";

  angular
    .module("user")
    .config(function ($stateProvider) {
      $stateProvider.state("cow-get-money-token", {
        url: "/recibir-dinero-vaca/:token",
        templateUrl: "app/views/cowGetMoneyToken/cowGetMoneyToken.html",
        controller: "CowGetMoneyTokenController",
        controllerAs: "cow-get-money-token",
        resolve: {
          cashoutMethods: function (cowEventService) {
            return cowEventService.getCashoutMethods();
          },
          tokenInfo: function ($stateParams, cowEventService) {
            return cowEventService.getTokenMoneyRequest($stateParams.token);
          },
        },
        data: {
          meta: {
            title: "Recibir dinero",
            robots: "noindex, nofollow",
          },
        },
      });
    })
    .controller(
      "CowGetMoneyTokenController",
      function (
        $scope,
        $state,
        $rootScope,
        $mdDialog,
        cashoutMethods,
        bankService,
        tokenInfo,
        cowEventService,
        toastr
      ) {
        $scope.tokenInfo = tokenInfo;

        $scope.documentTypes = $rootScope.documentTypes;

        $scope.bankAccountInfo = {
          name: null,
          bank_account_owner_name: null,
          bank_account_owner_document_type: 1,
          bank_account_owner_document: null,
          bank_account_owner_document_full: null,
          bank: null,
          bank_account_type: 0,
          bank_account_number: null,
          confirm_account_number: null,
        };

        $scope.selectedCashoutMethod = {
          bankTransfer: false,
          daviplata: false,
          nequi: false,
          efecty: false,
        };

        $scope.bankTransferActive = _.find(cashoutMethods, function (o) {
          return o.slug === "bank-transfer";
        });

        $scope.fourByThousand =
          $scope.tokenInfo !== 0
            ? $scope.tokenInfo.cow_event.total_value_to_date_left * 0.004
            : 0;

        $scope.getBanksList = function () {
          bankService.getBanksList().then(function (data) {
            $scope.banksList = data;
            if (data.length > 0) {
              $scope.bankAccountInfo.bank = data[0].id;
            }
          });
        };

        $scope.getBanksList();

        $scope.selectCashoutMethod = function (cashoutMethod) {
          for (var prop in $scope.selectedCashoutMethod) {
            $scope.selectedCashoutMethod[prop] = false;
          }
          $scope.selectedCashoutMethod[cashoutMethod] = true;
        };

        $scope.setDocumentNumber = function () {
          if ($scope.bankAccountInfo.bank_account_owner_document_full) {
            $scope.bankAccountInfo.bank_account_owner_document =
              $scope.bankAccountInfo.bank_account_owner_document_full.replace(
                /[^0-9]/g,
                ""
              );
          }
        };

        $scope.createBankTransfer = function (isValid) {
          if (isValid) {
            cowEventService
              .sendTokenMoneyRequest(
                tokenInfo.token,
                JSON.stringify($scope.bankAccountInfo)
              )
              .then(
                function (data) {
                  $mdDialog.show({
                    controller: ShowSuccessMoneyTokenRequestController,
                    templateUrl:
                      "app/views/cowGetMoneyToken/successMoneyTokenRequest.html",
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    locals: {
                      $state: $state,
                    },
                  });
                },
                function (err) {
                  toastr.error(err.data.error);
                }
              );
          }
        };

        function ShowSuccessMoneyTokenRequestController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
            $state.go("home");
          };
        }
      }
    );
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-get-money', {
          url: '/recolectar-monto-vaca/:cowId',
          templateUrl: 'app/views/cowGetMoney/cowGetMoney.html',
          controller: 'CowGetMoneyController',
          controllerAs: 'cow-get-money',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCow(cowId);
            },
            cashoutMethods: function (cowEventService) {
              return cowEventService.getCashoutMethods();
            }
          },
          data: {
            'meta': {
              'title': 'Solicitar dinero',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CowGetMoneyController', function ($scope, $state, $rootScope, usersService, $stateParams, cowId, $log,
                                                   cow, toastr, cowEventService, minGetMoneyValue, ngDialog, minGetMoneyValidationValue,
                                                   $mdDialog, ivaAtvTax, minPartialLeft, bankService, AboutUsService, GAuth,
                                                   marketplaceURL, businessCowPercentageFee, highValueCowPercentageFee, highValueCowValue,
                                                   highValueCowCreationDate, ivaValue, premiumUserPercentageFee, publicCowPercentageFee,
                                                   efectyCashoutFee, efectyCashoutMaxAmount, efectyTypeCashout, smoothScroll,
                                                   bankTransferTypeCashout, reversalTypeCashout, cashoutMethods,
                                                   pricingPlanPro, pricingPlanFree, fourByThousandAppliesDate) {

      console.log('cow get money');
      console.log(cow);

      $scope.checkUserAdmin = function () {
        if (cow.deleted) {
          $state.go('cow-deleted', {
            cowId: cowId
          });
        }
        usersService.getUserData().then(function (data) {
          if (data.user.id !== cow.user) {
            $state.go('cow', {
              cowId: cowId
            });
          }
          $scope.adminUser = true;
          $scope.accountUser = data.user;
          $scope.validationsAndParse();
          $scope.getRequests();
          $scope.getUserBankAccounts();
          console.log($scope.accountUser);

          $scope.efectyUser = {
            given_names: $scope.accountUser.user.first_name,
            surname_1: $scope.accountUser.user.last_name,
            surname_2: $scope.accountUser.surname_2,
            document_type: $scope.accountUser.document_type,
            document_number: $scope.accountUser.document_number,
            document_full_number: $scope.accountUser.document_full_number
          }

        }, function (err) {
          $scope.adminUser = false;
          console.log('no login');
        });
      };

      $scope.checkUserAdmin();

      $scope.getRequests = function () {
        cowEventService.cowGetAllMoneyRequests(cowId).then(function (data) {
          $scope.requests = data;
          $scope.getTotalAvailableAmount();
          $scope.getTotalRecolectedAmount();
          $scope.getTotalServiceCost();

          console.log($scope.requests);
        });
      };

      $scope.getUserBankAccounts = function () {
        bankService.getUserBankAccountList().then(function (data) {
          $scope.userBankAccounts = data;
          if (data.length > 0) {
            $scope.bankAccountSelect.bankAccountId = data[0].id;
            $scope.bankAccountSelect.bankAccountSelected = data[0];
          }
          var account_index = 1;
          _.forEach($scope.userBankAccounts, function (value) {
            if (!value.name) {
              value.name = "Cuenta " + account_index;
              account_index++;
            }
          });
        });
      };

      $scope.getTotalAvailableAmount = function () {
        var value = cow.total_value;
        _.forEach($scope.requests, function (value_req) {
          if (value_req.status !== 2 && value_req.status !== 7) {
            value -= value_req.total_value_to_date;
            value -= value_req.atv_tax;
          }
        });
        $scope.totalAvailableAmount = value;
        $scope.totalAvailableAmountWithTax = $scope.totalAvailableAmount - ivaAtvTax;
        $scope.maxPartialRequest = $scope.totalAvailableAmount - ivaAtvTax - minPartialLeft;

        //Check if plan is pro
        if ($scope.cowIsPlanPro) {
          $scope.total_value_bool = false;
          $scope.parcial_value_bool = true;
        }
        else {
          $scope.total_value_bool = true;
          $scope.parcial_value_bool = false;
          $scope.totalValueChanged();
        }
      };

      $scope.getTotalRecolectedAmount = function () {
        var value = 0;
        _.forEach($scope.requests, function (value_req) {
          if (value_req.status !== 2 && value_req.status !== 7) {
            value += value_req.total_value_to_date;
            value += value_req.atv_tax;
          }
        });
        $scope.totalRecolectedAmount = value;
      };

      $scope.getTotalServiceCost = function () {
        var value = 0;
        _.forEach($scope.requests, function (value_req) {
          if (value_req.status !== 2 && value_req.status !== 7) {
            value += value_req.atv_tax;
          }
        });
        $scope.totalServiceCost = value;
      };

      $scope.cow_event = cow;

      $scope.cowIsPlanPro = $scope.cow_event.pricing_plan === null || $scope.cow_event.pricing_plan.slug !== pricingPlanFree;

      $scope.ivaAtvTax = ivaAtvTax;

      $scope.minPartialLeft = minPartialLeft;

      $scope.minGetMoneyValidationValue = minGetMoneyValidationValue;
      $scope.minGetMoneyValue = minGetMoneyValue;

      $scope.efectyActive = _.find(cashoutMethods, function (o) {
        return o.slug === 'efecty';
      });

      $scope.daviplataActive = _.find(cashoutMethods, function (o) {
        return o.slug === 'daviplata';
      });

      $scope.nequiActive = _.find(cashoutMethods, function (o) {
        return o.slug === 'nequi';
      });

      $scope.bankTransferActive = _.find(cashoutMethods, function (o) {
        return o.slug === 'bank-transfer';
      });

      $scope.bankAccountSelect = {
        bankAccountId: null,
        bankAccountSelected: ''
      };

      $scope.selectedCashoutMethod = {
        bankTransfer: false,
        daviplata: false,
        nequi: false,
        efecty: false,
      };

      $scope.anyCashoutMethodSelected = function () {
        for (var prop in $scope.selectedCashoutMethod) {
          if ($scope.selectedCashoutMethod[prop] === true) {
            return true;
          }
        }
        return false;
      };

      $scope.selectCashoutMethod = function (cashoutMethod) {
        for (var prop in $scope.selectedCashoutMethod) {
          $scope.selectedCashoutMethod[prop] = false;
        }
        $scope.selectedCashoutMethod[cashoutMethod] = true;
      };

      $scope.daviplataAccount = {
        bank_slug: 'davivienda',
        bank_account_type: 2,
        name: 'daviplata',
        bank_account_number: '',
        bank_account_owner_name: '',
        bank_account_owner_document_type: '',
        bank_account_owner_document: '',
        bank_account_owner_document_full: '',
      };

      $scope.nequiAccount = {
        bank_slug: 'nequi',
        bank_account_type: 0,
        name: 'nequi',
        bank_account_number: '',
        bank_account_owner_name: '',
        bank_account_owner_document_type: '',
        bank_account_owner_document: '',
        bank_account_owner_document_full: '',
      };

      $scope.efectyCashoutFee = efectyCashoutFee;
      $scope.efectyCashoutMaxAmount = efectyCashoutMaxAmount;
      $scope.efectyTypeCashout = efectyTypeCashout;

      $scope.bankTransferTypeCashout = bankTransferTypeCashout;
      $scope.reversalTypeCashout = reversalTypeCashout;

      $scope.todayDate = moment();
      $scope.maxDate = moment().set('year', $scope.todayDate.year() - 18);
      $scope.maxDate = $scope.maxDate.toDate();

      //Check if cow is over the free tier
      $scope.cowIsHighValue = ($scope.cow_event.total_value >= highValueCowValue) &&
        (new Date($scope.cow_event.creation_date) > highValueCowCreationDate);

      //Check if 4x1000 tax applies
      $scope.fourbyThousandApplies = false;
      if ($scope.cow_event.pricing_plan != null) {
        $scope.fourbyThousandApplies = $scope.cow_event.pricing_plan.slug === pricingPlanFree && 
        (new Date($scope.cow_event.creation_date) > fourByThousandAppliesDate);
      }
      
      $scope.upgradeCowToPro = function () {
        ngDialog.open({
          template: 'upgradeCowToProModal',
          data: {cow_event_id: $scope.cow_event.cow_event_id},
          controller: 'upgradeCowToProCtrl'
        });
      };

      $scope.validationsAndParse = function () {
        if ($scope.accountUser.born_date) {
          $scope.accountUser.born_date = moment($scope.accountUser.born_date);
          $scope.accountUser.born_date = $scope.accountUser.born_date.toDate();
        }
        if ($scope.accountUser.cellphone) {
          $scope.accountUser.cellphone = $scope.accountUser.cellphone.toString();
        }
        if ($scope.accountUser.document_type) {
          $scope.accountUser.document_type = $scope.accountUser.document_type.toString();
        }
      };

      $scope.openConfirmation = function () {
        console.log($scope.selectedCashoutMethod)
        console.log($scope.efectyUser)
        ngDialog.open({
          template: 'confirmationCloseGetMoneyRequestModal-1',
          data: {
            accountUser: $scope.accountUser,
            cow_event: $scope.cow_event,
            bankAccountSelected: $scope.bankAccountSelect.bankAccountSelected,
            parcial_value_bool: $scope.parcial_value_bool,
            total_value_bool: $scope.total_value_bool,
            totalAvailableAmount: $scope.totalAvailableAmount,
            totalRequests: $scope.requests.length,
            money_request_value: $scope.money_request_value,
            ivaAtvTax: $scope.ivaAtvTax,
            selectedCashoutMethod: $scope.selectedCashoutMethod,
            efectyUser: $scope.efectyUser,
            daviplataAccount: $scope.daviplataAccount,
            nequiAccount: $scope.nequiAccount
          },
          controller: 'GetMoneyRequestModalCtrl'
        });
      };

      $scope.scrollToCreateRequestForm = function (formToValidate) {
        if (formToValidate.$valid) {
          var element = document.getElementById('formCreateRequest');
          smoothScroll(element);
        }
      }

      $scope.sendRequest = function (isValid, efectyUserForm, daviplataForm, nequiForm) {
        if (!isValid || (!$scope.parcial_value_bool && !$scope.total_value_bool)) {
          var element = document.getElementById('formCreateRequest');
          smoothScroll(element);
          toastr.info('No se ha enviado la solicitud, verifica los campos del fomulario');
        } else if ($scope.selectedCashoutMethod.bankTransfer &&
          ($scope.bankAccountSelect.bankAccountSelected === null || $scope.bankAccountSelect.bankAccountSelected === '')) {
          element = document.getElementById('bankTransferFormHeader');
          smoothScroll(element);
          toastr.info('Debes seleccionar una cuenta bancaria');
        } else if ($scope.selectedCashoutMethod.efecty && !efectyUserForm.$valid) {
          element = document.getElementById('efectyUserFormHeader');
          smoothScroll(element);
          toastr.info('Verifica los campos de quien retira el dinero');
        } else if ($scope.selectedCashoutMethod.efecty && ($scope.money_request_value > $scope.efectyCashoutMaxAmount)) {
          element = document.getElementById('formCreateRequest');
          smoothScroll(element);
          toastr.info('Excedes el valor máximo de retiro por Efecty');
        } else if ($scope.selectedCashoutMethod.daviplata && !daviplataForm.$valid) {
          element = document.getElementById('daviplataFormHeader');
          smoothScroll(element);
          toastr.info('Verifica los campos');
        } else if ($scope.selectedCashoutMethod.nequi && !nequiForm.$valid) {
          element = document.getElementById('nequiFormHeader');
          smoothScroll(element);
          toastr.info('Verifica los campos');
        } else if ($scope.accountUser.born_date && $scope.showDateError) {
          toastr.info('Por favor ingresa una fecha de nacimiento valida, debes ser mayor de edad', 'Solicitud incompleta');
        } else if (isValid && $scope.anyCashoutMethodSelected()) {
          if ($scope.cow_event.total_value >= $scope.minGetMoneyValidationValue || $scope.accountUser.total_value_cash_out >= minGetMoneyValidationValue) {
            if (!$scope.accountUser.has_document_image_front && !$scope.accountUser.has_document_image_back && !$scope.accountUser.has_document_pdf) {
              toastr.info('Por favor agrega la imagen frontal - trasera o un archivo pdf del documento indentidad del organizador', 'Solicitud incompleta');
            }
            else if ($scope.accountUser.has_document_image_front && !$scope.accountUser.has_document_image_back && !$scope.accountUser.has_document_pdf) {
              toastr.info('Por favor agrega la imagen trasera del documento de indentidad del organizador', 'Solicitud incompleta');
            }
            else if (!$scope.accountUser.has_document_image_front && $scope.accountUser.has_document_image_back && !$scope.accountUser.has_document_pdf) {
              toastr.info('Por favor agrega la imagen frontal  del documento de indentidad del organizador', 'Solicitud incompleta');
            }
            else {
              $scope.openConfirmation();
            }
          } else {
            $scope.openConfirmation();
          }
        } else {
          toastr.info('Debes seleccionar un método de retiro');
        }
      };

      $scope.checkedChanged = function (bankAccount) {

        _.forEach($scope.userBankAccounts, function (value) {
          if (parseInt(bankAccount) === value.id) {
            value.checked = true;
            $scope.bankAccountSelect.bankAccountSelected = value;

          } else {
            value.checked = false;
          }
        });
      };

      $scope.updateAccountUser = function () {
        usersService.getUserData().then(function (data) {
          $scope.accountUser = data.user;
          $scope.validationsAndParse();
        }, function (err) {

        });
      };

      $scope.showDateError = false;
      $scope.dateBornValidator = function (isCompleted) {
        if ($scope.accountUser.born_date && isCompleted) {
          if ($scope.accountUser.born_date > $scope.maxDate) {
            $scope.showDateError = true;
          }
        } else {
          $scope.showDateError = false;
        }
      };

      $scope.showExample = function (ev) {
        $mdDialog.show({
          controller: ExampleController,
          templateUrl: 'dialog.document.example.tmpl.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: false // Only for -xs, -sm breakpoints.
        })
          .then(function () {
          }, function () {
          });
      };


      function ExampleController($scope, $mdDialog) {
        $scope.hide = function () {
          $mdDialog.hide();
        };

        $scope.cancel = function () {
          $mdDialog.cancel();
        };
      }

      $scope.showDocument = function (showNumber) {
        $scope.documentFileShow = showNumber;
        $mdDialog.show({
          controller: DocumentController,
          templateUrl: 'dialog.document.tmpl.html',
          parent: angular.element(document.body),
          scope: $scope.$new(),
          clickOutsideToClose: true,
          fullscreen: false // Only for -xs, -sm breakpoints.
        })
          .then(function () {
          }, function () {
          });
      };


      function DocumentController($scope, $mdDialog, $state) {
        $scope.hide = function () {
          $mdDialog.hide();
        };

        $scope.cancel = function () {
          $mdDialog.cancel();
        };
      }

      $scope.addDocumentImageFront = function () {
        usersService.uploadDocumenUserImageFront($scope.accountUser.documentUserFrontFileMQ).then(function (data) {
          usersService.retrieveUserData().then(function (data) {
            $scope.updateAccountUser();
            // $state.reload();
            toastr.success('Imagen agregada');
          }, function (err) {

          });
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de agregar tu documento');
        });
      };

      $scope.addDocumentImageBack = function () {
        usersService.uploadDocumenUserImageBack($scope.accountUser.documentUserBackFileMQ).then(function (data) {
          usersService.retrieveUserData().then(function (data) {
            $scope.updateAccountUser();
            // $state.reload();
            toastr.success('Imagen agregada');
          }, function (err) {

          });
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de agregar tu documento');
        });
      };

      $scope.addDocumentPDF = function () {
        usersService.uploadDocumenUserPDF($scope.accountUser.documentUserPDFFileMQ).then(function (data) {
          usersService.retrieveUserData().then(function (data) {
            $scope.updateAccountUser();
            // $state.reload();
            toastr.success('Documento agregado');
          }, function (err) {

          });
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de agregar tu documento');
        });
      };

      $scope.validateDocument = function (type) {
        if (type === 'ImageFront') {
          if ($scope.accountUser.documentUserFrontFileMQ.type === 'image/png' ||
            $scope.accountUser.documentUserFrontFileMQ.type === 'image/jpeg') {
            AboutUsService.validateDocument($scope.accountUser.documentUserFrontFileMQ, false).then(function (data) {
              if (data.data.invalid_document) {
                $scope.openDocumentConfirmation(type);
              }
              else {
                $scope.addDocumentImageFront();
              }
            }, function (err) {
              toastr.error('Error adjuntando el documento')
            });
          }
          else {
            toastr.error('Adjunta una imagen en fomato PNG o JPEG');
          }
        }
        else if (type === 'ImageBack') {
          if ($scope.accountUser.documentUserBackFileMQ.type === 'image/png' ||
            $scope.accountUser.documentUserBackFileMQ.type === 'image/jpeg') {
            AboutUsService.validateDocument($scope.accountUser.documentUserBackFileMQ, false).then(function (data) {
              if (data.data.invalid_document) {
                $scope.openDocumentConfirmation(type);
              }
              else {
                $scope.addDocumentImageBack();
              }
            }, function (err) {
              toastr.error('Error adjuntando el documento')
            });
          }
          else {
            toastr.error('Adjunta una imagen en fomato PNG o JPEG');
          }
        }
        else if (type === 'PDF') {
          if ($scope.accountUser.documentUserPDFFileMQ.type === 'application/pdf') {
            AboutUsService.validateDocument($scope.accountUser.documentUserPDFFileMQ, true).then(function (data) {
              if (data.data.invalid_document) {
                $scope.openDocumentConfirmation(type);
              }
              else {
                $scope.addDocumentPDF();
              }
            }, function (err) {
              toastr.error('Error adjuntando el documento')
            });
          }
          else {
            toastr.error('Adjunta un documento en fomato PDF');
          }
        }
      };

      $scope.clickChangeDocumentImageFront = function () {
        angular.element('#fileInputImageFrontMQ').trigger('click');
      };

      $scope.clickChangeDocumentImageBack = function () {
        angular.element('#fileInputImageBackMQ').trigger('click');
      };

      $scope.clickChangeDocumentPDF = function () {
        angular.element('#fileInputPDFMQ').trigger('click');
      };

      $scope.$watch('accountUser.documentUserFrontFileMQ', function (newValue, oldValue) {
        if (newValue != null) {
          $scope.validateDocument('ImageFront');
          // $scope.addDocumentImageFront();
        }
      });

      $scope.$watch('accountUser.documentUserBackFileMQ', function (newValue, oldValue) {
        if (newValue != null) {
          $scope.validateDocument('ImageBack');
          // $scope.addDocumentImageBack();
        }
      });

      $scope.$watch('accountUser.documentUserPDFFileMQ', function (newValue, oldValue) {
        if (newValue != null) {
          $scope.validateDocument('PDF');
          // $scope.addDocumentPDF();
        }
      });

      $scope.totalValueChanged = function () {
        $scope.parcial_value_bool = false;
        $scope.totalAmountReadOnly = true;
        $scope.money_request_value = $scope.totalAvailableAmount;

        $scope.calculateTaxCommission();
      };

      $scope.partialValueChanged = function () {
        $scope.total_value_bool = false;
        $scope.totalAmountReadOnly = false;
        delete $scope.money_request_value;

        $scope.calculateTaxCommission();
      };

      $scope.changedMoneyRequestAmount = function () {
        if ($scope.money_request_value === $scope.totalAvailableAmountWithTax) {
          $scope.retrieveAvailableBool = true;
        }
        else {
          $scope.retrieveAvailableBool = false;
        }

        $scope.calculateTaxCommission();
      };

      $scope.retrieveAvailableAmount = function () {
        if ($scope.retrieveAvailableBool) {
          $scope.money_request_value = $scope.totalAvailableAmountWithTax;
        }
        else {
          delete $scope.money_request_value;
        }
        $scope.calculateTaxCommission();
      };

      $scope.calculateTaxCommission = function () {
        $scope.fourByThousandTax = $scope.money_request_value * 0.004;
        $scope.businessCowPercentage = businessCowPercentageFee * 100;
        $scope.publicCowPercentage = publicCowPercentageFee * 100;
        $scope.highValueCowCommission = $scope.money_request_value * highValueCowPercentageFee * (1 + ivaValue);
        // $scope.businessCowCommission = $scope.money_request_value * businessCowPercentageFee * (1 + ivaValue);
        // $scope.premiumUserCommission = $scope.money_request_value * premiumUserPercentageFee * (1 + ivaValue);
        // $scope.efectyCashoutCommission = $scope.money_request_value * efectyCashoutFee * (1 + ivaValue);
        // $scope.publicCowCommission = $scope.money_request_value * publicCowPercentageFee * (1 + ivaValue);

        if ($scope.cow_event.cashout_commission_fixed) {
          $scope.cashout_commission_value = $scope.cow_event.cashout_commission_value;
          $scope.cashout_commission_tax_value = $scope.cashout_commission_value * ivaValue;
        }
        else if ($scope.cow_event.cashout_commission_percentage) {
          $scope.cashout_commission_value = $scope.cow_event.cashout_commission_value * $scope.money_request_value;
          $scope.cashout_commission_tax_value = $scope.cashout_commission_value * ivaValue;
        }
        else {
          $scope.cashout_commission_value = 0;
          $scope.cashout_commission_tax_value = $scope.cashout_commission_value * ivaValue;
        }
      };

      $scope.$on('updateBankAccountsUserGetMoneyRequest', function (event, bank_account_id) {
        bankService.getUserBankAccountList().then(function (data) {
          $scope.userBankAccounts = data;
          if (data.length > 0) {
            data.find(function(value, index){
              if (value.id === bank_account_id){
                $scope.bankAccountSelect.bankAccountId = data[index].id;
                $scope.bankAccountSelect.bankAccountSelected = data[index];
              }
            });

          }
          var account_index = 1;
          _.forEach($scope.userBankAccounts, function (value) {
            if (!value.name) {
              console.log(value);
              value.name = "Cuenta " + account_index;
              account_index++;
            }
          });
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de obtener la lista de cuentas bancarias');
        });
      });

      $scope.openDocumentConfirmation = function (type) {
        ngDialog.open({
          template: 'confirmationDocumentValidated',
          scope: $scope,
          data: {type: type}
        });
      };

      $scope.acceptDocumentValidation = function (data) {
        if (data.type === 'ImageFront') {
          $scope.addDocumentImageFront();
        }
        else if (data.type === 'ImageBack') {
          $scope.addDocumentImageBack();
        }
        else if (data.type === 'PDF') {
          $scope.addDocumentPDF();
        }

        $scope.closeDocumentConfirmation(data.ngDialogId);
      };

      $scope.closeDocumentConfirmation = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.setDocumentNumber = function () {
        if ($scope.accountUser.document_full_number) {
          $scope.accountUser.document_number = $scope.accountUser.document_full_number.replace(/[^0-9]/g, '');
        }
      };

      $scope.setDocumentFullNumber = function () {
        if ($scope.accountUser.document_number) {
          $scope.accountUser.document_full_number = $scope.accountUser.document_number;
        }
      };

      $scope.goToPublicCow = function () {
        $state.go('cow', {
          cowId: cowId
        });
      };

      $scope.loginFb = function () {
        var send_welcome_email = true;
        usersService.loginFb(send_welcome_email).then(function (data) {
          $state.reload();
        }, function (err) {
          $rootScope.errorSended = true;
          $scope.errorMessage = "Usuario y/o contraseña incorrectos";
        });
      };

      $scope.loginGg = function () {
        var send_welcome_email = true;
        GAuth.login().then(function (user) {
          GAuth.getToken().then(function (token_response) {
            usersService.loginGg(token_response.access_token, send_welcome_email).then(function (data) {
              $state.reload();
            }, function (err) {
              $rootScope.errorSended = true;
              $scope.errorMessage = "Usuario y/o contraseña incorrectos";
            });
          }, function () {
            console.log('token error');
          });
        }, function () {
          console.log('login fail');
        });
      };


      $scope.loginUser = function (isValid) {
        if (isValid) {
          console.log($scope.user.email,
            $scope.user.password);
          usersService.login($scope.user.email,
            $scope.user.password
          ).then(function (data) {
            $state.reload();
          }, function (err) {
            $scope.errorSended = true;
            $scope.errorMessage = "Usuario y/o contraseña incorrectos";
          });
        }
      };

    })
    .controller('GetMoneyRequestModalCtrl', function ($scope, ngDialog, cowEventService, bankService,
                                                      toastr, usersService, $state, ivaAtvTax) {

      $scope.closeSecond = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.confirmMoneyRequestSuccess = function () {
        ngDialog.open({
          template: 'moneyRequestSuccessModal-1',
          data: {selectedCashoutMethod: $scope.ngDialogData.selectedCashoutMethod},
          controller: 'ConfimationMoneyRequestSuccessCtrl'
        });
      };

      $scope.confirmationGetMoneyRequest = function () {
        ngDialog.close();

        var accountUser = $scope.ngDialogData.accountUser;
        var cow_event = $scope.ngDialogData.cow_event;
        var bankAccountSelected = $scope.ngDialogData.bankAccountSelected;
        var money_request_value = $scope.ngDialogData.money_request_value;
        var parcial_value_bool = $scope.ngDialogData.parcial_value_bool;
        var total_value_bool = $scope.ngDialogData.total_value_bool;
        var selectedCashoutMethod = $scope.ngDialogData.selectedCashoutMethod;
        var efectyUser = $scope.ngDialogData.efectyUser;
        var daviplataAccount = $scope.ngDialogData.daviplataAccount;
        var nequiAccount = $scope.ngDialogData.nequiAccount;

        usersService.updateMyProfile(accountUser.user.first_name,
          accountUser.user.last_name,
          accountUser.born_date,
          accountUser.cellphone,
          accountUser.document_number,
          accountUser.document_type,
          accountUser.document_full_number,
          accountUser.surname_2
        ).then(function () {
          if (parcial_value_bool) {
            money_request_value += ivaAtvTax;
          }

          if (selectedCashoutMethod.bankTransfer) {
            cowEventService.createGetMoneyRequest(cow_event, bankAccountSelected.id, money_request_value,
              parcial_value_bool, total_value_bool).then(function (data) {
              console.log(data.get_money_request_id);
              usersService.retrieveUserData().then(function (data) {
                $state.reload();
                toastr.success('Solicitud creada exitosamente');
                $scope.confirmMoneyRequestSuccess();
              });
            }, function (err) {
              toastr.error('Error creando la solicitud, inténtalo de nuevo');
            });
          }

          else if (selectedCashoutMethod.efecty) {
            var efectyUserData = JSON.stringify(efectyUser);
            cowEventService.createEfectyMoneyRequest(cow_event, money_request_value, total_value_bool, efectyUserData).then(function (data) {
              console.log(data.get_money_request_id);
              usersService.retrieveUserData().then(function (data) {
                $state.reload();
                toastr.success('Solicitud creada exitosamente');
                $scope.confirmMoneyRequestSuccess();
              });
            }, function (err) {
              if (err.data.exceed_daily_value) {
                toastr.error('Ya has retirado el máximo permitido al día por Efecty');
              }
              else {
                toastr.error('Error creando la solicitud, inténtalo de nuevo');
              }
            });
          }

          else if (selectedCashoutMethod.daviplata) {
            bankService.createBankAccountUser(daviplataAccount).then(function (data) {
              cowEventService.createGetMoneyRequest(cow_event, data.bank_account_id, money_request_value,
                parcial_value_bool, total_value_bool).then(function (data) {
                console.log(data.get_money_request_id);
                usersService.retrieveUserData().then(function (data) {
                  $state.reload();
                  toastr.success('Solicitud creada exitosamente');
                  $scope.confirmMoneyRequestSuccess();
                });
              }, function (err) {
                toastr.error('Error creando la solicitud, inténtalo de nuevo');
              });
            }, function (err) {
              console.log('err login', err);
              toastr.error('Error intentando agregar la cuenta bancaria');
            });
          }

          else if (selectedCashoutMethod.nequi) {
            bankService.createBankAccountUser(nequiAccount).then(function (data) {
              cowEventService.createGetMoneyRequest(cow_event, data.bank_account_id, money_request_value,
                parcial_value_bool, total_value_bool).then(function (data) {
                console.log(data.get_money_request_id);
                usersService.retrieveUserData().then(function (data) {
                  $state.reload();
                  toastr.success('Solicitud creada exitosamente');
                  $scope.confirmMoneyRequestSuccess();
                });
              }, function (err) {
                toastr.error('Error creando la solicitud, inténtalo de nuevo');
              });
            }, function (err) {
              console.log('err login', err);
              toastr.error('Error intentando agregar la cuenta bancaria');
            });
          }

          else {
            toastr.error('Error creando la solicitud, inténtalo de nuevo');
          }

        }, function (err) {
          try {
            if (err.data.error_text_msg) {
              toastr.error(err.data.error_text_msg);

            } else {
              toastr.error('Se presento un error actualizando tus datos, inténtalo mas tarde.');
            }
          } catch (err) {
            toastr.error('Se presento un error actualizando tus datos, inténtalo mas tarde.');
          }
        });
      };
    })
    .controller('ConfimationMoneyRequestSuccessCtrl', function ($scope, ngDialog, toastr, $state) {
      $scope.closeSuccessConfirmation = function (closeId) {
        ngDialog.close(closeId);
      };
    })
    .controller('upgradeCowToProCtrl', function ($scope, $state, ngDialog, cowEventService, toastr, businessCowPercentageFee) {
      $scope.businessCowFee = (businessCowPercentageFee * 100).toFixed(2);

      $scope.closeUpgradeCowToProModal = function () {
        ngDialog.close();
      };

      $scope.acceptUpgradeCowToPro = function () {
        ngDialog.close();

        ngDialog.open({
          template: 'confirmCowToProModal',
          data: {cow_event_id: $scope.ngDialogData.cow_event_id},
          controller: 'upgradeCowToProCtrl'
        });
      };

      $scope.confirmUpgradeCowToPro = function () {
        ngDialog.close();

        cowEventService.upgradeCowPlan($scope.ngDialogData.cow_event_id).then(function (data) {
          toastr.success('El plan de tu Vaca se ha actualizado correctamente');
          $state.reload();
        }, function (err) {
          toastr.error('Error actualizando el plan de tu Vaca, inténtalo de nuevo');
        });
      }
    });
})();

/**
 * Created by hetdev on 7/07/17.
 */
(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-gift-code-terms-and-conditions', {
          url: '/terminos-y-condiciones-codigos-promocionales-vacas/:slugGiftCode',
          templateUrl: 'app/views/cowEventGiftCodeTermsAndConditions/cowEventGiftCodeTermsAndConditions.html',
          controller: 'CowEventGiftCodeTermsAndConditionsController',
          controllerAs: 'cow-invite',
          resolve: {
            slugGiftCode: function ($stateParams) {
              return $stateParams.slugGiftCode;
            },
            giftCode: function (cowEventService, slugGiftCode) {
              return cowEventService.getCowEventTermsAndConditions(slugGiftCode);
            }
          },
          data: {
            'meta': {
              'title': 'Términos y Condiciones Códigos Promocionales',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CowEventGiftCodeTermsAndConditionsController', function ($scope, $state, slugGiftCode, giftCode) {

      console.log('giftcode');
      console.log(slugGiftCode);
      console.log(giftCode);

      $scope.giftCode = giftCode;


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-edit', {
          url: '/editar-vaca/:cowId',
          templateUrl: 'app/views/cowEdit/cowEdit.html',
          controller: 'CowEditController',
          controllerAs: 'cow-edit',
          resolve: {
            cowEventTypes: function (cowEventService) {
              return cowEventService.getCowEventTypes();
            },
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            currentCow: function (cowEventService, cowId) {
              return cowEventService.getCow(cowId);
            },
            matrixCommissions: function (paymentService) {
              return paymentService.getMatrixComissionsList();
            }
          },
          data: {
            'meta': {
              'title': 'Editar mi Vaca',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CowEditController', function ($scope, $state, $rootScope, usersService, $stateParams, cowEventTypes,
                                               $log, cowEventService, toastr, currentCow, cowId,
                                               matrixCommissions, fileSizeImage) {

      $scope.checkCowIsPro = function () {
        if(currentCow.pricing_plan){
          if (currentCow.pricing_plan.slug === 'free'){
            $state.go('cow', {
              cowId: cowId
            });
          }
        }
      };
      $scope.checkCowIsPro();
      $scope.checkUserAdmin = function () {
        if (currentCow.deleted) {
          $state.go('cow-deleted', {
            cowId: cowId
          });
        } else {
          usersService.getUserData().then(function (data) {
            if (data.user.id != currentCow.user) {
              $state.go('cow', {
                cowId: cowId
              });
            }
          }, function (err) {
            $state.go('cow', {
              cowId: cowId
            });
          });
        }
      };
      $scope.checkUserAdmin();

      $scope.matrixCommissions = matrixCommissions;

      $scope.cow = currentCow;

      $scope.cowEventTypesList = cowEventTypes;


      if ($scope.cow.event_date) {
        $scope.cow.event_date = new Date($scope.cow.event_date);
      }
      if ($scope.cow.pay_limit_date) {
        $scope.cow.pay_limit_date = new Date($scope.cow.pay_limit_date);
      }
      $scope.main_img_raw = $scope.cow.main_img_raw;

      usersService.getUserData().then(function (data) {
        $scope.user = data.user;
      }, function (err) {
      });

      $scope.todayDate = new Date();
      $scope.todayDate_format = $scope.todayDate.getDay() + '/' + $scope.todayDate.getMonth() + '/' + $scope.todayDate.getFullYear();

      $scope.animationClass = 'box-one';

      $scope.cowEventTypeChanged = function (typeString) {
        $scope.cow_type = typeString;
        $scope.main_img_raw = $scope.cow_type.example_img;
        if ($scope.animationClass == 'box-one') {
          $scope.animationClass = 'box-two';
        } else if ($scope.animationClass == 'box-two') {
          $scope.animationClass = 'box-one';
        }
        $scope.cowType = $scope.cow_type.id;
      };

      var cowEventTemp = _.find($scope.cowEventTypesList, {
        'id': $scope.cow.cow_type.id
      });
      $scope.cowTypeString = cowEventTemp;
      $scope.cowType = $scope.cow.cow_type;
      $scope.cow_type = $scope.cow.cow_type;

      $scope.getCowEventTypeEmotivaca = function () {
        return $scope.cow_type.emotivaca;
      };

      var handleFileSelect = function (evt) {
        var file = evt.currentTarget.files[0];
        if (file.size <= fileSizeImage) {
          var reader = new FileReader();
          reader.onload = function (evt) {
            $scope.$apply(function ($scope) {
              $scope.main_img_raw = evt.target.result;
              toastr.success("Imagen cargada correctamente");
            });
          };
          reader.readAsDataURL(file);
        } else {
          toastr.error('El tamaño de la imagen es superior a ' + (fileSizeImage / 1000000) + 'MB');
        }
      };
      angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);

      $scope.checkCommissionsToMatrix = function () {
        var commTemp = _.find($scope.matrixCommissions, function (o) {
          return o.min_value <= $scope.participant_value_example && o.max_value > $scope.participant_value_example;
        });
        if (commTemp) {
          $scope.commissionObj = commTemp;
        }
        console.log(commTemp);
      };

      $scope.calculateCommissions = function () {
        if ($scope.commissionObj.fixed) {
          if ($scope.cow.commission_added) {
            $scope.participant_pay_example = $scope.participant_value_example + $scope.commissionObj.fixed_value;
            $scope.received_value_example = $scope.participant_value_example;
          } else if ($scope.cow.commission_deducted) {
            $scope.participant_pay_example = $scope.participant_value_example;
            $scope.received_value_example = $scope.participant_value_example - $scope.commissionObj.fixed_value;
          }
        } else if ($scope.commissionObj.percentage) {
          if ($scope.cow.commission_added) {
            $scope.participant_pay_example = $scope.participant_value_example * (1 + $scope.commissionObj.percentage_value);
            $scope.received_value_example = $scope.participant_value_example;
          } else if ($scope.cow.commission_deducted) {
            $scope.participant_pay_example = $scope.participant_value_example;
            $scope.received_value_example = $scope.participant_value_example * (1 - $scope.commissionObj.percentage_value);
          }
        }
      };

      $scope.setParticipationValueExample = function (value) {
        if (!value || value < $scope.minPaymentValue) {
          $scope.participant_value_example = 20000;
        } else {
          $scope.participant_value_example = value;
        }

        $scope.checkCommissionsToMatrix();
        $scope.calculateCommissions();
      };

      $scope.setParticipationValueExample();

      $scope.commisionAddedChanged = function () {
        $scope.cow.commission_deducted = !$scope.cow.commission_added;
        $scope.calculateCommissions();
      };

      $scope.commisionDeductedChanged = function () {
        $scope.cow.commission_added = !$scope.cow.commission_deducted;
        $scope.calculateCommissions();
      };

      $scope.selectParticipationFree = function () {
        $scope.cow.participation_free = true;
        $scope.cow.participation_suggested = false;
        $scope.cow.participation_fixed = false;
        $scope.cow.participant_value_suggested = undefined;
        $scope.cow.participant_value_fixed = undefined;
        $scope.setParticipationValueExample();
      };

      $scope.selectParticipationSuggested = function () {
        $scope.cow.participation_suggested = true;
        $scope.cow.participation_free = false;
        $scope.cow.participation_fixed = false;
        $scope.cow.participant_value_fixed = undefined;
      };

      $scope.selectParticipationFixed = function () {
        $scope.cow.participation_fixed = true;
        $scope.cow.participation_free = false;
        $scope.cow.participation_suggested = false;
        $scope.cow.participant_value_suggested = undefined;
      };

      $scope.selectParticipationSuggestedFocus = function () {
        $scope.cow.participation_suggested = true;
        $scope.cow.participation_free = false;
        $scope.cow.participation_fixed = false;
        $scope.cow.participant_value_fixed = undefined;
      };

      $scope.selectParticipationFixedFocus = function () {
        $scope.cow.participation_fixed = true;
        $scope.cow.participation_free = false;
        $scope.cow.participation_suggested = false;
        $scope.cow.participant_value_suggested = undefined;
      };

      $scope.clickChangeImageHeader = function () {
        angular.element('#fileInput').trigger('click');
      };

      $scope.map = {
        center: {
          latitude: $scope.cow.location_point.latitude,
          longitude: $scope.cow.location_point.longitude
        },
        zoom: 16
      };
      $scope.marker = {
        id: 0,
        coords: {
          latitude: $scope.cow.location_point.latitude,
          longitude: $scope.cow.location_point.longitude
        },
        options: {
          draggable: true,
          icon: 'assets/images/map-pin.png'
        },
        events: {
          dragend: function (marker, eventName, args) {
            $log.log('marker dragend');
            var lat = marker.getPosition().lat();
            var lon = marker.getPosition().lng();
          }
        }
      };

      var events = {
        place_changed: function (searchBox) {
          var place = searchBox.getPlace();
          if (!place || place == 'undefined') {
            return;
          }
          // refresh the map
          $scope.map = {
            center: {
              latitude: place.geometry.location.lat(),
              longitude: place.geometry.location.lng()
            },
            zoom: 16
          };

          // refresh the marker
          $scope.marker = {
            id: 0,
            options: {
              draggable: true,
              icon: 'assets/images/map-pin.png'
            },
            coords: {
              latitude: place.geometry.location.lat(),
              longitude: place.geometry.location.lng()
            },
            events: {
              dragend: function (marker, eventName, args) {
                $log.log('marker dragendg');
                var lat = marker.getPosition().lat();
                var lon = marker.getPosition().lng();
              }
            }
          };
        }
      };

      $scope.searchbox = {
        template: 'searchbox.tpl.html',
        events: events,
        options: {
          autocomplete: true,
          componentRestrictions: {
            country: 'co'
          }
        }
      };

      $scope.updateCow = function (isValid) {
        $scope.dateCowEventValidator(true);
        if ($scope.cow.event_date && $scope.showEventDateError) {
          toastr.info('Por favor asegurate de escoger una fecha futura para el evento', 'Fecha Inválida');
        } else if ($scope.cow.pay_limit_date && $scope.showDeadlineDateError) {
          toastr.info('Por favor asegurate que la fecha límite de pago sea futura', 'Fecha Inválida');
        } else if ($scope.cow.participation_suggested && $scope.cow.participant_value_suggested < $scope.minPaymentValue) {
          toastr.info('El monto sugerido debe ser mayor', 'Vaca incompleta');
        } else if ($scope.cow.participation_suggested && $scope.cow.participant_value_suggested > $scope.maxPaymentValue) {
          toastr.info('El monto sugerido debe ser menor', 'Vaca incompleta');
        } else if ($scope.cow.participation_fixed && $scope.cow.participant_value_fixed < $scope.minPaymentValue) {
          toastr.info('El monto fijo debe ser mayor', 'Vaca incompleta');
        } else if ($scope.cow.participation_fixed && $scope.cow.participant_value_fixed > $scope.maxPaymentValue) {
          toastr.info('El monto fijo debe ser menor', 'Vaca incompleta');
        } else if (!$scope.cow.participation_free && !$scope.cow.participation_suggested && !$scope.cow.participation_fixed) {
          toastr.info('Elige el tipo de participación', 'Vaca incompleta');
        } else if (isValid) {
          $scope.cow_temp = JSON.parse(JSON.stringify($scope.cow));
          for (var data in $scope.cow_temp) {
            if ($scope.cow_temp[data] == null) {
              delete $scope.cow_temp[data];
            }
          }
          $scope.cow_temp.location_point = "SRID=4326;POINT (" + $scope.marker.coords.longitude + " " + $scope.marker.coords.latitude + ")";
          $scope.cow_temp.temp = false;
          if ($scope.main_img_raw.includes('https://armatuvaca.s3.')) {
            $scope.main_img_raw_temp = $scope.main_img_raw.replace("https://armatuvaca.s3.amazonaws.com/", "");
            delete $scope.cow_temp.main_img_raw;
          } else {
            $scope.main_img_raw_temp = $scope.main_img_raw_file;
            $scope.cow_temp.main_img_raw = $scope.main_img_raw_file;
          }
          $scope.blob_main_img.name = 'radom.' + $scope.blob_main_img.type.replace("image/", "");
          $scope.cow_temp.cow_type = $scope.cowType;
          $scope.cow_temp.main_img = $scope.blob_main_img;
          if ($scope.cow_temp.pay_limit_date == null) {
            $scope.cow_temp.pay_limit_date = '';
          }
          console.log($scope.cow_temp);
          cowEventService.editCowEvent($scope.cow_temp).then(function (data) {
            var cowDataId = data.data.cow_event_id;
            $rootScope.scrapeFbCowEvent(cowDataId);
            $state.go('cow-admin', {
              cowId: cowDataId
            });
            toastr.success('Actualización exitosa!');
          }, function (err) {
            toastr.error('Si el error persiste, comunicate con nosotros.', 'Error actualizando la Vaca');
          });
        } else {
          toastr.info('Por favor revisa los campos obligatorios', 'Vaca incompleta');
        }
      };


      $scope.goToAdmin = function () {
        $state.go('cow-admin', {
          cowId: cowId
        }, {
          reload: true
        });
      };

      $scope.showEventDateError = false;
      $scope.showDeadlineDateError = false;
      $scope.dateCowEventValidator = function (isCompleted) {
        if ($scope.cow.event_date && isCompleted) {
          if ($scope.cow.event_date < $scope.todayDate) {
            $scope.showEventDateError = true;
          } else {
            $scope.showEventDateError = false;
          }
        } else {
          $scope.showEventDateError = false;
        }
        if ($scope.cow.pay_limit_date && isCompleted) {
          if ($scope.cow.pay_limit_date < $scope.todayDate) {
            $scope.showDeadlineDateError = true;
          } else {
            $scope.showDeadlineDateError = false;
          }
        } else {
          $scope.showDeadlineDateError = false;
        }
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-deleted', {
          url: '/vaca-eliminada/:cowId',
          templateUrl: 'app/views/cowDeleted/cowDeleted.html',
          controller: 'CowDeletedController',
          controllerAs: 'Vaca eliminada',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCowPublic(cowId);
            }
          },
          data: {
            'meta': {
              'title': 'Vaca eliminada',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CowDeletedController', function ($scope, $state, $rootScope, usersService, $stateParams, cowId, cow) {

      console.log('cow deleted');
      if (!cow.deleted) {
        console.log('eroorrr', cowId);
        $state.go('cow', {cowId: cowId});
      }
      console.log(cowId);


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-create', {
          url: '/crear-vaca-online?cow_name&cow_type&participation_type&participant_value&is_public',
          templateUrl: 'app/views/cowCreateNew/cowCreateNew.html',
          controller: 'CowCreateController',
          controllerAs: 'cow-create',
          resolve: {
            cowEventTypes: function (cowEventService) {
              return cowEventService.getCowEventTypes();
            },
            publicCowCategories: function (cowEventService) {
              return cowEventService.getCategoryCows();
            },
            matrixCommissions: function (paymentService) {
              return paymentService.getMatrixComissionsList();
            }
          },
          data: {
            'meta': {
              'title': 'Armatuvaca | Recolecta dinero en grupo Online',
              'description': 'Armatuvaca para la próxima reunión o evento. Realiza una colecta para lo que quieras, un regalo, un viaje o un cumpleaños. Invita a tus amigos a un proyecto de Crowdfunding. Recolecta dinero por medios electrónicos. Recauda fondos o cobra dinero a un amigo. Ahora la Vaca se hace Online.',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CowCreateController', function ($scope, $state, $rootScope, $window, usersService, ngDialog, $stateParams,
                                                 cowEventTypes, cowEventService, toastr, $analytics, matrixCommissions,
                                                 businessCowTypeSlug, socialBusinessCowTypeSlug, businessCowPercentageFee,
                                                 smoothScroll, publicCowPercentageFee, publicCowCategories) {

      // $analytics.pageTrack('/cow-create');
      // $analytics.pageTrack('/crear-vaca-online');

      //$window.fbq('trackCustom', 'EntraCrearVaca');


      // USER DOCUMENT VALIDATION
      if ($rootScope.isLogged) {
        usersService.getUserData().then(function (data) {
          $scope.user = data.user;
          if ($scope.user.document_number == null) {
            ngDialog.open({
              template: 'noDocumentAlert',
              scope: $scope,
              showClose: false,
              closeByEscape: false,
              closeByNavigation: true,
              closeByDocument: false
            });
          }
        }, function (err) {
        });
      }
      $scope.acceptNoDocumentAlert = function (closeId) {
        $state.go('account');
        ngDialog.close(closeId);
      };

      // MAN
      // plans: (free, pro)
      // categories: (group, crowdfunding, wallet)

      // Initial Declarations
      $scope.cow = {
        cow_type: null,
        cow_public_type: null,
        name: null,
        plan: 'free',
        is_public: false,
        category: null
      };

      $scope.create_cow_button_submit = false;

      $scope.cowEventTypeWallet = [
        {'name': 'Cobrar a amigos', 'slug': 'cobrar-amigos'},
        {'name': 'Alcancía y/ó Guardar dinero', 'slug': 'alcancia'}
      ];

      $scope.cowEventPublicType = publicCowCategories;
      $scope.cow.cow_public_type = $scope.cowEventPublicType[0].slug;

      $scope.ranges = [
        '\ud83c[\udf00-\udfff]', // U+1F300 to U+1F3FF
        '\ud83d[\udc00-\ude4f]', // U+1F400 to U+1F64F
        '\ud83d[\ude80-\udeff]'  // U+1F680 to U+1F6FF
      ];

      $scope.businessCowFee = (businessCowPercentageFee * 100).toFixed(2);
      $scope.publicCowFee = (publicCowPercentageFee * 100).toFixed(2);

      // Verify Query Params
      if ($stateParams.cow_name !== undefined) {
        $scope.cow.name = $stateParams.cow_name;
      }
      if ($stateParams.is_public !== undefined && $stateParams.is_public === 'true') {
        $scope.cow.is_public = true;
        $scope.cow.category = 'crowdfunding';

        $scope.cow.cow_type = 'fundacion';
        smoothScroll(document.getElementsByClassName('new-cow-create-selector-widget-option')[2]);
      }

      if ($stateParams.cow_type !== undefined && $stateParams.cow_type === 'negocio') {
        $scope.cowEventTypesList = $scope.cowEventTypeWallet;
        $scope.cow.plan = 'pro';
        $scope.cow.category = 'wallet';
        $scope.cow.cow_type = 'cobrar-negocio';
        smoothScroll(document.getElementsByClassName('new-cow-create-selector-widget-option')[2]);
      }

      if ($stateParams.cow_type !== undefined && $stateParams.cow_type === 'fundacion') {
        $scope.cow.category = 'crowdfunding';
        $scope.cow.cow_type = 'fundacion';
        smoothScroll(document.getElementsByClassName('new-cow-create-selector-widget-option')[2]);

      }

      if ($stateParams.cow_type !== undefined && ($stateParams.cow_type === 'group' || $stateParams.cow_type === 'wallet')) {
        $scope.cow.category = $stateParams.cow_type;
        smoothScroll(document.getElementsByClassName('new-cow-create-selector-widget-option')[2]);
        if ($stateParams.cow_type === 'wallet') {
          $scope.cowEventTypesList = $scope.cowEventTypeWallet;
          $scope.cow.cow_type = $scope.cowEventTypeWallet[0].slug;
        }
        if ($stateParams.cow_type === 'group') {
          $scope.cowEventTypesList = cowEventTypes;
          $scope.cow.cow_type = cowEventTypes[0].slug;
        }
      }


      //Functions
      //CLICK CATEGORY
      $scope.clickCategory = function (option) {
        $scope.cow.category = option;

        if (cowEventTypes.length > 0 && option === 'group') {
          $scope.cowEventTypesList = cowEventTypes;
          $scope.cow.cow_type = cowEventTypes[0].slug;
        }

        if (option === 'wallet') {
          $scope.cowEventTypesList = $scope.cowEventTypeWallet;
          $scope.cow.cow_type = $scope.cowEventTypeWallet[0].slug;
        }


        if (option !== 'crowdfunding') {
          $scope.cow.is_public = false;
        }

        if (option === 'crowdfunding') {
          $scope.cow.cow_type = 'fundacion'
        }

        var element = null;
        if ($window.innerWidth <= 767.98) {
          element = document.getElementsByClassName('new-cow-create-selector-widget-option')[2];
          smoothScroll(element);
        } else {
          element = document.getElementsByClassName('new-cow-create-title')[0];
          smoothScroll(element, {offset: 20});
        }

      };
      // CHANGE SELECT COW TYPE
      $scope.cowEventTypeChanged = function (slug) {
        if (slug === 'cobrar-negocio') {
          $scope.cow.plan = 'pro';
        }
      };

      // CLICK CREATE COW
      $scope.createCowEvent = function () {
        $scope.create_cow_button_submit = true;
        var str = $scope.cow.name;
        str = str.replace(new RegExp($scope.ranges.join('|'), 'g'), '');
        $scope.cow.name = str;
        if ($scope.cow.name === undefined || !$scope.cow.name || $scope.cow.name === '') {
          var element = document.getElementsByClassName('new-cow-create-selector-widget-option')[2];
          smoothScroll(element);
        } else {
          ngDialog.open({
            template: 'confirmCowCreationDialog',
            scope: $scope
          });
        }
      };

      //CONFIRM COW
      $scope.confirmCreateCow = function () {
        ngDialog.close();

        cowEventService.createNewCowEvent(JSON.stringify($scope.cow)).then(function (data) {
          var cowId = data.data.cow_id;
          $rootScope.scrapeFbCowEvent(cowId);
          if ($rootScope.isLogged) {
            $analytics.eventTrack('cow-created-user', {category: 'cow-created-user', value: 1});
            $state.go('cow-admin', {
              cowId: cowId
            });
          } else {
            $analytics.eventTrack('cow-created-temp', {category: 'cow-created-temp', value: 1});
            $state.go('cow-temp', {
              cowId: cowId
            });
          }
        }, function (err) {
          console.log('err login', err);
          toastr.error('Si el error persiste, comunicate con nosotros.', 'Error creando la Vaca');
        });

      }
      $scope.paste = function (e) {
        e.preventDefault();
        return false
      }

    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-create-legacy', {
          url: '/crear-vaca-online-legacy?cow_name&cow_type&participation_type&participant_value&is_public',
          templateUrl: 'app/views/cowCreate/cowCreate.html',
          controller: 'CowCreateControllerLegacy',
          controllerAs: 'cow-create-legacy',
          resolve: {
            cowEventTypes: function (cowEventService) {
              return cowEventService.getCowEventTypes();
            },
            matrixCommissions: function (paymentService) {
              return paymentService.getMatrixComissionsList();
            }
          },
          data: {
            'meta': {
              'title': 'Armatuvaca | Recolecta dinero en grupo Online',
              'description': 'Armatuvaca para la próxima reunión o evento. Realiza una colecta para lo que quieras, un regalo, un viaje o un cumpleaños. Invita a tus amigos a un proyecto de Crowdfunding. Recolecta dinero por medios electrónicos. Recauda fondos o cobra dinero a un amigo. Ahora la Vaca se hace Online.',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CowCreateControllerLegacy', function ($scope, $state, $rootScope, $window, usersService, ngDialog, $stateParams,
                                                 cowEventTypes, cowEventService, toastr, $analytics, matrixCommissions,
                                                 businessCowTypeSlug, socialBusinessCowTypeSlug, businessCowPercentageFee) {

      // $analytics.pageTrack('/cow-create');
      // $analytics.pageTrack('/crear-vaca-online');

      //$window.fbq('trackCustom', 'EntraCrearVaca');

      $scope.matrixCommissions = matrixCommissions;

      $scope.cow = {};
      $scope.cowEventTypesList = cowEventTypes;

      $scope.businessCowTypeSlug = businessCowTypeSlug;
      $scope.socialBusinessCowTypeSlug = socialBusinessCowTypeSlug;

      usersService.getUserData().then(function (data) {
        $scope.user = data.user;
        $scope.cow.made_by = $scope.user.user.first_name + ' ' + $scope.user.user.last_name;
      }, function (err) {
      });

      if ($stateParams.cow_name != undefined) {
        $scope.cow.name = $stateParams.cow_name;
      }

      if ($stateParams.commission_added == 'true') {
        $scope.cow.commission_added = true;
        $scope.cow.commission_deducted = false;
      } else if ($stateParams.commission_deducted == 'true') {
        $scope.cow.commission_deducted = true;
        $scope.cow.commission_added = false;
      } else {
        $scope.cow.commission_added = true;
        $scope.cow.commission_deducted = false;
      }

      $scope.is_public = $stateParams.is_public === 'true';

      $scope.cowEventTypeChanged = function (typeString) {
        $scope.cow_type = typeString;
        $scope.main_img_raw = $scope.cow_type.example_img;
        $scope.cowType = $scope.cow_type.id;
        $scope.cowTypeSlug = $scope.cow_type.slug;
      };

      if ($stateParams.cow_type !== undefined) {
        $scope.cowTypeParam = $stateParams.cow_type;
        var cowType = _.find($scope.cowEventTypesList, {
          'slug': $scope.cowTypeParam
        });
        $scope.cowTypeString = cowType;
        if ($scope.cowTypeString === undefined){
          cowType = _.first($scope.cowEventTypesList);
          $scope.cowTypeString = cowType;
        }
        $scope.cowEventTypeChanged(cowType);
      } else {
        cowType = _.first($scope.cowEventTypesList);
        $scope.cowTypeString = cowType;
        $scope.cowEventTypeChanged(cowType);
      }

      if ($scope.is_public) {
        var cowType = _.find($scope.cowEventTypesList, {
          'slug': socialBusinessCowTypeSlug
        });
        $scope.cowTypeString = cowType;
        if ($scope.cowTypeString === undefined){
          cowType = _.first($scope.cowEventTypesList);
          $scope.cowTypeString = cowType;
        }
        $scope.cowEventTypeChanged(cowType);
      }

      $scope.checkCommissionsToMatrix = function () {
        var commTemp = _.find($scope.matrixCommissions, function (o) {
          return o.min_value <= $scope.participant_value_example && o.max_value > $scope.participant_value_example;
        });
        if (commTemp) {
          $scope.commissionObj = commTemp;
        }
      };

      $scope.calculateCommissions = function () {
        if ($scope.commissionObj.fixed) {
          if ($scope.cow.commission_added) {
            $scope.participant_pay_example = $scope.participant_value_example + $scope.commissionObj.fixed_value;
            $scope.received_value_example = $scope.participant_value_example;
          } else if ($scope.cow.commission_deducted) {
            $scope.participant_pay_example = $scope.participant_value_example;
            $scope.received_value_example = $scope.participant_value_example - $scope.commissionObj.fixed_value;
          }
        } else if ($scope.commissionObj.percentage) {
          if ($scope.cow.commission_added) {
            $scope.participant_pay_example = $scope.participant_value_example * (1 + $scope.commissionObj.percentage_value);
            $scope.received_value_example = $scope.participant_value_example;
          } else if ($scope.cow.commission_deducted) {
            $scope.participant_pay_example = $scope.participant_value_example;
            $scope.received_value_example = $scope.participant_value_example * (1 - $scope.commissionObj.percentage_value);
          }
        }
      };

      $scope.setParticipationValueExample = function (value) {
        if (!value || value < $scope.minPaymentValue) {
          $scope.participant_value_example = 20000;
        } else {
          $scope.participant_value_example = value;
        }

        $scope.checkCommissionsToMatrix();
        $scope.calculateCommissions();
      };

      $scope.selectParticipationFree = function () {
        $scope.cow.participation_free = true;
        $scope.cow.participation_suggested = false;
        $scope.cow.participation_fixed = false;
        $scope.cow.participant_value_suggested = undefined;
        $scope.cow.participant_value_fixed = undefined;
        $scope.setParticipationValueExample();
      };

      $scope.selectParticipationSuggested = function () {
        $scope.cow.participation_suggested = true;
        $scope.cow.participation_free = false;
        $scope.cow.participation_fixed = false;
        $scope.cow.participant_value_fixed = undefined;
      };

      $scope.selectParticipationFixed = function () {
        $scope.cow.participation_fixed = true;
        $scope.cow.participation_free = false;
        $scope.cow.participation_suggested = false;
        $scope.cow.participant_value_suggested = undefined;
      };

      $scope.selectParticipationSuggestedFocus = function () {
        $scope.cow.participation_suggested = true;
        $scope.cow.participation_free = false;
        $scope.cow.participation_fixed = false;
        $scope.cow.participant_value_fixed = undefined;
      };

      $scope.selectParticipationFixedFocus = function () {
        $scope.cow.participation_fixed = true;
        $scope.cow.participation_free = false;
        $scope.cow.participation_suggested = false;
        $scope.cow.participant_value_suggested = undefined;
      };

      if ($stateParams.participation_type != undefined && $stateParams.participant_value != undefined) {
        if ($stateParams.participation_type == 2) {
          $scope.cow.participant_value_suggested = parseInt($stateParams.participant_value);
          $scope.cow.participation_suggested = true;
          $scope.selectParticipationSuggested();
        } else if ($stateParams.participation_type == 3) {
          $scope.cow.participant_value_fixed = parseInt($stateParams.participant_value);
          $scope.cow.participation_fixed = true;
          $scope.selectParticipationFixed();
        } else {
          $scope.cow.participation_free = true;
          $scope.selectParticipationFree();
        }
      } else {
        $scope.cow.participation_free = true;
        $scope.selectParticipationFree();
      }

      $scope.commisionAddedChanged = function () {
        $scope.cow.commission_deducted = !$scope.cow.commission_added;
        $scope.calculateCommissions();
      };

      $scope.commisionDeductedChanged = function () {
        $scope.cow.commission_added = !$scope.cow.commission_deducted;
        $scope.calculateCommissions();
      };

      $scope.createCow = function (isValid) {
        if ($scope.cow.participation_suggested && $scope.cow.participant_value_suggested < $scope.minPaymentValue) {
          toastr.info('El monto sugerido debe ser mayor', 'Vaca incompleta');
        } else if ($scope.cow.participation_suggested && $scope.cow.participant_value_suggested > $scope.maxPaymentValue) {
          toastr.info('El monto sugerido debe ser menor', 'Vaca incompleta');
        } else if ($scope.cow.participation_fixed && $scope.cow.participant_value_fixed < $scope.minPaymentValue) {
          toastr.info('El monto fijo debe ser mayor', 'Vaca incompleta');
        } else if ($scope.cow.participation_fixed && $scope.cow.participant_value_fixed > $scope.maxPaymentValue) {
          toastr.info('El monto fijo debe ser menor', 'Vaca incompleta');
        } else if (!$scope.cow.participation_free && !$scope.cow.participation_suggested && !$scope.cow.participation_fixed) {
          toastr.info('Elige el tipo de participación', 'Vaca incompleta');
        } else if (isValid) {

          if ($scope.is_public) {
            $scope.openIsPublicDialog();
          } else if ($scope.cowTypeSlug === businessCowTypeSlug || $scope.cowTypeSlug === socialBusinessCowTypeSlug) {
            $scope.openAcceptFeeDialog();
          } else {
            $scope.openConfirmCowCreationDialog();
          }

        } else {
          toastr.info('Por favor revisa los campos obligatorios', 'Vaca incompleta');
        }
      };

      $scope.giftCodeInputVisible = false;
      $scope.showGiftCodeInput = function () {
        $scope.giftCodeInputVisible = !$scope.giftCodeInputVisible;
      };

      $scope.applyCoupon = function () {
        if ($scope.gift_code === '' || $scope.gift_code === undefined) {
          toastr.info('Debes ingresar un código promocional válido');
        } else {
          var data_gift_code = {
            gift_code: $scope.gift_code
          };
          cowEventService.validateGiftCode(data_gift_code).then(function (data) {

            if (data.payment_gift_code) {
              toastr.error('Este código debe ser utilizado por los participantes al momento de hacer su contribución');
            } else {
              $scope.gift_code_obj = data;
              $scope.gift_code_valid = $scope.gift_code_obj.valid;
              toastr.success('Código aplicado con éxito');
            }
          }, function (err) {
            console.log('err login', err);
            toastr.error('El código ya se ha vencido o se encuentra mal escrito');
          });
        }
      };

      $scope.openConfirmCowCreationDialog = function () {
        ngDialog.open({
          template: 'confirmCowCreationDialog',
          scope: $scope
        });
      };
      $scope.acceptConfirmationDialog = function (closeId) {
        ngDialog.close(closeId);
        $scope.confirmCreateCow();
      };

      $scope.openAcceptFeeDialog = function () {
        ngDialog.open({
          template: 'askCowFeeDialog',
          scope: $scope
        });
      };
      // $scope.acceptCowFee = function (closeId) {
      //   ngDialog.close(closeId);
      //   $scope.confirmCreateCow();
      // };

      $scope.confirmCreateCow = function () {
        if ($scope.cowTypeSlug === businessCowTypeSlug || $scope.cowTypeSlug === socialBusinessCowTypeSlug) {
          $scope.cow.is_business = true;
          $scope.cow.cashout_commission_percentage = true;
          $scope.cow.cashout_commission_value = businessCowPercentageFee;
        }

        $scope.cow_temp = JSON.parse(JSON.stringify($scope.cow));

        if ($scope.main_img_raw.includes('https://armatuvacacom.s3.')) {
          $scope.main_img_raw_temp = $scope.main_img_raw.replace("https://armatuvacacom.s3.amazonaws.com/", "");
        } else {
          $scope.main_img_raw_temp = $scope.main_img_raw_file;
        }

        if ($scope.gift_code_valid) {
          $scope.cow_temp.gift_code_id = $scope.gift_code_obj.id;
        }

        if ($rootScope.isLogged) {
          $scope.cow_temp.temp = false;
          $scope.cow_temp = JSON.stringify($scope.cow_temp);
          cowEventService.createCowEvent($scope.cow_temp, $scope.cowType, $scope.user.id, $scope.main_img_raw_temp, $scope.main_img_raw_temp, $scope.is_public).then(function (data) {
            if (data.data.valid === false && data.data.blacklist === true) {
              toastr.error('Hubo un problema validando tus datos, contáctate con nosotros', 'Error de validación')
            } else {
              $analytics.eventTrack('cow-created-user', {category: 'cow-created-user', value: 1});
              var cowId = data.data.cow_id;
              $rootScope.scrapeFbCowEvent(cowId);
              $state.go('cow-admin', {
                cowId: cowId
              });
            }
          }, function (err) {
            console.log('err login', err);
            toastr.error('Si el error persiste, comunicate con nosotros.', 'Error creando la Vaca');
          });
        } else {
          $scope.cow_temp.temp = true;
          $scope.cow_temp = JSON.stringify($scope.cow_temp);
          cowEventService.createCowEventTemp($scope.cow_temp, $scope.cowType, $scope.main_img_raw_temp, $scope.main_img_raw_temp).then(function (data) {
            $analytics.eventTrack('cow-created-temp', {category: 'cow-created-temp', value: 1});
            var cowId = data.data.cow_id;
            $rootScope.scrapeFbCowEvent(cowId);
            $state.go('cow-temp', {
              cowId: cowId
            });
          }, function (err) {
            console.log('err login', err);
            toastr.error('Si el error persiste, comunicate con nosotros.', 'Error creando la Vaca');
          });
        }
      };

      $scope.openIsPublicDialog = function () {
        ngDialog.open({
          template: 'confirmIsPubliCow',
          scope: $scope
        });
      };
      // $scope.acceptPublicCow = function (closeId) {
      //   ngDialog.close(closeId);
      //   $scope.confirmCreateCow();
      // };
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-contact-me', {
          url: '/contactame/:cowId',
          templateUrl: 'app/views/cowContactMe/cowContactMe.html',
          controller: 'CowContactMeController',
          controllerAs: 'cow-contact-me',
          resolve: {
            user: function (usersService) {
              return usersService.getUserData();
            },
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCow(cowId);
            }
          },
          data: {
            'meta': {
              'title': 'Contactame',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CowContactMeController', function ($scope, $state, $rootScope, usersService, $stateParams, cowId,
                                                    $log, cow, toastr, cowEventService, user, ngDialog) {

      console.log('cow contact me');
      $rootScope.loginAllowed();

      if (cow.deleted) {
        $state.go('cow-deleted', {cowId: cowId});
      }

      console.log(cow);
      console.log(user);
      $scope.cow = cow;
      $scope.user = user.user;

      $scope.goToAdmin = function () {
        $state.go('cow-admin', {
          cowId: cowId
        }, {
          reload: true
        });
      };


      if ($scope.cow.contact_me_list !== null && $scope.cow.contact_me_list !== '') {
        $scope.contacts = JSON.parse($scope.cow.contact_me_list);
      }
      else {
        $scope.contacts = [];
      }

      $scope.friendsContactsEdited = false;
      $scope.addContact = function (isValid) {
        console.log(isValid);
        if (isValid) {
          $scope.friendsContactsEdited = true;
          var contact_temp = {
            name: $scope.contact.name,
            tel: $scope.contact.tel
          };

          $scope.contacts.push(contact_temp);
          $scope.contactsForm.$setPristine();

          $scope.contact = {};
        }
      };

      $scope.deleteContact = function (index) {
        $scope.contacts.splice(index, 1);
        $scope.friendsContactsEdited = true;
      };


      $scope.saveCowEventContactMe = function () {
        var data = {
          cow_event_id: $scope.cow.cow_event_id,
          contact_me_via_wapp: $scope.cow.contact_me_via_wapp,
          contact_me_list: JSON.stringify($scope.contacts),
          friends_contacts_edited: $scope.friendsContactsEdited
        };
        cowEventService.saveCowEventContactMe(data).then(function (dataResp) {
          ngDialog.open({
            template: 'contactRefreshConfirmModal',
            data: {
              cowId: cowId
            },
            controller: 'ContactRefreshConfirmModalCtrl',
            trapFocus: false
          })
        }, function (err) {
          toastr.error('Si el error persiste, comunicate con nosotros.', 'Error actualizando la Vaca');
        });
      };

      $scope.submitUserCellphone = function (valid) {
        console.log(valid);
        if (valid) {
          console.log($scope.cellphoneContactMe);
          usersService.updateCellphone($scope.cellphoneContactMe, $scope.cow.cow_event_id).then(function () {
            toastr.success("¡Número celular agregado con éxito!");
          }, function (err) {
            if (err.status == 409) {
              toastr.error("Este número celular ya se encuentra asociado a otra cuenta");
            }
            else {
              toastr.error("Se presentó un error actualizando tus datos, inténtalo mas tarde");
            }

          });
        }
      };


    })
    .controller('ContactRefreshConfirmModalCtrl', function ($scope, $state, ngDialog) {
      $scope.continueEdit = function () {
        ngDialog.close()
      };
      $scope.goToCow = function (cowId) {
        ngDialog.close()
        $state.go('cow-admin', {
          cowId: cowId
        }, {
          reload: true
        });
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow-admin', {
          url: '/administrar-vaca/:cowId',
          templateUrl: 'app/views/cowAdmin/cowAdmin.html',
          controller: 'CowAdminController',
          controllerAs: 'cow-admin',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCow(cowId);
            }
          },
          data: {
            'meta': {
              'title': 'Administrador',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CowAdminController', function ($scope, $state, $rootScope, usersService, $stateParams,
      cowId, $log, cow, toastr, atvURL, cowPublicURL, bankService,
      fbAPI, cowEventService, ngDialog, GAuth, paymentService, ivaAtvTax,
      cowBusinessTypePolitical, highValueCowValue, fileSizeImage,
      pricingPlanPro, pricingPlanFree, businessCowPercentageFee) {

      // $rootScope.loginAllowed();

      if (cow.is_business === true && cow.business_type === 2) {
        $state.go('fep-cow-admin', { cowId: cowId }, { reload: true });
      }
      $scope.ivaAtvTax = ivaAtvTax;
      $scope.cowBusinessTypePolitical = cowBusinessTypePolitical;
      //$scope.max_length_description_cow = 2000;
      $scope.isExpand = true;

      $scope.requestUserDocumentNumber = function () {
        ngDialog.open({
          template: 'noDocumentAlert',
          scope: $scope,
          showClose: false,
          closeByEscape: false,
          closeByNavigation: true,
          closeByDocument: false
        });
      };
      
      $scope.requestUserCellphone = function (user, cowId) {
        ngDialog.open({
          template: 'requestCellphoneModal',
          data: {
            user: user,
            cowId: cowId
          },
          controller: 'RequestCellphoneModalCtrl'
        });
      };

      $scope.checkUserAdmin = function () {
        if (cow.deleted) {
          $state.go('cow-deleted', {
            cowId: cowId
          });
        } else {
          usersService.getUserData().then(function (data) {
            if (data.user.id != cow.user) {
              $state.go('cow', {
                cowId: cowId
              });
            } else if (data.user.document_number == null) {
              $scope.requestUserDocumentNumber()
            } else if (data.user.cellphone == null) {
              $scope.requestUserCellphone(data.user, cowId);
            }
            $scope.adminUser = true;
          }, function (err) {
            $scope.adminUser = false;
            console.log('no login');
          });
        }
      };

      $scope.checkUserAdmin();

      $scope.acceptNoDocumentAlert = function (closeId) {
        $state.go('account');
        ngDialog.close(closeId);
      };

      $scope.cow_event = cow;

      $scope.length_cow_event_description = jQuery($scope.cow_event.description).text().length

      $scope.request_public = $scope.cow_event.request_public === null;
      $scope.cowIsPlanPro = $scope.cow_event.pricing_plan === null || $scope.cow_event.pricing_plan.slug !== pricingPlanFree;

      $scope.cowclosed = cow.closed;
      $scope.cowclosed_moneyrequest = cow.closed_money_request;

      $scope.cowCashinCommission = 0;
      if ($scope.cow_event.is_business) {
        _.forEach($scope.cow_event.participations_data, function (value) {
          $scope.cowCashinCommission += value.commission_value_organizer;
        });
      }

      var eventDate = new Date($scope.cow_event.event_date);
      $scope.eventDateString = eventDate.getDate() + "/" + (eventDate.getMonth() + 1) + "/" + eventDate.getFullYear();


      if ($scope.cow_event.marketplace) {
        $scope.classMp = 'admin-marketplace-buttons';
      } else {
        $scope.classMp = '';
      }

      $scope.cowPublicURLComplete = atvURL + cowPublicURL + cowId;
      $scope.cowPublicURLCompleteCopy = atvURL + cowPublicURL + cowId;

      $scope.showCowMainImage = true;
      $scope.showCowMainImageEdit = false;

      $scope.showCowDescription = true;
      $scope.showCowDescriptionEdit = false;

      $scope.main_img_raw = $scope.cow_event.main_img_raw;

      if ($scope.cow_event.description != null && $scope.cow_event.description !== '') {
        $scope.cowNewdescription = $scope.cow_event.description;
      }

      $scope.checkCowTotalValue = function () {

        if (($scope.cow_event.total_value >= highValueCowValue) && $scope.cow_event.pricing_plan === null) {
          toastr.info('Recuerda que si recibes $2.000.000 o más en tu Vaca, se aplicará un cobro al retirar tu dinero',
            'Tarifas',
            { timeOut: 30000, extendedTimeOut: 30000, closeButton: true, preventDuplicates: true, progressBar: false })
        }
      };
      $scope.checkCowTotalValue();

      $scope.goToResend = function () {
        if ($scope.cow_event.closed) {
          toastr.info('No puedes enviar recordatorios para una Vaca cerrada', 'Vaca cerrada');
        } else {
          $state.go('cow-resend', {
            cowId: cowId
          }, {
            reload: true
          });
        }
      };

      $scope.goToThanks = function () {
        $state.go('cow-thanks', {
          cowId: cowId
        }, {
          reload: true
        });
      };

      $scope.goToMembershipCard = function () {
        $state.go('membership-card-cow', {
          cowId: cowId
        }, {
          reload: true
        });
      };

      $scope.contactList = function () {
        cowEventService.getCowEventGuestList(cowId).then(function (data) {
          ngDialog.open({
            template: 'contactListModal-1',
            data: {
              guestList: data,
              cowId: cowId
            },
            controller: 'ContactListModalCtrl'
          });
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de obtener la lista de invitados');
        });
      };

      $scope.showDescriptionEdit = function () {
        $scope.showCowDescription = false;
        $scope.showCowDescriptionEdit = true;
      };

      $scope.showMainImageEdit = function () {
        $scope.showCowMainImage = false;
        $scope.showCowMainImageEdit = true;
      };

      $scope.saveCowDescription = function () {
        if ($scope.cowNewdescription != null) {
          var cowTempData = {};
          cowTempData.id = $scope.cow_event.cow_event_id;
          cowTempData.description = $scope.cowNewdescription;
          cowEventService.cowEventPartialUpdate(cowTempData).then(function (data) {
            $scope.cow_event = data;
            toastr.success('¡Actualización exitosa!');
            $scope.closeCowDescriptionEdit();
          }, function (err) {
            toastr.error('Si el error persiste, comunicate con nosotros.', 'Error actualizando la descripción');
          });
        }
      };

      $scope.closeCowDescriptionEdit = function () {
        $scope.showCowDescription = true;
        $scope.showCowDescriptionEdit = false;
      };

      $scope.closeCowImageEdit = function () {
        $scope.showCowMainImage = true;
        $scope.showCowMainImageEdit = false;
      };

      $scope.clickChangeImageHeader = function () {
        angular.element('#fileInput').trigger('click');
      };

      var handleFileSelect = function (evt) {
        var file = evt.currentTarget.files[0];
        if (file.size <= fileSizeImage) {
          var reader = new FileReader();
          reader.onload = function (evt) {
            $scope.$apply(function ($scope) {
              $scope.main_img_raw = evt.target.result;
              toastr.success("Imagen cargada correctamente");
            });
          };
          reader.readAsDataURL(file);
        } else {
          toastr.error('El tamaño de la imagen es superior a ' + (fileSizeImage / 1000000) + 'MB');
        }
      };
      angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);


      $scope.saveCowMainImage = function () {
        if ($scope.main_img_raw.includes('https://armatuvaca.s3.')) {
          $scope.main_img_raw_temp = $scope.main_img_raw.replace("https://armatuvaca.s3.amazonaws.com/", "");
        } else {
          $scope.main_img_raw_temp = $scope.main_img_raw_file;
        }

        $scope.blob_main_img.name = 'radom.' + $scope.blob_main_img.type.replace("image/", "");

        var cowTempData = {};
        cowTempData.cow_event_id = $scope.cow_event.cow_event_id;
        cowTempData.participation_free = $scope.cow_event.participation_free;
        cowTempData.participation_suggested = $scope.cow_event.participation_suggested;
        cowTempData.participation_fixed = $scope.cow_event.participation_fixed;
        cowTempData.show_location_point = $scope.cow_event.show_location_point;
        cowTempData.commission_added = $scope.cow_event.commission_added;
        cowTempData.commission_deducted = $scope.cow_event.commission_deducted;
        cowTempData.hide_participants_identity = $scope.cow_event.hide_participants_identity;
        cowTempData.hide_total_amount = $scope.cow_event.hide_total_amount;
        cowTempData.not_allow_messages_to_owner = $scope.cow_event.not_allow_messages_to_owner;
        cowTempData.open_invitations = $scope.cow_event.open_invitations;
        cowTempData.hide_comments_wall = $scope.cow_event.hide_comments_wall;
        cowTempData.no_notifications_email = $scope.cow_event.no_notifications_email;
        cowTempData.no_notifications_sms = $scope.cow_event.no_notifications_sms;

        cowTempData.main_img = $scope.blob_main_img;
        cowTempData.main_img_raw = $scope.main_img_raw_file;

        cowEventService.editCowEvent(cowTempData).then(function (data) {
          $rootScope.scrapeFbCowEvent(cowId);
          $state.reload();
          toastr.success('Actualización exitosa!');
        }, function (err) {
          console.log('err login', err);
          toastr.error('Si el error persiste, comunicate con nosotros.', 'Error actualizando la Vaca');
        });
      };

      $scope.goToPublicCow = function () {
        $state.go('cow', {
          cowId: cowId
        });
      };

      $scope.loginUser = function (isValid) {
        if (isValid) {
          usersService.login($scope.user.email,
            $scope.user.password
          ).then(function (data) {
            $state.reload();
          }, function (err) {
            $scope.errorSended = true;
            $scope.errorMessage = "Usuario y/o contraseña incorrectos";
          });
        }
      };

      $scope.loginFb = function () {
        var send_welcome_email = true;
        usersService.loginFb(send_welcome_email).then(function (data) {
          $state.reload();
        }, function (err) {
          $rootScope.errorSended = true;
          $scope.errorMessage = "Usuario y/o contraseña incorrectos";
        });
      };

      $scope.loginGg = function () {
        var send_welcome_email = true;
        GAuth.login().then(function (user) {
          GAuth.getToken().then(function (token_response) {
            usersService.loginGg(token_response.access_token, send_welcome_email).then(function (data) {
              $state.reload();
            }, function (err) {
              $rootScope.errorSended = true;
              $scope.errorMessage = "Usuario y/o contraseña incorrectos";
            });
          }, function () {
            console.log('token error');
          });
        }, function () {
          console.log('login fail');
        });
      };

      $scope.modalParticipants = function (contacts) {
        paymentService.getCowEventParticipantsOrganizerList(cowId).then(function (data) {
          console.log(data);
          ngDialog.open({
            template: 'participantsModal-1',
            data: {
              cow: $scope.cow_event,
              participants: data
            }
          });
        },
          function (err) {
            toastr.error('Error obteniendo los participantes');
          });
      };

      if ($scope.cow_event.show_location_point) {
        $scope.map = {
          center: {
            latitude: $scope.cow_event.location_point.latitude,
            longitude: $scope.cow_event.location_point.longitude
          },
          zoom: 16
        };
        $scope.marker = {
          id: 0,
          coords: {
            latitude: $scope.cow_event.location_point.latitude,
            longitude: $scope.cow_event.location_point.longitude
          },
          options: {
            draggable: false,
            icon: 'assets/images/map-pin.png'
          }
        };
      }

      $scope.openAdminOptions = function () {
        ngDialog.open({
          template: 'adminOptionsModal',
          data: {
            cowId: cowId,
            cowClosed: $scope.cow_event.closed,
            cowMandatoryClosed: $scope.cow_event.closed_money_request || $scope.cow_event.closed_admin,
            cowPublic: $scope.cow_event.is_public,
            cowIsPlanPro: $scope.cowIsPlanPro
          },
          controller: 'AdminOptionsModalCtrl'
        });
      };

      $scope.upgradeCowToPro = function () {
        ngDialog.close();

        ngDialog.open({
          template: 'confirmCowToProModal',
          data: { cow_event_id: $scope.cow_event.cow_event_id },
          controller: 'upgradeCowToProCtrl'
        });
      };
      $scope.goToInvite = function () {

        $state.go('cow-invite', {
          cowId: cowId
        }, {
          reload: true
        });
      };


      $scope.downloadParticipantsList = function () {

        if ($scope.cowIsPlanPro) {
          cowEventService.downloadParticipantsList(cowId).then(function (data) {
            var hiddenElement = document.createElement('a');
            hiddenElement.href = data.data.file_list;
            hiddenElement.download = 'Lista de participantes.xlsx';
            document.body.appendChild(hiddenElement);
            hiddenElement.click();
            document.body.removeChild(hiddenElement);
          }, function (err) {
            console.log('err login', err);
            toastr.error('Error generando el archivo');
          });
        } else {
          ngDialog.open({
            template: 'upgradeCowToProModal',
            data: { cow_event_id: cowId },
            controller: 'upgradeCowToProCtrl'
          });
        }
      };

      $scope.goToEdit = function () {

        if ($scope.cowIsPlanPro) {
          $state.go('cow-edit', {
            cowId: cowId
          }, {
            reload: true
          });
        } else {
          ngDialog.open({
            template: 'upgradeCowToProModal',
            data: { cow_event_id: cowId },
            controller: 'upgradeCowToProCtrl'
          });
        }
      };

      $scope.openCloseCowEventModal = function () {

        ngDialog.open({
          template: 'confirmationCloseCowEventModal-1',
          data: {
            cowId: cowId
          },
          controller: 'CloseCowEventModalCtrl'
        });
      };

      $scope.openReopenCowEventModal = function () {
        if ($scope.cow_event.closed_money_request || $scope.cow_event.closed_admin) {
          ngDialog.open({
            template: 'notAllowReOpenCowModal-1',
            data: {},
            controller: 'NotAllowReOpenCowModalCtrl'
          });
        } else {
          ngDialog.open({
            template: 'confirmationReopenCowEventModal-1',
            data: {
              cowId: cowId
            },
            controller: 'ReopenCowEventModalCtrl'
          });
        }
      };

      $scope.openRequestPublicCowEventModal = function (cowId) {
        ngDialog.close();
        if ($scope.request_public) {
          ngDialog.open({
            template: 'confirmationRequestPublicCow-1',
            data: {
              cowId: cowId
            },
            controller: 'RequestCowPublicEventModalCtrl'
          });
        } else {
          toastr.error('Ya se envió solicitud para que esta Vaca haga parte de Vacanes');

        }
      };

      $scope.upgradeCow = function (cowEventId) {
        if (!$scope.cowIsPlanPro) {
          $scope.upgradeCowToPro();
        }
      }
      $scope.isExpandToggle = function(){
        $scope.isExpand = !$scope.isExpand;
      }

    })
    .controller('ContactListModalCtrl', function ($scope, ngDialog, cowEventService, toastr) {

      $scope.confirmationDg;
      $scope.deleteGuest = function (guest, cowId) {
        $scope.confirmationDg = ngDialog.open({
          template: 'confirmationModal-1',
          data: {
            guest: guest,
            cowId: cowId
          },
          controller: 'ContactListModalCtrl'
        });
      };

      $scope.closeSecond = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.confirmationDeleteGuest = function (guest, closeId, cowId) {

        cowEventService.deleteCowEventGuest(guest.id).then(function (data) {
          ngDialog.close();
          cowEventService.getCowEventGuestList(cowId).then(function (data) {
            ngDialog.open({
              template: 'contactListModal-1',
              data: {
                guestList: data,
                cowId: cowId
              },
              controller: 'ContactListModalCtrl'
            });
          }, function (err) {
            console.log('err login', err);
            toastr.error('Error tratando de obtener la lista de invitados');
          });
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de eliminar el contacto');
        });
      };
    })
    .controller('CloseCowEventModalCtrl', function ($scope, ngDialog, cowEventService, toastr, $state) {
      $scope.closeThird = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.confirmationCloseCowEvent = function (cowId) {
        console.log(cowId);
        var cowTempData = {};
        cowTempData.id = cowId;
        cowTempData.closed = true;
        cowEventService.cowEventPartialUpdate(cowTempData).then(function (data) {
          // $scope.cow_event = data;
          ngDialog.close();
          $state.reload();
          toastr.success('Vaca cerrada');
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de cerra la Vaca');
        });

      };
    })
    .controller('ReopenCowEventModalCtrl', function ($scope, ngDialog, cowEventService, toastr, $state) {
      $scope.closeFourth = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.confirmationReopenCowEvent = function (cowId) {
        console.log(cowId);
        var cowTempData = {};
        cowTempData.id = cowId;
        cowTempData.closed = false;
        cowEventService.cowEventPartialUpdate(cowTempData).then(function (data) {
          // $scope.cow_event = data;
          ngDialog.close();
          $state.reload();
          toastr.success('Vaca re-abierta');
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando re abriendo la Vaca');
        });
      };
    })
    .controller('NotAllowReOpenCowModalCtrl', function ($scope, ngDialog, cowEventService, toastr, $state) {
      $scope.closeFifth = function (closeId) {
        ngDialog.close(closeId);
      };
    })
    .controller('RequestCellphoneModalCtrl', function ($scope, ngDialog, cowEventService, toastr, $state, usersService) {

      $scope.submitUserCellphone = function (valid) {
        if (valid) {
          console.log($scope.user.cellphone);
          usersService.updateCellphone($scope.user.cellphone, $scope.ngDialogData.cowId).then(function () {
            toastr.success("¡Número celular agregado con éxito!");
            ngDialog.close();
          }, function (err) {
            if (err.status == 409) {
              toastr.error("Este número celular ya se encuentra asociado a otra cuenta");
            } else {
              toastr.error("Se presentó un error actualizando tus datos, inténtalo mas tarde");
              ngDialog.close();
            }
          });
        }
      };
    })
    .controller('AdminOptionsModalCtrl', function ($scope, $state, ngDialog, cowEventService, toastr) {
      $scope.goToEdit = function () {
        ngDialog.close();

        if ($scope.ngDialogData.cowIsPlanPro) {
          $state.go('cow-edit', {
            cowId: $scope.ngDialogData.cowId
          }, {
            reload: true
          });
        } else {
          ngDialog.open({
            template: 'upgradeCowToProModal',
            data: { cow_event_id: $scope.ngDialogData.cowId },
            controller: 'upgradeCowToProCtrl'
          });
        }
      };

      $scope.goToInvite = function () {
        ngDialog.close();

        $state.go('cow-invite', {
          cowId: $scope.ngDialogData.cowId
        }, {
          reload: true
        });
      };

      $scope.downloadParticipantsList = function () {
        ngDialog.close();

        if ($scope.ngDialogData.cowIsPlanPro) {
          cowEventService.downloadParticipantsList($scope.ngDialogData.cowId).then(function (data) {
            var hiddenElement = document.createElement('a');
            hiddenElement.href = data.data.file_list;
            hiddenElement.download = 'Lista de participantes.xlsx';
            document.body.appendChild(hiddenElement);
            hiddenElement.click();
            document.body.removeChild(hiddenElement);
          }, function (err) {
            console.log('err login', err);
            toastr.error('Error generando el archivo');
          });
        } else {
          ngDialog.open({
            template: 'upgradeCowToProModal',
            data: { cow_event_id: $scope.ngDialogData.cowId },
            controller: 'upgradeCowToProCtrl'
          });
        }
      };

      $scope.openCloseCowEventModal = function () {
        ngDialog.close();

        ngDialog.open({
          template: 'confirmationCloseCowEventModal-1',
          data: {
            cowId: $scope.ngDialogData.cowId
          },
          controller: 'CloseCowEventModalCtrl'
        });
      };

      $scope.openReopenCowEventModal = function () {
        ngDialog.close();
        console.log($scope.ngDialogData);

        if ($scope.ngDialogData.cowMandatoryClosed) {
          ngDialog.open({
            template: 'notAllowReOpenCowModal-1',
            data: {},
            controller: 'NotAllowReOpenCowModalCtrl'
          });
        } else {
          ngDialog.open({
            template: 'confirmationReopenCowEventModal-1',
            data: {
              cowId: $scope.ngDialogData.cowId
            },
            controller: 'ReopenCowEventModalCtrl'
          });
        }
      };
    })
    .controller('upgradeCowToProCtrl', function ($scope, $state, ngDialog, cowEventService, toastr, businessCowPercentageFee) {
      $scope.businessCowFee = (businessCowPercentageFee * 100).toFixed(2);

      $scope.closeUpgradeCowToProModal = function () {
        ngDialog.close();
      };

      $scope.acceptUpgradeCowToPro = function () {
        ngDialog.close();

        ngDialog.open({
          template: 'confirmCowToProModal',
          data: { cow_event_id: $scope.ngDialogData.cow_event_id },
          controller: 'upgradeCowToProCtrl'
        });
      };

      $scope.confirmUpgradeCowToPro = function () {
        ngDialog.close();

        cowEventService.upgradeCowPlan($scope.ngDialogData.cow_event_id).then(function (data) {
          toastr.success('El plan de tu Vaca se ha actualizado correctamente');
          $state.reload();
        }, function (err) {
          toastr.error('Error actualizando el plan de tu Vaca, inténtalo de nuevo');
        });
      }
    })
    .controller('RequestCowPublicEventModalCtrl', function ($scope, ngDialog, cowEventService, toastr, $state) {
      $scope.closeThird = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.confirmationRequestCowPublicEvent = function (cowId) {
        cowEventService.requestcowEventPublic(cowId).then(function (data) {
          // $scope.cow_event = data;
          ngDialog.close();
          $state.reload();
          toastr.success('Solicitud enviada');
        }, function (err) {
          toastr.error('Error enviando solicitud para Vacanes');
        });

      };
    });

})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cow', {
          url: '/vaca/:cowId',
          templateUrl: 'app/views/cow/cow.html',
          controller: 'CowController',
          controllerAs: 'cow-controller',
          resolve: {
            cowId: function ($stateParams) {
              return $stateParams.cowId;
            },
            cow: function (cowEventService, cowId) {
              return cowEventService.getCowPublic(cowId);
            },
            data: function (ngMeta, cow, atvURL, cowPublicURL, cowId, fbAPI) {

              var imgUrl = cow.main_img.substring(8);
              ngMeta.setTitle(cow.name);
              ngMeta.setTag('description', 'Armatuvaca online de forma fácil, rapida y segura.');
              ngMeta.setTag('og:url', atvURL + cowPublicURL + cowId);
              ngMeta.setTag('og:title', cow.name);
              ngMeta.setTag('og:type', 'website');
              ngMeta.setTag('og:description', 'Armatuvaca online de forma fácil, rapida y segura.');
              ngMeta.setTag('og:image', cow.main_img);
              ngMeta.setTag('fb:app_id', fbAPI);
              ngMeta.setTag('twitter:url', atvURL + cowPublicURL + cowId);
              ngMeta.setTag('twitter:title', cow.name);
              ngMeta.setTag('twitter:description', 'Armatuvaca online de forma fácil, rapida y segura.');
              ngMeta.setTag('twitter:image', cow.main_img);
              ngMeta.setTag('robots', 'noindex, nofollow');
            }
          },
          meta: {
            disableUpdate: true
          }
        })
    })
    .controller('CowController', function ($scope, $state, $rootScope, usersService, $stateParams,
                                           cowId, $log, cow, toastr, atvURL, cowPublicURL, ngDialog, paymentService,
                                           cowBusinessTypeFEP, cowBusinessTypePolitical, cowBusinessTypeCredibanco) {

      if (cow.deleted) {
        $state.go('cow-deleted', {
          cowId: cowId
        });
      }

      if (cow.is_business === true && cow.business_type === cowBusinessTypeFEP) {
        $state.go('fep-cow', {cowId: cowId}, {reload: true});
      }

      if (cow.is_business === true && cow.business_type === cowBusinessTypeCredibanco) {
        $state.go('credibanco-cow', {cowId: cowId}, {reload: true});
      }

      $scope.cow_event = cow;

      $scope.length_cow_event_description = jQuery($scope.cow_event.description).text().length

      $scope.cowclosed = cow.closed;

      $scope.cowCashinCommission = 0;
      if ($scope.cow_event.is_business) {
        _.forEach($scope.cow_event.participations_data, function (value) {
          $scope.cowCashinCommission += value.commission_value_organizer;
        });
      }

      var eventDate = new Date($scope.cow_event.event_date);
      $scope.eventDateString = eventDate.getDate() + "/" + (eventDate.getMonth() + 1) + "/" + eventDate.getFullYear();

      $scope.cowPublicURLComplete = atvURL + cowPublicURL + cowId;
      $scope.cowPublicURLCompleteCopy = atvURL + cowPublicURL + cowId;
      $scope.isExpand = true;


      $scope.modalParticipants = function (contacts) {
        paymentService.getCowEventParticipantsPublicList(cowId).then(function (data) {
            console.log(data);
            ngDialog.open({
              template: 'participantsModal-1',
              data: {
                cow: $scope.cow_event,
                participants: data
              }
            });
          },
          function (err) {
            toastr.error('Error obteniendo los participantes');
          });

      };
      $scope.goToInvite = function () {

        $state.go('cow-invite', {
          cowId: cowId
        }, {
          reload: true
        });
      };
      if ($scope.cow_event.show_location_point) {
        $scope.map = {
          center: {
            latitude: $scope.cow_event.location_point.latitude,
            longitude: $scope.cow_event.location_point.longitude
          },
          zoom: 16
        };
        $scope.marker = {
          id: 0,
          coords: {
            latitude: $scope.cow_event.location_point.latitude,
            longitude: $scope.cow_event.location_point.longitude
          },
          options: {
            draggable: false,
            icon: 'assets/images/map-pin.png'
          }
        };
      }


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('confirmation-email', {
          url: '/activar-cuenta/:token',
          templateUrl: 'app/views/confirmationEmail/confirmationEmail.html',
          controller: 'confirmationEmailController',
          controllerAs: 'confirmation-email',
          resolve: {
            token: function ($stateParams) {
              return $stateParams.token;
            },
          },
          data: {
            'meta': {
              'title': 'Validación de Correo',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('confirmationEmailController', function ($scope, $state, $rootScope, toastr, usersService, token) {
      $scope.token = token;
      $scope.validate_token_email = function(){
          usersService.validateTokenEmail($scope.token).then(function(data){
            toastr.success("Hemos valido tu correo con éxito");
            $state.go('login');
          },function(error){
            toastr.error("Este correo ya fue validado");
        });
      };
      $scope.validate_token_email();
    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('company', {
          url: '/mp/:slug',
          templateUrl: 'app/views/company/company.html',
          controller: 'CompanyController',
          controllerAs: 'company-controller',
          resolve: {
            slug: function ($stateParams) {
              return $stateParams.slug;
            },
            company: function (marketplaceService, slug) {
              return marketplaceService.getCompany(slug);
            },
            companyProducts: function (marketplaceService, slug) {
              return marketplaceService.getCompanyProducts(slug);
            }
          }
        })
    })
    .controller('CompanyController', function ($scope, $state, $rootScope, usersService, $stateParams, slug, company,
                                               cowEventService, toastr, $analytics, companyProducts) {

      console.log('empresa');
      console.log(slug);
      console.log(company);
      console.log(companyProducts);

      $scope.company = company;
      $scope.companyProducts = companyProducts;


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('cash-dashboard', {
          url: '/mi-dinero',
          templateUrl: 'app/views/cashDashboard/cashDashboard.html',
          controller: 'CashDashboardController',
          controllerAs: 'cash-dashboard',
          resolve: {
            userStats: function (usersService) {
              return usersService.getUserStats();
            },
            availableCowsCash: function (cowEventService) {
              return cowEventService.getAvailableCowsCash()
            },
            notifyAlert: function (AboutUsService) {
              return AboutUsService.getNotifyAlertsAdmin();
            },
            userInfo: function(usersService){
              return usersService.getUserData();
            }
          },
          data: {
            'meta': {
              'title': 'Mi Cuenta',
              'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('CashDashboardController', function ($scope, $state, $rootScope, $mdDialog, usersService, $stateParams, $log, cowEventService,
                                                     toastr, userStats, ngDialog, availableCowsCash, highValueCowPercentageFee, notifyAlert, userInfo) {

      $rootScope.loginAllowed();
      $scope.stats = userStats.user_stats;
      $scope.user = userInfo.user;

      if ($scope.user.document_number == null) {
        ngDialog.open({
          template: 'noDocumentAlert',
          scope: $scope,
          showClose: false,
          closeByEscape: false,
          closeByNavigation: true,
          closeByDocument: false
        });
      }
      $scope.acceptNoDocumentAlert = function (closeId) {
        $state.go('account');
        ngDialog.close(closeId);
      };

      $scope.notifyAlert = notifyAlert;

      $scope.validDocuments = false;

      if($scope.user.document_number != null && (($scope.user.document_image_front != null && $scope.user.document_image_back != null) || $scope.user.document_pdf != null)){
        $scope.validDocuments = true;
      }
      $scope.atv_brands_ads = [
        {
          id: 1,
          image: '\"/assets/images/fondo_banner_wenjoy.jpg\"',
          title: '¿Tienes un negocio? Conoce nuestra solución de recaudo online',
          brand_page_route: 'https://wenjoy.com.co',
          second_image: 'assets/images/movil.png'
        },
        {
          id: 2,
          image: '\"/assets/images/fep/fep_home_promo_image.png\"',
          title: '¿Quieres ir a ver a tu artista favorito? Conoce nuestras Alcancías',
          brand_page_route: 'https://alcancias.armatuvaca.com/',
          second_image: '/assets/images/fep/fep_ad_image.png'
        }
      ];

      if ($scope.notifyAlert.length > 0) {
        ngDialog.open({
          template: 'notifyAlertDialog',
          scope: $scope,
          showClose: false,
          closeByEscape: false,
          closeByNavigation: true,
          closeByDocument: false
        });
      }
      $scope.acceptNotifyAlert = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.showCowCashoutDialog = function () {
        if (availableCowsCash.length > 0) {
          $mdDialog.show({
            controller: ShowCowCashoutDialogController,
            templateUrl: 'app/views/cashDashboard/selectCowCashoutDialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            locals: {
              availableCowsCash: availableCowsCash,
              $state: $state
            }
          })
        } else {
          toastr.info('No hay Vacas disponibles para retirar dinero. Arma una Vaca para sacar dinero');
        }
      };

      $scope.showWalletCollectFriendCowDialog = function () {
        $mdDialog.show({
          controller: ShowWalletCollectFriendCowDialog,
          templateUrl: 'app/views/cashDashboard/createWalletCollectFriendCowDialog.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals: {
            $state: $state
          }
        })
      };

      function ShowCowCashoutDialogController($scope, $rootScope, $mdDialog, availableCowsCash) {
        $scope.availableCowsCash = availableCowsCash;
        $scope.cow_event_id = availableCowsCash[0].cow_event_id;
        $scope.goToCowGetMoney = function () {
          $rootScope.goToCowGetMoney($scope.cow_event_id);
          $mdDialog.hide();
        };
      }

      function ShowWalletCollectFriendCowDialog($scope, $rootScope, $mdDialog, $analytics, $state, cowEventService) {

        $scope.highValueCowFee = (highValueCowPercentageFee * 100).toFixed(2);

        $scope.create_form = {
          name: null,
          amount: 0,
          plan: 'free'
        };

        $scope.createWalletCow = function () {
          var cow = {
            "cow_type": "cobrar-amigos",
            "name": "Cobro a " + $scope.create_form.name,
            "plan": $scope.create_form.plan,
            "is_public": false,
            "category": "wallet",
            "cow_goal":  $scope.create_form.amount
          };
          cowEventService.createNewCowEvent(JSON.stringify(cow)).then(function (data) {
            var cowId = data.data.cow_id;
            $rootScope.scrapeFbCowEvent(cowId);
            $analytics.eventTrack('cow-created-user', {category: 'cow-created-user', value: 1});
            $state.go('cow-invite', {
              cowId: cowId
            });
            $mdDialog.hide();
          }, function (err) {
            console.log('err login', err);
            toastr.error('Si el error persiste, comunicate con nosotros.', 'Error creando la Vaca');
          });
        };


      }
    })
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('account', {
          url: '/mi-cuenta?currentTab',
          templateUrl: 'app/views/account/account.html',
          controller: 'AccountController',
          controllerAs: 'account',
          resolve: {
            user: function (usersService) {
              return usersService.getUserData();
            },
            contacts: function (usersService) {
              return usersService.getContactsUser();
            },
            bankAccounts: function (bankService) {
              return bankService.getUserBankAccountList();
            },
            userInvoices: function (paymentService) {
              return paymentService.getUserInvoicesList();
            },
            creditCards: function (paymentService) {
              return paymentService.getUserCreditCards();
            }
          },
          data: {
            'meta': {
              'title': 'Mi cuenta',
              'robots': 'noindex, nofollow'
            }
          },
          reloadOnSearch: true
        })
    })
    .controller('AccountController', function ($scope, $state, $rootScope, usersService, user, toastr, contacts, ngDialog,
                                               bankService, bankAccounts, $location, $mdDialog, userInvoices, atvURL, cowPublicURL,
                                               AboutUsService, creditCards, paymentService, fileSizeImage, fileSizePDF) {

      console.log('account');

      console.log(creditCards);

      $rootScope.loginAllowed();

      $scope.searchCows = '';

      $scope.userContacts = contacts;

      $scope.userInvoices = userInvoices;

      console.log(userInvoices);

      $scope.searchInvoices = '';

      $scope.creditCards = creditCards.credit_cards;

      $scope.cowPublicURL = atvURL + cowPublicURL;

      $scope.userBankAccounts = bankAccounts;
      var account_index = 1;
      _.forEach(bankAccounts, function (value) {
        if (!value.name) {
          value.name = "Cuenta " + account_index;
          account_index++;
        }
      });

      if ($state.params.currentTab) {
        $scope.tabSelected = $state.params.currentTab;
      }

      $scope.titleList = [
        'Mi perfil',
        'Mis tarjetas',
        'Mis cuentas bancarias',
        'Mis Participaciones',
        'Mis contactos'
      ];

      $scope.todayDate = new Date();
      $scope.maxDate = new Date(
        $scope.todayDate.getFullYear() - 18,
        $scope.todayDate.getMonth(),
        $scope.todayDate.getDate());

      $scope.accountUser = user.user;
      if ($scope.accountUser.born_date) {
        console.log($scope.accountUser.born_date);
        $scope.accountUser.born_date = $rootScope.parseDate($scope.accountUser.born_date);
        console.log($scope.accountUser.born_date);
      }
      if ($scope.accountUser.cellphone) {
        $scope.accountUser.cellphone = $scope.accountUser.cellphone.toString();
      }
      if ($scope.accountUser.document_type) {
        console.log($scope.accountUser.document_type);
        $scope.accountUser.document_type = $scope.accountUser.document_type.toString();
        console.log($scope.accountUser.document_type);
      }

      $scope.updateAccountUser = function () {
        usersService.retrieveUserData().then(function (data) {
          $scope.accountUser = data.user;
          if ($scope.accountUser.born_date) {
            $scope.accountUser.born_date = $rootScope.parseDate($scope.accountUser.born_date);
          }
        }, function (err) {

        });
      };

      $scope.setDocumentNumber = function () {
        if ($scope.accountUser.document_full_number) {
          $scope.accountUser.document_number = $scope.accountUser.document_full_number.replace(/[^0-9]/g, '');
        }
      };

      $scope.setDocumentFullNumber = function () {
        if ($scope.accountUser.document_number) {
          $scope.accountUser.document_full_number = $scope.accountUser.document_number;
        }
      };

      $scope.updateMyProfile = function (isValid) {
        if ($scope.accountUser.born_date && $scope.showDateError) {
          toastr.info('Por favor ingresa una fecha de nacimiento valida', 'Actualización incompleta');
        } else if (isValid) {
          usersService.updateMyProfile($scope.accountUser.user.first_name,
            $scope.accountUser.user.last_name,
            $scope.accountUser.born_date,
            $scope.accountUser.cellphone,
            $scope.accountUser.document_number,
            $scope.accountUser.document_type,
            $scope.accountUser.document_full_number
          ).then(function () {
            $state.reload();
            toastr.success("¡Cuenta actualizada!");
            console.log('updated');
          }, function (err) {
            try {
              if (err.data.error_text_msg) {
                toastr.error(err.data.error_text_msg);
              } else {
                toastr.error("Se presento un error actualizando tus datos, inténtalo mas tarde.");
              }
            } catch (err) {
              toastr.error("Se presento un error actualizando tus datos, inténtalo mas tarde.");
            }
          });
        }
      };

      $scope.updateMyEmail = function (isValid) {
        if (isValid) {
          usersService.updateMyEmail($scope.new_email).then(function () {
            $state.reload();
            toastr.success("¡Correo actualizado!");
            console.log('updated');
          }, function (err) {
            try {
              if (err.data.error_text_msg) {
                toastr.error(err.data.error_text_msg);

              } else {
                toastr.error("Se presento un error actualizando tus datos, inténtalo mas tarde.");

              }
            } catch (err) {
              toastr.error("Se presento un error actualizando tus datos, inténtalo mas tarde.");
            }
          });
        }
      };

      $scope.updateMyPassword = function (isValid) {
        if (isValid) {
          usersService.updateMyPassword($scope.new_password).then(function () {
            $state.reload();
            toastr.success("¡Contraseña actualizada!");
            console.log('updated');
          }, function (err) {
            toastr.error("Se presento un error actualizando tus datos, inténtalo mas tarde.");
          });
        }
      };

      $scope.openContactConfirmation = function (contact) {
        ngDialog.open({
          template: 'confirmationContactDeleteModal-1',
          data: {
            contact: contact
          },
          controller: 'ContactConfirmationModalCtrl'
        });
      };

      $scope.openDeleteBankAccountConfirmation = function (bankAccount) {
        ngDialog.open({
          template: 'confirmationBankAccountDeleteModal-2',
          data: {
            bankAccount: bankAccount
          },
          controller: 'ContactConfirmationDeleteBankAccountModalCtrl'
        });
      };

      $scope.openDeleteCreditCardConfirmation = function (creditCard) {
        ngDialog.open({
          template: 'confirmationCreditCardDeleteModal-3',
          data: {
            creditCard: creditCard
          },
          controller: 'ContactConfirmationDeleteCreditCardModalCtrl'
        });
      };

      $rootScope.$on('updateContactsUser', function () {
        usersService.getContactsUser().then(function (data) {
          $scope.userContacts = data;
          ngDialog.close();
          toastr.success('Contacto borrado con éxito');
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de obtener la lista de contactos');
        });
      });

      $rootScope.$on('updateBankAccountsUser', function () {
        bankService.getUserBankAccountList().then(function (data) {
          $scope.userBankAccounts = data;
          var account_index = 1;
          _.forEach($scope.userBankAccounts, function (value) {
            if (!value.name) {
              console.log(value);
              value.name = "Cuenta " + account_index;
              account_index++;
            }
          });
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de obtener la lista de cuentas bancarias');
        });
      });

      $rootScope.$on('deleteBankAccountsUser', function () {
        bankService.getUserBankAccountList().then(function (data) {
          $scope.userBankAccounts = data;
          var account_index = 1;
          _.forEach($scope.userBankAccounts, function (value) {
            if (!value.name) {
              console.log(value);
              value.name = "Cuenta " + account_index;
              account_index++;
            }
          });
          ngDialog.close();

          toastr.success('Cuenta bancarias actualizadas');
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de obtener la lista de cuentas bancarias');
        });
      });

      $rootScope.$on('deleteCreditCardUser', function () {
        paymentService.getUserCreditCards().then(function (data) {
          $scope.creditCards = data.credit_cards;
          ngDialog.close();

          toastr.success('Tarjetas de crédito actualizadas');
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de obtener las tarjetas de crédito');
        });
      });

      $scope.addNewContact = function (isValid) {
        if (isValid) {

          $scope.newContact.user_father = user.user.id;

          usersService.addNewContact($scope.newContact).then(function (data) {

            usersService.getContactsUser().then(function (data) {
              $scope.userContacts = data;
              toastr.success('Contacto agregado con éxito');
              $scope.addContactForm.$setPristine(true);
              $scope.addContactForm.$setUntouched(true);
              $scope.newContact = {};
            }, function (err) {
              console.log('err login', err);
              toastr.error('Error tratando de obtener la lista de contactos');
            });
          }, function (err) {
            console.log('err login', err);
            toastr.error(err.data);
          });
        }
      };

      $scope.onTabChanges = function (currentTab) {
        // console.log(currentTab);
        $state.currentTab = currentTab;
        $location.replace();
        $location.search('currentTab', currentTab);
        $scope.tabSelected = currentTab;
        $scope.menuTabsCollapse = true;
      };
      $scope.showDateError = false;
      $scope.dateBornValidator = function (isCompleted) {
        if ($scope.accountUser.born_date && isCompleted) {
          if ($scope.accountUser.born_date > $scope.maxDate) {
            $scope.showDateError = true;
          }
        } else {
          $scope.showDateError = false;
        }
      };

      $scope.showExample = function (ev) {
        $mdDialog.show({
          controller: ExampleController,
          templateUrl: 'dialog.document.example.tmpl.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: false // Only for -xs, -sm breakpoints.
        })
          .then(function () {
          }, function () {
          });
      };


      function ExampleController($scope, $mdDialog) {
        $scope.hide = function () {
          $mdDialog.hide();
        };

        $scope.cancel = function () {
          $mdDialog.cancel();
        };
      }

      $scope.showDocument = function (showNumber) {
        $scope.documentFileShow = showNumber;
        $mdDialog.show({
          controller: DocumentController,
          templateUrl: 'dialog.document.tmpl.html',
          parent: angular.element(document.body),
          scope: $scope.$new(),
          clickOutsideToClose: true,
          fullscreen: false // Only for -xs, -sm breakpoints.
        })
          .then(function () {
          }, function () {
          });
      };

      function DocumentController($scope, $mdDialog, $state) {
        $scope.hide = function () {
          $mdDialog.hide();
        };

        $scope.cancel = function () {
          $mdDialog.cancel();
        };
      }

      $scope.addDocumentImageFront = function () {
        usersService.uploadDocumenUserImageFront($scope.accountUser.documentUserFrontFile).then(function (data) {
          usersService.retrieveUserData().then(function (data) {
            $scope.updateAccountUser();
            // $state.reload();
            toastr.success('Imagen agregada');
          }, function (err) {

          });
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de agregar tu documento');
        });
      };

      $scope.addDocumentImageBack = function () {
        usersService.uploadDocumenUserImageBack($scope.accountUser.documentUserBackFile).then(function (data) {
          usersService.retrieveUserData().then(function (data) {
            $scope.updateAccountUser();
            // $state.reload();
            toastr.success('Imagen agregada');
          }, function (err) {

          });
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de agregar tu documento');
        });
      };

      $scope.addDocumentPDF = function () {
        usersService.uploadDocumenUserPDF($scope.accountUser.documentUserPDFFile).then(function (data) {
          usersService.retrieveUserData().then(function (data) {
            $scope.updateAccountUser();
            // $state.reload();
            toastr.success('Documento agregado');
          }, function (err) {

          });
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de agregar tu documento');
        });
      };

      $scope.validateDocument = function (type) {
        if (type === 'ImageFront') {
          if ($scope.accountUser.documentUserFrontFile.type === 'image/png' || $scope.accountUser.documentUserFrontFile.type === 'image/jpeg') {
            if ($scope.accountUser.documentUserFrontFile.size <= fileSizeImage) {
              AboutUsService.validateDocument($scope.accountUser.documentUserFrontFile, false).then(function (data) {
                if (data.data.invalid_document) {
                  $scope.openDocumentConfirmation(type);
                } else {
                  $scope.addDocumentImageFront();
                }
              }, function (err) {
              });
            } else {
              toastr.error('El tamaño de la imagen es superior a ' + (fileSizeImage / 1000000) + 'MB');
            }
          } else {
            toastr.error('Adjunta una imagen en fomato PNG o JPEG');
          }
        } else if (type === 'ImageBack') {
          if ($scope.accountUser.documentUserBackFile.type === 'image/png' || $scope.accountUser.documentUserBackFile.type === 'image/jpeg') {
            if ($scope.accountUser.documentUserBackFile.size <= fileSizeImage) {
              AboutUsService.validateDocument($scope.accountUser.documentUserBackFile, false).then(function (data) {
                if (data.data.invalid_document) {
                  $scope.openDocumentConfirmation(type);
                } else {
                  $scope.addDocumentImageBack();
                }
              }, function (err) {
              });
            } else {
              toastr.error('El tamaño de la imagen es superior a ' + (fileSizeImage / 1000000) + 'MB');
            }
          } else {
            toastr.error('Adjunta una imagen en fomato PNG o JPEG');
          }
        } else if (type === 'PDF') {
          if ($scope.accountUser.documentUserPDFFile.type === 'application/pdf') {
            if ($scope.accountUser.documentUserPDFFile.size <= fileSizePDF) {
              AboutUsService.validateDocument($scope.accountUser.documentUserPDFFile, true).then(function (data) {
                if (data.data.invalid_document) {
                  $scope.openDocumentConfirmation(type);
                } else {
                  $scope.addDocumentPDF();
                }
              }, function (err) {
              });
            } else {
              toastr.error('El tamaño del archivo es superior a ' + (fileSizePDF / 1000000) + 'MB');
            }
          } else {
            toastr.error('Adjunta un documento en fomato PDF');
          }
        }
      };

      $scope.clickChangeDocumentImageFront = function () {
        angular.element('#fileInputImageFront').trigger('click');
      };

      $scope.clickChangeDocumentImageBack = function () {
        angular.element('#fileInputImageBack').trigger('click');
      };

      $scope.clickChangeDocumentPDF = function () {
        angular.element('#fileInputPDF').trigger('click');
      };

      $scope.$watch('accountUser.documentUserFrontFile', function (newValue, oldValue) {
        if (newValue != null) {
          $scope.validateDocument('ImageFront');
        }
      });

      $scope.$watch('accountUser.documentUserBackFile', function (newValue, oldValue) {
        if (newValue != null) {
          $scope.validateDocument('ImageBack');
        }
      });

      $scope.$watch('accountUser.documentUserPDFFile', function (newValue, oldValue) {
        if (newValue != null) {
          $scope.validateDocument('PDF');
        }
      });

      $scope.downloadInvoiceList = function (invoice) {
        var hiddenElement = document.createElement('a');
        hiddenElement.href = invoice.invoice_pdf;
        hiddenElement.download = 'Factura-ATV.pdf';
        hiddenElement.click();
      };

      $scope.openDocumentConfirmation = function (type) {
        ngDialog.open({
          template: 'confirmationDocumentValidated',
          scope: $scope,
          data: {type: type}
        });
      };

      $scope.acceptDocumentValidation = function (data) {
        if (data.type === 'ImageFront') {
          $scope.addDocumentImageFront();
        } else if (data.type === 'ImageBack') {
          $scope.addDocumentImageBack();
        } else if (data.type === 'PDF') {
          $scope.addDocumentPDF();
        }

        $scope.closeDocumentConfirmation(data.ngDialogId);
      };

      $scope.closeDocumentConfirmation = function (closeId) {
        ngDialog.close(closeId);
      };
    })
    .controller('ContactConfirmationModalCtrl', function ($scope, ngDialog, usersService, toastr, cowEventService, $rootScope) {


      $scope.closeSecond = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.confirmationDeleteContact = function (contact, closeId) {

        delete contact.user_contact;
        usersService.deleteContactUser(contact).then(function (data) {
          $rootScope.$broadcast("updateContactsUser");
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de eliminar el contacto');
        });

      };


    })
    .controller('ContactConfirmationDeleteBankAccountModalCtrl', function ($scope, ngDialog, toastr, bankService, $rootScope) {


      $scope.closeSecond = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.confirmationDeleteBankAccount = function (bankAccount, closeId) {

        bankService.deleteBankAccountUser(bankAccount.id).then(function (data) {
          $rootScope.$broadcast("deleteBankAccountsUser");
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de eliminar la cuenta bancaria');
        });

      };


    })
    .controller('ContactConfirmationDeleteCreditCardModalCtrl', function ($scope, ngDialog, toastr, paymentService, $rootScope) {


      $scope.closeSecond = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.confirmationDeleteCreditCard = function (creditCard, closeId) {

        paymentService.deleteCreditCardUser(creditCard.id).then(function (data) {
          $rootScope.$broadcast("deleteCreditCardUser");
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de eliminar la tarjeta de crédito');
        });

      };


    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('about-us', {
          url: '/quienes-somos-en-arma-tu-vaca',
          templateUrl: 'app/views/aboutUs/aboutUs.html',
          controller: 'AboutUsController',
          controllerAs: 'about-us',
          resolve: {
            teamMembers: function (AboutUsService) {
              return AboutUsService.getTeamMembers();
            }
          },
          data: {
            'meta': {
              'title': '¿Quiénes somos?',
              'description': 'Equipo de jóvenes emprendedores colombianos buscando cambiar la forma de armar Vacas.',
              'robots': 'noindex'
            }
          }
        })
    })
    .controller('AboutUsController', function ($scope, teamMembers) {

      console.log('quienes somos');
      console.log(teamMembers);
      $scope.myInterval = 6000;
      $scope.noWrapSlides = false;
      $scope.carouselIndex = 0;
      $scope.teamMembers = teamMembers;

      $scope.slides_about_us_fr = [];
      $scope.slide_1_about_us_fr = {
        id: 0,
        title: 'Ghislain Foucque',
        subtitle: 'CEO & Cofundador',
        description: 'Administrador de empresas de la Universidad de los Andes. ' +
        'Es el culpable de que ArmaTuVaca.com sea una realidad. ' +
        'Curioso, inquieto, innovador y siempre buscando nuevas oportunidades.',
        image: "assets/images/about-us/ghislain.jpg"
      };
      $scope.slide_2_about_us_fr = {
        id: 1,
        title: 'Adrien Soucachet',
        subtitle: 'CMO & Cofundador',
        description: 'Ingeniero Mecánico de la universidad de los Andes. Encargado de evaluar el nivel de belleza de las ' +
        'mujeres para la campañas de mercadeo.',
        image: "assets/images/about-us/adrien.jpg"
      };
      $scope.slide_3_about_us_fr = {
        id: 2,
        title: 'Thibault Lefevre',
        subtitle: 'CFM / Asociado',
        description: 'Ingeniero Industrial de la universidad de los Andes. Es la mente detrás de las noches de entretenimiento ' +
        'en ATV. La fiesta su hobbie y las viejas su admiración.',
        image: "assets/images/about-us/pablo.jpg"
      };
      $scope.slide_4_about_us_fr = {
        id: 3,
        title: 'Tom Marcha',
        subtitle: 'CTO',
        description: 'Ingeniero de Sistemas de la U. de los Andes, geek amante de la comida mexicana y videojuegos.' +
        ' Desarrollador hábil  encargado de guiar la visión tecnológica a corto y mediano plazo de la compañía.',
        image: "assets/images/about-us/tom.jpg"
      };

      $scope.slides_about_us_fr = [$scope.slide_1_about_us_fr, $scope.slide_2_about_us_fr, $scope.slide_3_about_us_fr, $scope.slide_4_about_us_fr];

    });
})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(function ($stateProvider) {
      $stateProvider
        .state('404', {
          url: '/404',
          templateUrl: 'app/views/404/404.html',
          controller: 'NotFoundController',
          controllerAs: '404',
          resolve: {},
          data: {
            'meta': {
              'title': 'Error 404',
                'robots': 'noindex, nofollow'
            }
          }
        })
    })
    .controller('NotFoundController', function ($scope, $state, $rootScope, $analytics) {

      console.log('not found 404');
      // $analytics.pageTrack('/404');
      // $analytics.eventTrack('404');
    });
})();

'use strict';

angular.module('user')
  .factory('usersRegisterResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/user-register/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('usersResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/user-data/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('usersLoginResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/user-login/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('fbLoginResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/user-fb-login/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('ggLoginResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/user-gg-login/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('updateMyProfileResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/user-update-my-profile/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('updateMyEmailResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/user-update-my-email/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('updateMyPasswordResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/user-update-my-password/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('userContactsResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/contacts-user/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('userContactResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/contact-user/:id", {
      id: '@id'
    }, {
      'delete': {
        method: 'DELETE'
      }
    });
  })
  .factory('userCreateContactResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/create-contact-user/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('updateCellphoneResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/user-update-cellphone/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('updateDocumentResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/user-update-document/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('userFepCowResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/user-fep-cow/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET'
      }
    });
  })
  .factory('userStatsResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/user-stats/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET'
      }
    });
  })
  .factory('userValidateToken', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/confirmation-email/:token", {
      token: '@token'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('resendEmailConfirmationResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/resend-confirmation-email/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('usersService', function ($rootScope, $q, $http, $state, $timeout, usersRegisterResource, resourceBaseUrl, usersResource, usersLoginResource,
    fbLoginResource, ggLoginResource, updateMyProfileResource, updateMyEmailResource, updateMyPasswordResource, ezfb, userContactsResource,
    userContactResource, userCreateContactResource, Upload, updateCellphoneResource, updateDocumentResource,
    userFepCowResource, userStatsResource, userValidateToken, resendEmailConfirmationResource) {

    var service = {};

    var token = localStorage.token;
    var userData;
    var loginAttemptPromise;

    service.registerNewUser = function (first_name, last_name, born_date, email, password, send_welcome_email, token, second_validation) {
      var deferred = $q.defer();

      usersRegisterResource.post({
        first_name: first_name,
        last_name: last_name,
        born_date: born_date,
        email: email,
        password: password,
        send_welcome_email: send_welcome_email,
        token: token,
        second_validation: (second_validation)?second_validation:false
      }).$promise.then(function (data) {
        deferred.resolve(data);
        service.saveToken(data.token);
        service.retrieveUserData();
      }, function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    };

    service.saveToken = function (tokenP) {
      service.clearToken();
      // service.clearUserData();
      token = tokenP;
      localStorage.token = token;
      // $http.defaults.headers.common.Authorization = 'Bearer ' + token;
    };

    service.clearToken = function () {
      token = null;
      localStorage.removeItem('token');
      // $http.defaults.headers.common.Authorization = undefined;
    };

    service.saveUserData = function (userDataP) {
      userData = userDataP;
      localStorage.userData = JSON.stringify(userDataP);
    };

    service.clearUserData = function () {
      userData = null;
      localStorage.removeItem('userData');
    };

    service.retrieveUserData = function () {
      var deferred = $q.defer();

      usersResource.post().$promise.then(function (data) {
        deferred.resolve(data);
        userData = data;
        service.saveUserData(data);
        $rootScope.$broadcast('loggedIn');
        $rootScope.checkLoginStatus();
      }, function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    };

    service.getUserData = function () {
      var deferred = $q.defer();

      if (userData != null) {
        deferred.resolve(userData);
      } else if (token != null) {
        service.retrieveUserData().then(function (data) {
          deferred.resolve(userData);
        }, function (err) {
          deferred.reject(err);
          service.logout();
        });
      } else {
        deferred.reject('err');
      }
      return deferred.promise;
    };

    service.isLoggedIn = function () {
      var deferred = $q.defer();
      service.getUserData().then(function (data) {
        deferred.resolve({
          login: true
        });
      }, function (err) {
        deferred.resolve({
          login: false
        });
      });
      return deferred.promise;
    };

    service.logout = function () {
      userData = null;
      service.clearToken();
      service.clearUserData();
      $rootScope.$broadcast('loggedOut');
      $rootScope.checkLoginStatus();
      // $state.reload();
    };

    service.clearAllData = function () {
      userData = null;
      service.clearToken();
      service.clearUserData();
    };

    service.login = function (email, password, token, secondValidation) {
      var deferred = $q.defer();
      usersLoginResource.post({
        email: email,
        password: password,
        token: token,
        second_validation:(secondValidation) ? secondValidation:false
      }).$promise.then(function (data) {
        deferred.resolve(data);
        service.saveToken(data.token);
        service.retrieveUserData();
      }, function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    };

    service.loginFb = function (send_welcome_email) {
      var deferred = $q.defer();
      ezfb.login(function (res) {
        if (res.authResponse) {
          fbLoginResource.post({
            fb_token: res.authResponse.accessToken,
            send_welcome_email: send_welcome_email
          }).$promise.then(function (data) {
            deferred.resolve(data);
            if (data.token !== 0) {
              service.saveToken(data.token);
              service.retrieveUserData();
            }
          }, function (err) {
            deferred.reject(err);
          });
        }
      }, {
        scope: 'email'
      });
      return deferred.promise;
    };

    service.loginGg = function (access_token, send_welcome_email) {
      var deferred = $q.defer();
      ggLoginResource.post({
        access_token: access_token,
        send_welcome_email: send_welcome_email
      }).$promise.then(function (data) {
        deferred.resolve(data);
        service.saveToken(data.token);
        service.retrieveUserData();
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.updateMyProfile = function (first_name, last_name, born_date, cellphone,
      document_number, document_type, document_full_number, surname_2) {
      var deferred = $q.defer();
      updateMyProfileResource.post({
        first_name: first_name,
        last_name: last_name,
        born_date: born_date,
        cellphone: cellphone,
        document_number: document_number,
        document_type: document_type,
        document_full_number: document_full_number,
        surname_2: surname_2
      }).$promise.then(function (data) {
        deferred.resolve(data);
        service.retrieveUserData();
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.updateMyEmail = function (new_email) {
      var deferred = $q.defer();
      updateMyEmailResource.post({
        new_email: new_email
      }).$promise.then(function (data) {
        attemptLogin();
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.updateMyPassword = function (new_password) {
      var deferred = $q.defer();
      updateMyPasswordResource.post({
        new_password: new_password
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getContactsUser = function () {
      var deferred = $q.defer();
      userContactsResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.deleteContactUser = function (contactData) {
      var deferred = $q.defer();
      userContactResource.delete({
        id: contactData.id
      }, contactData).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.addNewContact = function (contactData) {
      var deferred = $q.defer();
      userCreateContactResource.post(contactData).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.uploadDocumenUserImageFront = function (document) {
      var deferred = $q.defer();
      Upload.upload({
        url: resourceBaseUrl + '/u/upload-user-document-image-front',
        data: {
          document_file: document
        }
      }).then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.uploadDocumenUserImageBack = function (document) {
      var deferred = $q.defer();
      Upload.upload({
        url: resourceBaseUrl + '/u/upload-user-document-image-back',
        data: {
          document_file: document
        }
      }).then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.uploadDocumenUserPDF = function (document) {
      var deferred = $q.defer();
      Upload.upload({
        url: resourceBaseUrl + '/u/upload-user-document-pdf',
        data: {
          document_file: document
        }
      }).then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    function attemptLogin() {
      if (token != null) {
        service.saveToken(token);
        // loginAttemptPromise = service.retrieveUserData();
        // loginAttemptPromise.catch(function() {
        //   service.clearToken();
        //   service.clearUserData();
        // });
      }
    }

    attemptLogin();

    service.updateCellphone = function (cellphone, cowId) {
      var deferred = $q.defer();
      updateCellphoneResource.post({
        cellphone: cellphone,
        cow_id: cowId
      }).$promise.then(function (data) {
        deferred.resolve(data);
        service.retrieveUserData();
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.updateDocument = function (document) {
      var deferred = $q.defer();
      updateDocumentResource.post({
        document_number: document
      }).$promise.then(function (data) {
        deferred.resolve(data);
        service.retrieveUserData();
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getFepCow = function () {
      var deferred = $q.defer();
      userFepCowResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getUserStats = function () {
      var deferred = $q.defer();
      userStatsResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };
    service.validateTokenEmail = function (token) {
      var deferred = $q.defer();
      userValidateToken.post({
        token: token
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.resendEmailConfirmation = function () {
      var deferred = $q.defer();
      resendEmailConfirmationResource.post().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    return service;
  });

'use strict';

angular.module('user')
  .factory('checkPaymentStatusResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/py/check-payment-status/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('CowEventParticipantsThanksListResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/py/cow-event-participants-thanks-list/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('UserInvoicesListResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/py/user-invoices/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('MatrixComissionsListResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/py/matrix-commissions-list/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('CowEventParticipantsPublicListResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/py/cow-event-participants-public-list/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('CowEventParticipantsOrganizerListResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/py/cow-event-participants-organizer-list/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('ValidateGiftCodeResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/py/validate-gift-code/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('GetPaymentResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/py/get-payment-data/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET'
      }
    });
  })
  .factory('UserCreditCardsResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/py/user-credit-cards/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('DeleteUserCreditCardsResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/py/delete-user-credit-card/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('GetPaymentMethodsResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/py/get-payment-methods/:id", {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('paymentService', function ($rootScope, $q, $http, $state, $timeout, checkPaymentStatusResource,
                                       CowEventParticipantsThanksListResource, CowEventParticipantsOrganizerListResource,
                                       CowEventParticipantsPublicListResource, MatrixComissionsListResource,
                                       ValidateGiftCodeResource, UserInvoicesListResource, GetPaymentResource,
                                       UserCreditCardsResource, DeleteUserCreditCardsResource, GetPaymentMethodsResource) {
    var service = {};


    service.checkPaymentStatus = function (paymentId) {
      var deferred = $q.defer();
      checkPaymentStatusResource.post({
        payment_id: paymentId
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getCowEventParticipantsThanksList = function (cowId) {
      var deferred = $q.defer();
      CowEventParticipantsThanksListResource.query({
        cow_id: cowId
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getCowEventParticipantsPublicList = function (cowId) {
      var deferred = $q.defer();
      CowEventParticipantsPublicListResource.query({
        cow_id: cowId
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getCowEventParticipantsOrganizerList = function (cowId) {
      var deferred = $q.defer();
      CowEventParticipantsOrganizerListResource.query({
        cow_id: cowId
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getMatrixComissionsList = function () {
      var deferred = $q.defer();
      MatrixComissionsListResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getUserInvoicesList = function () {
      var deferred = $q.defer();
      UserInvoicesListResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.validateGiftCode = function (data) {
      var deferred = $q.defer();
      ValidateGiftCodeResource.post(data).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getUserCreditCards = function () {
      var deferred = $q.defer();
      UserCreditCardsResource.post().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.deleteCreditCardUser = function (userId) {
      var deferred = $q.defer();
      DeleteUserCreditCardsResource.post({credit_card_id: userId}).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getPaymentData = function (paymentId) {
      var deferred = $q.defer();
      GetPaymentResource.query({
        payment_id: paymentId
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getPaymentMethods = function () {
      var deferred = $q.defer();
      GetPaymentMethodsResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    return service;
  });

'use strict';

angular.module('user')
  .factory('forgotPasswordEmailResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/forgot-password-email/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('forgotPasswordCellphoneResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/forgot-password-cellphone/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('checkPasswordEmailTokenResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/check-password-email-token/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('checkPasswordCellphoneTokenResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/check-password-cellphone-token/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('changePasswordEmailResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/change-password-email/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('changePasswordCellphoneResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/u/change-password-cellphone/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('passwordService', function ($rootScope, $q, $http, $state, $timeout, usersRegisterResource, resourceBaseUrl, forgotPasswordEmailResource,
                                        checkPasswordEmailTokenResource, usersService, changePasswordEmailResource, forgotPasswordCellphoneResource, checkPasswordCellphoneTokenResource,
                                        changePasswordCellphoneResource) {

    var service = {};


    service.forgotPasswordEmail = function (email) {
      var deferred = $q.defer();

      forgotPasswordEmailResource.post({
        email: email
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.forgotPasswordCellphone = function (cellphone) {
      var deferred = $q.defer();

      forgotPasswordCellphoneResource.post({
        cellphone: cellphone
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.checkPasswordEmailToken = function (email_token) {
      var deferred = $q.defer();

      checkPasswordEmailTokenResource.post({
        email_token: email_token
      }).$promise.then(function (data) {
        deferred.resolve(data);
        usersService.clearAllData();
      }, function (err) {
        deferred.reject(err);
        usersService.clearAllData();
      });
      return deferred.promise;
    };

    service.checkPasswordCellphoneToken = function (cellphone_token) {
      var deferred = $q.defer();

      checkPasswordCellphoneTokenResource.post({
        cellphone_token: cellphone_token
      }).$promise.then(function (data) {
        deferred.resolve(data);
        usersService.clearAllData();
      }, function (err) {
        deferred.reject(err);
        usersService.clearAllData();
      });
      return deferred.promise;
    };

    service.changePasswordEmail = function (password, emailToken, token) {
      var deferred = $q.defer();

      usersService.saveToken(token);

      changePasswordEmailResource.post({
        password: password,
        email_token: emailToken
      }).$promise.then(function (data) {
        if (data.changed) {
          if (data.changed) {
            usersService.retrieveUserData();
          } else {
            usersService.clearAllData();
          }
        }
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.changePasswordCellphone = function (password, cellphoneToken, token) {
      var deferred = $q.defer();

      usersService.saveToken(token);

      changePasswordCellphoneResource.post({
        password: password,
        cellphone_token: cellphoneToken
      }).$promise.then(function (data) {
        if (data.changed) {
          if (data.changed) {
            usersService.retrieveUserData();
          } else {
            usersService.clearAllData();
          }
        }
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };


    return service;
  });

'use strict';

angular.module('user')
  .factory('createParticipationResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/py/create-payment-participation/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('pseBanksListResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/py/pse-banks/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('participationService', function ($rootScope, $q, $http, $state, $timeout, resourceBaseUrl, createParticipationResource
    , Upload, pseBanksListResource) {

    var service = {};


    service.createParticipation = function (participationData, token, secondValidation) {
      var deferred = $q.defer();

      createParticipationResource.post({
        participation_data: participationData,
        token: token,
        second_validation:(secondValidation) ? secondValidation:false
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getPseBanks = function () {
      var deferred = $q.defer();
      pseBanksListResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    return service;
  });

'use strict';

angular.module('user')
    .factory('GetMemberResource', function ($resource, resourceBaseUrl) {
        return $resource(resourceBaseUrl + "/mb/get-member-data/:id", {
            id: '@id'
        }, {
            'query': {
                method: 'GET'
            }
        });
    })
    .factory('memberService', function ($rootScope, $q, $http, $state, $timeout, resourceBaseUrl, Upload,
                                        GetMemberResource) {

        var service = {};


        service.createMember = function (memberData, member_img, member_img_raw) {
            var deferred = $q.defer();

            console.log(memberData);

            Upload.upload({
                url: resourceBaseUrl + '/mb/create-member',
                data: {
                    member_data: memberData,
                    member_img: member_img,
                    member_img_raw: member_img_raw
                }
            }).then(function (data) {
                deferred.resolve(data);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        };

        service.getMemberData = function (memberId) {
            var deferred = $q.defer();
            GetMemberResource.query({
                member_id: memberId
            }).$promise.then(function (data) {
                deferred.resolve(data);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        };

        service.updateMember = function (memberData, member_img, member_img_raw) {
            var deferred = $q.defer();
            Upload.upload({
                url: resourceBaseUrl + '/mb/update-member',
                data: {
                    member_data: memberData,
                    member_img: member_img,
                    member_img_raw: member_img_raw
                }
            }).then(function (data) {
                deferred.resolve(data);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        };

        return service;
    });
'use strict';

angular.module('user')
  .factory('companyListResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/mp/company-list/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('companyResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/mp/company-slug/:id", {
      id: '@id'
    }, {
      'get': {
        method: 'GET'
      }
    });
  })
  .factory('companyProductsResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/mp/company-products/:id", {
      id: '@id'
    }, {
      'get': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('productResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/mp/product-slug/:id", {
      id: '@id'
    }, {
      'get': {
        method: 'GET'
      }
    });
  })
  .factory('marketplaceOffersResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/mp/banner/home/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET'
      }
    });
  })
  .factory('marketplaceCategoriesResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/mp/category/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET'
      }
    });
  })
  .factory('marketplaceService', function ($q, $http, $state, $timeout, companyListResource, companyResource,
                                           companyProductsResource, productResource, marketplaceOffersResource,
                                           marketplaceCategoriesResource) {

    var service = {};

    service.getCompaniesList = function () {
      var deferred = $q.defer();
      companyListResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getCompany = function (slug) {
      var deferred = $q.defer();
      companyResource.get({
        slug: slug
      }).$promise.then(function (data) {
        deferred.resolve(data.company_data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getCompanyProducts = function (slug) {
      var deferred = $q.defer();
      companyProductsResource.get({
        slug: slug
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getProduct = function (slug) {
      var deferred = $q.defer();
      productResource.get({
        slug: slug
      }).$promise.then(function (data) {
        deferred.resolve(data.product_data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getMarketplaceOffers = function () {
      var deferred = $q.defer();
      marketplaceOffersResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getMarketplaceCategories = function () {
      var deferred = $q.defer();
      marketplaceCategoriesResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    return service;
  });

/**
 * Created by lucas on 5/04/17.
 */

'use strict';

angular.module('user')
  .factory('addFeedbackPaymentResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/fd/add-feedback-payment/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('updateFeedbackPaymentResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/fd/update-feedback-payment/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('addFeedbackCowResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/fd/add-feedback-cow/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('updateFeedbackCowResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/fd/update-feedback-cow/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('addFeedbackUserResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/fd/add-feedback-user/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('updateFeedbackUserResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/fd/update-feedback-user/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('feedbackListResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/fd/get-feedback-list/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET'
      }
    });
  })
  .factory('feedbackService', function ($q, resourceBaseUrl, addFeedbackPaymentResource, updateFeedbackPaymentResource,
                                        addFeedbackCowResource, updateFeedbackCowResource, addFeedbackUserResource,
                                        updateFeedbackUserResource, feedbackListResource) {
    var service = {};

    service.addFeedbackPayment = function (payment, grade) {
      var deferred = $q.defer();

      addFeedbackPaymentResource.post({
        payment: payment,
        grade: grade
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.updateFeedbackPayment = function (payment, grade, title, comments) {
      var deferred = $q.defer();

      updateFeedbackPaymentResource.post({
        payment: payment,
        grade: grade,
        title: title,
        comments: comments
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.addFeedbackCow = function (cow, grade) {
      var deferred = $q.defer();

      addFeedbackCowResource.post({
        cow: cow,
        grade: grade
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.updateFeedbackCow = function (cow, grade, title, comments) {
      var deferred = $q.defer();

      updateFeedbackCowResource.post({
        cow: cow,
        grade: grade,
        title: title,
        comments: comments
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.addFeedbackUser = function (user, campaign, grade) {
      var deferred = $q.defer();

      addFeedbackUserResource.post({
        user: user,
        campaign: campaign,
        grade: grade
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.updateFeedbackUser = function (user, campaign, grade, title, comments) {
      var deferred = $q.defer();

      updateFeedbackUserResource.post({
        user: user,
        campaign: campaign,
        grade: grade,
        title: title,
        comments: comments
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getFeedbackList = function () {
      var deferred = $q.defer();
      feedbackListResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    return service;
  });

'use strict';

angular.module('user')
  .factory('cowEventTypeResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/cow-event-types/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('cowEventCreateTempResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/cow-temp-event-create/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('cowEventTempUserResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/cow-temp-user/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('cowEventResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/cow/:id", {
      id: '@id'
    }, {
      'get': {
        method: 'GET'
      }
    });
  })
  .factory('cowEventPublicResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/cow-public/:id", {
      id: '@id'
    }, {
      'get': {
        method: 'GET'
      }
    });
  })
  .factory('cowEventEditResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/cow-event-edit/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      },
      'save': {
        method: 'PUT'
      },
      'partial_update': {
        method: 'PATCH'
      }
    });
  })
  .factory('cowsEventUserResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/cows-user/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('PublicCowsEventResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/public-cows/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('cowsEventGuestListResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/get-contacts-cow/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('cowEventAddContactsResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/add-contacts-cow/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('cowEventDeleteContactResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/delete-contact-cow/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('cowEventResendInviteResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/resend-invite-cow/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('cowEventParticipantListDownloadResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/download-participants-list/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('sendThanksResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/send-thanks/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('createGetMoneyRequestResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/create-get-money-request/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('createEfectyMoneyRequestResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/create-efecty-money-request/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('cowGetMoneyRequestResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/cow-get-money-request/:id", {
      id: '@id'
    }, {
      'get': {
        method: 'GET',
        isArray: false
      }
    });
  })
  .factory('cowGetMoneyRequestByCowIdResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/cow-get-money-request-by-cow-id/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('cowGetAllMoneyRequestsByCowIdResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/cow-get-all-money-requests-by-cow-id/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('cowEventUserInvitesResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/cow-event-user-invites/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('cowValidateGiftCodeResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/validate-gift-code/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('cowEventGiftCodeTermsAndConditionsResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/gift-code-terms-and-conditions/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: false
      }
    });
  })
  .factory('cowEventMarketplaceCreateTempResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/cow-marketplace-create/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('cowEventMarketplaceRedeemResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/cow-marketplace-redeem/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('cowEventSaveContactMeResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/cow-contact-me/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('createFepCowResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/fep-cow-create/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('updateCowAdditionalInfoResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/update-cow-additional-info/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('GetCashoutMethodsResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/get-cashout-methods/:id", {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('upgradeCowPlanResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/upgrade-cow-plan/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('GetAvailableCowsCash', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/avaliable-cows-cash", {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('CategoryCowsPublicResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/public-cow-categories", {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('cowGetTokenMoneyRequest', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/send-money-cow-token/:id", {
      id: '@id'
    }, {
      'get': {
        method: 'GET',
        isArray: false
      }
    });
  })
  .factory('RequestPublicCowsEvent', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/cw/request-public-cows/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('cowEventService', function ($rootScope, $q, $http, $state, $timeout, resourceBaseUrl, cowEventTypeResource,
                                        Upload, cowEventCreateTempResource, cowEventTempUserResource, cowEventResource,
                                        cowEventEditResource, cowsEventUserResource, cowEventAddContactsResource,
                                        cowsEventGuestListResource, cowEventDeleteContactResource, cowEventResendInviteResource,
                                        cowEventParticipantListDownloadResource, cowEventPublicResource, sendThanksResource,
                                        createGetMoneyRequestResource, cowGetMoneyRequestResource, cowGetMoneyRequestByCowIdResource,
                                        cowEventUserInvitesResource, cowGetAllMoneyRequestsByCowIdResource, cowValidateGiftCodeResource,
                                        cowEventGiftCodeTermsAndConditionsResource, cowEventMarketplaceCreateTempResource,
                                        cowEventMarketplaceRedeemResource, cowEventSaveContactMeResource, createFepCowResource,
                                        updateCowAdditionalInfoResource, createEfectyMoneyRequestResource, PublicCowsEventResource,
                                        GetCashoutMethodsResource, upgradeCowPlanResource, GetAvailableCowsCash, CategoryCowsPublicResource, cowGetTokenMoneyRequest,RequestPublicCowsEvent) {

    var service = {};

    service.getCowEventTypes = function () {
      var deferred = $q.defer();
      cowEventTypeResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getCowEventUserInvitesList = function () {
      var deferred = $q.defer();
      cowEventUserInvitesResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.createCowEventTemp = function (cow, cow_type, main_img, main_img_raw) {
      var deferred = $q.defer();
      Upload.upload({
        url: resourceBaseUrl + '/cw/cow-temp-event-create',
        data: {
          cow: cow,
          cow_type: cow_type,
          main_img: main_img,
          main_img_raw: main_img_raw
        }
      }).then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.createNewCowEvent = function (cow) {
      var deferred = $q.defer();
      Upload.upload({
        url: resourceBaseUrl + '/cw/new-cow-create',
        data: {
          cow: cow
        }
      }).then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.createCowEvent = function (cow, cow_type, cow_user, main_img, main_img_raw, is_public) {
      var deferred = $q.defer();
      Upload.upload({
        url: resourceBaseUrl + '/cw/cow-event-create',
        data: {
          cow: cow,
          cow_type: cow_type,
          cow_user: cow_user,
          main_img: main_img,
          main_img_raw: main_img_raw,
          is_public: is_public
        }
      }).then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.editCowEvent = function (cow) {
      var deferred = $q.defer();
      Upload.upload({
        url: resourceBaseUrl + '/cw/cow-event-edit/' + cow.cow_event_id,
        data: cow,
        method: 'PUT'
      }).then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.cowEventPartialUpdate = function (cow) {
      var deferred = $q.defer();

      cowEventEditResource.partial_update(cow).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.cowEventDelete = function (cowId) {
      var deferred = $q.defer();
      var cowData = {
        id: cowId,
        deleted: true
      };
      cowEventEditResource.partial_update(cowData).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.cowEventTempToUser = function (cowId) {
      var deferred = $q.defer();

      cowEventTempUserResource.post({
        cow_id: cowId
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getCow = function (cowId) {
      var deferred = $q.defer();
      cowEventResource.get({
        id: cowId
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getCowPublic = function (cowId) {
      var deferred = $q.defer();
      cowEventPublicResource.get({
        id: cowId
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getCowsEventUser = function () {
      var deferred = $q.defer();
      cowsEventUserResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.cowEventAddContacts = function (cowData) {
      var deferred = $q.defer();

      cowEventAddContactsResource.post(cowData).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getCowEventGuestList = function (cowId) {
      var deferred = $q.defer();

      cowsEventGuestListResource.query({
        cow_id: cowId
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.deleteCowEventGuest = function (contactId) {
      var deferred = $q.defer();

      cowEventDeleteContactResource.post({
        guest_id: contactId
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.resendInviteCowEvent = function (data) {
      var deferred = $q.defer();

      cowEventResendInviteResource.post(data).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.downloadParticipantsList = function (cowId) {
      var deferred = $q.defer();

      cowEventParticipantListDownloadResource.post({
        cow_id: cowId
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.sendThanks = function (thanksData) {
      var deferred = $q.defer();

      sendThanksResource.post(thanksData).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.createGetMoneyRequest = function (cow, bankAccount_id, moneyRequestValue, parcialValueBool, totalValueBool) {
      var deferred = $q.defer();
      var data = {
        cow_id: cow.cow_event_id,
        bank_account_id: bankAccount_id,
        money_request_value: moneyRequestValue,
        parcial_value_bool: parcialValueBool,
        total_value_bool: totalValueBool
      };
      createGetMoneyRequestResource.post(data).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.createEfectyMoneyRequest = function (cow, moneyRequestValue, totalValueBool, efectyUserData) {
      var deferred = $q.defer();
      var data = {
        cow_id: cow.cow_event_id,
        money_request_value: moneyRequestValue,
        total_value_bool: totalValueBool,
        efecty_user_data: efectyUserData
      };
      createEfectyMoneyRequestResource.post(data).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.cowGetMoneyRequest = function (getMoneyRequestId) {
      var deferred = $q.defer();
      cowGetMoneyRequestResource.get({id: getMoneyRequestId}).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.cowGetAllMoneyRequests = function (cowEventId) {
      var deferred = $q.defer();
      cowGetAllMoneyRequestsByCowIdResource.query({cow_event_id: cowEventId}).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.cowGetMoneyRequestByCowId = function (getMoneyRequestId) {
      var deferred = $q.defer();
      cowGetMoneyRequestByCowIdResource.post({cow_id: getMoneyRequestId}).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.validateGiftCode = function (data) {
      var deferred = $q.defer();
      cowValidateGiftCodeResource.post(data).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getCowEventTermsAndConditions = function (slug) {
      var deferred = $q.defer();
      cowEventGiftCodeTermsAndConditionsResource.get({slug: slug}).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.createCowEventMarketplace = function (productSlug, group) {
      var deferred = $q.defer();

      cowEventMarketplaceCreateTempResource.post({
        product_slug: productSlug,
        group: group
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.redeemCowEventMarketplace = function (cowEventId) {
      var deferred = $q.defer();

      cowEventMarketplaceRedeemResource.post({
        cow_event_id: cowEventId
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.saveCowEventContactMe = function (data) {
      var deferred = $q.defer();
      cowEventSaveContactMeResource.post(data).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.createFepCow = function (ticketType, numTickets) {
      var deferred = $q.defer();

      createFepCowResource.post({
        ticketType: ticketType,
        numTickets: numTickets
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.updateCowAdditionalInfo = function (cowId, data) {
      var deferred = $q.defer();

      updateCowAdditionalInfoResource.post({
        cow_id: cowId,
        info: data
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getPublicCows = function (params) {
      var deferred = $q.defer();
      PublicCowsEventResource.get(params).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getCashoutMethods = function () {
      var deferred = $q.defer();
      GetCashoutMethodsResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.upgradeCowPlan = function (cowEventId) {
      var deferred = $q.defer();
      upgradeCowPlanResource.post({
        cow_event_id: cowEventId
      }).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getAvailableCowsCash = function () {
      var deferred = $q.defer();
      GetAvailableCowsCash.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getCategoryCows = function () {
      var deferred = $q.defer();
      CategoryCowsPublicResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.sendMoneyCowCreate = function (user_participation) {
      var deferred = $q.defer();
      Upload.upload({
        url: resourceBaseUrl + '/cw/send-money-cow',
        data: {
          user_participation: user_participation
        }
      }).then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getTokenMoneyRequest = function (token) {
      var deferred = $q.defer();
      cowGetTokenMoneyRequest.get({id: token}).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.resolve(0);
        // deferred.reject(err);
      });
      return deferred.promise;
    };

    service.sendTokenMoneyRequest = function (token, bank_account_info) {
      var deferred = $q.defer();
      Upload.upload({
        url: resourceBaseUrl + '/cw/send-money-cow-token/' + token,
        data: {
          bank_account_info: bank_account_info
        }
      }).then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.requestcowEventPublic = function (cow) {
      var deferred = $q.defer();
      Upload.upload({
        url: resourceBaseUrl + '/cw/request-public-cows/'+ cow,
        data: {
        }
      }).then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    return service;
  });

'use strict';

angular.module('user')
  .factory('banksListResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/bk/banks-list/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('userBankAccountListResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/bk/user-bank-accounts-list/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('createBankAccountUserResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/bk/create-bank-account/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST',
        isArray: false
      }
    });
  })
  .factory('updateBankAccountUserResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/bk/user-bank-account-update/:id", {
      id: '@id'
    }, {
      'partial_update': {
        method: 'PATCH'
      }
    });
  })
  .factory('bankService', function ($q, $http, $state, $timeout, banksListResource, createBankAccountUserResource, userBankAccountListResource,
                                    updateBankAccountUserResource) {

    var service = {};

    service.getBanksList = function () {
      var deferred = $q.defer();
      banksListResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getUserBankAccountList = function () {
      var deferred = $q.defer();
      userBankAccountListResource.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.createBankAccountUser = function (bankAccountData) {
      var deferred = $q.defer();
      createBankAccountUserResource.post(bankAccountData).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.deleteBankAccountUser = function (bankAccountId) {
      var deferred = $q.defer();
      var bankAccountData = {
        id: bankAccountId,
        valid: false
      };
      updateBankAccountUserResource.partial_update(bankAccountData).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    return service;
  });

/**
 * Created by hetdev on 27/03/17.
 */
'use strict';

angular.module('user')
  .factory('frecuentlyQuestionsResource', function ($resource, resourceBaseUrl, brandedCowTypeSlug) {
    return $resource(resourceBaseUrl + "/au/frecuently-questions/" + brandedCowTypeSlug, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('homeImagesResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/au/home-images/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('mediaLinksResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/au/media-links/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('termsAndConditionsResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/au/terms-and-conditions/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: false
      }
    });
  })
  .factory('privatePolicyResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/au/private-policy/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: false
      }
    });
  })
  .factory('teamMembersResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/au/team-members/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('cowTipsResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/au/cow-tips/:id", {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('submitBusinessContactFormResource', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/au/business-contact-form/:id", {
      id: '@id'
    }, {
      'post': {
        method: 'POST'
      }
    });
  })
  .factory('notifyAlerts', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/au/get-notify-alerts/:id", {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('notifyAlertsAdmin', function ($resource, resourceBaseUrl) {
    return $resource(resourceBaseUrl + "/au/get-notify-alerts-admin/:id", {
      'query': {
        method: 'GET',
        isArray: true
      }
    });
  })
  .factory('AboutUsService', function ($rootScope, $q, $http, $state, $timeout, Upload, resourceBaseUrl,
                                       frecuentlyQuestionsResource, homeImagesResource, mediaLinksResource,
                                       termsAndConditionsResource, privatePolicyResource, teamMembersResource,
                                       cowTipsResource, submitBusinessContactFormResource, notifyAlerts, notifyAlertsAdmin) {

    var service = {};

    service.getFrecuentlyQuestions = function () {
      var deferred = $q.defer();

      frecuentlyQuestionsResource.query().$promise.then(function (data) {
        deferred.resolve(data);

      }, function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    };

    service.getHomeImages = function () {
      var deferred = $q.defer();

      homeImagesResource.query().$promise.then(function (data) {
        deferred.resolve(data);

      }, function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    };

    service.getMediaLinks = function () {
      var deferred = $q.defer();

      mediaLinksResource.query().$promise.then(function (data) {
        deferred.resolve(data);

      }, function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    };

    service.getTermsAndConditions = function () {
      var deferred = $q.defer();

      termsAndConditionsResource.query().$promise.then(function (data) {
        deferred.resolve(data);

      }, function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    };

    service.getPrivatePolicy = function () {
      var deferred = $q.defer();

      privatePolicyResource.query().$promise.then(function (data) {
        deferred.resolve(data);

      }, function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    };

    service.validateDocument = function (document, isPdf) {
      var deferred = $q.defer();
      Upload.upload({
        url: resourceBaseUrl + '/au/validate-document',
        data: {
          document_file: document,
          isPdf: isPdf
        }
      }).then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getTeamMembers = function () {
      var deferred = $q.defer();

      teamMembersResource.query().$promise.then(function (data) {
        deferred.resolve(data);

      }, function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    };

    service.getCowTips = function () {
      var deferred = $q.defer();

      cowTipsResource.query().$promise.then(function (data) {
        deferred.resolve(data);

      }, function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    };

    service.submitBusinessContactForm = function (data) {
      var deferred = $q.defer();
      submitBusinessContactFormResource.post(data).$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    service.getNotifyAlerts = function () {
      var deferred = $q.defer();

      notifyAlerts.query().$promise.then(function (data) {
        deferred.resolve(data);

      }, function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    };

    service.getNotifyAlertsAdmin = function () {
      var deferred = $q.defer();
      notifyAlertsAdmin.query().$promise.then(function (data) {
        deferred.resolve(data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    return service;
  });

(function () {
  'use strict';

  angular
    .module('user')
    .directive('onlyDigits', function () {
      return {
        require: 'ngModel',
        restrict: 'A',
        link: function (scope, element, attr, ctrl) {
          function inputValue(val) {
            if (val) {
              var digits = val.replace(/[^0-9]/g, '');
              if (digits !== val) {
                ctrl.$setViewValue(digits);
                ctrl.$render();
              }
              return parseInt(digits, 10);
            }
            return undefined;
          }

          ctrl.$parsers.push(inputValue);
        }
      };
    })
    .directive('digitsNoIndicative', function () {
      return {
        require: 'ngModel',
        restrict: 'A',
        link: function (scope, element, attr, ctrl) {
          function inputValue(val) {
            if (val) {
              var digits = val.replace(/[^0-9]/g, '');
              if (digits.indexOf('57') === 0) {
                digits = digits.replace('57', '');
              }
              if (digits !== val) {
                ctrl.$setViewValue(digits);
                ctrl.$render();
              }
              return parseInt(digits, 10);
            }
            return undefined;
          }

          ctrl.$parsers.push(inputValue);
        }
      };
    })
    .directive('onlyAlphanumeric', function () {
      return {
        require: 'ngModel',
        restrict: 'A',
        link: function (scope, element, attr, ctrl) {
          function inputValue(val) {
            if (val) {
              var characters = val.replace(/[^A-Za-z0-9]/g, '');
              if (characters !== val) {
                ctrl.$setViewValue(characters);
                ctrl.$render();
              }
              return characters;
            }
            return undefined;
          }

          ctrl.$parsers.push(inputValue);
        }
      };
    })
    .directive('noSpecialChars', function () {
      return {
        require: 'ngModel',
        restrict: 'A',
        link: function (scope, element, attr, ctrl) {
          function inputValue(val) {
            if (val) {
              var characters = val.replace(/[^A-Za-zZáéíóúÁÉÍÓÚÑñ0()?¿!¡_*0-9 ]/g, '');
              if (characters !== val) {
                ctrl.$setViewValue(characters);
                ctrl.$render();
              }
              return characters;
            }
            return undefined;
          }

          ctrl.$parsers.push(inputValue);
        }
      };
    })
    .directive('format', ['$filter', function ($filter) {
      return {
        require: '?ngModel',
        link: function (scope, elem, attrs, ctrl) {
          if (!ctrl) return;
          ctrl.$formatters.unshift(function (a) {
            return $filter(attrs.format)(ctrl.$modelValue)
          });
          elem.bind('blur', function (event) {
            var plainNumber = elem.val().replace(/[^\d|\-+|\.+]/g, '');
            elem.val($filter(attrs.format)(plainNumber));
          });
        }
      };
    }])
    .directive('fileModel', ['$parse', function ($parse) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var model = $parse(attrs.fileModel);
          var modelSetter = model.assign;
          element.bind('change', function () {
            scope.$apply(function () {
              modelSetter(scope, element[0].files[0]);
            });
          });
        }
      };
    }])
    .directive('realTimeCurrency', function ($filter, $locale) {
      var decimalSep = $locale.NUMBER_FORMATS.DECIMAL_SEP;
      var toNumberRegex = new RegExp('[^0-9\\' + decimalSep + ']', 'g');
      var trailingZerosRegex = new RegExp('\\' + decimalSep + '0+$');
      var filterFunc = function (value) {
        return $filter('currency')(value);
      };

      function getCaretPosition(input) {
        if (!input) return 0;
        if (input.selectionStart !== undefined) {
          return input.selectionStart;
        } else if (document.selection) {
          // Curse you IE
          input.focus();
          var selection = document.selection.createRange();
          selection.moveStart('character', input.value ? -input.value.length : 0);
          return selection.text.length;
        }
        return 0;
      }

      function setCaretPosition(input, pos) {
        if (!input) return 0;
        if (input.offsetWidth === 0 || input.offsetHeight === 0) {
          return; // Input's hidden
        }
        if (input.setSelectionRange) {
          input.focus();
          input.setSelectionRange(pos, pos);
        } else if (input.createTextRange) {
          // Curse you IE
          var range = input.createTextRange();
          range.collapse(true);
          range.moveEnd('character', pos);
          range.moveStart('character', pos);
          range.select();
        }
      }

      function toNumber(currencyStr) {
        return parseFloat(currencyStr.replace(toNumberRegex, ''), 10);
      }

      return {
        restrict: 'A',
        require: 'ngModel',
        link: function postLink(scope, elem, attrs, modelCtrl) {
          modelCtrl.$formatters.push(filterFunc);
          modelCtrl.$parsers.push(function (newViewValue) {
            var oldModelValue = modelCtrl.$modelValue;
            var newModelValue = toNumber(newViewValue);
            modelCtrl.$viewValue = filterFunc(newModelValue);
            var pos = getCaretPosition(elem[0]);
            elem.val(modelCtrl.$viewValue);
            var newPos = pos + modelCtrl.$viewValue.length -
              newViewValue.length;
            if ((oldModelValue === undefined) || isNaN(oldModelValue)) {
              newPos -= 3;
            }
            setCaretPosition(elem[0], newPos);
            return newModelValue;
          });
        }
      };
    })
    .directive('dynFbCommentBox', function () {
      function createHTML(href, numposts, colorscheme) {
        return '<div class="fb-comments" ' +
          'data-href="' + href + '" ' +
          'data-numposts="' + numposts + '" ' +
          'data-colorsheme="' + colorscheme + '">' +
          'data-width=' + 100 % +' </div>';
      }

      return {
        restrict: 'A',
        scope: {},
        link: function postLink(scope, elem, attrs) {
          attrs.$observe('pageHref', function (newValue) {
            var href = newValue;
            var numposts = attrs.numposts || 5;
            var colorscheme = attrs.colorscheme || 'light';
          });
        }
      };
    })
    .directive('fileReader', function () {
      return {
        scope: {
          fileReader: "=",
          arrayContacts: "="
        },
        link: function (scope, element) {
          $(element).on('change', function (changeEvent) {
            console.log(scope.arrayContacts);
            var files = changeEvent.target.files;
            if (files.length) {
              var r = new FileReader();
              console.log(r);
              r.onload = function (e) {
                var contents = e.target.result;
                if (files[0].name.includes(".txt")) {
                  var text_no_spaces = contents.replace(/\s+/g, '');
                  text_no_spaces = text_no_spaces.replace(/,/g, ';');
                  var just_emails = text_no_spaces.split(';');
                  _.forEach(just_emails, function (value) {
                    if (validateEmail(value) && !_.find(scope.arrayContacts, function (o) {
                      return o.email == value;
                    })) {
                      var contact_email = {
                        img: 'assets/images/user/user-green.svg',
                        name: value,
                        email: value
                      };
                      scope.arrayContacts.push(contact_email);
                    }
                  });
                  scope.$apply(function () {
                    scope.fileReader = contents;
                    scope.arrayContacts = scope.arrayContacts;
                  });
                } else {
                  var workbook = XLSX.read(contents, {
                    type: 'binary'
                  });
                  var sheet_name_list = workbook.SheetNames;
                  var contacts = [];
                  sheet_name_list.forEach(function (y) { /* iterate through sheets */
                    var worksheet = workbook.Sheets[y];
                    for (var z in worksheet) {
                      /* all keys that do not begin with "!" correspond to cell addresses */
                      if (z[0] === '!') continue;
                      var email_array = (JSON.stringify(worksheet[z].v)).split('"');
                      if (email_array.length >= 3) {
                        var email = email_array[1];
                        if (validateEmail(email) && !_.find(scope.arrayContacts, function (o) {
                          return o.email == email;
                        })) {
                          var contact_email = {
                            img: 'assets/images/user/user-green.svg',
                            name: email,
                            email: email
                          };
                          scope.arrayContacts.push(contact_email);
                        }
                      }
                    }
                  });
                  scope.$apply(function () {
                    scope.fileReader = workbook;
                    scope.arrayContacts = scope.arrayContacts;
                  });
                }
              };
              r.readAsBinaryString(files[0]);
            }
            setCaretPosition(elem[0], newPos);
            return newModelValue;
          });
        }
      };
    })
    .directive('onlyDigitsString', function () {
      return {
        require: 'ngModel',
        restrict: 'A',
        link: function (scope, element, attr, ctrl) {
          function inputValue(val) {
            if (val) {
              var digits = val.replace(/[^0-9]/g, '');
              if (digits !== val) {
                ctrl.$setViewValue(digits);
                ctrl.$render();
              }
              return digits;
            }
            return undefined;
          }

          ctrl.$parsers.push(inputValue);
        }
      };
    })
})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('publicCows', publicCows);


  /** @ngInject */
  function publicCows() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/publicCowDirective/publicCows.html',
      scope: {
        cows: '=',
        cowsPublicCategory: '='
      },
      controller: PublicCowsController,
      controllerAs: 'cows-user'
    };
    return directive;

    /** @ngInject */
    function PublicCowsController($scope, $rootScope, ngDialog, $state, cowEventService, smoothScroll) {
      $scope.getTraductor = $rootScope.getTraductor;
      $scope.selectedCategory = 'All';
      $scope.getBackgroudCssStyleCowShadow = function (imgUrl, closed) {
        return $rootScope.getBackgroudCssStyleCowShadow(imgUrl, closed);
      };

      $scope.goToCreatePublicCow = function () {
        $state.go('cow-create', {is_public: true});
      };

      $scope.goToCow = function (cowId) {
        $rootScope.goToCow(cowId);
      };

      $scope.goToCowEdit = function (cowId) {
        $rootScope.goToCowEdit(cowId);
      };

      $scope.goToCowInvite = function (cowId) {
        $rootScope.goToCowInvite(cowId);
      };

      $scope.goToCowGetMoney = function (cowId) {
        $rootScope.goToCowGetMoney(cowId);
      };
      $scope.gotToParticipate = function (cowId) {
        $rootScope.goToCowParticipate(cowId);
      };

      $scope.openCowDeleteConfirmation = function (cow) {
        ngDialog.open({
          template: 'confirmationContactDeleteCowModal-1',
          data: {
            cow: cow
          },
          controller: 'CowDeleteConfirmationModalCtrl'
        });
      };

      $scope.hideClosedCows = false;
      $scope.displayClosedCows = function () {
        $scope.hideClosedCows = !$scope.hideClosedCows;
      };

      $rootScope.$on('refreshCowsUser', function () {

      });
      $scope.changePage = function (page) {
        if ($scope.cows.current_page !== page) {
          cowEventService.getPublicCows({page: page, category: $scope.selectedCategory}).then(function (data) {
            $scope.cows = data;
          });
        }
      };

      var searchBarTimeout = null;
      $scope.searchBarChange = function (e) {
        clearTimeout(searchBarTimeout);
        searchBarTimeout = setTimeout(function () {
          $scope.selectedCategory = 'All';
          cowEventService.getPublicCows({search: e.target.value}).then(function (data) {
            $scope.cows = data;
          });
        }, 1000);
      };

      $scope.scrollToPublicCows = function () {
        var element = document.getElementsByClassName('description-paragraph')[0];
        smoothScroll(element);
      };

      $scope.searchCowPubliCategory = function (element, e) {
        $scope.selectedCategory = e;
        var chip = document.getElementsByClassName('chipa active')[0];
        var el = document.getElementById(element);
        chip.classList.remove('active');
        el.classList.add('active');
        cowEventService.getPublicCows({category: e}).then(function (data) {
          $scope.cows = data;
        });
      }

    }
  }

})();

/**
 * Created by lucas on 29/12/17.
 */

(function () {
    'use strict';

    angular
        .module('user')
        .directive('productShare', productShare);


    /** @ngInject */
    function productShare() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/productShareDirective/productShare.html',
            scope: {
                product: '='
            },
            controller: productShareController,
            controllerAs: 'product-share'
        };

        return directive;

        /** @ngInject */
        function productShareController($scope, $rootScope, toastr, Socialshare, fbAPI, productPublicURL, atvURL) {
            console.log($scope.product);

            $scope.productPublicURLComplete = atvURL + productPublicURL + $scope.product.slug;
            $scope.productPublicURLCompleteCopy = atvURL + productPublicURL + $scope.product.slug;
            $scope.shareText = $scope.product.name;
            $scope.shareImage = $scope.product.main_img;

            $scope.copyLink = function () {
                toastr.success('El link se ha guardado en el portapapeles', 'Link guardado');
            };

            $scope.shareFb = function () {
                Socialshare.share({
                    'provider': 'facebook',
                    'attrs': {
                        'socialshareUrl': $scope.productPublicURLComplete,
                        'socialshareType': 'share',
                        'socialshareVia': fbAPI,
                        'socialshareText': $scope.shareText,
                        'socialshareMedia': $scope.shareImage,
                        'socialshareDescription': 'Armatuvaca online de forma fácil, rapida y segura.',
                        'socialshareCaption': 'Armatuvaca: ' + $scope.shareText,
                        'socialsharePopupHeight': 300,
                        'socialsharePopupWidth': 400
                    }
                });
            };

            $scope.shareTw = function () {
                Socialshare.share({
                    'provider': 'twitter',
                    'attrs': {
                        'socialshareHashtags': "armatuvaca, vacasonline",
                        'socialshareVia': "armatuvaca",
                        'socialshareText': $scope.shareText,
                        'socialshareUrl': $scope.productPublicURLComplete,
                        'socialsharePopupHeight': 250,
                        'socialsharePopupWidth': 500
                    }
                });
            };

            $scope.shareLinkedin = function () {
                Socialshare.share({
                    'provider': 'linkedin',
                    'attrs': {
                        'socialshareText': $scope.shareText,
                        'socialshareUrl': $scope.productPublicURLComplete,
                        'socialshareDescription' : $scope.shareText,
                        'socialshareSource' : 'armatuvaca'
                    }
                });
            };

            $scope.shareWa = function () {
                Socialshare.share({
                    'provider': 'whatsapp',
                    'attrs': {
                        'socialshareText': $scope.shareText + " ",
                        'socialshareUrl': $scope.productPublicURLComplete
                    }
                });
            };

            $scope.shareFbMessenger = function () {
                Socialshare.share({
                    'provider': 'facebook-messenger',
                    'attrs': {
                        'socialshareUrl': $scope.productPublicURLComplete
                    }
                });
            };


        }
    }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('participationBar', participationBar)
    .controller('ParticipationBarController', ParticipationBarController);

  /** @ngInject */
  function participationBar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/participationBar/participationBar.html',
      scope: {
        // participations: '=',
        // product: '='
          currentValue: '=',
          goal: '='
      },
      controller: ParticipationBarController,
      controllerAs: 'participationBar'
    };
    return directive;
  }

  /** @ngInject */
  function ParticipationBarController($scope, moment, $log) {

    console.log("participation barrr");
    console.log($scope.currentValue);
    console.log($scope.goal);

    var percentCompleted = $scope.currentValue / $scope.goal;
    if (percentCompleted > 0.7) {
      $scope.type = "success";
    }
    else if (percentCompleted > 0.3) {
      $scope.type = "warning";
    }
    else {
      $scope.type = "alert";
    }
    console.log(percentCompleted);

    // var types = ['success-1', 'success-2', 'success-3', 'success-4', 'success-5'];
    // $scope.stacked = [];
    //
    // _.forEach($scope.participations, function (participation) {
    //   console.log(participation);
    //   var value_percentage = Math.round(((participation.total_value / $scope.product.price) * 100));
    //   $scope.stacked.push({
    //     value: value_percentage,
    //     // type: types[Math.floor(Math.random() * types.length)]
    //     type:'success-3'
    //   });
    //
    // });
  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('newCalc', newCalc)
    .controller('newCalcController', newCalcController);

  /** @ngInject */
  function newCalc() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/newCalc/newCalc.html',
      scope: {
        onChangeCalc: '&'
      },
      controller: newCalcController,
      controllerAs: 'newCalc',
    };
    return directive;
  }

  /** @ngInject */
  function newCalcController($scope, highValueCowPercentageFee, publicCowPercentageFee, ivaValue) {
    // Track Values
    $scope.track_values = [
      {
        name: "Gratis*",
        min_value: 50000,
        max_value: 1000000,
        step: 50000,
        default_value: 150000,
        label_start: "$50K",
        label_end: "$1M"
      },
      {
        name: "Pro",
        min_value: 1000000,
        max_value: 100000000,
        step: 500000,
        default_value: 1500000,
        label_start: "$1M",
        label_end: "$100M"
      },
      {
        name: "Vacanes",
        min_value: 1000000,
        max_value: 100000000,
        step: 500000,
        default_value: 1500000,
        label_start: "$1M",
        label_end: "$100M"
      },
    ];

    $scope.track_option = 0
    $scope.track_value = $scope.track_values[$scope.track_option].default_value;
    $scope.tax_value = 0;
    $scope.four_by_thousand_tax_value = 0;
    $scope.total_value = 0;

    // Track Methods
    $scope.changeTrack = function () {
      $scope.modifyTrack();
    }
    $scope.calculatePercentTrack = function () {
      var relativeValue = $scope.track_value - $scope.track_values[$scope.track_option].min_value;
      var ticks = $scope.track_values[$scope.track_option].max_value - $scope.track_values[$scope.track_option].min_value;
      return relativeValue / ticks;
    }
    $scope.modifyTrack = function () {
      var bullet = document.getElementsByClassName("atv__calc__slider__bullet")
      var tooltip = document.getElementsByClassName("atv__calc__slider__tooltip")
      var filled = document.getElementsByClassName("atv__calc__slider__track__filled")
      var percent = $scope.calculatePercentTrack();
      var objCalculate = {}
      tooltip[0].style.left = "calc(" + percent * 100 + "% - 73px)";
      bullet[0].style.left = "calc(" + percent * 100 + "% - 17px)";
      filled[0].style.width = "calc(" + percent * 100 + "% - 17px)";


      objCalculate.current_value = $scope.track_value;
      if ($scope.track_option == 1) {
        objCalculate.tax_value = $scope.track_value * highValueCowPercentageFee + ($scope.track_value * highValueCowPercentageFee * ivaValue);
        objCalculate.percentage = highValueCowPercentageFee * 100;
        objCalculate.four_by_thousand_tax_value = 0;
      } else if ($scope.track_option == 2) {
        objCalculate.tax_value = $scope.track_value * publicCowPercentageFee + ($scope.track_value * publicCowPercentageFee * ivaValue);
        objCalculate.percentage = publicCowPercentageFee * 100;
        objCalculate.four_by_thousand_tax_value = 0;
      }else {
        objCalculate.tax_value = 0;
        objCalculate.percentage = 0;
        objCalculate.four_by_thousand_tax_value = $scope.track_value * 0.004;
      }
      objCalculate.total_value = objCalculate.current_value - objCalculate.tax_value - objCalculate.four_by_thousand_tax_value;

      $scope.onChangeCalc(objCalculate);
    }

    $scope.selectOption = function (index) {
      $scope.track_option = index
      $scope.track_value = $scope.track_values[index].default_value;
      $scope.modifyTrack();
    }

    $scope.modifyTrack();


  }

})();

(function () {
    'use strict';

    angular
        .module('user')
        .directive('newBankAccountUser', newBankAccountUser);


    /** @ngInject */
    function newBankAccountUser() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/newBankAccountDirective/newBankAccount.html',
            scope: {
            },
            controller: NewBankAccountController,
            controllerAs: 'new-bank-account'
        };

        return directive;
        /** @ngInject */
        function NewBankAccountController($scope, $state, $rootScope, ngDialog, toastr, bankService) {

            $scope.documentTypes = $rootScope.documentTypes;

            $scope.bankAccountInfo = {};

            $scope.isCollapsed = true;

            $scope.getBanksList = function () {
                bankService.getBanksList().then(function (data) {
                $scope.banksList = data;
                console.log($scope.banksList);
                });
            };

            $scope.getBanksList();

            $scope.setDocumentNumber = function () {
                if ($scope.bankAccountInfo.bank_account_owner_document_full) {
                    $scope.bankAccountInfo.bank_account_owner_document =
                        $scope.bankAccountInfo.bank_account_owner_document_full.replace(/[^0-9]/g, '');
                }
            };

            $scope.setDocumentFullNumber = function () {
                if ($scope.bankAccountInfo.bank_account_owner_document) {
                    $scope.bankAccountInfo.bank_account_owner_document_full = $scope.bankAccountInfo.bank_account_owner_document;
                }
            };

            $scope.addBankAccount = function (isValid) {
                if (isValid) {
                    bankService.createBankAccountUser($scope.bankAccountInfo).then(function (bank_data) {
                        bankService.getUserBankAccountList().then(function (data) {
                            $scope.userBankAccounts = data;
                            toastr.success('Cuenta bancaria agregada con éxito');
                            $scope.formNewBankAccount.$setPristine(true);
                            $scope.formNewBankAccount.$setUntouched(true);
                            $scope.bankAccountInfo = {};
                            $scope.isCollapsed = true;
                            delete $scope.confirm_account_number;
                            $rootScope.$broadcast("updateBankAccountsUser");
                            $rootScope.$broadcast("updateBankAccountsUserGetMoneyRequest", bank_data.bank_account_id);
                        }, function (err) {
                            console.log('err login', err);
                            toastr.error('Error intentando obtener la lista de cuentas bancarias');
                        });
                    }, function (err) {
                        console.log('err login', err);
                        toastr.error('Error intentando agregar la cuenta bancaria');
                    });
                }
            };


        }
    }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('atvNavbar', atvNavbar);

  /** @ngInject */
  function atvNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
        creationDate: '=',
        vacanes: '=',
        loadLang: '&',
        lang: '='
      },
      controller: NavbarController,
      controllerAs: 'navbar'
    };

    return directive;

    /** @ngInject */
    function NavbarController($scope, $mdSidenav, $rootScope, usersService, $state, smoothScroll, marketplaceURL) {

      $scope.marketplaceURL = marketplaceURL;
      $scope.selected_lang = 'es';
      $scope.default_lang = 'es';
      $scope.current_lang = { id: 'es', name: 'Español', icon: 'flag-icon-co' };
      $scope.langs = [
        { id: 'es', name: 'Español', icon: 'flag-icon-co' },
        { id: 'en', name: 'English', icon: 'flag-icon-gb' },
      ];
      $scope.menuOptions = [
        /* {
          id:'navbar_public_cows',
          uihref:'public-cow',
          uioptions:'{reload:true}',
          href:'',
          class:'navbar-a',
          submenu: [],
          description: 'Vacanes',
          required_auth: false          
        }, */
        {
          title: 'Iniciar sesión',
          id: 'navbar_login_link',
          uihref: 'login',
          uioptions: '{reload:true}',
          href: null,
          class: 'navbar-a',
          submenu: [],
          required_auth: true,
          is_logged: false,
          action: null
        },
        {
          title: 'Registrarse',
          id: 'navbar_register_link',
          uihref: 'register',
          uioptions: '{reload:true}',
          href: null,
          class: 'navbar-a',
          submenu: [],
          required_auth: true,
          is_logged: false,
          action: null
        },
        
        {
          title: 'Armar Vaca',
          id: 'navbar_btn_lg_cow_create',
          uihref: 'cow-create',
          uioptions: '{is_public: null},{reload:true}',
          href: null,
          //class:'btn btn-default navbar-button',
          class: 'navbar-a',
          submenu: [],
          required_auth: true,
          action: null,
          is_logged: true

        },
        {
          title: 'Planes',
          id: 'navbar_prices_link',
          uihref: 'prices',
          uioptions: '{reload:true}',
          href: null,
          class: 'navbar-a',
          submenu: [],
          required_auth: false,
          action: null
        },
        {
          title: 'Productos',
          id: 'navbar_hiw_link',
          uihref: null,
          uioptions: '{reload:true}',
          href: null,
          class: 'navbar-a',
          submenu: [
            {
              title: 'Armatuvaca',
              description: 'Reúne y maneja tu dinero en grupo',
              id: null,
              uihref: 'home',
              uioptions: null,
              href: null,
              class: 'navbar-a',
              required_auth: false,
              action: null,
              icon: 'social.svg'
            },
            {
              title: 'Armatuvaca Alcancías',
              description: 'Reserva tu experiencia, congela el precio, paga el resto a tu ritmo y ¡disfruta!',
              id: null,
              uihref: null,
              uioptions: null,
              href: 'https://alcancias.armatuvaca.com/',
              class: 'navbar-a',
              required_auth: false,
              action: null,
              icon: 'piggy.svg'
            },
            {
              title: 'Armatuvaca Pay',
              description: 'Vende y cobra por internet (Wenjoy)',
              id: null,
              uihref: null,
              uioptions: null,
              href: 'https://wenjoy.com.co/',
              class: 'navbar-a',
              required_auth: false,
              action: null,
              icon: 'card.svg'
            },
            // {
            //   title: 'Armatuvaca Crowfunding - Vacanes',
            //   description: 'Haz tu proyecto realidad ó ayuda a quien más lo necesita (Causas sociales, financiación de proyectos)',
            //   id: null,
            //   uihref: 'public-cow',
            //   uioptions: null,
            //   href: null,
            //   class: 'navbar-a',
            //   required_auth: false,
            //   action: null,
            //   icon: 'crowd.svg'
            // },
            // {
            //   title: 'ArmaTuVaca Wallet',
            //   description: 'Tu billetera virtual',
            //   id: null,
            //   uihref: null,
            //   uioptions: null,
            //   href: null,
            //   class: 'navbar-a',
            //   required_auth: false,
            //   action: null,
            //   icon: 'wallet.svg'
            // },
          ],
          required_auth: false,
          action: null
        },
        {
          title: 'Ayuda',
          id: 'navbar_faqs_link',
          uihref: 'frecuently-asked-questions',
          uioptions: '{reload:true}',
          href: null,
          class: 'navbar-a',
          submenu: [],
          required_auth: false,
          action: null
        },
        {
          title: 'Mi cuenta',
          id: 'navbar_cows_user_link',
          uihref: null,
          uioptions: null,
          href: null,
          class: 'navbar-a',
          required_auth: true,
          action: null,
          is_logged: true,
          submenu: [
            {
              id: 'navbar_dp_cows_user_link',
              uihref: 'cash-dashboard',
              uioptions: '{reload:true}',
              href: null,
              class: null,
              title: '<i class="fa fa-home font-color-atv" aria-hidden="true"></i> Mi cuenta',
              description: null,
              required_auth: false,
              action: null
            },
            {
              id: 'navbar_dp_account_link',
              uihref: 'account',
              uioptions: '{reload:true}',
              href: null,
              class: null,
              title: '<i class="fa fa-user font-color-atv" aria-hidden="true"></i> Perfil',
              description: null,
              required_auth: false,
              action: null
            },
            {
              id: 'navbar_my_participations_link',
              uihref: "account({currentTab: '3'})",
              uioptions: '{reload:true}',
              href: null,
              class: null,
              title: '<i class="fa fa-credit-card font-color-atv" aria-hidden="true"></i> Mis Participaciones',
              description: null,
              required_auth: false,
              action: null
            },
            {
              id: 'navbar_my_participations_link',
              uihref: "cows-user",
              uioptions: '{reload:true}',
              href: null,
              class: null,
              title: '<i class="fa fa-list-ul font-color-atv" aria-hidden="true"></i> Mis Vacas',
              description: null,
              required_auth: false,
              action: null
            },
            {
              id: 'navbar_my_participations_link',
              uihref: "account({currentTab: '2'})",
              uioptions: '{reload:true}',
              href: null,
              class: null,
              title: '<i class="fa fa-university font-color-atv" aria-hidden="true"></i> Medios de pago',
              description: null,
              required_auth: false,
              action: null
            },
            {
              id: 'navbar_logout_link',
              uihref: null,
              uioptions: null,
              href: null,
              class: null,
              title: '<i class="fa fa-power-off font-color-atv" aria-hidden="true"></i> Cerrar Sesión',
              description: null,
              required_auth: false,
              action: function(){
                $scope.logOut()
              }
            },
          ],
        }
      ];

      //Vakudate de localstorage
      $scope.loadLang = function () {
        const lang = localStorage.getItem('lang');
        if (lang) {
          $scope.selected_lang = lang;
        }
      };

      $scope.getLang = function () {
        //$scope.current_lang = $scope.langs.find(value => value.id === $scope.selected_lang);
        angular.forEach($scope.langs, function (value, key) {
          if (value.id === $scope.selected_lang) {
            $scope.current_lang = value;
          }
        });
      };

      $scope.loadLang();
      $scope.getLang();

      $scope.toggleRight = function () {
        $mdSidenav('left')
          .toggle()
          .then(function () {
          });
      };

      $scope.checkUserData = function () {
        usersService.getUserData().then(function (data) {
          $scope.logged = true;
          $scope.user = data.user;
        }, function (err) {
          $scope.logged = false;
        });

      };

      $rootScope.$on('loggedIn', function () {
        $scope.checkUserData();
      });

      $rootScope.$on('loggedOut', function () {
        $scope.checkUserData();
      });

      $scope.isOpenRight = function () {
        return $mdSidenav('left').isOpen();
      };

      $scope.close = function () {
        $mdSidenav('left').close()
          .then(function () {
          });
      };

      $scope.logOut = function () {
        usersService.logout();
        $state.go('home', {}, { reload: true });
      };

      $scope.checkUserData();

      $scope.goToCreateCow = function () {
        $state.go('cow-create', { is_public: null }, { reload: true });
        // fbq('trackCustom', 'CrearVaca', {button: 'navbar'});
      };

      $scope.scrollToTopOrGoHome = function () {
        if ($state.current.name == "home") {
          var element = document.getElementById('top-scroll');
          smoothScroll(element);
        } else {
          $state.go('home');
        }
      };
      $scope.loadLang = function () {
        const lang = localStorage.getItem('lang');
        if (lang) {
          $scope.selected_lang = lang;
        }
      };
      $scope.changeLang = function (id) {
        localStorage.setItem('lang', id);
        $scope.loadLang();
        $scope.getLang();
        //document.location.reload();
      };

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('mediaCarousel', mediaCarousel)
    .controller('MediaCarouselController', MediaCarouselController);

  /** @ngInject */
  function mediaCarousel() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/mediaCarousel/mediaCarousel.html',
      scope: {
      },
      controller: MediaCarouselController,
      controllerAs: 'mc'
    };
    return directive;
  }

  /** @ngInject */
  function MediaCarouselController($scope, moment, $log, AboutUsService) {

    AboutUsService.getMediaLinks().then(function (data) {
      $scope.mediaLinks = data;
      $scope.mediaLinksContainers = [];

      var currentIndex = 0;
      var mediaLinksGroup = [];

      $scope.mediaLinks.sort(function (a, b) {
        return a.priority - b.priority;
      });

      for(var i = 0; i < $scope.mediaLinks.length; i++) {
        mediaLinksGroup.push($scope.mediaLinks[i]);
        if ((i+1)%4 === 0) {
          $scope.mediaLinksContainers.push({
            id: currentIndex,
            content: mediaLinksGroup,
            class: "col-md-"+(12/mediaLinksGroup.length)
          });
          currentIndex++;
          mediaLinksGroup = [];
        }
      }
      if (mediaLinksGroup.length > 0) {
        $scope.mediaLinksContainers.push({
          id: currentIndex,
          content: mediaLinksGroup,
          class: "col-md-"+(12/mediaLinksGroup.length)
        });
      }
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('user')
    .directive('marketplaceOffers', marketplaceOffers);

  /** @ngInject */
  function marketplaceOffers() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/marketplaceOffers/marketplaceOffers.html',
      scope: {
        marketplaceOffers: '='
      },
      controller: marketplaceOffersController,
      controllerAs: 'mpo'
    };

    return directive;

    /** @ngInject */
    function marketplaceOffersController($scope, moment, $log, $mdDialog, $rootScope) {

      console.log($scope.marketplaceOffers);

      $scope.offersList = [];
      for (var i=0; i < $scope.marketplaceOffers.products.length; i++) {
        $scope.offersList.push($scope.marketplaceOffers.products[i]);
      }

      for (var i=0; i < $scope.marketplaceOffers.experiences.length; i++) {
        $scope.offersList.push($scope.marketplaceOffers.experiences[i]);
      }

      $scope.offers = [];
      var currentIndex = 0;
      for (var i=0; i < $scope.offersList.length; i++) {
        $scope.offers.push({
          id: currentIndex,
          data: $scope.offersList[i]
        });
        currentIndex++;
      }

      console.log($scope.offers);

      $scope.offersGroups = [];
      var groupLenght = 3;
      var offerGroup = [];
      currentIndex = 0;

      for(var i = 0; i < $scope.offersList.length; i++) {
        offerGroup.push($scope.offersList[i]);
        if ((i+1)%groupLenght === 0) {
          $scope.offersGroups.push({
            id: currentIndex,
            content: offerGroup,
            class: "col-sm-"+(12/offerGroup.length)
          });
          currentIndex++;
          offerGroup = [];
        }
      }
      if (offerGroup.length > 0) {
        $scope.offersGroups.push({
          id: currentIndex,
          content: offerGroup,
          class: "col-sm-"+(12/offerGroup.length)
        });
      }

      $scope.goToCreateCow = function() {
        $rootScope.goToCreateCow();
      };
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('user')
    .directive('marketplaceCategories', marketplaceCategories);

  /** @ngInject */
  function marketplaceCategories() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/marketplaceCategories/marketplaceCategories.html',
      scope: {
        marketplaceCategories: '='
      },
      controller: marketplaceCategoriesController,
      controllerAs: 'mpc'
    };

    return directive;

    /** @ngInject */
    function marketplaceCategoriesController($scope, marketplaceURL) {
      $scope.categories = $scope.marketplaceCategories.categories.slice(0,6);

      $scope.marketplaceURL = marketplaceURL;

      console.log($scope.categories);

      $scope.openCategory = function (category) {
        window.open(marketplaceURL + "categoria/" + category, "_self");
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('user')
    .directive('hiw4Steps', hiw4Steps);

  /** @ngInject */
  function hiw4Steps() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/howItWorks4Steps/howItWorks4Steps.html',
      scope: {
        showTitle: '=',
        exampleVideo: '='
      },
      controller: hiw4StepsController,
      controllerAs: 'hiw-directive'
    };

    return directive;

    /** @ngInject */
    function hiw4StepsController($scope, moment, $log, $mdDialog, $rootScope) {
      $scope.myInterval = 6000;
      $scope.noWrapSlides = false;
      $scope.carouselIndex = 0;
      $scope.slides_cow = [];
      $scope.slide_1_cow = {
        id: 0,
        title: '1. Crea',
        description: 'La Vaca del paseo, asado, despedida...',
        image: "assets/images/how-it-works/step-1.png"
      };
      $scope.slide_2_cow = {
        id: 1,
        title: '2. Invita',
        description: 'Facebook, Messenger, WhatsApp y Twitter.',
        image: "assets/images/how-it-works/step-2.png"
      };
      $scope.slide_3_cow = {
        id: 2,
        title: '3. Recolecta',
        description: 'PSE, Visa, MasterCard o Diners.',
        image: "assets/images/how-it-works/step-3.png"
      };
      $scope.slide_4_cow = {
        id: 3,
        title: '4. Usa',
        description: 'En tu cuenta bancaria colombiana.',
        image: "assets/images/how-it-works/step-4.png"
      };

      $scope.slides_cow = [$scope.slide_1_cow, $scope.slide_2_cow, $scope.slide_3_cow, $scope.slide_4_cow];


      $scope.showAdvanced = function(ev) {
        $mdDialog.show({
            locals: {
                showVideo: $scope.exampleVideo
            },
            controller: DialogController,
            templateUrl: 'dialog1.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: false // Only for -xs, -sm breakpoints.
          })
          .then(function() {
            // $scope.status = 'You said the information was "' + answer + '".';
          }, function() {
            // $scope.status = 'You cancelled the dialog.';
          });
      };

      $scope.goToCreateCow = function() {
        $rootScope.goToCreateCow();
      };

      function DialogController($scope, $mdDialog, showVideo) {
        $scope.showVideo = showVideo;

        $scope.hide = function() {
          $mdDialog.hide();
        };

        $scope.cancel = function() {
          $mdDialog.cancel();
        };

        $scope.answer = function(answer) {
          $mdDialog.hide(answer);
        };
      };


    }
  }

})();

(function() {
    'use strict';

    angular
        .module('user')
        .factory('FormSubmitter', FormSubmitter)
        .directive('formSubmitter', formSubmitterDirective);

    function FormSubmitter($rootScope, $sce) {
        // Expose our Api
        return {
            submit: submit
        }


        function submit(url, method, params) {
            url = $sce.trustAsResourceUrl(url);

            $rootScope.$broadcast('form.submit', {
                url: url,
                method: method,
                params: params
            });
        }
    }
    
    function formSubmitterDirective($timeout) {
        return {
            restrict: 'E',
            replace: true,
            template:
                '<form action="{{ formData.url }}" method="{{ formData.method }}">' +
                '   <div ng-repeat="(key,val) in formData.params">' +
                '       <input type="hidden" name="{{ key }}" value="{{ val }}" />' +
                '   </div>' +
                '</form>',
            link: function($scope, $element, $attrs) {
                $scope.$on('form.submit', function(event, data) {
                    $scope.formData = data;

                    console.log('auto submitting form...');

                    $timeout(function() {
                        $element.submit();
                    })
                })
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('atvFooter', atvFooter)
    .controller('FooterController', FooterController);

  /** @ngInject */
  function atvFooter() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html',
      scope: {
      },
      controller: FooterController,
      controllerAs: 'footer'
    };
    return directive;
  }

  /** @ngInject */
  function FooterController($scope, moment, $log, ngDialog, toastr) {
    $scope.businessContact = {};

    $scope.openAtvBusinessContact = function () {
      ngDialog.open({
        template: 'atvBusinessContactModal',
        data: {
        },
        controller: 'FooterController'
      });
    };

    $scope.submitAtvBusinessContact = function () {
      console.log($scope.businessContact);
      AboutUsService.submitBusinessContactForm($scope.businessContact).then(function (data) {
        toastr.success('Formulario enviado con éxito');
        ngDialog.close();
      }, function (err) {
        console.log(err);
        toastr.error('Intentalo nuevamente mas tarde', 'Error enviando el formulario');
      })
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('feedback', feedback)

  /** @ngInject */
  function feedback() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/feedbackDirective/feedback.html',
      scope: {},
      controller: feedbackController,
      controllerAs: 'fbDirective'
    };
    return directive;
  }

  /** @ngInject */
  function feedbackController($scope, feedbackService) {
    $scope.getFeedbackCows = function () {
      feedbackService.getFeedbackList().then(function (data) {
        $scope.listFeedback = data.feedback_cows.slice(0,3);
      });
    };
    $scope.getFeedbackCows();
  }

})();

/**
 * Created by lucas on 24/04/17.
 */

(function () {
  'use strict';

  angular
    .module('user')
    .directive('feedbackCarousel', feedbackCarousel)
    .controller('fdCarouselController', fdCarouselController);

  /** @ngInject */
  function feedbackCarousel() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/feedbackCarousel/feedbackCarousel.html',
      scope: {},
      controller: fdCarouselController,
      controllerAs: 'fdCarousel'
    };
    return directive;
  }

    /** @ngInject */
    function fdCarouselController($scope, feedbackService) {

      feedbackService.getFeedbackList().then(function (data) {
        $scope.feedbackPayments = data.feedback_payments;
        $scope.feedbackCows = data.feedback_cows;
        $scope.feedbackUsers = data.feedback_users;

        $scope.feedbackList = [];
        for (var i=0; i < $scope.feedbackPayments.length; i++) {
          $scope.feedbackList.push($scope.feedbackPayments[i]);
        }
        for (var i=0; i < $scope.feedbackCows.length; i++) {
          $scope.feedbackList.push($scope.feedbackCows[i]);
        }
        for (var i=0; i < $scope.feedbackUsers.length; i++) {
          $scope.feedbackList.push($scope.feedbackUsers[i]);
        }

        $scope.feedbacksGroups = [];

        var groupLenght = 3;
        var currentIndex = 0;
        var feedbacksGroup = [];

        for(var i = 0; i < $scope.feedbackList.length; i++) {
          feedbacksGroup.push($scope.feedbackList[i]);
          if ((i+1)%groupLenght === 0) {
            $scope.feedbacksGroups.push({
              id: currentIndex,
              content: feedbacksGroup,
              class: "col-md-"+(12/feedbacksGroup.length)
            });
            currentIndex++;
            feedbacksGroup = [];
          }
        }
        if (feedbacksGroup.length > 0) {
          $scope.feedbacksGroups.push({
            id: currentIndex,
            content: feedbacksGroup,
            class: "col-md-"+(12/feedbacksGroup.length)
          });
        }
      });

      $scope.stars = [
        {value:1},
        {value:2},
        {value:3},
        {value:4},
        {value:5}
      ];
    }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('cowsUser', cowsUser)
    .controller('CowDeleteConfirmationModalCtrl', function ($scope, ngDialog, toastr, cowEventService, $rootScope, $state) {


      $scope.closeSecond = function (closeId) {
        ngDialog.close(closeId);
      };

      $scope.confirmationDeleteCow = function (cow, closeId) {
        ngDialog.close();
        cowEventService.cowEventDelete(cow.cow_event_id).then(function (data) {
          $state.reload();
          toastr.success('Vaca borrada con éxito');
        }, function (err) {
          console.log('err login', err);
          toastr.error('Error tratando de eliminar la vaca');
        });

      };

      $scope.goToCreateCow = function () {
        $state.go('cow-create');
        // fbq('trackCustom', 'CrearVaca', {button: 'calculator'});
      };

    });


  /** @ngInject */
  function cowsUser() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cowsDirective/cows.html',
      scope: {
        cows: '='
      },
      controller: CowsUserController,
      controllerAs: 'cows-user'
    };

    return directive;

    /** @ngInject */
    function CowsUserController($scope, $rootScope, ngDialog) {

      $scope.getBackgroudCssStyleCowShadow = function (imgUrl, closed) {
        return $rootScope.getBackgroudCssStyleCowShadow(imgUrl, closed);
      };

      $scope.goToCreateCow = function () {
        $rootScope.goToCreateCow();
      };

      $scope.goToCowAdmin = function (cowId) {
        console.log(cowId);
        $rootScope.goToCowAdmin(cowId);
      };

      $scope.goToCowEdit = function (cowId) {
        $rootScope.goToCowEdit(cowId);
      };

      $scope.goToCowInvite = function (cowId) {
        $rootScope.goToCowInvite(cowId);
      };

      $scope.goToCowGetMoney = function (cowId) {
        console.log(cowId);
        $rootScope.goToCowGetMoney(cowId);
      };

      $scope.openCowDeleteConfirmation = function (cow) {
        ngDialog.open({
          template: 'confirmationContactDeleteCowModal-1',
          data: {
            cow: cow
          },
          controller: 'CowDeleteConfirmationModalCtrl'
        });
      };

      $scope.hideClosedCows = true;
      $scope.displayClosedCows = function () {
        $scope.hideClosedCows = !$scope.hideClosedCows;
      };

      $rootScope.$on('refreshCowsUser', function () {

      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('cowTips', cowTips)
    .controller('cowTipsController', cowTipsController);

  /** @ngInject */
  function cowTips() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cowTips/cowTips.html',
      scope: {},
      controller: cowTipsController,
      controllerAs: 'cowTips'
    };
    return directive;
  }

  /** @ngInject */
  function cowTipsController($scope, AboutUsService) {

    AboutUsService.getCowTips().then(function (data) {

      $scope.cowTipsList = data;

      $scope.cowTipsGroups = [];

      var groupLenght = 3;
      var currentIndex = 0;
      var cowTipsGroup = [];

      for(var i = 0; i < $scope.cowTipsList.length; i++) {
        cowTipsGroup.push($scope.cowTipsList[i]);
        if ((i+1)%groupLenght === 0) {
          $scope.cowTipsGroups.push({
            id: currentIndex,
            content: cowTipsGroup,
            class: "col-md-"+(12/cowTipsGroup.length)
          });
          currentIndex++;
          cowTipsGroup = [];
        }
      }
      if (cowTipsGroup.length > 0) {
        $scope.cowTipsGroups.push({
          id: currentIndex,
          content: cowTipsGroup,
          class: "col-md-"+(12/cowTipsGroup.length)
        });
      }

      console.log($scope.cowTipsGroups);
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('cowShare', cowShare);


  /** @ngInject */
  function cowShare() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cowShareDirective/cowShare.html',
      scope: {
        cow: '=',
        isAdmin: '=',
        cowBusinessType: '='
      },
      controller: CowShareController,
      controllerAs: 'cow-share'
    };

    return directive;

    /** @ngInject */
    function CowShareController($scope, $rootScope, atvURL, cowPublicURL, toastr, Socialshare, fbAPI, $state, ngDialog,
                                cowBusinessTypeCredibanco, credibancoCowPublicURL) {
      $scope.getTraductor = $rootScope.getTraductor;

      $scope.cow_event = $scope.cow;
      // console.log($scope.cow_event);
      console.log($scope.isAdmin);
      console.log($scope.cowBusinessType);

      $scope.cowBusinessTypeCredibanco = cowBusinessTypeCredibanco;

      if ($scope.cowBusinessType === cowBusinessTypeCredibanco) {
        $scope.cowPublicURLComplete = atvURL + credibancoCowPublicURL + $scope.cow_event.cow_event_id;
        $scope.cowPublicURLCompleteCopy = atvURL + credibancoCowPublicURL + $scope.cow_event.cow_event_id;
      }
      else {
        $scope.cowPublicURLComplete = atvURL + cowPublicURL + $scope.cow_event.cow_event_id;
        $scope.cowPublicURLCompleteCopy = atvURL + cowPublicURL + $scope.cow_event.cow_event_id;
      }

      $scope.copyLink = function () {
        toastr.success('El link de la Vaca se ha guardado en el portapapeles', 'Link guardado');
      };

      $scope.shareFb = function () {
        Socialshare.share({
          'provider': 'facebook',
          'attrs': {
            'socialshareUrl': $scope.cowPublicURLComplete,
            'socialshareType': 'share',
            'socialshareVia': fbAPI,
            'socialshareText': $scope.cow_event.name,
            'socialshareMedia': $scope.cow_event.main_img,
            'socialshareDescription': 'Armatuvaca online de forma fácil, rapida y segura.',
            'socialshareCaption': 'Armatuvaca: ' + $scope.cow_event.name,
            'socialsharePopupHeight': 300,
            'socialsharePopupWidth': 400
          }
        });
      };

      $scope.shareTw = function () {
        Socialshare.share({
          'provider': 'twitter',
          'attrs': {
            'socialshareHashtags': "armatuvaca, vacasonline",
            'socialshareVia': "armatuvaca",
            'socialshareText': $scope.cow_event.name,
            'socialshareUrl': $scope.cowPublicURLComplete,
            'socialsharePopupHeight': 250,
            'socialsharePopupWidth': 500
          }
        });
      };

      $scope.shareLinkedin = function () {
        Socialshare.share({
          'provider': 'linkedin',
          'attrs': {
            'socialshareText': $scope.cow_event.name,
            'socialshareUrl': $scope.cowPublicURLComplete,
            'socialshareDescription' : $scope.cow_event.name,
            'socialshareSource' : 'armatuvaca'
          }
        });
      };

      $scope.shareWa = function () {
        Socialshare.share({
          'provider': 'whatsapp',
          'attrs': {
            'socialshareText': $scope.cow_event.name + " ",
            'socialshareUrl': $scope.cowPublicURLComplete
          }
        });
      };

      $scope.shareFbMessenger = function () {
        Socialshare.share({
          'provider': 'facebook-messenger',
          'attrs': {
            'socialshareUrl': $scope.cowPublicURLComplete
          }
        });
      };

      $scope.goToContactMe = function () {
        $state.go('cow-contact-me', {cowId: $scope.cow_event.cow_event_id}, {reload: true});
      };

      $scope.openQR = function () {
        ngDialog.open({
          template: 'QRCodeModal',
          width: 300,
          data: {
            cowParticipateURL: $scope.cowPublicURLComplete
          }
        });
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('user')
    .directive('cowQuickCreate', cowQuickCreate);

  /** @ngInject */
  function cowQuickCreate() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cowQuickCreate/cowQuickCreate.html',
      scope: {
        cowEventTypes: '='
      },
      controller: cowQuickCreateController,
      controllerAs: 'cqc'
    };

    return directive;

    /** @ngInject */
    function cowQuickCreateController($scope, moment, $log, $mdDialog, $rootScope, $state, minPaymentValue,
                                      maxPaymentValue) {

      console.log($scope.cowEventTypes);

      $scope.cow = {};

      $scope.minPaymentValue = minPaymentValue;
      $scope.maxPaymentValue = maxPaymentValue;

      $scope.cowEventTypesList = $scope.cowEventTypes;

      $scope.animationClass = 'box-one';

      $scope.cowEventTypeChanged = function (typeString) {
        $scope.cow_type = typeString;
        $scope.main_img_raw = $scope.cow_type.example_img;
        if ($scope.animationClass == 'box-one') {
          $scope.animationClass = 'box-two';
        } else if ($scope.animationClass == 'box-two') {
          $scope.animationClass = 'box-one';
        }
        $scope.cowType = $scope.cow_type.id;
      };

      var cowEventTemp = _.first($scope.cowEventTypesList);
      $scope.cowTypeString = cowEventTemp;
      $scope.cowEventTypeChanged(cowEventTemp);

      $scope.getCowEventTypeEmotivaca = function () {
        return $scope.cow_type.emotivaca;
      };

      $scope.selectParticipationFree = function () {
        $scope.cow.participation_suggested = false;
        $scope.cow.participation_fixed = false;
        $scope.cow.participant_value_suggested = undefined;
        $scope.cow.participant_value_fixed = undefined;
      };
      $scope.cow.participation_free = true;
      $scope.selectParticipationFree();

      $scope.selectParticipationSuggested = function () {
        $scope.cow.participation_free = false;
        $scope.cow.participation_fixed = false;
        $scope.cow.participant_value_fixed = undefined;
      };

      $scope.selectParticipationFixed = function () {
        $scope.cow.participation_free = false;
        $scope.cow.participation_suggested = false;
        $scope.cow.participant_value_suggested = undefined;
      };

      $scope.goToCreateCow = function (isValid) {
        if ($scope.cow.participation_suggested && $scope.cow.participant_value_suggested < $scope.minPaymentValue) {
          isValid = false;
        }
        else if ($scope.cow.participation_suggested && $scope.cow.participant_value_suggested > $scope.maxPaymentValue) {
          isValid = false;
        }
        else if ($scope.cow.participation_fixed && $scope.cow.participant_value_fixed < $scope.minPaymentValue) {
          isValid = false;
        }
        else if ($scope.cow.participation_fixed && $scope.cow.participant_value_fixed > $scope.maxPaymentValue) {
          isValid = false;
        }
        else if (isValid) {
          if ($scope.cow.participation_free) {
            $state.go('cow-create', {cow_name: $scope.cow.name, cow_type: $scope.cow_type.id}, {reload: true});
          }
          else if ($scope.cow.participation_suggested) {
            $state.go('cow-create', {cow_name: $scope.cow.name, cow_type: $scope.cow_type.id, participation_type: 2,
              participant_value: $scope.cow.participant_value_suggested}, {reload: true});
          }
          else if ($scope.cow.participation_fixed) {
            $state.go('cow-create', {cow_name: $scope.cow.name, cow_type: $scope.cow_type.id, participation_type: 3,
              participant_value: $scope.cow.participant_value_fixed}, {reload: true});
          }
        }
      };
    }
  }

})();

/**
 * Created by lucas on 16/01/18.
 */

(function () {
    'use strict';

    angular
        .module('user')
        .directive('countdownTimer', countdownTimer)
        .controller('CountdownTimerController', CountdownTimerController);

    /** @ngInject */
    function countdownTimer() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/countdownTimer/countdownTimer.html',
            scope: {
                deadline: '=',
                publicCow: '='
            },
            controller: CountdownTimerController,
            controllerAs: 'countdownTimer'
        };
        return directive;
    }

    /** @ngInject */
    function CountdownTimerController($scope, $rootScope, moment, $log) {
        console.log("countdown");
        console.log($scope.deadline);
        console.log($scope.publicCow);

        var today = new Date();
        var deadlineDate = new Date($scope.deadline);
        deadlineDate.setHours(23);
        deadlineDate.setMinutes(59);
        deadlineDate.setSeconds(59);

        var diffMiliseconds = deadlineDate - today;

        if (diffMiliseconds < 0) {
            $scope.daysLeft = 0;
            $scope.hoursLeft = 0;
            $scope.minutesLeft = 0;
            $scope.secondsLeft = 0;
            if ($scope.publicCow) {
                $scope.cowFinished = true;
            }
        }
        else {
            var totalDays = diffMiliseconds/1000/60/60/24;
            $scope.daysLeft = Math.floor(totalDays);
            var totalHours = (totalDays - $scope.daysLeft) * 24;
            $scope.hoursLeft = Math.floor(totalHours);
            var totalMinutes = (totalHours - $scope.hoursLeft) * 60;
            $scope.minutesLeft = Math.floor(totalMinutes);
            var totalSeconds = (totalMinutes - $scope.minutesLeft) * 60;
            $scope.secondsLeft = Math.round(totalSeconds);
        }

        $scope.getTraductor = $rootScope.getTraductor;
    }

})();


(function () {
  'use strict';

  angular
    .module('user')
    .directive('atvCalculator', atvCalculator);

  /** @ngInject */
  function atvCalculator() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/calculator/calculator.html',
      scope: {
        matrixCommissions: "="
      },
      controller: CalculatorController,
      controllerAs: 'calculator'
    };

    return directive;

    /** @ngInject */
    function CalculatorController($scope, $state, minPaymentValue, maxPaymentValue) {
      console.log($scope.matrixCommissions);
      console.log('calculator');
      $scope.commission_added = true;
      $scope.commission_deducted = false;

      $scope.minPaymentValue = minPaymentValue;
      $scope.maxPaymentValue = maxPaymentValue;

      $scope.commissionObj = {
        percentage: true,
        percentage_value: 0.1
      };
      $scope.participant_value_temp = 0;
      $scope.participants_value_temp = 2;
      $scope.commission_value = $scope.participant_value * $scope.commissionObj.percentage_value;
      $scope.participant_value_commission = $scope.participant_value + ($scope.participant_value * $scope.commissionObj.percentage_value);


      $scope.checkCommisionsToMatrix = function () {
        var commTemp = _.find($scope.matrixCommissions, function (o) {
          return o.min_value <= $scope.participant_value && o.max_value > $scope.participant_value;
        });
        if (commTemp) {
          $scope.commissionObj = commTemp;
        }
        // console.log(commTemp);
      };

      $scope.participantValueChanged = function () {
        if ($scope.participant_value >= minPaymentValue && $scope.participant_value <= maxPaymentValue) {
          $scope.checkCommisionsToMatrix();
          $scope.commssionChanged();
        }
      };

      $scope.commissionAddedChanged = function () {
        if ($scope.commission_added) {
          $scope.commission_deducted = false;
          $scope.commssionChanged();
        } else {
          $scope.commission_added = true;
          $scope.commssionChanged();
        }
      };
      $scope.commissionDeductedChanged = function () {
        if ($scope.commission_deducted) {
          $scope.commission_added = false;
          $scope.commssionChanged();

        } else {
          $scope.commission_deducted = true;
          $scope.commssionChanged();
        }
      };

      $scope.calculateCommissionAmmountPercentange = function () {
        if ($scope.commission_added) {
          $scope.commission_value = $scope.participant_value_temp * $scope.commissionObj.percentage_value;
          $scope.participant_value_temp_commission = $scope.participant_value_temp + $scope.commission_value;
          $scope.total_value_obtained = $scope.participant_value_temp;

          $scope.owner_added_participant_pay = $scope.participant_value_temp_commission;
          $scope.owner_added_participant_get = $scope.participant_value_temp_commission - $scope.commission_value;

          $scope.owner_deducted_participant_pay = $scope.participant_value_temp;
          $scope.owner_deducted_participant_get = $scope.participant_value_temp - $scope.commission_value;
        } else if ($scope.commission_deducted) {
          $scope.participant_value_temp_commission = $scope.participant_value_temp;
          $scope.commission_value = $scope.participant_value_temp * $scope.commissionObj.percentage_value;
          $scope.total_value_obtained = $scope.participant_value_temp - $scope.commission_value;

          $scope.owner_added_participant_pay = $scope.participant_value_temp + ($scope.participant_value_temp * $scope.commissionObj.percentage_value);
          $scope.owner_added_participant_get = $scope.participant_value_temp;

          $scope.owner_deducted_participant_pay = $scope.participant_value_temp;
          $scope.owner_deducted_participant_get = $scope.participant_value_temp - $scope.commission_value;
        }
      };

      $scope.calculateCommissionAmmountFixed = function () {
        if ($scope.commission_added) {
          $scope.commission_value = $scope.commissionObj.fixed_value;
          $scope.participant_value_temp_commission = $scope.participant_value_temp + $scope.commission_value;
          $scope.total_value_obtained = $scope.participant_value_temp;

          $scope.owner_added_participant_pay = $scope.participant_value_temp_commission;
          $scope.owner_added_participant_get = $scope.participant_value_temp_commission - $scope.commission_value;

          $scope.owner_deducted_participant_pay = $scope.participant_value_temp;
          $scope.owner_deducted_participant_get = $scope.participant_value_temp - $scope.commission_value;
        } else if ($scope.commission_deducted) {
          $scope.participant_value_temp_commission = $scope.participant_value_temp;
          $scope.commission_value = $scope.commissionObj.fixed_value;
          $scope.total_value_obtained = $scope.participant_value_temp - $scope.commission_value;

          $scope.owner_added_participant_pay = $scope.participant_value_temp + $scope.commissionObj.fixed_value;
          $scope.owner_added_participant_get = $scope.participant_value_temp;

          $scope.owner_deducted_participant_pay = $scope.participant_value_temp;
          $scope.owner_deducted_participant_get = $scope.participant_value_temp - $scope.commission_value;
        }
      };

      $scope.commssionChanged = function () {
        if ($scope.participant_value != null) {
          $scope.participant_value_temp = $scope.participant_value;
        }
        if ($scope.commissionObj) {
          if ($scope.commissionObj.fixed) {
            $scope.calculateCommissionAmmountFixed();
            console.log('fijo', $scope.commissionObj);
          } else if ($scope.commissionObj.percentage) {
            $scope.calculateCommissionAmmountPercentange();
            console.log('porcentaje', $scope.commissionObj);
          } else {
            $scope.calculateCommissionAmmountPercentange();
          }

        } else {
          $scope.calculateCommissionAmmountPercentange();
        }

      };

      $scope.goToCreateCow = function () {
        $state.go('cow-create', {
          participantValue: $scope.participant_value,
          commissionAdded: $scope.commission_added,
          commissionDeducted: $scope.commission_deducted
        });
        // fbq('trackCustom', 'CrearVaca', {button: 'calculator'});
      };

      $scope.commssionChanged();


    }
  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('cashoutCalculator', cashoutCalculator);

  /** @ngInject */
  function cashoutCalculator() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cashoutCalculator/cashoutCalculator.html',
      scope: {
        selectedFee: '='
      },
      controller: CachoutCalculatorController,
      controllerAs: 'calculatorCtrl'
    };

    return directive;

    /** @ngInject */
    function CachoutCalculatorController($scope, $state, minGetMoneyValue, ivaValue, businessCowPercentageFee,
                                         publicCowPercentageFee, maxTotalValueFreePlan) {

      $scope.minGetMoneyValue = minGetMoneyValue;
      $scope.ivaValue = ivaValue;

      $scope.cashoutValue = minGetMoneyValue;

      $scope.$watch("selectedFee",function(newValue, oldValue) {
        if ($scope.selectedFee === 2) {
          $scope.select3PercentFee()
        }
        else if ($scope.selectedFee === 3) {
          $scope.select5PercentFee()
        }
        else {
          $scope.selectFreeFee()
        }
      });

      $scope.freeFeeSelected = true;
      $scope.threePercentFeeSelected = false;
      $scope.fivePercentFeeSelected = false;

      $scope.selectFreeFee = function () {
        $scope.freeFeeSelected = true;
        $scope.threePercentFeeSelected = false;
        $scope.fivePercentFeeSelected = false;
        $scope.cashoutValueChanged();
      };

      $scope.select3PercentFee = function () {
        $scope.freeFeeSelected = false;
        $scope.threePercentFeeSelected = true;
        $scope.fivePercentFeeSelected = false;
        $scope.cashoutValueChanged();
      };

      $scope.select5PercentFee = function () {
        $scope.freeFeeSelected = false;
        $scope.threePercentFeeSelected = false;
        $scope.fivePercentFeeSelected = true;
        $scope.cashoutValueChanged();
      };

      $scope.cashoutValueChanged = function () {
        if ($scope.freeFeeSelected && $scope.cashoutValue > maxTotalValueFreePlan) {
          $scope.freeFeeSelected = false;
          $scope.threePercentFeeSelected = true;
        }

        if ($scope.freeFeeSelected) {
          $scope.commissionValue = 0;
          $scope.fourByThousandTax = $scope.cashoutValue * 0.004;
        }

        else if ($scope.threePercentFeeSelected) {
          $scope.commissionValue = $scope.cashoutValue * businessCowPercentageFee;
          $scope.fourByThousandTax = 0;
        }

        else if ($scope.fivePercentFeeSelected) {
          $scope.commissionValue = $scope.cashoutValue * publicCowPercentageFee;
          $scope.fourByThousandTax = 0;
        }

        $scope.ivaValue = $scope.commissionValue * ivaValue;
        $scope.totalValueReceived = $scope.cashoutValue - $scope.commissionValue - $scope.ivaValue - $scope.fourByThousandTax;
      };

      $scope.cashoutValueChanged();

      $scope.goToCreateCow = function () {
        $state.go('cow-create');
        // fbq('trackCustom', 'CrearVaca', {button: 'calculator'});
      };
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('adminNavBar', adminNavBar);

  /** @ngInject */
  function adminNavBar() {

    return {
      restrict: 'E',
      templateUrl: 'app/components/adminNavBar/adminNavBar.html',
      // scope: {
      //   showTitle: '=',
      //   exampleVideo: '='
      // },
      controller: adminNavBarController,
      controllerAs: 'adminnavbar-directive',
      transclude: true
    };

    /** @ngInject */
    function adminNavBarController($scope, moment, $log, $mdDialog, $rootScope, usersService, $state) {


      $scope.user = {
        user:{
          first_name: null
        }
      };
      $scope.checkUserData = function () {
        usersService.getUserData().then(function (data) {
          $scope.logged = true;
          $scope.user = data.user;
        }, function (err) {
          $scope.logged = false;
        });

      };
      $scope.logOut = function () {
        usersService.logout();
        $state.go('home', {}, {reload: true});
      };


      $rootScope.$on('loggedIn', function () {
        $scope.checkUserData();
      });

      $rootScope.$on('loggedOut', function () {
        $scope.checkUserData();
      });

      $scope.checkUserData();


    }
  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .directive('barHome', barHome)
    .controller('barHomeController', barHomeController);

  /** @ngInject */
  function barHome() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/barHome/barHome.html',
      scope: {
        onSelectedItem: "&"
      },
      controller: barHomeController,
      controllerAs: 'barHome',
    };
    return directive;
  }

  /** @ngInject */
  function barHomeController($scope) {
    $scope.active_item = 1;
    $scope.onSelectedItem({item: 1});
    $scope.bar_items = [
      {title: "Alcancías", desc: "Para viajes, regalos, fiestas, compras y mas...",icon:"piggy.svg"},
      {title: "Reune dinero", desc: "Para viajes, regalos, fiestas, compras y mas...",icon:"social.svg"},
      // {title: "Causas sociales", desc: "Dar una mano, crea o aporta a una causa social",icon:"crowd.svg"},
      // {title: "Maneja tu dinero", desc: "Transfiere, recibe y cobra dinero a tu Vaca",icon:"wallet.svg"},
      {title: "Para negocios", desc: "Recibe pagos con Tarjeta o PSE para ti o tu negocio",icon:"card.svg"},
    ]
    $scope.clickItem = function(item) {
      $scope.active_item = item;
      $scope.onSelectedItem({item: item});
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, usersService, $state, GAuth, GData, ggAPI,
    ngMeta, $transitions, fbAccessToken, atvURL, cowPublicURL, minPaymentValue,
    maxPaymentValue, dictionary, $mdDialog, jwtPubKey) {

    ngMeta.init();

    $transitions.onFinish({}, function (trans) {
      $rootScope.$broadcast('$routeChangeSuccess', trans.to());
    });

    // $trace.enable('TRANSITION');

    $transitions.onSuccess({}, function (trans) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });


    $state.defaultErrorHandler(function (error) {
      console.log('error', error);

      // JWT Validator
      var pubkey = KEYUTIL.getKey(jwtPubKey);
      var token = localStorage.token;
      if (token) {
        try {
          var isValidJwt = KJUR.jws.JWS.verifyJWT(token, pubkey, { alg: ['RS256'] });
          if (!isValidJwt) {
            usersService.logout();
            $state.go('home', {}, { reload: true });
          } else {
            $state.go('login', {}, { reload: true });
          }
        } catch (err) {
          usersService.logout();
          $state.go('home', {}, { reload: true });
        }
      } else {
        $state.go('login', {}, { reload: true });
      }
    });


    $rootScope.gdata = GData;

    // var BASE = 'https://myGoogleAppEngine.appspot.com/_ah/api';

    GAuth.setClient(ggAPI);
    GAuth.setScope("https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile");
    GAuth.load('people', 'v1');
    GAuth.load('client:auth2', 'v1');
    GAuth.load();

    $rootScope.getTraductor = function (value) {
      var lang = localStorage.getItem('lang');
      try {
        if (lang) {
          return (lang + '.' + value).split('.').reduce(function (o, i) {
            return o[i]
          }, dictionary);
        } else {
          return ('es.' + value).split('.').reduce(function (o, i) {
            return o[i]
          }, dictionary);
        }
      } catch (error) {
        return 'Dict-Error';
      }
    };

    $rootScope.loginAllowed = function () {
      usersService.isLoggedIn().then(function (data) {
        if (!data.login) {
          $state.go('home');
        }
      }, function (err) {
        $state.go('home');
      });
    };

    $rootScope.loggedNotAllowed = function () {
      usersService.isLoggedIn().then(function (data) {
        if (data.login) {
          $state.go('cash-dashboard');
        }
      }, function (err) {
        $state.go('home');
      });
    };

    $rootScope.goToCreateCow = function () {
      $state.go('cow-create');
    };

    $rootScope.goToCowAdmin = function (cowId) {
      $state.go('cow-admin', { cowId: cowId }, { reload: true });
    };

    $rootScope.goToCowEdit = function (cowId) {
      $state.go('cow-edit', { cowId: cowId }, { reload: true });
    };

    $rootScope.goToCowParticipate = function (cowId) {
      $state.go('cow-participate', { cowId: cowId }, { reload: true });
    };

    $rootScope.goToCow = function (cowId) {
      $state.go('cow', { cowId: cowId }, { reload: true });
    };

    $rootScope.returnToCow = function (cowId, cowUser) {
      usersService.getUserData().then(function (data) {
        if (data.user.id == cowUser) {
          $state.go('cow-admin', {cowId: cowId}, {reload: true});
        }
        else {
          $state.go('cow', {cowId: cowId}, {reload: true});
        }
      }, function (err) {
        $state.go('cow', {cowId: cowId}, {reload: true});
      });
    };

    $rootScope.goToCowThanks = function (cowId) {
      $state.go('cow-thanks', { cowId: cowId }, { reload: true });
    };

    $rootScope.goToCowGetMoney = function (cowId) {
      usersService.retrieveUserData().then(function (data) {
        if (data.user.email_verified) {
          console.log(cowId);
          $state.go('cow-get-money', { cowId: cowId }, { reload: true });
        } else {
          $mdDialog.show({
            controller: ShowVerifyEmailDialog,
            templateUrl: 'app/components/verifyEmailDialog/verifyEmailDialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            locals: {
              $state: $state
            }
          })
        }
      });
    };

    function ShowVerifyEmailDialog($scope, $mdDialog, usersService, toastr) {
      $scope.closeDialog = function () {
        $mdDialog.hide();
      };
      $scope.resendEmail = function () {
        usersService.resendEmailConfirmation().then(function (data) {
          $mdDialog.hide();
          toastr.info('Hemos enviado un correo electronicó de verificación', 'Revisa tu bandeja de entrada');
        });
      }
    }

    $rootScope.goToCowInvite = function (cowId) {
      console.log(cowId);
      $state.go('cow-invite', { cowId: cowId }, { reload: true });
    };

    $rootScope.goToHowItWorks = function () {
      $state.go('how-it-works', {}, { reload: true });
    };

    $rootScope.goToHome = function () {
      $state.go('home', {}, { reload: true });
    };

    $rootScope.goToAccount = function () {
      usersService.isLoggedIn().then(function (data) {
        if (data.login) {
          $state.go('account');
        } else {
          $state.go('login')
        }
      }, function (err) {
        $state.go('home');
      });
    };

    $rootScope.retryPayment = function (cowId) {
      $state.go('cow-participate', { cowId: cowId }, { reload: true });
    };


    $rootScope.checkLoginStatus = function () {
      usersService.isLoggedIn().then(function (data) {
        if (data.login) {
          $rootScope.isLogged = true;
        } else {
          $rootScope.isLogged = false;
        }
      }, function (err) {
        $rootScope.isLogged = false;
      });
    };
    $rootScope.checkLoginStatus();


    $rootScope.loginDirect = function (cows_num) {
      usersService.getUserData().then(function (data) {
        console.log(data.user);
        if (data.user.document_number == null) {
          $state.go('cash-dashboard');
        } else {
          if (cows_num === 0) {
            $state.go('cow-create');
          } else {
            $state.go('cash-dashboard');
          }
        }
      }, function (err) {
      })
    };

    $rootScope.documentTypes = [{
      key_type_name: 'Cédula de ciudadanía',
      id: 1
    }, {
      key_type_name: 'NIT (empresa)',
      id: 2
    }, {
      key_type_name: 'Cédula de extranjería',
      id: 3
    }, {
      key_type_name: 'Pasaporte',
      id: 4
    }];


    var ccMonths = [];
    for (var i = 1; i <= 12; i++) {
      ccMonths.push({
        key_type_name: i < 10 ? '0' + i.toString() : i.toString(),
        id: i
      })
    }

    $rootScope.ccMonths = ccMonths;

    var ccYears = [];
    var currentYear = new Date().getFullYear().toString().substr(-2);
    for (var j = parseInt(currentYear); j < (parseInt(currentYear) + 17); j++) {
      ccYears.push({
        key_type_name: j.toString(),
        id: j
      })
    }

    $rootScope.ccYears = ccYears;

    var ccInstallments = [];
    for (var k = 1; k <= 24; k++) {
      ccInstallments.push({
        key_type_name: k.toString(),
        id: k
      });
    }

    $rootScope.ccInstallments = ccInstallments;

    $rootScope.placeholderDescription = "Hola.  \\a \\a Gracias por utilizar  nuestros servicios.\\a Armar una Vaca nunca había sido tan fácil y rápido.  \\a \\a En este espacio, incluye el mensaje que quieres enviar a tus invitados, \\a dando la informacion del evento, fecha y toda la información que consideres pertinente...  \\a \\a No lo olvides, si tienes alguna duda, sugerencia o necesitas ayuda, \\a no dudes en contactarnos a contacto@armatuvaca.com o al número de teléfono que \\a encontrarás en la parte de abajo del Sitio Web.";


    $rootScope.scrapeFbCowEvent = function (cowId) {

      var urlToScrape = atvURL + cowPublicURL + cowId;

      FB.api('https://graph.facebook.com/', 'post', {
        access_token: fbAccessToken,
        id: urlToScrape,
        scrape: true
      }, function (response) {
        console.log('rescrape1!', response);
        FB.api('https://graph.facebook.com/', 'post', {
          access_token: fbAccessToken,
          id: urlToScrape,
          scrape: true
        }, function (response) {
          console.log('rescrape2!', response);
          FB.api('https://graph.facebook.com/', 'post', {
            access_token: fbAccessToken,
            id: urlToScrape,
            scrape: true
          }, function (response) {
            console.log('rescrape3!', response);
            FB.api('https://graph.facebook.com/', 'post', {
              access_token: fbAccessToken,
              id: urlToScrape,
              scrape: true
            }, function (response) {
              console.log('rescrape4!', response);
              FB.api('https://graph.facebook.com/', 'post', {
                access_token: fbAccessToken,
                id: urlToScrape,
                scrape: true
              }, function (response) {
                console.log('rescrape5!', response);
                FB.api('https://graph.facebook.com/', 'post', {
                  access_token: fbAccessToken,
                  id: urlToScrape,
                  scrape: true
                }, function (response) {
                  console.log('rescrape6!', response);
                });
              });
            });
          });
        });
      });
    };

    $rootScope.parseDate = function (strDate) {
      try {
        console.log(strDate);

        var arrayDate = strDate.split('-');
        var year = arrayDate[0];
        var month = arrayDate[1] - 1;
        var day = arrayDate[2];

        return new Date(year, month, day, 13, 0, 0, 0);
      } catch (err) {
        console.log(strDate);
        return strDate;
      }

    };

    $rootScope.getBackgroudCssStyle = function (imgUrl) {
      return {
        "background": "url(\'" + imgUrl + "\') no-repeat",
        "background-position": "center",
        "background-size": "cover"
      };
    };

    $rootScope.getBackgroudCssStyleCow = function (imgUrl, closed) {
      if (closed) {
        return {
          "background": "url(\'" + imgUrl + "\') no-repeat",
          "background-position": "center",
          "background-size": "cover",
          "filter": "grayscale(100%) blur(3px)",
          "-webkit-filter": "grayscale(100%) blur(3px)"
        };
      } else {
        return {
          "background": "url(\'" + imgUrl + "\') no-repeat",
          "background-position": "center",
          "background-size": "cover"
        };
      }
    };

    $rootScope.getBackgroudCssStyleCowBlur = function (imgUrl, closed) {
      if (closed) {
        return {
          "background": "url(\'" + imgUrl + "\') no-repeat",
          "background-position": "center",
          "background-size": "cover",
          "filter": "grayscale(100%) blur(3px)",
          "-webkit-filter": "grayscale(100%) blur(6px)"
        };
      } else {
        return {
          "background": "url(\'" + imgUrl + "\') no-repeat",
          "background-position": "center",
          "background-size": "cover",
          "filter": "blur(3px)"
        };
      }
    };
    $rootScope.getBackgroudCssStyleCowShadow = function (imgUrl, closed) {
      if (closed) {
        return {
          "background": "url(\'" + imgUrl + "\') no-repeat",
          "background-position": "center",
          "background-size": "cover",
          "filter": "grayscale(100%)",
          "-webkit-filter": "grayscale(100%)"
        };
      } else {
        return {
          "background": "url(\'" + imgUrl + "\') no-repeat",
          "background-position": "center",
          "background-size": "cover",
        };
      }
    };

    $rootScope.goToMpCompany = function (company) {
      $state.go('company', { slug: company.slug });
    };

    $rootScope.goToMpProduct = function (product) {
      $state.go('product', { slug: product.slug });
    };

    $rootScope.minPaymentValue = minPaymentValue;

    $rootScope.maxPaymentValue = maxPaymentValue;

    $rootScope.registerDirect = function () {
      $state.go('register');
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(routerConfig)
    .factory("JWTInterceptor", JWTInterceptor)
    .factory("LoadingInterceptor", LoadingInterceptor);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider) {


    $locationProvider.html5Mode(true).hashPrefix('!');
    $urlRouterProvider.otherwise('/404');
    $httpProvider.interceptors.push("JWTInterceptor");
    $httpProvider.interceptors.push("LoadingInterceptor");
  };

  function JWTInterceptor() {
    return {
      request: function (config) {
        var token = localStorage.token;
        if (token) {
          config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
      }      
    }
  }
  function LoadingInterceptor($rootScope, $q) {
    var counter = 0;

    $rootScope.loading = function () {
      return counter != 0;
    };
    return {
      'request': function (config) {
        counter++;
        return config;
      },
      'response': function (response) {
        counter--;
        return response;
      },
      'responseError': function (rejection) {
        counter--;
        return $q.reject(rejection);
      }
    }
  };

})();

(function () {
  'use strict';

  angular
    .module('user')
    .constant('jwtPubKey', "-----BEGIN PUBLIC KEY-----" +
      "MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAt4p4WlBRAvuoh+7tMoyK" +
      "SzWhsKdC/NQmgaAgKGGconpRpcfZ7UeiJxYT//PPob75AWbdzrGU21vGKjhnUX4v" +
      "gk6GmuC16HPW90RT/r32AVsaT/RIhzPKx8/F/VZ/rKTcY1gRBwz2NcOedRqnvmRP" +
      "gXAtZFoGXo4BC8C9UKcJY5kTGS7Rkva+twerPKw2MH6q+RM6ruhRCm28cFDzucy/" +
      "DK7gkmvVboleDk4aojSy3o5W20rflAu7EZ4+OiYf3t9Ux6kH6KgEAp4opYAeYDFC" +
      "1XoD19cMe1vakl4gTMRTnYVGy8LfscDR03TLhq8qqySUwmkqTOkuL1HEPaWZU1/+" +
      "zdAv+qbNB4r1Gd7/N3qOvomfN7awmAdYsNKLMx2oR+GJFOrbZK8bc9Br0wLqZS8Q" +
      "I/JH7AYU58nVy1C3k4B5M+8bOkUt+V8rcklcQbGWBcA6RNSddfoGb4qfFPhxS3AO" +
      "nrA0sC05wlyux6CQIiL0no3uhglFa3bzrys4Q651BYbcNkHNTsqyoqsXnwvI9j+4" +
      "sshiRSuyqDNE3N4CkrlRLUH0A6hKpXLMpgKdbxUdDPxguz6NFu1znKmGiIHgCLf/" +
      "KzJ994Ret9Y+QBWiD3d8OXTq8JmjgaCHzM4f6mfN7UT6Cu45x0pZDAuLoj+/TBNY" +
      "VVegRnlrf3tmL20r27Owb2kCAwEAAQ==" +
      "-----END PUBLIC KEY-----" +
      "");

})();

(function () {
  'use strict';

  angular
    .module('user')
    .constant('dictionary', {
      es: {
        home: {
          cta_title: "¿Necesitas recoger plata en grupo?"
        },
        participate: {
          create_by: 'Organizada por',
          personal_data: 'Datos Responsable Pago',
          //NAME
          name: 'Nombre',
          //DOCUMENT
          document: 'Documento',
          //FIRTS NAME
          first_name: 'Nombre',
          required_first_name: 'Por favor digita un nombre',
          holder_first_name: 'Nombre responsable del pago',
          //LAST NAME
          last_name: 'Apellido',
          required_last_name: 'Por favor digita un apellido',
          holder_last_name: 'Apellido responsable del pago',
          //Document number
          document_type: 'Tipo de Documento',
          document_number: 'N° de Documento',
          required_document_number: 'El número de documento es obligatorio',
          min_document_number: 'El número de documento debe contener entre 6 y 15 caracteres numéricos',
          min_document_number_passport: 'El número de documento debe contener entre 6 y 15 caracteres alfanuméricos',
          document_number_nit: 'Digita el numero NIT incluyendo dígito de verificación',
          holder_document_number: 'Documento responsable del pago',
          //EMAIL
          email: 'Correo Electrónico',
          required_email: 'Por favor digita el correo.',
          invalid_email: 'Dirección de correo inválida',
          holder_email: 'Correo responsable del pago',
          //CELLPHONE
          cellphone: 'Número celular',
          required_cellphone: 'Por favor digita el número celular',
          min_cellphone: 'El número celular debe contener entre 10 y 12 números y contener solo caracteres numericos',
          holder_cellphone: 'Celular responsable del pago',

          //BTN PERSONAL DATA
          btn_ok: 'Listo',
          //PARTICIPATION
          participation: 'Participación',
          //EDIT INFO
          edit_info: 'Editar datos',
          additional_data: 'Datos Adicionales',
          optional_field: 'Este campo es opcional',
          donation: 'Donación',
          label_fixed_amount: 'El administrador fijó la participación en un monto fijo',
          choose_number_participation: 'Elige el número de participaciones que vas a pagar (Max 8)',
          options: 'Opciones',
          participant_option: 'Opciones Participante',
          donation_amount: 'Monto de donación (COP)',
          participation_amount: 'Monto de participación (COP)',
          min_amount: 'El monto mínimo de participación es de',
          max_amount: 'El monto máximo de participación es de',
          participating: 'Participante',
          cost_service: 'Costo transaccional',
          efecty_cost_service: 'Tarifa Efecty',
          tax_cost_service: 'IVA',
          total_to_pay: 'Total a pagar',
          anonymous_donation: 'Quiero que mi donación sea anónima',
          hidden_donation: 'Quiero ocultar el monto de mi donación',
          alert_hidden_donation: 'El monto que aportas no se mostrará en la lista de participantes',
          apply_code: 'Aplicar Código',
          select_payment_method: 'Selecciona el método de pago',
          debit_account: 'Cuenta de Ahorros (PSE)',
          credit_card: 'Tarjeta de crédito',
          efecty: 'Pago en Efectivo (Efecty)',
          no_transactional_fee: 'Sin costo transaccional',
          transactional_fee: 'Costo transaccional 1.99%+IVA',
          efecty_fee: 'Tarifa Efecty añadida',
          to_pse: 'Para pagar con PSE debes <b>tener habilitada esta opción</b> con tu entidad bancaria y el monto a pagar no debe superar los <b>topes que te han habilitado</b>. ' +
            'El pago puede tardar hasta <b>30 minutos en verse reflejado</b>.',
          efecty_info: '<p>Al seleccionar este metodo de pago podrás pagar tu participación en efectivo en cualquier ' +
            '<a href="https://www.efecty.com.co/web/puntos-de-atencion" target="_blank">punto Efecty del país</a>.</p>' +
            '<ul><li>Debes llevar tu <b>documento de identidad</b> y los datos deben corresponder con los registrados anteriormente en el formulario <b>"Datos Responsable Pago"</b>.</li>' +
            '<li>Debes llevar la <b>Referencia de Pago</b> que te generará nuestra plataforma al confirmar el pago.</li>' +
            '<li>Para pagos de <b>$1.000 hasta $195.000</b> la tarifa es de $2.000 + IVA</li>' +
            '<li>Para pagos <b>mayores a $195.000</b> la tarifa es de $4.000 + IVA</li></ul>',
          saved_cards: 'Tarjetas Guardadas',
          number_credit_Card: 'Número de la tarjeta',
          year: 'Año',
          month: 'Mes',
          name_credit_card: 'Nombre del titular',
          installments: 'Cuotas',
          invalid_number_card: 'Ingresa un número de tarjeta valido',
          invalid_expiration_date: 'Fecha de vencimiento inválida',
          invalid_card_name: 'Ingresa el nombre del titular de la tarjeta',
          invalid_card_type: 'Tu tarjeta debe ser Mastercard, Visa o Diners',
          invalid_cvc: 'El CVC es obligatorio y sólo debes ingresar dígitos',
          cvc: 'CVC (Cod. Seguridad)',
          save_credit_card: 'Guardar tarjeta de crédito para futuras participaciones',
          confirm_data_title: 'Confirma los Datos',
          confirm_data: 'Revisa que toda la información ingresada sea correcta',
          responsible_data_payment: 'Datos responsable pago',
          payment_method: 'Método de pago',
          first_label_efecty: 'Al hacer clic en <b>"Realizar Pago"</b>, se generará tu referencia de pago',
          second_label_efecty: 'Debes acercarte a cualquier <a href="https://www.efecty.com.co/web/puntos-de-atencion" target="_blank">punto Efecty del país</a> con la <b>Referencia de Pago</b> y el <b>Documento de Identidad</b>.',
          third_label_efecty: 'Los datos del documento de identidad deben coincidir con los registrados anteriormente en el formulario <b>Datos Responsable Pago.</b>',
          first_label_pse: 'Al hacer clic en <b>Realizar pago</b> serás redireccionado a la pasarela de pagos. No recargues ni cierres la página.',
          second_label_pse: 'Recuerda hacer clic en <b>Regresar al comercio</b> al finalizar la transacción.',
          third_label_pse: 'Los pagos con PSE pueden tardar hasta <b>30 minutos en verse reflejados.</b>',
          evolution_payment: 'Ten en cuenta que el cobro lo verás reflejado a nombre de <strong>Evolution Ideas SAS (Armatuvaca)</strong>',
          value_pay: 'Valor a pagar',
          notify_atv: 'Deseo recibir más información sobre los servicios de Armatuvaca',
          terms_condi: 'He leído y acepto los <a id="register_terms_and_conditions_link2" ui-sref="terms-and-conditions" target="_blank">términos y condiciones</a> y la <a id="register_privacy_policy_link2" ui-sref="privacy-policy" target="_blank">política de tratamiento de datos</a> de Armatuvaca.',
          valid_term_condi: 'Debes aceptar para finalizar el pago.',
          verification_pay: '<strong><b><i class="fa fa-exclamation-triangle font-color-blue" aria-hidden="true"></i></b> </strong>&nbsp;En este momento nuestro proveedor de pagos se encuentra verificando tu transacción anterior en estado <strong>pendiente</strong>. Recuerda que si pagaste usando PSE este proceso puede tardar hasta <strong>30 minutos</strong>. Si deseas mayor información sobre el estado actual de la operación puedes enviar un correo electrónico a <strong>contacto@armatuvaca.com</strong>.',
          return: 'Volver',
          continue: 'Continuar',
          make_payment: 'Realizar Pago',
          recomended: 'Recomendado',
          payment_redirect: 'Redireccionando a la plataforma de pagos',
          title_political_term_dialog: 'Antes de realizar la donación por favor lea y acepte:',
          political_term_dialog: 'Declaro bajo la gravedad de juramento que la contribución o donación por mí realizada no se encuentra en ninguna de las situaciones que se transcriben a continuación:<br>\n' +
            '                                  1. Las que provengan, directa o indirectamente, de gobiernos o personas naturales o jurídicas extranjeras, excepto las que se realicen a título de cooperación técnica para el desarrollo de actividades distintas a las campañas electorales.<br>\n' +
            '                                  2. Las que se deriven de actividades ilícitas o tengan por objeto financiar fines antidemocráticos o atentatorios del orden público.<br>\n' +
            '                                  3. Las contribuciones o donaciones de personas titulares del derecho real, personal, aparente o presunto, de dominio, respecto de bienes sobre los cuales se hubiere iniciado un proceso de extinción de dominio.<br>\n' +
            '                                  4. Las contribuciones anónimas.<br>\n' +
            '                                  5. Las de personas naturales contra las cuales se hubiere formulado acusación o imputación en un proceso penal por delitos relacionados con la financiación, pertenencia o promoción de grupos armados ilegales, narcotráfico, delitos contra la administración pública, contra los mecanismos de participación democrática y de lesa humanidad.<br>\n' +
            '                                  6. Las que provengan de personas que desempeñan funciones públicas, excepto de los miembros de corporaciones públicas de elección popular, quienes podrán realizar aportes voluntarios a las organizaciones políticas a las que pertenezcan, con destino a la financiación de su funcionamiento y a las campañas electorales en las que participen, de acuerdo con los límites a la financiación privada previstos en el artículo 25 de la presente ley.<br>\n' +
            '                                  7. Las que provengan de personas naturales o jurídicas cuyos ingresos en el año anterior se hayan originado en más de un cincuenta por ciento de contratos o subsidios estatales; que administren recursos públicos o parafiscales, o que tengan licencias o permisos para explotar monopolios estatales o juegos de suerte y azar.\n' +
            '                               ',


        },
        vacanes: {
          about_vacanes: ', un espacio de crowdfunding social para resaltar la labor de Vacas que tienen la meta de ayudar.',
          become_to: 'Crear una Causa',
          contribute_to: 'Apoyar una causa',
          know_vacanes: 'Conoce aquí a nuestros <b>Vaca</b>nes:',
          explore_vacanes: 'Explorar Vacanes',
          collected: 'Recolectado:',
          back_up: 'Apoyar',
          chose_category: 'Elige la <strong>categoría</strong> en la que <strong>quieres ayudar: </strong>'
        },
        cow: {
          donate: 'Donar',
          participate: 'Participar',
          closed: 'Cerrada',
          info_closed: 'Has recolectado todo el dinero disponible en esta Vaca',
          collected_amount: 'Monto recolectado',
          participation: 'Participación',
          participations: 'Participaciones',
          only_to_organizer: 'Sólo visible para el organizador',
          organized_by: 'Organizada por',
          to_shere: 'Compartir',
          you_want_to_do: '¿Qué quieres hacer?',
          date: 'Fecha',
          place: 'Lugar',
          no_participation: 'Por el momento no hay ninguna participación',
          invite_participate: 'Invita a tus amigos a que participen en la Vaca',
          participants: 'Participantes',
          copy_list: 'Copiar lista',
          hidden_information: 'El organizador de la Vaca ha ocultado la información de las participaciones',
          change_image: 'Cambiar imagen',
          return: 'Volver',
          upload_img: 'Subir imagen',
          save: 'Guardar',
          take_out_money: 'Sacar Plata',
          close_cow: 'Cerrar Vaca',
          reopen_cow: 'Reabrir Vaca',
          upgrade_to_vacanes: 'Pasar a Vacanes',
          upgrade_cow: 'Mejorar Vaca',
          see_report: 'Ver reporte',
          edit_cow: 'Editar Vaca',
          you_received: 'Has recibido',
          goal: 'Meta:',
          service_cost: 'Costo de servicio',
          you_withdrawn: 'Has retirado',
          you_available: 'Tienes disponible',
          benefits_pro: '<h4> Tu Vaca está en el plan <strong>Básico</strong>.<br>' +
            'Pásate al plan <strong class="font-color-atv">PRO</strong> y recibe todos los beneficios:</h4>' +
            '<ul class="list-style-none">' +
            '<li>Personaliza tu Vaca</li>' +
            '<li>Descarga el reporte en Excel de tu Vaca</li>' +
            '<li>Retiros a Efecty, Nequi, Daviplata</li>' +
            '<li>Retiros parciales de dinero</li>' +
            '<li>Recibe pagos con tarjeta de crédito</li>' +
            '<li>Vaca sin límites en monto recolectado</li>' +
            '</ul>',
          wanna_be_pro: 'Quiero ser PRO',
          edit_description: 'Editar descripción',
          admin_cow: 'Administración de la Vaca',
          restricted_area: 'Área restringida para el administrador',
          if_you_are_invited: 'Si eres un invitado de la Vaca haz clic en el botón para ir a la pagina de ' +
            'invitados',
          go_to_cow: 'Ir a la Vaca',
          if_you_are_administrator: 'Si eres el administrador de esta Vaca inicia sesión',
          login_facebook: 'Ingresa con Facebook',
          login_google: 'Ingresa con Google',
          login: 'Iniciar sesión',
          email: 'Correo',
          password: 'Contraseña',
          required_email: 'Por favor, digita tu correo.',
          required_password: 'Por favor, digita tu contraseña.',
          length_password: 'Tu contraseña debe ser mínimo de 8 caracteres.',
          forget_password: 'Ohh no ¿Olvidaste tu contraseña?',
          guest_list: 'Lista de invitados',
          no_guest_list: 'Todavía no tienes invitados',
          delete_person_one: '¿Seguro que quieres borrar a ',
          delete_person_two: 'de la lista?',
          confirm_close_cow: '¿Seguro que quieres cerrar la Vaca?',
          confirm_reopen_cow: '¿Estas seguro que re-abrir la Vaca?',
          no_reopen_cow: 'No puedes reabrir esta Vaca. No dudes en contactarnos si necesitas ayuda.',
          no_participations: 'Por el momento no tienes ninguna participación',
          invite_friends: 'Invita a tus amigos a que participen en tu Vaca',
          juice_atv: 'sácale el jugo a Armatuvaca!',
          add_cellphone_accout: 'Agrega un número celular a tu cuenta y así podremos ayudarte para que tu Vaca sea la más exitosa',
          required_cellphone: 'Debes digitar tu número celular',
          min_cellphone: 'El número debe contener entre 10 y 12 dígitos',
          cellphone_data_processing_policy: 'Tu número se mantendrá privado y no será compartido con terceros. <br>' +
            '<a ui-sref="privacy-policy" href="" target="_blank" class="">' +
            'Política de Tratamiento de Datos</a>',
          invite: 'Invitar',
          download_report: 'Descargar reporte',
          dont_fast: '<h4>¡No tan rápido!<br>Está opción está activa solo para <strong>Vacas PRO</strong><br>Cambia de plan y recibe todos los beneficios:</h4>' +
            '<ul class="text-left list-style-ckeck-color">' +
            '<li>Personaliza tu Vaca</li>' +
            '<li>Descarga el reporte en Excel de tu Vaca</li>' +
            '<li>Retiros a Efecty, Nequi, Daviplata</li>' +
            '<li>Retiros parciales de dinero</li>' +
            '<li>Recibe pagos con tarjeta de crédito</li>' +
            '<li>Vaca sin topes máximos</li>' +
            '</ul>',
          title_confirmation_pro_firts: 'Este cambio implica un costo de',
          title_confirmation_pro_second: 'sobre el valor que recolectes en tu Vaca. Una vez hagas el cambio <strong>no</strong> puedes volver al plan básico.',
          confirmation_pro: '<h4>Recuerda que siendo PRO puedes:</h4>' +
            '<ul class="text-left list-style-ckeck-color">' +
            '<li>Personalizar tu Vaca</li>' +
            '<li>Descargar el reporte en Excel de tu Vaca</li>' +
            '<li>Retirar a Efecty, Nequi, Daviplata</li>' +
            '<li>Retirar parcialmente el dinero</li>' +
            '<li>Recibir pagos con tarjeta de crédito</li>' +
            '<li>Vaca sin topes máximos</li>' +
            '</ul>' +
            '<h4>¿Estás de acuerdo con esto?</h4>',
          yes_i_agree: '¡Sí! Estoy de acuerdo',
          confirmation_vacan: '¿Seguro que quieres pasar esta Vaca a Vacanes?',
          info_vacanes: 'Ten en cuenta que este cambio no es inmediato. Tu Vaca debe ser verificada y esto puede' +
            'tardar hasta <strong>2 días hábiles</strong>.<br><br>' +
            'Si tu Vaca es aprobada, aparecerá de forma pública en nuestra sección de Vacanes y la nueva tarifa será de' +
            '<strong>4.99% + IVA</strong>',
          description_cow: 'Descripción de la Vaca',
          see_more: false

        },
        share_cow: {
          to_share: '¡A compartir esa Vaca!',
          copy_link: 'Copiar link',
          qr_code: 'Código QR',
          touch_qr: 'Toca el QR para descargar',
          alert_qr: 'Este QR debe ser escaneado con la aplicación de cámara del celular (NO aplicación bancaria)',
          copy_link_long: 'Comparte la Vaca con quien quieras',
          share_networks: 'Comparte en redes',
          qr_option: 'También puedes mostrar el QR para que lo escaneen con el celular',
          networks_options: 'O comparte por redes sociales',
          see_qr: 'Ver QR'
        },
        countdown_timer: {
          countdown_header: 'Se cierra en:',
          day: 'Día',
          days: 'Días',
          hour: 'Hora',
          hours: 'Horas',
          minute: 'Minuto',
          minutes: 'Minutos',
          countdown_alert: '¡Esta Vaca está próxima a cerrarse, participa ahora!'
        },
        invitation: {
          invitation_friend: 'Ahora invita a tus amigos a tu Vaca',
          go_to_cow: 'Ir a mi Vaca'
        }
      },
      en: {
        home: {
          cta_title: "Do you need to pool money?"
        },
        participate: {
          create_by: 'Created by',
          personal_data: 'Personal Data',
          //NAME
          name: 'Name',
          //DOCUMENT
          document: 'Document Number',
          //FIRST NAME
          first_name: 'First name',
          required_first_name: 'Please type your first name',
          holder_first_name: 'Your first name',
          //LAST NAME
          last_name: 'Last name',
          required_last_name: 'Please type your last name',
          holder_last_name: 'Your last name',
          //DOCUMENT NUMBER
          document_type: 'Document type',
          document_number: 'Document number',
          required_document_number: 'Document number is required',
          min_document_number: 'Document number should have between 6 and 15 numeric characters',
          min_document_number_passport: 'Document number should have between 6 and 15 alphanumeric characters',
          document_number_nit: 'NIT (Colombia) number including verification digit',
          holder_document_number: 'Your document number',
          //EMAIL
          email: 'Email',
          required_email: 'Please type your email',
          invalid_email: "This email is not valid",
          holder_email: 'Your email address',
          //CELLPHONE
          cellphone: 'Cellphone',
          required_cellphone: 'Please type your cellphone number',
          min_cellphone: 'Cellphone number should have between 10 and 12 digits and only numeric characters',
          holder_cellphone: 'Your cellphone number',
          //BTN PERSONAL DATA
          btn_ok: 'OK',
          //PARTICIPATION
          participation: 'Participation',
          //EDIT INFO
          edit_info: 'Edit info',
          additional_data: 'Additional info',
          optional_field: 'This field is optional',
          donation: 'Donation',
          label_fixed_amount: 'The administrator set the participation to a fixed amount',
          choose_number_participation: 'Choose the number of participants you are going to pay for (Max 8)',
          options: 'Options',
          participant_option: 'Participant Options',
          donation_amount: 'Donation amount (COP)',
          participation_amount: 'Participation amount (COP)',
          min_amount: 'The minimum participation amount is',
          max_amount: 'The maximum participation amount is',
          participating: 'Participant',
          cost_service: 'Transaction fee',
          efecty_cost_service: 'Efecty fee',
          tax_cost_service: 'Tax',
          total_to_pay: 'Total',
          anonymous_donation: 'I want my donation to be anonymous',
          hidden_donation: 'I want to hide the amount of my donation',
          alert_hidden_donation: 'The amount you contribute will not be shown in the list of participants',
          apply_code: 'Apply code',
          select_payment_method: 'Select payment method',
          debit_account: 'Debit Bank Account (PSE - Colombia)',
          efecty: 'Cash (Efecty - Colombia)',
          credit_card: 'Credit Card',
          no_transactional_fee: 'No transactional fees',
          transactional_fee: 'Transactional fee 1.99%+IVA',
          efecty_fee: 'Additional Efecty fee',
          to_pse: 'To pay with PSE you must <b>have this option enabled</b> with your bank and the amount to be paid must ' +
            'not exceed the <b>limits allowed by your bank.</b> Payment can take up to <b>30 minutes to be resolved</b>',
          efecty_info: '<p>Choose this method to pay with cash in any <a href="https://www.efecty.com.co/web/puntos-de-atencion" target="_blank">Efecty location in Colombia</a>.</p>  ' +
            '<ul><li>You will need to present your <b>ID</b> and the data should be the same as the one registered above on the <b>"Personal Data"</b> form.</li>' +
            '<li>You will also need to show the <b>Payment ID</b> that will be generated by our platform after you confirm your payment.</li>' +
            '<li>For payments <b>between $1.000 COP to $195.000 COP</b>, the fee is $2.000 + IVA</li>' +
            '<li>For payments <b>greater than $195.000 COP</b>, the fee is $4.000 + IVA</li></ul>',
          saved_cards: 'Stored Cards',
          number_credit_Card: 'Card number',
          year: 'Year',
          month: 'Month',
          name_credit_card: 'Cardholder name',
          installments: 'Installments',
          invalid_number_card: 'Type a valid credit card number',
          invalid_expiration_date: 'Expiration date is not valid',
          invalid_card_name: 'Type a valid cardholder name',
          invalid_card_type: 'Your card must be Mastercard, Visa or Diners',
          invalid_cvc: 'CVC is required and you should only enter numbers',
          cvc: 'CVC (Security Code)',
          save_credit_card: 'Store credit card for future payments',
          confirm_data_title: 'Confirm payment data',
          confirm_data: 'Verify that all the information is correct',
          responsible_data_payment: 'Personal data',
          payment_method: 'Payment method',
          first_label_efecty: 'When you click in "Pay", your payment reference will be generated',
          second_label_efecty: 'You must go to any <a href="https://www.efecty.com.co/web/puntos-de-atencion" target="_blank">Efecty branch in Colombia</a> with your <b>payment reference</b> and your <b>Document ID</b>.',
          third_label_efecty: 'The data on the document ID must match what was registered on the form <b>Personal Data</b>.',
          first_label_pse: 'After clicking on <b>Pay</b> you will be redirected to the payment gateway. Do not reload or close the page.',
          second_label_pse: 'Remember to click <b>Return to store</b> at the end of the transaction.',
          third_label_pse: 'PSE payments can take up to <b>30 minutes to be resolved</b>.',
          evolution_payment: 'Keep in mind that the payment will be charged by <strong>Evolution Ideas SAS (Armatuvaca)</strong>',
          value_pay: 'Payment Value',
          notify_atv: 'I want to receive more information about Armatuvaca.com',
          terms_condi: 'I have read and accept the <a id="register_terms_and_conditions_link2" ui-sref="terms-and-conditions" target="_blank">Terms and Conditions</a> and the <a id="register_privacy_policy_link2" ui-sref="privacy-policy" target="_blank">Data Protection Policy</a> of Armatuvaca.com',
          valid_term_condi: 'You must accept to complete your payment.',
          verification_pay: '<strong><b><i class="fa fa-exclamation-triangle font-color-blue" aria-hidden="true"></i></b> </strong>&nbsp;In this moment, our payment provider is verifying your previous transaction in <strong>pending</strong> state. Remember that if you paid using PSE, this process may take up to <strong>30 minutes</strong>. If you want more information about the current status of the operation, please send a email to <strong>contacto@armatuvaca.com</strong>.',
          return: 'Return',
          continue: 'Continue',
          make_payment: 'Pay',
          recomended: 'Recomended',
          payment_redirect: 'Redirecting to the payment platform',
          title_political_term_dialog: 'Before making the donation please read and accept:',
          political_term_dialog: 'Declaro bajo la gravedad de juramento que la contribución o donación por mí realizada no se encuentra en ninguna de las situaciones que se transcriben a continuación:<br>\n' +
            '                                  1. Las que provengan, directa o indirectamente, de gobiernos o personas naturales o jurídicas extranjeras, excepto las que se realicen a título de cooperación técnica para el desarrollo de actividades distintas a las campañas electorales.<br>\n' +
            '                                  2. Las que se deriven de actividades ilícitas o tengan por objeto financiar fines antidemocráticos o atentatorios del orden público.<br>\n' +
            '                                  3. Las contribuciones o donaciones de personas titulares del derecho real, personal, aparente o presunto, de dominio, respecto de bienes sobre los cuales se hubiere iniciado un proceso de extinción de dominio.<br>\n' +
            '                                  4. Las contribuciones anónimas.<br>\n' +
            '                                  5. Las de personas naturales contra las cuales se hubiere formulado acusación o imputación en un proceso penal por delitos relacionados con la financiación, pertenencia o promoción de grupos armados ilegales, narcotráfico, delitos contra la administración pública, contra los mecanismos de participación democrática y de lesa humanidad.<br>\n' +
            '                                  6. Las que provengan de personas que desempeñan funciones públicas, excepto de los miembros de corporaciones públicas de elección popular, quienes podrán realizar aportes voluntarios a las organizaciones políticas a las que pertenezcan, con destino a la financiación de su funcionamiento y a las campañas electorales en las que participen, de acuerdo con los límites a la financiación privada previstos en el artículo 25 de la presente ley.<br>\n' +
            '                                  7. Las que provengan de personas naturales o jurídicas cuyos ingresos en el año anterior se hayan originado en más de un cincuenta por ciento de contratos o subsidios estatales; que administren recursos públicos o parafiscales, o que tengan licencias o permisos para explotar monopolios estatales o juegos de suerte y azar.\n' +
            '                               ',
        },
        vacanes: {
          about_vacanes: ', a crowdfunding platform to highlight "Vacas" with social impact.',
          become_to: 'Create a social cause',
          contribute_to: 'Contribute to a social cause',
          know_vacanes: 'Meet our <b>Vaca</b>nes:',
          explore_vacanes: 'Explore Vacanes',
          collected: 'Collected:',
          back_up: 'Back up',
          chose_category: 'Choose the <strong>category</strong> in which you <strong>want to help: </strong>'
        },
        cow: {
          donate: 'Donate',
          participate: 'Participate',
          closed: 'Closed',
          participation: 'Participant',
          participations: 'Participants',
          only_to_organizer: 'Only visible to the organizer',
          organized_by: 'Organized by',
          date: 'Date',
          place: 'Location',
          no_participation: 'There are no participations yet.',
          invite_participate: 'Invite your friends to participate',
          participants: 'Participants',
          copy_list: 'Copy list',
          hidden_information: 'The organizer has hidden the information of the participants',
          info_closed: 'You have collected all the money available on this Vaca',
          collected_amount: 'Amount collected',
          to_shere: 'Share',
          you_want_to_do: 'What do you want to do?',
          change_image: 'Change image',
          return: 'Return',
          upload_img: 'Upload image',
          save: 'Save',
          take_out_money: 'Withdraw',
          close_cow: 'Close Vaca',
          reopen_cow: 'Reopen Vaca',
          upgrade_to_vacanes: 'Upgrade to Vacanes',
          upgrade_cow: 'Upgrade Vaca',
          see_report: 'View report',
          edit_cow: 'Edit Vaca',
          you_received: 'You have received',
          goal: 'Goal:',
          service_cost: 'Service cost',
          you_withdrawn: 'You have withdrawn',
          you_available: 'You have available',
          benefits_pro: '<h4> Your Vaca is on the <strong>Basic</strong> plan.<br>' +
            'Go to the <strong class="font-color-atv">PRO</strong> plan and receive all the benefits:</h4>' +
            '<ul class="list-style-none">' +
            '<li>Customize your Vaca</li>' +
            '<li>Download the Excel report of your Vaca</li>' +
            '<li>Withdrawals to Efecty, Nequi, Daviplata</li>' +
            '<li>Partial withdrawals of money</li>' +
            '<li>Receive credit card payments</li>' +
            '<li>Vaca without limits in amount collected</li>' +
            '</ul>',
          wanna_be_pro: 'I want to be PRO',
          edit_description: 'Edit description',
          admin_cow: 'Vaca management',
          restricted_area: 'Restricted area for the administrator',
          if_you_are_invited: 'If you are a guest of the Cow, click on the button to go to the guest page',
          go_to_cow: 'Go to the Vaca',
          if_you_are_administrator: 'If you are the administrator of this Vaca, please log in',
          login_facebook: 'Login with Facebook',
          login_google: 'Login with Google',
          login: 'Log in',
          email: 'Email',
          password: 'Password',
          required_email: 'Please, type your email.',
          required_password: 'Please, type your password.',
          length_password: 'Your password must be a minimum of 8 characters.',
          forget_password: 'Ohh no. Did you forget your password?',
          guest_list: 'Guest list',
          no_guest_list: 'You still have no guests',
          delete_person_one: 'Are you sure that you want delete ',
          delete_person_two: 'from the list?',
          confirm_close_cow: 'Are you sure that you want close the Vaca?',
          confirm_reopen_cow: 'Are you sure that you want reopen the Vaca?',
          no_reopen_cow: 'You cannot reopen this Vaca. Feel free to contact us if you need help.',
          no_participations: "At the moment you don't have any participation",
          invite_friends: 'Invite your friends to participate in your Vaca',
          juice_atv: 'get the most of Armatuvaca',
          add_cellphone_accout: 'Add a cell phone number to your account and so we can help you so that your Cow is the most successful',
          required_cellphone: 'You must enter your cell phone number',
          min_cellphone: 'The number must contain between 10 and 12 digits',
          cellphone_data_processing_policy: 'Your number will be kept private and will not be shared with third parties. <br>' +
            '<a ui-sref="privacy-policy" href="" target="_blank" class="">' +
            'Data Processing Policy</a>',
          invite: 'Invite',
          download_report: 'Download report',
          dont_fast: '<h4>Not so fast!<br>This option is only active to <strong>Vacas PRO</strong><br>Change plans and receive all the benefits:</h4>' +
            '<ul class="text-left list-style-ckeck-color">' +
            '<li>Customize your Vaca</li>' +
            '<li>Download the Excel report of your Vaca</li>' +
            '<li>Cash outs to Efecty, Nequi, Daviplata</li>' +
            '<li>Partial cash outs of money</li>' +
            '<li>Receive credit card payments</li>' +
            '<li>Vaca without maximum caps</li>' +
            '</ul>',
          title_confirmation_pro_firts: 'This change implies a cost of',
          title_confirmation_pro_second: 'about the value that you collect from your Vaca. Once you make the change you <strong>cannot</strong> return to the basic plan.',
          confirmation_pro: '<h4>Remember that being PRO you can:</h4>' +
            '<ul class="text-left list-style-ckeck-color">' +
            '<li>Customize your Vaca</li>' +
            '<li>Donwload the Excel report of your Vaca</li>' +
            '<li>Cash outs to Efecty, Nequi, Daviplata</li>' +
            '<li>Partial cash outs of money</li>' +
            '<li>Receive credit card payments</li>' +
            '<li>Vaca without maximum caps</li>' +
            '</ul>' +
            '<h4>Do you agree with this?</h4>',
          yes_i_agree: 'Yes! I agree',
          confirmation_vacan: 'Are you sure you want to pass this Vaca to Vacanes?',
          info_vacanes: 'Keep in mind that this change is not immediate. Your Cow must be verified and this can take up to' +
            '<strong> 2 business days</strong>.<br><br>' +
            'If your Cow is approved, it will appear publicly in our Cow section and the new rate will be ' +
            '<strong>4.99% + IVA</strong>',
            description_cow: "Vaca's description",
            see_more: true         

        },
        share_cow: {
          to_share: "Share it!",
          copy_link: 'Copy link',
          qr_code: 'QR Code',
          touch_qr: 'Click on the QR code to download',
          alert_qr: 'This QR should be scanned using the camera application (NOT banking app)',
          copy_link_long: 'Share the Vaca with everyone',
          share_networks: 'Share in networks',
          qr_option: 'You can also show the QR to scan it with the cell phone',
          networks_options: 'Or share on social networks',
          see_qr: 'See QR'

        },
        countdown_timer: {
          countdown_header: 'Closes in:',
          day: 'Day',
          days: 'Days',
          hour: 'Hour',
          hours: 'Hours',
          minute: 'Minute',
          minutes: 'Minutes',
          countdown_alert: 'To be closed soon, make your contribution!'
        },
        invitation: {
          invitation_friend: 'Now invite your friends to your Vaca',
          go_to_cow: 'Go to my Vaca'
        }
      }
    });

})();

(function () {
  'use strict';

  angular
    .module('user')
    .constant('apiVersion', '1.0')
    .constant('moment', moment)
    .constant('mainColorCow', '#47C9AF')
    .constant('mainColorTicket', '#5BB2D7')
    .constant('urlPart1', 'https://www.zonapagos.com/')
    .constant('urlPart2', '/pago.asp?estado_pago=iniciar_pago&identificador=')
    .constant('minPaymentValue', 1000)
    .constant('minGetMoneyValidationValue', 500000)
    .constant('minParticipantPaymentValue', 360000)
    .constant('minGetMoneyValue', 10000)
    .constant('ivaAtvTax', 0)
    .constant('minPartialLeft', 10000)
    .constant('maxPaymentValue', 10000000)
    .constant('maxPaymentValueCC', 2000000)
    .constant('additionalParticipantFee', 0)
    .constant('fbAccessToken', 'EAAXajJLtypEBAFtIHpF5qXcTlEVVLNen5nORSmb9SP7uxhe6IaAxi3COZBfZCotjhsKcri6olZAkpMzUsQKmMp3805VeWaM2SVCaW7XzJq54Y6T9dV3k37YRFxPQveY8KFWpYGCRaOTSxRvOrst20pPGCwRyMsZD')
    .constant('psePaymentCode', 4)
    .constant('ccPaymentCode', 5)
    .constant('efectyPaymentCode', 6)
    .constant('fepSingleTicketSlug', 'fep-day')
    .constant('fepSingleTicketStage2Slug', 'fep-day-stage-2')
    .constant('fepComboTicketSlug', 'fep-combo')
    .constant('fepComboTicketStage2Slug', 'fep-combo-stage-2')
    .constant('fepSingleTicketPrice', 304000)
    .constant('fepSingleTicketStage2Price', 327000)
    .constant('fepComboTicketPrice', 649000)
    .constant('fepComboTicketStage2Price', 682000)
    .constant('businessCowTypeSlug', 'negocio')
    .constant('socialBusinessCowTypeSlug', 'fundacion')
    .constant('businessCowPercentageFee', 0.0299)
    .constant('cowBusinessTypeSocial', 1)
    .constant('cowBusinessTypeFEP', 2)
    .constant('cowBusinessTypePolitical', 3)
    .constant('cowBusinessTypeCredibanco', 4)
    .constant('ivaValue', 0.19)
    .constant('highValueCowPercentageFee', 0.0299)
    .constant('highValueCowValue', 2000000)
    .constant('highValueCowCreationDate', new Date(2019, 4, 2))
    .constant('premiumUserPercentageFee', 0.01)
    .constant('brandedCowTypeSlug', 'ATV')
    .constant('efectyCashoutFee', 0.0299)
    .constant('efectyCashoutMaxAmount', 500000)
    .constant('efectyTypeCashout', 3)
    .constant('fileSizeImage', 5000000)
    .constant('fileSizePDF', 5000000)
    .constant('publicCowPercentageFee', 0.0499)
    .constant('bankTransferTypeCashout', 0)
    .constant('reversalTypeCashout', 1)
    .constant('cowPublicURL', 'vaca/')
    .constant('productPublicURL', 'p/')
    .constant('fepCowPublicURL', 'alcancia-fep/')
    .constant('credibancoCowPublicURL', 'yo-me-quedo-en-mi-negocio/')
    .constant('pricingPlanFree', 'free')
    .constant('pricingPlanPro', 'pro')
    .constant('creditCardFee', 0.0199)
    .constant('maxTotalValueFreePlan', 1000000)
    .constant('paymentSlugPse', 'pse')
    .constant('paymentSlugTc', 'tc')
    .constant('paymentSlugEfecty', 'efecty')
    .constant('efectyTier1Limit', 195000)
    .constant('efectyTier2Limit', 495000)
    .constant('efectyTier1Fee', 2500)
    .constant('efectyTier2Fee', 5000)
    .constant('key_site_gg','6Lecb4AbAAAAAA_1Cf7t_A8i4r4rsUo_rEJiIN_w')
    .constant('key_site_gg_v2','6LdU5aAdAAAAACVIU0r5-5AiYoKRO0PeKnBXM8H4')
    .constant('secret_token_gg_r','ggrcptchv2')
    .constant('fourByThousandAppliesDate', new Date(2021, 7, 24))

    // production
    .constant('ruteCode', 't_evolutionpas')
    .constant('protocol', 'https://')
    .constant('host', 'armatuvaca.com')
    .constant('fbAPI', '1647672178887313')
    .constant('ggAPI', '706551587800-s4d2u8qfef5mbnod3bvqrspq12vu2r43.apps.googleusercontent.com')
    .constant('paymentURL', 'https://www.zonapagos.com/api_inicio_pago/api/inicio_pagoV2')
    .constant('marketplaceURL', 'https://tienda.armatuvaca.com/')
    .constant('fepURL', 'https://fep.armatuvaca.com/')
    .constant('atvURL', 'https://armatuvaca.com/')
    .constant('atvPayURL', 'https://wenjoy.com.co/')
    // staging
    // .constant('ruteCode', 't_evolutionpruebas')
    // .constant('protocol', 'https://')
    // .constant('host', 'staging.armatuvaca.com')
    // .constant('fbAPI', '1647672178887313')
    // .constant('ggAPI', '706551587800-s4d2u8qfef5mbnod3bvqrspq12vu2r43.apps.googleusercontent.com')
    // .constant('paymentURL', 'https://www.zonapagosdemo.com/api_inicio_pago/api/inicio_pagoV2')
    // .constant('marketplaceURL', 'https://tiendastaging.armatuvaca.com/')
    // .constant('fepURL', 'https://fepstaging.armatuvaca.com/')
    // .constant('atvURL', 'https://staging.armatuvaca.com/')
    // .constant('atvPayURL', 'https://staging.wenjoy.com.co/')
      // dev
    // .constant('ruteCode', 't_evolutionpruebas')
    // .constant('protocol', 'http://')
    // .constant('host', 'localhost:8000')
    // .constant('fbAPI', '1652217155099482')
    // .constant('ggAPI', '706551587800-7tf0dvnua5n9b2llm20fa8vqfppmbng4.apps.googleusercontent.com')
    // .constant('paymentURL', 'https://www.zonapagosdemo.com/api_inicio_pago/api/inicio_pagoV2')
    // .constant('marketplaceURL', 'https://tiendastaging.armatuvaca.com/')
    // .constant('fepURL', 'http://localhost:3000/')
    // .constant('atvURL', 'http://localhost:3000/')
    // .constant('atvPayURL', 'https://staging.wenjoy.com.co/')
    .factory('resourceBaseUrl', function (protocol, host, apiVersion) {
      return protocol + host + '/api/' + apiVersion;
    });

})();

(function () {
  'use strict';

  angular
    .module('user')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $mdDateLocaleProvider, fbAPI, ngIntlTelInputProvider,
                  $sceDelegateProvider, $provide, mainColorCow, uiGmapGoogleMapApiProvider, ezfbProvider, $urlRouterProvider,
                  ngMetaProvider, $stateProvider, $compileProvider) {
    // Enable log
    $logProvider.debugEnabled(false);

    ngMetaProvider.useTitleSuffix(true);
    ngMetaProvider.setDefaultTitle('Armatuvaca | Recolecta dinero en grupo Online');
    // ngMetaProvider.setDefaultTitleSuffix(' | ArmaTuVaca.com');
    ngMetaProvider.setDefaultTag('description', 'Armatuvaca para la próxima reunión o evento. Realiza una colecta para lo que quieras, un regalo, un viaje o un cumpleaños. Invita a tus amigos a un proyecto de Crowdfunding. Recolecta dinero por medios electrónicos. Recauda fondos o cobra dinero a un amigo. Ahora la Vaca se hace Online.');

    ngMetaProvider.setDefaultTag('og:url', 'https://armatuvaca.com');
    ngMetaProvider.setDefaultTag('og:type', 'website');
    ngMetaProvider.setDefaultTag('og:title', 'Armatuvaca | Recolecta dinero en grupo Online');
    ngMetaProvider.setDefaultTag('og:description', 'Armatuvaca para la próxima reunión o evento. Realiza una colecta para lo que quieras, un regalo, un viaje o un cumpleaños. Invita a tus amigos a un proyecto de Crowdfunding. Recolecta dinero por medios electrónicos. Recauda fondos o cobra dinero a un amigo. Ahora la Vaca se hace Online.');
    ngMetaProvider.setDefaultTag('og:image', 'https://armatuvacacom.s3.amazonaws.com/stuff/meta-share-img.jpg');
    ngMetaProvider.setDefaultTag('fb:app_id', fbAPI);

    ngMetaProvider.setDefaultTag('twitter:url', 'https://armatuvaca.com');
    ngMetaProvider.setDefaultTag('twitter:title', 'Armatuvaca | Recolecta dinero en grupo Online');
    ngMetaProvider.setDefaultTag('twitter:description', 'Armatuvaca para la próxima reunión o evento. Realiza una colecta para lo que quieras, un regalo, un viaje o un cumpleaños. Invita a tus amigos a un proyecto de Crowdfunding. Recolecta dinero por medios electrónicos. Recauda fondos o cobra dinero a un amigo. Ahora la Vaca se hace Online.');
    ngMetaProvider.setDefaultTag('twitter:image', 'https://armatuvacacom.s3.amazonaws.com/stuff/meta-share-img.jpg');

    ngMetaProvider.setDefaultTag('robots', 'index,follow');

    $stateProvider.decorator('data', ngMetaProvider.mergeNestedStateData);


    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      'self',
      // Allow loading from our assets domain.  Notice the difference between * and **.
      'https://armatuvaca.s3.amazonaws.com/**'
    ]);

    $urlRouterProvider.when('/how-it-works', '/como-funciona-hacer-una-vaca-online');
    $urlRouterProvider.when('/prices', '/tarifas-hacer-una-vaca-online');
    $urlRouterProvider.when('/register', '/registro-vaca-online');
    $urlRouterProvider.when('/create-cow?participant_value&commission_added&commission_deducted&cowEventId', '/crear-vaca-onlne?participant_value&commission_added&commission_deducted&cowEventId');
    $urlRouterProvider.when('/crear-vaca?participant_value&commission_added&commission_deducted&cowEventId', '/crear-vaca-onlne?participant_value&commission_added&commission_deducted&cowEventId');
    $urlRouterProvider.when('/account?currentTab', '/mi-cuenta?currentTab');
    $urlRouterProvider.when('/cow/:cowId', '/vaca/:cowId');
    $urlRouterProvider.when('/cow-admin/:cowId', '/administrar-vaca/:cowId');
    $urlRouterProvider.when('/cow-deleted/:cowId', '/vaca-eliminada/:cowId');
    $urlRouterProvider.when('/cow-get-money/:cowId', '/recolectar-monto-vaca/:cowId');
    $urlRouterProvider.when('/cow-resend/:cowId', '/reenviar-vaca/:cowId');
    $urlRouterProvider.when('/participate/:cowId', '/participante/:cowId');
    $urlRouterProvider.when('/forgot-password', '/olvide-contrasena');
    $urlRouterProvider.when('/recovery-cellphone-password/:cellphoneToken', '/recuperar-celular-contrasena/:cellphoneToken');
    $urlRouterProvider.when('/recovery-email-password/:emailToken', '/recuperar-email-contrasena/:emailToken');
    $urlRouterProvider.when('/payment-respond?id_pago', '/respuesta-pago?id_pago');
    $urlRouterProvider.when('/cow-get-money-status/:getMoneyRequestId', '/recolectar-monto-vaca-status/:getMoneyRequestId');
    $urlRouterProvider.when('/privacy-policy', '/politica-tratamiento-datos');
    $urlRouterProvider.when('/terms-and-conditions', '/terminos-y-condiciones');
    $urlRouterProvider.when('/welcome', '/bienvenido-armar-vaca-online');
    // $urlRouterProvider.when('/administrar-vaca/:cowId', '/administrar-vaca/:cowId');
    // $urlRouterProvider.when('/feedback-payment?id_pago&calificacion', '/calificar-pago?id_pago&calificacion');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;

    $mdDateLocaleProvider.formatDate = function (date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    };

    $mdDateLocaleProvider.parseDate = function (dateString) {
      var m = moment(dateString, 'DD/MM/YYYY', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };

    ezfbProvider.setLocale('es_CO');
    ezfbProvider.setInitParams({
      appId: fbAPI,
      version: 'v12.0'
    });

    var _defaultInitFunction = ['$window', 'ezfbInitParams', function ($window, ezfbInitParams) {
      // Initialize the FB JS SDK
      $window.FB.init(ezfbInitParams);
    }];

    ngIntlTelInputProvider.set({
      defaultCountry: 'co'
    });

    $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function (taRegisterTool, taOptions) { // $delegate is the taOptions we are decorating
      taOptions.toolbar = [
        ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
        ['insertLink', 'insertVideo']
        // ['html', 'insertImage', 'insertLink', 'insertVideo']
      ];
      return taOptions;
    }]);

    $(".button-action").css('background-color', mainColorCow);


    uiGmapGoogleMapApiProvider.configure({
      //    key: 'your api key',
      v: '3.20', //defaults to latest 3.X anyhow
      libraries: 'places,placeses'
    });

    $compileProvider.debugInfoEnabled(false);
    $compileProvider.commentDirectivesEnabled(false);
    $compileProvider.cssClassDirectivesEnabled(false);


  }

})();

angular.module("user").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/calculator/calculator.html","<div class=\"container-fluid margin-top-20\"><h2 class=\"text-center font-color-atv\">Calculadora Inteligente</h2><p class=\"font-color-gray text-center calculator-subtitle\">Nuestro costo de servicio oscila entre $2.000 y $7.000 pesos (COP).</p><p class=\"font-color-gray text-center calculator-subtitle\">Nuestra Calculadora Inteligente te mostrará el costo por Participación, dependiendo del monto que ingreses.</p></div><form name=calculatorMain novalidate ng-submit=createCowFromMain($valid)><div class=container-fluid><div class=\"container main-calculator-value\"><div class=row><div class=\"form-group text-center font-color-atv\"><label>Participación / Contribución <i class=\"fa fa-info-circle\" tooltip-placement=bottom tooltip-class=tl-tip-custom uib-tooltip=\"Es el monto que pagarán los participantes\" aria-hidden=true></i></label><input id=partipant_value ng-model=participant_value name=partipant_value class=\"form-control-atv text-center center-item participant_value no-placeholder-sm-xs\" placeholder=\"Ingresa la participación\" ui-money-mask=0 type=tel ng-change=participantValueChanged() onfocus=\"this.placeholder = \'\'\" onblur=\"this.placeholder = \'Ingresa la participación\'\" required><p>*Participación entre <b>{{minPaymentValue | currency:\"$\":\'0\'}} COP</b> y <b>{{maxPaymentValue | currency:\"$\":\'0\'}} COP</b></p></div></div></div></div><div class=\"container-fluid background-color-gray-light\"><div class=\"row margin-top-bottom-20\"><div class=col-md-12><h3 class=\"font-color-atv text-center margin-top-5\"><b>Elige el costo de servicio </b><i class=\"fa fa-info-circle tooltip-calculator\" tooltip-placement=bottom uib-tooltip=\"¿Qué es el costo de servicio? Es el costo de utilizar el servicio de Armatuvaca\" aria-hidden=true></i></h3></div><div class=\"col-md-offset-1 col-md-10 margin-top-20 padding-bottom-20\"><div class=\"col-xs-12 col-sm-12 col-md-6 text-center no-padding-right-md no-padding-left-right-xs-sm\"><div class=\"col-md-12 calculator-header-box padding-top-15\"><md-checkbox id=commission_added ng-model=commission_added class=\"font-bold font-color-atv\" ng-change=commissionAddedChanged()>Costo de servicio añadido</md-checkbox></div><div class=\"col-xs-6 col-sm-6 col-md-6 no-padding-left-right calculator-left-value-box font-color-gray padding-top-bottom-30\"><h6 class=font-size-11-xs>El participante paga</h6><p class=\"font-size-xx-large text-center font-size-x-large-xs\">{{owner_added_participant_pay | currency:\"$\":0}}</p></div><div class=\"col-xs-6 col-sm-6 col-md-6 no-padding-left-right calculator-right-value-box font-color-gray padding-top-bottom-30\"><h6 class=font-size-11-xs>El organizador recupera</h6><p class=\"font-size-xx-large text-center font-color-atv font-size-x-large-xs\"><b>{{owner_added_participant_get | currency:\"$\":0}}</b></p></div><div class=col-md-12><h5 class=\"text-center margin-top-20\">El costo de servicio será añadido a la participación</h5></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 text-center no-padding-left-md no-padding-left-right-xs-sm\"><div class=\"col-md-12 calculator-header-box padding-top-15\"><md-checkbox id=commission_deducted ng-model=commission_deducted class=\"font-bold font-color-atv\" ng-change=commissionDeductedChanged()>Costo de servicio deducido</md-checkbox></div><div class=\"col-xs-6 col-sm-6 col-md-6 no-padding-left-right calculator-left-value-box font-color-gray padding-top-bottom-30\"><h6 class=font-size-11-xs>El participante paga</h6><p class=\"font-size-xx-large text-center font-size-x-large-xs\">{{owner_deducted_participant_pay | currency:\"$\":0}}</p></div><div class=\"col-xs-6 col-sm-6 col-md-6 no-padding-left-right calculator-right-value-box padding-top-bottom-30\"><h6 class=\"font-color-gray font-size-11-xs\">El organizador recupera</h6><p class=\"font-size-xx-large text-center font-color-atv font-size-x-large-xs\"><b>{{owner_deducted_participant_get | currency:\"$\":0}}</b></p></div><div class=col-md-12><h5 class=\"text-center margin-top-20\">El costo de servicio será deducido de la participación</h5></div></div></div></div></div><div class=\"container-fluid background-color-white\"><div class=\"row margin-top-20\"><div class=\"col-md-offset-3 col-md-6 text-center\"><h3 class=\"font-color-atv margin-top-5\"><b>Resumen</b></h3><div class=row><table class=center-item><tr><td class=text-right>Participación por persona:</td><td><b class=\"margin-td-calculator-value font-size-initial\">{{participant_value_temp | currency:\"$\":0}}</b></td></tr><tr><td class=text-right>Costo de servicio:</td><td><b class=\"pull-right font-size-initial\">{{commission_value | currency:\"$\":0}}</b></td></tr><tr><td class=text-right>Participación + costo de servicio:</td><td><b class=\"pull-right font-size-initial\">{{participant_value_temp_commission | currency:\"$\":0}}</b></td></tr></table><hr class=hr-calculator-summary><div class=margin-top-20><table class=center-item><tr><td class=text-right><b>¿Cuánto recibo?</b></td><td class=font-color-atv><b class=\"margin-td-calculator-value font-size-x-large\">{{total_value_obtained | currency:\"$\":0}}</b> <i class=\"fa fa-info-circle tooltip-calculator\" tooltip-placement=bottom uib-tooltip=\"Este es el monto final que recibirás de cada participante.\" aria-hidden=true></i></td></tr></table></div></div></div></div><div class=\"row margin-bottom-40 margin-top-20\"><div class=\"main-hiw-button center-item\"><h4 class=font-color-gray>¿Estás listo?</h4><button id=calculator_cow_create class=button-action ng-click=goToCreateCow()>Armar una Vaca</button></div></div></div></form>");
$templateCache.put("app/components/adminNavBar/adminNavBar.html","<div class=cow-adminv><div class=cow-adminv-menu><div class=cow-adminv-menu-user>¡Hola {{user.user.first_name}}!</div><!--<div class=\"cow-adminv-menu-user cow-adminv-menu-user-sm\">--><!--¡Hola!--><!--</div>--><div class=cow-adminv-menu-desc><p>Nos alegra que vuelvas por acá</p><small>Selecciona una opción:</small></div><div class=\"cow-adminv-menu-desc cow-adminv-menu-desc-sm\"><small>Menú:</small></div><ul><li ui-sref=cash-dashboard><i class=atv-admin-home uib-tooltip=\"Mi Cuenta\" tooltip-placement=right></i> <span>Mi Cuenta</span></li><li ui-sref=cows-user><i class=icon-atv-logo-blank-square uib-tooltip=\"Mis Vacas\" tooltip-placement=right></i> <span>Mis Vacas</span></li><li ui-sref=\"account({currentTab: \'2\'})\"><i class=atv-admin-bank uib-tooltip=\"Cuentas Bancarias\" tooltip-placement=right></i> <span>Cuentas Bancarias</span></li><li ui-sref=\"account({currentTab: \'1\'})\"><i class=atv-admin-creditcard uib-tooltip=\"Medios de pago\" tooltip-placement=right></i> <span>Medios de pago</span></li><li ui-sref=\"account({currentTab: \'0\'})\"><i class=atv-admin-profile uib-tooltip=Perfil tooltip-placement=right></i> <span>Perfil</span></li><li ng-click=logOut()><i class=atv-admin-logout uib-tooltip=\"Cerrar Sesión\" tooltip-placement=right></i> <span>Cerrar Sesión</span></li></ul></div><div class=\"cow-adminv-content lowerR-cowspot-div\"><div ng-transclude></div></div></div>");
$templateCache.put("app/components/cashoutCalculator/cashoutCalculator.html","<div class=\"container-fluid margin-top-20\"><h2 class=\"text-center font-color-atv\">Calculadora Inteligente</h2><p class=\"font-color-gray text-center calculator-subtitle\">Nuestra Calculadora Inteligente te mostrará el costo de servicio, dependiendo del plan que elijas y el monto recolectado en la Vaca</p></div><form name=calculatorMain novalidate ng-submit=createCowFromMain($valid)><div class=container-fluid><div class=\"container main-calculator-value\"><div class=row><div class=\"col-md-6 col-sm-6 col-xs-6 participation-value-container\"><div class=\"col-sm-12 col-xs-12 col-md-12 no-padding-left-right margin-bottom-10\"><button type=button id=freeFeeButton ng-click=selectFreeFee() class=\"participation-type-button font-bold\" ng-class=\"freeFeeSelected ? \'participation-type-button-selected\' : \'participation-type-button-unselected\'\">Plan Básico</button></div></div><div class=\"col-md-6 col-sm-6 col-xs-6 participation-value-container\"><div class=\"col-sm-12 col-xs-12 col-md-12 no-padding-left-right margin-bottom-10\"><button type=button id=3PercentFeeButton ng-click=select3PercentFee() class=\"participation-type-button font-bold\" ng-class=\"threePercentFeeSelected ? \'participation-type-button-selected\' : \'participation-type-button-unselected\'\">Plan Pro</button></div></div><!-- <div class=\"col-md-4 col-sm-4 col-xs-4 participation-value-container\">\n                    <div class=\"col-sm-12 col-xs-12 col-md-12 no-padding-left-right margin-bottom-10\">\n                        <button type=\"button\" id=\"5PercentFeeButton\" ng-click=\"select5PercentFee()\"\n                                class=\"participation-type-button font-bold\"\n                                ng-class=\"fivePercentFeeSelected ? \'participation-type-button-selected\' : \'participation-type-button-unselected\'\">\n                          Plan Vacanes\n                        </button>\n                    </div>\n                </div> --><div class=\"form-group text-center font-color-atv\"><input id=cashout_value ng-model=cashoutValue name=cashout_value class=\"form-control-atv text-center center-item participant_value no-placeholder-sm-xs\" placeholder=\"Monto que retiras\" ui-money-mask=0 type=tel ng-change=cashoutValueChanged() onfocus=\"this.placeholder = \'\'\" onblur=\"this.placeholder = \'Monto que retiras\'\" required><!--                    <p>--><!--                        *El retiro debe ser mínimo <b>{{minGetMoneyValue | currency:\"$\":\'0\'}} COP</b>--><!--                    </p>--></div></div></div></div><div class=\"container-fluid background-color-white\"><div class=\"row margin-top-20\"><div class=\"col-md-offset-3 col-md-6 text-center\"><h3 class=\"font-color-atv margin-top-5\"><b>Resumen</b></h3><div class=row><table class=center-item><tr><td class=text-right>Valor recolectado:</td><td><b class=\"margin-td-calculator-value font-size-initial\">{{cashoutValue | currency:\"$\":0}}</b></td></tr><tr><td class=text-right>Costo del servicio:</td><td><b class=\"pull-right font-size-initial text-red\">-{{commissionValue | currency:\"$\":0}}</b></td></tr><tr><td class=text-right>IVA sobre el servicio:</td><td><b class=\"pull-right font-size-initial text-red\">-{{ivaValue | currency:\"$\":0}}</b></td></tr><tr><td class=text-right>4x1000 en el retiro:</td><td><b class=\"pull-right font-size-initial text-red\">-{{fourByThousandTax | currency:\"$\":0}}</b></td></tr></table><hr class=hr-calculator-summary><div class=margin-top-20><table class=center-item><tr><td class=text-right><b>¿Cuánto recibo?</b></td><td class=font-color-atv><b class=\"margin-td-calculator-value font-size-x-large\">{{totalValueReceived | currency:\"$\":0}}</b></td></tr></table></div></div></div></div><div class=\"row margin-bottom-40 margin-top-20\"><div class=\"main-hiw-button center-item\"><h4 class=font-color-gray>¿Estás listo?</h4><button id=calculator_cow_create class=button-action ng-click=goToCreateCow()>Armar una Vaca</button></div></div></div></form>");
$templateCache.put("app/components/barHome/barHome.html","<div class=atv__bar-home><div class=atv__bar-home__item ng-repeat=\"(key, value) in bar_items\" ng-class=\"{\'atv__bar-home__item--active\': (key+1) === active_item}\" ng-click=clickItem(key+1)><img class=atv__bar-home__item__icon src=assets/images/newhome/{{value.icon}} ng-class=\"{\'atv__bar-home__item__icon--active\': (key+1) === active_item}\"><h2 class=atv__bar-home__item__title>{{value.title}}</h2><!-- <p class=\"atv__bar-home__item__desc\">{{value.desc}}</p> --><div class=atv__bar-home__item__selector ng-if=\"(key+1) === active_item\"></div></div></div>");
$templateCache.put("app/components/countdownTimer/countdownTimer.html","<div class=\"cow-timer-container text-center row\" ng-show=!cowFinished><h4 class=\"no-margin col-md-3\">{{getTraductor(\'countdown_timer.countdown_header\')}}</h4><div class=\"col-md-3 col-xs-4\"><p class=\"font-size-30 font-size-30-sm-xs no-margin-bottom\">{{daysLeft}}</p><p ng-if=\"daysLeft!=1\">{{getTraductor(\'countdown_timer.days\')}}</p><p ng-if=\"daysLeft==1\">{{getTraductor(\'countdown_timer.day\')}}</p></div><div class=\"col-md-3 col-xs-4\"><p class=\"font-size-30 font-size-30-sm-xs no-margin-bottom\">{{hoursLeft}}</p><p ng-if=\"hoursLeft!=1\">{{getTraductor(\'countdown_timer.hours\')}}</p><p ng-if=\"hoursLeft==1\">{{getTraductor(\'countdown_timer.hour\')}}</p></div><div class=\"col-md-3 col-xs-4\"><p class=\"font-size-30 font-size-30-sm-xs no-margin-bottom\">{{minutesLeft}}</p><p ng-if=\"minutesLeft!=1\">{{getTraductor(\'countdown_timer.minutes\')}}</p><p ng-if=\"minutesLeft==1\">{{getTraductor(\'countdown_timer.minute\')}}</p></div></div><div class=text-center ng-show=cowFinished><h3 class=\"margin-top-10 no-margin-bottom hidden-xs\">{{getTraductor(\'countdown_timer.countdown_alert\')}}</h3><h4 class=\"no-margin visible-xs\">{{getTraductor(\'countdown_timer.countdown_alert\')}}</h4></div>");
$templateCache.put("app/components/cowQuickCreate/cowQuickCreate.html","<div class=\"container-fluid background-color-white no-padding-left-right cow-quick-create-container\"><div class=cow-quick-create-title><h3 class=\"font-bold no-margin\">Arma una Vaca</h3></div><form class=margin-top-20 name=formCow novalidate ng-submit=goToCreateCow(formCow.$valid) id=dateRangeForm><div><div class=\"row cow-quick-create-section margin-top-40\"><div><div class=\"cow-type-img-container hidden-xs hidden-sm\"><div ng-if=cowTypeString><img src={{getCowEventTypeEmotivaca(cowTypeString)}} class=\"img-responsive center-img cow-type-img\" ng-class=animationClass alt=emotivaca_img></div></div><md-input-container class=\"col-md-6 col-xs-12 md-input-has-placeholder no-padding-left text-left\" md-is-error=\"formCow.cow_name.$invalid && formCow.$submitted\"><label class=font-size-18>Nombre de la Vaca</label><input id=cow_create_cow_name required type=text name=cow_name md-maxlength=50 ng-model=cow.name placeholder=\"Agrega acá el nombre de la Vaca\"><div ng-messages=formCow.cow_name.$error><div ng-message=required>Escribe el nombre de tu vaca</div></div></md-input-container><md-input-container class=\"col-md-6 col-md-offset-right-6 col-xs-12 no-padding-left text-left\"><label>Tipo de la Vaca</label><md-select ng-model=cowTypeString ng-change=cowEventTypeChanged(cowTypeString)><md-option ng-repeat=\"cowType in cowEventTypesList | orderBy:\'priority\'\" ng-value=cowType>{{cowType.name}}</md-option></md-select></md-input-container></div></div><div class=\"row cow-quick-create-section\"><div class=margin-bottom-20><h4 class=text-left><b>Participación / Contribución</b> <i class=\"fa fa-info-circle cow-quick-create-tooltip hidden-xs\" tooltip-placement=right uib-tooltip=\"Es el monto que cada participante aportará a la Vaca\" aria-hidden=true></i></h4></div><div class=\"col-md-4 col-sm-4 col-xs-12 no-padding-left-right margin-bottom-20 text-left\"><div class=\"col-sm-4 col-xs-4 col-md-4 no-padding-left\"><md-checkbox id=cow_create_participation_free ng-model=cow.participation_free aria-label=\"Checkbox 1\" ng-change=selectParticipationFree() uib-tooltip=\"El participante eligirá el monto de su contribución\" tooltip-placement=bottom tooltip-class=hidden-xs>Libre</md-checkbox></div><i class=\"visible-xs fa fa-info-circle cow-quick-create-tooltip-participation\" tooltip-placement=left uib-tooltip=\"El participante eligirá el monto de su contribución\" aria-hidden=true></i></div><div class=\"col-md-4 col-sm-4 col-xs-12 no-padding-left-right margin-bottom-20 text-left\"><div class=\"col-md-12 col-sm-12 col-xs-4 no-padding-left\"><md-checkbox id=cow_create_participation_suggested ng-model=cow.participation_suggested aria-label=\"Checkbox 1\" ng-change=selectParticipationSuggested() uib-tooltip=\"Podrás sugerir un monto al participante\" tooltip-placement=bottom tooltip-class=hidden-xs>Sugerida</md-checkbox></div><div class=\"col-md-12 col-sm-12 col-xs-8 pull-left no-padding-left-right\"><input ng-show=cow.participation_suggested id=cow_create_participant_value_suggested ng-model=cow.participant_value_suggested name=partipantSuggestedValue class=\"form-control-atv text-center cow-quick-create-participation-value\" placeholder=\"Monto sugerido\" ui-money-mask=0 type=tel min=\"\" ng-focus=selectParticipationSuggestedFocus() ng-required=cow.participation_suggested ng-change=setParticipationValueExample(cow.participant_value_suggested)><p ng-show=\"formCow.$submitted && formCow.partipantSuggestedValue.$invalid && cow.participation_suggested\" class=\"validation-messages text-left\">Por favor ingresa el monto sugerido</p><p ng-show=\"formCow.$submitted && formCow.partipantSuggestedValue.$dirty && cow.participation_suggested && cow.participant_value_suggested < minPaymentValue\" class=validation-messages>El monto mínimo de participación es de {{minPaymentValue | currency:\"$\":\'0\'}} COP</p><p ng-show=\"formCow.$submitted && formCow.partipantSuggestedValue.$dirty && cow.participation_suggested && cow.participant_value_suggested > maxPaymentValue\" class=validation-messages>El monto máximo de participación es de {{maxPaymentValue | currency:\"$\":\'0\'}} COP</p></div><i class=\"visible-xs fa fa-info-circle cow-quick-create-tooltip-participation\" tooltip-placement=left uib-tooltip=\"Podrás sugerir un monto al participante\" aria-hidden=true></i></div><div class=\"col-md-4 col-sm-4 col-xs-12 no-padding-left-right margin-bottom-20 text-left\"><div class=\"col-md-12 col-sm-12 col-xs-4 no-padding-left\"><md-checkbox id=cow_create_participation_fixed ng-model=cow.participation_fixed aria-label=\"Checkbox 1\" ng-change=selectParticipationFixed() uib-tooltip=\"El participante solo podra aportar el monto que tu decidas\" tooltip-placement=bottom tooltip-class=hidden-xs>Fija</md-checkbox><p ng-show=\"formCow.$submitted && (!cow.participation_suggested && !cow.participation_fixed && !cow.participation_free)\" class=validation-messages>Por favor selecciona un tipo de participación</p></div><div class=\"col-md-12 col-sm-12 col-xs-8 pull-left no-padding-left-right\"><input ng-show=cow.participation_fixed id=cow_create_participant_value_fixed ng-model=cow.participant_value_fixed name=partipantFixedValue class=\"form-control-atv text-center cow-quick-create-participation-value\" placeholder=\"Monto fijo\" ui-money-mask=0 type=tel min=\"\" ng-focus=selectParticipationFixedFocus() ng-required=cow.participation_fixed ng-change=setParticipationValueExample(cow.participant_value_fixed)><p ng-show=\"formCow.$submitted && formCow.partipantFixedValue.$invalid && cow.participation_fixed\" class=\"validation-messages text-left\">Por favor ingresa el monto fijo</p><p ng-show=\"formCow.$submitted && formCow.partipantFixedValue.$dirty && cow.participation_fixed && cow.participant_value_fixed < minPaymentValue\" class=validation-messages>El monto mínimo de participación es de {{minPaymentValue | currency:\"$\":\'0\'}} COP</p><p ng-show=\"formCow.$submitted && formCow.partipantFixedValue.$dirty && cow.participation_fixed && cow.participant_value_fixed > maxPaymentValue\" class=validation-messages>El monto máximo de participación es de {{maxPaymentValue | currency:\"$\":\'0\'}} COP</p></div><i class=\"visible-xs fa fa-info-circle cow-quick-create-tooltip-participation\" tooltip-placement=left uib-tooltip=\"El participante solo podra aportar el monto que tu decidas\" aria-hidden=true></i></div></div></div><div class=\"col-md-12 margin-bottom-20 text-center\"><button id=cow_create_btn_submit class=\"btn btn-default button-action no-margin\" type=submit>Armar Vaca</button></div></form></div>");
$templateCache.put("app/components/cowShareDirective/cowShare.html","<div class=atv-cow-share-widget><div class=atv-cow-share-widget-link><p><b style=\"color: #808080\">{{getTraductor(\'share_cow.copy_link_long\')}}:</b></p><input id=cow_link type=text name=link ng-model=cowPublicURLCompleteCopy readonly> <button type=button name=button ngclipboard data-clipboard-target=#cow_link ng-click=copyLink()><span>Copia el enlace <i class=\"fa fa-link\" aria-hidden=true></i></span></button> <button type=button name=button ng-click=openQR()><span>Comparte el QR <i class=\"fa fa-qrcode\" aria-hidden=true></i></span></button></div><div class=atv-cow-share-widget-social><!-- <p>{{getTraductor(\'share_cow.share_networks\')}}:</p> --><div><div class=\"col-md-2 col-xs-3 text-center\"><a class=no-outline ng-click=shareFb()><img src=assets/images/utils/facebook.svg class=\"no-outline center-item img-share\" alt=facebook-logo></a></div><div class=\"col-xs-3 text-center visible-xs visible-sm\"><a class=\"no-outline center-item\" socialshare socialshare-provider=facebook-messenger socialshare-url={{cowPublicURLComplete}}><img src=assets/images/utils/messenger.svg class=\"no-outline center-item img-share\" alt=messenger-logo></a></div><div class=\"col-xs-3 text-center visible-xs visible-sm\"><a class=no-outline socialshare socialshare-provider=whatsapp socialshare-url={{cowPublicURLComplete}} socialshare-text=\"{{cow_event.name + \' \' }}\"><img src=assets/images/utils/whatsapp.svg class=\"no-outline center-item img-share\" alt=whatsapp-logo></a></div><div class=\"col-md-2 col-xs-3 text-center hidden-xs hidden-sm\"><a ng-href=\"https://wa.me/?text={{cowPublicURLComplete}}\" data-action=share/whatsapp/share onclick=\"window.open(this.href, \'\', \'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600\');return false\" target=_blank title=\"Share on whatsapp\"><img src=assets/images/utils/whatsapp.svg class=\"no-outline center-item img-share\" alt=whatsapp-logo></a></div><div class=\"col-md-2 col-xs-3 text-center\"><a class=no-outline ng-click=shareTw()><img src=assets/images/utils/twitter.svg class=\"no-outline center-item img-share\" alt=twitter-logo></a></div><!-- <div class=\"col-md-2 col-xs-2 text-center\">\n        <a class=\"no-outline\" href=\"https://www.linkedin.com/sharing/share-offsite/?url={{cowPublicURLComplete}}\" target=\"_blank\">\n          <img src=\"assets/images/utils/linkedin.svg\" class=\"no-outline center-item img-share\"\n               alt=\"LinkedIn-logo\">\n        </a>\n      </div> --></div></div><br></div><!--<div class=\"row text-center margin-top-bottom-20-sm\">--><!--<h3 class=\"col-md-12 no-margin\" ng-if=\"cowBusinessType !== cowBusinessTypeCredibanco\">--><!--{{getTraductor(\'share_cow.to_share\')}}</h3>--><!--<h3 class=\"col-md-12 no-margin\" ng-if=\"cowBusinessType === cowBusinessTypeCredibanco\">¡Comparte esta causa!</h3>--><!--<div class=\"col-md-9 col-md-offset-3 col-sm-12 col-xs-12 text-center margin-top-5 no-padding\">--><!--<div class=\"form-group\">--><!--<input id=\"cow_link\" type=\"text\" name=\"link\" ng-model=\"cowPublicURLCompleteCopy\"--><!--class=\"form-control width-300-md\">--><!--<div class=\"col-md-4 col-sm-6 col-xs-6 padding-5\">--><!--<button type=\"button\" name=\"button\" class=\"form-control no-padding\" ngclipboard--><!--data-clipboard-target=\"#cow_link\"--><!--ng-click=\"copyLink()\">--><!--<i class=\"fa fa-clone\" aria-hidden=\"true\"></i>--><!--{{getTraductor(\'share_cow.copy_link\')}}--><!--</button>--><!--</div>--><!--<div class=\"col-md-4 col-sm-6 col-xs-6 padding-5\">--><!--<button type=\"button\" name=\"button\" class=\"form-control no-padding\" ng-click=\"openQR()\">--><!--<i class=\"fa fa-qrcode font-size-18\" aria-hidden=\"true\"></i>--><!--{{getTraductor(\'share_cow.qr_code\')}}--><!--</button>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><script type=text/ng-template id=QRCodeModal><div class=\"text-center\">\n    <h4>{{getTraductor(\'share_cow.touch_qr\')}}</h4>\n    <h5>{{getTraductor(\'share_cow.alert_qr\')}}</h5>\n    <qrcode data=\"{{ngDialogData.cowParticipateURL}}\" size=\"200\" color=\"#333\" download></qrcode>\n  </div></script>");
$templateCache.put("app/components/cowTips/cowTips.html","<div class=\"container-fluid text-center\" ng-show=\"cowTipsList.length > 0\"><h3 class=\"text-center font-color-white\">Tips de la Vaca</h3><div class=\"hidden-xs hidden-sm\"><div class=no-carousel-control uib-carousel active=0 interval=5000><div ng-repeat=\"cowTipsGroup in cowTipsGroups\" uib-slide index=cowTipsGroup.id><div ng-repeat=\"cowTip in cowTipsGroup.content\" ng-class=cowTipsGroup.class class=cow-tips-container><div class=cow-tip-number>{{cowTip.id}}</div><p class=cow-tip>{{cowTip.tip}}</p></div></div></div></div><div class=\"no-carousel-control visible-sm visible-xs\" uib-carousel active=0 interval=3000><div uib-slide ng-repeat=\"cowTip in cowTipsList track by $index\" index=$index><div><div class=cow-tips-container><div class=cow-tip-number>{{cowTip.id}}</div><p class=cow-tip>{{cowTip.tip}}</p></div></div></div></div></div>");
$templateCache.put("app/components/cowsDirective/cows.html","<div class=user-cows-container><div class=\"row text-center\" ng-if=\"cows.length == 0\"><h4><b>Aún no tienes Vacas</b></h4><button class=button-action ng-click=goToCreateCow()>Armar mi primera Vaca</button></div><div class=cows-title ng-show=\"cows.length > 0\"><h3 class=cows-search-title>Mis Vacas</h3><button type=button name=button class=\"form-control font-size-12-sm-xs\" ng-click=displayClosedCows() style=\"max-width: 150px\"><span class=\"fa fa-eye-slash\" aria-hidden=true ng-show=!hideClosedCows></span> <span class=\"fa fa-eye\" aria-hidden=true ng-show=hideClosedCows></span> <span ng-show=!hideClosedCows>Vacas Cerradas</span> <span ng-show=hideClosedCows>Vacas Cerradas</span></button></div><input class=\"form-control margin-top-20 cows-search ng-valid ng-not-empty ng-dirty ng-valid-parse ng-touched\" placeholder=\"Busca entre tus vacas\" type=text ng-model=searchCows aria-invalid=false data-dashlane-rid=d72e0eacbe6ad08e data-form-type=\"\"><div class=\"row text-center margin-bottom-20\"><div class=\"col-md-6 col-sm-12 col-xs-12 margin-top-20 margin-bottom-20\" ng-repeat=\"cow in cows | filter:searchCows\" ng-show=\"!hideClosedCows || (hideClosedCows && !cow.closed && !cow.closed_money_request && !cow.marketplace_cow_completed)\"><div class=cows-cow><div class=\"closed-cows-bar text-center no-outline\" ng-show=\"cow.closed && !cow.closed_money_request && !cow.marketplace_cow_completed\" ng-click=goToCowAdmin(cow.cow_event_id)><p class=\"font-color-white name-cow\"><b>{{cow.name}}</b></p><p class=\"mayus font-color-white font-size-11\"><b>Cerrada</b></p></div><div class=\"closed-cows-bar text-center no-outline\" ng-show=cow.closed_money_request ng-click=goToCowAdmin(cow.cow_event_id)><p class=\"font-color-white name-cow\"><b>{{cow.name}}</b></p><p class=\"mayus font-color-white font-size-11\"><b>Recolectada</b></p></div><div class=\"closed-cows-bar text-center no-outline\" ng-show=cow.marketplace_cow_completed ng-click=goToCowAdmin(cow.cow_event_id)><p class=\"font-color-white name-cow\"><b>{{cow.name}}</b></p><p class=\"mayus font-color-white font-size-11\"><b>Finalizada</b></p></div><div class=\"closed-cows-bar text-center no-outline\" ng-show=\"!cow.closed_money_request && !cow.closed\" ng-click=goToCowAdmin(cow.cow_event_id)><p class=\"font-color-white name-cow\"><b>{{cow.name}}</b></p></div><div class=\"container-fluid no-padding-left-right overflow-hidden no-outline\" ng-click=goToCowAdmin(cow.cow_event_id)><div class=main-top-content-cows ng-style=\"getBackgroudCssStyleCowShadow(cow.main_img, cow.closed)\"><div class=div-gradiant></div></div></div><!--<div class=\"text-center no-outline cows-box-title\" ng-click=\"goToCowAdmin(cow.cow_event_id)\">--><!--<h6>--><!--<b>{{cow.name}}</b>--><!--</h6>--><!--</div>--><div class=\"col-md-6 col-sm-6 col-xs-6 cows-info-bar no-padding\"><div class=\"col-md-6 col-sm-6 col-xs-6 text-center cows-box-participants no-outline\" ng-click=goToCowAdmin(cow.cow_event_id)><p class=\"p-cow-details font-color-white\"><b>{{cow.participations}} <i class=\"fa fa-user\" ng-if=\"cow.participations <= 1\" aria-hidden=true></i> <i class=\"fa fa-users\" ng-if=\"cow.participations > 1\" aria-hidden=true></i></b></p></div><div class=\"col-md-6 col-sm-6 col-xs-6 text-center cows-box-total-value no-outline\" ng-click=goToCowAdmin(cow.cow_event_id)><p class=p-cow-details><b class=font-color-white>{{cow.total_value | currency:\"$\":0}} COP</b></p></div></div><div class=\"col-md-6 col-sm-6 col-xs-6 text-center cows-box-1 no-outline\" ng-click=goToCowEdit(cow.cow_event_id) ng-show=\"!cow.marketplace && !cow.is_promo\"><p class=p-cows-details-box><i class=\"fa fa-pencil font-color-blue\" aria-hidden=true></i> <b>Modificar</b></p></div><div class=\"col-md-6 col-sm-6 col-xs-6 text-center cows-box-1 no-outline\" ng-click=goToCowInvite(cow.cow_event_id) ng-show=cow.marketplace><p class=p-cows-details-box><i class=\"fa fa-paper-plane-o font-color-blue\" aria-hidden=true></i> <b>Invitar</b></p></div><div class=\"col-md-6 col-sm-6 col-xs-6 text-center cows-box-2 no-outline\" ng-click=goToCowAdmin(cow.cow_event_id) ng-show=!cow.is_promo><p class=p-cows-details-box><i class=\"fa fa-cog font-color-gray\" aria-hidden=true></i> <b>Administrar Vaca</b></p></div><div class=\"col-md-12 col-sm-12 col-xs-12 text-center cows-box-3 no-outline\" ng-click=goToCowAdmin(cow.cow_event_id) ng-show=cow.is_promo><p class=p-cows-details-box><i class=\"fa fa-cog font-color-gray\" aria-hidden=true></i> <b>Administrar Vaca</b></p></div><div class=\"col-md-6 col-sm-6 col-xs-6 text-center cows-box-3 no-outline\" ng-click=goToCowGetMoney(cow.cow_event_id) ng-show=!cow.is_promo><p class=p-cows-details-box><i class=\"fa fa-money font-color-atv\" aria-hidden=true></i> <b>Sacar Plata</b></p></div><div class=\"col-md-12 col-sm-12 col-xs-12 text-center cows-box-3 no-outline\" ng-click=goToCowGetMoney(cow.cow_event_id) ng-show=cow.is_promo><p class=p-cows-details-box><i class=\"fa fa-money font-color-atv\" aria-hidden=true></i> <b>Sacar Plata</b></p></div><div class=\"col-md-6 col-sm-6 col-xs-6 text-center cows-box-4 no-outline\" ng-click=openCowDeleteConfirmation(cow) ng-show=!cow.is_promo><p class=p-cows-details-box><i class=\"fa fa-trash-o font-color-red-error\" aria-hidden=true></i> <b>Eliminar</b></p></div></div></div></div><div class=cows-create-cow ng-show=\"cows.length > 0\"><button class=atv__home__second-view__button ng-click=goToCreateCow() style=\"color: white\">Armatuvaca</button></div></div><script type=text/ng-template id=confirmationContactDeleteCowModal-1><div class=\"ngdialog-message text-center\">\n    <div class=\"\" ng-if=\"ngDialogData.cow.total_value > 0\">\n      <h3 class=\"\">Tu Vaca ya tiene participaciones, no la puedes eliminar</h3>\n      <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeSecond(ngDialogId)\"></a>\n    </div>\n    <div class=\"\" ng-if=\"ngDialogData.cow.total_value == 0\">\n      <h3 class=\"\">¿Seguro que quieres borrar esta Vaca?</h3>\n      <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeSecond(ngDialogId)\"></a>\n      <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"confirmationDeleteCow(ngDialogData.cow, ngDialogId)\"></a>\n    </div>\n  </div></script>");
$templateCache.put("app/components/feedbackCarousel/feedbackCarousel.html","<div class=\"container-fluid text-center\" ng-show=\"feedbackList.length > 0\"><h3 class=\"text-center margin-bottom-20 font-color-white\">Lo que dicen nuestros usuarios</h3><div class=\"hidden-xs hidden-sm\"><div class=no-carousel-control uib-carousel active=0 interval=5000><div ng-repeat=\"feedbacksGroup in feedbacksGroups\" uib-slide index=feedbacksGroup.id><div ng-repeat=\"feedback in feedbacksGroup.content\" ng-class=feedbacksGroup.class><div><i class=\"no-outline font-color-atv\" ng-repeat=\"star in stars\" ng-class=\"(star.value <= feedback.grade)?\'fa fa-star\':\'fa fa-star-o\'\"></i><h4 class=\"no-margin font-color-white\">{{feedback.title}}</h4><p class=font-color-white>{{feedback.comments}}</p></div></div></div></div></div><div class=\"no-carousel-control visible-sm visible-xs\" uib-carousel active=0 interval=3000><div uib-slide ng-repeat=\"feedback in feedbackList track by $index\" index=$index><div><div><i class=\"no-outline font-color-atv\" ng-repeat=\"star in stars\" ng-class=\"(star.value <= feedback.grade)?\'fa fa-star\':\'fa fa-star-o\'\"></i><h3 class=\"no-margin font-color-white\">{{feedback.title}}</h3><p class=font-color-white>{{feedback.comments}}</p></div></div></div></div></div>");
$templateCache.put("app/components/feedbackDirective/feedback.html","<div class=container><div class=\"row text-center\"><div class=\"col-md-4 col-sm-12 col-xs-12 margin-top-20 margin-bottom-20\" ng-repeat=\"feedback in listFeedback track by $index\"><div class=cw-public-cow-info style=\"background-color: lightgrey; color: #323232\"><div style=\"text-align: left\"><span style=\"font-size: 0.8em; color: yellow\" ng-repeat=\"x in [].constructor(feedback.grade) track by $index\"><i class=\"fa fa-star\"></i></span><br><h3 class=cw-public-cow-name>{{feedback.title}}</h3><h4 class=cw-public-cow-name>{{feedback.cow_event.name}}</h4><p class=cw-public-cow-desc style=\"font-style: italic\">\"{{feedback.comments}}\"</p></div></div></div></div></div>");
$templateCache.put("app/components/footer/footer.html","<footer><div class=\"container-fluid footer-main\"><div class=\"container footer-margin-top\"><hr><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 footer-security\"><h5 class=\"text-center mayus\">Seguridad</h5><br><p style=\"text-align: center\"><i class=\"fa fa-lock\" aria-hidden=true></i> Protocolo Https (Seguro)<br><br><i class=\"fa fa-key\" aria-hidden=true></i> Certificados de seguridad<br><br><i class=\"fa fa-check\" aria-hidden=true></i> Certificación PCI (Manejo de tarjetas de crédito)<br><br></p><div><div class=\"text-center col-md-4 col-xs-4 margin-bottom-10\"><img class=\"img_gray height-60 height-40-sm-xs margin-auto\" src=assets/images/secure/positivessl-icon.png alt=security></div><div class=\"text-center col-md-4 col-xs-4 margin-bottom-10\"><img class=\"img_gray height-60 height-40-sm-xs margin-auto\" src=assets/images/secure/ssl_security.png alt=security></div><div class=\"text-center col-md-4 col-xs-4 margin-bottom-10\"><img class=\"img_gray height-60 height-40-sm-xs margin-auto\" src=assets/images/secure/pci_compliant.png alt=security></div><div class=\"text-center col-md-12 col-xs-12 margin-bottom-10\"><a href=https://www.sic.gov.co/ target=_blank><img class=\"height-60 height-40-sm-xs margin-auto\" src=assets/images/secure/sic.png alt=SIC></a></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 footer-contact\"><h5 class=\"text-center mayus\">Contacto</h5><br><p style=\"text-align: center\"><i class=\"fa fa-whatsapp\" aria-hidden=true></i> +57 300 718 5815<br><br><i class=\"fa fa-phone\" aria-hidden=true></i> +57 300 718 5815<br><br><i class=\"fa fa-envelope-o\" aria-hidden=true></i> <a href=mailto:contacto@armatuvaca.com class=font-color-white>contacto@armatuvaca.com</a><br><br></p><div class=row><div class=\"text-center col-md-2 col-xs-2 margin-bottom-10 margin-top-10\"><a href=https://www.facebook.com/armatuvaca target=_blank class=social-media-footer-link><p id=iconFacebook><i class=\"fa fa-facebook font-size-18 padding-top-12\" aria-hidden=true></i></p></a></div><div class=\"text-center col-md-2 col-xs-2 margin-bottom-10 margin-top-10\"><a href=https://www.instagram.com/armatuvaca/ target=_blank class=social-media-footer-link><p id=iconInstagram><i class=\"fa fa-instagram font-size-18 padding-top-12\" aria-hidden=true></i></p></a></div><div class=\"text-center col-md-2 col-xs-2 margin-bottom-10 margin-top-10\"><a href=https://www.youtube.com/channel/UCXK9YoqhNvyRXz0kNMf-vqw target=_blank class=social-media-footer-link><p id=iconYoutube><i class=\"fa fa-youtube-play font-size-18 padding-top-12\" aria-hidden=true></i></p></a></div><div class=\"text-center col-md-2 col-xs-2 margin-bottom-10 margin-top-10\"><a href=https://twitter.com/armatuvaca target=_blank class=social-media-footer-link><p id=iconTwitter><i class=\"fa fa-twitter font-size-18 padding-top-12\" aria-hidden=true></i></p></a></div><div class=\"text-center col-md-2 col-xs-2 margin-bottom-10 margin-top-10\"><a href=https://lu.linkedin.com/company/arma-tu-vaca target=_blank class=social-media-footer-link><p id=iconLinkedin><i class=\"fa fa-linkedin font-size-18 padding-top-12\" aria-hidden=true></i></p></a></div><div class=\"text-center col-md-2 col-xs-2 margin-bottom-10 margin-top-10\"><a href=https://www.tiktok.com/@armatuvaca target=_blank class=social-media-footer-link><p id=iconTikTok><i class=\"fa atv-admin-tiktok font-size-18 padding-top-12\" aria-hidden=true></i></p></a></div></div></div></div><hr><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 footer-about text-center\"><h5>ACERCA DE</h5><ul class=\"list-unstyled footer-list\"><li class=\"margin-top-10 margin-bottom-10\"><a id=footer_faq ui-sref=frecuently-asked-questions href=\"\" class=font-color-white>Preguntas Frecuentes</a></li><li class=\"margin-top-10 margin-bottom-10\"><a id=footer_hiw ui-sref=how-it-works href=\"\" class=font-color-white>¿Cómo funciona?</a></li><li class=\"margin-top-10 margin-bottom-10\"><a id=footer_prices ui-sref=prices href=\"\" class=font-color-white>Tarifas</a></li><!--            <li class=\"margin-top-10 margin-bottom-10\">--><!--              <a id=\"footer_about_us\" ui-sref=\"about-us\" href=\"\" class=\"font-color-white\">¿Quiénes somos?</a>--><!--            </li>--><li class=\"margin-top-10 margin-bottom-10\"><a id=footer_terms_and_conditions ui-sref=terms-and-conditions href=\"\" class=font-color-white>Términos y Condiciones</a></li><li class=\"margin-top-10 margin-bottom-10\"><a id=footer_privacy_policy ui-sref=privacy-policy href=\"\" class=font-color-white>Política de Tratamiento de Datos</a></li></ul></div><div class=\"col-xs-12 col-sm-12 col-md-6 footer-services text-center\"><div class=text-center><h5 class=\"mayus font-bold no-margin-bottom margin-top-30\">Medios de pago aceptados</h5><div><div class=\"text-center col-md-3 col-xs-3 margin-top-20\"><img class=\"img_gray height-50 height-40-sm-xs margin-auto\" src=assets/images/footer/mastercard.png alt=payment-methods></div><div class=\"text-center col-md-3 col-xs-3 margin-top-20\"><img class=\"img_gray height-50 height-40-sm-xs margin-auto\" src=assets/images/footer/visa.png alt=payment-methods></div><div class=\"text-center col-md-3 col-xs-3 margin-top-20\"><img class=\"img_gray height-50 height-40-sm-xs margin-auto\" src=assets/images/footer/diners.jpg alt=payment-methods></div><div class=\"text-center col-md-3 col-xs-3 margin-top-20\"><img class=\"img_gray height-50 height-40-sm-xs margin-auto\" src=assets/images/footer/pse.png alt=payment-methods></div></div></div></div></div></div><hr><div class=\"row footer-develop text-center\"><!--<h6>v 1.2.1</h6>--><h6>Desarrollado con <i class=\"fa fa-heart font-color-pink font-size-18\" aria-hidden=true></i> por <a href=https://evolutionideas.co/ target=_blank>Evolution Ideas SAS© </a><img src=assets/images/footer/flag_CO.png height=17 width=23 alt=flag_CO></h6></div></div></footer><script type=text/ng-template id=atvBusinessContactModal><div class=\"ngdialog-message\">\n    <div class=\"text-center\">\n      <i class=\"fa fa-envelope font-size-40\" aria-hidden=\"true\"></i>\n      <p>\n        Tenemos una solución pensada para ti. Si te interesa que Armatuvaca sea tu aliado en pagos para tu negocio,\n        déjanos tus datos y te contactaremos.</p>\n      <form class=\"userCellphoneModal\" name=\"formAtvBusinessContact\" novalidate=\"\">\n        <md-input-container class=\"col-md-offset-2 col-xs-offset-1 col-md-8 col-xs-10 margin-top-10 no-margin-bottom\"\n                            md-no-float>\n          <input ng-model=\"businessContact.name\" name=\"contactName\" type=\"text\"\n                 required=\"\" placeholder=\"Tu nombre\" class=\"text-center\">\n          <div ng-messages=\"formAtvBusinessContact.contactName.$error\">\n            <div ng-message=\"required\">\n              Por favor ingresa tu nombre\n            </div>\n          </div>\n        </md-input-container>\n        <md-input-container class=\"col-md-offset-2 col-xs-offset-1 col-md-8 col-xs-10 margin-top-10 no-margin-bottom\"\n                            md-no-float>\n          <input ng-model=\"businessContact.email\" name=\"contactEmail\" type=\"email\"\n                 required=\"\" placeholder=\"Tu correo electrónico\" class=\"text-center\">\n          <div ng-messages=\"formAtvBusinessContact.contactEmail.$error\">\n            <div ng-message=\"required\">\n              Por favor ingresa un correo electrónico válido\n            </div>\n          </div>\n        </md-input-container>\n        <md-input-container class=\"col-md-offset-2 col-xs-offset-1 col-md-8 col-xs-10 margin-top-10 no-margin-bottom\"\n                            md-no-float>\n          <input ng-model=\"businessContact.cellphone\" name=\"contactCellphone\" type=\"tel\" pattern=\"[0-9]{10,12}\"\n                 only-digits required=\"\" placeholder=\"Tu número celular\" class=\"text-center\">\n          <div ng-messages=\"formAtvBusinessContact.contactCellphone.$error\">\n            <div ng-message=\"required\">\n              Por favor ingresa tu número celular\n            </div>\n            <div ng-message=\"pattern\">\n              El número debe contener entre 10 y 12 dígitos\n            </div>\n          </div>\n        </md-input-container>\n        <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"submitAtvBusinessContact()\"></a>\n      </form>\n      <p class=\"font-size-12 margin-top-10\">\n        <a ui-sref=\"privacy-policy\" href=\"\" target=\"_blank\" class=\"\">\n          Política de Tratamiento de Datos\n        </a>\n      </p>\n    </div>\n  </div></script>");
$templateCache.put("app/components/howItWorks4Steps/howItWorks4Steps.html","<div class=container-fluid><div class=\"container-fluid fluid-hiw\"><div><div class=\"main-hiw-tittle text-center\" ng-show=showTitle><h3>¿Cómo funciona?</h3></div><div class=\"main-hiw-content hidden-xs-sm\"><div class=\"col-xm-12 col-sm-6 col-md-3\"><div class=\"text-center main-hiw-description\"><a href=\"\" ui-sref=cow-create><img class=\"img-circle img-hiw\" src={{slides_cow[0].image}} alt=img-home></a><h4>{{slides_cow[0].title}}</h4><p>{{slides_cow[0].description}}</p></div></div><div class=\"col-xm-12 col-sm-6 col-md-3\"><div class=\"text-center main-hiw-description\"><img class=\"img-circle img-hiw\" src={{slides_cow[1].image}} alt=img-home><h4>{{slides_cow[1].title}}</h4><p>{{slides_cow[1].description}}</p></div></div><div class=\"col-xm-12 col-sm-6 col-md-3\"><div class=\"text-center main-hiw-description\"><img class=\"img-circle img-hiw\" src={{slides_cow[2].image}} alt=img-home><h4>{{slides_cow[2].title}}</h4><p>{{slides_cow[2].description}}</p></div></div><div class=\"col-xm-12 col-sm-6 col-md-3\"><div class=\"text-center main-hiw-description\"><img class=\"img-circle img-hiw\" src={{slides_cow[3].image}} alt=img-home><h4>{{slides_cow[3].title}}</h4><p>{{slides_cow[3].description}}</p></div></div></div><div class=\"main-hit-slider visible-sm visible-xs position-relative\"><ul rn-carousel rn-carousel-controls rn-carousel-index=carouselIndex rn-carousel-buffered rn-carousel-duration=800 rn-carousel-easing=easeInOutSine><li ng-repeat=\"slide in slides_cow track by slide.id\"><div class=\"text-center main-hiw-description\"><img class=\"img-circle img-hiw\" src={{slide.image}} alt=img-home><h4>{{slide.title}}</h4><p>{{slide.description}}</p></div></li></ul></div><div class=\"main-hiw-button hidden-md hidden-lg\" ng-show=!showTitle><button class=button-action ng-click=goToCreateCow()>Armar una Vaca</button></div><!--<div class=\"text-center visible-sm visible-xs\">--><!--<p>--><!--<a id=\"hiw_see_example\" ng-click=\"showAdvanced($event)\">Ver ejemplo</a>--><!--</p>--><!--</div>--><div class=\"col-md-12 text-center\" ng-show=showTitle><button class=\"btn btn-default button-action-small\" ng-click=showAdvanced($event)>Ver ejemplo</button></div></div></div></div><script type=text/ng-template id=dialog1.tmpl.html><md-dialog aria-label=\"Ejemplo\">\n    <form ng-cloak>\n      <!-- <md-toolbar>\n        <div class=\"md-toolbar-tools\">\n          <h2>Ejemplo</h2>\n          <span flex></span>\n          <md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n            <md-icon md-svg-src=\"img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n          </md-button>\n        </div>\n      </md-toolbar> -->\n\n      <md-dialog-content>\n        <div class=\"md-dialog-content\">\n          <img class=\"img-example\" alt=\"ejemplo armatuvaca.com\" src=\"assets/images/utils/example-cow.png\" ng-show=\"!showVideo\">\n          <iframe class=\"video-example\"\n                  src=\"https://www.youtube.com/embed/UDGjRHbUxF4?autoplay=0&autohide=1&hd=1&showinfo=0&rel=0&version=3&vq=hd720\"\n                  frameborder=\"0\" allowfullscreen ng-show=\"showVideo\"></iframe>\n        </div>\n      </md-dialog-content>\n\n      <md-dialog-actions layout=\"row\">\n        <md-button id=\"hiw_close_example\" ng-click=\"cancel()\">\n          Cerrar\n        </md-button>\n      </md-dialog-actions>\n    </form>\n  </md-dialog></script>");
$templateCache.put("app/components/marketplaceCategories/marketplaceCategories.html","<div class=\"container-fluid background-color-white no-padding-left-right cow-quick-create-container margin-bottom-20\"><div class=cow-quick-create-title><a class=white-link href={{marketplaceURL}}><h3 class=\"font-bold no-margin\">Compra y Paga en Grupo</h3></a></div><div class=marketplace-categories-container><div class=marketplace-category ng-repeat=\"category in categories\" ng-click=openCategory(category.slug)><p class=no-margin><span><img src={{category.main_img}} alt=category-image></span><br>{{category.name}}</p></div></div></div>");
$templateCache.put("app/components/marketplaceOffers/marketplaceOffers.html","<div class=marketplace-offers-container><!--<div class=\"hidden-xs\">--><!--<div uib-carousel active=\"0\" interval=\"3000\">--><!--<div ng-repeat=\"offersGroup in offersGroups\" uib-slide index=\"offersGroup.id\">--><!--<div ng-repeat=\"offer in offersGroup.content\" ng-class=\"offersGroup.class\">--><!--<a href=\"{{offer.url}}\">--><!--<img class=\"marketplace-offers-img\" src=\"{{offer.small_img}}\" alt=\"offer-image\"/>--><!--</a>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><div><div uib-carousel active=0 interval=3000><div ng-repeat=\"offer in offers\" uib-slide index=offer.id><a href={{offer.data.url}}><img class=marketplace-offers-img src={{offer.data.main_img}} alt=offer-image></a></div></div></div></div>");
$templateCache.put("app/components/mediaCarousel/mediaCarousel.html","<div class=\"container-fluid text-center background-color-white padding-bottom-30\"><!--<h3 class=\"text-center font-color-atv\">¿Quién habla de nosotros? </h3>--><div class=\"main-hiw-content no-carousel-control hidden-xs hidden-sm\"><div uib-carousel active=0 interval=3000><div ng-repeat=\"mediaLinksContainer in mediaLinksContainers\" uib-slide index=mediaLinksContainer.id><div ng-repeat=\"mediaLink in mediaLinksContainer.content\" ng-class=mediaLinksContainer.class><a href={{mediaLink.link}} target=_blank><img class=\"slider-press-img center-img\" src={{mediaLink.image}} alt=\"media link image\"></a></div></div></div></div><div class=\"media-slider no-carousel-control visible-sm visible-xs position-relative margin-top-20\"><div uib-carousel active=0 interval=3000><div ng-repeat=\"mediaLink in mediaLinks\" uib-slide index=\"mediaLink.priority - 1\"><a href={{mediaLink.link}} target=_blank><img class=\"slider-press-img center-img\" src={{mediaLink.image}} alt=\"media link image\"></a></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<header><div><nav class=\"navbar navbar-default navbar-fixed-top navbar-atv\" role=navigation><div class=container><a id=navbar_sm_menu class=\"navbar-toggle pull-left\" ng-click=toggleRight() ng-hide=isOpenRight()><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></a></div><!-- menu de escritorio --><div class=\"hidden-xs hidden-sm padding-left-right-50\"><ul class=\"nav navbar-nav pull-right\"><!--Menu sin desplegables--><li ng-repeat=\"menuOption in menuOptions\" ng-show=\"{{menuOption.required_auth ? menuOption.is_logged === logged : true }}\" ng-if=\"menuOption.submenu.length <= 0\"><a id=menuOption.id ui-sref={{menuOption.uihref}} ui-sref-opts=menuOption.uioptions href=menuOption.href class=menuOption.class><b>{{menuOption.title}}</b></a></li><!--Menu desplegable--><li uib-dropdown ng-repeat=\"menuOption in menuOptions\" ng-show=\"{{menuOption.required_auth ? menuOption.is_logged === logged : true }}\" ng-if=\"menuOption.submenu.length > 0\"><a id={{menuOption.id}} ui-sref={{menuOption.uihref}} uib-dropdown-toggle ui-sref-opts=menuOption.uioptions href=menuOption.href class=menuOption.class><b>{{menuOption.title}} <i class=\"fa fa-caret-down\" aria-hidden=true></i></b></a><ul uib-dropdown-menu><li ng-repeat=\"subMenuOption in menuOption.submenu track by $index\"><!-- ui-sref --> <a id=subMenuOption.id ui-sref={{subMenuOption.uihref}} ui-sref-opts=menuOption.uioptions ng-if=subMenuOption.uihref><img class=atv__bar-home__item__icon ng-src=\"{{\'assets/images/newhome/\' + subMenuOption.icon}}\" ng-if=subMenuOption.icon> <b ng-bind-html=subMenuOption.title></b><br><span ng-if=subMenuOption.description ng-bind-html=subMenuOption.description></span> </a><!-- href --> <a id=subMenuOption.id ng-if=subMenuOption.href href={{subMenuOption.href}} target=_blank><img class=atv__bar-home__item__icon ng-src=\"{{\'assets/images/newhome/\' + subMenuOption.icon}}\" ng-if=subMenuOption.icon> <b ng-bind-html=subMenuOption.title></b><br><span ng-if=subMenuOption.description ng-bind-html=subMenuOption.description></span> </a><!-- ng-click --> <a id=subMenuOption.id ng-click=subMenuOption.action() ng-if=subMenuOption.action style=\"cursor: pointer\"><img class=atv__bar-home__item__icon ng-src=\"{{\'assets/images/newhome/\' + subMenuOption.icon}}\" ng-if=subMenuOption.icon> <b ng-bind-html=subMenuOption.title></b><br><span ng-if=subMenuOption.description ng-bind-html=subMenuOption.description></span> </a><!-- <hr ng-if=\"$index+1 < menuOption.submenu.length\"> --></li></ul></li><!-- traductor --><li uib-dropdown ng-if=lang><a class=navbar_dp_options_lan uib-dropdown-toggle href=\"\"><b><span class=\"flag-icon {{current_lang.icon}}\"></span> <i class=\"fa fa-caret-down\" aria-hidden=true></i></b></a><ul uib-dropdown-menu><li ng-repeat=\"lang in langs\" style=\"cursor: pointer\"><a class=navbar_dp_lan_es ng-click=changeLang(lang.id)><b><span class=\"flag-icon {{lang.icon}}\"></span> {{lang.name}}</b></a></li></ul></li></ul><div class=header-logo><a id=navbar_logo_box_letters_home ng-click=scrollToTopOrGoHome() href=# class=hidden-sm><img class=\"img-responsive pull-right logo-header-letters\" src=assets/images/atvorangelogo.png alt=logo></a></div></div><!-- menu movile --><div class=\"container visible-xs visible-sm\"><div><a id=navbar_logo_letters_sm_home ng-click=scrollToTopOrGoHome() href=#><img class=\"img-responsive logo-header-icon-letters\" src=assets/images/atvorangelogo.png alt=logo></a></div></div></nav></div><div class=sidebar-nav><section layout=row flex=\"\"><md-sidenav class=md-sidenav-left md-component-id=left><div layout-padding=\"\"><div><a id=navbar_sm_menu_close class=\"pull-right dark-font-atv\" ng-click=close()><span class=\"glyphicon glyphicon-remove\"></span></a></div><div class=container><ul class=\"nav navbar-nav navbar-sitebar\"><!-- traductor --><li uib-dropdown ng-if=lang><a class=navbar_dp_options_lan uib-dropdown-toggle href=\"\"><b><span class=\"flag-icon {{current_lang.icon}}\"></span> <i class=\"fa fa-caret-down\" aria-hidden=true></i></b></a><ul uib-dropdown-menu><li ng-repeat=\"lang in langs\" style=\"cursor: pointer\"><a class=navbar_dp_lan_es ng-click=changeLang(lang.id)><b><span class=\"flag-icon {{lang.icon}}\"></span> {{lang.name}}</b></a></li></ul></li><!-- fin traductor --><!-- menu sin desplegable --><li ng-repeat=\"menuOption in menuOptions\" ng-show=\"{{menuOption.required_auth ? menuOption.is_logged === logged : true }}\" ng-if=\"menuOption.submenu.length <= 0\"><a id={{menuOption.id}} ng-click=close() ui-sref={{menuOption.uihref}}><b>{{menuOption.title}}</b></a></li><!-- menu desplegable --><li uib-dropdown ng-repeat=\"menuOption in menuOptions\" ng-show=\"{{menuOption.required_auth ? menuOption.is_logged === logged : true }}\" ng-if=\"menuOption.submenu.length > 0\"><a id={{menuOption.id}} ui-sref={{menuOption.uihref}} uib-dropdown-toggle><b>{{menuOption.title}} <i class=\"fa fa-caret-down\" aria-hidden=true></i></b></a><ul uib-dropdown-menu><li ng-repeat=\"subMenuOption in menuOption.submenu track by $index\"><!-- ui-sref --> <a id=subMenuOption.id ui-sref={{subMenuOption.uihref}} ui-sref-opts=menuOption.uioptions ng-click=close() ng-if=subMenuOption.uihref><img class=atv__bar-home__item__icon ng-src=\"{{\'assets/images/newhome/\' + subMenuOption.icon}}\" ng-if=subMenuOption.icon> <b ng-bind-html=subMenuOption.title></b><br><span class=atv__navbar__text ng-if=subMenuOption.description ng-bind-html=subMenuOption.description></span> </a><!-- href --> <a id=subMenuOption.id ng-if=subMenuOption.href href={{subMenuOption.href}} target=_blank><img class=atv__bar-home__item__icon ng-src=\"{{\'assets/images/newhome/\' + subMenuOption.icon}}\" ng-if=subMenuOption.icon> <b ng-bind-html=subMenuOption.title></b><br><span class=atv__navbar__text ng-if=subMenuOption.description ng-bind-html=subMenuOption.description></span> </a><!-- ng-click --> <a id=subMenuOption.id ng-click=\"subMenuOption.action(); close();\" ng-if=subMenuOption.action style=\"cursor: pointer\"><img class=atv__bar-home__item__icon ng-src=\"{{\'assets/images/newhome/\' + subMenuOption.icon}}\" ng-if=subMenuOption.icon> <b ng-bind-html=subMenuOption.title></b><br><span class=atv__navbar__text ng-if=subMenuOption.description ng-bind-html=subMenuOption.description></span> </a><!-- <hr ng-if=\"$index+1 < menuOption.submenu.length\"> --></li></ul></li></ul></div><div class=sidebar-button><button id=navbar_btn_sm_cow_create class=\"btn btn-default button-action\" ng-click=goToCreateCow()>Armar Vaca</button></div></div></md-sidenav></section></div><div id=top-scroll></div></header>");
$templateCache.put("app/components/newBankAccountDirective/newBankAccount.html","<!--<div class=\"row\">--><!--<div class=\"col-md-offset-3 col-md-6\">--><!--<h4 id=\"account_bank_account_tittle\" ng-click=\"isCollapsed=!isCollapsed\" class=\"no-outline\">--><!--<i class=\"fa\" ng-class=\"(isCollapsed)?\'fa-plus-circle\':\'fa-minus-circle\'\" aria-hidden=\"true\"></i>--><!--Agregar cuenta bancaria--><!--</h4>--><!--<p>(Puede ser tu cuenta o la de un tercero)</p>--><!--</div>--><!--</div>--><div class=atv-bank-account-new ng-click=\"isCollapsed=!isCollapsed\"><div><i class=fa ng-class=\"(isCollapsed)?\'fa-plus-circle\':\'fa-minus-circle\'\" aria-hidden=true></i><p>Agregar cuenta bancaria</p><small>(Puede ser tu cuenta o la de un tercero)</small></div></div><div><div class=margin-top-20 uib-collapse=isCollapsed><form name=formNewBankAccount id=formNewBankAccount ng-submit=\"addBankAccount(formNewBankAccount.$valid && confirm_account_number == bankAccountInfo.bank_account_number)\" novalidate><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-offset-gt-sm=25 flex-gt-sm=50 md-is-error=\"formNewBankAccount.name.$invalid && formNewBankAccount.$submitted\"><label>Nombre personalizado</label><input id=account_bank_account_name type=text name=name ng-model=bankAccountInfo.name placeholder=\"Mi cuenta bancaria\" md-maxlength=50 required><div ng-messages=formNewBankAccount.name.$error><div ng-message=required>Dale un nombre a tu cuenta</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-offset-gt-sm=25 flex-gt-sm=50 md-is-error=\"formNewBankAccount.bank_account_owner_name.$invalid && formNewBankAccount.$submitted\"><label>Nombre del titular / Razón social</label><input id=account_bank_account_owner_name required type=text name=bank_account_owner_name ng-model=bankAccountInfo.bank_account_owner_name placeholder=\"Escribe el nombre del titular de la cuenta\" md-maxlength=50><div ng-messages=formNewBankAccount.bank_account_owner_name.$error><div ng-message=required>El nombre del titular es obligatorio</div></div></md-input-container></div><div layout-gt-sm=row><!--<md-input-container class=\"md-block no-margin-bottom\" flex-offset-gt-sm=\"25\" flex-gt-sm=\"50\"--><!--md-is-error=\"formNewBankAccount.bank_account_owner_document.$invalid && formNewBankAccount.$submitted\">--><!--<label>Documento de identificación / NIT--><!--</label>--><!--<input id=\"account_bank_account_document\" required=\"\" type=\"tel\" name=\"bank_account_owner_document\"--><!--ng-model=\"bankAccountInfo.bank_account_owner_document\" placeholder=\"10190722189\"--><!--pattern=\"[0-9]{6,15}\">--><!--<div ng-messages=\"formNewBankAccount.bank_account_owner_document.$error\">--><!--<div ng-message=\"required\">El numero de cuenta es obligatorio</div>--><!--<div ng-message=\"pattern\">Solo se aceptan numeros y su longitud no debe ser mayor a 15 dígitos</div>--><!--</div>--><!--</md-input-container>--><md-input-container class=\"md-block no-margin-top\" flex-offset-gt-sm=25 flex-gt-sm=50><md-select-header><span class=select-title>Tipo de documento</span></md-select-header><md-select ng-model=bankAccountInfo.bank_account_owner_document_type name=bank_account_owner_document_type aria-label=\"Document Type\" required><md-option ng-repeat=\"document in documentTypes\" value={{document.id}}>{{document.key_type_name}}</md-option></md-select><div ng-messages=formNewBankAccount.bank_account_owner_document_type.$error multiple md-auto-hide=true><div ng-message=required>Por favor selecciona un tipo de documento</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom margin-top-30-sm-xs\" flex-offset-gt-sm=25 flex-gt-sm=50 ng-show=\"bankAccountInfo.bank_account_owner_document_type == 1 ||\n                                    bankAccountInfo.bank_account_owner_document_type == 2\"><label ng-show=\"bankAccountInfo.bank_account_owner_document_type == 1\">N° de cédula</label><label ng-show=\"bankAccountInfo.bank_account_owner_document_type == 2\">NIT (Con dígito de verificación)</label><input ng-model=bankAccountInfo.bank_account_owner_document name=bank_account_owner_document type=tel pattern=[0-9]{1,15} only-digits required placeholder=\"Ingresa el N° de documento\"><div ng-messages=formNewBankAccount.bank_account_owner_document.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>Sólo se aceptan números con una longitud entre 6 y 10 dígitos</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom margin-top-30-sm-xs\" flex-offset-gt-sm=25 flex-gt-sm=50 ng-show=\"bankAccountInfo.bank_account_owner_document_type == 3 ||\n                                    bankAccountInfo.bank_account_owner_document_type == 4\"><label ng-show=\"bankAccountInfo.bank_account_owner_document_type == 3\">N° de cédula</label><label ng-show=\"bankAccountInfo.bank_account_owner_document_type == 4\">N° de pasaporte</label><input ng-model=bankAccountInfo.bank_account_owner_document_full name=bank_account_owner_document_full ng-change=setDocumentNumber() ng-required=\"bankAccountInfo.bank_account_owner_document_type == 3 ||\n                                    bankAccountInfo.bank_account_owner_document_type == 4\" pattern=\"^(?=.*\\d).{1,15}\" only-alphanumeric placeholder=\"Ingresa el N° de documento\"><div ng-messages=formNewBankAccount.bank_account_owner_document_full.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>El número debe contener entre 6 y 10 caracteres alfanuméricos</div></div></md-input-container><div ng-show=\"bankAccountInfo.bank_account_owner_document_type==2\" class=hidden-xs-sm><i class=\"fa fa-info-circle tooltip-document\" tooltip-placement=right uib-tooltip=\"Digita el NIT incluyendo dígito de verificación\" aria-hidden=true></i></div></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-top\" flex-offset-gt-sm=25 flex-gt-sm=50 md-is-error=\"formNewBankAccount.bank.$invalid && formNewBankAccount.$submitted\"><md-select-header><span class=select-title>Banco</span></md-select-header><md-select name=bank ng-model=bankAccountInfo.bank aria-label=Bank required><md-option ng-repeat=\"bank in banksList\" value={{bank.id}}>{{bank.name}}</md-option></md-select><div ng-messages=formNewBankAccount.bank.$error multiple md-auto-hide=true><div ng-message=required>Por favor selecciona un banco</div></div></md-input-container><div class=hidden-xs-sm><i class=\"fa fa-info-circle tooltip-document\" tooltip-placement=right uib-tooltip=\"Para BBVA ingresa la versión de 9 dígitos de tu cuenta bancaria\" aria-hidden=true></i></div></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-top\" flex-offset-gt-sm=25 flex-gt-sm=50 md-is-error=\"formNewBankAccount.bank_type.$invalid && formNewBankAccount.$submitted\"><md-select-header><span class=select-title>Tipo de cuenta</span></md-select-header><md-select name=bank_type ng-model=bankAccountInfo.bank_account_type aria-label=\"Bank Account Type\" required><md-option value=0>Ahorros</md-option><md-option value=1>Corriente</md-option></md-select><div ng-messages=formNewBankAccount.bank_type.$error multiple md-auto-hide=true><div ng-message=required>Por favor selecciona un tipo de cuenta</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom margin-top-30-sm-xs\" flex-offset-gt-sm=25 flex-gt-sm=50 md-is-error=\"formNewBankAccount.bank_account_number.$invalid && formNewBankAccount.$submitted\"><label>N° cuenta bancaria</label><input id=account_bank_account_number required type=tel name=bank_account_number ng-model=bankAccountInfo.bank_account_number placeholder=555457889523 pattern=[0-9]{8,16} only-digits-string><div ng-messages=formNewBankAccount.bank_account_number.$error><div ng-message=required>El número de cuenta es obligatorio</div><div ng-message=pattern>Debe tener entre 8 y 16 dígitos</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-offset-gt-sm=25 flex-gt-sm=50 md-is-error=\"formNewBankAccount.confirm_account_number.$invalid && formNewBankAccount.$submitted\"><label>Confirma tu N° de cuenta</label><input id=account_bank_account_confirm_number required type=tel name=confirm_account_number ng-model=confirm_account_number placeholder=555457889523 pattern=[0-9]{8,16} only-digits><p ng-show=\"confirm_account_number != bankAccountInfo.bank_account_number\" class=validation-messages>El número de cuenta debe coincidir.</p><div ng-messages=formNewBankAccount.confirm_account_number.$error><div ng-message=required>Confirma tu número de cuenta</div><div ng-message=pattern>Debe tener entre 8 y 16 dígitos</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-offset-gt-sm=25 flex-gt-sm=50 md-is-error=\"formNewBankAccount.email.$invalid && formNewBankAccount.$submitted\"><label>Email del Titular (Opcional)</label><input id=account_bank_account_email type=email name=email ng-model=bankAccountInfo.bank_account_owner_email placeholder=\"Correo electrónico para notificaciones\" md-maxlength=50 ng-pattern=/^.+@.+\\..+$/ ><div ng-messages=formNewBankAccount.email.$error><div ng-message=pattern>Dirección de correo inválida</div></div></md-input-container><div class=info-message><i class=\"fa fa-info-circle tooltip-document\" tooltip-placement=top uib-tooltip=\"Las transferencias que envíes a esta cuenta bancaria se notificarán a este correo electrónico\" aria-hidden=true></i></div></div><div class=center-item><button id=account_bank_account_submit class=\"btn btn-default button-action-small margin-bottom-20\" type=submit>Agregar cuenta bancaria</button></div></form></div></div>");
$templateCache.put("app/components/newCalc/newCalc.html","<div class=atv__calc><div class=atv__calc__slider><div class=atv__calc__slider__labels><span class=atv__calc__slider__labels__limit>{{track_values[track_option].label_start}}</span> <span class=atv__calc__slider__labels__message ng-if=\"track_option === 0\">(Si deseas recolectar más selecciona otro plan) </span><span class=atv__calc__slider__labels__limit>{{track_values[track_option].label_end}}</span></div><div class=atv__calc__slider__tooltip><p>{{track_value | currency:\"$\":\'0\'}}</p></div><div class=atv__calc__slider__track><div class=atv__calc__slider__track__filled></div></div><div class=atv__calc__slider__bullet></div><input class=atv__calc__slider__input type=range min={{track_values[track_option].min_value}} max={{track_values[track_option].max_value}} step={{track_values[track_option].step}} ng-change=changeTrack() ng-model=track_value></div><div class=atv__calc__selector><p class=atv__calc__selector__title>Elige un plan:</p><div class=atv__calc__selector__options><div class=atv__calc__selector__options__item ng-repeat=\"(key, option) in track_values\" ng-click=selectOption(key) ng-class=\"{\'atv__calc__selector__options__item--active\': key===track_option}\">{{option.name}}</div></div><br><h4>¿Quieres conocer más sobre nuestros planes? <a ui-sref=prices href=\"\">Haz click acá.</a></h4></div></div>");
$templateCache.put("app/components/participationBar/participationBar.html","<!--<uib-progress>--><!--<uib-bar ng-repeat=\"bar in stacked track by $index\" value=\"bar.value\" type=\"{{bar.type}}\"><span>{{bar.value}}%</span></uib-bar>--><!--</uib-progress>--><div class=atv-cow-progressbar><div class=\"atv-cow-progressbar-line atv-cow-progressbar-line-{{type}}\" style=\"border-radius: 5px\" ng-style=\"{\'width\': ((currentValue/goal)*100) +\'%\'}\"></div></div>");
$templateCache.put("app/components/productShareDirective/productShare.html","<div class=\"row margin-top-20 margin-bottom-25 text-center\"><h5>Compartir:</h5><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=\"col-md-4 col-md-offset-1 col-xs-2 width-20-sm-xs text-center\"><a class=no-outline ng-click=shareFb()><img src=assets/images/utils/facebook.svg class=\"no-outline center-item img-share\" alt=facebook-logo></a></div><div class=\"col-xs-2 width-20-sm-xs text-center visible-xs-sm\"><a class=\"no-outline center-item\" socialshare socialshare-provider=facebook-messenger socialshare-url={{productPublicURLComplete}}><img src=assets/images/utils/messenger.svg class=\"no-outline center-item img-share\" alt=messenger-logo></a></div><div class=\"col-xs-2 width-20-sm-xs text-center visible-xs-sm\"><a class=no-outline socialshare socialshare-provider=whatsapp socialshare-url={{productPublicURLComplete}} socialshare-text=\"{{product.name + \' \' }}\"><img src=assets/images/utils/whatsapp.svg class=\"no-outline center-item img-share\" alt=whatsapp-logo></a></div><div class=\"col-xs-2 width-20-sm-xs text-center\"><a class=no-outline ng-click=shareLinkedin()><img src=assets/images/utils/linkedin-logo.png class=\"no-outline center-item img-share\" alt=linkedin-logo></a></div><div class=\"col-md-4 col-xs-2 width-20-sm-xs text-center\"><a class=no-outline ng-click=shareTw()><img src=assets/images/utils/twitter.svg class=\"no-outline center-item img-share\" alt=twitter-logo></a></div></div><div class=\"col-md-12 col-sm-12 col-xs-12 text-center margin-top-5 no-padding-left\"><div class=form-group><input id=cow_link type=text name=link ng-model=productPublicURLCompleteCopy class=\"form-control col-md-offset-2 input-link-share\"><div class=\"col-md-offset-2 col-md-6 col-sm-6 col-xs-6 no-padding-left-xs-sm\"><button type=button name=button class=form-control ngclipboard data-clipboard-target=#cow_link ng-click=copyLink()><i class=\"fa fa-clone\" aria-hidden=true></i> Copiar link</button></div></div></div></div>");
$templateCache.put("app/components/publicCowDirective/publicCows.html","<div class=cw-public-cow-background style=\"background-image: url(\'assets/images/vacanes/vacanes_back.jpg\')\"><div class=container><div class=atv-col-container><div class=\"atv-col atv-col-md-8\" style=\"margin: 20px 0\"><p class=cw-public-cow-background-desc><img src=/assets/images/vacanes/vacanes_letra.png alt=\"\" style=\"height: 25px; margin-top: -8px; width: auto\">{{getTraductor(\'vacanes.about_vacanes\')}}</p><p class=cw-public-cow-background-hashtag>#ElPoderdeLaManada</p><div class=cw-public-cow-background-cta><!-- <button ng-click=\"goToCreatePublicCow()\" class=\"button-action-pink\"\n                  style=\"padding: 0 25px; margin: 0 10px 0 0\">\n            {{getTraductor(\'vacanes.become_to\')}}\n          </button> --> <button ng-click=scrollToPublicCows() class=button-action-pink style=\"padding: 0 25px; background: #00BACA; border-color: #00BACA\">{{getTraductor(\'vacanes.contribute_to\')}}</button></div></div><div class=\"atv-col atv-col-md-4\"><ul class=cw-public-cow-background-benefits><li><img src=/assets/images/vacanes/exposicion_home.png alt=\"\"><p><b>Exposición</b> para tu proyecto en el home de la plataforma.</p></li><li><img src=/assets/images/vacanes/pagos_desde.png alt=\"\"><p><b>Pagos</b> desde <b>$1.000 COP</b> y desde cualquier parte del mundo.</p></li><li><img src=/assets/images/vacanes/cobro_recurrente.png alt=\"\"><p><b>Cobro recurrente</b> para tu proyecto, puedes tener donaciones <b>mensuales</b>.</p></li><li><img src=/assets/images/vacanes/pagos_efectivo.png alt=\"\"><p>Donaciones y retiros en <b>efectivo</b> en todo Colombia. <b>(Efecty)</b></p></li></ul></div></div></div></div><!--<div class=\"text-center\">--><!--<button ng-click=\"goToCreatePublicCow()\" class=\"button-action-pink\">--><!--{{getTraductor(\'vacanes.become_to\')}}--><!--</button>--><!--</div>--><br><div class=container><div class=\"row text-center description-paragraph\"><p ng-bind-html=\"getTraductor(\'vacanes.know_vacanes\')\"></p></div><div class=\"row text-center\"><div class=\"col-md-6 col-md-offset-3 margin-top-20\"><input class=\"form-control margin-bottom-20\" placeholder=\"{{getTraductor(\'vacanes.explore_vacanes\')}}\" type=text ng-keyup=searchBarChange($event)></div><div class=\"col-md-6 col-md-offset-3 margin-top-10\"><div class=\"row text-center description-paragraph\"><p style=\"color: #424242 !important\" ng-bind-html=\"getTraductor(\'vacanes.chose_category\')\"></p></div><ul class=\"nav nav-pills chips\" role=tablist><li role=presentation class=chip><a ng-click=\"searchCowPubliCategory(\'a_all\', \'All\')\" class=\"chipa active\" id=a_all><strong>Todos</strong></a></li><li role=presentation class=chip ng-repeat=\"category in cowsPublicCategory\"><a ng-click=\"searchCowPubliCategory(\'a_\'+category.slug, category.slug)\" class=chipa id=a_{{category.slug}}><strong>{{category.name}}</strong></a></li></ul><!--<md-content class=\"md-padding\" layout=\"column\">\n        <md-chips class=\"custom-chips\" ng-model=\"cowsPublicCategory\" readonly=\"false\" md-removable=\"false\"\n                  input-aria-label=\"Categorias de vacanes\" md-max-chips=\"{{cowsPublicCategory.length}}\">\n          <md-chip ng-click=\"searchCowPubliCategory(\'All\')\"><strong>Todos</strong></md-chip>\n          <md-chip-template ng-click=\"searchCowPubliCategory($chip.slug)\">\n        <span>\n          <strong>{{$chip.name}}</strong>\n        </span>\n          </md-chip-template>\n        </md-chips>\n      </md-content>--></div><div class=\"col-md-12 col-sm-12 col-xs-12 margin-top-20 margin-bottom-20\" ng-if=\"cows.cows.length === 0\"><br><p style=\"text-align: center; font-size: 25px\">No hay Vacas disponibles en esta categoría</p></div><div class=\"col-md-4 col-sm-12 col-xs-12 margin-top-20 margin-bottom-20\" ng-repeat=\"cow in cows.cows\"><div class=\"closed-cows-bar text-center no-outline\" ng-click=goToCow(cow.cow_event_id)><!--<p class=\"font-color-white name-cow\">--><!--<b>{{cow.name}}</b>--><!--</p>--></div><div class=\"container-fluid no-padding-left-right overflow-hidden no-outline\" ng-click=goToCow(cow.cow_event_id)><div class=main-top-content-cows ng-style=\"getBackgroudCssStyleCowShadow(cow.main_img, cow.closed)\"><div class=div-gradiant></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-6 cows-info-bar no-padding\"><div class=\"col-xs-12 text-center cows-box-participants no-outline\" ng-click=goToCowAdmin(cow.cow_event_id)><p class=\"p-cow-details cw-public-cow-participations\"><b>{{cow.participations}} <i class=\"fa fa-user\" ng-if=\"cow.participations <= 1\" aria-hidden=true></i> <i class=\"fa fa-users\" ng-if=\"cow.participations > 1\" aria-hidden=true></i></b></p></div><!--<div class=\"col-md-6 col-sm-6 col-xs-6 text-center cows-box-total-value no-outline\"--><!--ng-click=\"goToCowAdmin(cow.cow_event_id)\">--><!--<p class=\"p-cow-details cw-public-cow-value\">--><!--<b>{{cow.total_value | currency:\"$\":0}} COP</b>--><!--</p>--><!--</div>--></div><!--<div class=\"col-md-6 col-sm-6 col-xs-6 text-center cows-box-1 no-outline\"--><!--ng-click=\"goToCow(cow.cow_event_id)\">--><!--<p class=\"p-cows-details-box\">--><!--<i class=\"fa fa-arrow-right font-color-blue\" aria-hidden=\"true\"></i>--><!--<b>Ir a la Vaca</b>--><!--</p>--><!--</div>--><div class=cw-public-cow-info ng-click=goToCow(cow.cow_event_id)><div style=\"text-align: left\"><h3 class=cw-public-cow-name>{{cow.name}}</h3><div class=cw-public-cow-separator></div><br><p class=cw-public-cow-desc ng-bind-html=cow.description></p></div><div><p style=\"margin: 2px 0 2px 0; text-align: start\">{{getTraductor(\'vacanes.collected\')}}</p><p class=cw-public-cow-value><b>{{cow.total_commission_value | currency:\"$\":0}} COP</b></p></div></div><div class=\"text-center cows-box-1 no-outline cw-public-cow-donate\" ng-click=goToCow(cow.cow_event_id)><p class=p-cows-details-box><i class=\"fa fa-dollar\" aria-hidden=true></i> <b>{{getTraductor(\'vacanes.back_up\')}}</b></p></div><!--<div class=\"col-xs-12\">--><!--<div class=\"cw-public-cow-finish\"></div>--><!--</div>--></div></div></div><div class=container><div class=\"row text-center\"><div class=col-md-12><nav aria-label=\"Page navigation\"><ul class=pagination><li><a ng-click=changePage(1) aria-label=Previous><span aria-hidden=true>&laquo;</span></a></li><li ng-repeat=\"x in [].constructor(cows.pages) track by $index\"><a ng-click=\"changePage($index + 1)\">{{$index + 1}}</a></li><li><a ng-click=changePage(cows.pages) aria-label=Next><span aria-hidden=true>&raquo;</span></a></li></ul></nav></div></div></div>");
$templateCache.put("app/components/verifyEmailDialog/verifyEmailDialog.html","<div class=selectCowCashoutDialog><div class=\"selectCowCashoutDialog-icon text-center\"><i class=\"fa fa-envelope-o\" aria-hidden=true></i></div><h4 class=text-center>Debes verificar tu dirección de correo electrónico<br>para sacar plata</h4><div class=text-center><p style=\"cursor: pointer; text-decoration: underline\" ng-click=resendEmail()><small>¿No te llegó el correo? Haz click aquí para reenviar el correo de confirmación</small></p><button id=cow_create_btn_submit class=\"button-action btn-sm\" style=\"font-size: 15px\" ng-click=closeDialog(cow_event_id)>Aceptar</button></div></div>");
$templateCache.put("app/views/404/404.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid background-color-white\"><div class=\"container text-center\"><h1 class=\"svg-h1 text-center\">Ooopps! Parece que estás perdido...</h1><div class=\"col-md-12 margin-top-20 margin-bottom-20 text-center hidden-xs-sm\"><button class=\"btn btn-default button-action-pink btn-small-xs-sm\" ng-click=goToHome()><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Ir al inicio</button> <button class=\"btn btn-default button-action btn-small-xs-sm\" ng-click=goToCreateCow()>Arma una Vaca</button></div><div class=\"col-md-12 text-center\"><img class=\"img-responsive text-center center-item\" src=assets/images/404cow.png alt=\"astronaut img\"></div></div><div class=\"container margin-top-20 margin-bottom-20 text-center hidden-md hidden-lg\"><button class=\"btn btn-default button-action-pink btn-small-xs-sm\" ng-click=goToHome()><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Ir al inicio</button> <button class=\"btn btn-default button-action btn-small-xs-sm\" ng-click=goToCreateCow()>Arma una Vaca</button></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/aboutUs/aboutUs.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>¿Quiénes somos?</b></h1></div></div><div class=\"container-fluid padding-bottom-20 bottom-line background-color-white\"><div class=container><div class=\"row text-center hidden-xs-sm margin-top-40-md\"><p>Somos un Startup creado por un multidisciplinario grupo de emprendedores colombianos, con un único objetivo: facilitarte la vida. Con Armatuvaca no tendrás que preocuparte, en tan sólo unos clics, podrás crear una Vaca en la que tus amigos podrán participar por Internet desde donde estén, sea su celular, tableta o computador, y podrás organizar todas tus Fiestas, Cumpleaños, Regalos en Común, Paseos, Partidos, Despedidas, Asados y mucho más. ¡No más excusas! Armatuvaca.com llega a Colombia par cambiar la forma en la cual gestionamos nuestros eventos en común! Hacer la Vaca nunca fue tan fácil.</p></div><div class=row><h1 class=\"text-center font-color-atv\">Nuestro Equipo</h1></div><div class=\"main-hiw-content hidden-xs-sm\"><div class=\"col-xs-12 col-sm-6 col-md-4 min-height-410\" ng-repeat=\"member in teamMembers track by member.id\"><div class=\"text-center main-hiw-description\"><img class=\"img-circle img-hiw\" src={{member.image}} alt=img-home><h4>{{member.name}}</h4><h5><i class=font-color-atv>{{member.position}}</i></h5><p class=text-justify>{{member.description}}</p></div></div></div><div class=\"about-us-slider visible-sm visible-xs position-relative\"><ul rn-carousel rn-carousel-controls rn-carousel-index=carouselIndex rn-carousel-buffered rn-carousel-duration=800 rn-carousel-easing=easeInOutSine><li ng-repeat=\"member in teamMembers track by member.id\"><div class=\"text-center about-us-description\"><img class=\"img-circle img-hiw\" src={{member.image}} alt=img-home><h4>{{member.name}}</h4><h5><i class=font-color-atv>{{member.position}}</i></h5><p>{{member.description}}</p></div></li></ul></div></div><!--Francia--><!--<div class=\"container\">--><!--<div class=\"row\">--><!--<h1 class=\"text-center font-color-atv\">En Francia</h1>--><!--</div>--><!--<div class=\"main-hiw-content hidden-xs-sm\">--><!--<div class=\"col-xm-12 col-sm-6 col-md-3\" ng-repeat=\"slide in slides_about_us_fr track by slide.id\">--><!--<div class=\"text-center main-hiw-description\">--><!--<img class=\"img-circle img-hiw\" src=\"{{slide.image}}\" alt=\"img-home\"/>--><!--<h4>{{slide.title}}</h4>--><!--<h5><i class=\"font-color-atv\">{{slide.subtitle}}</i></h5>--><!--<p class=\"text-justify\">--><!--{{slide.description}}--><!--</p>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"main-hit-slider visible-sm visible-xs position-relative\">--><!--<ul rn-carousel rn-carousel-controls rn-carousel-index=\"carouselIndex\" rn-carousel-buffered--><!--rn-carousel-duration=\"800\" rn-carousel-easing=\"easeInOutSine\">--><!--<li ng-repeat=\"slide in slides_about_us_fr track by slide.id\">--><!--<div class=\"text-center main-hiw-description\">--><!--<img class=\"img-circle img-hiw\" src=\"{{slide.image}}\" alt=\"img-home\"/>--><!--<h4>{{slide.title}}</h4>--><!--<h5><i class=\"font-color-atv\">{{slide.subtitle}}</i></h5>--><!--<p class=\"text-justify\">--><!--{{slide.description}}--><!--</p>--><!--</div>--><!--</li>--><!--</ul>--><!--</div>--><!--</div>--></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/account/account.html","<div><atv-navbar></atv-navbar></div><admin-nav-bar><div class=\"tabs-content background-color-white\"><div class=\"row visible-xs-sm\"><div class=\"padding-left-15 padding-right-15 text-center no-outline\" ng-init=\"menuTabsCollapse=true\" ng-click=\"menuTabsCollapse = !menuTabsCollapse\"><h4 class=menu-mobile-account><i class=fa ng-class=\"(menuTabsCollapse)?\'fa-caret-down\':\'fa-minus-circle\'\" aria-hidden=true></i> {{titleList[tabSelected]}}</h4></div><div class=\"padding-left-15 padding-right-15 div-menu-account\" uib-collapse=menuTabsCollapse><div ng-repeat=\"title in titleList track by $index\"><p class=\"margin-top-10 no-outline\" ng-click=onTabChanges($index)><i class=fa ng-class=\"($index!=tabSelected)?\'fa-plus-circle\':\'fa-minus-circle\'\" aria-hidden=true></i> {{title}}</p></div></div></div><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-center-tabs=true md-selected=tabSelected><md-tab label={{titleList[0]}} md-on-select=onTabChanges(0) class=hidden-xs-sm><md-content class=\"md-padding tab-1-account-height\"><form name=formAccountProfile ng-submit=updateMyProfile(formAccountProfile.$valid) novalidate><div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left-right-xs-sm\"><div class=col-md-6><div class=\"col-md-6 no-padding-left\"><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"formAccountProfile.first_name.$invalid && formAccountProfile.$submitted\"><label>Nombre</label><input id=account_profile_first_name required name=first_name md-maxlength=50 ng-model=accountUser.user.first_name placeholder=\"Ingresa tu nombre\"><div ng-messages=formAccountProfile.first_name.$error><div ng-message=required>Por favor, digita tu nombre.</div></div></md-input-container></div><div class=\"col-md-6 no-padding-left\"><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"formAccountProfile.last_name.$invalid && formAccountProfile.$submitted\"><label>Apellido</label><input id=account_profile_last_name required name=last_name md-maxlength=100 ng-model=accountUser.user.last_name placeholder=\"Ingresa tu apellido\"><div ng-messages=formAccountProfile.last_name.$error><div ng-message=required>Por favor, digita tu apellido.</div></div></md-input-container></div></div><div class=col-md-6><md-input-container class=md-block flex-gt-sm=\"\"><label>Correo</label><input id=account_email_email name=email maxlength=100 ng-model=accountUser.user.email type=email readonly disabled></md-input-container></div><div class=col-md-6><div class=\"col-md-6 no-padding-left no-padding-right-xs-sm\"><md-input-container class=md-block flex-gt-sm=100><label>Tipo de documento</label><md-select name=document_type ng-model=accountUser.document_type required><md-option ng-repeat=\"document in documentTypes\" ng-value=document.id>{{document.key_type_name}}</md-option></md-select><div ng-messages=formAccountProfile.document_type.$error multiple md-auto-hide=true><div ng-message=required>Por favor selecciona un tipo de documento</div></div></md-input-container></div><div class=\"col-md-6 top-20-sm-xs no-padding-left no-padding-right-xs-sm\"><md-input-container class=md-block md-is-error=\"formAccountProfile.document_number.$invalid && formAccountProfile.$submitted\" flex-gt-sm=100 ng-show=\"accountUser.document_type == 1 || accountUser.document_type == 2\"><label>N° de documento</label><input id=account_profile_document_number ng-model=accountUser.document_number name=document_number type=tel pattern=[0-9]{1,15} only-digits required placeholder=\"Ingresa tu número de documento\"><div ng-messages=formAccountProfile.document_number.$error multiple md-auto-hide=true><div ng-message=required>Tu número de documento es obligatorio</div><div ng-message=pattern>Tu número de documento debe contener entre 6 y 15 caracteres numéricos</div></div></md-input-container><md-input-container class=md-block md-is-error=\"formAccountProfile.document_full_number.$invalid && formAccountProfile.$submitted\" flex-gt-sm=100 ng-show=\"accountUser.document_type == 3 || accountUser.document_type == 4\"><label>N° de documento</label><input id=account_profile_document_full_number ng-model=accountUser.document_full_number ng-change=setDocumentNumber() name=document_full_number pattern=\"^(?=.*\\d).{1,15}\" only-alphanumeric ng-required=\"accountUser.document_type == 3 || accountUser.document_type == 4\" placeholder=\"Ingresa tu número de documento\"><div ng-messages=formAccountProfile.document_full_number.$error multiple md-auto-hide=true><div ng-message=required>Tu número de documento es obligatorio</div><div ng-message=pattern>Tu número de documento debe contener entre 6 y 15 caracteres alfanuméricos</div></div></md-input-container></div><!--                  <div ng-show=\"accountUser.document_type==2\" class=\"col-md-1 hidden-xs-sm\">--><!--                    <i class=\"fa fa-info-circle tooltip-document\" tooltip-placement=\"bottom\"--><!--                       uib-tooltip=\"Ingresa el número sin caracteres especiales\" aria-hidden=\"true\"></i>--><!--                  </div>--></div><div class=\"col-md-6 top-20-sm-xs\"><md-input-container class=md-block flex-gt-sm=\"\"><label>Número celular</label><input id=account_profile_cellphone ng-model=accountUser.cellphone name=cellphone type=tel pattern=[0-9]{10,12} digits-no-indicative required placeholder=3196316557><div ng-messages=formAccountProfile.cellphone.$error multiple md-auto-hide=true><div ng-message-exp=\"[\'required\']\">Debes digitar tu número celular</div><div ng-message-exp=\"[\'pattern\']\">El número celular debe contener entre 10 y 12 números y contener solo caracteres numericos</div></div></md-input-container></div><div class=\"col-md-6 top-negative-10\"><div layout-gt-xs=row><div flex-gt-xs><h5 ng-class=\"(accountUser.born_date)? \'font-color-blue\': \'font-color-gray\'\" class=\"form-label-atv margin-top-bottom-4\"><b>Fecha de nacimiento</b></h5><md-input-container class=\"margin-top-3 no-margin-bottom\"><md-datepicker ng-model=accountUser.born_date md-max-date=maxDate md-placeholder=DD/MM/AAAA name=born_date required></md-datepicker><div ng-messages=formAccountProfile.born_date.$error><div ng-message=valid>Fecha invalida</div><div ng-message=required>Por favor, selecciona tu fecha de nacimiento</div><div ng-message=maxdate>Debes ser mayor de edad</div></div></md-input-container></div></div></div><div class=col-md-6><md-input-container flex-gt-sm=\"\" class=col-md-11><label>Saldo disponible</label><input id=account_profile_value_available value=\"{{accountUser.value_available| currency:\'$\':\'0\'}}\" name=value_available type=tel placeholder=\"\" disabled></md-input-container><md-input-container flex-gt-sm=\"\" class=no-margin-top-sm-xs><i class=\"fa fa-info-circle tooltip-calculator\" tooltip-placement=bottom uib-tooltip=\"Esta es la suma del dinero total disponible en Armatuvaca\" aria-hidden=true></i></md-input-container></div><div class=col-md-12 ng-if=accountUser.is_premium><p class=\"font-size-18 text-center font-bold\"><i class=\"fa fa-star font-color-atv\" aria-hidden=true></i> ¡Eres usuario premium Armatuvaca!</p></div><div class=\"col-md-12 hidden-xs-sm\"><button id=account_profile_submit_lg class=\"btn btn-default pull-right button-action-inherit\" type=submit>Actualizar</button></div><div class=\"col-md-12 visible-xs-sm text-center\"><button id=account_profile_submit_sm class=\"btn btn-default button-action-inherit\" type=submit>Actualizar</button></div></div></form><div ng-show=\"!accountUser.document_is_valid ||\n          (!accountUser.has_document_pdf && (!accountUser.has_document_image_front || !accountUser.has_document_image_back))\"><div class=\"col-md-12 col-sm-12 col-xs-12 padding-left-right-30-md\"><h3 class=font-color-atv>Verificación de identidad</h3><p class=text-justify><b>ARMATUVACA.COM</b>, por temas legales, debe solicitar una justificación de identidad en el caso de que un Organizador decida usar el monto recolectado y este supere $500.000 (COP). En este caso, es necesario adjuntar por medio electrónico una copia del documento de identidad del Organizador de la Vaca, ya sea la Cédula de Ciudadanía para personas naturales o del RUT actualizado en caso de ser persona jurídica.</p></div><div class=col-md-12><div class=\"col-md-1 col-sm-1 col-xs-1 div-warning-kyc text-center\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i></div><div class=\"col-md-11 col-sm-12 col-xs-12\"><p class=text-justify>El nombre y número de documento en los documentos enviados deben coincidir con El nombre y número de documento del titular de la cuenta en Armatuvaca (y no con los del destinatario del dinero). Los documentos subidos a la página deben estar en formato pdf, jpg, jpeg o png.</p></div></div><div class=col-md-12><div class=\"col-md-1 col-sm-1 col-xs-1 div-warning-kyc text-center\"><i class=\"fa fa-id-card\" aria-hidden=true></i></div><div class=\"col-md-11 col-sm-12 col-xs-12\"><h4><b>DOCUMENTO DE IDENTIDAD / RUT</b><label class=\"margin-left-5 font-color-pink no-outline\" ng-click=showExample()><i class=\"fa fa-question-circle\" aria-hidden=true></i></label><label class=\"font-color-pink hidden-xs-sm no-outline\" ng-click=showExample()>Ver un ejemplo</label></h4><p><i>Tu documento de identidad vigente (por delante y por detrás) con las cuatro esquinas visibles, o RUT actualizado para personas jurídicas. Puedes subir la imagen frontal y trasera o un archivo pdf con las dos imágenes adjuntas.</i></p><div class=\"col-md-4 col-sm-12 col-xs-12 no-padding-left margin-top-20\"><p ng-click=showDocument(0) ng-show=accountUser.has_document_image_front><i class=\"fa fa-file-image-o\" aria-hidden=true></i> <u class=no-outline>Ver imagen frontal</u></p><button id=account_profile_document_front_image type=button name=button class=form-control ng-click=clickChangeDocumentImageFront()><i class=\"fa fa-cloud-upload font-color-blue\" aria-hidden=true></i> Subir imagen frontal</button> <input class=\"center-item text-center file-input-hidden\" file-model=accountUser.documentUserFrontFile type=file id=fileInputImageFront accept=image/*></div><div class=\"col-md-4 col-sm-12 col-xs-12 no-padding-left margin-top-20\"><p ng-click=showDocument(1) ng-show=accountUser.has_document_image_back><i class=\"fa fa-file-image-o\" aria-hidden=true></i> <u class=no-outline>Ver imagen trasera</u></p><button id=account_profile_document_back_image type=button name=button class=form-control ng-click=clickChangeDocumentImageBack()><i class=\"fa fa-cloud-upload font-color-blue\" aria-hidden=true></i> Subir imagen trasera</button> <input class=\"center-item text-center file-input-hidden\" file-model=accountUser.documentUserBackFile type=file id=fileInputImageBack accept=image/*></div><div class=\"col-md-4 col-sm-12 col-xs-12 no-padding-left margin-top-20\"><p ng-click=showDocument(2) ng-show=accountUser.has_document_pdf><i class=\"fa fa-file-pdf-o\" aria-hidden=true></i> <u class=no-outline>Ver pdf adjuntado</u></p><button id=account_profile_document_pdf type=button name=button class=form-control ng-click=clickChangeDocumentPDF()><i class=\"fa fa-cloud-upload font-color-pink\" aria-hidden=true></i> Subir pdf</button> <input class=\"center-item text-center file-input-hidden\" file-model=accountUser.documentUserPDFFile type=file id=fileInputPDF accept=application/pdf></div></div></div></div></md-content></md-tab><md-tab label={{titleList[1]}} md-on-select=onTabChanges(1)><md-content class=md-padding><div class=\"row padding-15\" ng-show=\"creditCards.length > 0\"><div class=\"col-md-8 col-md-offset-2\"><div class=\"col-md-6 no-padding-left-right\" ng-repeat=\"credit_card in creditCards track by $index\"><md-list-item class=\"contact-item selected list-contact\"><img ng-if=\"credit_card.franchise==1\" src=assets/images/payment-methods/visa.png class=md-avatar alt=visa-img> <img ng-if=\"credit_card.franchise==2 || credit_card.franchise==3\" src=assets/images/payment-methods/mastercard.png class=md-avatar alt=mastercard-img> <img ng-if=\"credit_card.franchise==4\" src=assets/images/payment-methods/diners.png class=md-avatar alt=diners-img><div><p class=font-size-12>{{credit_card.card_name}}</p><p class=\"no-margin-bottom font-size-12\">**** **** **** {{credit_card.last_numbers}}</p><span class=\"closebtn-cc no-outline\" ng-click=openDeleteCreditCardConfirmation(credit_card)>&times;</span></div></md-list-item></div></div></div><div class=\"row padding-15\" ng-show=\"creditCards.length == 0\"><h3 class=text-center>No tienes tarjetas registradas</h3></div></md-content></md-tab><md-tab label={{titleList[2]}} md-on-select=onTabChanges(2)><md-content class=md-padding><div class=row ng-show=\"userBankAccounts.length == 0\"><div class=\"margin-top-40-md margin-top-10 no-outline\"><h4 class=text-center>Aún no has registrado una cuenta bancaria.</h4></div></div><div class=\"row padding-15\" ng-show=\"userBankAccounts.length > 0\"><div class=col-md-12><div class=\"col-md-6 no-padding-left-right\" ng-repeat=\"b_account in userBankAccounts track by $index\"><md-list-item class=\"contact-item selected list-contact\"><img ng-src={{b_account.bank.logo}} class=md-avatar alt={{b_account.bank.name}}><div><h3>{{b_account.name}}</h3><p><span ng-if=\"b_account.bank_account_type === 0\">Ahorros</span> <span ng-if=\"b_account.bank_account_type === 1\">Corriente</span> {{b_account.bank_account_number}}</p><span class=\"closebtn no-outline\" ng-click=openDeleteBankAccountConfirmation(b_account)>&times;</span></div></md-list-item></div></div></div><div><new-bank-account-user></new-bank-account-user></div></md-content></md-tab><md-tab label={{titleList[3]}} md-on-select=onTabChanges(3)><md-content class=md-padding><div class=text-center ng-if=\"userInvoices.length == 0\"><h3>Todavía no tienes participaciones registradas</h3></div><div ng-show=\"userInvoices.length != 0\"><input class=\"form-control search-box margin-bottom-20\" placeholder=\"Busca entre tus participaciones\" type=text ng-model=searchInvoices><table class=table><thead><tr><th>Fecha</th><th class=text-center-sm-xs>Nombre de la Vaca</th><th>Comprobante</th></tr></thead><tbody><tr ng-repeat=\"invoice in userInvoices | filter:searchInvoices | orderBy:\'-creation_date\' track by $index\"><td>{{invoice.creation_date | date:\'mediumDate\'}}</td><td class=text-center-sm-xs>{{invoice.cow.name}}</td><td class=text-center-sm-xs><button type=button class=\"btn background-color-blue font-color-white hover-font-color-white active-font-color-white\" ng-click=downloadInvoiceList(invoice)>Descarga</button></td><td class=hidden-xs><a href=\"{{cowPublicURL + invoice.cow.cow_event_id}}\" class=font-color-white target=_blank><button type=button class=\"btn background-color-atv hover-font-color-white active-font-color-white\">Ver Vaca</button> </a></td></tr></tbody></table></div></md-content></md-tab><md-tab label={{titleList[4]}} md-on-select=onTabChanges(4)><md-content class=md-padding><div class=row><div class=\"col-md-6 col-md-offset-3\"><form name=addContactForm id=addContactForm ng-submit=addNewContact(addContactForm.$valid) novalidate><h3 class=\"text-center no-margin-top-sm-xs padding-bottom-15\">Agregar contacto</h3><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"addContactForm.first_name.$invalid && addContactForm.$submitted\"><label>Nombre</label><input id=account_contacs_name required type=text name=first_name md-maxlength=50 ng-model=newContact.name placeholder=\"Alejandro Magno\"><div ng-messages=addContactForm.first_name.$error><div ng-message=required>El nombre es obligatorio</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"addContactForm.email.$invalid && addContactForm.$submitted\"><label>Correo</label><input id=account_contacs_email required type=email name=email ng-model=newContact.email placeholder=micontacto@armatuvaca.com><div ng-messages=addContactForm.email.$error><div ng-message=required>El correo es obligatorio</div></div></md-input-container></div><div class=center-item><button id=account_contacs_submit class=\"btn btn-default button-action-small-pink margin-bottom-20\" type=submit>Agregar contacto</button></div></form></div></div><div class=row ng-show=\"userContacts.length == 0\"><div class=\"margin-top-40-md margin-top-10 no-outline\"><h4 class=text-center>Por el momento no tienes ningún contacto, tus contactos son las direcciones de correo que invitas en tus Vacas</h4></div></div><div class=\"row list-emails padding-15\" ng-show=\"userContacts.length > 0\"><div class=col-md-12><div class=\"text-center col-md-4 col-md-offset-4\"><input type=text name=email_text_search placeholder=\"Filtra por tu correos\" row=3 ng-model=email_text_search_userContacts class=form-control></div></div><div class=col-md-12><div class=\"col-md-4 no-padding-left-right\" ng-repeat=\"contact in userContacts | filter: {email : email_text_search_userContacts} | limitTo: 9 track by $index\"><md-list-item class=\"contact-item selected list-contact\"><img ng-src=assets/images/user/user-blue.svg class=md-avatar alt={{contact.name}}><div class=\"md-list-item-text compact\"><h3>{{contact.name}}</h3><p>{{contact.email}}</p><span class=\"closebtn no-outline\" ng-click=openContactConfirmation(contact)>&times;</span></div></md-list-item></div></div></div></md-content></md-tab></md-tabs></md-content></div></admin-nav-bar><div><atv-footer></atv-footer></div><script type=text/ng-template id=confirmationContactDeleteModal-1><div class=\"ngdialog-message text-center\">\n    <h3 class=\"\">¿Seguro que quieres borrar a\n      {{ngDialogData.contact.name}}\n      de tus contactos?</h3>\n    <a class=\"smGlobalBtn confirmContactBtn\"\n       ng-click=\"confirmationDeleteContact(ngDialogData.contact, ngDialogId)\"></a>\n    <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeSecond(ngDialogId)\"></a>\n  </div></script><script type=text/ng-template id=confirmationBankAccountDeleteModal-2><div class=\"ngdialog-message text-center\">\n    <h3 class=\"\">¿Seguro que quieres borrar la cuenta bancaria\n      {{ngDialogData.bankAccount.bank_account_number_last_digits}}\n      -\n      {{ngDialogData.bankAccount.bank.name}}?</h3>\n    <a class=\"smGlobalBtn confirmContactBtn\"\n       ng-click=\"confirmationDeleteBankAccount(ngDialogData.bankAccount, ngDialogId)\"></a>\n    <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeSecond(ngDialogId)\"></a>\n  </div></script><script type=text/ng-template id=confirmationCreditCardDeleteModal-3><div class=\"ngdialog-message text-center\">\n    <h3 class=\"\">¿Seguro que quieres borrar la tarjeta de crédito\n      {{ngDialogData.creditCard.card_name}}\n      -\n      **** **** **** {{ngDialogData.creditCard.last_numbers}}?</h3>\n    <a class=\"smGlobalBtn confirmContactBtn\"\n       ng-click=\"confirmationDeleteCreditCard(ngDialogData.creditCard, ngDialogId)\"></a>\n    <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeSecond(ngDialogId)\"></a>\n  </div></script><script type=text/ng-template id=dialog.document.example.tmpl.html><md-dialog aria-label=\"Ejemplo\">\n    <form ng-cloak>\n      <md-dialog-content>\n        <div class=\"md-dialog-content\">\n          <h2 class=\"text-center font-color-atv mayus\">\n            Documento de Identidad</h2>\n          <p class=\"text-center text-underline\">\n            <u>Recuerda :</u>\n          </p>\n          <p class=\"text-center\">\n            Tu documento de identidad debe estar en\n            <b>período de validez, por las dos caras y con los cuatro ángulos bien visibles</b>\n          </p>\n          <img class=\"img-example\" alt=\"ejemplo documento de identidad\"\n               src=\"assets/images/utils/cc-example.jpg\">\n        </div>\n      </md-dialog-content>\n      <md-dialog-actions layout=\"row\">\n        <md-button ng-click=\"cancel()\">\n          Cerrar\n        </md-button>\n      </md-dialog-actions>\n    </form>\n  </md-dialog></script><script type=text/ng-template id=dialog.document.tmpl.html><md-dialog aria-label=\"Ejemplo\">\n    <form ng-cloak>\n      <md-dialog-content>\n        <div class=\"md-dialog-content\">\n          <img class=\"img-example\" alt=\"ejemplo documento de identidad\" ng-if=\"documentFileShow==0\"\n               ng-src=\"{{accountUser.document_image_front}}\">\n          <img class=\"img-example\" alt=\"ejemplo documento de identidad\" ng-if=\"documentFileShow==1\"\n               ng-src=\"{{accountUser.document_image_back}}\">\n          <div id=\"pdf\" ng-if=\"documentFileShow==2\">\n            <object width=\"700\" height=\"500\" type=\"application/pdf\" data=\"{{accountUser.document_pdf}}\"\n                    id=\"pdf_content\">\n              <p>\n                Tu navegador web no tiene un soporte de un complemento de PDF. En su lugar, puedes\n                <a target=\"_blank\" href=\"{{accountUser.document_pdf}}\">\n                  hacer clic aquí para descargar el archivo.\n                </a>\n              </p>\n\n            </object>\n          </div>\n        </div>\n      </md-dialog-content>\n      <md-dialog-actions layout=\"row\">\n        <md-button ng-click=\"cancel()\">\n          Cerrar\n        </md-button>\n      </md-dialog-actions>\n    </form>\n  </md-dialog></script><script type=text/ng-template id=confirmationDocumentValidated><div class=\"ngdialog-message text-center\">\n    <h3 ng-show=\"ngDialogData.type === \'ImageFront\'\">\n      ¿Estás seguro que la imagen que adjuntaste corresponde a la parte frontal de un documento de identidad\n      válido?\n    </h3>\n    <h3 ng-show=\"ngDialogData.type === \'ImageBack\'\">\n      ¿Estás seguro que la imagen que adjuntaste corresponde a la parte trasera de un documento de identidad\n      válido?\n    </h3>\n    <h3 ng-show=\"ngDialogData.type === \'PDF\'\">\n      ¿Estás seguro que el pdf que adjuntaste corresponde a un documento de identidad válido?\n    </h3>\n    <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeDocumentConfirmation(ngDialogId)\"></a>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"acceptDocumentValidation(ngDialogData)\"></a>\n  </div></script>");
$templateCache.put("app/views/cashDashboard/cashDashboard.html","<div><atv-navbar></atv-navbar></div><!--<div class=\"container-fluid text-center\">--><!--<div class=\"row page-top-title page-title\">--><!--<h1 class=\"font-color-atv margin-top-40-md\">--><!--<b>Mis Vacas</b>--><!--</h1>--><!--<p class=\"\">--><!--Mira todas las Vacas que has creado y a las que te han invitado--><!--</p>--><!--</div>--><!--</div>--><admin-nav-bar><div class=cows-stats-user><div class=\"cows-stats-user-cash margin-top-40\"><h3>Dinero total en Vacas ($):</h3><h4>{{stats.money_left | currency:\"$\":\'0\'}} COP</h4><h5 ui-sref=cows-user><span class=font-color-atv>Vacas activas: </span><b>{{stats.num_cows}}</b></h5></div><!-- <div class=\"atv-col-container\">\n      <div class=\"atv-col atv-col-sm-4\">\n        <div class=\"cows-stats-user-item\" ui-sref=\"cows-user\" style=\"cursor: pointer;\">\n          <img src=\"assets/images/logo-box.png\" alt=\"\">\n          <div>\n            <small>Vacas font-color-atvCreadas</small>\n            <br>\n            <h4>{{stats.num_cows}}</h4>\n          </div>\n        </div>\n      </div>\n      <div class=\"atv-col atv-col-sm-4\">\n        <div class=\"cows-stats-user-item\">\n          <img src=\"assets/images/vs/tc.png\" alt=\"\">\n          <div>\n            <small>Pagos Recibidos</small>\n            <br>\n            <h4>{{stats.num_payments_received}}</h4>\n          </div>\n        </div>\n      </div>\n      <div class=\"atv-col atv-col-sm-4\">\n        <div class=\"cows-stats-user-item\">\n          <img src=\"assets/images/vs/costo.png\" alt=\"\">\n          <div>\n            <small>Historico Recibido ($)</small>\n            <br>\n            <h4>{{stats.total_value_cows | currency:\"$\":\'0\'}} COP</h4>\n          </div>\n        </div>\n      </div>\n    </div> --></div><md-card class=cash-dashboard-actions><md-card-content><div><h2 style=\"font-size: 18px; font-weight: 600\">¿Qué quieres hacer?</h2><hr><ul><li ng-click=showCowCashoutDialog()><div class=cash-dashboard-actions-icon><i class=atv-admin-atm style=\"color: #03E09D\"></i></div><md-tooltip>Elige la Vaca de la cual quieres retirar el dinero.</md-tooltip><p class=cash-dashboard-actions-name>Retirar de Vaca</p></li><li ui-sref=cows-user><div class=cash-dashboard-actions-icon><i class=\"fa fa-list-ul\" aria-hidden=true style=\"color: #512DA8\"></i></div><md-tooltip>Revisa, administra e interactúa con tus Vacas.</md-tooltip><p class=cash-dashboard-actions-name>Ver mis Vacas</p></li><li ui-sref=cow-create><div class=cash-dashboard-actions-icon><i class=icon-atv-logo-blank-square style=\"color: #0db9f0\"></i></div><md-tooltip>Simplifícate la vida y Armatuvaca para lo que necesites.</md-tooltip><p class=cash-dashboard-actions-name>Armar Vaca</p></li><li ui-sref=send-money-cow><div class=cash-dashboard-actions-icon><i class=\"fa fa-money\" style=\"color: #ff6666\"></i></div><md-tooltip>Solución ideal para enviarle dinero a quien quieras por medio de tarjeta de crédito o PSE.</md-tooltip><p class=cash-dashboard-actions-name>Enviar Dinero</p></li><li ng-click=showWalletCollectFriendCowDialog()><div class=cash-dashboard-actions-icon><i class=atv-admin-handhold style=\"color: #AE38FE\"></i></div><md-tooltip>Elige el medio por el cual quieres que te paguen y cóbrale a tus amigos o familiares.</md-tooltip><p class=cash-dashboard-actions-name>Cobrar Dinero</p></li><li ui-sref=public-cow><div class=cash-dashboard-actions-icon><i class=atv-admin-donate style=\"color: #c835ff\"></i></div><md-tooltip>Ayuda a los que más lo necesitan aportando a alguna causa social en nuestra solución de Crowdfunding Socal Vacanes.</md-tooltip><p class=cash-dashboard-actions-name>Donar</p></li></ul></div></md-card-content></md-card><md-card class=cash-dashboard-ads><md-card-content><ui-carousel slides=atv_brands_ads slides-to-show=1 slides-to-scroll=1 initial-slide=1 autoplay autoplay-speed=4000 dots=false><carousel-item><div class=\"banner-wenjoy atv-col-container\" style=\"background-image: url({{item.image}})\"><div class=\"atv-col atv-col-md-6 banner-wenjoy-text\"><p>{{item.title}}</p><a class=\"btn btn-default button-action\" href={{item.brand_page_route}} target=_blank>Conoce Más...</a></div><!-- <div class=\"atv-col atv-col-md-6 banner-wenjoy-mobile\">\n              <img class=\"\" src=\"{{item.second_image}}\" alt=\"movil\">\n            </div> --></div></carousel-item><carousel-prev><button class=\"home-media-links-carousel-button prev-btn\"><i class=\"fa fa-chevron-left\" aria-hidden=true></i></button></carousel-prev><carousel-next><button class=\"home-media-links-carousel-button next-btn\"><i class=\"fa fa-chevron-right\" aria-hidden=true></i></button></carousel-next></ui-carousel></md-card-content></md-card></admin-nav-bar><div><atv-footer></atv-footer></div><!-- Templates --><script type=text/ng-template id=notifyAlertDialog><div class=\"ngdialog-message text-center\">\n    <div ng-bind-html=\"notifyAlert[0].text_area_value\" class=\"padding-bottom-15\"></div>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"acceptNotifyAlert(ngDialogData)\"></a>\n  </div></script><script type=text/ng-template id=noDocumentAlert><div class=\"ngdialog-message text-center\">\n    <h3>¡Hola!</h3>\n    <h4>Tan sólo un paso más. Para continuar usando Armatuvaca debes terminar de registrar tus datos</h4>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"acceptNoDocumentAlert(ngDialogData)\"></a>\n  </div></script>");
$templateCache.put("app/views/cashDashboard/createWalletCollectFriendCowDialog.html","<div class=createWalletCollectFriendCowDialog><div class=\"createWalletCollectFriendCowDialog-icon text-center\"><i class=atv-admin-handhold></i></div><br><div style=\"margin: 10px 0\"><div class=createWalletCollectFriendCowDialog-label><b>¿A quién le vas a cobrar?:</b><br></div><md-input-container md-no-float><input type=text ng-model=create_form.name placeholder=\"Ingresa aquí el nombre de la persona\" md-maxlength=50></md-input-container><br><div class=createWalletCollectFriendCowDialog-label><b>¿Cuánto vas a cobrar?:</b><br></div><md-input-container md-no-float><input ng-model=create_form.amount placeholder=$ ui-money-mask=0 type=tel><p class=\"validation-messages text-left\" style=\"color: dimgray; margin: 10px 0\">{{create_form.plan === \'free\' ? \'Mínimo $1.000 COP Máximo $1´000.000 COP\': \'Mínimo $1.000 COP. Sin tope máximo\'}}</p></md-input-container><div class=createWalletCollectFriendCowDialog-label><b>¿Cómo te van a pagar?:</b><br></div><md-input-container><md-radio-group ng-model=create_form.plan><md-radio-button value=free class=md-primary><div class=new-cow-create-form-select-option><img src=assets/images/payment-methods/pse.png alt=\"\"> <span>PSE</span></div></md-radio-button><md-radio-button value=pro class=md-primary><div class=new-cow-create-form-select-option><img src=assets/images/payment-methods/mastercard.png alt=\"\"> <img src=assets/images/payment-methods/visa.png alt=\"\"> <img src=assets/images/payment-methods/diners.png alt=\"\"><br><span>Tarjeta De Crédito</span></div></md-radio-button></md-radio-group></md-input-container><div style=\"max-width: 300px; margin: 0 auto\"><small ng-if=\"create_form.plan === \'free\'\">Puedes recibir hasta $1\'000.000 COP, solo por PSE, no tiene costo. </small><small ng-if=\"create_form.plan === \'pro\'\">Sin topes máximos, recibe pagos con tarjeta de crédito y PSE. Se cobrará el {{highValueCowFee}}% + IVA del monto recolectado</small></div><div class=text-center><button id=cow_create_btn_submit class=\"button-action btn-sm\" style=\"font-size: 15px\" ng-if=\"(create_form.name && create_form.amount >= 1000) && ((create_form.plan === \'free\' && create_form.amount <=1000000) || (create_form.plan === \'pro\'))\" ng-click=createWalletCow()>Continuar</button></div></div></div>");
$templateCache.put("app/views/cashDashboard/selectCowCashoutDialog.html","<div class=selectCowCashoutDialog><div class=\"selectCowCashoutDialog-icon text-center\"><i class=atv-admin-atm></i></div><h4>Selecciona la Vaca de donde quieres sacar el dinero:</h4><md-input-container><label>Selecciona una Vaca:</label><md-select ng-model=cow_event_id><md-option ng-repeat=\"cow in availableCowsCash\" ng-value=cow.cow_event_id style=\"height: 60px\"><div class=selectCowCashoutDialog-option><span><b>{{cow.name}}</b> </span><span><small>Disponible</small>: {{cow.total_value_to_date_left | currency:\"$\":\'0\'}} COP</span></div></md-option></md-select></md-input-container><div class=text-center><button id=cow_create_btn_submit class=\"button-action btn-sm\" style=\"font-size: 15px\" ng-if=cow_event_id ng-click=goToCowGetMoney(cow_event_id)>Continuar</button></div></div>");
$templateCache.put("app/views/company/company.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid no-padding-left-right overflow-hidden\"><div class=main-top-content-marketplace ng-style=getBackgroudCssStyle(company.main_image)></div></div><div class=\"container-fluid background-color-white\"><div class=container><div ng-repeat=\"companyProduct in companyProducts track by $index\"><div class=row><h4>{{companyProduct.category.name}}</h4></div><div class=row><div class=\"col-md-4 padding-top-bottom-20\" ng-repeat=\"product in companyProduct.products track by $index\"><a href=\"\" ng-click=goToMpProduct(product)><div class=marketplace-list-img ng-style=getBackgroudCssStyle(product.main_img)></div></a><h4 class=text-center>{{product.name}}</h4><p class=ellipsis>{{product.short_description}}</p><button class=\"btn btn-default button-action-white-small no-margin-top pull-right\" ng-click=goToMpProduct(product)>Ver más</button></div></div></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/confirmationEmail/confirmationEmail.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md font-size-30-sm-xs\"><b>Validación de correo electrónico</b></h1></div></div><div class=\"container-fluid background-color-white no-padding-left-right\"><div class=\"container margin-top-40\"><div class=\"row margin-bottom-20\"><div class=col-md-2><div class=\"text-center main-hiw-description\"><img class=\"img-circle img-hiw\" src=assets/images/logo-box.png alt=img-home></div></div><div class=\"col-md-10 margin-top-10\"><p>¡Hola! Estamos validando tu correo electrónico.<br><br>Por favor espera...<br></p></div></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/cow/cow.html","<div><atv-navbar lang=true></atv-navbar></div><div class=\"container background-color-white upper-cowspot-div\"><div class=atv-cow-top-container><div class=atv-cow-title-container><h1><b class=break-word>{{cow_event.name}}</b></h1><div class=cw-public-cow-separator></div><h4><b>{{getTraductor(\'cow.organized_by\')}}: {{cow_event.made_by}}</b></h4><!-- <div class=\"atv-cow-col-container-title-share\">\n        <button ng-click=\"goToInvite()\" style=\"font-weight: bold; border-radius: 5px; margin: 0;\"><i\n            class=\"fa fa-share-alt\"></i>&nbsp;{{getTraductor(\'cow.to_shere\')}}</button>\n      </div> --></div><div class=atv-cow-col-container><div class=margin-bottom-20><div class=\"container-fluid no-padding-left-right overflow-hidden\"><div class=closed-cow-bar ng-show=\"cowclosed && !cowclosed_moneyrequest\"><p class=alert-2>{{getTraductor(\'cow.closed\')}}</p></div><div ng-if=\"cow_event.cow_event_photos.length === 0\" class=main-top-content ng-style=\"getBackgroudCssStyleCow(cow_event.main_img, cow_event.closed)\"></div><!--Cuando tiene varias fotos--><div class=atv-col-container ng-if=\"cow_event.cow_event_photos.length > 0\"><div class=\"atv-col atv-col-md-12 atv__cow__carousel\"><ui-carousel slides=cow_event.cow_event_photos slides-to-show=1 slides-to-scroll=1 initial-slide=1 autoplay autoplay-speed=2000 dots=true><carousel-item><div class=\"main-top-content atv__cow__img\" style=\"background-image: url(\'{{item.photo}}\')\"></div></carousel-item><carousel-prev><button class=\"atv__cow__carousel__btn atv__cow__carousel__btn--prev\"><i class=\"fa fa-chevron-circle-left\" aria-hidden=true></i></button></carousel-prev><carousel-next><button class=\"atv__cow__carousel__btn atv__cow__carousel__btn--next\"><i class=\"fa fa-chevron-circle-right\" aria-hidden=true></i></button></carousel-next></ui-carousel></div></div><!--fin de cuando tiene varias fotos--><div class=pay_limit_day_div ng-if=\"cow_event.pay_limit_date && !cow_event.closed\"><countdown-timer deadline=cow_event.pay_limit_date></countdown-timer></div></div></div><div><div class=width-100><!-- <div class=\"atv-cow-col-container-title\">\n            <div class=\"atv-cow-col-container-title-text\">\n              <h2>\n                <b class=\"break-word\">{{cow_event.name}}</b>\n              </h2>\n              <h4>\n                <b>{{getTraductor(\'cow.organized_by\')}}:\n                  {{cow_event.made_by}}</b>\n              </h4>\n            </div>\n            <div class=\"atv-cow-col-container-title-share\">\n              <button ng-click=\"goToInvite()\"><i\n                  class=\"fa fa-share-alt\"></i>&nbsp;{{getTraductor(\'cow.to_shere\')}}</button>\n            </div>\n          </div> --><div class=atv-cow-col-container-progress><div class=atv-cow-col-container-progress-collected><p ng-if=cow_event.hide_total_amount style=\"font-size: 12px\">{{getTraductor(\'cow.only_to_organizer\')}}</p><p ng-if=!cow_event.hide_total_amount>{{getTraductor(\'cow.collected_amount\')}}:<br>{{cow_event.total_value + cowCashinCommission | currency:\"$\":\'0\'}} COP</p><p ng-click=modalParticipants()>{{cow_event.participations}} {{cow_event.participations === 1 ? getTraductor(\'cow.participation\'): getTraductor(\'cow.participations\')}}</p></div><div ng-if=\"cow_event.cow_goal > 0\"><participation-bar current-value=cow_event.total_value goal=cow_event.cow_goal></participation-bar></div><div class=atv-cow-col-container-progress-avaliable ng-if=\"cow_event.cow_goal > 0\"><p>&nbsp;</p><p><i class=\"fa fa-flag-checkered\" aria-hidden=true></i>&nbsp; {{getTraductor(\'cow.goal\')}} {{cow_event.cow_goal | currency:\"$\":\'0\'}} COP</p></div></div><div class=atv-cow-col-container-participate><button class=\"button-action width-100\" ng-click=goToCowParticipate(cow_event.cow_event_id) ng-if=!cowclosed><span ng-if=\"cow_event.business_type === 3 && !cow_event.is_public\"><i class=\"fa fa-heart\" aria-hidden=true></i>&nbsp;{{getTraductor(\'cow.donate\')}} </span><span ng-if=\"cow_event.business_type === 0 && !cow_event.is_public\"><i class=\"fa fa-usd\" aria-hidden=true></i>&nbsp;{{getTraductor(\'cow.participate\')}}</span> <span ng-if=\"cow_event.business_type === 0 && cow_event.is_public\"><i class=\"fa fa-heart\" aria-hidden=true></i>&nbsp;{{getTraductor(\'vacanes.back_up\')}}</span></button></div><div ng-show=!cow_event.is_promo class=margin-top-20-md><cow-share cow=cow_event is-admin=false></cow-share></div></div></div></div></div><div class=col-md-12><div class=\"row atv-cow-col-container-title-text\"><hr><!-- <h4 class=\"text-center font-color-gray\"\n        ng-show=\"cow_event.event_date && cow_event.location_name && cow_event.location_name != \'null\'\">\n        <b class=>{{getTraductor(\'cow.date\')}}:\n          {{eventDateString}}</b>\n          <br>\n        <b>{{getTraductor(\'cow.place\')}}:\n          {{cow_event.location_name}}</b>\n      </h4> --><h4 class=\"text-center font-color-gray\" ng-show=cow_event.event_date><b><i class=\"fa fa-calendar\"></i> {{getTraductor(\'cow.date\')}}: {{eventDateString}}</b></h4><h4 class=\"text-center font-color-gray\" ng-show=\"cow_event.location_name && cow_event.location_name != \'null\'\"><b><i class=\"fa fa-map-marker\"></i> {{getTraductor(\'cow.place\')}}: {{cow_event.location_name}}</b></h4></div><div class=\"row margin-bottom-20\"><div class=atv-cow-col-container-title-text><h4><b>{{getTraductor(\'cow.description_cow\')}}</b></h4></div><div class=\"text-left overflow-auto\" ng-class=\"{\'overflow\':isExpand && !getTraductor(\'cow.see_more\') && length_cow_event_description > 1000,\'overflow-en\':isExpand && getTraductor(\'cow.see_more\') && length_cow_event_description > 1000}\" ta-bind ng-model=cow_event.description ng-if=cow_event.description ng-click=\"isExpand = !isExpand;\"></div><div class=\"text-left col-md-6 col-md-offset-3 margin-bottom-20 overflow-auto\" ng-if=!cow_event.description ng-bind-html=cow_event.cow_type.description_default></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 no-padding-left-right margin-bottom-20\" ng-if=cow_event.show_location_point><ui-gmap-google-map center=map.center zoom=map.zoom><!--MARKER--><ui-gmap-marker coords=marker.coords options=marker.options events=marker.events idkey=marker.id></ui-gmap-marker></ui-gmap-google-map></div></div><div><atv-footer></atv-footer></div><script type=text/ng-template id=participantsModal-1><div class=\"ngdialog-message\">\n    <div class=\"text-center\" ng-if=\"ngDialogData.participants.length == 0\">\n      <h3>{{getTraductor(\'cow.no_participation\')}}</h3>\n      <p>\n        {{getTraductor(\'cow.invite_participate\')}}\n      </p>\n    </div>\n    <div class=\"text-center\"\n         ng-if=\"ngDialogData.participants.length > 0 &&\n         (!ngDialogData.cow.hide_participants_identity || (!ngDialogData.cow.hide_participant_amount && !ngDialogData.cow.hide_total_amount))\">\n      <div id=\"participants_list\">\n        <h3>{{getTraductor(\'cow.participants\')}}</h3>\n        <div ng-if=\"!ngDialogData.cow.has_options\">\n          <p ng-repeat=\"participant in ngDialogData.participants track by $index\">\n            {{ ($index + 1) + \". \" + participant.first_name + \' \' + participant.last_name + \' - \' +\n            participant.total_amount}}\n          </p>\n        </div>\n        <div ng-if=\"ngDialogData.cow.has_options\">\n          <div ng-repeat=\"option in ngDialogData.participants track by $index\">\n            <h4>{{option.option + \' - \' + option.option_total}}</h4>\n            <p ng-repeat=\"participant in option.participants track by $index\">\n              {{ ($index + 1) + \". \" + participant.first_name + \' \' + participant.last_name + \' - \' +\n              participant.total_amount}}\n            </p>\n            <br>\n          </div>\n        </div>\n      </div>\n      <button type=\"button\" name=\"button\" class=\"form-control\" ngclipboard data-clipboard-target=\"#participants_list\">\n        <i class=\"fa fa-clone\" aria-hidden=\"true\"></i>\n        {{getTraductor(\'cow.copy_list\')}}\n      </button>\n    </div>\n    <div class=\"text-center\"\n         ng-if=\"ngDialogData.participants.length > 0 && ngDialogData.cow.hide_participants_identity &&\n         (ngDialogData.cow.hide_participant_amount || ngDialogData.cow.hide_total_amount)\">\n      <h4>{{getTraductor(\'cow.hidden_information\')}}</h4>\n    </div>\n  </div></script>");
$templateCache.put("app/views/cowAdmin/cowAdmin.html","<div><atv-navbar lang=true></atv-navbar></div><div class=\"container background-color-white upper-cowspot-div\" ng-show=adminUser><div class=atv-cow-top-container><div class=atv-cow-title-container><h1><b class=break-word>{{cow_event.name}}</b></h1><div class=cw-public-cow-separator></div><h4><b>{{getTraductor(\'cow.organized_by\')}}: {{cow_event.made_by}}</b></h4><!-- <div class=\"atv-cow-col-container-title-share\">\n        <button ng-click=\"goToInvite()\" style=\"font-weight: bold; border-radius: 5px; margin: 0;\"><i\n            class=\"fa fa-share-alt\"></i>&nbsp;{{getTraductor(\'cow.to_shere\')}}</button>\n      </div> --></div><div class=atv-cow-col-container><div class=margin-bottom-20><div class=\"container-fluid no-padding-left-right overflow-hidden\"><div class=closed-cow-bar ng-show=\"cowclosed && !cowclosed_moneyrequest\"><p class=alert-2>{{getTraductor(\'cow.closed\')}}</p></div><div class=closed-cow-bar ng-show=cowclosed_moneyrequest><p class=\"alert-4 font-size-12-xs\">{{getTraductor(\'cow.info_closed\')}}<br>{{getTraductor(\'cow.collected_amount\')}}: {{cow_event.total_value_cash_out | currency:\"$\":\'0\'}} COP</p></div><div class=main-top-content ng-style=\"getBackgroudCssStyleCow(cow_event.main_img, cow_event.closed)\" ng-if=\"showCowMainImage && cow_event.cow_event_photos.length === 0\"><div class=\"col-md-4 col-sm-6 col-xs-6 no-padding-left-xs-sm margin-top-20 changeImgAdmin\" ng-show=\"!cow_event.is_promo && !cow_event.is_public && cowIsPlanPro\"><button type=button name=button class=\"form-control font-size-13-sm-xs no-padding\" ng-click=showMainImageEdit() ng-show=\"!cowclosed && !cow_event.marketplace\"><img src=assets/images/utils/icon_image.png alt=icon_image> {{getTraductor(\'cow.change_image\')}}</button></div></div><!--Div del cow event photos--><div class=atv-col-container ng-if=\"showCowMainImage && cow_event.cow_event_photos.length > 0\"><div class=\"atv-col atv-col-md-12 atv__cow__carousel\"><ui-carousel slides=cow_event.cow_event_photos slides-to-show=1 slides-to-scroll=1 initial-slide=1 autoplay autoplay-speed=2000 dots=true><carousel-item><div class=\"main-top-content atv__cow__img\" style=\"background-image: url(\'{{item.photo}}\')\"></div></carousel-item><carousel-prev><button class=\"atv__cow__carousel__btn atv__cow__carousel__btn--prev\"><i class=\"fa fa-chevron-circle-left\" aria-hidden=true></i></button></carousel-prev><carousel-next><button class=\"atv__cow__carousel__btn atv__cow__carousel__btn--next\"><i class=\"fa fa-chevron-circle-right\" aria-hidden=true></i></button></carousel-next></ui-carousel></div></div><!--Fin del div cow event photos--><div class=pay_limit_day_div ng-if=\"cow_event.pay_limit_date && !cow_event.closed\"><countdown-timer deadline=cow_event.pay_limit_date></countdown-timer></div></div><div class=container-fluid ng-show=showCowMainImageEdit><div class=\"crop-area height-300-sm-xs\"><ui-cropper class=background-color-white image=main_img_raw area-type=rectangle aspect-ratio=1.3 result-image-size=\"{w: 1980,h: 550}\" result-image-format=image/jpeg result-image=main_img result-blob=blob_main_img url-blob=url_img></ui-cropper></div><div class=\"text-center col-md-12 col-sm-12 col-xs-12 no-padding\"><input class=\"center-item text-center opacity-0 no-display\" file-model=main_img_raw_file type=file id=fileInput accept=\"image/x-png, image/jpeg\"><div class=\"col-md-4 col-sm-6 col-xs-6 padding-right-5-xs-sm no-padding-left-xs-sm margin-top-20\"><button type=button name=button class=\"form-control no-padding\" ng-click=closeCowImageEdit()><i class=\"fa fa-arrow-circle-o-left font-color-pink\" aria-hidden=true></i> {{getTraductor(\'cow.return\')}}</button></div><div class=\"col-md-4 col-sm-6 col-xs-6 padding-left-5-xs-sm no-padding-right-xs-sm margin-top-20\"><button type=button name=button class=\"form-control no-padding\" ng-click=clickChangeImageHeader()><i class=\"fa fa-cloud-upload font-color-blue\" aria-hidden=true></i> {{getTraductor(\'cow.upload_img\')}}</button></div><div class=\"col-md-4 col-sm-6 col-xs-6 col-xs-offset-3 col-sm-offset-3 col-md-offset-0 no-padding-left-xs-sm margin-top-20\"><button type=button name=button class=\"form-control no-padding\" ng-click=saveCowMainImage()><i class=\"fa fa-floppy-o font-color-atv\" aria-hidden=true></i> {{getTraductor(\'cow.save\')}}</button></div></div></div></div><div><div class=width-100><div class=atv-cow-col-container-progress><div class=atv-cow-col-container-progress-collected><p>{{getTraductor(\'cow.you_available\')}}:<br>{{(cow_event.total_value_to_date_left == 0) ? cow_event.total_value_to_date_left : (cow_event.total_value_to_date_left - ivaAtvTax) | currency:\"$\":\'0\'}} COP</p><p ng-click=modalParticipants()>{{cow_event.participations}} {{cow_event.participations === 1 ? getTraductor(\'cow.participation\') : getTraductor(\'cow.participations\')}}</p></div><div ng-if=\"cow_event.cow_goal > 0\"><participation-bar current-value=cow_event.total_value goal=cow_event.cow_goal></participation-bar></div><div class=atv-cow-col-container-progress-avaliable><p class=font-color-gray>{{getTraductor(\'cow.you_received\')}}: {{cow_event.total_value + cowCashinCommission | currency:\"$\":\'0\'}} COP<br>{{getTraductor(\'cow.service_cost\')}}: -{{cowCashinCommission + cow_event.atv_tax_total | currency:\"$\":\'0\'}}<br>{{getTraductor(\'cow.you_withdrawn\')}}: -{{cow_event.total_value_cash_out | currency:\"$\":\'0\'}}</p><p ng-if=\"cow_event.cow_goal > 0\"><i class=\"fa fa-flag-checkered\" aria-hidden=true></i>&nbsp; {{getTraductor(\'cow.goal\')}} {{cow_event.cow_goal | currency:\"$\":\'0\'}} COP</p></div></div><!-- <div class=\"atv-cow-col-container-title\">\n            <div class=\"atv-cow-col-container-title-text\">\n              <h2>\n                <b class=\"break-word\">{{cow_event.name}}</b>\n              </h2>\n              <h4>\n                <b>{{getTraductor(\'cow.organized_by\')}}:\n                  {{cow_event.made_by}}</b>\n              </h4>\n            </div>\n            <div class=\"atv-cow-col-container-title-share\">\n              <button ng-click=\"goToInvite()\"><i\n                  class=\"fa fa-share-alt\"></i>&nbsp;{{getTraductor(\'cow.to_shere\')}}</button>\n            </div>\n          </div> --><div class=atv-cow-col-container-actions><div><h2>{{getTraductor(\'cow.you_want_to_do\')}}</h2><ul><li ng-click=goToCowGetMoney(cow_event.cow_event_id)><div class=atv-cow-col-container-actions-icon style=\"color: #03E09D\"><i class=atv-admin-atm></i></div><p class=atv-cow-col-container-actions-name>{{getTraductor(\'cow.take_out_money\')}}</p></li><!-- <li ng-click=\"goToInvite()\">\n                <div class=\"atv-cow-col-container-actions-icon\">\n                  <i class=\"fa fa-share-alt\"></i>\n                </div>\n                <p class=\"atv-cow-col-container-actions-name\">Invitar</p>\n              </li> --><li ng-click=openCloseCowEventModal() ng-if=!cow_event.closed><div class=atv-cow-col-container-actions-icon style=\"color: #ff6666\"><i class=\"fa fa-times\"></i></div><p class=atv-cow-col-container-actions-name>{{getTraductor(\'cow.close_cow\')}}</p></li><li ng-click=openReopenCowEventModal() ng-if=cow_event.closed><div class=atv-cow-col-container-actions-icon style=\"color: #c835ff\"><i class=\"fa fa-sign-in\" aria-hidden=true style=\"font-weight: bold\"></i></div><p class=atv-cow-col-container-actions-name>{{getTraductor(\'cow.reopen_cow\')}}</p></li><li ng-click=upgradeCow(cow_event.cow_event_id) ng-if=!cowIsPlanPro><div class=atv-cow-col-container-actions-icon style=\"color: #c835ff\"><i class=\"fa fa-star-o\" aria-hidden=true style=\"font-weight: bold\"></i></div><p class=atv-cow-col-container-actions-name>{{getTraductor(\'cow.upgrade_cow\')}}</p></li><li ng-click=downloadParticipantsList()><div class=atv-cow-col-container-actions-icon ng-class=\"{\'atv-cow-col-container-actions-icon-disabled\': !cowIsPlanPro}\" style=\"color: #512DA8\"><i class=\"fa fa-file-excel-o\"></i></div><p class=atv-cow-col-container-actions-name>{{getTraductor(\'cow.see_report\')}}</p></li><li ng-click=goToEdit()><div class=atv-cow-col-container-actions-icon ng-class=\"{\'atv-cow-col-container-actions-icon-disabled\': !cowIsPlanPro}\" style=\"color: #0db9f0\"><i class=\"fa fa-pencil-square-o\"></i></div><p class=atv-cow-col-container-actions-name>{{getTraductor(\'cow.edit_cow\')}}</p></li></ul></div></div><div class=atv-cow-col-container-participate><button class=\"button-action width-100\" ng-click=goToCowParticipate(cow_event.cow_event_id) ng-if=!cowclosed ng-switch=cow_event.business_type><span ng-switch-when=3><i class=\"fa fa-heart\" aria-hidden=true></i>&nbsp;{{getTraductor(\'cow.donate\')}} </span><span ng-switch-default><i class=\"fa fa-usd\" aria-hidden=true></i>&nbsp;{{getTraductor(\'cow.participate\')}}</span></button></div><div ng-show=!cow_event.is_promo><cow-share cow=cow_event is-admin=adminUser></cow-share></div></div></div></div></div><div class=col-md-12><div class=\"row atv-cow-col-container-title-text\"><hr><!-- <h4 class=\"text-center font-color-gray\"\n        ng-show=\"cow_event.event_date && cow_event.location_name && cow_event.location_name != \'null\'\">\n        <b class=>{{getTraductor(\'cow.date\')}}:\n          {{eventDateString}}</b>\n          <br>\n        <b>{{getTraductor(\'cow.place\')}}:\n          {{cow_event.location_name}}</b>\n      </h4> --><h4 class=\"text-center font-color-gray\" ng-show=cow_event.event_date><b><i class=\"fa fa-calendar\"></i> {{getTraductor(\'cow.date\')}}: {{eventDateString}}</b></h4><h4 class=\"text-center font-color-gray\" ng-show=\"cow_event.location_name && cow_event.location_name != \'null\'\"><b><i class=\"fa fa-map-marker\"></i> {{getTraductor(\'cow.place\')}}: {{cow_event.location_name}}</b></h4></div><div class=\"row margin-bottom-20\"><div class=atv-cow-col-container-title-text><h4><b>{{getTraductor(\'cow.description_cow\')}}</b></h4></div><div class=\"text-left overflow-auto\" ta-bind ng-model=cow_event.description ng-class=\"{\'overflow\':isExpand && !getTraductor(\'cow.see_more\') && length_cow_event_description > 1000,\'overflow-en\':isExpand && getTraductor(\'cow.see_more\') && length_cow_event_description > 1000}\" ng-if=\"cow_event.description && showCowDescription && cowIsPlanPro\" ng-click=\"isExpand = !isExpand;\"></div><div class=\"text-left col-md-6 col-md-offset-3 margin-bottom-20 overflow-auto\" ng-if=\"!cow_event.description && showCowDescription && cowIsPlanPro\" ng-bind-html=cow_event.cow_type.description_default></div><!--Beneficios de ser pro--><div class=\"text-center overflow-auto upgrade-to-pro-div col-md-offset-3 col-md-6\" ng-if=!cowIsPlanPro><div ng-bind-html=\"getTraductor(\'cow.benefits_pro\')\"><!--Contenido de beneficios de ser pro--></div><button id=cowToProButton class=\"button-action btn-sm\" style=\"font-size: 15px\" ng-click=upgradeCowToPro()>{{getTraductor(\'cow.wanna_be_pro\')}}</button></div><div class=\"col-md-4 col-md-offset-8 col-sm-7 col-xs-7 no-padding-left-xs-sm\" ng-show=\"!cow_event.marketplace && !cow_event.is_promo && !cow_event.is_public && cowIsPlanPro\"><button type=button name=button class=\"form-control font-size-13-sm-xs no-padding\" ng-click=showDescriptionEdit()><i class=\"fa fa-pencil-square-o\" aria-hidden=true></i> {{getTraductor(\'cow.edit_description\')}}</button></div><div ng-show=showCowDescriptionEdit><text-angular ng-model=cowNewdescription name=demo-editor placeholder={{cow_event.cow_type.description_placeholder}}></text-angular><div class=\"col-md-3 col-md-offset-3 col-sm-4 col-xs-4 no-padding-left-xs-sm margin-top-20\"><button type=button name=button class=\"form-control no-padding\" ng-click=closeCowDescriptionEdit()><i class=\"fa fa-arrow-circle-o-left font-color-pink\" aria-hidden=true></i> {{getTraductor(\'cow.return\')}}</button></div><div class=\"col-md-3 col-sm-4 col-xs-4 no-padding-left-xs-sm margin-top-20\"><button type=button name=button class=\"form-control no-padding\" ng-click=saveCowDescription()><i class=\"fa fa-floppy-o font-color-atv\" aria-hidden=true></i> {{getTraductor(\'cow.save\')}}</button></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 no-padding-left-right margin-bottom-20\" ng-if=cow_event.show_location_point><ui-gmap-google-map center=map.center zoom=map.zoom><!--MARKER--><ui-gmap-marker coords=marker.coords options=marker.options events=marker.events idkey=marker.id></ui-gmap-marker></ui-gmap-google-map></div></div><div ng-show=!adminUser><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>{{getTraductor(\'cow.admin_cow\')}}</b></h1></div></div><div class=\"container-fluid background-color-white\"><div class=container><h3 class=text-center>{{getTraductor(\'cow.restricted_area\')}}</h3><div class=\"row col-md-6 text-center margin-bottom-20\"><h4 class=text-center>{{getTraductor(\'cow.if_you_are_invited\')}}</h4><button class=\"btn btn-default button-action-small\" ng-click=goToPublicCow()><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>{{getTraductor(\'cow.go_to_cow\')}}</button></div><div class=\"row col-md-6 margin-bottom-20\"><h4 class=text-center>{{getTraductor(\'cow.if_you_are_administrator\')}}</h4><div class=\"row login-form-content col-md-offset-2 col-md-8\"><div class=social-login><div><a class=\"btn btn-block btn-social btn-facebook facebook-button\" ng-click=loginFb()><span class=\"fa fa-facebook\"></span> {{getTraductor(\'cow.login_facebook\')}}</a></div><div class=google-social><a class=\"btn btn-block btn-social btn-google google-button\" ng-click=loginGg()><img src=assets/images/utils/google-logo.svg class=\"no-outline img-google-logo\" alt=google-maps-logo> {{getTraductor(\'cow.login_google\')}}</a></div></div><div class=email-login><form name=loginForm ng-submit=loginUser(loginForm.$valid) novalidate><h3 class=text-center>{{getTraductor(\'cow.login\')}}</h3><md-input-container class=md-block flex-gt-sm=\"\"><label>{{getTraductor(\'cow.email\')}}</label><input required name=email maxlength=100 ng-model=user.email type=email><div ng-messages=loginForm.email.$error><div ng-message=required>{{getTraductor(\'cow.required_email\')}}</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\"><label>{{getTraductor(\'cow.password\')}}</label><input required name=password maxlength=100 minlength=8 ng-model=user.password type=\"{{(show_password)? \'text\': \'password\'}}\"><div ng-messages=loginForm.password.$error><div ng-message=required>{{getTraductor(\'cow.required_password\')}}</div><div ng-message=minlength>{{getTraductor(\'cow.length_password\')}}</div></div></md-input-container><div class=\"col-md-6 no-padding-left\"><a href=\"\" ui-sref=forgot-password>{{getTraductor(\'cow.forget_password\')}}</a></div><p ng-show=errorSended class=\"text-danger login-error-msg\">{{errorMessage}}</p><button class=\"btn btn-default pull-right button-action-small\" type=submit>{{getTraductor(\'cow.login\')}}</button></form></div></div></div></div></div></div><div><atv-footer></atv-footer></div><!-- Templates --><script type=text/ng-template id=contactListModal-1><div class=\"ngdialog-message\">\n    <h3 ng-show=\"ngDialogData.guestList.length > 0\">{{getTraductor(\'cow.guest_list\')}}</h3>\n    <h3 ng-show=\"ngDialogData.guestList.length == 0\">{{getTraductor(\'cow.no_guest_list\')}}</h3>\n    <div class=\"text-center\" ng-repeat=\"guest in ngDialogData.guestList track by $index\">\n      <p>\n        {{guest.name}}\n        <i class=\"fa fa-times pull-right no-outline\" aria-hidden=\"true\"\n           ng-click=\"deleteGuest(guest, ngDialogData.cowId)\"></i>\n      </p>\n    </div>\n  </div></script><script type=text/ng-template id=confirmationModal-1><div class=\"ngdialog-message text-center\">\n    <h3 class=\"\">{{getTraductor(\'cow.delete_person_one\')}}\n      {{ngDialogData.guest.name}}\n      {{getTraductor(\'cow.delete_person_two\')}}</h3>\n    <a class=\"smGlobalBtn confirmContactBtn\"\n       ng-click=\"confirmationDeleteGuest(ngDialogData.guest, ngDialogId, ngDialogData.cowId)\"></a>\n    <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeSecond(ngDialogId)\"></a>\n  </div></script><script type=text/ng-template id=confirmationCloseCowEventModal-1><div class=\"ngdialog-message text-center\">\n    <h3 class=\"\">{{getTraductor(\'cow.confirm_close_cow\')}}</h3>\n    <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeThird(ngDialogId)\"></a>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"confirmationCloseCowEvent(ngDialogData.cowId)\"></a>\n  </div></script><script type=text/ng-template id=confirmationReopenCowEventModal-1><div class=\"ngdialog-message text-center\">\n    <h3 class=\"\">{{getTraductor(\'cow.confirm_reopen_cow\')}}</h3>\n    <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeFourth(ngDialogId)\"></a>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"confirmationReopenCowEvent(ngDialogData.cowId)\"></a>\n  </div></script><script type=text/ng-template id=notAllowReOpenCowModal-1><div class=\"ngdialog-message text-center\">\n    <h4 class=\"\">{{getTraductor(\'cow.no_reopen_cow\')}}</h4>\n    <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeFifth(ngDialogId)\"></a>\n  </div></script><script type=text/ng-template id=participantsModal-1><div class=\"ngdialog-message\">\n    <div class=\"text-center\" ng-if=\"ngDialogData.participants.length == 0\">\n      <h3>{{getTraductor(\'cow.no_participations\')}}</h3>\n      <p>\n        {{getTraductor(\'cow.invite_friends\')}}\n      </p>\n    </div>\n    <div class=\"text-center\" ng-if=\"ngDialogData.participants.length > 0\">\n      <div id=\"participants_list\">\n        <h3>Participantes</h3>\n        <div ng-if=\"!ngDialogData.cow.has_options\">\n          <p ng-repeat=\"participant in ngDialogData.participants track by $index\">\n            {{ ($index + 1) + \". \" + participant.first_name + \' \' + participant.last_name + \' - \' +\n          participant.total_amount}}\n          </p>\n        </div>\n        <div ng-if=\"ngDialogData.cow.has_options\">\n          <div ng-repeat=\"option in ngDialogData.participants track by $index\">\n            <h4>{{option.option + \' - \' + option.option_total}}</h4>\n            <p ng-repeat=\"participant in option.participants track by $index\">\n              {{ ($index + 1) + \". \" + participant.first_name + \' \' + participant.last_name + \' - \' +\n            participant.total_amount}}\n            </p>\n            <br>\n          </div>\n        </div>\n      </div>\n      <button type=\"button\" name=\"button\" class=\"form-control\" ngclipboard data-clipboard-target=\"#participants_list\">\n        <i class=\"fa fa-clone\" aria-hidden=\"true\"></i>\n        {{getTraductor(\'cow.copy_list\')}}\n      </button>\n    </div>\n  </div></script><script type=text/ng-template id=requestCellphoneModal><div class=\"ngdialog-message\">\n    <div class=\"text-center\">\n      <i class=\"fa fa-mobile font-size-60\" aria-hidden=\"true\"></i>\n      <h3 class=\"margin-top-10\">¡{{ngDialogData.user.user.first_name}}, {{getTraductor(\'cow.juice_atv\')}}</h3>\n      <p>\n        {{getTraductor(\'cow.add_cellphone_accout\')}}\n      </p>\n      <form class=\"userCellphoneModal\" name=\"formUserCellphone\" novalidate=\"\">\n        <md-input-container class=\"col-md-offset-2 col-xs-offset-1 col-md-8 col-xs-10 margin-top-10 no-margin-bottom\"\n                            md-no-float>\n          <input id=\"user_cellphone\" ng-model=\"user.cellphone\" name=\"userCellphone\" type=\"tel\" pattern=\"[0-9]{10,12}\"\n                 only-digits required=\"\" placeholder=\"Tu número celular\" class=\"text-center\">\n          <div ng-messages=\"formUserCellphone.userCellphone.$error\">\n            <div ng-message=\"required\">\n              {{getTraductor(\'cow.required_cellphone\')}}\n            </div>\n            <div ng-message=\"pattern\">\n              {{getTraductor(\'cow.min_cellphone\')}}\n            </div>\n          </div>\n        </md-input-container>\n        <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"submitUserCellphone(formUserCellphone.$valid)\"></a>\n      </form>\n      <p class=\"font-size-12 margin-top-10\" ng-bind-html=\"getTraductor(\'cow.cellphone_data_processing_policy\')\">        \n      </p>\n    </div>\n  </div></script><script type=text/ng-template id=adminOptionsModal><div class=\"text-center row\">\n    <div class=\"col-md-6 col-sm-6 col-xs-6 padding-top-bottom-10\" ng-click=\"goToEdit(ngDialogData.cowId)\"\n         ng-show=\"!ngDialogData.cowPublic\">\n      <div class=\"width-100\">\n        <img src=\"../../../assets/images/admin/edit.png\" alt=\"edit\"\n             ng-class=\"(!ngDialogData.cowIsPlanPro)?\'filter-gray\':\'no-filter-gray\'\"/>\n      </div>\n      <b>{{getTraductor(\'cow.edit_cow\')}}</b>\n    </div>\n    <div class=\"col-md-6 col-sm-6 col-xs-6 padding-top-bottom-10\" ng-click=\"goToInvite()\">\n      <div class=\"width-100\">\n        <img src=\"../../../assets/images/admin/invite.png\" alt=\"invite\"/>\n      </div>\n      <b>{{getTraductor(\'cow.invite\')}}</b>\n    </div>\n    <div class=\"col-md-6 col-sm-6 col-xs-6 padding-top-bottom-10\" ng-click=\"downloadParticipantsList()\">\n      <div class=\"width-100\">\n        <img src=\"../../../assets/images/admin/download.png\" alt=\"download\"\n             ng-class=\"(!ngDialogData.cowIsPlanPro)?\'filter-gray\':\'no-filter-gray\'\"/>\n      </div>\n      <b>{{getTraductor(\'cow.download_report\')}}</b>\n    </div>\n    <div class=\"col-md-6 col-sm-6 col-xs-6 padding-top-bottom-10\" ng-click=\"openCloseCowEventModal()\"\n         ng-if=\"!ngDialogData.cowClosed\">\n      <div class=\"width-100\">\n        <img src=\"../../../assets/images/admin/close.png\" alt=\"close\"/>\n      </div>\n      <b>{{getTraductor(\'cow.close_cow\')}}</b>\n    </div>\n    <div class=\"col-md-6 col-sm-6 col-xs-6 padding-top-bottom-10\" ng-click=\"openReopenCowEventModal()\"\n         ng-if=\"ngDialogData.cowClosed\">\n      <div class=\"width-100\">\n        <img src=\"../../../assets/images/admin/close.png\" alt=\"close\"/>\n      </div>\n      <b>{{getTraductor(\'cow.reopen_cow\')}}</b>\n    </div>\n  </div></script><script type=text/ng-template id=upgradeCowToProModal><div class=\"ngdialog-message text-center\">\n    <div ng-bind-html=\"getTraductor(\'cow.dont_fast\')\">\n\n    </div>\n    <button id=\"upgradeCowToProButton\" class=\"button-action btn-sm\" style=\"font-size: 15px\"\n            ng-click=\"acceptUpgradeCowToPro()\">\n      {{getTraductor(\'cow.wanna_be_pro\')}}\n    </button>\n  </div></script><script type=text/ng-template id=confirmCowToProModal><div class=\"ngdialog-message text-center\">\n    <div class=\"confirmation_pro\">\n      <h4>{{getTraductor(\'cow.title_confirmation_pro_firts\')}}<strong> {{businessCowFee}}% + IVA</strong> <div ng-bind-html=\"getTraductor(\'cow.title_confirmation_pro_second\')\"></div></h4>\n      <div ng-bind-html=\"getTraductor(\'cow.confirmation_pro\')\"></div>\n    </div>\n    <button id=\"acceptCowToProModal\" class=\"button-action btn-sm\" style=\"font-size: 15px\"\n            ng-click=\"confirmUpgradeCowToPro()\">\n      {{getTraductor(\'cow.yes_i_agree\')}}\n    </button>\n  </div></script><script type=text/ng-template id=confirmationRequestPublicCow-1><div class=\"ngdialog-message text-center\">\n    <h3 class=\"\">{{getTraductor(\'cow.confirmation_vacan\')}}</h3>\n    <h4 ng-bind-html=\"getTraductor(\'cow.info_vacanes\')\">      \n    </h4>\n    <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeThird(ngDialogId)\"></a>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"confirmationRequestCowPublicEvent(ngDialogData.cowId)\"></a>\n  </div></script><!-- NO USER DOCUMENT ALERT --><script type=text/ng-template id=noDocumentAlert><div class=\"ngdialog-message text-center\">\n    <h3>¡Hola!</h3>\n    <h4>Tan sólo un paso más. Para continuar usando Armatuvaca debes terminar de registrar tus datos</h4>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"acceptNoDocumentAlert(ngDialogData)\"></a>\n  </div></script>");
$templateCache.put("app/views/cowContactMe/cowContactMe.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center page-top-title page-title\"><div class=container><div class=row><h1 class=\"font-color-atv margin-top-40-md\"><b>Cobramos por ti</b></h1><p>Te ayudamos con tu Vaca para que sea todo un éxito, elije una de nuestras opciones.</p></div></div></div><div class=\"container-fluid background-color-white\"><div class=\"container margin-top-20 margin-bottom-20 text-center\"><div class=col-md-12><div class=\"row col-md-6\"><div class=\"col-md-8 col-md-offset-2\"><img src=assets/images/utils/whatsapp.svg class=\"no-outline center-item img-wapp-contact-me\" alt=whatsapp-logo><h3 class=text-left>Opción 1.</h3><p class=\"margin-top-10 text-justify\">Agrega a Armatuvaca a tu grupo de Whatsapp y recibirán notificaciones y recordatorios para que se complete la Vaca y se genere interacción en el grupo.</p><p><a class=num-link-wapp-contact-me href=\"https://api.whatsapp.com/api/send?phone=3007185815?text=Hola,%20quisiera%20que%20me%20ayuden%20a%20contactar%20a%20mis%20amigos\" target=_blank>+57 300 718 5815</a></p><hr><div ng-show=!user.cellphone><form id=userCellphoneContactMe name=userCellphoneContactMe ng-submit=submitUserCellphone(userCellphoneContactMe.$valid) novalidate><p class=text-left>Todavía no tenemos tu número celular, ingresalo para poder contactarte.</p><div class=\"form-group text-left\"><label>Celular</label><input type=tel class=form-control digits-no-indicative placeholder=\"300 440 7899\" required pattern=[0-9]{10,10} ng-model=cellphoneContactMe only-digits></div><!--<a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"submitUserCellphone(formUserCellphone.$valid)\"></a>--></form><p class=\"validation-messages no-margin-top text-left\" ng-show=\"userCellphoneContactMe.$submitted && !userCellphoneContactMe.$valid\">El número debe ser de 10 dígitos</p><button type=submit form=userCellphoneContactMe name=button class=form-control><i class=\"fa fa-floppy-o font-color-atv\" aria-hidden=true></i> Guardar</button></div><div ng-show=user.cellphone><h3 class=text-left>Opción 2.</h3><p class=text-justify>Si lo prefieres te enviaremos imágenes y mensajes personalizados para que le reenvíes a los participantes de tu Vaca y los motives a pagar.</p><div class=\"row text-left padding-left-15\"><md-checkbox ng-model=cow.contact_me_via_wapp aria-label=\"Checkbox contact me\">Contactarme vía Whatsapp</md-checkbox></div></div></div></div><div class=\"row col-md-6\"><div class=\"col-md-8 col-md-offset-2\"><img src=assets/images/utils/mobile-phone.svg class=\"no-outline center-item img-wapp-contact-me\" alt=whatsapp-logo><h3 class=text-left>Opción 3.</h3><p class=\"margin-top-10 text-justify\">Déjanos cobrar por ti : Agrega los nombres o apodos de los participantes de tu Vaca y nosotros nos encargamos de cobrar.</p><div class=text-left><form name=contactsForm id=contactsForm ng-submit=addContact(contactsForm.$valid) novalidate><div class=form-group><label>Nombre</label><input type=text ng-model=contact.name class=form-control placeholder=\"Pedro Pérez\" required></div><div class=form-group><label>Celular</label><input type=tel class=form-control placeholder=\"300 123 4567\" required pattern=[0-9]{10,10} ng-model=contact.tel only-digits></div></form><p class=\"validation-messages no-margin-top\" ng-show=\"contactsForm.$submitted && !contactsForm.$valid\">Verifica que hayas añadido Nombre y Celular. El célular debe tener 10 dígitos.</p><button type=submit form=contactsForm name=button class=\"form-control margin-bottom-20\"><i class=\"fa fa-plus font-color-atv\" aria-hidden=true></i> Agregar</button><div class=\"text-left div-tels\"><p ng-repeat=\"contact in contacts track by $index\">{{contact.name}} - {{contact.tel}} <span class=\"no-outline close-btn-tel\" ng-click=deleteContact($index)>&times;</span></p></div><small id=emailHelp class=\"form-text text-muted\">Al incluir tus contactos, aceptas en calidad de responsable de estos datos de contacto, que nuestra plataforma envíe mensajes de texto. Ten en cuenta que los datos entregados serán tratados de acuerdo a nuestra <a ui-sref=privacy-policy target=_blank>política de tratamiento de datos</a>.</small></div></div></div></div><div class=\"col-md-10 col-md-offset-1 padding-15\"><button ng-click=goToCowAdmin(cow.cow_event_id) class=\"btn btn-default button-action-small-pink pull-left\">Ir a la Vaca</button> <button ng-click=saveCowEventContactMe() class=\"btn btn-default button-action-small pull-right btn-next-contact-me\">Guardar</button></div></div></div><div class=container-fluid><atv-footer></atv-footer></div><!--Templates--><script type=text/ng-template id=contactRefreshConfirmModal><div class=\"ngdialog-message\">\n    <h3 class=\"contactRefreshConfirmModal_title\">\n      Tus cambios se han guardado con exito.\n    </h3>\n    <p class=\"contactRefreshConfirmModal_subtitle\" id=\"ngdialog1-aria-describedby\">\n      Puedes seguir editando o revisar de nuevo tu vaca.\n    </p>\n    <div style=\"text-align: center\">\n      <button\n        ng-click=\"goToCow(ngDialogData.cowId)\" class=\"contactRefreshConfirmModal_buttons btn btn-default button-action-small-pink\">\n        Ir a la Vaca\n      </button>\n      <button\n        ng-click=\"continueEdit()\" class=\"contactRefreshConfirmModal_buttons btn btn-default button-action-small btn-next-contact-me\">\n        Seguir editando\n      </button>\n    </div>\n  </div></script>");
$templateCache.put("app/views/cowCreate/cowCreate.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Armatuvaca</b></h1><p>Y recolecta dinero en grupo</p></div></div><div class=\"container-fluid background-color-white no-padding-left-right\"><form class=margin-top-20 name=formCow novalidate ng-submit=createCow(formCow.$valid) id=createCowForm><div class=\"container col-md-6 col-md-offset-3\"><div class=\"row col-md-10 col-md-offset-1 margin-top-40\"><div class=required-text><p><b>*</b> Obligatorio</p></div><div><md-input-container class=\"col-md-12 col-xs-12 md-input-has-placeholder no-padding-left\" flex-gt-sm=\"\" md-is-error=\"formCow.cow_name.$invalid && formCow.$submitted\"><label class=font-size-18>Nombre de la Vaca</label><input id=cow_create_cow_name required type=text name=cow_name md-maxlength=50 ng-model=cow.name no-special-chars placeholder=\"Agrega acá el nombre de la Vaca\" onkeypress=\"return (event.charCode == 209 || event.charCode == 241 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 32)); return this.replace(/([\\uE000-\\uF8FF]|\\uD83C[\\uDF00-\\uDFFF]|\\uD83D[\\uDC00-\\uDDFF])/g, \'\')\" ng-paste=paste($event)><div ng-messages=formCow.cow_name.$error><div ng-message=required>Escribe el nombre de tu vaca</div></div></md-input-container><md-input-container class=\"col-md-12 col-md-offset-right-6 col-xs-12 col-sm-12 no-padding-left\"><label>Tipo de la Vaca</label><md-select ng-model=cowTypeString ng-change=cowEventTypeChanged(cowTypeString) ng-disabled={{is_public}}><md-option ng-repeat=\"cowType in cowEventTypesList | orderBy:\'priority\'\" ng-value=cowType>{{cowType.name}}</md-option></md-select></md-input-container></div></div><div class=\"row padding-left-15-xs-sm padding-right-15-xs-sm col-md-10 col-md-offset-1\"><div class=padding-right-15-xs-sm><div class=margin-bottom-20><h5 class=text-left><b>Participación / Contribución </b><i class=\"fa fa-info-circle tooltip-cow-option\" tooltip-placement=left uib-tooltip=\"Es el monto que cada participante aportará a la Vaca\" aria-hidden=true></i></h5></div><div class=\"col-md-4 col-sm-4 col-xs-4 participation-value-container\"><div class=\"col-sm-12 col-xs-12 col-md-12 no-padding-left-right margin-bottom-10\"><button type=button id=cow_create_participation_free ng-click=selectParticipationFree() class=participation-type-button ng-class=\"cow.participation_free ? \'participation-type-button-selected\' : \'participation-type-button-unselected\'\" uib-tooltip=\"El participante elegirá el monto de su contribución\" tooltip-placement=top tooltip-class=hidden-xs>Libre</button></div></div><div class=\"col-md-4 col-sm-4 col-xs-4 participation-value-container\"><div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left-right margin-bottom-10\"><button type=button id=cow_create_participation_suggested ng-click=selectParticipationSuggested() class=participation-type-button ng-class=\"cow.participation_suggested ? \'participation-type-button-selected\' : \'participation-type-button-unselected\'\" uib-tooltip=\"Sugierele un monto a pagar al participante\" tooltip-placement=top tooltip-class=hidden-xs>Sugerida</button></div><div class=\"col-md-12 col-sm-12 col-xs-12 pull-left no-padding-left-right\"><input ng-show=cow.participation_suggested id=cow_create_participant_value_suggested ng-model=cow.participant_value_suggested name=partipantSuggestedValue class=\"form-control-atv text-center\" placeholder=$ ui-money-mask=0 type=tel min=\"\" ng-focus=selectParticipationSuggestedFocus() ng-required=cow.participation_suggested ng-change=setParticipationValueExample(cow.participant_value_suggested)><p ng-show=\"formCow.$submitted && formCow.partipantSuggestedValue.$invalid && cow.participation_suggested\" class=\"validation-messages text-left\">Por favor ingresa el monto sugerido</p><p ng-show=\"formCow.$submitted && formCow.partipantSuggestedValue.$dirty && cow.participation_suggested && cow.participant_value_suggested < minPaymentValue\" class=validation-messages>El monto mínimo de participación es de {{minPaymentValue | currency:\"$\":\'0\'}} COP</p><p ng-show=\"formCow.$submitted && formCow.partipantSuggestedValue.$dirty && cow.participation_suggested && cow.participant_value_suggested > maxPaymentValue\" class=validation-messages>El monto máximo de participación es de {{maxPaymentValue | currency:\"$\":\'0\'}} COP</p></div></div><div class=\"col-md-4 col-sm-4 col-xs-4 participation-value-container\"><div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left-right margin-bottom-10\"><button type=button id=cow_create_participation_fixed ng-click=selectParticipationFixed() class=participation-type-button ng-class=\"cow.participation_fixed ? \'participation-type-button-selected\' : \'participation-type-button-unselected\'\" uib-tooltip=\"El participante debe aportar el valor que tú decidas\" tooltip-placement=top tooltip-class=hidden-xs>Fija</button><p ng-show=\"formCow.$submitted && (!cow.participation_suggested && !cow.participation_fixed && !cow.participation_free)\" class=validation-messages>Por favor selecciona un tipo de participación</p></div><div class=\"col-md-12 col-sm-12 col-xs-12 pull-left no-padding-left-right\"><input ng-show=cow.participation_fixed id=cow_create_participant_value_fixed ng-model=cow.participant_value_fixed name=partipantFixedValue class=\"form-control-atv text-center\" placeholder=$ ui-money-mask=0 type=tel min=\"\" ng-focus=selectParticipationFixedFocus() ng-required=cow.participation_fixed ng-change=setParticipationValueExample(cow.participant_value_fixed)><p ng-show=\"formCow.$submitted && formCow.partipantFixedValue.$invalid && cow.participation_fixed\" class=\"validation-messages text-left\">Por favor ingresa el monto fijo</p><p ng-show=\"formCow.$submitted && formCow.partipantFixedValue.$dirty && cow.participation_fixed && cow.participant_value_fixed < minPaymentValue\" class=validation-messages>El monto mínimo de participación es de {{minPaymentValue | currency:\"$\":\'0\'}} COP</p><p ng-show=\"formCow.$submitted && formCow.partipantFixedValue.$dirty && cow.participation_fixed && cow.participant_value_fixed > maxPaymentValue\" class=validation-messages>El monto máximo de participación es de {{maxPaymentValue | currency:\"$\":\'0\'}} COP</p></div></div></div></div><!--<div class=\"row padding-left-15-xs-sm padding-right-15-xs-sm col-md-10 col-md-offset-1 margin-bottom-10\">--><!--<a ng-click=\"showGiftCodeInput()\"><strong class=\"margin-bottom-10 font-size-12 cursor-pointer\">¿Tienes un código promocional?</strong></a>--><!--<div class=\"form-group padding-bottom-20\" ng-show=\"!gift_code_obj.valid && giftCodeInputVisible\">--><!--<input id=\"cow_gift_code\" type=\"text\" name=\"gift_code\" ng-model=\"gift_code\"--><!--class=\"form-control col-md-8 input-link-share\" placeholder=\"Ingresar código\">--><!--<div class=\"col-md-4 col-sm-6 col-xs-6 no-padding-left-right-xs-sm\">--><!--<button id=\"apply_gift_code\" type=\"button\" name=\"button\" class=\"form-control\"--><!--ng-click=\"applyCoupon()\">--><!--<i class=\"fa fa-gift\" aria-hidden=\"true\"></i>--><!--Aplicar código--><!--</button>--><!--</div>--><!--</div>--><!--<p class=\"padding-top-10 font-size-13 font-color-atv\" ng-show=\"gift_code_obj.valid\">El código ha sido aplicado: {{gift_code_obj.description}}</p>--><!--</div>--><!--CHECK PUBLIC COW--><!-- <div class=\"row padding-left-15-xs-sm padding-right-15-xs-sm col-md-10 col-md-offset-1\">\n        <div class=\"padding-right-15-xs-sm\">\n          <div class=\"margin-bottom-20\">\n            <h5 class=\"text-left\">\n              <b>Conviértete en Vacán:\n              </b>\n              <i class=\"fa fa-info-circle tooltip-cow-option\" tooltip-placement=\"left\"\n                 uib-tooltip=\"Vacanes es un espacio para publicar los proyectos de\n                ArmaTuVaca con causas solidarias.\"\n                 aria-hidden=\"true\"></i>\n            </h5>\n          </div>\n          <div class=\"col-md-12 col-sm-12 col-xs-12\">\n            <div class=\"custom-control custom-checkbox\">\n              <label class=\"custom-control-label\" for=\"is_public\">\n                <input type=\"checkbox\" class=\"custom-control-input\" id=\"is_public\" ng-model=\"is_public\"\n                       ng-disabled=\"{{is_public}}\">\n                Deseo que mi Vaca aparezca de forma pública en\n                la sección de Vacanes</label>\n            </div>\n          </div>\n        </div>\n      </div> --></div><div class=\"col-md-12 margin-top-20 margin-bottom-20 text-center\"><button id=cow_create_btn_submit class=button-action type=submit>Armar Vaca</button></div></form></div><div><atv-footer></atv-footer></div><script type=text/ng-template id=confirmCowCreationDialog><div class=\"ngdialog-message text-center\">\n    <h4>\n      <b>¡Estás creando una Vaca Gratuita!</b><br>\n      Sin embargo ten en cuenta que:\n    </h4>\n    <ul class=\"text-left\">\n      <li>Si recibes un total de <strong>2 millones de pesos</strong> o más</li>\n      en la Vaca\n      <li>Si utilizas tu Vaca para fines comerciales o a nombre de una fundación</li>\n    </ul>\n    <h4>\n      se aplicará un costo de servicio <br>\n      (No olvides revisar nuestra sección de TARIFAS para más información)\n    </h4>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"acceptConfirmationDialog(ngDialogData)\"></a>\n  </div></script><script type=text/ng-template id=askCowFeeDialog><div class=\"ngdialog-message text-center\">\n    <h4 ng-if=\"cowTypeSlug == businessCowTypeSlug\">\n      Como la Vaca que estás creando es para fines comerciales, tu Vaca tendrá un costo de 2.99% + IVA sobre el total\n      recolectado\n    </h4>\n    <h4 ng-if=\"cowTypeSlug == socialBusinessCowTypeSlug\">\n      Como la Vaca que estás creando no es para fines personales, tu Vaca tendrá un costo de 2.99% + IVA sobre el total\n      recolectado\n    </h4>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"acceptConfirmationDialog(ngDialogData)\"></a>\n  </div></script><script type=text/ng-template id=confirmIsPubliCow><div class=\"ngdialog-message text-center\">\n    <h4>\n      Estás creando una Vaca pública:\n    </h4>\n    <ul class=\"text-left\">\n      <li>Esto tiene un costo de <b>4.99% + IVA</b> sobre el total recolectado.</li>\n      <li>Debes personalizar la <b>descripción e imagen</b> de la Vaca para que esta sea aprobada y publicada.</li>\n      <li>En la descripción debes agregar alguna <b>red social, número de teléfono y/o correo electrónico</b> de\n        contacto.\n      </li>\n      <li>Después de que se apruebe y publique tu Vaca, <b>NO</b> podrás modificarla.</li>\n      <li>El <b>valor recolectado y el número de participaciones</b> serán visibles para todo el público</li>\n    </ul>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"acceptConfirmationDialog(ngDialogData)\"></a>\n  </div></script>");
$templateCache.put("app/views/cowCreateNew/cowCreateNew.html","<div><atv-navbar></atv-navbar></div><!--TITLE COW--><div class=\"new-cow-create-title container-fluid text-center\"><!--<p>Estás a un paso de crear tu Vaca</p>--><!--<div class=\"new-cow-create-title-name\">--><!--<input type=\"text\" placeholder=\"Ingresa aquí el nombre de tu Vaca\" ng-model=\"cow.name\"--><!--ng-class=\"{\'animated pulse infinite slow\': !cow.name}\">--><!--<div ng-class=\"{\'animated pulse infinite slow\': !cow.name}\"></div>--><!--</div>--><div class=new-cow-create-title-separator></div></div><!--WIDGET COW TYPE--><div class=\"new-cow-create-selector text-center margin-top-10\"><p class=new-cow-create-selector-title><strong>¿Para qué es la Vaca?</strong><br>Selecciona una opción:</p><div class=\"new-cow-create-selector-widget atv-col-container\"><div class=\"atv-col atv-col-sm-4\"><div class=new-cow-create-selector-widget-option ng-class=\"{\'active\':cow.category === \'group\'}\" ng-click=\"clickCategory(\'group\')\"><img src=assets/images/newcowcreate/group.png alt=\"\"><div><h3>Reunir dinero en grupo</h3><p>Paseo, asado, viaje en grupo, regalo grupal...</p></div></div></div><div class=\"atv-col atv-col-sm-4\"><div class=new-cow-create-selector-widget-option ng-class=\"{\'active\':cow.category === \'wallet\'}\" ng-click=\"clickCategory(\'wallet\')\"><img src=assets/images/newcowcreate/wallet.png alt=\"\"><div><h3>Administrar mi dinero</h3><p>Cobrar a amigos, usala como alcancía, otros gastos...</p></div></div></div><div class=\"atv-col atv-col-sm-4\"><div class=new-cow-create-selector-widget-option ng-class=\"{\'active\':cow.category === \'crowdfunding\'}\" ng-click=\"clickCategory(\'crowdfunding\')\"><img src=assets/images/newcowcreate/crowdfunding.png alt=\"\"><div><h3>Crear una causa social</h3><p>Donacion, fundación, ayudas humanitarias...</p></div></div></div></div></div><!--COW TYPES--><div class=\"new-cow-create-form text-center\" ng-if=cow.category><!--GROUP/CASH OPTION--><div ng-if=\"cow.category === \'group\' || cow.category === \'wallet\'\"><div class=new-cow-create-form-subtitle><b>Nombre de la Vaca:</b><br></div><md-input-container md-no-float md-is-error=\"!cow.name && create_cow_button_submit\"><input type=text ng-model=cow.name placeholder=\"Ingresa aquí el nombre de tu Vaca\" md-maxlength=50 onkeypress=\"return (event.charCode == 209 || event.charCode == 241 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 32)); return this.replace(/([\\uE000-\\uF8FF]|\\uD83C[\\uDF00-\\uDFFF]|\\uD83D[\\uDC00-\\uDDFF])/g, \'\')\" ng-paste=paste($event)><!--onkeypress=\"return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || event.charCode == 32)\">--> <small ng-if=\"!cow.name && create_cow_button_submit\" style=\"color: red\">Este es un campo obligatorio (Máximo 50 Caracteres)</small></md-input-container><div class=new-cow-create-form-subtitle><b>Tipo de Vaca:</b><br></div><md-input-container><md-select ng-model=cow.cow_type placeholder=\"Tipo de vaca\" ng-change=cowEventTypeChanged(cow.cow_type)><md-option ng-repeat=\"cowType in cowEventTypesList | orderBy:\'priority\'\" ng-value=cowType.slug>{{cowType.name}}</md-option></md-select></md-input-container><br><br><div class=new-cow-create-form-subtitle><b>{{cow.cow_type !== \'cobrar-negocio\'? \'Selecciona un plan:\': \'Plan:\'}}</b><br><div class=new-cow-create-form-select-option ng-if=\"cow.cow_type === \'cobrar-negocio\'\"><img src=assets/images/newcowcreate/pro.png alt=\"\"> <span>Pro</span></div><span ng-if=\"cow.cow_type === \'cobrar-negocio\'\">Como la Vaca que estás creando tiene fines comerciales, tiene costo.</span></div><md-input-container ng-if=\"cow.cow_type !== \'cobrar-negocio\'\"><md-radio-group ng-model=cow.plan><md-radio-button value=free class=md-primary><div class=new-cow-create-form-select-option><img src=assets/images/newcowcreate/free.png alt=\"\"> <span>Básico</span></div></md-radio-button><md-radio-button value=pro class=md-primary><div class=new-cow-create-form-select-option><img src=assets/images/newcowcreate/pro.png alt=\"\"> <span>Pro</span></div></md-radio-button></md-radio-group></md-input-container><!--<md-input-container>--><!--<md-select ng-model=\"cow.plan\" placeholder=\"Selecciona un plan\" ng-if=\"cow.cow_type !== \'cobrar-negocio\'\">--><!--<md-option ng-value=\"\'free\'\">--><!--<div class=\"new-cow-create-form-select-option\">--><!--<img src=\"assets/images/newcowcreate/free.png\" alt=\"\">--><!--<span>Básico</span>--><!--</div>--><!--</md-option>--><!--<md-option ng-value=\"\'pro\'\">--><!--<div class=\"new-cow-create-form-select-option\">--><!--<img src=\"assets/images/newcowcreate/pro.png\" alt=\"\">--><!--<span>Pro</span>--><!--</div>--><!--</md-option>--><!--</md-select>--><!--</md-input-container>--></div><!--CROWDFUNDING/ VACANES OPTION--><div ng-if=\"cow.category === \'crowdfunding\'\"><div class=new-cow-create-form-subtitle><b>Nombre de la Vaca:</b><br></div><md-input-container md-no-float md-is-error=\"!cow.name && create_cow_button_submit\"><input type=text ng-model=cow.name placeholder=\"Ingresa aquí el nombre de tu Vaca\" md-maxlength=50 onkeypress=\"return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || event.charCode == 32)\"> <small ng-if=\"!cow.name && create_cow_button_submit\" style=\"color: red\">Este es un campo obligatorio (Máximo 50 Caracteres)</small></md-input-container><!-- <div class=\"new-cow-create-form-subtitle\">\n      <b>Conviértete en Vacán:</b><br>\n    </div>\n    <div class=\"new-cow-create-form-checkbox\" style=\"margin-top: 10px\">\n      <md-checkbox ng-model=\"cow.is_public\"\n                   aria-label=\"Quiero ser un Vacan\"\n                   ng-true-value=\"true\"\n                   ng-false-value=\"false\">\n        <span>\n          Quiero aparecer en Vacanes&nbsp;\n          <i class=\"fa fa-info-circle\" tooltip-placement=\"left\"\n             uib-tooltip=\"Vacanes es un espacio para publicar los proyectos de ArmaTuVaca con causas solidarias.\"\n             aria-hidden=\"true\"\n             style=\"font-size: 16px\"\n          ></i>\n        </span>\n      </md-checkbox>\n    </div>\n    <div ng-if=\"cow.is_public\">\n      <br>\n      <div class=\"new-cow-create-form-subtitle\">\n        <b>Tipo de Causa:</b><br>\n      </div>\n      <md-input-container>\n        <md-select ng-model=\"cow.cow_public_type\" placeholder=\"Tipo de vaca\">\n          <md-option ng-repeat=\"cowType in cowEventPublicType | orderBy:\'priority\'\" ng-value=\"cowType.slug\">\n            {{cowType.name}}\n          </md-option>\n        </md-select>\n      </md-input-container>\n    </div> --></div></div><br><!-- RESUME CONTAINER--><div class=\"new-cow-create-resume text-center\" ng-if=cow.category><p class=new-cow-create-resume-price>{{cow.category === \'crowdfunding\' && cow.is_public ? \'Plan Vacanes*\': null}} {{cow.category === \'crowdfunding\' && !cow.is_public ? \'Plan Pro*\': null}} {{(cow.category === \'group\' || cow.category === \'wallet\') && cow.plan === \'pro\' ? \'Plan Pro*\': null}} {{(cow.category === \'group\' || cow.category === \'wallet\') && cow.plan === \'free\' ? \'Plan Básico\': null}}</p><p style=\"margin-bottom: 10px\">{{cow.category === \'crowdfunding\' && cow.is_public ? \'4.99% + IVA\': null}} {{cow.category === \'crowdfunding\' && !cow.is_public ? \'2.99% + IVA\': null}} {{(cow.category === \'group\' || cow.category === \'wallet\') && cow.plan === \'pro\' ? \'2.99% + IVA\': null}} {{(cow.category === \'group\' || cow.category === \'wallet\') && cow.plan === \'free\' ? \'Sin costo\': null}}</p><div class=new-cow-create-title-separator></div><ul ng-if=\"(cow.category === \'group\' || cow.category === \'wallet\') && cow.plan === \'free\'\"><li>Recibe un monto total en la Vaca de máximo <b>$1\'000.000 COP </b></li><li>Recibe pagos solo con <b>PSE</b></li><li>Haz un retiro total de la plata a una <b>cuenta bancaria en Colombia</b></li></ul><ul ng-if=\"cow.category === \'crowdfunding\' || cow.plan === \'pro\'\"><li><b>Sin topes máximos</b> en el monto total de tu Vaca</li><li>Recibe pagos con <b>Tarjeta de crédito* y PSE</b></li><li>Haz <b>retiros parciales</b> del dinero de tu Vaca</li><li>Saca la plata a una cuenta bancaria o a <b>Efecty, Nequi o Daviplata</b></li><li ng-if=\"cow.category === \'crowdfunding\' && cow.is_public\">Mayor <b>visibilidad</b>, apareces en la sección de <b>Vacanes</b></li></ul><div class=text-center ng-if=cow.category><button id=cow_create_btn_submit class=button-action style=\"width: 80%; font-size: 20px\" ng-click=createCowEvent()>Armar Vaca</button><br><br></div></div><!--CONDITIONS CONTAINER--><div class=new-cow-create-conditions><p ng-if=\"cow.category === \'crowdfunding\' || cow.plan === \'pro\'\">&nbsp;&nbsp; <small>Los pagos con tarjeta de crédito generan un cobro de 1.99% + IVA, este será cobrado al participante.</small></p><p ng-if=\"cow.category === \'crowdfunding\' || cow.plan === \'pro\'\">&nbsp;&nbsp; <small>El Valor del IVA se calcula asi: el 19%(IVA) del {{cow.category === \'crowdfunding\' && cow.is_public ? \'4.99%\': \'2.99%\'}} de comisión</small></p></div><!--FOOTER--><br><br><div><atv-footer></atv-footer></div><!--MODALS--><script type=text/ng-template id=confirmCowCreationDialog><!--FREE COW DIALOG-->\n  <div class=\"new-cow-create-confirm\"\n       ng-if=\"(cow.category === \'group\' || cow.category === \'wallet\') && cow.plan === \'free\'\">\n    <h3 class=\"text-center\"><b>¡Estás creando una Vaca Básica!</b></h3>\n    <h4 class=\"text-center\">Sin embargo ten en cuenta que:</h4>\n    <ul class=\"text-left\">\n      <li>Solo puedes recibir hasta <b>$1\'000.000 COP.</b></li>\n      <li>Solo puedes recibir pagos con <b>PSE</b></li>\n      <li>Si utilizas tu Vaca para fines comerciales o a nombre de una fundación se aplicará un costo de servicio<br>\n        <small>(No olvides revisar nuestra sección de TARIFAS para más información)</small>\n      </li>\n    </ul>\n    <div class=\"new-cow-create-confirm-buttons text-center\">\n      <button id=\"cow_create_btn_submit\" class=\"button-action btn-sm\" style=\"font-size: 15px\"\n              ng-click=\"confirmCreateCow()\">\n        Aceptar\n      </button>\n    </div>\n  </div>\n  <!--VACANES COW DIALOG-->\n  <div class=\"new-cow-create-confirm\"\n       ng-if=\"cow.category === \'crowdfunding\' && cow.is_public\">\n    <h3 class=\"text-center\"><b>¡Estás creando una Vaca en Vacanes!</b></h3>\n    <ul class=\"text-left\">\n      <li>Esto tiene un costo de <b>{{publicCowFee}}% + IVA</b> sobre el total recolectado.</li>\n      <li>Debes personalizar la <b>descripción e imagen</b> de la Vaca para que esta sea aprobada y publicada.</li>\n      <li>En la descripción debes agregar alguna <b>red social, número de teléfono y/o correo electrónico</b> de\n        contacto.\n      </li>\n      <li>Después de que se apruebe y publique tu Vaca, <b>NO</b> podrás modificarla.</li>\n      <li>El <b>valor recolectado y el número de participaciones</b> serán visibles para todo el público</li>\n    </ul>\n    <div class=\"new-cow-create-confirm-buttons text-center\">\n      <button id=\"cow_create_btn_submit\" class=\"button-action btn-sm\" style=\"font-size: 15px\"\n              ng-click=\"confirmCreateCow()\">\n        Aceptar\n      </button>\n    </div>\n  </div>\n  <!--CROWDFUNDING COW DIALOG-->\n  <div class=\"new-cow-create-confirm\"\n       ng-if=\"cow.category === \'crowdfunding\' && !cow.is_public\">\n    <h3 class=\"text-center\"><b>¡Estás creando una Vaca Social!</b></h3>\n    <ul class=\"text-left\">\n      <li>Esto tiene un costo de <b>{{businessCowFee}}% + IVA</b> sobre el total recolectado.</li>\n      <li>Tienes todas las funcionalidades del <b>Plan PRO</b> activas.</li>\n    </ul>\n    <div class=\"new-cow-create-confirm-buttons text-center\">\n      <button id=\"cow_create_btn_submit\" class=\"button-action btn-sm\" style=\"font-size: 15px\"\n              ng-click=\"confirmCreateCow()\">\n        Aceptar\n      </button>\n    </div>\n  </div>\n  <!--Pro COW DIALOG-->\n  <div class=\"new-cow-create-confirm\"\n       ng-if=\"(cow.category === \'group\' || cow.category === \'wallet\') && cow.plan === \'pro\'\">\n    <h3 class=\"text-center\"><b>¡Estás creando una Vaca Pro!</b></h3>\n    <h4 class=\"text-center\">Ten en cuenta que:</h4>\n    <ul class=\"text-left\">\n      <li>Esto tiene un costo de <b>{{businessCowFee}}% + IVA</b> sobre el total recolectado.</li>\n      <li>Tienes todas las funcionalidades del <b>Plan PRO</b> activas.</li>\n      <li ng-if=\"cow.cow_type === \'cobrar-negocio\'\"> Como la Vaca que estás creando es para fines comerciales, tiene\n        costo\n      </li>\n    </ul>\n    <div class=\"new-cow-create-confirm-buttons text-center\">\n      <button id=\"cow_create_btn_submit\" class=\"button-action btn-sm\" style=\"font-size: 15px\"\n              ng-click=\"confirmCreateCow()\">\n        Aceptar\n      </button>\n    </div>\n  </div></script><!-- NO USER DOCUMENT ALERT --><script type=text/ng-template id=noDocumentAlert><div class=\"ngdialog-message text-center\">\n    <h3>¡Hola!</h3>\n    <h4>Tan sólo un paso más. Para continuar usando Armatuvaca debes terminar de registrar tus datos</h4>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"acceptNoDocumentAlert(ngDialogData)\"></a>\n  </div></script>");
$templateCache.put("app/views/cowDeleted/cowDeleted.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Vaca eliminada</b></h1><p></p></div></div><div class=\"container-fluid background-color-white no-padding-left-right\"><div class=\"container margin-top-40\"><div class=row><div class=col-md-2><div class=\"text-center main-hiw-description\"><img class=\"img-circle img-hiw\" src=assets/images/how-it-works/step-4.png alt=img-home></div></div><div class=\"col-md-offset-1 col-md-9 margin-top-10\"><p>Lamentablente esta Vaca ha sido eliminada por su organizador.<br><br>No dudes en contactarnos si nos necesitas:<br><br>Correo: <a href=mailto:contacto@armatuvaca.com>contacto@armatuvaca.com</a><br><br>Teléfono: (+57) 300 7185815</p></div></div><div class=\"row text-center margin-bottom-20\"><div class=col-md-6><button class=\"btn btn-default button-action-white pull-right\" ng-click=goToHowItWorks()>¿Cómo funciona?</button></div><div class=col-md-6><button class=\"btn btn-default button-action-white pull-left\" ng-click=goToHome()>Ir al Inicio</button></div></div></div></div><atv-footer></atv-footer>");
$templateCache.put("app/views/cowEdit/cowEdit.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Edita tu Vaca</b></h1><p>¿Cambios de última hora? No hay problema</p></div></div><div class=\"container-fluid background-color-white no-padding-left-right\"><form class=margin-top-20 name=formCow novalidate ng-submit=updateCow(formCow.$valid)><div class=\"container col-md-8 col-md-offset-2\"><div class=\"row col-md-10 col-md-offset-1 margin-top-40\"><div class=required-text><p><b>*</b> Obligatorio</p></div><div><md-input-container class=\"col-md-12 col-xs-12 md-input-has-placeholder no-padding-left\" flex-gt-sm=\"\" md-is-error=\"formCow.cow_name.$invalid && formCow.$submitted\"><label class=font-size-18>Nombre de la Vaca</label><input id=cow_create_cow_name required type=text no-special-chars name=cow_name md-maxlength=50 ng-model=cow.name placeholder=\"Agrega acá el nombre de la Vaca\"><div ng-messages=formCow.cow_name.$error><div ng-message=required>Escribe el nombre de tu vaca</div></div></md-input-container><md-input-container class=\"col-md-12 col-md-offset-right-6 col-xs-12 no-padding-left margin-bottom-40\"><label>Tipo de la Vaca</label><md-select ng-model=cowTypeString ng-change=cowEventTypeChanged(cowTypeString)><md-option ng-repeat=\"cowType in cowEventTypesList | orderBy:\'priority\'\" ng-value=cowType>{{cowType.name}}</md-option></md-select></md-input-container><md-input-container class=\"col-md-12 col-md-offset-right-6 col-xs-12 no-padding-left\" flex-gt-sm=\"\" md-is-error=\"formCow.made_by.$invalid && formCow.$submitted\"><label class=font-size-18>Organizada por</label><input id=cow_create_made_by required type=text name=made_by md-maxlength=50 ng-model=cow.made_by placeholder=\"Agrega el nombre del organizador de la Vaca\"><div ng-messages=formCow.made_by.$error><div ng-message=required>Organizada por</div></div></md-input-container></div></div><div class=\"row padding-left-15-xs-sm padding-right-15-xs-sm col-md-10 col-md-offset-1 margin-bottom-20\"><div class=padding-right-15-xs-sm><div class=margin-bottom-20><h5 class=text-left><b>Participación / Contribución </b><i class=\"fa fa-info-circle tooltip-cow-option\" tooltip-placement=left uib-tooltip=\"Es el monto que cada participante aportará a la Vaca\" aria-hidden=true></i></h5></div><div class=\"col-md-4 col-sm-4 col-xs-4 participation-value-container\"><div class=\"col-sm-12 col-xs-12 col-md-12 no-padding-left-right margin-bottom-10\"><button type=button id=cow_create_participation_free ng-click=selectParticipationFree() class=participation-type-button ng-class=\"cow.participation_free ? \'participation-type-button-selected\' : \'participation-type-button-unselected\'\" uib-tooltip=\"El participante elegirá el monto de su contribución\" tooltip-placement=top tooltip-class=hidden-xs>Libre</button></div></div><div class=\"col-md-4 col-sm-4 col-xs-4 participation-value-container\"><div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left-right margin-bottom-10\"><button type=button id=cow_create_participation_suggested ng-click=selectParticipationSuggested() class=participation-type-button ng-class=\"cow.participation_suggested ? \'participation-type-button-selected\' : \'participation-type-button-unselected\'\" uib-tooltip=\"Sugierele un monto a pagar al participante\" tooltip-placement=top tooltip-class=hidden-xs>Sugerida</button></div><div class=\"col-md-12 col-sm-12 col-xs-12 pull-left no-padding-left-right\"><input ng-show=cow.participation_suggested id=cow_create_participant_value_suggested ng-model=cow.participant_value_suggested name=partipantSuggestedValue class=\"form-control-atv text-center\" placeholder=$ ui-money-mask=0 type=tel min=\"\" ng-focus=selectParticipationSuggestedFocus() ng-required=cow.participation_suggested ng-change=setParticipationValueExample(cow.participant_value_suggested)><p ng-show=\"formCow.$submitted && formCow.partipantSuggestedValue.$invalid && cow.participation_suggested\" class=\"validation-messages text-left\">Por favor ingresa el monto sugerido</p><p ng-show=\"formCow.$submitted && formCow.partipantSuggestedValue.$dirty && cow.participation_suggested && cow.participant_value_suggested < minPaymentValue\" class=validation-messages>El monto mínimo de participación es de {{minPaymentValue | currency:\"$\":\'0\'}} COP</p><p ng-show=\"formCow.$submitted && formCow.partipantSuggestedValue.$dirty && cow.participation_suggested && cow.participant_value_suggested > maxPaymentValue\" class=validation-messages>El monto máximo de participación es de {{maxPaymentValue | currency:\"$\":\'0\'}} COP</p></div></div><div class=\"col-md-4 col-sm-4 col-xs-4 participation-value-container\"><div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left-right margin-bottom-10\"><button type=button id=cow_create_participation_fixed ng-click=selectParticipationFixed() class=participation-type-button ng-class=\"cow.participation_fixed ? \'participation-type-button-selected\' : \'participation-type-button-unselected\'\" uib-tooltip=\"El participante debe aportar el valor que tú decidas\" tooltip-placement=top tooltip-class=hidden-xs>Fija</button><p ng-show=\"formCow.$submitted && (!cow.participation_suggested && !cow.participation_fixed && !cow.participation_free)\" class=validation-messages>Por favor selecciona un tipo de participación</p></div><div class=\"col-md-12 col-sm-12 col-xs-12 pull-left no-padding-left-right\"><input ng-show=cow.participation_fixed id=cow_create_participant_value_fixed ng-model=cow.participant_value_fixed name=partipantFixedValue class=\"form-control-atv text-center\" placeholder=$ ui-money-mask=0 type=tel min=\"\" ng-focus=selectParticipationFixedFocus() ng-required=cow.participation_fixed ng-change=setParticipationValueExample(cow.participant_value_fixed)><p ng-show=\"formCow.$submitted && formCow.partipantFixedValue.$invalid && cow.participation_fixed\" class=\"validation-messages text-left\">Por favor ingresa el monto fijo</p><p ng-show=\"formCow.$submitted && formCow.partipantFixedValue.$dirty && cow.participation_fixed && cow.participant_value_fixed < minPaymentValue\" class=validation-messages>El monto mínimo de participación es de {{minPaymentValue | currency:\"$\":\'0\'}} COP</p><p ng-show=\"formCow.$submitted && formCow.partipantFixedValue.$dirty && cow.participation_fixed && cow.participant_value_fixed > maxPaymentValue\" class=validation-messages>El monto máximo de participación es de {{maxPaymentValue | currency:\"$\":\'0\'}} COP</p></div></div></div></div><div class=\"row padding-left-15-xs-sm padding-right-15-xs-sm col-md-10 col-md-offset-1\"><div class=\"col-xs-12 col-sm-12 col-md-12 no-padding-left-right\"><div class=\"col-xs-12 col-sm-4 col-sm-offset-right-2 col-md-4 col-md-offset-right-2 no-padding-left margin-top-20\"><div class=date-picker-position><label class=label-date-picker ng-class=\"(cow.pay_limit_date)? \'font-color-blue\': \'font-color-gray\'\">Fecha límite de pago (Opcional)</label><md-input-container class=\"margin-top-3 no-margin-bottom\"><md-datepicker ng-model=cow.pay_limit_date md-placeholder=DD/MM/AAAA name=pay_limit_date></md-datepicker><div ng-messages=formCow.pay_limit_date.$error><div ng-message=valid>Fecha invalida</div></div></md-input-container></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 no-padding-left margin-top-20 no-margin-xs\"><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\"><label class=font-size-18>Meta de recolección (Opcional)</label><input id=cow_create_goal type=tel ui-money-mask=0 name=cow_goal ng-model=cow.cow_goal placeholder=\"Monto a recolectar\"></md-input-container></div></div><div class=margin-bottom-20><h4 class=\"text-left outline-color-white\" ng-init=\"isCollapsedMainImg=true\" ng-click=\"isCollapsedMainImg = !isCollapsedMainImg\"><b><i class=\"fa custom-icon-form\" ng-class=\"(isCollapsedMainImg)? \'fa-plus\': \'fa-minus\'\" aria-hidden=true></i> Personalizar Vaca</b></h4></div><div class=hidden-xs-sm uib-collapse=isCollapsedMainImg><div class=\"crop-area height-300-sm-xs\"><ui-cropper class=background-color-white image=main_img_raw area-type=rectangle aspect-ratio=1.3 result-image-size=\"{w: 1980,h: 550}\" result-image-format=image/jpeg result-image=main_img result-blob=blob_main_img url-blob=url_img></ui-cropper></div><div class=text-center><input class=\"center-item text-center opacity-0\" file-model=main_img_raw_file type=file id=fileInput accept=image/*> <button id=cow_create_change_image type=button class=\"btn btn-default button-action-small-pink file-button\" ng-click=clickChangeImageHeader()><i class=\"fa fa-picture-o margin-right-10\" aria-hidden=true></i>Cambiar imagen</button></div></div><div uib-collapse=isCollapsedMainImg><text-angular ng-model=cow.description name=demo-editor ng-attr-placeholder={{cow_type.description_placeholder}}></text-angular></div><div uib-collapse=isCollapsedMainImg><div class=\"col-xs-12 col-sm-4 col-sm-offset-right-2 col-md-4 col-md-offset-right-2 no-padding-left margin-top-20\"><div class=date-picker-position><label class=label-date-picker ng-class=\"(cow.event_date)? \'font-color-blue\': \'font-color-gray\'\">Fecha del evento</label><md-input-container class=\"margin-top-3 no-margin-bottom\"><!--<label>Fecha del evento</label>--><md-datepicker ng-model=cow.event_date md-max-date=maxDate md-placeholder=DD/MM/AAAA name=born_date></md-datepicker><div ng-messages=formCow.born_date.$error><div ng-message=valid>Fecha invalida</div></div></md-input-container></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 no-padding-left margin-top-20 no-margin-xs\"><md-input-container class=\"md-block md-input-has-placeholder\" flex-gt-sm=\"\"><label class=font-size-18>Nombre de la ubicación</label><input id=cow_create_location_name type=text name=location_name md-maxlength=50 ng-model=cow.location_name placeholder=Dónde></md-input-container></div><div class=\"col-xs-12 col-sm-6 col-md-12 no-padding-left-right-xs no-margin-xs\"><md-checkbox id=cow_create_add_map_bool ng-model=cow.show_location_point aria-label=\"Checkbox 1\">Añadir mapa</md-checkbox></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 no-padding-left-right margin-bottom-20\" ng-if=\"cow.show_location_point && !isCollapsedMainImg\"><script type=text/ng-template id=searchbox.tpl.html><input type=\"text\" placeholder=\"Dirección o Lugares\" class=\"form-control gmaps-input\"></script><ui-gmap-google-map center=map.center zoom=map.zoom><!--SEARCHBOX--><ui-gmap-search-box template=searchbox.template events=searchbox.events options=searchbox.options></ui-gmap-search-box><!--MARKER--><ui-gmap-marker coords=marker.coords options=marker.options events=marker.events idkey=marker.id></ui-gmap-marker></ui-gmap-google-map></div></div><div class=\"row padding-left-15-xs-sm padding-right-15-xs-sm col-md-10 col-md-offset-1 margin-bottom-20\"><div class=margin-bottom-20><h4 class=\"text-left outline-color-white\" ng-init=\"isCollapsedOptions=true\" ng-click=\"isCollapsedOptions = !isCollapsedOptions\"><b><i class=\"fa custom-icon-form\" ng-class=\"(isCollapsedOptions)? \'fa-plus\': \'fa-minus\'\" aria-hidden=true></i> Más opciones</b></h4></div><div uib-collapse=isCollapsedOptions><div class=\"col-md-12 no-padding-left\"><md-checkbox ng-model=cow.hide_participants_identity aria-label=\"Checkbox 1\">Quiero ocultar la identidad de los participantes de mi <b>Vaca</b>.</md-checkbox><i class=\"fa fa-info-circle tooltip-cow-option hidden-xs-sm\" tooltip-placement=left uib-tooltip=\"La identidad de los participantes no podra ser vista por terceros\" aria-hidden=true></i></div><div class=\"col-md-12 no-padding-left\"><md-checkbox ng-model=cow.hide_participant_amount aria-label=\"Checkbox 1\">No mostrar la cuota añadida por cada uno de mis amigos.</md-checkbox><i class=\"fa fa-info-circle tooltip-cow-option hidden-xs-sm\" tooltip-placement=left uib-tooltip=\"Nadie podra ver el monto aportado por tus participantes\" aria-hidden=true></i></div><div class=\"col-md-12 no-padding-left\"><md-checkbox ng-model=cow.hide_total_amount aria-label=\"Checkbox 1\">¡Shhh! Que nadie vea el monto final de la <b>Vaca</b>.</md-checkbox><i class=\"fa fa-info-circle tooltip-cow-option hidden-xs-sm\" tooltip-placement=left uib-tooltip=\"No se mostrará el monto recolectado por tu Vaca\" aria-hidden=true></i></div><div class=\"col-md-12 no-padding-left\"><md-checkbox ng-model=cow.no_notifications_email aria-label=\"Checkbox 1\">No quiero recibir notificaciones por email.</md-checkbox><i class=\"fa fa-info-circle tooltip-cow-option hidden-xs-sm\" tooltip-placement=left uib-tooltip=\"No te enviaremos notificaciones a tu correo sobre el estado de tu Vaca\" aria-hidden=true></i></div></div></div></div><div class=\"container col-md-8 col-md-offset-2 margin-top-20 margin-bottom-20 no-padding-left-right-md\"><button class=\"btn btn-default button-action-pink pull-left\" type=button ng-click=goToCowAdmin(cow.cow_event_id)><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</button> <button class=\"btn btn-default button-action pull-right\" type=submit>Actualizar</button></div></form></div><atv-footer></atv-footer>");
$templateCache.put("app/views/cowEventGiftCodeTermsAndConditions/cowEventGiftCodeTermsAndConditions.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Términos y Condiciones</b></h1></div></div><div class=\"container-fluid background-color-white\"><div class=container><div><div ng-bind-html=giftCode.terms_and_conditions></div></div></div></div><div class=container-fluid><atv-footer></atv-footer></div>");
$templateCache.put("app/views/cowGetMoney/cowGetMoney.html","<div><atv-navbar></atv-navbar></div><div ng-show=adminUser><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Sacar Plata</b></h1><p>Solicita el retiro de lo que tienes en la Vaca</p></div></div><div class=\"container-fluid background-color-white\" ng-show=\"cow_event.total_value_to_date_left == 0 && cow_event.total_value > 0\"><div class=\"container text-center\"><h3>¡Felicidades!<br>Has sacado todo lo que había en tu Vaca</h3><p>Esperamos que hayas disfrutado de toda tu experiencia con Armatuvaca.<br>A continuación puedes revisar el resumen de tus retiros.</p></div></div><div class=\"container-fluid background-color-white\" ng-show=cow_event.marketplace_cow_completed><div class=\"container text-center\"><h3>¡Felicidades!<br>Tu Vaca ha finalizado</h3><p>Has recolectado el monto total correspondiente a la meta de tu Vaca.<br>Te contactaremos para continuar con el proceso o si lo prefieres,<br>puedes comunicarte con el comercio para redimir tu Vaca por tu producto o experiencia.</p><p><b>Comercio: </b>{{cow_event.product.company.name}}<br><b>Teléfono: </b>{{cow_event.product.company.telephone}}<br><b>Email: </b>{{cow_event.product.company.email}}</p><button class=\"btn btn-default button-action-pink margin-bottom-20\" ng-click=goToCowAdmin(cow_event.cow_event_id)><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</button></div></div><div class=\"container-fluid background-color-white\" ng-if=\"cow_event.total_value>0 && !cow_event.marketplace_cow_completed\"><div class=\"container text-center\" ng-show=cow_event.marketplace><h3>¡Ten en cuenta!</h3><p>Esta Vaca fue creada para adquirir un producto/experiencia de nuestro Marketplace, así que tienes dos opciones:</p><p class=no-margin-bottom>Solicitar ahora una transferencia a tu cuenta bancaria <b>(un cargo adicional será cobrado)</b><br>Completar la meta de la Vaca y redimirla en tu producto/experiencia <b>(sin cargo adicional)</b></p></div><div class=container><div class=row><div class=\"col-md-8 col-md-offset-2 margin-top-20\"><div class=\"row padding-top-15\" layout-gt-sm=row ng-show=\"requests.length != 0\"><div class=\"col-md-12 no-padding-left-right\" ng-init=\"isCollapsedTable=false\"><h3 class=\"text-center no-outline\" ng-click=\"isCollapsedTable=!isCollapsedTable\">Retiros Anteriores <i class=fa ng-class=\"(isCollapsedTable)?\'fa-plus-circle\':\'fa-minus-circle\'\" aria-hidden=true></i></h3><h5 class=text-center>Monto total retirado: {{totalRecolectedAmount | currency:\"$\":\'0\'}}</h5></div></div><div class=\"row padding-left-right-top\" layout-gt-sm=row uib-collapse=isCollapsedTable ng-show=\"requests.length != 0\"><div class=\"col-md-12 no-padding-left-right\"><table class=table><thead><tr><th class=\"text-center hidden-xs\">Fecha</th><th class=text-center>Valor retiro</th><th class=\"text-center hidden-xs\">Costo retiro</th><th class=text-center>Destino</th><th class=text-center>Estado</th></tr></thead><tbody><tr ng-repeat=\"request in requests | orderBy:\'-creation_date\' track by $index\"><td class=\"hidden-xs text-center\">{{request.creation_date | date:\'longDate\'}}</td><td class=text-center>{{(request.total_value_to_date + request.atv_tax) | currency:\"$\":\'0\'}}</td><td class=\"text-center hidden-xs\" ng-if=!request.is_marketplace>{{request.atv_tax | currency:\"$\":\'0\'}}</td><td class=\"text-center hidden-xs\" ng-if=request.is_marketplace>{{0 | currency:\"$\":\'0\'}}</td><td class=text-center ng-if=\"request.cashout_type == bankTransferTypeCashout\">{{request.bank_account.bank.name}} {{request.bank_account.bank_account_number_last_digits}}</td><td class=text-center ng-if=\"request.cashout_type == reversalTypeCashout\">Reversión a tarjeta</td><td class=text-center ng-if=\"request.cashout_type == efectyTypeCashout\">Retiro Efecty</td><td ng-show=\"(request.status == 0 || request.status == 5)\" class=text-center><span class=\"badge badge-info\">{{request.is_marketplace ? \'Compra \' : null}}Creada</span></td><td ng-show=\"(request.status == 1 || request.status == 3 || request.status == 4)\" class=text-center><span class=\"badge badge-success\">{{request.is_marketplace ? \'Compra \' : null}}Aprobada</span><br><a ng-if=request.invoice_pdf href={{request.invoice_pdf}} target=_blank style=\"text-decoration: underline; color: dodgerblue; font-size: 12px\">Ver Factura</a></td><td ng-show=\"(request.status == 2 || request.status == 6)\" class=text-center><span class=\"badge badge-error\">{{request.is_marketplace ? \'Compra \' : null}}Rechazada</span></td><td ng-show=\"(request.status == 7)\" class=text-center><span class=\"badge badge-error\">{{request.is_marketplace ? \'Compra \' : null}}Cancelada</span></td></tr></tbody></table></div></div><div class=\"row no-padding\" ng-show=\"!cow_event.closed_money_request && !cow_event.closed_admin && totalAvailableAmount - ivaAtvTax > 0\"><div class=margin-top-bottom-20><h3 class=text-center>Elige como vas a sacar la plata</h3></div><div ng-show=!cowIsPlanPro><div class=row ng-click=upgradeCowToPro()><div class=\"col-md-4 col-sm-6 col-xs-6 no-outline\"><p class=\"payment-method-title font-color-gray\"><span class=\"font-size-18 font-color-gray fa fa-circle-thin\"></span> Retiro en punto <b>Efecty</b>, Transferencia a <b>Daviplata</b>, Transferencia a <b>Nequi</b></p></div><div class=\"col-md-2 col-md-offset-right-6 col-sm-6 col-xs-6\"><p class=\"payment-method-title text-center\">Pásate al plan<br><span class=\"font-size-30 font-color-atv\">PRO</span></p></div></div><hr></div><div ng-show=cowIsPlanPro><div class=row ng-click=\"selectCashoutMethod(\'efecty\')\" ng-show=efectyActive.active><div class=\"col-md-4 col-sm-6 col-xs-6 no-outline\"><p class=payment-method-title><span class=\"font-size-18 font-color-gray\" ng-class=\"(!selectedCashoutMethod.efecty)?\'fa fa-circle-thin\':\'fa fa-check-circle-o font-color-blue\'\"></span> Retiro en punto Efecty</p></div><div class=\"col-md-8 col-sm-6 col-xs-6\"><img class=\"img-responsive cashout-method-image-efecty no-outline\" src=assets/images/payment-methods/efecty.png alt=payment-methods ng-click=paymentMethodToPse() ng-class=\"(!selectedCashoutMethod.efecty)?\'filter-gray\':\'no-filter-gray\'\"></div></div><div uib-collapse=!selectedCashoutMethod.efecty class=\"row padding-left-right-bottom\"><div class=\"col-md-11 no-padding-left\"><p>El monto máximo que puedes retirar por Efecty al día es de <b>{{efectyCashoutMaxAmount | currency:\"$\":\'0\'}}</b>.<br><br>Al solicitar el retiro por este medio recibirás a tu <b>correo electrónico el CÓDIGO</b> para realizar el retiro en cualquier punto Efecty del país <a href=https://www.efecty.com.co/web/puntos-de-atencion target=_blank>(Ver puntos Efecty)</a>.<br><br><b class=text-red>IMPORTANTE:</b> El retiro lo puedes hacer tú o un tercero pero quien haga el retiro debe <b>llevar su documento de identidad</b> y <b>los datos deben coincidir con los registrados en el siguiente formulario</b>:</p></div><div class=\"col-md-12 no-padding-left\"><div layout-gt-sm=row id=efectyUserFormHeader><div class=\"col-md-12 padding-top-bottom-20\"><h3 class=\"text-center no-margin\">Datos de quien retira el dinero</h3><h5 class=text-center>(Tal como aparecen en el documento de identidad)</h5></div></div><form id=efectyUserForm name=efectyUserForm novalidate><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=100 md-is-error=\"efectyUserForm.first_name.$invalid && efectyUserForm.$submitted\"><label>Nombre</label><input required name=first_name md-maxlength=50 ng-model=efectyUser.given_names placeholder=\"Ingresa acá el nombre\"><div ng-messages=efectyUserForm.first_name.$error><div ng-message=required>Por favor ingresa el nombre.</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"efectyUserForm.last_name.$invalid && efectyUserForm.$submitted\"><label>Apellido 1</label><input required name=last_name md-maxlength=100 ng-model=efectyUser.surname_1 placeholder=\"Ingresa acá el primer apellido\"><div ng-messages=efectyUserForm.last_name.$error><div ng-message=required>Por favor ingresa primer apellido.</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"efectyUserForm.surname_2.$invalid && efectyUserForm.$submitted\"><label>Apellido 2</label><input required name=surname_2 md-maxlength=100 ng-model=efectyUser.surname_2 placeholder=\"Ingresa acá el segundo apellido\"><div ng-messages=efectyUserForm.surname_2.$error><div ng-message=required>Por favor ingresa el segundo apellido.</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=50 md-is-error=\"efectyUserForm.document_type.$invalid && efectyUserForm.$submitted\"><label>Tipo de documento</label><md-select name=document_type ng-model=efectyUser.document_type required><md-option ng-repeat=\"document in documentTypes\" ng-value=document.id>{{document.key_type_name}}</md-option></md-select><div ng-messages=efectyUserForm.document_type.$error multiple md-auto-hide=true><div ng-message=required>Por favor selecciona un tipo de documento</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom margin-top-35-sm-xs\" flex-gt-sm=50 md-is-error=\"efectyUserForm.document_number.$invalid && efectyUserForm.$submitted\"><label>N° de documento</label><input ng-model=efectyUser.document_number name=document_number type=tel pattern=[0-9]{1,15} only-digits required placeholder=\"Ingresa el número de documento\"><div ng-messages=efectyUserForm.document_number.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>El número de documento debe contener entre 6 y 15 caracteres numéricos</div></div></md-input-container><div ng-show=\"efectyUser.document_type==2\"><i class=\"fa fa-info-circle tooltip-document\" tooltip-placement=bottom uib-tooltip=\"Digita el numero NIT incluyendo dígito de verificación\" aria-hidden=true></i></div></div></form><button type=submit form=efectyUserForm class=\"btn btn-default button-action-small margin-bottom-20 pull-right\" ng-click=scrollToCreateRequestForm(efectyUserForm)>Continuar</button></div></div><hr ng-show=efectyActive.active><div class=row ng-click=\"selectCashoutMethod(\'daviplata\')\" ng-show=daviplataActive.active><div class=\"col-md-4 col-sm-6 col-xs-6 no-outline\"><p class=payment-method-title><span class=\"font-size-18 font-color-gray\" ng-class=\"(!selectedCashoutMethod.daviplata)?\'fa fa-circle-thin\':\'fa fa-check-circle-o font-color-blue\'\"></span> Transferencia a Daviplata</p></div><div class=\"col-md-8 col-sm-6 col-xs-6\"><img class=\"img-responsive cashout-method-image-efecty no-outline\" src=assets/images/payment-methods/daviplata.png alt=payment-methods ng-click=paymentMethodToPse() ng-class=\"(!selectedCashoutMethod.daviplata)?\'filter-gray\':\'no-filter-gray\'\"></div></div><div uib-collapse=!selectedCashoutMethod.daviplata class=\"row padding-left-right-bottom\"><div class=\"col-md-12 no-padding-left\"><div layout-gt-sm=row id=daviplataFormHeader><div class=\"col-md-12 padding-top-bottom-20\"><h3 class=\"text-center no-margin\">Datos de la cuenta Daviplata</h3></div></div><form id=daviplataForm name=daviplataForm novalidate><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=100 md-is-error=\"daviplataForm.holder_name.$invalid && daviplataForm.$submitted\"><label>Nombre Titular / Razón Social</label><input required name=holder_name md-maxlength=50 ng-model=daviplataAccount.bank_account_owner_name placeholder=\"Ingresa el nombre del titular\"><div ng-messages=daviplataForm.holder_name.$error><div ng-message=required>Por favor ingresa el nombre</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom margin-top-35-sm-xs\" flex-gt-sm=100 md-is-error=\"daviplataForm.account_number.$invalid && daviplataForm.$submitted\"><label>N° de Cuenta</label><input ng-model=daviplataAccount.bank_account_number name=account_number type=tel pattern=[0-9]{10,15} only-digits required placeholder=\"Ingresa el número de cuenta (Celular)\"><div ng-messages=daviplataForm.account_number.$error multiple md-auto-hide=true><div ng-message=required>El número de cuenta es obligatorio</div><div ng-message=pattern>El número de cuenta corresponde al número celular y debe contener sólo caracteres numéricos</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=50 md-is-error=\"daviplataForm.document_type.$invalid && daviplataForm.$submitted\"><label>Tipo de documento</label><md-select name=document_type ng-model=daviplataAccount.bank_account_owner_document_type required><md-option ng-repeat=\"document in documentTypes\" ng-value=document.id>{{document.key_type_name}}</md-option></md-select><div ng-messages=daviplataForm.document_type.$error multiple md-auto-hide=true><div ng-message=required>Por favor selecciona un tipo de documento</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom margin-top-35-sm-xs\" flex-gt-sm=50 md-is-error=\"daviplataForm.document_number.$invalid && daviplataForm.$submitted\"><label>N° de documento</label><input ng-model=daviplataAccount.bank_account_owner_document name=document_number type=tel pattern=[0-9]{1,15} only-digits required placeholder=\"Ingresa el número de documento\"><div ng-messages=daviplataForm.document_number.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>El número de documento debe contener entre 6 y 15 caracteres numéricos</div></div></md-input-container><div ng-show=\"daviplataAccount.document_type==2\"><i class=\"fa fa-info-circle tooltip-document\" tooltip-placement=bottom uib-tooltip=\"Digita el numero NIT incluyendo dígito de verificación\" aria-hidden=true></i></div></div></form><button type=submit form=daviplataForm class=\"btn btn-default button-action-small margin-bottom-20 pull-right\" ng-click=scrollToCreateRequestForm(daviplataForm)>Continuar</button></div></div><hr ng-show=daviplataActive.active><div class=row ng-click=\"selectCashoutMethod(\'nequi\')\" ng-show=nequiActive.active><div class=\"col-md-4 col-sm-6 col-xs-6 no-outline\"><p class=payment-method-title><span class=\"font-size-18 font-color-gray\" ng-class=\"(!selectedCashoutMethod.nequi)?\'fa fa-circle-thin\':\'fa fa-check-circle-o font-color-blue\'\"></span> Transferencia a Nequi</p></div><div class=\"col-md-8 col-sm-6 col-xs-6\"><img class=\"img-responsive cashout-method-image-efecty no-outline\" src=assets/images/payment-methods/nequi.png alt=payment-methods ng-click=paymentMethodToPse() ng-class=\"(!selectedCashoutMethod.nequi)?\'filter-gray\':\'no-filter-gray\'\"></div></div><div uib-collapse=!selectedCashoutMethod.nequi class=\"row padding-left-right-bottom\"><div class=\"col-md-12 no-padding-left\"><div layout-gt-sm=row id=nequiFormHeader><div class=\"col-md-12 padding-top-bottom-20\"><h3 class=\"text-center no-margin\">Datos de la cuenta Nequi</h3></div></div><form id=nequiForm name=nequiForm novalidate><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=100 md-is-error=\"nequiForm.holder_name.$invalid && nequiForm.$submitted\"><label>Nombre Titular / Razón Social</label><input required name=holder_name md-maxlength=50 ng-model=nequiAccount.bank_account_owner_name placeholder=\"Ingresa el nombre del titular\"><div ng-messages=nequiForm.holder_name.$error><div ng-message=required>Por favor ingresa el nombre</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom margin-top-35-sm-xs\" flex-gt-sm=100 md-is-error=\"nequiForm.account_number.$invalid && nequiForm.$submitted\"><label>N° de Cuenta</label><input ng-model=nequiAccount.bank_account_number name=account_number type=tel pattern=[0-9]{10,15} only-digits required placeholder=\"Ingresa el número de cuenta (Celular)\"><div ng-messages=nequiForm.account_number.$error multiple md-auto-hide=true><div ng-message=required>El número de cuenta es obligatorio</div><div ng-message=pattern>El número de cuenta corresponde al número celular y debe contener sólo caracteres numéricos</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=50 md-is-error=\"nequiForm.document_type.$invalid && nequiForm.$submitted\"><label>Tipo de documento</label><md-select name=document_type ng-model=nequiAccount.bank_account_owner_document_type required><md-option ng-repeat=\"document in documentTypes\" ng-value=document.id>{{document.key_type_name}}</md-option></md-select><div ng-messages=nequiForm.document_type.$error multiple md-auto-hide=true><div ng-message=required>Por favor selecciona un tipo de documento</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom margin-top-35-sm-xs\" flex-gt-sm=50 md-is-error=\"nequiForm.document_number.$invalid && nequiForm.$submitted\"><label>N° de documento</label><input ng-model=nequiAccount.bank_account_owner_document name=document_number type=tel pattern=[0-9]{1,15} only-digits required placeholder=\"Ingresa el número de documento\"><div ng-messages=nequiForm.document_number.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>El número de documento debe contener entre 6 y 15 caracteres numéricos</div></div></md-input-container><div ng-show=\"nequiAccount.document_type==2\"><i class=\"fa fa-info-circle tooltip-document\" tooltip-placement=bottom uib-tooltip=\"Digita el numero NIT incluyendo dígito de verificación\" aria-hidden=true></i></div></div></form><button type=submit form=nequiForm class=\"btn btn-default button-action-small margin-bottom-20 pull-right\" ng-click=scrollToCreateRequestForm(nequiForm)>Continuar</button></div></div><hr ng-show=nequiActive.active></div><div class=row ng-click=\"selectCashoutMethod(\'bankTransfer\')\" id=bankTransferFormHeader ng-show=bankTransferActive.active><div class=\"col-md-4 col-sm-6 col-xs-6 no-outline\"><p class=payment-method-title><span class=\"font-size-18 font-color-gray\" ng-class=\"(!selectedCashoutMethod.bankTransfer)?\'fa fa-circle-thin\':\'fa fa-check-circle-o font-color-blue\'\"></span> Transferencia a cuenta bancaria en Colombia</p></div><div class=\"col-md-8 col-sm-6 col-xs-6 text-center\"><img class=\"img-responsive payment-method-image-cc no-outline\" src=assets/images/payment-methods/bank_transfer.png alt=payment-methods ng-click=paymentMethodToCc() ng-class=\"(!selectedCashoutMethod.bankTransfer)?\'filter-gray\':\'no-filter-gray\'\"></div></div><div uib-collapse=!selectedCashoutMethod.bankTransfer><div ng-show=\"userBankAccounts.length == 0\"><h4 class=text-center>Aún no has registrado una cuenta bancaria</h4></div><br><p ng-show=\"userBankAccounts.length > 0\" style=\"text-align: center\"><small style=\"font-weight: bold\">Selecciona una cuenta bancaria</small></p><div ng-show=\"userBankAccounts.length > 0\"><!--<md-radio-group ng-change=\"checkedChanged(bankAccountId)\" ng-model=\"bankAccountId\">--><!--<md-radio-button value=\"{{b_account.id}}\" class=\"md-primary\"--><!--ng-repeat=\"b_account in userBankAccounts\">--><!--<div class=\"atv-bank-account-item\">--><!--<img ng-src=\"{{b_account.bank.logo}}\" alt=\"{{b_account.bank.name}}\">--><!--<div>--><!--<p class=\"atv-bank-account-item-name\">{{b_account.name}}</p>--><!--<p class=\"atv-bank-account-item-number\">{{b_account.bank_account_number}}</p>--><!--<p class=\"atv-bank-account-item-type\">--><!--{{b_account.bank_account_type === 0 ? \'Ahorros\': null}}--><!--{{b_account.bank_account_type === 1 ? \'Corriente\': null}}--><!--</p>--><!--</div>--><!--</div>--><!--</md-radio-button>--><!--</md-radio-group>--><md-input-container style=\"width: 100%;\n                max-width: 300px;margin: 0 auto 20px auto;padding: 0; display: block\"><md-select ng-model=bankAccountSelect.bankAccountId placeholder=\"Selecciona una cuenta bancaria\" ng-change=checkedChanged(bankAccountSelect.bankAccountId)><md-option ng-value=b_account.id ng-repeat=\"b_account in userBankAccounts\"><div class=atv-bank-account-item><img ng-src={{b_account.bank.logo}} alt={{b_account.bank.name}}><div><p class=atv-bank-account-item-name>{{b_account.name}}</p><p class=atv-bank-account-item-number>{{b_account.bank_account_number}} - <span class=atv-bank-account-item-type>{{b_account.bank_account_type === 0 ? \'Ahorros\' : null}} {{b_account.bank_account_type === 1 ? \'Corriente\' : null}}</span></p></div></div></md-option></md-select></md-input-container></div><!--<div class=\"row padding-15\" ng-show=\"userBankAccounts.length > 0\">--><!--<div class=\"col-md-8 col-md-offset-2 padding-left-right-8\">--><!--<div class=\"col-md-6 no-padding-left-right\" ng-repeat=\"b_account in userBankAccounts track by $index\">--><!--<md-list-item class=\"contact-item selected min-height-120 list-contact\">--><!--<img ng-src=\"{{b_account.bank.logo}}\" class=\"md-avatar\" alt=\"{{b_account.bank.name}}\">--><!--<div class=\"\">--><!--<h3>--><!--{{b_account.name}}</h3>--><!--<p>--><!--<span ng-if=\"b_account.bank_account_type === 0\">Ahorros</span>--><!--<span ng-if=\"b_account.bank_account_type === 1\">Corriente</span>--><!--{{b_account.bank_account_number}}--><!--</p>--><!--<md-checkbox ng-model=\"b_account.checked\" class=\"font-bold right-corner-item\"--><!--ng-change=\"checkedChanged(b_account)\"></md-checkbox>--><!--</md-checkbox>--><!--</div>--><!--</md-list-item>--><!--</div>--><!--</div>--><!--</div>--><div><new-bank-account-user></new-bank-account-user></div></div></div><form id=formCreateRequest name=formCreateRequest novalidate ng-show=anyCashoutMethodSelected()><div ng-show=\"!cow_event.closed_money_request && !cow_event.closed_admin && totalAvailableAmountWithTax > 0\"><div layout-gt-sm=row><div class=\"col-md-12 padding-top-20\"><h3 class=text-center>¿Cuánto vas a sacar?</h3></div></div><div layout-gt-sm=row ng-show=!$parent.parcial_value_bool><div class=\"col-md-12 padding-top-20 no-padding-left-right\"><table class=center-item><tr><td class=text-right>Monto total en la Vaca:</td><td><b class=\"margin-td-calculator-value font-size-initial\">{{totalAvailableAmount | currency:\"$\":0}}</b></td></tr><tr><td class=text-right>Monto disponible en la Vaca:</td><td><b class=\"pull-right font-size-initial font-color-atv\">{{(totalAvailableAmount) | currency:\"$\":0}}</b></td></tr></table><hr class=hr-calculator-summary></div></div><div layout-gt-sm=row ng-show=$parent.parcial_value_bool><div class=\"col-md-12 padding-top-20 no-padding-left-right\"><table class=center-item><tr><td class=text-right>Monto total en la Vaca:</td><td><b class=\"margin-td-calculator-value font-size-initial\">{{cow_event.total_value | currency:\"$\":0}}</b></td></tr><tr><td class=text-right>Monto disponible en la Vaca:</td><td><b class=\"pull-right font-size-initial font-color-atv\">{{(totalAvailableAmount - ivaAtvTax) | currency:\"$\":0}}</b></td></tr></table><hr class=hr-calculator-summary></div></div><div class=\"row padding-left-right-bottom font-size-12\" layout-gt-sm=row><div class=\"col-md-12 no-padding-left-right\"><p><strong>*</strong> Recuerda que si el valor que vas a sacar es menor al monto disponible en la Vaca, debes dejar un mínimo de {{minPartialLeft | currency:\"$\":\'0\'}} para tu siguiente retiro parcial.</p></div></div><div class=\"row padding-left-right-top\" layout-gt-sm=row ng-show=\"requests.length < 1\"><div class=\"col-md-12 no-padding-left-right\"><p>¡Con nuestro servicio, tú decides si sacas Todo o Parte de la Vaca!</p></div></div><div layout-gt-sm=row><p ng-show=\"!$parent.parcial_value_bool && !$parent.total_value_bool && formCreateRequest.$submitted\" class=validation-messages>Por favor, selecciona el tipo de retiro.</p></div><div layout-gt-sm=row><div class=\"col-md-12 padding-top-15 no-padding-left\" ng-show=\"totalAvailableAmount === cow_event.total_value\"><md-checkbox ng-model=$parent.total_value_bool class=font-bold ng-disabled=!cowIsPlanPro ng-change=totalValueChanged()>Retiro Total</md-checkbox></div></div><div layout-gt-sm=row><div class=\"col-md-12 no-padding-left\" ng-show=cowIsPlanPro><md-checkbox ng-model=$parent.parcial_value_bool class=font-bold ng-disabled=\"totalAvailableAmount < cow_event.total_value\" ng-change=partialValueChanged()>Retiro Parcial</md-checkbox></div><div class=\"col-md-12 no-padding-left\" ng-show=!cowIsPlanPro ng-click=upgradeCowToPro()><md-checkbox class=\"font-bold no-margin\" disabled>Retiro Parcial</md-checkbox><p class=\"text-underlined font-bold\">Para hacer retiros parciales pásate al plan <span class=font-color-atv>PRO</span></p></div></div><div layout-gt-sm=row ng-show=\"$parent.parcial_value_bool && (totalAvailableAmount < cow_event.total_value)\"><div class=\"col-md-12 no-padding-left\"><md-checkbox class=font-bold ng-model=$parent.retrieveAvailableBool ng-change=retrieveAvailableAmount($parent.money_request_value)>Retirar el saldo total</md-checkbox></div></div><div class=\"row padding-left-right-top\" layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\"><label>Monto que vas a sacar</label><input ng-model=$parent.money_request_value ng-change=changedMoneyRequestAmount() id=moneyRequestValueInput name=total_value ui-money-mask=0 type=tel required placeholder=$ ng-readonly=totalAmountReadOnly><p ng-show=\"money_request_value && money_request_value < minGetMoneyValue\" class=validation-messages>Mínimo puedes sacar {{minGetMoneyValue | currency:\"$\":\'0\'}}</p><p ng-show=\"money_request_value && money_request_value > totalAvailableAmountWithTax && $parent.parcial_value_bool\" class=validation-messages>Máximo puedes sacar {{totalAvailableAmountWithTax | currency:\"$\":\'0\'}}</p><p ng-show=\"selectedCashoutMethod.efecty && money_request_value && money_request_value > efectyCashoutMaxAmount\" class=validation-messages>Por Efecty máximo puedes sacar {{efectyCashoutMaxAmount | currency:\"$\":\'0\'}}</p><p ng-show=\"money_request_value && money_request_value > maxPartialRequest && money_request_value < totalAvailableAmountWithTax\n                      && $parent.parcial_value_bool\" class=validation-messages>Debes dejar mínimo {{minPartialLeft | currency:\"$\":\'0\'}} en la Vaca para tu siguiente retiro parcial o puedes retirar el saldo total</p></md-input-container></div><div class=\"row padding-left-right\" ng-show=fourbyThousandApplies><p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Impuesto 4x1000:</p><p class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right\">-{{fourByThousandTax | currency:\"$\":\'0\'}}</p><p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Recibirás:</p><p class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right font-color-atv font-size-18-non-small-mobile\">{{$parent.money_request_value - fourByThousandTax | currency:\"$\":\'0\'}}</p></div><div class=\"row padding-left-right\" ng-show=\"cashout_commission_value === 0 && !cowIsHighValue && !selectedCashoutMethod.efecty && cow_event.is_business && !fourbyThousandApplies\"><p class=\"no-margin no-padding col-md-4 col-xs-6 font-bold\">Impuesto 4x1000:</p><p class=\"no-margin no-padding col-md-2 col-xs-5 text-right\"><span class=\"font-line-through font-color-gray\">{{fourByThousandTax | currency:\"$\":\'0\'}} </span>$0</p><p class=\"no-margin no-padding font-color-gray font-size-12 col-md-12 col-xs-12\">¡Armatuvaca asume los costos transaccionales por ti!</p></div><div class=\"row padding-left-right\" ng-show=\"cashout_commission_value === 0 && (cowIsHighValue || selectedCashoutMethod.efecty) && !cow_event.is_business && !fourbyThousandApplies\"><p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Costos transaccionales:</p><p class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right\">-{{highValueCowCommission | currency:\"$\":\'0\'}}</p><p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Recibirás:</p><p class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right font-color-atv font-size-18-non-small-mobile\">{{$parent.money_request_value - highValueCowCommission | currency:\"$\":\'0\'}}</p></div><div class=\"row padding-left-right\" ng-show=\"cashout_commission_value > 0 && !fourbyThousandApplies\"><p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Costo de retiro:</p><p class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right\">-{{cashout_commission_value | currency:\"$\":\'0\'}}</p><p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">IVA:</p><p class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right\">-{{cashout_commission_tax_value | currency:\"$\":\'0\'}}</p><p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Recibirás:</p><p class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right font-color-atv font-size-18-non-small-mobile\">{{$parent.money_request_value - cashout_commission_value - cashout_commission_tax_value | currency:\"$\":\'0\'}}</p></div><!--              <div class=\"row padding-left-right\"--><!--                   ng-show=\"fourByThousandTax > 0 && !cow_event.is_business && !cowIsHighValue && !efectySelected && !cow_event.is_public\">--><!--                <p class=\"no-margin no-padding col-md-4 col-xs-6 font-bold\">Cobro 4x1000: </p>--><!--                <p class=\"no-margin no-padding col-md-2 col-xs-5 text-right\">--><!--                  <span class=\"font-line-through font-color-gray\">{{fourByThousandTax | currency:\"$\":\'0\'}} </span> $0--><!--                </p>--><!--                <p class=\"no-margin no-padding font-color-gray font-size-12 col-md-12 col-xs-12\">--><!--                  ¡ArmaTuVaca asume los costos transaccionales por ti!</p>--><!--              </div>--><!--              <div class=\"row padding-left-right\"--><!--                   ng-show=\"cow_event.is_business && !efectySelected && !cow_event.is_public\">--><!--                <p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Comisión ATV ({{businessCowPercentage}}% +--><!--                  IVA): </p>--><!--                <p class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right\">--><!--                  -{{businessCowCommission | currency:\"$\":\'0\'}}</p>--><!--                <p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Recibirás: </p>--><!--                <p--><!--                  class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right font-color-atv font-size-18-non-small-mobile\">--><!--                  {{$parent.money_request_value - businessCowCommission | currency:\"$\":\'0\'}}--><!--                </p>--><!--              </div>--><!--              <div class=\"row padding-left-right\"--><!--                   ng-show=\"!cow_event.is_business && cowIsHighValue && !accountUser.is_premium && !efectySelected\">--><!--                <p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Costos transaccionales: </p>--><!--                <p class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right\">--><!--                  -{{highValueCowCommission | currency:\"$\":\'0\'}}</p>--><!--                <p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Recibirás: </p>--><!--                <p--><!--                  class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right font-color-atv font-size-18-non-small-mobile\">--><!--                  {{$parent.money_request_value - highValueCowCommission | currency:\"$\":\'0\'}}--><!--                </p>--><!--              </div>--><!--              <div class=\"row padding-left-right\"--><!--                   ng-show=\"!cow_event.is_business && cowIsHighValue && accountUser.is_premium && !efectySelected\">--><!--                <p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Tarifa usuario premium: </p>--><!--                <p class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right\">--><!--                  -{{premiumUserCommission | currency:\"$\":\'0\'}}</p>--><!--                <p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Recibirás: </p>--><!--                <p--><!--                  class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right font-color-atv font-size-18-non-small-mobile\">--><!--                  {{$parent.money_request_value - premiumUserCommission | currency:\"$\":\'0\'}}--><!--                </p>--><!--              </div>--><!--              <div class=\"row padding-left-right\" ng-show=\"efectySelected && !cow_event.is_public\">--><!--                <p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Comisión retiro Efecty ({{efectyCashoutFee *--><!--                  100}}% + IVA): </p>--><!--                <p class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right\">--><!--                  -{{efectyCashoutCommission | currency:\"$\":\'0\'}}</p>--><!--                <p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Recibirás: </p>--><!--                <p--><!--                  class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right font-color-atv font-size-18-non-small-mobile\">--><!--                  {{$parent.money_request_value - efectyCashoutCommission | currency:\"$\":\'0\'}}--><!--                </p>--><!--              </div>--><!--              <div class=\"row padding-left-right\" ng-show=\"cow_event.is_public\">--><!--                <p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Comisión Vacanes ({{publicCowPercentage}}% +--><!--                  IVA): </p>--><!--                <p class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right\">--><!--                  -{{publicCowCommission | currency:\"$\":\'0\'}}</p>--><!--                <p class=\"no-margin no-padding col-md-4 col-xs-8 font-bold\">Recibirás: </p>--><!--                <p--><!--                  class=\"no-margin no-padding col-md-2 col-md-offset-right-6 col-xs-4 text-right font-color-atv font-size-18-non-small-mobile\">--><!--                  {{$parent.money_request_value - publicCowCommission | currency:\"$\":\'0\'}}--><!--                </p>--><!--              </div>--></div><div ng-show=\"!cow_event.closed_money_request && !cow_event.closed_admin && totalAvailableAmount - ivaAtvTax > 0\"><div layout-gt-sm=row><div class=\"col-md-12 padding-top-bottom-20\"><h3 class=text-center>Datos del Creador de la Vaca</h3><h5 class=text-center>(Tal como aparecen en el documento de identidad)</h5></div></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=100 md-is-error=\"formCreateRequest.first_name.$invalid && formCreateRequest.$submitted\"><label>Nombre</label><input required name=first_name md-maxlength=50 ng-model=$parent.accountUser.user.first_name placeholder=\"Agrega acá tu nombre\"><div ng-messages=formCreateRequest.first_name.$error><div ng-message=required>Por favor, digita tu nombre.</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"formCreateRequest.last_name.$invalid && formCreateRequest.$submitted\"><label>Apellido 1</label><input required name=last_name md-maxlength=100 ng-model=$parent.accountUser.user.last_name placeholder=\"Agrega acá tu primer apellido\"><div ng-messages=formCreateRequest.last_name.$error><div ng-message=required>Por favor, digita tu primer apellido.</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"formCreateRequest.surname_2.$invalid && formCreateRequest.$submitted\"><label>Apellido 2</label><input required name=surname_2 md-maxlength=100 ng-model=$parent.accountUser.surname_2 placeholder=\"Agrega acá tu segundo apellido\"><div ng-messages=formCreateRequest.surname_2.$error><div ng-message=required>Por favor, digita tu segundo apellido.</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=50 md-is-error=\"formCreateRequest.document_type.$invalid && formCreateRequest.$submitted\"><label>Tipo de documento</label><md-select name=document_type ng-model=accountUser.document_type required><md-option ng-repeat=\"document in documentTypes\" ng-value=document.id>{{document.key_type_name}}</md-option></md-select><div ng-messages=formCreateRequest.document_type.$error multiple md-auto-hide=true><div ng-message=required>Por favor selecciona un tipo de documento</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom margin-top-35-sm-xs\" flex-gt-sm=50 md-is-error=\"formCreateRequest.document_number.$invalid && formCreateRequest.$submitted\" ng-show=\"accountUser.document_type == 1 || accountUser.document_type == 2\"><label>N° de documento</label><input ng-model=$parent.accountUser.document_number name=document_number type=tel pattern=[0-9]{1,15} only-digits required placeholder=\"Agrega el número de documento\"><div ng-messages=formCreateRequest.document_number.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>El número de documento debe contener entre 6 y 15 caracteres numéricos</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom margin-top-35-sm-xs\" flex-gt-sm=50 md-is-error=\"formCreateRequest.document_full_number.$invalid && formCreateRequest.$submitted\" ng-show=\"accountUser.document_type == 3 || accountUser.document_type == 4\"><label>N° de documento</label><input ng-model=$parent.accountUser.document_full_number name=document_full_number ng-change=setDocumentNumber() ng-required=\"accountUser.document_type == 3 || accountUser.document_type == 4\" pattern=\"^(?=.*\\d).{1,15}\" only-alphanumeric placeholder=\"Agrega el número de documento\"><div ng-messages=formCreateRequest.document_full_number.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>El número de documento debe contener entre 6 y 15 caracteres alfanuméricos</div></div></md-input-container><div ng-show=\"accountUser.document_type==2\"><i class=\"fa fa-info-circle tooltip-document\" tooltip-placement=bottom uib-tooltip=\"Digita el numero NIT incluyendo dígito de verificación\" aria-hidden=true></i></div></div><div class=\"col-md-6 no-padding-left\"><div layout-gt-xs=row><div flex-gt-xs><h5 ng-class=\"(accountUser.born_date)? \'font-color-blue\': \'font-color-gray\'\" class=\"form-label-atv margin-top-bottom-4\"><b>Fecha de nacimiento</b></h5><md-input-container class=\"margin-top-3 no-margin-bottom\"><md-datepicker ng-model=accountUser.born_date md-max-date=maxDate md-placeholder=DD/MM/AAAA name=born_date required></md-datepicker><div ng-messages=formCreateRequest.born_date.$error><div ng-message=valid>Fecha invalida</div><div ng-message=required>Por favor, selecciona tu fecha de nacimiento</div></div></md-input-container></div></div></div><div class=\"col-md-6 no-padding-left margin-top-8\"><md-input-container class=\"md-block margin-top-35-sm-xs\" flex-gt-sm=\"\"><label>Número celular</label><input ng-model=$parent.accountUser.cellphone name=cellphone type=tel pattern=[0-9]{10,12} digits-no-indicative required placeholder=3196316557><div ng-messages=formCreateRequest.cellphone.$error multiple md-auto-hide=true><div ng-message-exp=\"[\'required\']\">Debes digitar tu número celular</div><div ng-message-exp=\"[\'pattern\']\">El número celular debe contener entre 10 y 12 números y contener solo caracteres numericos</div></div></md-input-container></div><div class=col-md-12><p ng-show=errorSended class=text-danger>{{errorMessage}}</p></div></div></form></div></div><div class=row ng-show=\"(accountUser.total_value_cash_out >= minGetMoneyValidationValue ||\n           cow_event.total_value >= minGetMoneyValidationValue) && !cow_event.closed_money_request &&\n           !cow_event.closed_admin && totalAvailableAmount - ivaAtvTax > 0 &&\n           (!accountUser.document_is_valid ||\n           (!accountUser.has_document_pdf && (!accountUser.has_document_image_front || !accountUser.has_document_image_back)))\"><div class=\"col-md-8 col-md-offset-2 col-sm-12 col-xs-12 text-center\"><h3 class=\"font-color-atv no-outline\" ng-click=\"isCollapsed=!isCollapsed\">Verificación de identidad <i class=fa ng-class=\"(isCollapsed)?\'fa-plus-circle\':\'fa-minus-circle\'\" aria-hidden=true></i></h3></div><div class=\"col-md-8 col-md-offset-2 col-sm-12 col-xs-12 text-justify\" uib-collapse=isCollapsed><p><b>ARMATUVACA.COM</b>, por temas legales, debe solicitar una justificación de identidad en el caso de que un Organizador decida usar el monto recolectado y este supere $500.000 (COP). En este caso, es necesario adjuntar por medio electrónico una copia del documento de identidad del Organizador de la Vaca, ya sea la Cédula de Ciudadanía para personas naturales o del RUT actualizado en caso de ser persona jurídica.</p></div><div class=\"col-md-8 col-md-offset-2\" uib-collapse=isCollapsed><div class=\"col-md-1 col-sm-1 col-xs-1 div-warning-kyc text-center\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i></div><div class=\"col-md-11 col-sm-10 col-xs-10\"><p class=text-justify>El nombre y número de documento en los documentos enviados deben coincidir con el nombre y número de documento del titular de la cuenta en Armatuvaca (y no con los del destinatario del dinero). Los documentos subidos a la página deben estar en formato pdf, jpg, jpeg o png.</p></div></div><div class=\"col-md-8 col-md-offset-2\"><div class=\"col-md-1 col-sm-1 col-xs-1 div-warning-kyc text-center\" uib-collapse=isCollapsed>><div class=icon-document><i class=\"fa fa-id-card\" aria-hidden=true></i></div></div><div class=\"col-md-11 col-sm-11 col-xs-11\"><div uib-collapse=isCollapsed><h4><b>DOCUMENTO DE IDENTIDAD / RUT</b><label class=\"margin-left-5 font-color-pink no-outline\" ng-click=showExample()><i class=\"fa fa-question-circle\" aria-hidden=true></i></label><label class=\"font-color-pink hidden-xs-sm no-outline font-size-13\" ng-click=showExample()>Ver un ejemplo</label></h4><p><i>Tu documento de identidad vigente (por delante y por detrás) con las cuatro esquinas visibles. Puedes subir la imagen frontal y trasera o un archivo pdf con las dos imagenes adjuntas.</i></p></div><div class=\"col-md-6 col-sm-12 col-xs-12 no-padding-left margin-top-20\"><p ng-click=showDocument(0) ng-show=accountUser.has_document_image_front><i class=\"fa fa-file-image-o\" aria-hidden=true></i> <u class=no-outline>Ver imagen frontal</u></p><button type=button name=button class=form-control ng-click=clickChangeDocumentImageFront()><i class=\"fa fa-cloud-upload font-color-blue\" aria-hidden=true></i> Subir imagen frontal</button> <input class=\"center-item text-center file-input-hidden\" file-model=accountUser.documentUserFrontFileMQ type=file id=fileInputImageFrontMQ accept=image/*></div><div class=\"col-md-6 col-sm-12 col-xs-12 no-padding-left margin-top-20\"><p ng-click=showDocument(1) ng-show=accountUser.has_document_image_back><i class=\"fa fa-file-image-o\" aria-hidden=true></i> <u class=no-outline>Ver imagen trasera</u></p><button type=button name=button class=form-control ng-click=clickChangeDocumentImageBack()><i class=\"fa fa-cloud-upload font-color-blue\" aria-hidden=true></i> Subir imagen trasera</button> <input class=\"center-item text-center file-input-hidden\" file-model=accountUser.documentUserBackFileMQ type=file id=fileInputImageBackMQ accept=image/*></div><div class=\"col-md-6 col-sm-12 col-xs-12 no-padding-left margin-top-20\"><p ng-click=showDocument(2) ng-show=accountUser.has_document_pdf><i class=\"fa fa-file-pdf-o\" aria-hidden=true></i> <u class=no-outline>Ver pdf adjuntado</u></p><button type=button name=button class=form-control ng-click=clickChangeDocumentPDF()><i class=\"fa fa-cloud-upload font-color-pink\" aria-hidden=true></i> Subir pdf</button> <input class=\"center-item text-center file-input-hidden\" file-model=accountUser.documentUserPDFFileMQ type=file id=fileInputPDFMQ accept=application/pdf></div></div></div></div><div class=\"row margin-top-20\"><div class=\"col-md-8 col-md-offset-2 center-text\"><button class=\"btn btn-default button-action-small-pink margin-bottom-20\" ng-click=goToCowAdmin(cow_event.cow_event_id) ng-show=!cow_event.closed_money_request><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</button> <button type=submit form=formCreateRequest ng-show=\"!cow_event.closed_money_request && !cow_event.closed_admin && totalAvailableAmountWithTax > 0\n                  && $parent.parcial_value_bool && anyCashoutMethodSelected()\" class=\"btn btn-default button-action-small margin-bottom-20 pull-right\" ng-click=\"formCreateRequest.$setDirty();sendRequest(formCreateRequest.$valid && (money_request_value <= totalAvailableAmountWithTax)\n                  && (money_request_value <= maxPartialRequest || money_request_value == totalAvailableAmountWithTax) &&\n                  (money_request_value >= minGetMoneyValue), efectyUserForm, daviplataForm, nequiForm)\"><i class=\"fa fa-money atv-icon\" aria-hidden=true></i>Enviar</button> <button type=submit form=formCreateRequest ng-show=\"!cow_event.closed_money_request && !cow_event.closed_admin && totalAvailableAmount > 0\n                  && $parent.total_value_bool && anyCashoutMethodSelected()\" class=\"btn btn-default button-action-small margin-bottom-20 pull-right\" ng-click=\"formCreateRequest.$setDirty();sendRequest(formCreateRequest.$valid && (money_request_value <= totalAvailableAmount) &&\n                  (money_request_value >= minGetMoneyValue), efectyUserForm, daviplataForm, nequiForm)\"><i class=\"fa fa-money atv-icon\" aria-hidden=true></i>Enviar</button></div></div></div></div><div class=\"container-fluid background-color-white padding-top-15 hidden-xs-sm\" ng-show=\"cow_event.closed_money_request || cow_event.marketplace_cow_completed\"><div class=\"container text-center\"><h3 class=padding-bottom-15>¿Qué esperas para seguir disfrutando de todos nuestros servicios?</h3><div class=main-hiw-content><div class=\"col-xs-4 col-sm-4 col-md-4 padding-bottom-20\"><div class=text-center><h4 class=hidden-xs-sm><a ui-sref=account href=\"\">Mi Cuenta</a></h4><p class=\"hidden-xs-sm padding-left-right-30\">Ingresa a tu cuenta y modifica tus datos,<br>opciones personales y mucho más.</p></div></div><div class=\"col-xs-4 col-sm-4 col-md-4 padding-bottom-20\"><div class=text-center><h4 class=hidden-xs-sm><a ui-sref=cow-create href=\"\">Armar otra Vaca</a></h4><p class=\"hidden-xs-sm padding-left-right-30\">¿Tienes otro evento en mente?<br>Arma ya tu siguiente Vaca.</p></div></div><div class=\"col-xs-4 col-sm-4 col-md-4 padding-bottom-20\"><div class=text-center><h4 class=hidden-xs-sm><a ui-sref=frecuently-asked-questions href=\"\">FAQ</a></h4><p class=\"hidden-xs-sm padding-left-right-30\">¿Tienes alguna duda?<br>Seguro tenemos una respuesta para ti.</p></div></div></div></div></div><div class=\"container-fluid background-color-white\" ng-show=\"cow_event.total_value==0\"><div class=container><h3 class=text-center>El monto acumulado de tu vaca es:</h3><h1 class=\"font-color-pink text-center\"><b>{{cow_event.total_value | currency:\"$\":\'0\'}}</b></h1><h4 class=text-center>1. Comparte tu Vaca para empezar a recibir participaciones</h4><h4 class=text-center>2. El dinero que recibas se mantendrá seguro en Armatuvaca</h4><h4 class=text-center>3. Cuando lo desees podrás sacar tu plata por cualquiera de los medios que ofrecemos</h4><button class=\"btn btn-default button-action-pink margin-bottom-20\" ng-click=goToCowAdmin(cow_event.cow_event_id)><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</button></div></div></div><div ng-show=!adminUser><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Administración de la Vaca</b></h1></div></div><div class=\"container-fluid background-color-white\"><div class=container><h3 class=text-center>Area restringida para el administrador</h3><div class=\"row col-md-6 text-center margin-bottom-20\"><h4 class=text-center>Si eres un invitado de la Vaca haz clic en el botón para ir a la pagina de invitados</h4><button class=\"btn btn-default button-action-small\" ng-click=goToPublicCow()><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Ir a la Vaca</button></div><div class=\"row col-md-6 margin-bottom-20\"><h4 class=text-center>Si eres el administrador de esta Vaca inicia sesión</h4><div class=\"row login-form-content col-md-offset-2 col-md-8\"><div class=social-login><div><a class=\"btn btn-block btn-social btn-facebook facebook-button\" ng-click=loginFb()><span class=\"fa fa-facebook\"></span> Ingresa con Facebook</a></div><div class=google-social><a class=\"btn btn-block btn-social btn-google google-button\" ng-click=loginGg()><span class=\"fa fa-google\"></span> Ingresa con Google</a></div></div><div class=email-login><form name=loginForm ng-submit=loginUser(loginForm.$valid) novalidate><h3 class=text-center>Iniciar sesión</h3><md-input-container class=md-block flex-gt-sm=\"\"><label>Correo</label><input required name=email maxlength=100 ng-model=user.email type=email><div ng-messages=loginForm.email.$error><div ng-message=required>Por favor, digita tu correo.</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\"><label>Contraseña</label><input required name=password maxlength=100 minlength=8 ng-model=user.password type=\"{{(show_password)? \'text\': \'password\'}}\"><div ng-messages=loginForm.password.$error><div ng-message=required>Por favor, digita tu contraseña.</div><div ng-message=minlength>Tu contraseña debe ser mínimo de 8 caracteres.</div></div></md-input-container><div class=\"col-md-6 no-padding-left\"><a href=\"\" ui-sref=forgot-password>Ohh no ¿Olvidaste tu contraseña?</a></div><div class=\"col-md-6 text-right\">¿Eres nuevo? Ingresa <b><a ui-sref=register href=\"\">aquí</a></b></div><p ng-show=errorSended class=\"text-danger login-error-msg\">{{errorMessage}}</p><button class=\"btn btn-default pull-right button-action-small\" type=submit>Iniciar sesión</button></form></div></div></div></div></div></div><div><atv-footer></atv-footer></div><script type=text/ng-template id=confirmationCloseGetMoneyRequestModal-1><div class=\"ngdialog-message text-center\">\n    <h3 class=\"\" ng-show=\"ngDialogData.total_value_bool\">¿Estás seguro que deseas\n      solicitar\n      todo tu dinero ({{ngDialogData.money_request_value | currency:\"$\":0}})? Una vez creada tu solicitud no podrás\n      recibir mas participaciones para esta Vaca</h3>\n    <h3 class=\"\" ng-show=\"ngDialogData.parcial_value_bool &&\n      (ngDialogData.money_request_value == ngDialogData.totalAvailableAmount - ngDialogData.ivaAtvTax)\">\n      ¿Estás seguro que deseas solicitar el saldo total ({{ngDialogData.money_request_value | currency:\"$\":0}})?\n      Una vez creada la solicitud no podrás recibir mas participaciones para esta Vaca</h3>\n    <h3 class=\"\" ng-show=\"ngDialogData.parcial_value_bool &&\n      (ngDialogData.money_request_value != ngDialogData.totalAvailableAmount - ngDialogData.ivaAtvTax)\">\n      ¿Estás seguro que deseas crear una solicitud de retiro\n      parcial por {{ngDialogData.money_request_value | currency:\"$\":0}}?</h3>\n    <p ng-show=\"ngDialogData.selectedCashoutMethod.bankTransfer\">\n      Se va a enviar este dinero a la cuenta <b>{{ngDialogData.bankAccountSelected.bank_account_number}}</b> de\n      <b>{{ngDialogData.bankAccountSelected.bank.name}}</b>\n      <img src=\"{{ngDialogData.bankAccountSelected.bank.logo}}\" alt=\"\" width=\"25px\"> a nombre de\n      <b>{{ngDialogData.bankAccountSelected.bank_account_owner_name}}</b>\n    </p>\n    <p ng-show=\"ngDialogData.selectedCashoutMethod.nequi\">\n      Se va a enviar este dinero a la cuenta <b>{{ngDialogData.nequiAccount.bank_account_number}}</b> de\n      <b>{{ngDialogData.nequiAccount.bank.name}}</b>\n      <img src=\"assets/images/payment-methods/nequi.png\" alt=\"\" width=\"80px\"> a nombre de\n      <b>{{ngDialogData.nequiAccount.bank_account_owner_name}}</b>\n    </p>\n    <p ng-show=\"ngDialogData.selectedCashoutMethod.daviplata\">\n      Se va a enviar este dinero a la cuenta <b>{{ngDialogData.daviplataAccount.bank_account_number}}</b> de\n      <b>{{ngDialogData.daviplataAccount.bank.name}}</b>\n      <img src=\"assets/images/payment-methods/daviplata.png\" alt=\"\" width=\"90px\"> a nombre de\n      <b>{{ngDialogData.daviplataAccount.bank_account_owner_name}}</b>\n    </p>\n    <p ng-show=\"ngDialogData.selectedCashoutMethod.efecty\">\n      Se va a enviar este dinero a <b>{{ngDialogData.efectyUser.given_names}} {{ngDialogData.efectyUser.surname_1}}\n      {{ngDialogData.efectyUser.surname_2}}</b> con número de documento\n      <b>{{ngDialogData.efectyUser.document_number}}</b>\n      mediante <img src=\"assets/images/payment-methods/efecty.png\" alt=\"\" width=\"80px\"><br>\n      <span style=\"font-style: italic; font-size: 11px\">Recuerda que recibirás a tu <b>correo electrónico el CÓDIGO</b> para realizar el retiro</span>\n    </p>\n    <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeSecond(ngDialogId)\"></a>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"confirmationGetMoneyRequest()\"></a>\n  </div></script><script type=text/ng-template id=dialog.document.example.tmpl.html><md-dialog aria-label=\"Ejemplo\">\n    <form ng-cloak>\n      <md-dialog-content>\n        <div class=\"md-dialog-content\">\n          <h2 class=\"text-center font-color-atv mayus\">\n            Documento de Identidad</h2>\n          <p class=\"text-center text-underline\">\n            <u>Recuerda :</u>\n          </p>\n          <p class=\"text-center\">\n            Tu documento de identidad debe estar en\n            <b>período de validez, por las dos caras y con los cuatro ángulos bien visibles</b>\n          </p>\n          <img class=\"img-example\" alt=\"ejemplo documento de identidad\" src=\"assets/images/utils/cc-example.jpg\">\n        </div>\n      </md-dialog-content>\n      <md-dialog-actions layout=\"row\">\n        <md-button ng-click=\"cancel()\">\n          Cerrar\n        </md-button>\n      </md-dialog-actions>\n    </form>\n  </md-dialog></script><script type=text/ng-template id=dialog.document.tmpl.html><md-dialog aria-label=\"Ejemplo\">\n    <form ng-cloak>\n      <md-dialog-content>\n        <div class=\"md-dialog-content\">\n          <img class=\"img-example\" alt=\"ejemplo documento de identidad\" ng-if=\"documentFileShow==0\"\n               ng-src=\"{{accountUser.document_image_front}}\">\n          <img class=\"img-example\" alt=\"ejemplo documento de identidad\" ng-if=\"documentFileShow==1\"\n               ng-src=\"{{accountUser.document_image_back}}\">\n          <div id=\"pdf\" ng-if=\"documentFileShow==2\">\n            <object width=\"700\" height=\"500\" type=\"application/pdf\" data=\"{{accountUser.document_pdf}}\"\n                    id=\"pdf_content\">\n              <p>\n                Tu navegador web no tiene soporte de un complemento de PDF. En su lugar, puedes\n                <a target=\"_blank\" href=\"{{accountUser.document_pdf}}\">\n                  hacer clic aquí para descargar el archivo.\n                </a>\n              </p>\n            </object>\n          </div>\n        </div>\n      </md-dialog-content>\n      <md-dialog-actions layout=\"row\">\n        <md-button ng-click=\"cancel()\">\n          Cerrar\n        </md-button>\n      </md-dialog-actions>\n    </form>\n  </md-dialog></script><script type=text/ng-template id=moneyRequestSuccessModal-1><div class=\"ngdialog-message text-center\">\n    <h3 class=\"\" ng-show=\"!ngDialogData.selectedCashoutMethod.efecty\">¡Felicidades! <br>\n      Tu solicitud se ha creado con éxito. Recuerda que debes esperar entre 1 y 2 días hábiles para recibir tu dinero.\n    </h3>\n    <h3 class=\"\" ng-show=\"ngDialogData.selectedCashoutMethod.efecty\">¡Felicidades! <br>\n      Tu solicitud se ha creado con éxito. Cuando sea aprobada recibirás en tu correo electrónico el CÓDIGO con el que\n      puedes\n      reclamar tu dinero en cualquier punto Efecty.\n    </h3>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"closeSuccessConfirmation(ngDialogId)\"></a>\n  </div></script><script type=text/ng-template id=confirmationDocumentValidated><div class=\"ngdialog-message text-center\">\n    <h3 ng-show=\"ngDialogData.type === \'ImageFront\'\">\n      ¿Estás seguro que la imagen que adjuntaste corresponde a la parte frontal de un documento de identidad válido?\n    </h3>\n    <h3 ng-show=\"ngDialogData.type === \'ImageBack\'\">\n      ¿Estás seguro que la imagen que adjuntaste corresponde a la parte trasera de un documento de identidad válido?\n    </h3>\n    <h3 ng-show=\"ngDialogData.type === \'PDF\'\">\n      ¿Estás seguro que el pdf que adjuntaste corresponde a un documento de identidad válido?\n    </h3>\n    <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeDocumentConfirmation(ngDialogId)\"></a>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"acceptDocumentValidation(ngDialogData)\"></a>\n  </div></script><script type=text/ng-template id=upgradeCowToProModal><div class=\"ngdialog-message text-center\">\n    <h4>\n      ¡No tan rápido!<br>Está opción está activa solo para <strong>Vacas PRO</strong><br>Cambia de plan y recibe todos\n      los beneficios:\n    </h4>\n    <ul class=\"text-left list-style-ckeck-color\">\n      <li>Retiros a Efecty, Nequi, Daviplata</li>\n      <li>Retiros parciales de dinero</li>\n      <li>Recibe pagos con tarjeta de crédito</li>\n      <li>Vaca sin topes máximos</li>\n      <li>Personaliza tu Vaca</li>\n      <li>Descarga el reporte en Excel de tu Vaca</li>\n    </ul>\n    <button id=\"upgradeCowToProButton\" class=\"button-action btn-sm\" style=\"font-size: 15px\"\n            ng-click=\"acceptUpgradeCowToPro()\">\n      Quiero ser PRO\n    </button>\n  </div></script><script type=text/ng-template id=confirmCowToProModal><div class=\"ngdialog-message text-center\">\n    <h4>\n      Este cambio implica un costo de <strong>{{businessCowFee}}% + IVA</strong> sobre el valor que recolectes en tu\n      Vaca.\n      Una vez hagas el cambio <strong>no</strong> puedes volver al plan básico.\n    </h4>\n    <h4>¿Estás de acuerdo con esto?</h4>\n    <button id=\"acceptCowToProModal\" class=\"button-action btn-sm\" style=\"font-size: 15px\"\n            ng-click=\"confirmUpgradeCowToPro()\">\n      ¡Sí! Estoy de acuerdo\n    </button>\n  </div></script>");
$templateCache.put("app/views/cowGetMoneyToken/cowGetMoneyToken.html","<div><atv-navbar></atv-navbar></div><div><!--En caso de que ya sacaran el dinero--><div class=cow-token-request ng-if=\"tokenInfo === 0\"><div class=\"cow-token-request-icon error\"><i class=\"fa fa-times\" aria-hidden=true></i></div><div class=cow-token-request-title><p>Dinero retirado</p></div><div class=cow-token-request-subtitle><p>Lo sentimos. El dinero ya no se encuentra disponible</p></div><div class=cow-token-request-subtitle><p>Si consideras que esto es un error, por favor ponte en contacto con nosotros.</p></div></div><!-- Si no han sacado el dinero y el que envia no ha pagado--><div class=cow-token-request ng-if=\"tokenInfo !== 0 && tokenInfo.cow_event.total_value_to_date_left === 0\"><div class=cow-token-request-icon><i class=\"fa fa-clock-o\" aria-hidden=true></i></div><div class=cow-token-request-title><p><b>{{tokenInfo.cow_event.made_by}}</b> te está enviando dinero...</p></div><div class=cow-token-request-subtitle><p>Estamos esperando la confirmacion del pago para que puedas retirar tu dinero</p></div><div class=cow-token-request-subtitle><p>Ten en cuenta las siguientes recomendaciones:</p></div><ul class=cow-token-request-prompts><li>No compartas este link con otras personas.</li><li>Ingresa al link en unos minutos para verificar si el pago fue realizado.</li></ul></div><!-- Si no han sacado el dinero y el que envia ya pago--><div class=cow-token-request ng-if=\"tokenInfo !== 0 && tokenInfo.cow_event.total_value_to_date_left > 0\"><div class=cow-token-request-icon><i class=\"fa fa-money\" aria-hidden=true></i></div><div class=cow-token-request-title><p>¡Muuuy bien! <b>{{tokenInfo.cow_event.made_by}}</b> te ha enviado<br><b>{{tokenInfo.cow_event.total_value_to_date_left | currency:\"$\":\'0\'}} COP</b></p></div><div class=cow-token-request-subtitle><p>Ten en cuenta las siguientes recomendaciones al recibir tu dinero:</p></div><ul class=cow-token-request-prompts><li>No compartas este link con otras personas.</li><li>Verifica que todos los datos ingresados son correctos.</li><li ng-if=\"tokenInfo.via ===4\">Se te descontara <b>{{fourByThousand | currency:\"$\":\'0\'}} COP </b>debido al <b>4x1000</b>.</li><li ng-if=\"tokenInfo.via ===4\">Recibiras <b>{{tokenInfo.cow_event.total_value_to_date_left-fourByThousand | currency:\"$\":\'0\'}} COP.</b></li></ul><div class=cow-token-request-subtitle><p style=\"margin: 0\">¿Cómo quieres recibir tu dinero?</p><p style=\"margin: 0; color: grey\"><small>Selecciona una opción:</small></p></div><!--Transfer Options--><ul class=cow-token-request-methods><li ng-show=bankTransferActive.active ng-click=\"selectCashoutMethod(\'bankTransfer\')\"><img src=assets/images/payment-methods/bank_transfer.png><p>Transferencia a cuenta bancaria en Colombia</p></li></ul><!--Bank Transfer Section--><form class=cow-token-request-banktransfer ng-show=selectedCashoutMethod.bankTransfer name=formNewBankAccount id=formNewBankAccount ng-submit=\"createBankTransfer(formNewBankAccount.$valid && confirm_account_number == bankAccountInfo.bank_account_number)\" novalidate style=\"width: 90%; margin: 0 auto\"><hr style=\"margin: 20px auto\"><div><label>Nombre personalizado</label><br><md-input-container md-no-float><input id=account_bank_account_name type=text name=name ng-model=bankAccountInfo.name placeholder=\"Mi cuenta bancaria\" md-maxlength=50 required><div ng-messages=formNewBankAccount.name.$error><div ng-message=required>Dale un nombre a tu cuenta</div></div></md-input-container></div><div><label>Nombre del titular / Razón social</label><br><md-input-container md-no-float><input id=account_bank_account_owner_name required type=text name=bank_account_owner_name ng-model=bankAccountInfo.bank_account_owner_name placeholder=\"Escribe el nombre del titular de la cuenta\" md-maxlength=50><div ng-messages=formNewBankAccount.bank_account_owner_name.$error><div ng-message=required>El nombre del titular es obligatorio</div></div></md-input-container></div><div><md-input-container><md-select-header><span class=select-title>Tipo de documento</span></md-select-header><md-select ng-model=bankAccountInfo.bank_account_owner_document_type aria-label=\"Document Type\" style=\"width: 100%\" name=bank_account_owner_document_type><md-option ng-repeat=\"document in documentTypes\" value={{document.id}}>{{document.key_type_name}}</md-option></md-select></md-input-container></div><br><div ng-show=\"bankAccountInfo.bank_account_owner_document_type == 1 ||\n                                    bankAccountInfo.bank_account_owner_document_type == 2\"><label ng-show=\"bankAccountInfo.bank_account_owner_document_type == 1\">N° de cédula</label><label ng-show=\"bankAccountInfo.bank_account_owner_document_type == 2\">NIT (Con dígito de verificación)</label><md-input-container md-no-float><input ng-model=bankAccountInfo.bank_account_owner_document name=bank_account_owner_document type=tel pattern=[0-9]{1,15} only-digits required placeholder=\"Ingresa el N° de documento\"><div ng-messages=formNewBankAccount.bank_account_owner_document.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>Sólo se aceptan números con una longitud entre 6 y 10 dígitos</div></div></md-input-container></div><div ng-show=\"bankAccountInfo.bank_account_owner_document_type == 3 ||\n                                    bankAccountInfo.bank_account_owner_document_type == 4\"><label ng-show=\"bankAccountInfo.bank_account_owner_document_type == 3\">N° de cédula</label><label ng-show=\"bankAccountInfo.bank_account_owner_document_type == 4\">N° de pasaporte</label><md-input-container md-no-float><input ng-model=bankAccountInfo.bank_account_owner_document_full name=bank_account_owner_document_full ng-change=setDocumentNumber() ng-required=\"bankAccountInfo.bank_account_owner_document_type == 3 ||\n                                    bankAccountInfo.bank_account_owner_document_type == 4\" pattern=\"^(?=.*\\d).{1,15}\" only-alphanumeric placeholder=\"Ingresa el N° de documento\"><div ng-messages=formNewBankAccount.bank_account_owner_document_full.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>El número debe contener entre 6 y 10 caracteres alfanuméricos</div></div></md-input-container></div><div><md-input-container><md-select-header><span class=select-title>Banco</span></md-select-header><md-select ng-model=bankAccountInfo.bank aria-label=Bank style=\"width: 100%\" name=bank><md-option ng-repeat=\"bank in banksList\" value={{bank.id}}>{{bank.name}}</md-option></md-select></md-input-container></div><div><md-input-container><md-select-header><span class=select-title>Tipo de cuenta</span></md-select-header><md-select ng-model=bankAccountInfo.bank_account_type aria-label=\"Bank Account Type\" style=\"width: 100%\" name=bank_type><md-option value=0>Ahorros</md-option><md-option value=1>Corriente</md-option></md-select></md-input-container></div><div><label>N° cuenta bancaria</label><br><md-input-container md-no-float><input id=account_bank_account_number required type=tel name=bank_account_number ng-model=bankAccountInfo.bank_account_number placeholder=555457889523 pattern=[0-9]{8,16} only-digits-string><div ng-messages=formNewBankAccount.bank_account_number.$error><div ng-message=required>El número de cuenta es obligatorio</div><div ng-message=pattern>Debe tener entre 8 y 16 dígitos</div></div></md-input-container></div><div><label>Confirma tu N° de cuenta</label><br><md-input-container md-no-float><input id=account_bank_account_confirm_number required type=tel name=confirm_account_number ng-model=confirm_account_number placeholder=555457889523 pattern=[0-9]{8,16} only-digits><p ng-show=\"confirm_account_number != bankAccountInfo.bank_account_number\" class=validation-messages>El número de cuenta debe coincidir.</p><div ng-messages=formNewBankAccount.confirm_account_number.$error><div ng-message=required>Confirma tu número de cuenta</div><div ng-message=pattern>Debe tener entre 8 y 16 dígitos</div></div></md-input-container></div><button id=account_bank_account_submit class=\"btn btn-default button-action-small\" type=submit>Realizar Transferencia</button></form></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/cowGetMoneyToken/successMoneyTokenRequest.html","<div class=createWalletCollectFriendCowDialog><div class=\"createWalletCollectFriendCowDialog-icon text-center\"><i class=\"fa fa-money\"></i></div><div style=\"margin: 10px 0\"><p style=\"font-size: 16px; font-weight: 500; margin: 0; text-align: center\">!Muuuy Bien! la recolección fue realizada satisfactoriamente</p><p style=\"text-align: center; margin-top: 20px\">De <strong>1 a 2 dias hábiles</strong> recibiras el dinero en tu cuenta</p><p style=\"text-align: center\"><small>¡No olvides registrarte en Armatuvaca.com, la nueva forma de hacer Vacas online!</small></p><div style=\"text-align: center\"><button id=login_btn_submit class=button-action ng-click=closeDialog()>Continuar</button></div></div></div>");
$templateCache.put("app/views/cowInvite/cowInvite.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Invitar</b></h1><p>Aquí puedes invitar a tus amigos a que se unan a la Vaca.</p></div></div><div class=\"container-fluid background-color-white\"><div class=\"container form-group hidden-xs hidden-sm margin-top-20\"><div class=\"col-md-6 col-md-offset-3\"><input id=cow_link type=text name=link ng-model=cowPublicURLCompleteCopy class=\"form-control text-center\"><div class=\"col-md-4 col-md-offset-2 padding-5\"><button type=button name=button class=\"form-control no-padding\" ngclipboard data-clipboard-target=#cow_link ng-click=copyLink()><i class=\"fa fa-clone\" aria-hidden=true></i> Copiar link</button></div><div class=\"col-md-4 padding-5\"><button type=button name=button class=\"form-control no-padding\" ng-click=openQR()><i class=\"fa fa-qrcode font-size-18\" aria-hidden=true></i> Código QR</button></div></div></div><div class=\"container margin-top-20 margin-bottom-20 text-center visible-xs visible-sm\"><div><cow-share cow=cow></cow-share></div></div><p class=\"container margin-bottom-20 text-center\">Comparte este link con tus invitados o utiliza las demás opciones que te ofrecemos a continuación</p><div class=\"container tabs-content no-padding-left-right\"><div class=\"row visible-xs-sm\"><div class=\"padding-left-15 padding-right-15 text-center no-outline\" ng-init=\"menuTabsCollapse=true; tabSelected=0\" ng-click=\"menuTabsCollapse = !menuTabsCollapse\"><h4 class=menu-mobile-invite><i class=fa ng-class=\"(menuTabsCollapse)?\'fa-plus-circle\':\'fa-minus-circle\'\" aria-hidden=true></i> {{titleList[tabSelected]}}</h4></div><div class=\"padding-left-15 padding-right-15 div-menu-invite\" uib-collapse=menuTabsCollapse><div ng-repeat=\"title in titleList track by $index\"><p class=\"margin-top-10 no-outline\" ng-click=onTabChanges($index)><i class=fa ng-class=\"($index!=tabSelected)?\'fa-plus-circle\':\'fa-minus-circle\'\" aria-hidden=true></i> {{title}}</p></div></div></div><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-center-tabs=true><md-tab label=Correos md-active=\"tabSelected == 0\"><md-content class=md-padding><div class=\"row margin-bottom-20 padding-left-15 padding-right-15\"><h3>Correos</h3><textarea name=emails ng-model=textEmails rows=2 cols=40 class=\"form-control no-resize\" placeholder=leonardo@davinci.co></textarea><p>Separa tus direcciones por , (coma) o ; (punto y coma)</p></div><div class=row><button type=button class=\"center-item btn btn-default button-action-small-pink file-button\" ng-click=addEmails()>Agregar correos</button></div><div class=\"row padding-left-15 padding-right-15\"><h3 class=no-outline ng-init=\"emailListImportCollapse=true\" ng-click=\"emailListImportCollapse = !emailListImportCollapse\">Importar lista de correos <i class=fa ng-class=\"(emailListImportCollapse)?\'fa-plus-circle\':\'fa-minus-circle\'\" aria-hidden=true></i></h3></div><div class=\"row div-import\" uib-collapse=emailListImportCollapse><input class=\"center-item text-center\" ng-show=false type=file file-reader=fileContent array-contacts=contacts id=fileInputEmails accept=\".csv, .txt, .xlsx\"><p class=\"pull-left p-import\">Formatos compatibles: txt, csv, xlsx</p><i class=\"fa fa-arrow-circle-o-right pull-right font-size-webkit-xxx-large margin-top-1 no-outline\" ng-click=addEmailsByFile() aria-hidden=true></i></div><div class=\"row margin-top-20\"><div class=\"padding-left-15 padding-right-15 text-center no-outline\" ng-init=\"emailMessageCollapse=true\" ng-click=\"emailMessageCollapse = !emailMessageCollapse\"><h4><i class=fa ng-class=\"(emailMessageCollapse)?\'fa-plus-circle\':\'fa-minus-circle\'\" aria-hidden=true></i> ¿Quieres personalizar el correo de invitación?</h4></div><div class=\"padding-left-15 padding-right-15\" uib-collapse=emailMessageCollapse><p>Hola,<br><br>Te invito a participar en la Vaca creada para <b>{{cow.name}}</b><br>Puedes acceder a la Vaca desde tu móvil, tableta u ordenador y no necesitas registrarte para participar<br>Te dejo el enlace aquí: <a href={{cowPublicURLComplete}} target=_blank>{{cowPublicURLComplete}}</a></p><textarea name=emails rows=8 cols=40 class=\"form-control no-resize\" placeholder=\"\"></textarea><p class=margin-top-10>En caso de que tengas alguna pregunta, el equipo de Armatuvaca se encuentra a tu entera disposición</p></div></div><div class=\"row padding-left-15 padding-right-15\"><h3 class=\"text-center mayus\">Tu lista de correo</h3></div><div class=\"row list-emails padding-15\"><div class=\"col-md-4 no-padding-left-right\" ng-repeat=\"contact in contacts track by $index\"><md-list-item class=\"contact-item selected list-contact\"><img ng-src={{contact.img}} class=md-avatar alt={{contact.name}}><div class=\"md-list-item-text compact\"><h3>{{contact.name}}</h3><p>{{contact.email}}</p><span class=\"closebtn no-outline\" ng-click=deleteContact($index)>&times;</span></div></md-list-item></div></div><div class=text-center><a href=\"\" ng-click=cleanContactsList()>Limpiar lista</a></div><div class=\"row padding-15\"><md-checkbox ng-model=invite_day_3_email class=font-bold>Volver a invitarlos en 3 días</md-checkbox><md-checkbox ng-model=invite_week_1_email class=font-bold>Volver a invitarlos en 1 semana</md-checkbox></div><div class=\"row padding-left-15 padding-right-15\"><p class=\"text-center font-size-12\">Al incluir tus contactos, aceptas en calidad de responsable de estos datos de contacto, que nuestra plataforma envíe la invitación a la Vaca. Ten en cuenta que los datos entregados serán tratados de acuerdo a nuestra <a ui-sref=privacy-policy target=_blank>política de tratamiento de datos</a>.</p></div><div class=\"row padding-15\"><button class=\"btn btn-default button-action-pink pull-left\" ng-click=goToAdmin()><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</button> <button type=button class=\"btn btn-default button-action pull-right\" ng-click=addContacts()>Enviar invitaciones</button></div></md-content></md-tab><md-tab label=\"Redes sociales\"><md-content class=md-padding><div class=\"col-md-6 margin-bottom-20\"><div class=div-social-invite><p class=\"text-center margin-top-bottom-40\">Comparte en Facebook con un solo clic</p><img src=assets/images/utils/fb-share.png class=\"img-responsive center-item no-outline\" alt=facebook-logo ng-click=shareFb()><p class=\"text-center p-social-invite\">Comparte tu Vaca en un mensaje privado, en tu muro, en el muro de un amigo o dentro de un grupo. ¡Donde tú quieras!</p></div></div><div class=\"col-md-6 margin-bottom-20\"><div class=div-social-invite><p class=\"text-center margin-top-bottom-40\">Twitea tu Vaca con un solo clic</p><img src=assets/images/utils/tw-share.png class=\"img-responsive center-item no-outline\" alt=twitter-logo ng-click=shareTw()><p class=\"text-center p-social-invite\">Difunde tu Vaca entre tus seguidores y aprovecha la viralidad que ofrece Twitter</p></div></div><div class=\"row padding-15\"><button class=\"btn btn-default button-action-pink pull-left\" ng-click=goToAdmin()><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</button></div></md-content></md-tab><!-- <md-tab label=\"Contactos Gmail\" md-active=\"tabSelected == 1\">\n          <md-content class=\"md-padding\">\n            <div class=\"row\" ng-show=\"contacts_gmail.length == 0\">\n              <div class=\"margin-top-40-md margin-top-10 no-outline\" ng-click=\"getGmailContacts()\">\n                <img src=\"assets/images/utils/gmail-logo.svg\" class=\"invite-gmail img-responsive\"\n                     alt=\"{{contact.name}}\">\n                <h4 class=\"text-center\">¡Accede a tus contactos Gmail en un solo clic!</h4>\n              </div>\n            </div>\n            <div class=\"\" ng-show=\"contacts_gmail.length > 0\">\n              <div class=\"row list-emails padding-15\">\n                <div class=\"col-md-12\">\n                  <div class=\"text-center col-md-4 col-md-offset-4\">\n                    <input type=\"text\" name=\"email_text_search\" placeholder=\"Filtra por tu correos\" row=\"3\"\n                           ng-model=\"email_text_search\" class=\"form-control\">\n                  </div>\n                </div>\n                <div class=\"col-md-12\">\n                  <div class=\"col-md-4 no-padding-left-right\"\n                       ng-repeat=\"contact in contacts_gmail | filter: {email : email_text_search} | limitTo: 9 track by $index\">\n                    <md-list-item class=\"contact-item selected list-contact\">\n                      <img ng-src=\"{{contact.img}}\" class=\"md-avatar\" alt=\"{{contact.name}}\">\n                      <div class=\"md-list-item-text compact\">\n                        <h3>\n                          {{contact.name}}</h3>\n                        <p>{{contact.email}}</p>\n                        <md-checkbox ng-model=\"contact.checked\"\n                                     class=\"font-bold font-color-atv right-corner-item\"></md-checkbox>\n                      </div>\n                    </md-list-item>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row padding-15\">\n                <md-checkbox ng-model=\"invite_day_3_gmail\" class=\"font-bold\">Volver a invitarlos en 3\n                  días\n                </md-checkbox>\n                <md-checkbox ng-model=\"invite_week_1_gmail\" class=\"font-bold\">Volver a invitarlos en 1\n                  semana\n                </md-checkbox>\n              </div>\n              <div class=\"row padding-left-15 padding-right-15\">\n                <p class=\"text-center font-size-12\">\n                  Al incluir tus contactos, aceptas en calidad de responsable de estos\n                  datos de contacto, que nuestra plataforma envíe la invitación a la Vaca. Ten en cuenta que los datos\n                  entregados serán tratados de acuerdo a\n                  nuestra <a ui-sref=\"privacy-policy\" target=\"_blank\">política de tratamiento de datos</a>.\n                </p>\n              </div>\n              <div class=\"row padding-15\">\n                <button class=\"btn btn-default button-action-pink pull-left\" ng-click=\"goToAdmin()\">\n                  <i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=\"true\"></i>Volver\n                </button>\n                <button type=\"button\" class=\"btn btn-default button-action pull-right\" ng-click=\"addContactsGmail()\">\n                  Enviar invitaciones\n                </button>\n              </div>\n            </div>\n            <div class=\"row padding-15\" ng-show=\"!(contacts_gmail.length > 0)\">\n              <button class=\"btn btn-default button-action-pink pull-left\" ng-click=\"goToAdmin()\">\n                <i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=\"true\"></i>Volver\n              </button>\n            </div>\n          </md-content>\n        </md-tab> --><md-tab label=\"Mis contactos\" md-active=\"tabSelected == 2\"><md-content class=md-padding><div class=row ng-show=\"user_contacts.length == 0\"><div class=\"margin-top-40-md margin-top-10 no-outline\"><h4 class=text-center>Por el momento no tienes ningún contacto, tus contactos son las direcciones de correo que invitas en tus Vacas</h4></div></div><div ng-show=\"user_contacts.length > 0\"><div class=\"row list-emails padding-15\"><div class=col-md-12><div class=\"text-center col-md-4 col-md-offset-4\"><input type=text name=email_text_search placeholder=\"Filtra por correo\" row=3 ng-model=email_text_search_user_contacts class=form-control></div></div><div class=col-md-12><div class=\"col-md-4 no-padding-left-right\" ng-repeat=\"contact in user_contacts | filter: {email : email_text_search_user_contacts} | limitTo: 9 track by $index\"><md-list-item class=\"contact-item selected list-contact\"><img ng-src=assets/images/user/user-blue.svg class=md-avatar alt={{contact.name}}><div class=\"md-list-item-text compact\"><h3>{{contact.name}}</h3><p>{{contact.email}}</p><md-checkbox ng-model=contact.checked class=\"font-bold font-color-atv right-corner-item\"></md-checkbox></div></md-list-item></div></div></div><div class=\"row padding-15\"><md-checkbox ng-model=invite_day_3_user_contact class=font-bold>Volver a invitarlos en 3 días</md-checkbox><md-checkbox ng-model=invite_week_1_user_contact class=font-bold>Volver a invitarlos en 1 semana</md-checkbox></div><div class=\"row padding-left-15 padding-right-15\"><p class=\"text-center font-size-12\">Al incluir tus contactos, aceptas en calidad de responsable de estos datos de contacto, que nuestra plataforma envíe la invitación a la Vaca. Ten en cuenta que los datos entregados serán tratados de acuerdo a nuestra <a ui-sref=privacy-policy target=_blank>política de tratamiento de datos</a>.</p></div><div class=\"row padding-15\"><button class=\"btn btn-default button-action-pink pull-left\" ng-click=goToAdmin()><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</button> <button type=button class=\"btn btn-default button-action pull-right\" ng-click=addContactsUserContacts()>Enviar invitaciones</button></div></div></md-content></md-tab></md-tabs></md-content></div></div><div><atv-footer></atv-footer></div><!-- Templates --><script type=text/ng-template id=contactsModal-1><div class=\"ngdialog-message\">\n    <h3>Contactos no agregados</h3>\n    <p ng-repeat=\"contact in ngDialogData.contacts\">\n      {{contact.name}}\n    </p>\n  </div></script><script type=text/ng-template id=QRCodeModal><div class=\"text-center\">\n    <h4>Toca el QR para descargar</h4>\n    <qrcode data=\"{{ngDialogData.cowParticipateURL}}\" size=\"200\" color=\"#333\" download></qrcode>\n  </div></script>");
$templateCache.put("app/views/cowInviteNew/cowInviteNew.html","<div><atv-navbar lang=true></atv-navbar></div><div class=cow-invite-new><div class=cow-invite-new-icon><i class=\"fa fa-share-alt\" aria-hidden=true></i></div><div class=cow-invite-new-title><p>{{getTraductor(\'invitation.invitation_friend\')}}:<br><b>{{cow.name}}</b></p></div><div class=cow-invite-new-link><p>{{getTraductor(\'share_cow.copy_link_long\')}}:</p><input id=cow_link type=text name=link ng-model=cowPublicURLCompleteCopy readonly> <button ngclipboard data-clipboard-target=#cow_link ng-click=copyLink()><i class=\"fa fa-link\" aria-hidden=true></i></button></div><br><div class=cow-invite-new-qr><p style=\"width: 80%; margin: 10px auto\">{{getTraductor(\'share_cow.qr_option\')}}:</p><button type=button name=button ng-click=openQR()><i class=\"fa fa-qrcode font-size-18\" aria-hidden=true></i> {{getTraductor(\'share_cow.see_qr\')}}</button></div><div class=cow-invite-new-social><p style=\"width: 80%; margin: auto\">{{getTraductor(\'share_cow.networks_options\')}}:</p><br><div class=cow-invite-new-social-icons><div class=\"visible-xs visible-sm\"><a class=no-outline socialshare socialshare-provider=whatsapp socialshare-url={{cowPublicURLComplete}} socialshare-text=\"{{cow_event.name + \' \' }}\"><img src=assets/images/utils/whatsapp.svg alt=whatsapp-logo></a><p>Whatsapp</p></div><div class=\"hidden-xs hidden-sm\"><a href=\"whatsapp://send??text={{cowPublicURLComplete}}\" data-action=share/whatsapp/share onclick=\"window.open(this.href, \'\', \'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600\');return false\" target=_blank title=\"Share on whatsapp\"><img src=assets/images/utils/whatsapp.svg alt=whatsapp-logo></a><p>Whatsapp</p></div><div ng-click=shareFb()><img src=assets/images/utils/facebook.svg alt=facebook-logo><p>Facebook</p></div><div class=\"visible-xs visible-sm\"><a socialshare socialshare-provider=facebook-messenger><img src=assets/images/utils/messenger.svg alt=messenger-logo></a><p>Messenger</p></div><div ng-click=shareTw()><img src=assets/images/utils/twitter.svg alt=twitter-logo><p>Twitter</p></div><!-- <div>\n        <a href=\"https://www.linkedin.com/sharing/share-offsite/?url={{cowPublicURLComplete}}\" target=\"_blank\">\n          <img src=\"assets/images/utils/linkedin.svg\" alt=\"LinkedIn-logo\">\n        </a>\n        <p>LinkedIn</p>\n      </div> --></div></div></div><div class=text-center><button class=\"btn btn-default button-action-pink margin-bottom-20\" ng-click=goToCow(cow.cow_event_id)><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>{{getTraductor(\'invitation.go_to_cow\')}}</button></div><div><atv-footer></atv-footer></div><script type=text/ng-template id=QRCodeModal><div class=\"text-center\">\n    <h4>{{getTraductor(\'share_cow.touch_qr\')}}</h4>\n    <qrcode data=\"{{ngDialogData.cowParticipateURL}}\" size=\"200\" color=\"#333\" download></qrcode>\n  </div></script>");
$templateCache.put("app/views/cowMarketplaceRedeem/cowMarketplaceRedeem.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Redimir Vacas</b></h1><!--<p class=\"\">--><!----><!--</p>--></div></div><div class=\"container-fluid background-color-white\"><div class=\"container margin-bottom-20 margin-top-20\"><div class=\"row col-md-8 col-md-offset-2\"><p>Ingresa el código de la Vaca:</p></div><div class=\"row col-md-8 col-md-offset-2 no-padding-left-right\"><form name=cowSearchForm ng-submit=searchCowCode(cowSearchForm.$valid) novalidate><div class=col-md-6><input type=text name=codeCow class=form-control-atv-cc placeholder=\"Código Vaca G4S4TMSA...\" id=codeCow ng-model=cowCode minlength=16 required><div ng-messages=\"cowSearchForm.$submitted && cowSearchForm.codeCow.$error\"><div ng-message=required><p class=\"validation-messages no-margin-top\">Por favor, digita el código de la Vaca.</p></div><div ng-message=minlength><p class=\"validation-messages no-margin-top\">Tu contraseña debe ser mínimo de 16 caracteres.</p></div></div></div><div class=col-md-2><button type=submit name=button class=\"form-control form-control-btn-search\"><i class=\"fa fa-search font-color-blue\" aria-hidden=true></i> Buscar</button></div></form></div><div class=\"row col-md-8 col-md-offset-2\" ng-show=cowEvent><div class=\"col-md-12 no-padding-left-right\"><div><h2 class=\"font-color-atv text-center\">{{cowEvent.name}}</h2></div><div><p><b class=font-color-atv>Nombre organizador: </b>{{cowEvent.made_by}}</p><p><b class=font-color-atv>Empresa: </b>{{cowEvent.product.company.name}}</p><p><b class=font-color-atv>Nombre del producto: </b>{{cowEvent.product.name}}</p><p><b class=font-color-atv>N° participantes: </b>{{cowEvent.participations}}</p><p><b class=font-color-atv>Monto total: </b>{{cowEvent.total_value | currency:\"$\":\'0\'}} COP</p><p ng-show=cowEvent.marketplace_cow_redeemed><b class=font-color-atv>Estado: </b><span class=\"badge badge-success\">Redimida</span></p><p ng-show=!cowEvent.marketplace_cow_redeemed><b class=font-color-atv>Estado: </b><span class=\"badge badge-info\">Sin redimir</span></p></div></div><div class=\"col-md-12 no-padding-left-right\" ng-show=!cowEvent.marketplace_cow_redeemed><button type=button name=button class=\"form-control form-control-btn-search\" ng-click=redeemCow()>Redimir Vaca</button></div></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/cowResend/cowResend.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Volver a invitar</b></h1><p>Aquí puedes enviar un recordatoria los participantes de la Vaca</p></div></div><div class=\"container-fluid background-color-white margin-bottom-20\" ng-show=\"cow_guest_list.length > 0\"><div class=container><div class=row><h3 class=\"text-center mayus\">Tu mensaje de recordatorio</h3><div><text-angular ng-model=message name=demo-editor></text-angular></div></div></div></div><div class=\"container-fluid background-color-gray-light margin-bottom-20\"><div class=container><div class=\"row text-center\"><h3 class=\"mayus margin-top-bottom-20\">Personas a las que quieres recordar sobre tu Vaca</h3><p>Solo las personas que hayan sido invitadas por correo electrónico podrán recibir el recordatorio.</p></div><div class=\"row background-color-white margin-bottom-20\" ng-show=\"cow_guest_list.length > 0\"><div class=\"col-md-4 no-padding-left-right\" ng-repeat=\"contact in cow_guest_list track by $index\"><md-list-item class=\"contact-item selected list-contact\"><img ng-src=assets/images/user/user-blue.svg class=md-avatar alt={{contact.name}}><div class=\"md-list-item-text compact\"><h3>{{contact.name}}</h3><p>{{contact.email}}</p><i class=\"fa fa-times font-bold font-color-pink right-corner-x-item\" aria-hidden=true ng-click=deleteGuest($index)></i></div></md-list-item></div></div><div class=\"row background-color-white margin-bottom-20 text-center\" ng-show=\"cow_guest_list.length == 0\"><h4>Todavía no has invitado a ninguna persona.</h4></div><div class=\"row padding-15\"><button class=\"btn btn-default button-action-pink pull-left\" ng-click=goToAdmin()><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</button> <button type=button class=\"button-action pull-right\" ng-click=resend() ng-show=\"cow_guest_list.length > 0\">Enviar invitaciones</button> <button type=button class=\"button-action pull-right\" ng-click=goToInvite() ng-show=\"cow_guest_list.length == 0\"><i class=\"fa fa-plus-circle atv-icon\" aria-hidden=true></i>Invitar</button></div></div></div><div class=container-fluid><atv-footer></atv-footer></div>");
$templateCache.put("app/views/cowTempLogin/cowTempLogin.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center page-top-title margin-top-20\"><h1 class=font-color-atv>Estás a un paso de Armar Tu Vaca</h1><p class=font-size-18>Inicia sesión o regístrate para terminar</p></div><div class=\"container-fluid background-color-white upper-cowspot-div\"><div class=\"container margin-bottom-20\"><div class=login-register-options ng-if=!register_status_selected><div class=login-register-option ng-click=chooseInitialOption(0)><img src=assets/images/atv-cow.png alt=armar_vaca><h3>Ya tengo cuenta</h3></div><div class=login-register-option ng-click=chooseInitialOption(1)><img src=assets/images/newhome/ventajas/3_movil.png alt=armar_vaca><h3>No tengo cuenta</h3></div></div><uib-tabset active=active_tab_register justified=true ng-if=register_status_selected class=margin-top-20><uib-tab index=0 heading=\"Ya tengo cuenta\"><div class=\"row col-md-offset-2 col-md-8 margin-bottom-20\"><h2 style=\"text-align: center\">Inicia Sesión</h2><div class=social-login><div><a id=cow_temp_login_fb class=\"btn btn-block btn-social btn-facebook facebook-button\" ng-click=loginFb()><span class=\"fa fa-facebook\"></span> Ingresa con Facebook</a></div><div class=google-social><a id=cow_temp_login_gg class=\"btn btn-block btn-social btn-google google-button\" ng-click=loginGg()><img src=assets/images/utils/google-logo.svg class=\"no-outline img-google-logo\" alt=google-maps-logo> Ingresa con Google</a></div></div><div class=email-login><form name=loginForm ng-submit=loginUser(loginForm.$valid) novalidate><h3 class=text-center>Iniciar sesión con tu correo</h3><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"loginForm.email.$invalid && loginForm.$submitted\"><label>Correo</label><input id=cow_temp_login_email required name=email maxlength=100 ng-model=user.email type=email placeholder=\"Ingresa acá tu correo\"><div ng-messages=loginForm.email.$error><div ng-message=required>Por favor, digita tu correo.</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"loginForm.password.$invalid && loginForm.$submitted\"><label>Contraseña</label><input id=cow_temp_login_password required name=password maxlength=100 minlength=8 ng-model=user.password type=\"{{(show_password)? \'text\': \'password\'}}\" placeholder=\"Ingresa acá tu contraseña\"><div ng-messages=loginForm.password.$error><div ng-message=required>Por favor, digita tu contraseña.</div><div ng-message=minlength>Tu contraseña debe ser mínimo de 8 caracteres.</div></div></md-input-container><div class=\"col-md-6 no-padding-left\"><a id=cow_temp_login_forgot_password href=\"\" ui-sref=forgot-password>Ohh no ¿Olvidaste tu contraseña?</a></div><p ng-show=errorSended class=\"text-danger login-error-msg\">{{errorMessage}}</p><div id=container_recaptchaV2></div><button id=cow_temp_login_submit class=\"pull-right button-action\" type=submit ng-if=!secondValidation>Iniciar sesión</button></form></div></div></uib-tab><uib-tab index=1 heading=\"No tengo cuenta\"><div class=\"row col-md-8 user-data-form-content col-md-offset-2\"><h2 style=\"text-align: center\">Regístrate</h2><div class=\"social-login margin-bottom-20\"><div class=google-social><a id=cow_temp_register_gg class=\"btn btn-block btn-social btn-google google-button\" ng-click=loginGg()><img src=assets/images/utils/google-logo.svg class=\"no-outline img-google-logo\" alt=google-maps-logo> Ingresa con Google</a></div><div class=margin-top-20><p class=small-font>Al registrarte por medio de Google, aceptas los <a id=cow_temp_register_terms_and_conditions ui-sref=terms-and-conditions target=_blank>términos y condiciones</a> y la <a id=cow_temp_register_privacy_policy ui-sref=privacy-policy target=_blank>política de tratamiento de datos</a> de Armatuvaca</p><p ng-show=errorSended class=text-danger>{{errorMessage}}</p></div></div><form name=registerForm ng-submit=\"registerNewUser(registerForm.$valid && (user.password == user.confirm_password) && (user.email == user.confirm_email))\" novalidate><h3 class=\"text-center margin-bottom-40\">Regístrate con tu correo</h3><div layout-gt-sm=\"row \"><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"registerForm.first_name.$invalid && registerForm.$submitted\"><label>Nombre</label><input id=cow_temp_register_first_name required name=first_name md-maxlength=50 ng-model=user.first_name placeholder=\"Ingresa acá tu nombre\"><div ng-messages=registerForm.first_name.$error><div ng-message=required>Por favor, digita tu nombre.</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"registerForm.last_name.$invalid && registerForm.$submitted\"><label>Apellido</label><input id=cow_temp_register_last_name required name=last_name md-maxlength=100 ng-model=user.last_name placeholder=\"Ingresa acá tu apellido\"><div ng-messages=registerForm.last_name.$error><div ng-message=required>Por favor, digita tu apellido.</div></div></md-input-container></div><div class=row><div class=\"col-md-5 register-date-picker margin-bottom-20\"><label ng-class=\"(user.born_date)? \'font-color-atv\': \'font-color-gray\'\">Fecha de nacimiento</label><md-input-container class=\"margin-top-3 no-margin-bottom\"><md-datepicker id=cow_temp_register_born_date ng-model=user.born_date md-max-date=maxDate md-placeholder=DD/MM/AAAA name=born_date required></md-datepicker><div ng-messages=registerForm.born_date.$error><div ng-message=valid>Fecha invalida</div><div ng-message=required>Por favor, selecciona tu fecha de nacimiento</div><div ng-message=maxdate>Debes ser mayor de edad para registrarte</div></div></md-input-container></div></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"registerForm.email.$invalid && registerForm.$submitted\"><label>Correo</label><input id=cow_temp_register_email required name=email maxlength=100 ng-model=user.email type=email placeholder=\"Ingresa acá tu correo\"><div ng-messages=registerForm.email.$error><div ng-message=required>Por favor, digita tu correo.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"registerForm.confirm_email.$invalid && registerForm.$submitted\"><label>Confirmar correo</label><input id=cow_temp_register_confirm_email required name=confirm_email maxlength=100 ng-model=user.confirm_email type=email placeholder=\"Confirma acá tu correo\"><p ng-show=\"user.confirm_email != user.email\" class=validation-messages>Los correos deben coincidir.</p><div ng-messages=registerForm.confirm_email.$error><div ng-message=required>Por favor, confirma tu correo.</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"registerForm.password.$invalid && registerForm.$submitted\"><label>Contraseña</label><input id=cow_temp_register_password required name=password maxlength=100 minlength=8 ng-model=user.password type=\"{{(show_password)? \'text\': \'password\'}}\" placeholder=\"Ingresa acá tu contraseña\"><div ng-messages=registerForm.password.$error><div ng-message=required>Por favor, digita tu contraseña.</div><div ng-message=minlength>Tu contraseña debe ser mínimo de 8 caracteres.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"registerForm.confirm_password.$invalid && registerForm.$submitted\"><label>Confirmar contraseña</label><input id=cow_temp_register_confirm_password required name=confirm_password maxlength=100 ng-model=user.confirm_password type=\"{{(show_password)? \'text\': \'password\'}}\" placeholder=\"Confirma acá tu contraseña\"><p ng-show=\"user.confirm_password != user.password\" class=validation-messages>Las contraseñas deben ser iguales.</p><div ng-messages=registerForm.confirm_password.$error><div ng-message=required>Por favor, confirma tu contraseña.</div></div></md-input-container></div><div class=\"col-md-12 no-padding\"><div class=\"col-md-6 no-padding\"><md-checkbox id=cow_temp_register_show_password ng-model=show_password aria-label=\"Checkbox 1\">Mostrar contraseñas</md-checkbox></div></div><p class=small-font>Al hacer clic en Regístrate, aceptas los <a id=cow_temp_terms_and_conditions2 ui-sref=terms-and-conditions target=_blank>términos y condiciones</a> y la <a id=cow_temp_privacy_policy2 ui-sref=privacy-policy target=_blank>política de tratamiento de datos</a> de Armatuvaca</p><p ng-show=errorSended class=text-danger>{{errorMessage}}</p><div id=container_recaptchaV2></div><button id=cow_temp_register_submit class=\"pull-right button-action\" type=submit ng.if=!secondValidation>Regístrate</button></form></div></uib-tab></uib-tabset><div style=\"display: flex; justify-content: center; width: 100%\"><div class=\"return-cow-creation font-color-pink\" onclick=history.back()><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i> Volver a creación de Vaca</div></div></div></div><div><atv-footer></atv-footer></div><script type=text/ng-template id=atvBenefitsInfoModal><div class=\"ngdialog-message\">\n    <div class=\"text-center\">\n      <h3 class=\"margin-top-10\">¡Felicidades!<br>Estás a un paso de tener tu Vaca</h3>\n      <ul class=\"text-left font-size-13-sm-xs\">\n        <li>No te encartes con efectivo 💰😒</li>\n        <li>No pierdas tiempo llevando la cuenta de quién ha pagado 🕐🕒🕔</li>\n        <li>Reunimos tu dinero en un sólo sitio 🔐</li>\n      </ul>\n      <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"closeBenefitsInfoModal(ngDialogId)\"></a>\n    </div>\n  </div></script>");
$templateCache.put("app/views/cowThanks/cowThanks.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Agradecimientos</b></h1><p>Aquí puedes agradecer a tus amigos por su participación.</p></div></div><div class=\"container-fluid background-color-white\"><div class=container><div class=\"row margin-bottom-20\"><h3 class=\"text-center mayus\"><b>Tu mensaje de agradecimiento</b></h3><div class=\"padding-left-15 padding-right-15\" uib-collapse=emailMessageCollapse><text-angular ng-model=thanksData.message name=demo-editor placeholder=\"Hola \\a \\a Gracias por su participación y colaboración en la Vaca \\a \\a Saludos \"></text-angular></div></div></div></div><div class=\"container-fluid background-color-gray-light\"><div class=container><div class=\"row padding-left-15 padding-right-15\"><h3 class=\"text-center mayus\">Personas a las que das las gracias</h3></div><div class=\"row list-emails padding-15\" ng-show=\"thanksData.emails_list.length > 0\"><div class=\"col-md-4 no-padding-left-right\" ng-repeat=\"data in thanksData.emails_list track by $index\"><md-list-item class=\"data-item selected list-data\"><img ng-src=assets/images/user/user-green.svg class=md-avatar alt={{data.first_name}}><div class=\"md-list-item-text compact\"><h3>{{data.first_name}}</h3><p>{{data.email}}</p><span class=\"closebtn no-outline\" ng-click=deleteContact($index)>&times;</span></div></md-list-item></div></div><div class=\"row padding-15\"><md-checkbox ng-model=thanksData.include_previous class=\"font-bold font-color-atv\" ng-change=includePreviousChanged()>Incluir a las personas a las que ya has dado las gracias</md-checkbox><md-checkbox ng-model=thanksData.send_me_one class=\"font-bold font-color-atv\">Enviarme una copia del correo de agradecimiento</md-checkbox></div><div class=\"row padding-15\"><button class=\"btn btn-default button-action-pink pull-left\" ng-click=goToAdmin()><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</button> <button type=button class=\"btn btn-default button-action pull-right\" ng-click=sendThanks()>Enviar agradecimientos</button></div></div></div><div class=container-fluid><atv-footer></atv-footer></div>");
$templateCache.put("app/views/cowsUser/cowsUser.html","<div><atv-navbar></atv-navbar></div><!--<div class=\"container-fluid text-center\">--><!--<div class=\"row page-top-title page-title\">--><!--<h1 class=\"font-color-atv margin-top-40-md\">--><!--<b>Mis Vacas</b>--><!--</h1>--><!--<p class=\"\">--><!--Mira todas las Vacas que has creado y a las que te han invitado--><!--</p>--><!--</div>--><!--</div>--><admin-nav-bar><br><br><div class=margin-bottom-40><cows-user cows=cows></cows-user></div></admin-nav-bar><div><atv-footer></atv-footer></div><script type=text/ng-template id=newPrincingModelInform><div class=\"ngdialog-message\">\n    <div class=\"text-center\">\n      <h3 class=\"margin-top-10\">¡Hola!</h3>\n      <p>Pensando en ti hicimos algunos cambios en la forma de usar la plataforma, pero no hay de qué preocuparse,\n        las condiciones no cambian para las Vacas que habías creado anteriormente, solo aplican para las Vacas creadas a\n        partir del\n        <strong>12 de Junio de 2020</strong>. Si quieres más información, visita nuestra sección de\n        <a ng-click=\"closeNewPrincingModelInform()\" ui-sref=\"prices\" target=\"_blank\">Tarifas</a> y los\n        <a ng-click=\"closeNewPrincingModelInform()\" ui-sref=\"terms-and-conditions\" target=\"_blank\">Términos y\n          condiciones</a> de uso de la plataforma</p>\n      <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"closeNewPrincingModelInform()\"></a>\n    </div>\n  </div></script>");
$templateCache.put("app/views/efecty/efecty.html","<div><atv-navbar></atv-navbar></div><div><div class=cow-token-request><!--HEAD--><div class=cow-token><img src=assets/images/payment-methods/efecty.png alt=Efecty></div><div class=cow-token-request-title><p>¡Hola!</p></div><div class=cow-token-request-subtitle><p>Para reclamar tu dinero por <b>Efecty</b> debes seguir estos pasos:</p></div><div class=cow-token-request-paragraph><b>1.</b> Acércate a un punto <a href=https://www.efecty.com.co/web/puntos-de-atencion target=_blank><img src=assets/images/payment-methods/efecty.png alt=Efecty width=100px></a><br><a href=https://www.efecty.com.co/web/puntos-de-atencion target=_blank>Ver puntos.</a><br><br><b>2.</b> Infórmale al cajero que retiras dinero con el convenio empresarial 111625 (Pagos Armatuvaca) Si el cajero de Efecty no tiene claro el proceso debes darle estos pasos \"Ingresar al portafolio de servicio, opción pagos, consultar giros empresariales y seleccionar el proyecto 111625 (Pagos Armatuvaca)\"<br><br><b>3. </b>Entrégale al cajero el siguiente CÓDIGO: <b>{{cashout_id}}</b><br><br></div><div class=cow-token-request-paragraph>Recuerda que debes llevar tu documento de identidad y los datos deben corresponder con los registrados en la plataforma.<br><br></div><div class=cow-token-request-paragraph style=\"font-style: italic\">Si no realizaste esta solicitud, por favor contáctanos de <b>inmediato</b> al correo <b>contacto@armatuvaca.com</b> o al número de teléfono que se muestra en el sitio web.</div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/feedbackCow/feedbackCow.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Califícanos</b></h1><p>Califica tu experiencia para tu Vaca <strong>{{cow_info.name}}</strong></p></div></div><div class=\"container-fluid padding-bottom-20 bottom-line background-color-white\"><form name=feedbackForm ng-submit=updateFeedback() ng-if=!feedbackSaved><div><div class=\"form-group text-center font-color-atv padding-top-20\"><label>Califícanos de 1 a 5</label><br><i class=\"no-outline font-size-xx-large padding-left-right-5\" ng-init=loadStars() ng-repeat=\"star in stars\" ng-class=\"(star.selected)?\'fa fa-star\':\'fa fa-star-o\'\" ng-click=selectStar(star) ng-mouseenter=fillStar(star,true) ng-mouseleave=fillStar(star,false)></i></div><div class=\"form-group col-md-4 col-md-offset-4 text-center font-color-atv padding-top-20\"><md-input-container class=\"md-block md-input-has-placeholder\"><label class=text-left>Título</label><input aria-label=Title placeholder=\"Escribe un título para tu reseña\" ng-model=$parent.feedback_title name=feedbackTitle class=\"form-control-atv feedback-form\" md-maxlength=30></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\"><label class=text-left>Comentarios</label><textarea aria-label=Comments placeholder=\"Escribe aquí tus comentarios\" ng-model=$parent.feedback_comments name=feedbackComments class=\"form-control-atv feedback-form\" rows=4 md-maxlength=300>\n          </textarea></md-input-container></div></div><div class=\"col-md-12 margin-top-20 margin-bottom-20 text-center\"><button class=\"btn btn-default button-action\" type=submit>Enviar</button></div></form><div class=\"container-fluid text-center padding-top-20\" ng-if=feedbackSaved><p>Muchas gracias por darnos tu opinión {{$parent.cow_info.made_by}}.</p><p>¿Ahora qué esperas para armar tu siguiente Vaca?<br>Ideal para Paseos, Fiestas, Partidos, Regalos en Común, Asados, Despedidas, Novenas, Matrimonios y mucho más.</p><div class=main-hiw-button><button class=\"btn btn-default button-action\" ng-click=$parent.goToCreateCow()>Armar una Vaca</button></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/feedbackPayment/feedbackPayment.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Califícanos</b></h1><p>Califica tu experiencia durante el proceso de pago para la Vaca <strong>{{payment_info.cow_event.name}}</strong></p></div></div><div class=\"container-fluid padding-bottom-20 bottom-line background-color-white\"><form name=feedbackForm ng-submit=updateFeedback() ng-if=!feedbackSaved><div><div class=\"form-group text-center font-color-atv padding-top-20\"><label>Califícanos de 1 a 5</label><br><i class=\"no-outline font-size-xx-large padding-left-right-5\" ng-init=loadStars() ng-repeat=\"star in stars\" ng-class=\"(star.selected)?\'fa fa-star\':\'fa fa-star-o\'\" ng-click=selectStar(star) ng-mouseenter=fillStar(star,true) ng-mouseleave=fillStar(star,false)></i></div><div class=\"form-group col-md-4 col-md-offset-4 text-center font-color-atv padding-top-20\"><md-input-container class=\"md-block md-input-has-placeholder\"><label class=text-left>Título</label><input aria-label=Title placeholder=\"Escribe un título para tu reseña\" ng-model=$parent.feedback_title name=feedbackTitle class=\"form-control-atv feedback-form\" md-maxlength=30></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\"><label class=text-left>Comentarios</label><textarea aria-label=Comments placeholder=\"Escribe aquí tus comentarios\" ng-model=$parent.feedback_comments name=feedbackComments class=\"form-control-atv feedback-form\" rows=4 md-maxlength=300>\n          </textarea></md-input-container></div></div><div class=\"col-md-12 margin-top-20 margin-bottom-20 text-center\"><button class=button-action type=submit>Enviar</button></div></form><div class=\"container-fluid text-center padding-top-20\" ng-if=feedbackSaved><p>Muchas gracias por darnos tu opinión {{$parent.payment_info.participant.first_name}}.</p><p>¿Ahora qué esperas para armar tu propia Vaca?<br>Ideal para Paseos, Fiestas, Partidos, Regalos en Común, Asados, Despedidas, Novenas, Matrimonios y mucho más.</p><div class=main-hiw-button><button class=button-action ng-click=$parent.goToCreateCow()>Armar una Vaca</button></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/feedbackUser/feedbackUser.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Califícanos</b></h1><p>Califica tu experiencia con Armatuvaca <strong>{{payment_info.cow_event.name}}</strong></p></div></div><div class=\"container-fluid padding-bottom-20 bottom-line background-color-white\"><form name=feedbackForm ng-submit=updateFeedback() ng-if=!feedbackSaved><div><div class=\"form-group text-center font-color-atv padding-top-20\"><label>Califícanos de 1 a 5</label><br><i class=\"no-outline font-size-xx-large padding-left-right-5\" ng-init=loadStars() ng-repeat=\"star in stars\" ng-class=\"(star.selected)?\'fa fa-star\':\'fa fa-star-o\'\" ng-click=selectStar(star) ng-mouseenter=fillStar(star,true) ng-mouseleave=fillStar(star,false)></i></div><div class=\"form-group col-md-4 col-md-offset-4 text-center font-color-atv padding-top-20\"><md-input-container class=\"md-block md-input-has-placeholder\"><label class=text-left>Título</label><input aria-label=Title placeholder=\"Escribe un título para tu reseña\" ng-model=$parent.feedback_title name=feedbackTitle class=\"form-control-atv feedback-form\" md-maxlength=30></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\"><label class=text-left>Comentarios</label><textarea aria-label=Comments placeholder=\"Escribe aquí tus comentarios\" ng-model=$parent.feedback_comments name=feedbackComments class=\"form-control-atv feedback-form\" rows=4 md-maxlength=300>\n          </textarea></md-input-container></div></div><div class=\"col-md-12 margin-top-20 margin-bottom-20 text-center\"><button class=\"btn btn-default button-action\" type=submit>Enviar</button></div></form><div class=\"container-fluid text-center padding-top-20\" ng-if=feedbackSaved><p>Muchas gracias por darnos tu opinión {{$parent.payment_info.participant.first_name}}.</p><p>¿Ahora qué esperas para armar tu propia Vaca?<br>Ideal para Paseos, Fiestas, Partidos, Regalos en Común, Asados, Despedidas, Novenas, Matrimonios y mucho más.</p><div class=main-hiw-button><button class=\"btn btn-default button-action\" ng-click=$parent.goToCreateCow()>Armar una Vaca</button></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/firstLogin/firstLogin.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md font-size-30-sm-xs\"><b>Ahora eres parte de Armatuvaca.com</b></h1></div></div><div class=\"container-fluid background-color-white no-padding-left-right\"><div class=\"container margin-top-40\"><div class=row><div class=col-md-2><div class=\"text-center main-hiw-description\"><img class=\"img-circle img-hiw\" src=assets/images/logo-box.png alt=img-home></div></div><div class=\"col-md-10 margin-top-10\"><p>Hola <b>{{user.user.first_name}}</b>, te damos la bienvenida.<br><br>Armar una <b>Vaca</b> nunca había sido tan fácil<br><br>Ideal para cumpleaños, asados, paseos, fiestas, partidos, showers y mucho más.<br><br>Recuerda que debes revisar tu correo para activar tu cuenta.<br><br>¿Qué esperas?<br><!-- <br>\n          Lorem ipsum dolor sit amet, consectetur\n          <b>adipiscing elit.</b>\n          Fusce imperdiet ac\n          <b>ante non placerat.</b> --></p></div></div><div class=\"row text-center margin-bottom-20\"><button id=first_login_btn_cow_create class=\"btn btn-default button-action\" ng-click=goToCreateCow()>Armar una Vaca</button></div><div class=\"row text-center margin-bottom-20\"><div class=col-md-6><button id=first_login_btn_go_to_home class=\"btn btn-default button-action-white pull-right\" ng-click=goToHome()>Ir al Inicio</button></div><div class=col-md-6><button id=first_login_btn_hiw class=\"btn btn-default button-action-white pull-left\" ng-click=goToHowItWorks()>¿Cómo funciona?</button></div></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/frecuentlyAskedQuestions/frecuentlyAskedQuestions.html","<div><atv-navbar></atv-navbar></div><div class=faq-image><div class=faq-title><input class=\"center-item form-control typeahead-input\" placeholder=\"¿Cúal es tu pregunta?\" type=text ng-model=typeahead_input uib-typeahead=\"typeaheadItem.question_text for typeaheadItem in typeaheadItems | filter:$viewValue | limitTo:8\" typeahead-min-length=3 typeahead-editable=false typeahead-on-select=\"typeaheadSelected($item, $model, $label)\" class=form-control></div></div><div class=\"container margin-top-20 margin-bottom-20 background-color-white\"><div class=\"faq-content-md-ls margin-top-20 margin-bottom-20\"><div class=\"well background-color-white faq-content-question\" ng-repeat=\"fq in allQuestions track by $index\" id={{fq.element_id}}><h4 class=\"outline-color-white faq-content-q-title\" ng-click=uncollapseSingleFAQ(fq)><b>{{fq.question_text}}</b> <i class=\"pull-right fa outline-color-white\" ng-class=\"(fq.is_collapsed) ? \'fa-chevron-down\': \'fa-chevron-up\'\" aria-hidden=true></i></h4><div uib-collapse=fq.is_collapsed marked=fq.answer_text>{{fq.answer_text}}</div></div></div></div><div class=\"faq-contact margin-top-20 margin-bottom-40 background-color-white container\"><h2>¿Tienes más dudas?</h2><h4>Comunícate con nosotros</h4><div class=\"faq-contact-methods margin-top-20 margin-bottom-20\"><a class=faq-contact-method href=\"https://api.whatsapp.com/send?phone=573007185815\"><i class=\"fa fa-whatsapp\" aria-hidden=true style=\"color: #4bcb5a\"></i><h5>WhatsApp:</h5><h6>+57 300 718 5815</h6></a><a class=faq-contact-method href=mailto:contacto@armatuvaca.com><i class=\"fa fa-envelope\" aria-hidden=true style=\"color: #003644\"></i><h5>Correo electrónico:</h5><h6>contacto@armatuvaca.com</h6></a></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/howItWorks/howItWorks.html","<script>var scroll_controller = new ScrollMagic.Controller();</script><div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>¿Cómo funciona Armatuvaca?</b></h1><p>¡Es muy fácil! Sigue estos pasos:</p></div></div><div class=\"atv__home__second-view margin-top-40 margin-bottom-40\"><div class=\"container margin-top-40\"><div class=atv-col-container><div class=\"atv-col atv-col-md-3 atv-col-sm-6 atv-col-xs-6 padding-left-right-10 margin-bottom-40\" ng-repeat=\"step in list_steps\"><img class=atv__home__second-view__img src={{step.img}} alt=armar_vaca><h3>{{step.title}}</h3><p class=atv__home__second-view__text>{{step.description}}</p></div></div><!-- <h2 class=\"atv__home__subtitle text-center margin-bottom-25\">¡Es muy fácil! ahora Arma Tu Vaca...</h2> --> <button class=atv__home__second-view__button ng-click=goToCreateCow()>Armatuvaca</button><h5 class=margin-top-40>¿Tienes dudas? Mira <b><a ui-sref=frecuently-asked-questions href=\"\">acá</a></b> las respuestas a las preguntas más frecuentes.</h5></div></div><div class=atv__home__divider></div><!-- <div class=\"how-it-works\">\n  <img class=\"how-it-works-line left-line\" src=\"assets/images/how-it-works/linea_izq.png\">\n  <img class=\"how-it-works-line right-line\" src=\"assets/images/how-it-works/linea_der.png\">\n  <div class=\"how-it-works-item\" style=\"opacity: 1\">\n    <img src=\"assets/images/how-it-works/1_crear.png\">\n    <div class=\"how-it-works-item-line\"><div><div></div></div></div>\n  </div>\n  <div id=\"trigger-hiw-step-2\"></div>\n  <div class=\"how-it-works-item\" id=\"hiw-step2\">\n    <img src=\"assets/images/how-it-works/2_invitar.png\">\n    <div class=\"how-it-works-item-line\"><div><div></div></div></div>\n  </div>\n  <div id=\"trigger-hiw-step-3\"></div>\n  <div class=\"how-it-works-item\" id=\"hiw-step3\">\n    <img src=\"assets/images/how-it-works/3_paga.png\">\n    <div class=\"how-it-works-item-line\"><div><div></div></div></div>\n  </div>\n  <div id=\"trigger-hiw-mouse\"></div>\n  <div id=\"trigger-hiw-step-4\"></div>\n  <div class=\"how-it-works-item\" id=\"hiw-step4\">\n    <img src=\"assets/images/how-it-works/4_usar.png\" class=\"hidden-xs\">\n    <img src=\"assets/images/how-it-works/4_usar_mobile.png\" class=\"visible-xs\">\n    <div class=\"how-it-works-item-line\"><div></div></div>\n  </div>\n  <div class=\"how-it-works-create\">\n    <div class=\"how-it-works-create-line\"><div></div></div>\n    <button class=\"btn btn-default button-action animated pulse infinite\" ui-sref=\"cow-create\">Armar una Vaca</button>\n  </div>\n  <div class=\"how-it-works-mouse hidden-xs hidden-sm\">\n    <img src=\"assets/images/home/scroll.png\" alt=\"scroll\" class=\"animated infinite bounce slow\">\n    <br>\n    <span style=\"font-size: 10px\">Scroll</span>\n  </div>\n  <div class=\"how-it-works-mouse hidden-lg hidden-md\">\n    <img src=\"assets/images/home/hand.png\" alt=\"hand\" class=\"animated infinite bounce slow\">\n    <br>\n    <span style=\"font-size: 10px\">Swipe</span>\n  </div>\n</div>\n<script>\n  new ScrollMagic.Scene({\n    triggerElement: \'#trigger-hiw-step-2\',\n    duration:350\n  })\n    .setTween(\"#hiw-step2\", 0.5, {opacity:\'1\'})\n    .addTo(scroll_controller);\n  new ScrollMagic.Scene({\n    triggerElement: \'#trigger-hiw-step-3\',\n    duration:350\n\n  })\n    .setTween(\"#hiw-step3\", 0.5, {opacity:\'1\'})\n    .addTo(scroll_controller);\n  new ScrollMagic.Scene({\n    triggerElement: \'#trigger-hiw-step-4\',\n    duration:350\n  })\n    .setTween(\"#hiw-step4\", 0.5, {opacity:\'1\'})\n    .addTo(scroll_controller);\n  new ScrollMagic.Scene({\n    triggerElement: \'#trigger-hiw-mouse\',\n    duration:350\n\n  })\n    .setTween(\".how-it-works-mouse\", 0.3, {opacity:\'0\'})\n    .addTo(scroll_controller);\n</script> --><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/login/login.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Inicia Sesión</b></h1><p>Te estábamos esperando para armar una nueva Vaca</p></div></div><div class=container><div></div></div><div class=\"container login-form\"><div class=\"row login-form-content col-md-8\"><div class=social-login><div><a id=login_sigin_fb class=\"btn btn-block btn-social btn-facebook facebook-button\" ng-click=loginFb()><span class=\"fa fa-facebook facebook-logo-button-register\"></span> Ingresa con Facebook</a></div><div class=google-social><a id=login_sigin_gg class=\"btn btn-block btn-social btn-google google-button\" ng-click=loginGg()><img src=assets/images/utils/google-logo.svg class=\"no-outline img-google-logo\" alt=google-maps-logo> Ingresa con Google</a></div></div><div class=email-login><form name=loginForm ng-submit=loginUser(loginForm.$valid) novalidate><h3 class=text-center>Iniciar sesión</h3><br><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"loginForm.email.$invalid && loginForm.$submitted\"><label>Correo</label><input id=login_email required name=email maxlength=100 ng-model=user.email type=email placeholder=\"Ingresa acá tu correo\"><div ng-messages=loginForm.email.$error><div ng-message=required>Por favor, digita tu correo.</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"loginForm.password.$invalid && loginForm.$submitted\"><label>Contraseña</label><input id=login_password required name=password maxlength=100 minlength=8 ng-model=user.password type=\"{{(show_password)? \'text\': \'password\'}}\" placeholder=\"Ingresa acá tu contraseña\"><div ng-messages=loginForm.password.$error><div ng-message=required>Por favor, digita tu contraseña.</div><div ng-message=minlength>Tu contraseña debe ser mínimo de 8 caracteres.</div></div></md-input-container><div id=container_recaptchaV2></div><div class=\"col-md-6 no-padding-left\"><a id=login_forgot_password_link href=\"\" ui-sref=forgot-password>Ohh no ¿Olvidaste tu contraseña?</a></div><!--<div class=\"col-md-6 text-right\">--><!--¿Eres nuevo? Ingresa <b><a id=\"login_register_link\" ui-sref=\"register\" href=\"\">aquí</a></b>--><!--</div>--><p ng-show=errorSended class=\"text-danger login-error-msg\">{{errorMessage}}</p><button id=login_btn_submit class=\"pull-right button-action margin-bottom-20\" type=submit ng-if=!secondValidation>Iniciar sesión</button></form></div></div><div class=\"row login-register-section col-md-3 col-sm-4\"><i class=\"fa fa-users\" aria-hidden=true></i><p>¿No tienes una cuenta?</p><button class=button-action type=submit ng-click=register()>Regístrate</button></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/main/main.html","<script>var scroll_controller = new ScrollMagic.Controller();</script><div><atv-navbar></atv-navbar></div><div class=atv__home__first-view><div class=atv__home__first-view__container><div class=atv__home__first-view__col1><div class=atv__home__first-view__card><bar-home on-selected-item=onSelectedItem(item)></bar-home><div class=atv__home__first-view__card__wrapper ng-repeat=\"(key, option) in cta_options\" ng-if=\"(key+1 === selected_atv_bar)\"><h1 class=atv__home__first-view__card__title>{{option.title}}</h1><p class=atv__home__first-view__card__desc>{{option.desc}}</p><div class=atv__home__first-view__card__ctas><button class=atv__home__first-view__card__ctas__btn ng-click=option.primary_cta.action()>{{option.primary_cta.name}}</button> <button ng-if=option.secondary_cta class=\"atv__home__first-view__card__ctas__btn atv__home__first-view__card__ctas__btn--secondary\" ng-click=option.secondary_cta.action()>{{option.secondary_cta.name}}</button></div></div></div></div><div class=\"atv__home__first-view__col2 hidden-xs-sm\"><img src={{option.main_img}} ng-repeat=\"(key, option) in cta_options\" ng-if=\"(key+1 === selected_atv_bar)\"></div></div></div><div id=trigger-home-mouse></div><div id=trigger-home-end></div><div id=home-mouse-desepears></div><div class=atv__home__divider></div><!-- Armar Vaca es facil\n<div class=\"atv__home__second-view margin-top-40 margin-bottom-40\">\n  <h1 class=\"atv__home__title\">¿Cómo funciona Arma Tu Vaca?</h1>\n  <h2 class=\"atv__home__subtitle text-center margin-bottom-25\">¡Es muy fácil! Sigue estos pasos:</h2>\n  <div class=\"container margin-top-40\">\n    <div class=\"atv-col-container\">\n      <div class=\"atv-col atv-col-md-3 atv-col-sm-6 atv-col-xs-6 padding-left-right-10 margin-bottom-40\"\n        ng-repeat=\"step in list_steps\">\n        <img class=\"atv__home__second-view__img\" src=\"{{step.img}}\" alt=\"armar_vaca\">\n        <h3>{{step.title}}</h3>\n        <p class=\"atv__home__second-view__text\">\n          {{step.description}}\n        </p>\n      </div>\n    </div>\n    <h2 class=\"atv__home__subtitle text-center margin-bottom-25\">¡Es muy fácil! ahora Arma Tu Vaca...</h2>\n    <button class=\"atv__home__second-view__button\" ng-click=\"autoScroll($event, \'atv__home__first-view\')\">\n      Arma Tu Vaca\n    </button>\n  </div>\n</div>\n<div class=\"atv__home__divider\"></div> --><!--Ventajas de usar ATV--><div class=atv__home__third-view><h1 class=atv__home__title>Ventajas de usar Armatuvaca</h1><h2 class=atv__home__subtitle>Conoce todas las ventajas que tienes con nosotros</h2><div class=\"container atv__home__third-view__container\"><div class=atv-col-container><div class=\"atv-col atv-col-md-4 atv-col-sm-6 atv-col-xs-6 margin-bottom-40\" ng-repeat=\"adventage in list_adventage\"><div class=atv-col-container><div class=\"atv-col atv-col-md-4 atv-col-sm-12 atv-col-xs-12\"><img class=atv__home__third-view__img src={{adventage.img}} alt=armar_vaca></div><div class=\"atv-col atv-col-md-8 atv-col-sm-12 atv-col-xs-12\"><h3>{{adventage.title}}</h3><p ng-bind-html=adventage.description class=atv__home__third-view__text></p></div></div></div></div></div></div><div class=atv__home__divider></div><!-- Calculator --><div class=atv__home__pricing><h1 class=atv__home__title>¿Cuánto cuesta Armar Una Vaca?</h1><h2 class=atv__home__subtitle>Las cuentas claras y el chocolate espeso.<br>Conoce los costos y cuánto dinero recibes</h2><div class=atv-container><div class=atv-col-container><div class=\"atv-col atv-col-md-8 atv-col-sm-12 atv__home__pricing__calc\"><new-calc on-change-calc=\"onChangeCalc(current_value, tax_value, percentage, total_value)\"></new-calc></div><div class=\"atv-col atv-col-md-4 atv-col-sm-12 atv__home__pricing__info\"><p class=atv__home__pricing__info__text>Esto es lo que vas a recolectar:<br><b>{{current | currency:\'COP$\':0}}</b></p><br><p class=atv__home__pricing__info__text>Nuestro servicio cuesta:<br><b ng-if=\"tax === 0\">{{tax | currency:\'COP$\':0}}* </b><b ng-if=\"tax > 0\">{{tax | currency:\'COP$\':0}}</b><br><span class=atv__home__pricing__info__text__percentage ng-if=\"percentage > 0\">({{percentage | number:0}}% + IVA)</span></p><br><p class=atv__home__pricing__info__text>Impuesto 4x1000:<br><b ng-if=\"tax === 0\">*{{four_by_thousand_tax | currency:\'COP$\':0}} </b><b ng-if=\"tax > 0\">{{0 | currency:\'COP$\':0}}</b><br><span class=atv__home__pricing__info__text__percentage ng-if=\"percentage > 0\">(Lo asume Armatuvaca por ti)</span></p><br><p class=atv__home__pricing__info__text>Finalmente recibes:<br><span class=atv__home__pricing__info__text__title>{{total | currency:\'COP$\':0}}</span><br><span class=atv__home__pricing__info__text__aditional-info>(Los pagos con tarjeta generan un costo transaccional de 1.99% + IVA que se cobra al participante)</span></p></div></div></div></div><div class=atv__home__divider></div><!--Hacemos mas que Vacas--><div class=atv__home__fifth-view><div class=atv__home__fifth-view__section-one><h1 class=atv__home__title>Hacemos más que Vacas</h1><h2 class=atv__home__subtitle>En Armatuvaca somos disruptivos y llevamos un buen recorrido en el Fintech Latinoamericano.<br>Somos expertos en finanzas grupales y reunimos más que dinero.</h2><div class=\"container atv__home__fifth-view__section-one__container\"><div class=\"atv-col-container atv__home__fifth-view__section-one__container__col-container\"><div class=\"atv-col atv-col-md-6 atv__home__fifth-view__section-one__container__col-container__col\"><div class=\"atv-col-container atv__home__fifth-view__section-one__container__col-container\"><div class=atv__home__fifth-view__section-one__container__col-container__col--statistics ng-repeat=\"statistic in list_statistics\"><img src={{statistic.img}} alt=\"\"><p ng-bind-html=statistic.description></p></div></div></div><div class=\"atv-col atv-col-md-6 atv__home__fifth-view__section-one__container__col-container__col\"><img src=assets/images/newhome/stats/fintechatv.png alt=\"\"></div></div></div></div><div class=atv__home__fifth-view__section-two><div class=\"container atv__home__fifth-view__section-two__container\"><div class=\"atv-col-container atv__home__fifth-view__section-two__container__col-container\"><div class=\"atv-col atv-col-md-6 atv__home__fifth-view__section-two__container__col-container__col\"><ui-carousel slides=atv_slides slides-to-show=1 slides-to-scroll=1 initial-slide=1 autoplay autoplay-speed=2000 dots=false><carousel-item><img src={{item.image}}></carousel-item><carousel-prev><button class=\"home-media-links-carousel-button prev-btn\"><i class=\"fa fa-chevron-left\" aria-hidden=true></i></button></carousel-prev><carousel-next><button class=\"home-media-links-carousel-button next-btn\"><i class=\"fa fa-chevron-right\" aria-hidden=true></i></button></carousel-next></ui-carousel></div><div class=\"atv-col atv-col-md-6 atv__home__fifth-view__section-one__container__col-container__col\"><h1 class=atv__home__title>Las empresas avanzan con nuestras Alcancías</h1><p class=atv__home__text>Somos todo un ecosistema para recaudar dinero. Marcas como Festival Estéreo Picnic, Knotfest, Ahorrock, Credibanco, Protección han usado Armatuvaca.</p><button class=\"atv__home__btn atv__home__btn--secondary\" ng-click=goToAtv4Bsnss()>Conoce mas...</button></div></div></div></div></div><div class=atv__home__divider></div><div class=atv__home__closure-view><div class=container><div class=atv-col-container><div class=\"atv-col atv-col-md-12\"><!-- <h3 class=\"atv__home__subtitle\">Facilitamos tu manera de recaudar dinero</h3> --><h2 class=atv__home__title>Crea, aporta y comparte</h2><p class=atv__home__text>Porque en Armatuvaca reunimos más que dinero.<br>¿Qué esperas?</p><button class=atv__home__second-view__button ng-click=\"autoScroll($event, \'atv__home__first-view\')\">Armatuvaca</button></div></div></div></div><div class=\"atv__home-mouse hidden-xs hidden-sm\"><img src=assets/images/home/scroll.png alt=scroll class=\"animated infinite bounce slow\"><br><span style=\"font-size: 10px\">Scroll</span></div><div class=\"atv__home-mouse hidden-lg hidden-md\"><img src=assets/images/home/hand.png alt=hand class=\"animated infinite bounce slow\"><br><span style=\"font-size: 10px\">Swipe</span></div><script>new ScrollMagic.Scene({\n    triggerElement: \'#trigger-home-end\',\n    duration: 250\n  })\n    .setTween(\"#home-mouse-desepears\", 0.3, { opacity: \'0\' })\n    .addTo(scroll_controller);\n  new ScrollMagic.Scene({\n    triggerElement: \'#trigger-home-mouse\',\n    duration: 350\n\n  })\n    .setTween(\".atv__home-mouse\", 0.3, { opacity: \'0\' })\n    .addTo(scroll_controller);</script><div class=atv__home__divider></div><!--OLD FIRST VIEW ATV--><!-- <div class=\"home-main-container\" ng-style=\"backgroundImage\">\n  <div class=\"home-main-container-opacity\">\n    <h1>¿Para qué quieres reunir dinero?</h1>\n       <p>Para el paseo, el asado, la fiesta, una causa social o simplemente cobrar dinero.</p>\n    <p>Para el regalo virtual, envíar dinero, una causa social o simplemente cobrar dinero sin contacto.</p>\n\n    <div class=\"home-main-container-opacity-input\">\n      <form>\n        <input type=\"text\" placeholder=\"Nombre de la Vaca\" ng-model=\"cow_name\" no-special-chars ng-keydown=\"enterKeyDownSubmit($event)\">\n        <md-menu md-position-mode=\"target-right target\">\n          <button ng-click=\"createCowOpenMenu($mdMenu, $event)\" ng-mouseenter=\"$mdMenu.open()\"\n                  id=\"home-main-container-submit\">\n            Armar Vaca\n          </button>\n          <md-menu-content width=\"4\" ng-mouseleave=\"$mdMenu.close()\">\n            <md-menu-item class=\"home-main-container-menu-item-title\">\n              ¿Para qué es la Vaca?\n            </md-menu-item>\n            <md-menu-item class=\"home-main-container-menu-item\">\n              <md-button ui-sref=\"cow-create({\'cow_type\': \'group\', \'cow_name\': cow_name})\">\n                <div class=\"home-main-container-option\">\n                  <img src=\"assets/images/newcowcreate/group.png\" alt=\"\">\n                  <div>\n                    <span>Reunir dinero en grupo</span>\n                    <small>Paseo, asado, regalo, shower...</small>\n                  </div>\n                </div>\n              </md-button>\n            </md-menu-item>\n            <md-menu-item class=\"home-main-container-menu-item\">\n              <md-button ui-sref=\"cow-create({\'cow_type\': \'fundacion\', \'cow_name\': cow_name})\">\n                <div class=\"home-main-container-option\">\n                  <img src=\"assets/images/newcowcreate/crowdfunding.png\" alt=\"\">\n                  <div>\n                    <span>Crear una causa social</span>\n                    <small>Fundacion, donacion, ayudas hum...</small>\n                  </div>\n                </div>\n              </md-button>\n            </md-menu-item>\n            <md-menu-item class=\"home-main-container-menu-item\">\n              <md-button ui-sref=\"cow-create({\'cow_type\': \'wallet\', \'cow_name\': cow_name})\">\n                <div class=\"home-main-container-option\">\n                  <img src=\"assets/images/newcowcreate/wallet.png\" alt=\"\">\n                  <div>\n                    <span>Administrar mi dinero</span>\n                    <small>Cobrar dinero, alcancía, negocio...</small>\n                  </div>\n                </div>\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n      </form>\n    </div>\n  </div>\n  <div class=\"home-main-container-mouse hidden-sm hidden-xs\">\n    <img src=\"assets/images/home/scroll.png\" alt=\"scroll\" class=\"animated infinite bounce slow\"\n         ng-click=\"autoScroll($event,\'benefits-container\')\">\n    <br>\n    <span style=\"font-size: 10px\">Scroll</span>\n    <br>\n    <span style=\"font-size: 20px; float: left; padding-left: 20px;\">#CuidarnosEs<strong>Vaca</strong>no</span>\n  </div>\n  <div class=\"home-main-container-mouse hidden-md hidden-lg\">\n    <img src=\"assets/images/home/hand.png\" alt=\"hand\" class=\"animated infinite bounce slow\"\n         ng-click=\"autoScroll($event, \'benefits-container\')\">\n    <br>\n    <span style=\"font-size: 10px\">Swipe</span>\n    <br>\n    <span style=\"font-size: 12px; float: left; padding-left: 10px;\">#CuidarnosEs<strong>Vaca</strong>no</span>\n  </div>\n</div> --><!-- OLD VACANES BANNER --><!-- <div class=\"banner-vacanes\">\n  <div class=\"container\">\n    <div class=\"atv-col-container col-title-vacanes\">\n      <div class=\"atv-col atv-col-md-12\">\n        <h3 class=\"text-center\">Conoce <img style=\"height: 20px; margin-top: -5px\"\n                                            src=\"assets/images/vacanes/vacanes_letra.png\" alt=\"\"></h3><br>\n        <p class=\"text-center txt-home-vacanes\"><b>Vaca</b>nes es un espacio para resaltar los proyectos de\n          ArmaTuVaca con causas solidarias. Son personas increíbles que quieren lograr un cambio.</p><br>\n      </div>\n    </div>\n    <div class=\"atv-col-container target\">\n      <div class=\"col-md-4 col-sm-12 col-xs-12 margin-top-20 margin-bottom-20\" ng-repeat=\"cow in publicCows\">\n        <div class=\"container-fluid no-padding-left-right overflow-hidden no-outline\"\n             ng-click=\"goToCow(cow.cow_event_id)\">\n          <div class=\"main-top-content-cows\" ng-style=\"getBackgroudCssStyleCowShadow(cow.main_img, cow.closed)\">\n            <div class=\"div-gradiant\"></div>\n          </div>\n\n        </div>\n        <div class=\"container-shadow\">\n          <div class=\"closed-cows-bar text-center no-outline\" ng-click=\"goToCow(cow.cow_event_id)\">\n            <p class=\"font-color-white name-cow\">\n              <b>{{cow.name}}</b>\n            </p>\n          </div>\n          <div class=\"col-md-6 col-sm-6 col-xs-6 cows-info-bar no-padding\">\n            <div class=\"col-md-6 col-sm-6 col-xs-6 text-center cows-box-participants no-outline\"\n                 ng-click=\"goToCowAdmin(cow.cow_event_id)\">\n              <p class=\"p-cow-details font-color-white\">\n                <b>{{cow.participations}}\n                  <i class=\"fa fa-user\" ng-if=\"cow.participations <= 1\" aria-hidden=\"true\"></i>\n                  <i class=\"fa fa-users\" ng-if=\"cow.participations > 1\" aria-hidden=\"true\"></i>\n                </b>\n              </p>\n            </div>\n            <div class=\"col-md-6 col-sm-6 col-xs-6 text-center cows-box-total-value no-outline\"\n                 ng-click=\"goToCowAdmin(cow.cow_event_id)\">\n              <p class=\"p-cow-details\">\n                <b class=\" font-color-white\">{{cow.total_value | currency:\"$\":0}} COP</b>\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"atv-col-container\">\n      <div class=\"atv-col atv-col-md-12 margin-bottom-25\">\n        <button ng-click=\"goToPublicCows()\" class=\"btn-vacanes\">\n          <img src=\"/assets/images/vacanes/btn_see_more.png\" alt=\"btn_see_more.png\" aria-hidden=\"true\">\n        </button>\n      </div>\n    </div>\n  </div>\n</div> --><!-- OLD BENEFIT CONTAINER --><!-- <div class=\"benefits-container\">\n  <div class=\"container margin-top-20 margin-bottom-20\">\n    <h3 class=\"text-center margin-bottom-25 font-color-atv\">Ventajas de usar <b>ArmaTuVaca</b></h3>\n    <div class=\"atv-col-container\">\n      <div class=\"atv-col atv-col-md-4 benefits-container-item\">\n        <img src=\"assets/images/home/ventaja_armar_vaca.png\" alt=\"ventaja_armar_vaca\">\n      </div>\n      <div class=\"atv-col atv-col-md-4 benefits-container-item\">\n        <img src=\"assets/images/home/ventaja_asumimos.png\" alt=\"ventaja_asumimos\">\n      </div>\n      <div class=\"atv-col atv-col-md-4 benefits-container-item\">\n        <img src=\"assets/images/home/ventaja_control.png\" alt=\"ventaja_control\">\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"text-center padding-bottom-30\">\n  <button class=\"button-action\" ng-click=\"autoScroll($event, \'home-main-container\')\">Armar una Vaca</button>\n</div> --><!-- <div class=\"vs-container\">\n  <h3 class=\"text-center font-color-atv\">¿Por qué usar <b>ArmaTuVaca</b>?</h3>\n  <div class=\"atv-col-container container\">\n    <div class=\"atv-col atv-col-md-6 visible-xs visible-sm\">\n      <div class=\"vs-container-description\">\n        <h3 class=\"font-color-atv\">Saca tus propias conclusiones</h3>\n        <p>Selecciona una opción y descubre por qué usar ArmaTuVaca:</p>\n      </div>\n      <div class=\"vs-container-options\">\n        <div class=\"vs-container-options-item\" ng-repeat=\"question in atv_questions\"\n             ng-click=\"clickQuestion(question.id);autoScroll($event,\'vs-container-bubbles\')\"\n             ng-class=\"question.id === selected_atv_question ? \'question-active\': null\">\n          <img src={{question.image}} alt=\"{{question.alt}}\">\n        </div>\n      </div>\n      <br><br>\n    </div>\n    <div class=\"atv-col atv-col-md-6\">\n      <div class=\"vs-container-bubbles\">\n        <div class=\"vs-container-bubbles-item vs-container-bubbles-item-me\">\n          {{getQuestionById(selected_atv_question).question}}\n          <div class=\"vs-container-bubbles-item-triangle-right\"></div>\n        </div>\n        <div class=\"vs-container-bubbles-item\">\n          <b class=\"vs-container-bubbles-item-user vs-container-bubbles-item-user-cash\">Efectivo:</b><br>\n          <span>{{getQuestionById(selected_atv_question).cash_response}}</span>\n          <div class=\"vs-container-bubbles-item-triangle-left\"></div>\n        </div>\n        <div class=\"vs-container-bubbles-item\">\n          <b class=\"vs-container-bubbles-item-user vs-container-bubbles-item-user-bank\">Banco:</b><br>\n          <span>{{getQuestionById(selected_atv_question).bank_response}}</span>\n          <div class=\"vs-container-bubbles-item-triangle-left\"></div>\n        </div>\n        <div class=\"vs-container-bubbles-item\">\n          <b class=\"vs-container-bubbles-item-user vs-container-bubbles-item-user-atv\">ArmaTuVaca:</b><br>\n          <span>{{getQuestionById(selected_atv_question).atv_response}}</span>\n          <div class=\"vs-container-bubbles-item-triangle-left\"></div>\n        </div>\n      </div>\n    </div>\n    <div class=\"atv-col atv-col-md-6 hide-xs hide-sm vs-container-center\">\n      <div class=\"vs-container-description\">\n        <h3 class=\"font-color-atv\">Saca tus propias conclusiones</h3>\n        <p>Selecciona una opción y descubre por qué usar ArmaTuVaca:</p>\n      </div>\n      <div class=\"vs-container-options\">\n        <div class=\"vs-container-options-item\" ng-repeat=\"question in atv_questions\"\n             ng-click=\"clickQuestion(question.id)\"\n             ng-class=\"question.id === selected_atv_question ? \'question-active\': null\">\n          <img src={{question.image}}>\n        </div>\n      </div>\n    </div>\n  </div>\n</div> --><!-- OLD WENJOY LINK --><!-- <div class=\"banner-wenjoy atv-col-container\">\n  <div class=\"atv-col atv-col-md-6 banner-wenjoy-text\">\n    <p>¿Tu negocio necesita<br>una solución de<br>recaudo online?</p>\n    <a class=\"btn btn-default button-action\" href=\"https://wenjoy.com.co\">Conoce Más...</a>\n  </div>\n  <div class=\"atv-col atv-col-md-6 banner-wenjoy-mobile\">\n    <img class=\"\" src=\"assets/images/movil.png\" alt=\"movil\">\n  </div>\n</div> --><!-- OLD MEDIA LINKS --><!-- <div class=\"home-media-links talk-about-us atv-col-container\">\n  <div class=\"home-media-links-title atv-col atv-col-md-6\">\n    <h1 class=\"hidden-sm hidden-xs h1NuestraHistoria\">Nuestra<br>Historia</h1>\n    <h2 class=\"hidden-md hidden-lg\" style=\"text-align: right;\">Nuestra<br>Historia</h2>\n  </div>\n  <div class=\"home-media-links-carousel atv-col atv-col-md-6\">\n    <ui-carousel slides=\"media_slides\" slides-to-show=\"2\" slides-to-scroll=\"1\" initial-slide=\"1\" autoplay=\"true\"\n                 autoplay-speed=\"2000\" dots=\"false\">\n      <carousel-item>\n        <a href=\"{{item.link}}\" target=\"_blank\">\n          <img src=\"{{item.image}}\">\n        </a>\n      </carousel-item>\n\n      <carousel-prev>\n        <button class=\"home-media-links-carousel-button prev-btn\">\n          <i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i>\n        </button>\n      </carousel-prev>\n\n      <carousel-next>\n        <button class=\"home-media-links-carousel-button next-btn\">\n          <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n        </button>\n      </carousel-next>\n\n    </ui-carousel>\n  </div>\n</div> --><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/marketplace/marketplace.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Marketplace</b></h1><p>¡Bienvenido! ¿Sabías que puedes elegir entre comprar un producto tú solo o dividir el costo entre tus amigos?</p></div></div><div class=\"container-fluid background-color-white\"><div class=container><div class=row ng-repeat=\"companyCategory in companiesCategories\"><h2 class=\"text-center margin-bottom-20\">{{companyCategory.name}}</h2><div class=\"col-md-4 padding-top-bottom-20\" ng-repeat=\"company in companyCategory.category_companies\"><h4 class=text-center>{{company.name}}</h4><a href=\"\" ng-click=goToMpCompany(company)><div class=marketplace-list-img ng-style=getBackgroudCssStyle(company.main_image)></div></a><p class=\"ellipsis text-center\">{{company.short_description}}</p><button class=\"btn btn-default button-action-white-small no-margin-top pull-right\" ng-click=goToMpCompany(company)>Ver más</button></div></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/membershipCardCow/membershipCardCow.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center page-top-title page-title\"><div class=container><div class=row><h1 class=\"font-color-atv margin-top-40-md\"><b>Generar Carné</b></h1><p>Agrega los datos y la foto del titular del carné</p></div></div></div><div class=\"container-fluid background-color-white\"><div class=\"container margin-bottom-20 margin-top-20\"><form name=membershipCardForm novalidate ng-submit=addMember(membershipCardForm.$valid)><div class=\"col-md-offset-3 col-md-6 div-credit-card\"><div class=\"col-md-6 margin-bottom-40\"><div class=container-fluid><div class=\"crop-area-member height-250-sm-xs\"><ui-cropper class=background-color-white image=member_img_raw area-type=square result-image-size=\"{w: 300,h: 300}\" result-image-format=image/jpeg result-image=member_img result-blob=blob_member_img url-blob=url_img></ui-cropper></div><div class=\"text-center col-md-12 col-sm-12 col-xs-12\"><input class=\"center-item text-center opacity-0 no-display\" file-model=member_img_raw_file type=file id=fileInput accept=\"image/x-png, image/jpeg\"><div class=no-padding-left-xs-sm><button type=button name=button class=form-control ng-click=clickChangeMemberImage()><i class=\"fa fa-file-image-o font-color-blue\" aria-hidden=true></i> Añadir Foto</button></div></div></div></div><div class=col-md-6><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"membershipCardForm.first_name.$invalid && membershipCardForm.$submitted\"><label>Nombre</label><input id=member_first_name required name=first_name md-maxlength=30 ng-model=member.first_name placeholder=\"Ingresa tu nombre\"><div ng-messages=membershipCardForm.first_name.$error><div ng-message=required>Por favor, digita el nombre.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"membershipCardForm.last_name.$invalid && membershipCardForm.$submitted\"><label>Apellido</label><input id=member_last_name required name=last_name md-maxlength=30 ng-model=member.last_name placeholder=\"Ingresa tu apellido\"><div ng-messages=membershipCardForm.last_name.$error><div ng-message=required>Por favor, digita el apellido.</div></div></md-input-container><md-input-container class=md-block md-is-error=\"membershipCardForm.document_number.$invalid && membershipCardForm.$submitted\" flex-gt-sm=\"\"><label>N° de documento</label><input id=member_document_number ng-model=member.document_number name=document_number type=tel pattern=[0-9]{6,15} only-digits required placeholder=\"Ingresa tu número de documento\"><div ng-messages=membershipCardForm.document_number.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>El número de documento debe contener entre 6 y 15 dígitos</div></div></md-input-container><md-input-container class=\"md-block no-margin-top no-padding-left\" flex-gt-sm=\"\"><label>{{mainOption.option_type.name}}</label><md-select ng-model=member.selected_option required><md-option ng-repeat=\"option in mainOption.options\" ng-value={{option.id}}>{{option.name}}</md-option></md-select></md-input-container></div></div><div class=\"row col-md-6 col-md-offset-3 margin-top-20 no-padding-left-right-md\"><h4>¿A qué correo deseas enviar el carné?</h4><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"membershipCardForm.email.$invalid && membershipCardForm.$submitted\"><label></label><input id=member_email required name=email md-maxlength=50 type=email ng-model=member.email placeholder=\"Correo electrónico\" md-no-asterisk><div ng-messages=membershipCardForm.email.$error><div ng-message=required>Ingresa un correo electrónico</div></div></md-input-container><small id=emailHelp class=\"form-text text-muted\">Al incluir esta información, aceptas en calidad de responsable de estos datos de contacto, que nuestra plataforma envíe mensajes a esta dirección de correo. Ten en cuenta que los datos entregados serán tratados de acuerdo a nuestra <a ui-sref=privacy-policy target=_blank>política de tratamiento de datos</a>.</small></div><div class=\"row col-md-8 col-md-offset-2 no-padding-left-right-md\"><button class=\"btn btn-default button-action-pink pull-left\" ng-click=goToAdmin() type=button><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</button> <button class=\"btn btn-default button-action pull-right\" type=submit><span class=\"fa fa-floppy-o atv-icon\"></span>Enviar</button></div></form></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/membershipCardPayment/membershipCardPayment.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center page-top-title page-title\"><div class=container><div class=row><h1 class=\"font-color-atv margin-top-40-md\"><b>Generar Carné</b></h1><p>Agrega los datos y la foto del titular del carné</p></div></div></div><div class=\"container-fluid background-color-white\"><div class=container><div ng-repeat=\"participant in allParticipants track by participant.id\"><h2 class=col-md-offset-3 ng-show=\"participant.id <= currentMember\">Participante {{participant.id}} de {{payment.num_participants}} <span><img ng-show=participant.completed src=/assets/images/cow_check.png class=memberCheckImg></span></h2></div></div><div class=\"container margin-bottom-20\" ng-show=!completedRegister><form name=membershipCardForm novalidate ng-submit=addMember(membershipCardForm.$valid)><div class=\"col-md-offset-3 col-md-6 div-credit-card\"><div class=col-md-6><!--<div class=\"memberImage\" ng-style=\"getMemberImage(member.member_img)\"--><!--ng-show=\"showMemberImage\">--><!--<div class=\"no-padding-left-xs-sm margin-top-20 changeImgAdmin\">--><!--<button type=\"button\" name=\"button\" class=\"form-control font-size-13-sm-xs\" ng-click=\"showImageEdit()\">--><!--<i class=\"fa fa-file-image-o font-color-pink\" aria-hidden=\"true\"></i>--><!--Añadir Foto--><!--</button>--><!--</div>--><!--</div>--><div class=container-fluid><div class=\"crop-area-member height-250-sm-xs\"><ui-cropper class=background-color-white image=member_img_raw area-type=square result-image-size=\"{w: 300,h: 300}\" result-image-format=image/jpeg result-image=member_img result-blob=blob_member_img url-blob=url_img></ui-cropper></div><div class=\"text-center col-md-12 col-sm-12 col-xs-12\"><input class=\"center-item text-center opacity-0 no-display\" file-model=member_img_raw_file type=file id=fileInput accept=\"image/x-png, image/jpeg\"><div class=no-padding-left-xs-sm><button type=button name=button class=form-control ng-click=clickChangeMemberImage()><i class=\"fa fa-file-image-o font-color-blue\" aria-hidden=true></i> Añadir Foto<!--<i class=\"fa fa-cloud-upload font-color-blue\" aria-hidden=\"true\"></i>--><!--Subir imagen--></button></div><!--<div class=\"no-padding-left-xs-sm\">--><!--<button type=\"button\" name=\"button\" class=\"form-control\" ng-click=\"closeImageEdit()\">--><!--<i class=\"fa fa-arrow-circle-o-left font-color-pink\" aria-hidden=\"true\"></i>--><!--Volver--><!--</button>--><!--</div>--></div></div></div><div class=col-md-6><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"membershipCardForm.first_name.$invalid && membershipCardForm.$submitted\"><label>Nombre</label><input id=member_first_name required name=first_name md-maxlength=30 ng-model=member.first_name placeholder=\"Ingresa tu nombre\"><div ng-messages=membershipCardForm.first_name.$error><div ng-message=required>Por favor, digita el nombre.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"membershipCardForm.last_name.$invalid && membershipCardForm.$submitted\"><label>Apellido</label><input id=member_last_name required name=last_name md-maxlength=30 ng-model=member.last_name placeholder=\"Ingresa tu apellido\"><div ng-messages=membershipCardForm.last_name.$error><div ng-message=required>Por favor, digita el apellido.</div></div></md-input-container><md-input-container class=md-block md-is-error=\"membershipCardForm.document_number.$invalid && membershipCardForm.$submitted\" flex-gt-sm=\"\"><label>N° de documento</label><input id=member_document_number ng-model=member.document_number name=document_number type=tel pattern=[0-9]{6,15} only-digits required placeholder=\"Ingresa tu número de documento\"><div ng-messages=membershipCardForm.document_number.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>El número de documento debe contener entre 6 y 15 dígitos</div></div></md-input-container><md-input-container class=\"md-block no-margin-top no-padding-left\" flex-gt-sm=\"\"><label>{{mainOption.option_type.name}}</label><md-select ng-model=member.selected_option required><md-option ng-repeat=\"option in mainOption.options\" ng-value={{option.id}}>{{option.name}}</md-option></md-select></md-input-container></div></div><div class=\"row col-md-6 col-md-offset-3 margin-top-20 no-padding-left-right-md\"><h4>¿A qué correo deseas enviar el carné?</h4><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"membershipCardForm.email.$invalid && membershipCardForm.$submitted\"><label></label><input id=member_email required name=email md-maxlength=50 type=email ng-model=member.email placeholder=\"Correo electrónico\" md-no-asterisk><div ng-messages=membershipCardForm.email.$error><div ng-message=required>Ingresa un correo electrónico</div></div></md-input-container><small id=emailHelp class=\"form-text text-muted\">Al incluir esta información, aceptas en calidad de responsable de estos datos de contacto, que nuestra plataforma envíe mensajes a esta dirección de correo. Ten en cuenta que los datos entregados serán tratados de acuerdo a nuestra <a ui-sref=privacy-policy target=_blank>política de tratamiento de datos</a>.</small></div><div class=\"row col-md-8 col-md-offset-2 no-padding-left-right-md\"><button class=\"btn btn-default button-action pull-right\" type=submit><span class=\"fa fa-floppy-o atv-icon\"></span>Enviar</button></div></form></div><div class=\"container margin-top-20 margin-bottom-20 text-center\" ng-show=completedRegister><h1>¡Completaste el registro para todos los participantes!</h1><h3>Los carnés han sido enviados a los correos electrónicos que ingresaste</h3></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/membershipCardUpdate/membershipCardUpdate.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center page-top-title page-title\"><div class=container><div class=row><h1 class=\"font-color-atv margin-top-40-md\"><b>Generar Carné</b></h1><p>Agrega los datos y la foto del titular del carné</p></div></div></div><div class=\"container-fluid background-color-white\"><div class=\"container margin-bottom-20 margin-top-20\" ng-show=!completedRegister><form name=membershipCardForm novalidate ng-submit=updateMember(membershipCardForm.$valid)><div class=\"col-md-offset-3 col-md-6 div-credit-card\"><div class=col-md-6><div class=container-fluid><div class=\"crop-area-member height-250-sm-xs\"><ui-cropper class=background-color-white image=member_img_raw area-type=square result-image-size=\"{w: 300,h: 300}\" result-image-format=image/jpeg result-image=member_img result-blob=blob_member_img url-blob=url_img></ui-cropper></div><div class=\"text-center col-md-12 col-sm-12 col-xs-12\"><input class=\"center-item text-center opacity-0 no-display\" file-model=member_img_raw_file type=file id=fileInput accept=\"image/x-png, image/jpeg\"><div class=no-padding-left-xs-sm><button type=button name=button class=form-control ng-click=clickChangeMemberImage()><i class=\"fa fa-file-image-o font-color-blue\" aria-hidden=true></i> Añadir Foto</button></div></div></div></div><div class=col-md-6><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"membershipCardForm.first_name.$invalid && membershipCardForm.$submitted\"><label>Nombre</label><input id=member_first_name required name=first_name md-maxlength=30 ng-model=member.first_name placeholder=\"Ingresa tu nombre\"><div ng-messages=membershipCardForm.first_name.$error><div ng-message=required>Por favor, digita el nombre.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"membershipCardForm.last_name.$invalid && membershipCardForm.$submitted\"><label>Apellido</label><input id=member_last_name required name=last_name md-maxlength=30 ng-model=member.last_name placeholder=\"Ingresa tu apellido\"><div ng-messages=membershipCardForm.last_name.$error><div ng-message=required>Por favor, digita el apellido.</div></div></md-input-container><md-input-container class=md-block md-is-error=\"membershipCardForm.document_number.$invalid && membershipCardForm.$submitted\" flex-gt-sm=\"\"><label>N° de documento</label><input id=member_document_number ng-model=member.document_number name=document_number type=tel pattern=[0-9]{6,15} only-digits required placeholder=\"Ingresa tu número de documento\"><div ng-messages=membershipCardForm.document_number.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>El número de documento debe contener entre 6 y 15 dígitos</div></div></md-input-container><md-input-container class=\"md-block no-margin-top no-padding-left\" flex-gt-sm=\"\"><label>{{mainOption.option_type.name}}</label><md-select ng-model=member.selected_option required><md-option ng-repeat=\"option in mainOption.options\" ng-value={{option.id}}>{{option.name}}</md-option></md-select></md-input-container></div></div><div class=\"row col-md-6 col-md-offset-3 margin-top-20 no-padding-left-right-md\"><h4>¿A qué correo deseas enviar el carné?</h4><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"membershipCardForm.email.$invalid && membershipCardForm.$submitted\"><label></label><input id=member_email required name=email md-maxlength=50 type=email ng-model=member.email placeholder=\"Correo electrónico\" md-no-asterisk><div ng-messages=membershipCardForm.email.$error><div ng-message=required>Ingresa un correo electrónico</div></div></md-input-container></div><div class=\"row col-md-8 col-md-offset-2 no-padding-left-right-md\"><button class=\"button-action pull-right\" type=submit><span class=\"fa fa-floppy-o atv-icon\"></span>Enviar</button></div></form></div><div class=\"container margin-top-20 margin-bottom-20\" ng-show=completedRegister><h1 class=text-center>¡Tu carné ha sido enviado al correo electrónico que indicaste!</h1></div></div><div><atv-footer></atv-footer></div><script type=text/ng-template id=confirmationUpdateMember><div class=\"ngdialog-message text-center\">\n        <h3>\n            ¿Estás seguro que la foto y los datos son correctos?\n        </h3>\n        <h4>\n            Una vez envíes el carné no podrás hacer modificaciones\n        </h4>\n        <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeMemberConfirmation(ngDialogId)\"></a>\n        <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"acceptMemberConfirmation(ngDialogId)\"></a>\n    </div></script>");
$templateCache.put("app/views/participate/cowSendMoneyDialog.html","<div class=createWalletCollectFriendCowDialog><div class=\"createWalletCollectFriendCowDialog-icon text-center\"><i class=\"fa fa-money\"></i></div><div style=\"margin: 10px 0\"><p style=\"font-size: 16px; font-weight: 500; margin: 0\">!Muuuy Bien! Ahora realiza el pago para que tu contacto pueda recibir el dinero</p><br><p style=\"text-align: center\">Puedes copiar el siguiente link y enviarlo a tu contacto:</p><div class=atv-cow-share-widget-link style=\"text-align: center\"><input id=cow_link type=text name=link ng-model=completeURLSendToken readonly style=\"width: 250px\"> <button type=button name=button ngclipboard data-clipboard-text={{completeURLSendToken}} ng-click=copyLink() style=\"width: 250px; color: whitesmoke\"><i class=\"fa fa-link\" aria-hidden=true></i>&nbsp;<b>Copiar link</b></button></div><p style=\"text-align: center\"><small>En este link tu contacto podrá ingresar y reclamar el dinero</small></p><br><div style=\"text-align: center\"><button id=login_btn_submit class=button-action ng-click=closeDialog()>Continuar</button></div></div></div>");
$templateCache.put("app/views/participate/participate.html","<div><atv-navbar lang=true></atv-navbar></div><div class=\"main-top-content-participate font-color-white\" ng-style=getBackgroudCssStyle(cow_event.main_img)><div class=container><div class=\"row margin-bottom-20\"><h2 class=text-center><b>{{cow_event.name}}</b></h2><h4 class=text-center><b>{{getTraductor(\'participate.create_by\')}}: {{cow_event.made_by}}</b></h4></div></div></div><div id=top-scroll></div><div class=\"container-fluid background-color-white\" ng-show=\"!cow_event.deleted && !cow_event.closed\"><div class=container><div class=\"row col-md-8 user-data-form-content col-md-offset-2\"><div ng-show=showPersonalDataForm><!--Datos personales    --><div class=\"row text-center\"><h3 class=\"text-center margin-bottom-20\">{{getTraductor(\'participate.personal_data\')}}</h3></div><form name=personalInfoForm id=personalInfoForm ng-submit=submitPersonalForm(personalInfoForm.$valid) ng-show=showPersonalInfoForm novalidate><!--<form name=\"personalInfoForm\" id=\"personalInfoForm\" class=\"\"--><!--ng-submit=\"participateCow(personalInfoForm.$valid && user_participation.total_value >= minPaymentValue)\"--><!--novalidate>--><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=\"\"><label>{{getTraductor(\'participate.first_name\')}}</label><input required name=first_name placeholder=\"{{getTraductor(\'participate.holder_first_name\')}}\" md-maxlength=50 ng-model=user_participation.first_name><div ng-messages=personalInfoForm.first_name.$error><div ng-message=required>{{getTraductor(\'participate.required_first_name\')}}.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm=\"\"><label>{{getTraductor(\'participate.last_name\')}}</label><input required name=last_name placeholder=\"{{getTraductor(\'participate.holder_last_name\')}}\" md-maxlength=50 ng-model=user_participation.last_name><div ng-messages=personalInfoForm.last_name.$error><div ng-message=required>{{getTraductor(\'participate.required_last_name\')}}.</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-md\" flex-gt-sm=\"\"><label>{{getTraductor(\'participate.document_type\')}}</label><md-select ng-model=user_participation.document_type><md-option ng-repeat=\"document in documentTypes\" value={{document.id}}>{{document.key_type_name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block no-margin-md margin-top-30-sm-xs\" flex-gt-sm=\"\" ng-show=\"user_participation.document_type == 1 || user_participation.document_type == 2\"><label>{{getTraductor(\'participate.document_number\')}}</label><input ng-model=user_participation.document_number name=document_number type=tel pattern=[0-9]{1,15} only-digits required placeholder=\"{{getTraductor(\'participate.holder_document_number\')}}\"><div ng-messages=personalInfoForm.document_number.$error multiple md-auto-hide=true><div ng-message=required>{{getTraductor(\'participate.required_document_number\')}}</div><div ng-message=pattern>{{getTraductor(\'participate.min_document_number\')}}</div></div></md-input-container><md-input-container class=\"md-block no-margin-md margin-top-30-sm-xs\" flex-gt-sm=\"\" ng-show=\"user_participation.document_type == 3 || user_participation.document_type == 4\"><label>{{getTraductor(\'participate.document_number\')}}</label><input ng-model=user_participation.document_full_number name=document_full_number pattern=\"^(?=.*\\d).{1,15}\" ng-required=\"user_participation.document_type == 3 || user_participation.document_type == 4\" ng-change=setDocumentNumber() only-alphanumeric placeholder=\"{{getTraductor(\'participate.holder_document_number\')}}\"><div ng-messages=personalInfoForm.document_full_number.$error multiple md-auto-hide=true><div ng-message=required>{{getTraductor(\'participate.required_document_number\')}}</div><div ng-message=pattern>{{getTraductor(\'participate.min_document_number_passport\')}}</div></div></md-input-container><div ng-show=\"user_participation.document_type==2\"><i class=\"fa fa-info-circle tooltip-document\" tooltip-placement=bottom uib-tooltip=\"{{getTraductor(\'participate.document_number_nit\')}}\" aria-hidden=true></i></div></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\"><label>{{getTraductor(\'participate.email\')}}</label><input required name=email placeholder=\"{{getTraductor(\'participate.holder_email\')}}\" md-maxlength=60 ng-model=user_participation.email type=email ng-pattern=/^.+@.+\\..+$/ ><div ng-messages=personalInfoForm.email.$error><div ng-message=required>{{getTraductor(\'participate.required_email\')}}.</div><div ng-message=pattern>{{getTraductor(\'participate.invalid_email\')}}</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\"><label>{{getTraductor(\'participate.cellphone\')}}</label><input ng-model=user_participation.cellphone name=cellphone type=tel pattern=[0-9]{10,12} digits-no-indicative required placeholder=\"{{getTraductor(\'participate.holder_cellphone\')}}\"><div ng-messages=personalInfoForm.cellphone.$error multiple md-auto-hide=true><div ng-message-exp=\"[\'required\']\">{{getTraductor(\'participate.required_cellphone\')}}</div><div ng-message-exp=\"[\'pattern\']\">{{getTraductor(\'participate.min_cellphone\')}}</div></div></md-input-container></div></form><div class=\"col-md-3 col-md-offset-9 col-sm-offset-5 col-sm-7 col-xs-offset-5 col-xs-7 no-padding-left-xs-sm no-padding-right margin-bottom-10\" ng-show=showPersonalInfoForm><button type=submit form=personalInfoForm name=button class=\"form-control font-size-13-sm-xs\"><i class=\"fa fa-check font-color-atv\" aria-hidden=true></i> {{getTraductor(\'participate.btn_ok\')}}</button></div><!--Resumen datos personales--><div class=\"col-md-12 no-padding-left-right margin-bottom-10\" ng-show=!showPersonalInfoForm><div class=\"col-md-6 personal-info-payment-div\"><p class=no-margin-bottom>{{getTraductor(\'participate.name\')}}: <b>{{user_participation.first_name + \' \' + user_participation.last_name}}</b></p><p class=no-margin-bottom ng-show=\"user_participation.document_type == 1 || user_participation.document_type == 2\">{{getTraductor(\'participate.document\')}}: <b>{{user_participation.document_number}}</b></p><p class=no-margin-bottom ng-show=\"user_participation.document_type == 3 || user_participation.document_type == 4\">{{getTraductor(\'participate.document\')}}: <b>{{user_participation.document_full_number}}</b></p><p class=no-margin-bottom>{{getTraductor(\'participate.email\')}}: <b>{{user_participation.email }}</b></p><p class=no-margin-bottom>{{getTraductor(\'participate.cellphone\')}}: <b>{{user_participation.cellphone }}</b></p></div></div><div class=\"col-md-5 col-md-offset-7 col-sm-offset-3 col-sm-9 col-xs-offset-3 col-xs-9 no-padding-left-xs-sm no-padding-right margin-bottom-10\" ng-show=!showPersonalInfoForm><button type=button form=personalInfoForm name=button class=\"form-control font-size-13-sm-xs\" ng-click=showPersonalInfoFormEdit()><i class=\"fa fa-pencil-square-o font-color-blue\" aria-hidden=true></i> {{getTraductor(\'participate.edit_info\')}}</button></div><div class=row ng-show=\"cow_event.is_business && cow_event.business_type == 0\"><h3 class=\"margin-bottom-20 no-margin-top text-center\">{{getTraductor(\'participate.additional_data\')}}</h3><div class=\"padding-left-right margin-bottom-20\"><textarea rows=3 class=\"form-control no-resize\" ng-model=user_participation.message placeholder=\"{{getTraductor(\'participate.optional_field\')}}\">\n              </textarea></div></div><!--Métodos de pago--><div class=\"row text-center\" ng-if=\"!(viaPayment && sendToken)\"><h3 class=\"text-center margin-bottom-20\">{{getTraductor(\'participate.select_payment_method\')}}</h3></div><!--EFECTY--><div ng-show=\"efectyActive.active && cow_event.is_public\"><div class=\"row padding-left-right-bottom payment-method-container\"><div class=col-md-1><md-checkbox class=\"font-bold font-color-atv\" ng-click=paymentMethodToEfecty() ng-class=\"(efectyCollapsed)?\'\':\'md-checked\'\"></md-checkbox></div><div class=\"col-md-4 col-sm-5 col-xs-5 no-padding-left-right no-outline\" ng-click=paymentMethodToEfecty()><p class=payment-method-title><span>{{getTraductor(\'participate.efecty\')}}</span><br><strong ng-show=\"cow_event.pricing_plan !== null\">{{getTraductor(\'participate.efecty_fee\')}}</strong></p></div><div class=\"col-md-7 col-sm-6 col-xs-6\"><img class=\"img-responsive payment-method-image-efecty no-outline\" src=assets/images/payment-methods/efecty.png alt=payment-methods ng-click=paymentMethodToEfecty() ng-class=\"(efectyCollapsed)?\'filter-gray\':\'no-filter-gray\'\"></div></div><div uib-collapse=efectyCollapsed class=\"row padding-left-right-bottom\"><div class=\"col-md-11 no-padding-left\"><p ng-bind-html=\"getTraductor(\'participate.efecty_info\')\"></p></div></div></div><!--PSE--><div ng-show=pseActive.active><div class=\"row padding-left-right-bottom payment-method-container\"><div class=col-md-1><md-checkbox class=\"font-bold font-color-atv\" ng-click=paymentMethodToPse() ng-class=\"(pseCollapsed)?\'\':\'md-checked\'\"></md-checkbox></div><div class=\"col-md-4 col-sm-5 col-xs-5 no-padding-left-right no-outline\" ng-click=paymentMethodToPse()><p class=payment-method-title><strong class=recomended-payment-method>{{getTraductor(\'participate.recomended\')}}</strong><br><span>{{getTraductor(\'participate.debit_account\')}}</span><br><strong ng-show=\"cow_event.pricing_plan !== null\">{{getTraductor(\'participate.no_transactional_fee\')}}</strong></p></div><div class=\"col-md-7 col-sm-6 col-xs-6\"><img class=\"img-responsive payment-method-image-pse no-outline\" src=assets/images/payment-methods/pse.png alt=payment-methods ng-click=paymentMethodToPse() ng-class=\"(pseCollapsed)?\'filter-gray\':\'no-filter-gray\'\"></div></div><div uib-collapse=pseCollapsed class=\"row padding-left-right-bottom\"><div class=\"col-md-11 no-padding-left\"><p ng-bind-html=\"getTraductor(\'participate.to_pse\')\"></p></div><div class=installments-box><label>Tipo de persona:</label><select class=\"form-control div-select-payment\" required ng-model=pseOptions.psePersonTypeSelected><option value=N>Natural</option><option value=J>Jurídica</option></select></div><div class=installments-box><label>Selecciona tu banco:</label><select class=\"form-control div-select-payment\" required ng-model=pseOptions.pseBankSelected><option ng-repeat=\"bank in pseBanks\" value={{bank.code}}>{{bank.name}}</option></select></div></div></div><!--TC --><div ng-show=\"tcActive.active && cowIsPlanPro\"><div class=\"row padding-left-right-bottom payment-method-container\"><div class=col-md-1><md-checkbox class=\"font-bold font-color-atv\" ng-click=paymentMethodToCc() ng-class=\"(ccCollapsed)?\'\':\'md-checked\'\"></md-checkbox></div><div class=\"col-md-4 col-sm-5 col-xs-5 no-padding-left-right no-outline\" ng-click=paymentMethodToCc()><p class=payment-method-title><span>{{getTraductor(\'participate.credit_card\')}}</span><br><strong ng-show=\"cow_event.pricing_plan !== null\">{{getTraductor(\'participate.transactional_fee\')}}</strong></p></div><div class=\"imgs-Cc col-md-7 col-sm-6 col-xs-6 row\"><div class=text-center><img class=\"img-responsive payment-method-image-cc no-outline\" src=assets/images/payment-methods/mastercard.png alt=payment-methods ng-click=paymentMethodToCc() ng-class=\"(ccCollapsed)?\'filter-gray\':\'no-filter-gray\'\"></div><div class=text-center><img class=\"img-responsive payment-method-image-cc no-outline\" src=assets/images/payment-methods/visa.png alt=payment-methods ng-click=paymentMethodToCc() ng-class=\"(ccCollapsed)?\'filter-gray\':\'no-filter-gray\'\"></div><div class=text-center><img class=\"img-responsive payment-method-image-cc-diners no-outline\" src=assets/images/payment-methods/diners.png alt=payment-methods ng-click=paymentMethodToCc() ng-class=\"(ccCollapsed)?\'filter-gray\':\'no-filter-gray\'\"></div></div></div><div uib-collapse=ccCollapsed><div ng-show=\"userCreditCards.length>0\"><h4 class=text-center>{{getTraductor(\'participate.saved_cards\')}}</h4></div><div class=\"col-md-12 no-padding-left-right\" ng-show=\"userCreditCards.length>0\"><div class=\"col-md-8 col-md-offset-2 no-padding-left-right\"><div class=\"col-md-6 no-padding-left-right\" ng-repeat=\"credit_card in userCreditCards track by $index\"><md-list-item class=\"contact-item selected list-contact\"><img ng-if=\"credit_card.franchise==1\" src=assets/images/payment-methods/visa.png class=md-avatar alt=visa-img> <img ng-if=\"credit_card.franchise==2 || credit_card.franchise==3\" src=assets/images/payment-methods/mastercard.png class=md-avatar alt=mastercard-img> <img ng-if=\"credit_card.franchise==4\" src=assets/images/payment-methods/diners.png class=md-avatar alt=diners-img><div><p class=font-size-11>{{credit_card.card_name}}</p><p class=\"no-margin-bottom font-size-10\">**** **** **** {{credit_card.last_numbers}}</p><md-checkbox ng-model=credit_card.checked class=\"font-bold font-color-atv right-corner-item\" ng-change=checkedChanged(credit_card)></md-checkbox></div></md-list-item></div></div></div><!--<div class=\"\" ng-if=\"user && !creditCardSelected\">--><!--<h3 class=\"text-center\">Tarjeta Nueva</h3>--><!--</div>--><!--------------------------CREDIT CARD---------------><div ng-show=\"!creditCardSelected && !ccCollapsed\"><form name=ccForm novalidate><!--CARD CONTAINER--><div class=card-container><!--CARD NUMBER--><div class=card-container-input><label for=cardNumber>{{getTraductor(\'participate.number_credit_Card\')}}</label><input type=tel placeholder=\"\" cc-format=4242424242424242 id=cardNumber cc-number cc-eager-type name=ccNumber ng-model=user_participation.card.number ng-required=true></div><!--CARD EXPIRY--><div class=card-container-input><label>{{getTraductor(\'participate.month\')}}</label><select placeholder=MM ng-model=user_participation.card.month required><option value=\"\" selected hidden>MM</option><option ng-repeat=\"month in ccMonths\" value={{month.id}} class=font-color-black>{{month.key_type_name}}</option></select><label>{{getTraductor(\'participate.year\')}}</label><select placeholder=YY ng-model=user_participation.card.year name=ccExpYear required><option value=\"\" selected hidden>AA</option><option ng-repeat=\"year in ccYears\" value={{year.id}} class=font-color-black>{{year.key_type_name}}</option></select></div><!--CARD NAME--><div class=card-container-input><label>{{getTraductor(\'participate.name_credit_card\')}}<br></label><input type=text placeholder=\"\" maxlength=30 id=cardName name=ccName ng-model=user_participation.card.name ng-required=true></div><!--CARD BRAND--><div class=card-container-brand><div ng-if=\"ccForm.ccNumber.$ccEagerType==\'Diners Club\'\"><img src=assets/images/payment-methods/diners.png alt=payment-methods></div><div ng-if=\"ccForm.ccNumber.$ccEagerType==\'Visa\'\"><img src=assets/images/payment-methods/visa_white.png alt=payment-methods></div><div ng-if=\"ccForm.ccNumber.$ccEagerType==\'MasterCard\'\"><img src=assets/images/payment-methods/mastercard.png alt=payment-methods></div></div><!--CARD ATV OPACITY--><div class=card-container-logo><img src=assets/images/logo-box.png></div></div><!--FRONT CARD ERRORS--><div class=card-errors><div ng-show=\"ccForm.$submitted && !ccForm.ccNumber.$valid\"><p>{{getTraductor(\'participate.invalid_number_card\')}}.</p></div><div ng-show=\"actualMonth>user_participation.card.month && actualYear==user_participation.card.year\"><p>{{getTraductor(\'participate.invalid_expiration_date\')}}.</p></div><div ng-show=\"ccForm.$submitted && (!user_participation.card.month || !user_participation.card.year)\"><p>{{getTraductor(\'participate.invalid_expiration_date\')}}.</p></div><div ng-show=\"ccForm.$submitted && !user_participation.card.name\"><p>{{getTraductor(\'participate.invalid_card_name\')}}.</p></div><div ng-show=\"ccForm.$submitted && (ccForm.ccNumber.$ccEagerType !=\'MasterCard\' &&\n                ccForm.ccNumber.$ccEagerType !=\'Visa\' && ccForm.ccNumber.$ccEagerType !=\'Diners Club\')\"><p>{{getTraductor(\'participate.invalid_card_type\')}}</p></div></div><!--BACK CARD CONTAINER--><div class=card-back-container ng-if=\"ccForm.ccNumber.$valid &&\n              (ccForm.ccNumber.$ccEagerType ==\'MasterCard\' || ccForm.ccNumber.$ccEagerType ==\'Visa\' ||\n              ccForm.ccNumber.$ccEagerType ==\'Diners Club\')\"><div class=card-back-container-band></div><div class=card-back-container-cvc><label>{{getTraductor(\'participate.cvc\')}}</label><input type=tel id=cvc cc-cvc cc-type=ccForm.ccNumber.$ccType name=ccCvc ng-model=$parent.user_participation.card.cvc ng-required=true maxlength=3 minlength=3></div><div class=card-back-container-logo><img src=assets/images/logo-box.png></div></div><div ng-show=\"ccForm.$submitted && !ccForm.ccCvc.$valid\"><p class=\"validation-messages no-margin-top\">{{getTraductor(\'participate.invalid_cvc\')}}.</p></div></form></div><!-----------------------CARD INSTALLMENTS--------------------><div class=installments-box><label>{{getTraductor(\'participate.installments\')}}</label><select class=\"form-control div-select-payment\" placeholder=01 ng-model=user_participation.card_installments ng-init=\"user_participation.card_installments=\'1\'\" required><option ng-repeat=\"installment in ccInstallments\" value={{installment.id}}>{{installment.key_type_name}}</option></select></div><div ng-if=\"user && !creditCardSelected\"><md-checkbox ng-model=$parent.user_participation.save_credit_card aria-label=\"Checkbox 3\">{{getTraductor(\'participate.save_credit_card\')}}</md-checkbox></div></div></div><!--Participación--><div class=\"row text-center\"><h3 class=margin-top-bottom-20 ng-switch=cow_event.business_type><span ng-switch-when=1|3 ng-switch-when-separator=|>{{getTraductor(\'participate.donation\')}}</span> <span ng-switch-default>{{getTraductor(\'participate.participation\')}}</span></h3><p ng-show=\"cow_event.participation_fixed && !cow_event.marketplace\" class=no-margin-bottom><i class=\"fa fa fa-exclamation-circle font-color-atv\"></i> {{getTraductor(\'participate.label_fixed_amount\')}}.</p></div><form name=participationForm id=participationForm novalidate><div class=\"row padding-left-right\" ng-show=\"cow_event.participation_fixed && !cow_event.marketplace\"><div layout=div layout-align=\"start center\" class=participation-number-div><p class=text-center><b>{{getTraductor(\'participate.choose_number_participation\')}}</b></p><md-select name=participant_num ng-model=user_participation.fixed_participants required><md-option value=1>1</md-option><md-option value=2>2</md-option><md-option value=3>3</md-option><md-option value=4>4</md-option><md-option value=5>5</md-option><md-option value=6>6</md-option><md-option value=7>7</md-option><md-option value=8>8</md-option></md-select><p></p></div><!--<p class=\"font-size-12\">*Recuerda que se generará un cobro de--><!--{{additionalParticipantFee | currency:\"$\":\'0\'}} pesos por cada participante adicional.</p>--></div><div class=row ng-show=\"cow_event.is_business && cow_event.options && cow_event.has_options\" ng-repeat=\"participantsOptions in user_participation.participantsOptions track by participantsOptions.id\"><h4 class=\"margin-bottom-20 no-margin-top text-center\" ng-show=!cow_event.participation_fixed>{{getTraductor(\'participate.options\')}}}</h4><h4 class=\"margin-bottom-20 no-margin-top text-center\" ng-show=cow_event.participation_fixed>{{getTraductor(\'participate.participant_option\')}}} {{$index + 1}}</h4><div class=\"col-md-6 col-md-offset-right-6 margin-top-20 margin-top-35-sm-xs\" ng-repeat=\"optionObj in cow_event.options.custom_options track by $index\"><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-top no-padding-left\" flex-gt-sm=\"\"><label>{{optionObj.option_type.name}}</label><md-select ng-model=user_participation.participantsOptions[participantsOptions.id].options[$index] required ng-change=totalValueChanged() md-no-asterisk><md-option ng-repeat=\"option in optionObj.options\" value=\"{{optionObj.option_type.id+\'-\'+option.id}}\">{{option.name}}</md-option></md-select></md-input-container></div></div></div><div class=\"row padding-left-right-top\" layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\"><label ng-switch=cow_event.business_type><span ng-switch-when=1|3 ng-switch-when-separator=|>{{getTraductor(\'participate.donation_amount\')}}</span> <span ng-switch-default>{{getTraductor(\'participate.participation_amount\')}}</span></label><input ng-model=user_participation.total_value name=total_value ui-money-mask=0 type=tel required placeholder=$ ng-readonly=totalAmountReadOnly ng-change=totalValueChanged()><p ng-show=\"personalInfoForm.$submitted && user_participation.total_value && (user_participation.total_value < minPaymentValue)\" class=validation-messages>{{getTraductor(\'participate.min_amount\')}} {{minPaymentValue | currency:\"$\":\'0\'}} COP</p><p ng-show=\"personalInfoForm.$submitted && user_participation.total_value &&\n                (user_participation.total_value > maxPaymentValue)\" class=validation-messages>{{getTraductor(\'participate.max_amount\')}} {{maxPaymentValue | currency:\"$\":\'0\'}} COP</p></md-input-container></div><div class=\"row margin-bottom-10\" ng-if=\"user_participation.total_value >= minPaymentValue\"><div ng-show=\"user_participation.fixed_participants > 1\" ng-repeat=\"participantOptions in user_participation.participantsOptions track by participantOptions.id\"><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=\"pull-left font-size-13\">{{getTraductor(\'participate.participating\')}} {{$index + 1}}</p></div><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=pull-right>{{cow_event.participant_value_fixed + additionalValues[$index].additionalValue | currency:\"$\":\'0\'}} COP</p></div></div><div ng-show=cow_event.commission_added><div class=\"col-md-6 col-xs-6 col-sm-6\" ng-show=efectyCollapsed><p class=\"pull-left font-size-13\">{{getTraductor(\'participate.cost_service\')}}</p></div><div class=\"col-md-6 col-xs-6 col-sm-6\" ng-show=efectyCollapsed><p class=pull-right>{{commission_value | currency:\"$\":\'0\'}} COP</p></div><div class=\"col-md-6 col-xs-6 col-sm-6\" ng-show=!efectyCollapsed><p class=\"pull-left font-size-13\">{{getTraductor(\'participate.efecty_cost_service\')}}</p></div><div class=\"col-md-6 col-xs-6 col-sm-6\" ng-show=!efectyCollapsed><p class=pull-right>{{commission_value / 1.19 | currency:\"$\":\'0\'}} COP</p></div><div class=\"col-md-6 col-xs-6 col-sm-6\" ng-show=!efectyCollapsed><p class=\"pull-left font-size-13\">{{getTraductor(\'participate.tax_cost_service\')}}</p></div><div class=\"col-md-6 col-xs-6 col-sm-6\" ng-show=!efectyCollapsed><p class=pull-right>{{commission_value - (commission_value / 1.19) | currency:\"$\":\'0\'}} COP</p></div><!--<div ng-show=\"user_participation.fixed_participants > 1\">--><!--<div class=\"col-md-6 col-xs-6 col-sm-6\">--><!--<p class=\"pull-left font-size-13\">--><!--Cobro por participante adicional (x{{user_participation.fixed_participants - 1}})--><!--</p>--><!--</div>--><!--<div class=\"col-md-6 col-xs-6 col-sm-6\">--><!--<p class=\"pull-right\">--><!--{{multiple_participants_fee | currency:\"$\":\'0\'}}--><!--</p>--><!--</div>--><!--</div>--><div class=\"col-md-6 col-xs-6 col-sm-6\" ng-show=\"gift_code_obj.type==0 || gift_code_obj.type==1\"><p class=\"pull-left font-size-13\">{{gift_code_obj.name}}</p></div><div class=\"col-md-6 col-xs-6 col-sm-6\" ng-show=\"gift_code_obj.type==0 || gift_code_obj.type==1\"><p class=pull-right>-{{gift_code_obj.discount_value | currency:\"$\":\'0\'}} COP</p></div><div class=\"col-md-12 col-xs-12 col-sm-12 no-padding\"><hr class=hr-partipation></div></div><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=\"pull-left font-size-15\"><b>{{getTraductor(\'participate.total_to_pay\')}}</b></p></div><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=pull-right>{{total_value_commission | currency:\"$\":\'0\'}} COP</p></div></div><div ng-if=\"user_participation.total_value >= minPaymentValue && !cowIsPlanPro\"><p class=advise-cuatroPorMil><i class=\"fa fa-info-circle\"></i> Esta es una Vaca Básica, por lo que se le cobrará el impuesto del 4x1000 al organizador, y de tu aporte recibirá <b>{{(user_participation.total_value-user_participation.total_value*0.004) | currency:\"$\":\'0\'}} COP</b>. Si quieres que el organizador reciba exáctamente los <b>{{user_participation.total_value | currency:\"$\":\'0\'}} COP</b>, tendrás que aportar <b>{{(user_participation.total_value/0.996) | currency:\"$\":\'0\'}} COP</b> (considerando el 0.4% que establece el impuesto).</p></div><!-- Reminder Payment --><div ng-if=cow_event.reminder_payment><md-checkbox ng-model=reminder_payment.enabled aria-label=Recordatorio ng-change=verifyUserLoggedIn()><b>¿Deseas realizar este pago mensualmente?</b></md-checkbox><div ng-if=reminder_payment.enabled><p style=\"margin: 0\">Si seleccionas esta opción te llegara mensualmente un recordatorio a tu correo para pagar en esta Vaca</p></div></div><div class=\"row padding-left-right-top\" layout-gt-sm=row ng-show=\"cow_event.business_type == 1\"><md-checkbox ng-model=user_participation.hide_identity aria-label=\"Checkbox 1\">{{getTraductor(\'participate.anonymous_donation\')}}</md-checkbox><i class=\"fa fa-info-circle tooltip-cow-option\" tooltip-placement=left uib-tooltip=\"Tu nombre no se mostrará en la lista de participantes\" aria-hidden=true></i></div><div class=\"row padding-left-right-top\" layout-gt-sm=row ng-show=\"cow_event.business_type == 1\"><md-checkbox ng-model=user_participation.hide_total_amount aria-label=\"Checkbox 1\">{{getTraductor(\'participate.hidden_donation\')}}</md-checkbox><i class=\"fa fa-info-circle tooltip-cow-option\" tooltip-placement=left uib-tooltip=\"{{getTraductor(\'participate.alert_hidden_donation\')}}\" aria-hidden=true></i></div></form><!--Cupón--><div class=\"row text-center margin-top-5 padding-left-right-bottom\" ng-show=\"cow_event.has_promo_code && !cow_has_gift_code\"><div class=form-group><input id=cow_link type=text name=link ng-model=gift_code class=\"form-control col-md-8 input-link-share\" placeholder=\"Tienes un código promocional?\"><div class=\"col-md-4 col-sm-6 col-xs-6 no-padding-left-right-xs-sm\"><button type=button name=button class=\"form-control font-size-13-sm-xs\" ngclipboard data-clipboard-target=#cow_link ng-click=applyCoupon()><i class=\"fa fa-gift\" aria-hidden=true></i> {{getTraductor(\'participate.apply_code\')}}</button></div></div></div></div><!--<div ng-show=\"showSummary\" class=\"padding-15\">--><div ng-show=showSummary class=padding-15><div class=\"row text-center\"><h3 class=text-center>{{getTraductor(\'participate.confirm_data_title\')}}</h3><p><b>{{getTraductor(\'participate.confirm_data\')}}</b></p></div><div class=row><h4>{{getTraductor(\'participate.responsible_data_payment\')}}</h4><p class=no-margin-bottom>{{getTraductor(\'participate.name\')}}: <b>{{user_participation.first_name + \' \' + user_participation.last_name}}</b></p><p class=no-margin-bottom ng-show=\"user_participation.document_type == 1 || user_participation.document_type == 2\">{{getTraductor(\'participate.document\')}}: <b>{{user_participation.document_number}}</b></p><p class=no-margin-bottom ng-show=\"user_participation.document_type == 3 || user_participation.document_type == 4\">{{getTraductor(\'participate.document\')}}: <b>{{user_participation.document_full_number}}</b></p><p class=no-margin-bottom>{{getTraductor(\'participate.email\')}}: <b>{{user_participation.email }}</b></p><p class=no-margin-bottom>{{getTraductor(\'participate.cellphone\')}}: <b>{{user_participation.cellphone }}</b></p></div><div class=row><hr></div><div class=row><h4>{{getTraductor(\'participate.payment_method\')}}</h4><div ng-show=efectySummary><div class=\"col-md-2 no-padding-left\"><img class=\"img-responsive payment-method-image-efecty no-outline\" src=assets/images/payment-methods/efecty.png alt=payment-methods></div><div class=\"col-md-10 no-padding-left\"><ul><li ng-bind-html=\"getTraductor(\'participate.first_label_efecty\')\"></li><li ng-bind-html=\"getTraductor(\'participate.second_label_efecty\')\"></li><li ng-bind-html=\"getTraductor(\'participate.third_label_efecty\')\"></li></ul></div></div><div ng-show=pseSummary><div class=\"col-md-1 no-padding-left\"><img class=\"img-responsive payment-method-image-pse no-outline\" src=assets/images/payment-methods/pse.png alt=payment-methods></div><div class=\"col-md-11 no-padding-left\"><ul><li ng-bind-html=\"getTraductor(\'participate.first_label_pse\')\"></li><li ng-bind-html=\"getTraductor(\'participate.second_label_pse\')\"></li><li ng-bind-html=\"getTraductor(\'participate.third_label_pse\')\"></li></ul></div></div><div ng-show=ccSummary><div class=\"col-md-1 col-xs-3 no-padding-left\"><img ng-if=\"ccForm.ccNumber.$ccEagerType==\'Diners Club\'\" class=\"img-responsive payment-method-image-card-diners\" src=assets/images/payment-methods/diners.png alt=diners-img> <img ng-if=\"ccForm.ccNumber.$ccEagerType==\'Visa\'\" class=\"img-responsive payment-method-image-card-visa\" src=assets/images/payment-methods/visa.png alt=visa-img> <img ng-if=\"ccForm.ccNumber.$ccEagerType==\'MasterCard\'\" class=\"img-responsive payment-method-image-card-mc\" src=assets/images/payment-methods/mastercard.png alt=mastercard-img></div><div class=\"col-md-11 col-xs-9 no-padding-left\"><p>**** **** **** {{ccLastNumbers}}<br>{{user_participation.card.name}}</p></div></div><div ng-show=ccTokenSummary><div class=\"col-md-1 col-xs-3 no-padding-left\"><img ng-if=\"creditCardSelected.franchise==1\" src=assets/images/payment-methods/visa.png class=\"img-responsive payment-method-image-card-visa\" alt=visa-img> <img ng-if=\"creditCardSelected.franchise==2 || creditCardSelected.franchise==3\" src=assets/images/payment-methods/mastercard.png class=\"img-responsive payment-method-image-card-mc\" alt=mastercard-img> <img ng-if=\"creditCardSelected.franchise==4\" src=assets/images/payment-methods/diners.png class=\"img-responsive payment-method-image-card-diners\" alt=diners-img></div><div class=\"col-md-11 col-xs-9 no-padding-left\"><p>**** **** **** {{creditCardSelected.last_numbers}}<br>{{creditCardSelected.card_name}}</p></div></div></div><div ng-show=!efectySummary><div class=row><hr></div><div><p class=no-margin-bottom style=\"color: grey\" ng-bind-html=\"getTraductor(\'participate.evolution_payment\')\"></p></div><div class=row><hr></div></div><div class=row><p class=no-margin-bottom>{{getTraductor(\'participate.value_pay\')}}<br><b style=\"font-size: 22px\">{{total_value_commission | currency:\"$\":\'0\'}} COP</b></p></div></div><div ng-show=showSummary class=margin-top-10><md-checkbox ng-model=user_participation.send_promotional_emails aria-label=\"Checkbox 3\">{{getTraductor(\'participate.notify_atv\')}}</md-checkbox><md-checkbox ng-model=acceptTermsConditions aria-label=\"Checkbox 3\" class=no-margin><span ng-bind-html=\"getTraductor(\'participate.terms_condi\')\"></span></md-checkbox><p ng-show=!acceptTermsConditions class=validation-messages>{{getTraductor(\'participate.valid_term_condi\')}}</p></div><div class=\"row padding-left-right-bottom\" ng-show=payment_pending><br><p ng-show=payment_pending ng-bind-html=\"getTraductor(\'participate.verification_pay\')\"></p><br><br></div><div id=container_recaptchaV2></div><div class=\"row padding-15\"><!--<button class=\"btn btn-default button-action-small-pink pull-left\" type=\"button\"--><!--ng-click=\"goToCow(cow_event.cow_event_id)\" ng-show=\"showPersonalDataForm\">--><!--<i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=\"true\"></i>Volver a la Vaca--><!--</button>--> <a href=\"\" ng-click=\"returnToCow(cow_event.cow_event_id, user.id)\" ng-show=showPersonalDataForm class=\"return-payment-link font-color-pink\"><b><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>{{getTraductor(\'participate.return\')}}</b></a><!--<button class=\"btn btn-default button-action-small-pink pull-left\" type=\"button\"--><!--ng-click=\"backToPersonalDataForm()\" ng-show=\"showSummary\">--><!--<i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=\"true\"></i>Volver--><!--</button>--> <a href=\"\" ng-click=backToPersonalDataForm() ng-show=showSummary class=\"return-payment-link font-color-pink\"><b><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>{{getTraductor(\'participate.return\')}}</b></a> <button ng-click=submitPayment() class=\"btn btn-default button-action-small pull-right\" ng-show=showPersonalDataForm>{{getTraductor(\'participate.continue\')}}</button> <button ng-click=confirmPayment() class=\"btn btn-default button-action-small pull-right\" ng-show=\"!payment_pending && showSummary\" ng-disabled=secondValidation>{{getTraductor(\'participate.make_payment\')}}</button><!--<button class=\"btn btn-default button-action-small pull-right\"--><!--ng-click=\"user_participation.force_payment_pending=true; confirmPayment()\"--><!--ng-show=\"payment_pending && showSummary\">--><!--Reintentar pago--><!--</button>--></div></div></div></div><form-submitter></form-submitter><div class=loader-payment ng-show=payment_redirect><div class=container><h1 class=\"font-color-white text-center title-loader-payment\">{{getTraductor(\'participate.payment_redirect\')}}</h1></div><div class=spinner-payment><div class=cube1-payment></div><div class=cube2-payment></div></div></div><div><atv-footer></atv-footer></div><script type=text/ng-template id=politicalTermsDialog><div class=\"ngdialog-message text-center\">\n    <h4>\n      {{getTraductor(\'participate.title_political_term_dialog\')}}\n    </h4>\n    <p class=\"font-size-10\" ng-bind-html=\"getTraductor(\'participate.political_term_dialog\')\"></p>\n    <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"goToCow(cow_event.cow_event_id)\"></a>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"acceptPoliticalTerms(ngDialogData)\"></a>\n  </div></script><script type=text/ng-template id=notifyAlertDialog><div class=\"ngdialog-message text-center\">\n    <div ng-bind-html=\"notifyAlert[0].text_area_value\"></div>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"acceptNotifyAlert(ngDialogData)\"></a>\n  </div></script><script type=text/ng-template id=reminderPaymentOption><div class=\"ngdialog-message text-center\">\n    <div style=\"margin-bottom: 20px; font-size: 20px\"><b>Debes registrarte y/o inciar sesión para usar esta opción</b></div>\n    <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"acceptLoginUser(ngDialogData)\"></a>\n  </div></script>");
$templateCache.put("app/views/paymentRespond/paymentRespond.html","<div ng-if=!isFepCow><div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title-payment\"><h1 class=\"font-color-atv margin-top-40-md\" ng-if=\"paymentResp.status==1\"><b>¡Gracias por participar!</b></h1><h1 class=\"font-color-atv margin-top-40-md\" ng-if=\"paymentResp.status==1000 || paymentResp.status==4000\"><b>Pago Rechazado</b></h1><h1 class=\"font-color-atv margin-top-40-md\" ng-if=\"paymentResp.status==102 || paymentResp.status==103\"><b>Pago Abandonado</b></h1><h1 class=\"font-color-atv margin-top-40-md\" ng-if=\"paymentResp.status==4001 || paymentResp.status==999 || paymentResp.status==888\"><b>Pago Pendiente</b></h1><p ng-if=\"paymentResp.status==1\">Un correo de confirmación de tu pago será enviado a <b class=font-bold>{{paymentResp.participant.email}}</b>.<!--        <br>--><!--        Tu pago fue procesado y aprobado con la tecnología de nuestro botón de pagos:<br>--><!--        <img src=\"/assets/images/payment-methods/wenjoy.png\" class=\"wenjoy-logo\"/>--></p></div></div><div class=\"container-fluid background-color-white\"><div class=container><div class=row ng-if=\"paymentResp.status==1\"><div class=\"col-md-12 text-center margin-top-bottom-20\"><h1 class=no-margin-bottom>{{paymentResp.cow_event.name}}</h1><h3 class=no-margin-top>{{paymentResp.cow_event.made_by}}</h3><div class=row><h4 class=\"col-md-3 col-md-offset-3\">Participación</h4><h4 class=\"col-md-3 col-md-offset-right-3\">{{paymentResp.total_value | currency:\"$\":\'0\'}} COP</h4></div><div class=row><h4 class=\"col-md-3 col-md-offset-3\">Participante</h4><h4 class=\"col-md-3 col-md-offset-right-3\">{{paymentResp.participant.first_name + \' \' + paymentResp.participant.last_name}}</h4></div><div class=row><h4 class=\"col-md-3 col-md-offset-3\">Fecha</h4><h4 class=\"col-md-3 col-md-offset-right-3\">{{paymentResp.approved_date | date:\'dd/MM/yyyy\'}}</h4></div><div class=row><h4 class=\"col-md-3 col-md-offset-3\">Estado</h4><h4 class=\"col-md-3 col-md-offset-right-3 font-color-atv font-bold\">Aprobado</h4></div><div class=row><div class=\"padding-15 text-center col-md-2 col-md-offset-3\"><button class=\"btn btn-default button-action-white\" ng-click=goToHowItWorks()><i class=\"fa fa-info-circle atv-icon\" aria-hidden=true></i>Conocer más</button></div><div class=\"padding-15 text-center col-md-2\"><button class=\"btn btn-default button-action-white\" ng-click=goToCow(paymentResp.cow_event.cow_event_id)>Ir a la Vaca</button></div><div class=\"padding-15 text-center col-md-2 col-lg-offset-right-3\"><button class=\"btn btn-default button-action-white\" ng-click=goToAccount()><i class=\"fa fa-user atv-icon\" aria-hidden=true></i>Ir a mi cuenta</button></div><div class=\"padding-15 text-center col-md-12\" style=\"margin: auto\" ng-if=\"paymentResp.status==1\"><h4>¿Cómo te pareció la experiencia de pago? ¡Califícanos!</h4><a class=\"btn btn-default button-action-blue\" href=https://g.page/Armatuvaca/review target=_blank><i class=\"fa fa-star\" aria-hidden=true></i> Calificar</a></div></div></div></div><div class=\"row margin-top-bottom-20\" ng-if=\"paymentResp.status==1000 || paymentResp.status==4000\"><div class=\"col-md-3 text-center\"><img class=\"img-circle box-shadow-img\" src=assets/images/how-it-works/step-3.png alt=img-home></div><div class=\"col-md-9 margin-top-bottom-20\"><p>Hola {{paymentResp.participant.first_name}} tu pago por <b class=font-color-atv>{{paymentResp.total_value | currency:\"$\":\'0\'}} COP</b> no pudo ser procesado y fue <b class=font-color-pink>rechazado</b>.</p><p ng-if=\"paymentResp.via==4 || paymentResp.via==5\">Por favor intenta realizar un nuevo pago, y ten en cuenta las siguientes recomendaciones:</p><ul ng-switch=paymentResp.via><li ng-switch-when=4>Asegurate de que estás registrado para hacer pagos con PSE.</li><li ng-switch-when=4>Ten presente la clave virtual registrada con tu entidad bancaria.</li><li ng-switch-when=4>Verifica el monto máximo que puedes pagar en línea.</li><li ng-switch-when=5>Asegurate que tu tarjeta de crédito está habilitada para pagos online.</li><li ng-switch-when=5>Si haces el pago desde el exterior o utilizando una tarjeta de crédito extranjera, verifica que tu tarjeta puede ser utilizada en sitios web de Colombia.</li></ul><p>Si tienes alguna pregunta o el pago vuelve a ser rechazado contáctate con tu entidad bancaria o con nosotros.</p><button class=button-action ng-click=retryPayment(paymentResp.cow_event.cow_event_id)>Reintentar pago</button></div></div><div class=\"row margin-top-bottom-20\" ng-if=\"paymentResp.status==102 || paymentResp.status==103\"><div class=\"col-md-3 text-center\"><img class=\"img-circle box-shadow-img\" src=assets/images/how-it-works/step-3.png alt=img-home></div><div class=\"col-md-9 margin-top-bottom-20\"><p>Hola {{paymentResp.participant.first_name}}, tu pago por <b class=font-color-atv>{{paymentResp.total_value | currency:\"$\":\'0\'}} COP</b> no pudo ser procesado ya que se venció el tiempo dentro del cual se podía realizar.<br><br>Por favor inténtalo de nuevo y recuerda que tienes <b>10 minutos</b> para completar el pago.</p><button class=button-action ng-click=retryPayment(paymentResp.cow_event.cow_event_id)>Reintentar pago</button></div></div><div class=\"row margin-top-bottom-20\" ng-if=\"paymentResp.status==4001 || paymentResp.status==999\"><div class=\"col-md-3 text-center\"><img class=\"img-circle box-shadow-img\" src=assets/images/how-it-works/step-3.png alt=img-home></div><div class=\"col-md-9 margin-top-bottom-20\"><p>Hola {{paymentResp.participant.first_name}} tu pago por <b class=font-color-atv>{{paymentResp.total_value | currency:\"$\":\'0\'}} COP</b> se encuentra <b class=font-color-blue>pendiente</b> de aprobación por la entidad bancaria.<br><br>Cuando el estado de tu pago cambie te notificaremos por correo electrónico.</p></div><div class=\"padding-15 text-center col-md-12\"><button class=\"btn btn-default button-action-white\" ng-click=goToCow(paymentResp.cow_event.cow_event_id)>Ir a la Vaca</button></div></div><div class=\"row margin-top-bottom-20\" ng-if=\"paymentResp.status==888 && paymentResp.via != 6\"><div class=\"col-md-3 text-center\"><img class=\"img-circle box-shadow-img\" src=assets/images/how-it-works/step-3.png alt=img-home></div><div class=\"col-md-9 margin-top-bottom-20\"><p>Hola {{paymentResp.participant.first_name}} tu pago por <b class=font-color-atv>{{paymentResp.total_value | currency:\"$\":\'0\'}} COP</b> se encuentra <b class=font-color-blue>pendiente</b> de ser procesado por la entidad bancaria.<br><br>Cuando el estado de tu pago cambie te notificaremos por correo electronico.</p></div><div class=\"padding-15 text-center col-md-12\"><button class=\"btn btn-default button-action-white\" ng-click=goToCow(paymentResp.cow_event.cow_event_id)>Ir a la Vaca</button></div></div><div class=\"row margin-top-bottom-20\" ng-if=\"paymentResp.status==888 && paymentResp.via == 6\"><div class=\"col-md-3 text-center efecty-logo-container\"><img src=assets/images/payment-methods/efecty.png alt=efecty-logo></div><div class=\"col-md-9 margin-top-bottom-20\"><p>¡Hola {{paymentResp.participant.first_name}}! Tu pago por <b class=font-color-atv>{{paymentResp.total_value | currency:\"$\":\'0\'}} COP</b> se encuentra <b class=font-color-blue>pendiente</b> de ser completado.<br><br>Para completar tu pago solo debes:<br>1. Acercarte a un <a href=https://www.efecty.com.co/web/puntos-de-atencion target=_blank><b>Punto Efecty</b></a><br><br>2. Informarle al cajero que harás un pago con el convenio <b>111855 ARMA TU VACA RECAUDO</b><br><br>3. Entregar el siguiente número de Referencia: <strong>{{paymentResp.payment_id}}. </strong><br><br>Recuerda que debes llevar tu documento de identidad y los datos deben corresponder con los registrados en la plataforma.<br>Ah, y por si acaso esta información también la hemos enviado al correo electrónico <b>{{paymentResp.participant.email}}</b></p></div><div class=\"padding-15 text-center col-md-12\"><button class=\"btn btn-default button-action-white\" ng-click=goToCow(paymentResp.cow_event.cow_event_id)>Ir a la Vaca</button></div></div></div></div><!-- <div class=\"banner-wenjoy atv-col-container\"\n       style=\"background-image: url(\'assets/images/vacanes/vacanes_back.jpg\'); background-size: cover\">\n    <div class=\"atv-col atv-col-md-12 banner-wenjoy-text\">\n      <p>¿Conoces<br>a nuestros <img style=\"height: 20px; margin-top: -5px\"\n                                     src=\"assets/images/vacanes/vacanes_letra.png\" alt=\"\">?</p>\n      <a class=\"btn btn-default button-action\" ui-sref=\"public-cow\" ui-sref-opts=\"{reload:true}\">Conoce Más...</a>\n    </div>\n  </div> --><div><atv-footer></atv-footer></div></div><div ng-if=isFepCow><div><fep-navbar></fep-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title-fep fep-piggy-background\"><h1 class=\"font-color-gray margin-top-40-md\" ng-if=\"paymentResp.status==1\"><b>¡Gracias por participar!</b></h1><h1 class=\"font-color-gray margin-top-40-md\" ng-if=\"paymentResp.status==1000 || paymentResp.status==4000\"><b>Pago Rechazado</b></h1><h1 class=\"font-color-gray margin-top-40-md\" ng-if=\"paymentResp.status==102 || paymentResp.status==103\"><b>Pago Abandonado</b></h1><h1 class=\"font-color-gray margin-top-40-md\" ng-if=\"paymentResp.status==4001 || paymentResp.status==999 || paymentResp.status==888\"><b>Pago Pendiente</b></h1><p class=font-bold ng-if=\"paymentResp.status==1\">Tu participación de <b class=font-color-fep>{{paymentResp.total_value | currency:\"$\":\'0\'}} COP</b> en la Alcancía <b class=font-color-fep>{{paymentResp.cow_event.name}}</b> organizada por <b class=font-color-fep>{{paymentResp.cow_event.made_by}}</b> ha sido <b class=font-color-fep>aprobada</b>.<br>Un correo de confirmación de tu pago será enviado a <b class=font-color-fep>{{paymentResp.participant.email}}</b></p></div></div><div class=\"container-fluid background-color-white\"><div class=container><div class=row ng-if=\"paymentResp.status==1\"><div class=\"col-md-12 text-center margin-top-bottom-20\"><img class=cow-img-payment-resp-fep src=assets/images/fep/fep-cow-image.png alt=img-home><h1>{{paymentResp.cow_event.name}}</h1><div class=row><h4 class=\"col-md-3 col-md-offset-3\">Participación</h4><h4 class=\"col-md-3 col-md-offset-right-3\">{{paymentResp.total_value | currency:\"$\":\'0\'}} COP</h4></div><div class=row><h4 class=\"col-md-3 col-md-offset-3\">Participante</h4><h4 class=\"col-md-3 col-md-offset-right-3\">{{paymentResp.participant.first_name + \' \' + paymentResp.participant.last_name}}</h4></div><div class=row><h4 class=\"col-md-3 col-md-offset-3\">Fecha</h4><h4 class=\"col-md-3 col-md-offset-right-3\">{{paymentResp.approved_date | date:\'dd/MM/yyyy\'}}</h4></div><div class=row><div class=\"padding-15 text-center col-md-12\"><button class=\"btn btn-default button-action-small-fep\" ng-click=goToFepCow(paymentResp.cow_event.cow_event_id)>Ver la Alcancía</button></div></div></div></div><div class=\"row margin-top-bottom-20\" ng-if=\"paymentResp.status==1000 || paymentResp.status==4000\"><div class=\"col-md-offset-2 col-md-8 col-md-offset-right-2 margin-top-bottom-20\"><p>Hola {{paymentResp.participant.first_name}} tu pago por <b class=font-color-fep>{{paymentResp.total_value | currency:\"$\":\'0\'}} COP</b> no pudo ser procesado y fue <b class=font-color-pink>rechazado</b>.</p><p ng-if=\"paymentResp.via==4 || paymentResp.via==5\">Por favor intenta realizar un nuevo pago, y ten en cuenta las siguientes recomendaciones:</p><ul ng-switch=paymentResp.via><li ng-switch-when=4>Asegurate de que estás registrado para hacer pagos con PSE.</li><li ng-switch-when=4>Ten presente la clave virtual registrada con tu entidad bancaria.</li><li ng-switch-when=4>Verifica el monto máximo que puedes pagar en línea.</li><li ng-switch-when=5>Asegurate que tu tarjeta de crédito está habilitada para pagos online.</li><li ng-switch-when=5>Si haces el pago desde el exterior o utilizando una tarjeta de crédito extranjera, verifica que tu tarjeta puede ser utilizada en sitios web de Colombia.</li></ul><p>Si tienes alguna pregunta o el pago vuelve a ser rechazado contáctate con tu entidad bancaria o con nosotros.</p><button class=\"btn btn-default button-action-small-fep\" ng-click=retryFepPayment(paymentResp.cow_event.cow_event_id)>Reintentar pago</button></div></div><div class=\"row margin-top-bottom-20\" ng-if=\"paymentResp.status==102 || paymentResp.status==103\"><div class=\"col-md-offset-2 col-md-8 col-md-offset-right-2 margin-top-bottom-20\"><p>Hola {{paymentResp.participant.first_name}}, tu pago por <b class=font-color-fep>{{paymentResp.total_value | currency:\"$\":\'0\'}} COP</b> no pudo ser procesado ya que se venció el tiempo dentro del cual se podía realizar.<br><br>Por favor inténtalo de nuevo y recuerda que tienes <b>10 minutos</b> para completar el pago.</p><button class=\"btn btn-default button-action-small-fep\" ng-click=retryFepPayment(paymentResp.cow_event.cow_event_id)>Reintentar pago</button></div></div><div class=\"row margin-top-bottom-20\" ng-if=\"paymentResp.status==4001 || paymentResp.status==999\"><div class=\"col-md-offset-2 col-md-8 col-md-offset-right-2 margin-top-bottom-20\"><p>Hola {{paymentResp.participant.first_name}} tu pago por <b class=font-color-fep>{{paymentResp.total_value | currency:\"$\":\'0\'}} COP</b> se encuentra <b class=font-color-blue>pendiente</b> de aprobación por la entidad bancaria.<br><br>Cuando el estado de tu pago cambie te notificaremos por correo electrónico.</p></div></div><div class=\"row margin-top-bottom-20\" ng-if=\"paymentResp.status==888\"><div class=\"col-md-offset-2 col-md-8 col-md-offset-right-2 margin-top-bottom-20\"><p>Hola {{paymentResp.participant.first_name}} tu pago por <b class=font-color-fep>{{paymentResp.total_value | currency:\"$\":\'0\'}} COP</b> se encuentra <b class=font-color-blue>pendiente</b> de ser procesado por la entidad bancaria.<br><br>Cuando el estado de tu pago cambie te notificaremos por correo electronico.</p></div></div></div></div><div><fep-footer></fep-footer></div></div>");
$templateCache.put("app/views/prices/prices.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Planes</b></h1><p>Te ofrecemos diferentes planes para diferentes necesidades</p></div></div><div class=bank-transfer-pricing><div class=\"container atv-col-container\"><div class=\"atv-col atv-col-md-6 pricing-plan-container\"><div class=pricing-plan><div class=text-center><h1>Plan Gratis*</h1><p>*No incluye impuesto 4x1000</p></div><div class=\"gradient-line col-md-6 col-md-offset-3\"></div><ul><li><strong>Invita</strong> a participar en tu Vaca</li><li>Recibe pagos con <strong>PSE</strong> (débito cuenta bancaria)</li><li>Haz un retiro total de la plata a una <strong>cuenta bancaria en Colombia</strong></li><li>Recibe un monto total en la Vaca de máximo <strong>$1.000.000 COP</strong></li></ul><div><a href=\"\" ng-click=goToCalculator(1)>Ver Ejemplo</a></div><button class=button-action-pink ng-click=goCreateCow(1)>Armar una Vaca</button></div></div><div class=\"atv-col atv-col-md-6 pricing-plan-container\"><div class=pricing-plan><div class=text-center><h1>Plan Pro</h1><p>{{highValueCowPercentageFee}}% + IVA**</p></div><div class=\"gradient-line col-md-6 col-md-offset-3\"></div><ul><li>Armatuvaca asume el <strong>4x1000</strong></li><li>Recibe pagos con <strong>Tarjeta de crédito*** y PSE</strong></li><li><strong>Sin topes máximos</strong> en el monto total de tu Vaca</li><li>Haz <strong>retiros parciales</strong> a una cuenta bancaria o a <strong>Efecty, Nequi o Daviplata</strong></li></ul><div><a href=\"\" ng-click=goToCalculator(2)>Ver Ejemplo</a></div><button class=button-action-pink ng-click=goCreateCow(2)>Armar una Vaca</button></div></div><!-- <div class=\"atv-col atv-col-md-4 pricing-plan-container\">\n      <div class=\"pricing-plan\">\n          <div>\n              <h1>Plan Vacanes</h1>\n              <p>{{publicCowFee}}% + IVA**</p>\n          </div>\n        <div class=\"gradient-line col-md-6 col-md-offset-3\"></div>\n        <ul>\n          <li>Todo lo del plan <strong>PRO</strong></li>\n          <li>Recibe pagos en <strong>efectivo (Efecty)</strong></li>\n          <li>Tu Vaca será visible en nuestra sección de <strong>Vacanes</strong></li>\n          <li>Permite <strong>cobro recurrente</strong> a los participantes de tu Vaca </li>\n          <li>Visibilidad en nuestras <strong>redes sociales</strong></li>\n        </ul>\n          <div>\n              <a href=\"\" ng-click=\"goToCalculator(3)\">Ver Ejemplo</a>\n          </div>\n        <button class=\"button-action-pink\" ng-click=\"goCreateCow(3)\">Armar una Vaca</button>\n      </div>\n    </div> --><div id=feeMessageContainer class=feeMessageContainer><p class=\"font-bold padding-10 no-margin\">**Costo de servicio sobre el monto recolectado en la Vaca<br>***Los pagos con tarjeta generan un costo transaccional de 1.99% + IVA que se cobra al participante</p></div></div></div><div id=calculator><cashout-calculator selected-fee=selectedFee></cashout-calculator></div><div class=\"banner-wenjoy atv-col-container\"><div class=\"atv-col atv-col-md-6 banner-wenjoy-text\"><p>¿Tienes un negocio? Conoce<br>nuestra solución de<br>recaudo online</p><a class=\"btn btn-default button-action\" href=https://wenjoy.com.co target=_blank>Conoce Más...</a></div><div class=\"atv-col atv-col-md-6 banner-wenjoy-mobile\"><img src=assets/images/movil.png alt=movil></div></div><div><atv-footer></atv-footer></div><script type=text/ng-template id=atvFreeModal><div class=\"ngdialog-message\">\n    <div class=\"text-center\">\n      <img class=\"modalTopImage\" src=\"/assets/images/logo-box.png\"/>\n      <h2 class=\"margin-top-10\">¡Armatuvaca ahora es totalmente <strong>GRATIS!</strong></h2>\n      <h4>No te preocupes por tarifas ni costos adicionales</h4>\n      <button class=\"btn btn-default button-action\" ng-click=\"closeAtvFreeDialog(ngDialogId)\">Empezar</button>\n    </div>\n  </div></script>");
$templateCache.put("app/views/product/product.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid no-padding-left-right overflow-hidden\"><div uib-carousel active=active interval=myInterval no-wrap=noWrapSlides><div uib-slide ng-repeat=\"photo in product.product_photos track by photo.id\" index=photo.id><div class=main-top-content-marketplace ng-style=photo.background_style></div></div></div></div><div class=\"container-fluid background-color-white\"><div class=\"container margin-bottom-20\"><div class=row id=sticky-container><div ng-bind-html=product.description class=\"col-md-8 font-color-gray\"></div><div class=\"col-md-4 text-center product-price-div-sticky hidden-xs-sm\" hl-sticky=\"\" anchor=top container=sticky-container offset-top=80><h4 class=product-price-title>{{product.price | currency:$:0}}</h4><button id=mp_create_cow class=\"btn btn-default button-action-large\" ng-click=\"createCowMarketplace(product, true)\"><i class=\"fa fa-users\" aria-hidden=true></i> Comprar en Grupo</button> <button id=mp_create_solo_cow class=\"btn btn-default button-action-large-blue\" ng-click=\"createCowMarketplace(product, false)\"><i class=\"fa fa-user\" aria-hidden=true></i> Comprar solo</button><!--<div ng-bind-html=\"product.buy_info\" class=\"margin-top-15 text-justify\"></div>--><div><product-share product=product></product-share></div><hr><p ng-switch=product.company.type><b ng-switch-when=0>Preguntas relacionadas con el producto</b> <b ng-switch-when=1>Preguntas relacionadas con la experiencia</b> <b ng-switch-default>¿Tienes preguntas?</b></p><p><i class=\"fa fa-phone\" aria-hidden=true></i> {{product.company.telephone}}</p><p><b>Soporte con el proceso de pago</b></p><p><i class=\"fa fa-phone\" aria-hidden=true></i> +571 524 9603<br><i class=\"fa fa-whatsapp\" aria-hidden=true></i> +57 312 457 4750</p></div><div class=\"col-md-4 text-center product-price-div-sticky visible-xs-sm\"><div hl-sticky=\"\" anchor=bottom container=sticky-container class=\"background-color-white text-center\"><h4 class=product-price-title>{{product.price | currency:$:0}}</h4><span><b>Comprar</b></span><div class=\"col-xs-12 col-sm-12\"><div class=\"col-xs-6 col-sm-6\"><button id=mp_create_cow_solo_xs class=\"btn btn-default button-action-small-blue no-margin-top\" ng-click=\"createCowMarketplace(product, false)\"><i class=\"fa fa-user\" aria-hidden=true></i> Solo</button></div><div class=\"col-xs-6 col-sm-6\"><button id=mp_create_cow_xs class=\"btn btn-default button-action-small no-margin-top\" ng-click=\"createCowMarketplace(product, true)\"><i class=\"fa fa-users\" aria-hidden=true></i> Grupo</button></div></div></div><!--<div ng-bind-html=\"product.buy_info\" class=\"margin-top-15 text-justify\"></div>--><div class=\"position-relative top-20-sm-xs\"><product-share product=product></product-share></div><hr><p ng-switch=product.company.type><b ng-switch-when=0>Preguntas relacionadas con el producto</b> <b ng-switch-when=1>Preguntas relacionadas con la experiencia</b> <b ng-switch-default>¿Tienes preguntas?</b></p><p><i class=\"fa fa-phone\" aria-hidden=true></i> {{product.company.telephone}}</p><p><b>Soporte con el proceso de pago</b></p><p><i class=\"fa fa-phone\" aria-hidden=true></i> +571 524 9603<br><i class=\"fa fa-whatsapp\" aria-hidden=true></i> +57 312 457 4750</p></div></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/publicCow/publicCow.html","<div><atv-navbar vacanes=true lang=true></atv-navbar></div><!--<div class=\"container-fluid text-center\">--><!--<img src=\"/assets/images/vacanes/vacanes_color.png\" class=\"img-logo-vacanes\" alt=\"vacanes_azul.png\">--><!--</div>--><!--</div>--><div class=\"margin-bottom-20 background-color-white\"><public-cows cows=cows cows-public-category=cowsPublicCategory></public-cows></div><div><feedback></feedback></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/register/register.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>¡Crea tu cuenta!</b></h1><p>Y haz los mejores planes con tus amigos sin preocuparte.</p></div></div><div class=\"container-fluid background-color-white\"><div class=\"container register-form\"><div class=\"row col-md-8 user-data-form-content col-md-offset-2\"><div class=\"social-login margin-bottom-20\"><!--<div class=\"\">\n          <a id=\"register_login_fb\" class=\"btn btn-block btn-social btn-facebook facebook-button\" ng-click=\"loginFb()\">\n            <span class=\"fa fa-facebook facebook-logo-button-register\"></span>\n            Ingresa con Facebook\n          </a>\n        </div>--><div class=google-social><a id=register_login_gg class=\"btn btn-block btn-social btn-google google-button\" ng-click=loginGg()><img src=assets/images/utils/google-logo.svg class=\"no-outline img-google-logo\" alt=google-maps-logo> Ingresa con Google</a></div><div class=margin-top-20><p class=small-font>Al registrarte por medio de Google, aceptas los <a id=register_terms_and_conditions_link ui-sref=terms-and-conditions target=_blank>términos y condiciones</a> y la <a id=register_privacy_policy_link ui-sref=privacy-policy target=_blank>política de tratamiento de datos</a> de Armatuvaca.</p><p ng-show=errorSocialSent class=text-danger>{{errorMessage}}</p></div></div><form name=registerForm ng-submit=\"registerNewUser(registerForm.$valid && (user.password == user.confirm_password) && (user.email == user.confirm_email))\" novalidate><h3 class=\"text-center margin-bottom-40\">Regístrate con tu correo</h3><div layout-gt-sm=\"row \"><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"registerForm.first_name.$invalid && registerForm.$submitted\"><label>Nombre</label><input id=register_first_name required name=first_name md-maxlength=50 ng-model=user.first_name placeholder=\"Ingresa tu nombre\"><div ng-messages=registerForm.first_name.$error><div ng-message=required>Por favor, digita tu nombre.</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"registerForm.last_name.$invalid && registerForm.$submitted\"><label>Apellido</label><input id=register_last_name required name=last_name md-maxlength=100 ng-model=user.last_name placeholder=\"Ingresa tu apellido\"><div ng-messages=registerForm.last_name.$error><div ng-message=required>Por favor, digita tu apellido.</div></div></md-input-container></div><div class=row><div class=\"col-md-5 register-date-picker margin-bottom-20\"><label ng-class=\"(user.born_date)? \'font-color-atv\': \'font-color-gray\'\">Fecha de nacimiento</label><md-input-container class=\"margin-top-3 no-margin-bottom\"><md-datepicker id=register_born_date ng-model=user.born_date md-max-date=maxDate md-placeholder=DD/MM/AAAA name=born_date required></md-datepicker><div ng-messages=registerForm.born_date.$error><div ng-message=valid>Fecha invalida</div><div ng-message=required>Por favor, selecciona tu fecha de nacimiento</div><div ng-message=maxdate>Debes ser mayor de edad para registrarte</div></div></md-input-container></div></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"registerForm.email.$invalid && registerForm.$submitted\"><label>Correo</label><input id=register_email required name=email maxlength=100 ng-model=user.email type=email placeholder=\"Ingresa tu correo\"><div ng-messages=registerForm.email.$error><div ng-message=required>Por favor, digita tu correo.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"registerForm.confirm_email.$invalid && registerForm.$submitted\" ng-show=user.email><label>Confirmar correo</label><input id=register_confirm_email required name=confirm_email maxlength=100 ng-model=user.confirm_email type=email placeholder=\"Confirma tu correo\"><p ng-show=\"user.confirm_email != user.email\" class=validation-messages>Los correos deben coincidir.</p><div ng-messages=registerForm.confirm_email.$error><div ng-message=required>Por favor, confirma tu correo.</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"registerForm.password.$invalid && registerForm.$submitted\"><label>Contraseña</label><input id=register_password required name=password maxlength=100 minlength=8 ng-model=user.password ng-pattern=\"\'.*?[^0-9].*\'\" type=\"{{(show_password)? \'text\': \'password\'}}\" placeholder=\"Ingresa tu contraseña\"><div ng-messages=registerForm.password.$error><div ng-message=required>Por favor, digita tu contraseña.</div><div ng-message=minlength>Tu contraseña debe ser mínimo de 8 caracteres.</div><div ng-message=pattern>Tu contraseña no puede ser sólo numérica</div></div></md-input-container><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"registerForm.confirm_password.$invalid && registerForm.$submitted\" ng-show=user.password><label>Confirmar contraseña</label><input id=register_confirm_password required name=confirm_password maxlength=100 ng-model=user.confirm_password type=\"{{(show_password)? \'text\': \'password\'}}\" placeholder=\"Confirma tu contraseña\"><p ng-show=\"user.confirm_password != user.password\" class=validation-messages>Las contraseñas deben ser iguales.</p><div ng-messages=registerForm.confirm_password.$error><div ng-message=required>Por favor, confirma tu contraseña.</div></div></md-input-container></div><div class=\"col-md-12 no-padding\"><div class=\"col-md-6 no-padding\"><md-checkbox id=register_show_password ng-model=show_password aria-label=\"Checkbox 1\">Mostrar contraseñas</md-checkbox></div><div class=\"col-md-6 no-padding\"><p class=\"text-right hidden-xs-sm\">¿Ya tienes una cuenta? Ingresa <b><a ui-sref=login href=\"\">aquí</a></b></p><p class=\"text-left visible-xs-sm\">¿Ya tienes una cuenta? Ingresa <b><a id=register_login_link ui-sref=login href=\"\">aquí</a></b></p></div></div><!--<p class=\"small-font\">\n          Al hacer clic en Regístrate, aceptas los\n          <a id=\"register_terms_and_conditions_link2\" ui-sref=\"terms-and-conditions\" target=\"_blank\">términos y\n            condiciones</a>\n          y la\n          <a id=\"register_privacy_policy_link2\" ui-sref=\"privacy-policy\" target=\"_blank\">política de tratamiento de\n            datos</a>\n          de ArmaTuVaca.\n        </p>--><md-checkbox ng-model=acceptTermsConditions name=tyc aria-label=\"Checkbox 3\" class=no-margin>He leído y acepto los <a id=register_terms_and_conditions_link2 ui-sref=terms-and-conditions target=_blank>términos y condiciones</a> y la <a id=register_privacy_policy_link2 ui-sref=privacy-policy target=_blank>política de tratamiento de datos</a> de Armatuvaca.</md-checkbox><p ng-show=!acceptTermsConditions class=validation-messages>Debes aceptar para registrarte</p><p ng-show=errorSended class=text-danger>{{errorMessage}}</p><div id=container_recaptchaV2></div><div class=center-item><button id=register_btn_submit_form class=\"btn btn-default pull-right button-action\" type=submit ng-if=!secondValidation>Regístrate</button></div></form></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/requestStatus/requestStatus.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Solicitud</b></h1><p>Aquí puedes ver el estado de tu solicitud</p></div></div><div class=\"container-fluid background-color-white\"><div class=\"container margin-top-40\"><div class=row ng-if=\"request.status==0\"><div class=col-md-2><div class=\"text-center main-hiw-description margin-top-10 margin-bottom-20\"><img class=\"img-circle img-hiw\" src=assets/images/how-it-works/step-4.png alt=img-home></div></div><div class=\"col-md-offset-1 col-md-9\"><h4 class=font-color-atv>Solicitud pediente de revisión</h4><p>Tu solicitud ha sido generada<br><br>Muy pronto nos contactaremos contigo<br><br>Si tienes alguna duda no dudes en contactarnos<br><br>Correo: <a href=mailto:contacto@armatuvaca.com>contacto@armatuvaca.com</a><br>Télefono: (+57) 300 7185815</p></div></div><div class=row ng-if=\"request.status==1\"><div class=col-md-2><div class=\"text-center main-hiw-description margin-top-10 margin-bottom-20\"><img class=\"img-circle img-hiw\" src=assets/images/how-it-works/step-4.png alt=img-home></div></div><div class=\"col-md-offset-1 col-md-9\"><h4 class=font-color-atv>Solicitud aprobada</h4><p>En este momento podras ver el monto de la Vaca consignado en la cuenta bancaria seleccionada<br><br>Gracias por utilizar nuestros servicios<br><br>Si tienes alguna duda no dudes en contactarnos<br><br>Correo: <a href=mailto:contacto@armatuvaca.com>contacto@armatuvaca.com</a><br>Télefono: (+57) 300 7185815</p></div></div><div class=row ng-if=\"request.status==2\"><div class=col-md-2><div class=\"text-center main-hiw-description margin-top-10 margin-bottom-20\"><img class=\"img-circle img-hiw\" src=assets/images/how-it-works/step-4.png alt=img-home></div></div><div class=\"col-md-offset-1 col-md-9\"><h4 class=font-color-atv>Solicitud en revisión</h4><p>En este momento nuestro equipo se encuentra revisando tu solicitud<br><br>Muy pronto nos contactaremos contigo<br><br>Si tienes alguna duda no dudes en contactarnos<br><br>Correo: <a href=mailto:contacto@armatuvaca.com>contacto@armatuvaca.com</a><br>Télefono: (+57) 300 7185815</p></div></div><div class=row ng-if=\"request.status==3\"><div class=col-md-2><div class=\"text-center main-hiw-description margin-top-10 margin-bottom-20\"><img class=\"img-circle img-hiw\" src=assets/images/how-it-works/step-4.png alt=img-home></div></div><div class=\"col-md-offset-1 col-md-9\"><h4 class=font-color-atv>Solicitud rechazada</h4><p>Lamentablemente tu solicitud ha sido rechazada<br><br>Te fue enviado un correo con lo detalles del rechazo<br><br>Si tienes alguna duda no dudes en contactarnos<br><br>Correo: <a href=mailto:contacto@armatuvaca.com>contacto@armatuvaca.com</a><br>Télefono: (+57) 300 7185815</p></div></div><div class=\"row text-center margin-bottom-20\"><div class=col-md-6><button class=\"btn btn-default button-action-white pull-right\" ng-click=goToHowItWorks()>¿Cómo funciona?</button></div><div class=col-md-6><button class=\"btn btn-default button-action-white pull-left\" ng-click=goToHome()>Ir al Inicio</button></div></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/sendMoneyCow/sendMoneyCow.html","<div><atv-navbar></atv-navbar></div><div><div class=cow-token-request><!--HEAD--><div class=cow-token-request-icon><i class=\"fa fa-money\" aria-hidden=true></i></div><div class=cow-token-request-title><p>Envia dinero a tus amigos via SMS o Correo Electrónico</p></div><div class=cow-token-request-subtitle><p>Dinos, ¿Cuánto y cómo quieres enviar el dinero?:</p></div><form name=sendForm ng-submit=sendMoneyCow(sendForm.$valid)><!--VIA PAYMENT--><div><label>¿Cómo vas a pagar?<br><small>Selecciona una opción</small></label><br><md-input-container style=\"text-align: start; max-width: 250px; margin: 10px auto\"><md-radio-group ng-model=user_participation.via><md-radio-button value=4 class=md-primary><div class=new-cow-create-form-select-option><img src=assets/images/payment-methods/pse.png alt=\"\"> <span>PSE</span></div></md-radio-button><md-radio-button value=5 class=md-primary><div class=new-cow-create-form-select-option><img src=assets/images/payment-methods/mastercard.png alt=\"\"> <img src=assets/images/payment-methods/visa.png alt=\"\"> <img src=assets/images/payment-methods/diners.png alt=\"\"><br><span>Tarjeta</span></div></md-radio-button></md-radio-group></md-input-container></div><!--TOTAL VALUE--><div><label>¿Cuánto vas a enviar?</label><br><md-input-container md-no-float required style=\"text-align: center; width: 300px\"><input ng-model=user_participation.total_value name=total_value ui-money-mask=0 type=tel required placeholder=\"$ 0\"><div ng-messages=sendForm.total_value.$error><div ng-message=required>Ingresa el valor a pagar.</div></div><p class=\"validation-messages text-center\" style=\"color: dimgray; margin: 10px 0\">{{user_participation.via === \'4\' ? \'Mínimo $10.000 COP, máximo $1´000.000 COP\': \'Mínimo $10.000 COP, máximo $2´000.000 COP\'}}</p></md-input-container></div><!-- MODE --><div><label>Contacto a quien vas a enviar el dinero<br><small>Selecciona una opción</small></label><br><md-input-container style=\"margin-bottom: 0\"><md-radio-group ng-model=user_participation.send_money_type><md-radio-button value=0 class=md-primary>Mensaje de texto (SMS)</md-radio-button><md-radio-button value=1 class=md-primary>Correo Electrónico</md-radio-button></md-radio-group></md-input-container></div><!--EMAIL--><div ng-if=\"user_participation.send_money_type === \'1\'\"><md-input-container style=\"width: 200px; margin: 0\" md-no-float><input maxlength=100 ng-model=user_participation.send_email type=email placeholder=\"Ingresa el correo electrónico\" name=send_email required><div ng-messages=sendForm.send_email.$error><div ng-message=required>Por favor, digita un correo.</div></div></md-input-container></div><!--CELLPHONE--><div ng-if=\"user_participation.send_money_type === \'0\'\"><md-input-container style=\"width: 200px; margin: 0\" md-no-float><input ng-model=user_participation.send_sms type=tel pattern=[0-9]{10,12} digits-no-indicative required placeholder=\"Ingresa aquí un celular\" name=send_sms><div ng-messages=sendForm.send_sms.$error multiple md-auto-hide=true><div ng-message-exp=\"[\'required\']\">Debes digitar un número celular</div><div ng-message-exp=\"[\'pattern\']\">El número celular debe contener entre 10 y 12 números y contener solo caracteres numericos</div></div></md-input-container></div><!-- SEND--> <button id=login_btn_submit class=button-action type=submit ng-disabled=\"!((sendForm.$valid && user_participation.total_value >= 10000) && ((user_participation.via === \'4\' && user_participation.total_value<=1000000) || (user_participation.via === \'5\' && user_participation.total_value<=2000000)))\">Enviar Dinero</button></form></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/welcome/welcome.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Ya eres parte de Armatuvaca.com</b></h1></div></div><div class=\"container-fluid background-color-white no-padding-left-right\"><div class=\"container text-center\"><h1>Arma tu primera Vaca</h1><p class=hidden-xs-sm>Gracias por crear tu cuenta. Ahora podrás invitar a quien quieras: Paseos, Cumpleaños, Asados, Regalos en Común, Partidos y mucho más. En pocos clics, Armatuvaca online... Es rápido, fácil y seguro.</p><p class=visible-xs-sm>Gracias por crear tu cuenta, nosotros te ayudaremos con el manejo de la Vaca para tu evento.</p><p class=visible-xs-sm>Ingresa acá para armar tu primera Vaca:</p><div class=\"text-center margin-bottom-20\"><button class=\"btn btn-default button-action-pink\" ng-click=goToCreateCow()>Armar mi primera Vaca</button></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/components/credibanco/credibancoNavbar/credibancoNavbar.html","<header><div><nav class=\"navbar navbar-default navbar-fixed-top navbar-credibanco\" role=navigation><div class=container><a id=navbar_sm_menu class=\"navbar-toggle pull-left\" ng-click=toggleRight() ng-hide=isOpenRight()><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></a></div><div class=\"hidden-xs hidden-sm padding-left-right-50\"><ul class=\"nav navbar-nav pull-right\"><li><a id=credibanco_navbar_return ui-sref=public-cow class=highlighted-link>REGRESAR</a></li><li><button id=navbar_btn_lg_cow_create class=\"btn btn-default navbar-button\" ng-click=goToHome()>Conoce ArmaTuVaca.com</button></li></ul><div class=header-logo><a id=navbar_logo_credibanco href=https://yomequedoenminegocio.com/clapper target=_blank class=hidden-sm><img class=logo-credibanco src=assets/images/credibanco/main_logo.png alt=logo> </a><a id=navbar_logo_atv ui-sref=public-cow class=hidden-sm><img class=logo-by-atv src=assets/images/logo_letters_white.png alt=logo></a></div></div><div class=\"container visible-xs visible-sm\"><div><a id=navbar_logo_letters_sm_home href=https://yomequedoenminegocio.com/clapper target=_blank><img class=\"img-responsive logo-header-icon-letters logo-credibanco-mobile\" src=assets/images/credibanco/mobile_logo.png alt=logo></a></div><a id=navbar_logo_letters_box_home href=https://yomequedoenminegocio.com/clapper target=_blank><img class=\"img-responsive logo-header-icon\" src=assets/images/credibanco/hash_logo.png alt=logo></a></div></nav></div><div class=\"sidebar-nav credibanco-sitebar\"><section layout=row flex=\"\"><md-sidenav class=md-sidenav-left md-component-id=left><div layout-padding=\"\"><div><a id=navbar_sm_menu_close class=\"pull-right dark-font-atv\" ng-click=close()><span class=\"glyphicon glyphicon-remove\"></span></a></div><div class=container><ul class=\"nav navbar-sitebar\"><li class=\"hidden-md credibanco-sitebar-link\"><a id=credibanco_navbar_sm_return href=https://yomequedoenminegocio.com/clapper target=_blank>Ir a<br><span class=font-bold>YoMeQuedoEnMiNegocio.com</span></a></li><li class=\"hidden-md atv-sitebar-link\"><a id=credibanco_navbar_sm_atv ng-click=close() ui-sref=public-cow>Regresar a<br><span class=font-bold>ArmaTuVaca.com</span></a></li></ul></div></div></md-sidenav></section></div><div id=top-scroll></div></header>");
$templateCache.put("app/components/credibanco/credibancoFooter/credibancoFooter.html","<footer><div class=\"container-fluid footer-main\"><div class=\"container footer-margin-top\"><hr><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 footer-security\"><h5 class=\"text-center mayus\">Seguridad</h5><br><p style=\"text-align: center\"><i class=\"fa fa-lock\" aria-hidden=true></i> Protocolo Https (Seguro)<br><br><i class=\"fa fa-key\" aria-hidden=true></i> Certificados de seguridad<br><br><i class=\"fa fa-check\" aria-hidden=true></i> Certificación PCI (Manejo de tarjetas de crédito)<br><br></p><div><div class=\"text-center col-md-3 col-xs-4 margin-bottom-10\"><img class=\"img_gray height-60 height-40-sm-xs margin-auto\" src=assets/images/secure/comodo_secure_seal.png alt=security></div><div class=\"text-center col-md-3 col-xs-4 margin-bottom-10\"><img class=\"img_gray height-60 height-40-sm-xs margin-auto\" src=assets/images/secure/positivessl-icon.png alt=security></div><div class=\"text-center col-md-3 col-xs-4 margin-bottom-10\"><img class=\"img_gray height-60 height-40-sm-xs margin-auto\" src=assets/images/secure/ssl_security.png alt=security></div><div class=\"text-center col-md-3 col-xs-12 margin-bottom-10\"><img class=\"img_gray height-60 height-40-sm-xs margin-auto\" src=assets/images/secure/pci_compliant.png alt=security></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 footer-about text-center\"><h5 class=\"text-center mayus\">Acerca De</h5><br><p style=\"text-align: center\"><a id=footer_terms_and_conditions ui-sref=terms-and-conditions href=\"\" class=font-color-white>Términos y Condiciones</a><br><br><a id=footer_privacy_policy ui-sref=privacy-policy href=\"\" class=font-color-white>Política de Tratamiento de Datos</a><br><br></p><div class=text-center><h5 class=\"mayus font-bold no-margin-bottom margin-top-30\">Medios de pago aceptados</h5><div><div class=\"text-center col-md-3 col-xs-3 margin-top-20\"><img class=\"img_gray height-50 height-40-sm-xs margin-auto\" src=assets/images/footer/mastercard.png alt=payment-methods></div><div class=\"text-center col-md-3 col-xs-3 margin-top-20\"><img class=\"img_gray height-50 height-40-sm-xs margin-auto\" src=assets/images/footer/visa.png alt=payment-methods></div><div class=\"text-center col-md-3 col-xs-3 margin-top-20\"><img class=\"img_gray height-50 height-40-sm-xs margin-auto\" src=assets/images/footer/diners.jpg alt=payment-methods></div><div class=\"text-center col-md-3 col-xs-3 margin-top-20\"><img class=\"img_gray height-50 height-40-sm-xs margin-auto\" src=assets/images/footer/pse.png alt=payment-methods></div></div></div></div></div><hr><div class=\"row footer-develop text-center\"><!--<h6>v 1.2.1</h6>--><h6>Desarrollado con <i class=\"fa fa-heart font-color-pink font-size-18\" aria-hidden=true></i> por Evolution Ideas SAS ©<img src=assets/images/footer/flag_CO.png height=17 width=23 alt=flag_CO></h6></div></div></div></footer>");
$templateCache.put("app/components/fep/fepCowShare/fepCowShare.html","<div class=\"row margin-top-20 margin-bottom-20 text-center\"><div class=\"col-md-4 col-sm-12 col-xs-12\"><div class=\"col-md-4 col-xs-2 width-20-sm-xs text-center\"><a class=no-outline ng-click=shareFb()><img src=assets/images/utils/facebook.svg class=\"no-outline center-item img-share\" alt=facebook-logo></a></div><div class=\"col-xs-2 width-20-sm-xs text-center visible-xs-sm\"><a class=\"no-outline center-item\" socialshare socialshare-provider=facebook-messenger socialshare-url={{cowPublicURLComplete}}><img src=assets/images/utils/messenger.svg class=\"no-outline center-item img-share\" alt=messenger-logo></a></div><div class=\"col-xs-2 width-20-sm-xs text-center visible-xs-sm\"><a class=no-outline socialshare socialshare-provider=whatsapp socialshare-url={{cowPublicURLComplete}} socialshare-text=\"{{cow_event.name + \' \' }}\"><img src=assets/images/utils/whatsapp.svg class=\"no-outline center-item img-share\" alt=whatsapp-logo></a></div><div class=\"col-xs-2 width-20-sm-xs text-center\"><a class=no-outline ng-click=shareLinkedin()><img src=assets/images/utils/linkedin-logo.png class=\"no-outline center-item img-share\" alt=linkedin-logo></a></div><div class=\"col-md-4 col-xs-2 width-20-sm-xs text-center\"><a class=no-outline ng-click=shareTw()><img src=assets/images/utils/twitter.svg class=\"no-outline center-item img-share\" alt=twitter-logo></a></div></div><div class=\"col-md-8 col-sm-12 col-xs-12 text-center margin-top-5 no-padding-left\"><div class=form-group><input id=cow_link type=text name=link ng-model=cowPublicURLCompleteCopy class=\"form-control col-md-4 input-link-share\"><div class=\"col-md-3 col-sm-6 col-xs-6 no-padding-left-xs-sm\"><button type=button name=button class=form-control ngclipboard data-clipboard-target=#cow_link ng-click=copyLink()><i class=\"fa fa-clone\" aria-hidden=true></i> Copiar link</button></div></div></div></div>");
$templateCache.put("app/components/fep/fepNavbar/fepNavbar.html","<header><div><nav class=\"navbar navbar-default navbar-fixed-top navbar-fep\" role=navigation><div class=container><a id=navbar_sm_menu class=\"navbar-toggle pull-left\" ng-click=toggleRight() ng-hide=isOpenRight()><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></a></div><div class=\"hidden-xs hidden-sm padding-left-right-50\"><ul class=\"nav navbar-nav pull-right\"><li><a id=navbar_hiw_link href=https://alcancia.festivalestereopicnic.com/ target=_blank class=navbar-a><b><i class=\"fa fa-info-circle font-color-white\" aria-hidden=true></i> ¿Cómo funciona?</b></a></li><li ng-show=!logged><a id=navbar_login_link ui-sref=fep-login ui-sref-opts={reload:true} href=\"\" class=navbar-a><b><i class=\"fa fa-sign-in font-color-white\" aria-hidden=true></i> Iniciar sesión</b></a></li><li ng-show=logged class=navbar-nav-item><span><b class=navbar-a><i class=\"fa fa-user font-color-white\" aria-hidden=true></i> {{user.user.first_name}}</b></span></li><li ng-show=logged class=\"navbar-nav-item padding-left-15\" tooltip-placement=bottom uib-tooltip=\"Saldo disponible\"><span><b class=navbar-a>{{fepCowValue | currency:\"$\":\'0\'}} COP</b></span></li><li uib-dropdown ng-show=logged><a id=navbar_dp_options_link uib-dropdown-toggle href=\"\"><b><i class=\"fa fa-caret-down\" aria-hidden=true></i></b></a><ul uib-dropdown-menu><!--<li>--><!--<a id=\"navbar_dp_account_link\" ui-sref=\"account\" ui-sref-opts=\"{reload:true}\">--><!--<b>--><!--<i class=\"fa fa-user font-color-fep\" aria-hidden=\"true\"></i>--><!--Cuenta--><!--</b>--><!--</a>--><!--</li>--><li><a id=navbar_logout_link ng-click=logOut() href=\"\"><b><i class=\"fa fa-sign-out\" aria-hidden=true></i> Cerrar sesión</b></a></li></ul></li></ul><div class=header-logo><a id=navbar_logo_box_letters_home href=https://alcancia.festivalestereopicnic.com/ target=_blank class=hidden-sm><img class=\"img-responsive pull-right logo-header-letters\" src=assets/images/fep/logo-fep-white.png alt=logo></a></div></div><div class=\"container visible-xs visible-sm\"><div><a id=navbar_logo_letters_sm_home><img class=\"img-responsive logo-header-icon-letters\" src=assets/images/fep/logo-fep-white.png alt=logo></a></div></div></nav></div><div class=sidebar-nav><section layout=row flex=\"\"><md-sidenav class=md-sidenav-left md-component-id=left><div layout-padding=\"\"><div><a id=navbar_sm_menu_close class=\"pull-right dark-font-atv\" ng-click=close()><span class=\"glyphicon glyphicon-remove\"></span></a></div><div class=container><ul class=\"nav navbar-sitebar\"><li ng-show=logged><a id=navbar_sm_account_link href=\"\" class=navbar-a><b><i class=\"fa fa-user font-color-fep\" aria-hidden=true></i> {{user.user.first_name}}</b> <span class=font-color-black>({{fepCowValue | currency:\"$\":\'0\'}} COP)</span></a></li><li><a id=navbar_sm_hiw_link href=https://alcancia.festivalestereopicnic.com/ target=_blank class=navbar-a><b><i class=\"fa fa-info-circle\" aria-hidden=true></i> ¿Cómo funciona?</b></a></li><li ng-show=!logged><a id=navbar_sm_login_link ui-sref=fep-login ui-sref-opts={reload:true} href=\"\" class=navbar-a><b><i class=\"fa fa-sign-in\" aria-hidden=true></i> Iniciar sesión</b></a></li><li ng-show=logged><a id=navbar_sm_logout_link ng-click=logOut() href=\"\" class=\"navbar-a text-left\"><b><i class=\"fa fa-sign-out\" aria-hidden=true></i> Cerrar sesión</b></a></li></ul></div></div></md-sidenav></section></div><div id=top-scroll></div></header>");
$templateCache.put("app/components/fep/fepFooter/fepFooter.html","<footer><div class=\"container-fluid footer-main\"><div class=\"container footer-margin-top\"><div class=\"row text-center\"><h3 class=text-center>¿Qué es la alcancía FEP?</h3><ul class=list-unstyled><li class=\"margin-top-10 margin-bottom-10\"><img src=assets/images/fep/piggy-bullet.png class=height-20> La nueva forma de ahorrar para tus boletas</li><li class=\"margin-top-10 margin-bottom-10\"><img src=assets/images/fep/piggy-bullet.png class=height-20> ¡No tienes que pagar todo ya! Paga poco a poco</li><li class=\"margin-top-10 margin-bottom-10\"><img src=assets/images/fep/piggy-bullet.png class=height-20> Puedes ahorrar individualmente o en grupo</li><li class=\"margin-top-10 margin-bottom-10\"><img src=assets/images/fep/piggy-bullet.png class=height-20> Paga tus cuotas durante cualquier día del mes</li><li class=\"margin-top-10 margin-bottom-10\"><img src=assets/images/fep/piggy-bullet.png class=height-20> Asegura el precio de tu boleta pagando el 10% del valor total</li><li class=\"margin-top-10 margin-bottom-10\"><img src=assets/images/fep/piggy-bullet.png class=height-20> Los cuotas son libres y puedes completar el valor total hasta 2 semanas antes del evento</li></ul></div></div></div><div class=\"container-fluid footer-main\"><div class=container><hr><div class=row><div class=\"footer-about text-center\"><div class=\"col-xs-12 col-sm-12 col-md-4\"><ul class=\"list-unstyled footer-list-fep\"><li class=\"margin-top-10 margin-bottom-10\"><a id=footer_faq href=https://alcancia.festivalestereopicnic.com/ target=_blank class=font-color-white>Preguntas Frecuentes</a></li><li class=\"margin-top-10 margin-bottom-10\"><a id=footer_terms_and_conditions href=https://s3.amazonaws.com/alcancia.festivalestereopicnic.com/docs/TyC.pdf target=_blank class=font-color-white>Términos y Condiciones</a></li><li class=\"margin-top-10 margin-bottom-10\"><a id=footer_privacy_policy href=https://s3.amazonaws.com/alcancia.festivalestereopicnic.com/docs/PoliticaDatos.pdf target=_blank href=\"\" class=font-color-white>Política de Tratamiento de Datos</a></li></ul></div><div class=\"col-xs-12 col-sm-12 col-md-8 text-center padding-top-15\"><div class=row><div class=\"col-md-6 col-xs-12\"><a href=http://www.festivalestereopicnic.com/ target=_blank><img class=\"height-60 height-50-sm-xs margin-auto\" src=assets/images/fep/logo-fep-white.png alt=logo-fep></a></div><div class=\"text-center col-md-2 col-xs-4 margin-bottom-10 margin-top-10\"><a href=https://www.facebook.com/festivalestereopicnic target=_blank class=social-media-fep><p><i class=\"fa fa-facebook font-size-18 padding-top-12\" aria-hidden=true></i></p></a></div><div class=\"text-center col-md-2 col-xs-4 margin-bottom-10 margin-top-10\"><a href=https://www.instagram.com/festereopicnic/ target=_blank class=social-media-fep><p><i class=\"fa fa-instagram font-size-18 padding-top-12\" aria-hidden=true></i></p></a></div><div class=\"text-center col-md-2 col-xs-4 margin-bottom-10 margin-top-10\"><a href=https://www.twitter.com/festereopicnic target=_blank class=social-media-fep><p><i class=\"fa fa-twitter font-size-18 padding-top-12\" aria-hidden=true></i></p></a></div></div></div></div></div><hr><div class=row><div class=\"col-xs-12 col-sm-6 col-md-4 footer-security\"><h5 class=\"text-center mayus\">Seguridad</h5><ul class=list-group><li class=list-group-item><i class=\"fa fa-lock\" aria-hidden=true></i> Protocolo Https (Seguro)</li></ul><ul class=list-group><li class=list-group-item><i class=\"fa fa-key\" aria-hidden=true></i> Certificados de seguridad</li></ul></div><div class=\"col-xs-12 col-sm-6 col-md-4 footer-contact\"><h5 class=\"text-center mayus\">Contacto</h5><ul class=list-group><li class=list-group-item><i class=\"fa fa-whatsapp\" aria-hidden=true></i> +57 305 353 4967 / +571 524 9603</li></ul><ul class=list-group><li class=list-group-item><i class=\"fa fa-envelope-o\" aria-hidden=true></i> <a href=mailto:fep@armatuvaca.com class=font-color-white>fep@armatuvaca.com</a></li></ul></div><div class=\"col-xs-12 col-sm-12 col-md-4 footer-services text-center\"><div class=text-center><h5 class=\"mayus font-bold no-margin-bottom margin-top-30\">Medios de pago aceptados</h5><div><div class=\"text-center col-md-3 col-xs-3 margin-top-20\"><img class=\"height-50 height-40-sm-xs margin-auto\" src=assets/images/footer/mastercard.png alt=payment-methods></div><div class=\"text-center col-md-3 col-xs-3 margin-top-20\"><img class=\"height-50 height-40-sm-xs margin-auto\" src=assets/images/footer/visa.png alt=payment-methods></div><div class=\"text-center col-md-3 col-xs-3 margin-top-20\"><img class=\"height-50 height-40-sm-xs margin-auto\" src=assets/images/footer/diners.jpg alt=payment-methods></div><div class=\"text-center col-md-3 col-xs-3 margin-top-20\"><img class=\"height-50 height-40-sm-xs margin-auto\" src=assets/images/footer/pse.png alt=payment-methods></div></div></div></div></div></div><hr><div class=\"row footer-develop text-center\"><!--<h6>v 1.2.1</h6>--><h6>Desarrollado con <i class=\"fa fa-heart font-color-pink font-size-18\" aria-hidden=true></i> por Evolution Ideas SAS © <img src=assets/images/footer/flag_CO.png height=17 width=23 alt=flag_CO></h6></div></div></footer>");
$templateCache.put("app/views/credibanco/credibancoCow/credibancoCow.html","<div><credibanco-navbar></credibanco-navbar></div><div class=\"container background-color-white\"><div class=\"col-md-6 margin-top-20\"><div class=\"container-fluid no-padding-left-right overflow-hidden\"><div class=closed-cow-bar ng-show=\"cowclosed && !cowclosed_moneyrequest\"><p class=alert-2>Cerrada</p></div><div class=main-top-content ng-style=\"getBackgroudCssStyleCow(cow_event.main_img, cow_event.closed)\"></div><div class=margin-top-10 ng-if=\"cow_event.cow_goal > 0\"><participation-bar current-value=cow_event.total_value goal=cow_event.cow_goal></participation-bar></div><div ng-if=\"cow_event.pay_limit_date && !cow_event.closed\"><countdown-timer deadline=cow_event.pay_limit_date></countdown-timer></div></div></div><div class=\"col-md-6 margin-top-20-md cow-right-container-md\"><div class=width-100><div class=\"width-100 text-center\" ng-if=!cow_event.is_promo><button class=\"button-action width-50 width-80-sm-xs\" ng-click=goToCredibancoParticipate() ng-if=!cowclosed>Donar</button> <button class=\"button-action width-50 width-80-sm-xs cow-closed-participate font-color-black\" ng-if=cowclosed>Donar</button></div><div ng-show=!cow_event.is_promo class=margin-top-20-md><cow-share cow=cow_event is-admin=false cow-business-type=cowBusinessTypeCredibanco></cow-share></div><div class=\"margin-top-20-md col-md-12 text-center\" ng-if=!cow_event.is_promo><button class=\"width-50 width-80-sm-xs cow-participants-num no-outline margin-bottom-10\" ng-click=modalParticipants() ng-if=\"cow_event.participations == 1\">{{cow_event.participations}} donación</button> <button class=\"width-50 width-80-sm-xs cow-participants-num no-outline margin-bottom-10\" ng-click=modalParticipants() ng-if=\"cow_event.participations != 1\">{{cow_event.participations}} donaciones</button><div class=margin-top-20><p><b class=\"font-color-atv font-size-30\" ng-if=!cow_event.hide_total_amount>{{cow_event.total_value | currency:\"$\":\'0\'}} COP</b> <b class=\"font-color-atv font-size-18\" ng-if=cow_event.hide_total_amount>Sólo visible para el organizador</b><br><b class=font-size-12>Total</b></p></div></div></div></div><div class=col-md-12><div class=\"row margin-bottom-20\"><h2 class=\"text-center col-md-offset-3 col-md-6 col-md-offset-right-3\"><b class=break-word>{{cow_event.name}}</b></h2><h4 class=\"text-center font-color-gray\"><b>Organizada por: {{cow_event.made_by}}</b></h4><h5 class=\"text-center font-color-gray\" ng-show=\"cow_event.event_date && cow_event.location_name && cow_event.location_name != \'null\'\"><b class=\"col-md-3 col-md-offset-3\">Fecha: {{eventDateString}}</b> <b class=col-md-3>Lugar: {{cow_event.location_name}}</b></h5><h5 class=\"text-center font-color-gray\" ng-show=\"cow_event.event_date && !cow_event.location_name\"><b>Fecha: {{eventDateString}}</b></h5><h5 class=\"text-center font-color-gray\" ng-show=\"!cow_event.event_date && cow_event.location_name && cow_event.location_name != \'null\'\"><b>Lugar: {{cow_event.location_name}}</b></h5></div><div class=\"row margin-bottom-20\"><div class=\"text-center overflow-auto\" ta-bind ng-model=cow_event.description ng-if=cow_event.description></div><div class=\"text-center col-md-6 col-md-offset-3 margin-bottom-20 overflow-auto\" ng-if=!cow_event.description ng-bind-html=cow_event.cow_type.description_default></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 no-padding-left-right margin-bottom-20\" ng-if=cow_event.show_location_point><ui-gmap-google-map center=map.center zoom=map.zoom><!--MARKER--><ui-gmap-marker coords=marker.coords options=marker.options events=marker.events idkey=marker.id></ui-gmap-marker></ui-gmap-google-map></div></div><div><credibanco-footer></credibanco-footer></div><script type=text/ng-template id=participantsModal-1><div class=\"ngdialog-message\">\n    <div class=\"text-center\" ng-if=\"ngDialogData.participants.length == 0\">\n      <h3>Por el momento no hay ninguna donación</h3>\n      <p>\n        Invita a tus amigos a que donen en la Vaca\n      </p>\n    </div>\n    <div class=\"text-center\"\n         ng-if=\"ngDialogData.participants.length > 0 &&\n         (!ngDialogData.cow.hide_participants_identity || (!ngDialogData.cow.hide_participant_amount && !ngDialogData.cow.hide_total_amount))\">\n      <div id=\"participants_list\">\n        <h3>Participantes</h3>\n        <div ng-if=\"!ngDialogData.cow.has_options\">\n          <p ng-repeat=\"participant in ngDialogData.participants track by $index\">\n            {{ ($index + 1) + \". \" + participant.first_name + \' \' + participant.last_name + \' - \' +\n            participant.total_amount}}\n          </p>\n        </div>\n        <div ng-if=\"ngDialogData.cow.has_options\">\n          <div ng-repeat=\"option in ngDialogData.participants track by $index\">\n            <h4>{{option.option + \' - \' + option.option_total}}</h4>\n            <p ng-repeat=\"participant in option.participants track by $index\">\n              {{ ($index + 1) + \". \" + participant.first_name + \' \' + participant.last_name + \' - \' +\n              participant.total_amount}}\n            </p>\n            <br>\n          </div>\n        </div>\n      </div>\n      <button type=\"button\" name=\"button\" class=\"form-control\" ngclipboard data-clipboard-target=\"#participants_list\">\n        <i class=\"fa fa-clone\" aria-hidden=\"true\"></i>\n        Copiar lista\n      </button>\n    </div>\n    <div class=\"text-center\"\n         ng-if=\"ngDialogData.participants.length > 0 && ngDialogData.cow.hide_participants_identity &&\n         (ngDialogData.cow.hide_participant_amount || ngDialogData.cow.hide_total_amount)\">\n      <h4>El organizador de la Vaca ha ocultado la información de las participaciones</h4>\n    </div>\n  </div></script>");
$templateCache.put("app/views/credibanco/credibancoParticipate/credibancoParticipate.html","<div><credibanco-navbar></credibanco-navbar></div><div class=\"main-top-content-participate font-color-white credibanco-banner\"><div class=container><div class=\"row margin-bottom-20\"><h2 class=text-center><b>{{cow_event.name}}</b></h2><h4 class=text-center><b>Organizada por: {{cow_event.made_by}}</b></h4></div></div></div><div id=top-scroll></div><div class=\"container-fluid background-color-white\" ng-show=\"!cow_event.deleted && !cow_event.closed\"><div class=container><div class=\"row col-md-8 user-data-form-content col-md-offset-2\"><div ng-show=showPersonalDataForm><!--Datos personales    --><div class=\"row text-center\"><h3 class=\"text-center margin-bottom-20\">Datos Responsable Pago</h3></div><form name=personalInfoForm id=personalInfoForm ng-submit=submitPersonalForm(personalInfoForm.$valid) ng-show=showPersonalInfoForm novalidate><!--<form name=\"personalInfoForm\" id=\"personalInfoForm\" class=\"\"--><!--ng-submit=\"participateCow(personalInfoForm.$valid && user_participation.total_value >= minPaymentValue)\"--><!--novalidate>--><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=\"\"><label>Nombre</label><input required name=first_name placeholder=\"Nombre responsable del pago\" md-maxlength=50 ng-model=user_participation.first_name><div ng-messages=personalInfoForm.first_name.$error><div ng-message=required>Por favor digita un nombre.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm=\"\"><label>Apellido</label><input required name=last_name placeholder=\"Apellido responsable del pago\" md-maxlength=50 ng-model=user_participation.last_name><div ng-messages=personalInfoForm.last_name.$error><div ng-message=required>Por favor digita un apellido.</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-md\" flex-gt-sm=\"\"><label>Tipo de documento</label><md-select ng-model=user_participation.document_type><md-option ng-repeat=\"document in documentTypes\" value={{document.id}}>{{document.key_type_name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block no-margin-md margin-top-30-sm-xs\" flex-gt-sm=\"\" ng-show=\"user_participation.document_type == 1 || user_participation.document_type == 2\"><label>N° de documento</label><input ng-model=user_participation.document_number name=document_number type=tel pattern=[0-9]{1,15} only-digits required placeholder=\"Documento responsable del pago\"><div ng-messages=personalInfoForm.document_number.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>El número de documento debe contener entre 6 y 15 caracteres numéricos</div></div></md-input-container><md-input-container class=\"md-block no-margin-md margin-top-30-sm-xs\" flex-gt-sm=\"\" ng-show=\"user_participation.document_type == 3 || user_participation.document_type == 4\"><label>N° de documento</label><input ng-model=user_participation.document_full_number name=document_full_number pattern=\"^(?=.*\\d).{1,15}\" ng-required=\"user_participation.document_type == 3 || user_participation.document_type == 4\" ng-change=setDocumentNumber() only-alphanumeric placeholder=\"Documento responsable del pago\"><div ng-messages=personalInfoForm.document_full_number.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>El número de documento debe contener entre 6 y 15 caracteres alfanuméricos</div></div></md-input-container><div ng-show=\"user_participation.document_type==2\"><i class=\"fa fa-info-circle tooltip-document\" tooltip-placement=bottom uib-tooltip=\"Digita el numero NIT incluyendo dígito de verificación\" aria-hidden=true></i></div></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\"><label>Correo electrónico</label><input required name=email placeholder=\"Correo responsable del pago\" md-maxlength=60 ng-model=user_participation.email type=email ng-pattern=/^.+@.+\\..+$/ ><div ng-messages=personalInfoForm.email.$error><div ng-message=required>Por favor digita el correo.</div><div ng-message=pattern>Dirección de correo inválida</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\"><label>Número celular</label><input ng-model=user_participation.cellphone name=cellphone type=tel pattern=[0-9]{10,12} digits-no-indicative required placeholder=\"Celular responsable del pago\"><div ng-messages=personalInfoForm.cellphone.$error multiple md-auto-hide=true><div ng-message-exp=\"[\'required\']\">Por favor digita el número celular</div><div ng-message-exp=\"[\'pattern\']\">El número celular debe contener entre 10 y 12 números y contener solo caracteres numericos</div></div></md-input-container></div></form><div class=\"col-md-3 col-md-offset-9 col-sm-offset-5 col-sm-7 col-xs-offset-5 col-xs-7 no-padding-left-xs-sm no-padding-right margin-bottom-10\" ng-show=showPersonalInfoForm><button type=submit form=personalInfoForm name=button class=\"form-control font-size-13-sm-xs\"><i class=\"fa fa-check font-color-atv\" aria-hidden=true></i> Listo</button></div><!--Resumen datos personales--><div class=\"col-md-12 no-padding-left-right margin-bottom-10\" ng-show=!showPersonalInfoForm><div class=\"col-md-6 personal-info-payment-div\"><p class=no-margin-bottom>Nombre: <b>{{user_participation.first_name + \' \' + user_participation.last_name}}</b></p><p class=no-margin-bottom ng-show=\"user_participation.document_type == 1 || user_participation.document_type == 2\">Documento: <b>{{user_participation.document_number}}</b></p><p class=no-margin-bottom ng-show=\"user_participation.document_type == 3 || user_participation.document_type == 4\">Documento: <b>{{user_participation.document_full_number}}</b></p><p class=no-margin-bottom>Email: <b>{{user_participation.email }}</b></p><p class=no-margin-bottom>Número celular: <b>{{user_participation.cellphone }}</b></p></div></div><div class=\"col-md-5 col-md-offset-7 col-sm-offset-3 col-sm-9 col-xs-offset-3 col-xs-9 no-padding-left-xs-sm no-padding-right margin-bottom-10\" ng-show=!showPersonalInfoForm><button type=button form=personalInfoForm name=button class=\"form-control font-size-13-sm-xs\" ng-click=showPersonalInfoFormEdit()><i class=\"fa fa-pencil-square-o font-color-blue\" aria-hidden=true></i> Editar datos</button></div><div class=row ng-show=\"cow_event.is_business && cow_event.business_type == 0\"><h3 class=\"margin-bottom-20 no-margin-top text-center\">Datos Adicionales</h3><div class=\"padding-left-right margin-bottom-20\"><textarea rows=3 class=\"form-control no-resize\" ng-model=user_participation.message placeholder=\"Este campo es opcional\">\n              </textarea></div></div><!--Participación--><div class=\"row text-center\"><h3 class=margin-top-bottom-20>Donación</h3><p ng-show=\"cow_event.participation_fixed && !cow_event.marketplace\" class=no-margin-bottom><i class=\"fa fa fa-exclamation-circle font-color-atv\"></i> El administrador fijó la donación en un monto fijo.</p></div><form name=participationForm id=participationForm novalidate><div class=\"row padding-left-right\" ng-show=\"cow_event.participation_fixed && !cow_event.marketplace\"><div layout=div layout-align=\"start center\"><md-select name=participant_num ng-model=user_participation.fixed_participants flex-gt-sm=5 flex-xs=5 required><md-option value=1>1</md-option><md-option value=2>2</md-option><md-option value=3>3</md-option><md-option value=4>4</md-option><md-option value=5>5</md-option><md-option value=6>6</md-option><md-option value=7>7</md-option><md-option value=8>8</md-option></md-select><p></p><p class=margin-left-55>Elige el número de donaciones que vas a pagar (Max 8)</p></div><!--<p class=\"font-size-12\">*Recuerda que se generará un cobro de--><!--{{additionalParticipantFee | currency:\"$\":\'0\'}} pesos por cada participante adicional.</p>--></div><div class=row ng-show=\"cow_event.is_business && cow_event.options && cow_event.has_options\" ng-repeat=\"participantsOptions in user_participation.participantsOptions track by participantsOptions.id\"><h4 class=\"margin-bottom-20 no-margin-top text-center\" ng-show=!cow_event.participation_fixed>Opciones</h4><h4 class=\"margin-bottom-20 no-margin-top text-center\" ng-show=cow_event.participation_fixed>Opciones participante {{$index + 1}}</h4><div class=\"col-md-6 col-md-offset-right-6 margin-top-20 margin-top-35-sm-xs\" ng-repeat=\"optionObj in cow_event.options.custom_options track by $index\"><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-top no-padding-left\" flex-gt-sm=\"\"><label>{{optionObj.option_type.name}}</label><md-select ng-model=user_participation.participantsOptions[participantsOptions.id].options[$index] required ng-change=totalValueChanged() md-no-asterisk><md-option ng-repeat=\"option in optionObj.options\" value=\"{{optionObj.option_type.id+\'-\'+option.id}}\">{{option.name}}</md-option></md-select></md-input-container></div></div></div><div class=\"row padding-left-right-top\" layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\"><label>Monto de donación (COP)</label><input ng-model=user_participation.total_value name=total_value ui-money-mask=0 type=tel required placeholder=$ ng-readonly=totalAmountReadOnly ng-change=totalValueChanged()><p ng-show=\"personalInfoForm.$submitted && user_participation.total_value && (user_participation.total_value < minPaymentValue)\" class=validation-messages>El monto mínimo de donación es de {{minPaymentValue | currency:\"$\":\'0\'}} COP</p><p ng-show=\"personalInfoForm.$submitted && user_participation.total_value && (user_participation.total_value > maxPaymentValue)\" class=validation-messages>El monto máximo de donación es de {{maxPaymentValue | currency:\"$\":\'0\'}} COP</p></md-input-container></div><div class=\"row margin-bottom-10\" ng-if=\"user_participation.total_value >= minPaymentValue\"><div ng-show=\"user_participation.fixed_participants > 1\" ng-repeat=\"participantOptions in user_participation.participantsOptions track by participantOptions.id\"><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=\"pull-left font-size-13\">Participante {{$index + 1}}</p></div><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=pull-right>{{cow_event.participant_value_fixed + additionalValues[$index].additionalValue | currency:\"$\":\'0\'}} COP</p></div></div><div ng-show=cow_event.commission_added><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=\"pull-left font-size-13\">Costo de servicio</p></div><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=pull-right>{{commission_value | currency:\"$\":\'0\'}} COP</p></div><!--<div ng-show=\"user_participation.fixed_participants > 1\">--><!--<div class=\"col-md-6 col-xs-6 col-sm-6\">--><!--<p class=\"pull-left font-size-13\">--><!--Cobro por participante adicional (x{{user_participation.fixed_participants - 1}})--><!--</p>--><!--</div>--><!--<div class=\"col-md-6 col-xs-6 col-sm-6\">--><!--<p class=\"pull-right\">--><!--{{multiple_participants_fee | currency:\"$\":\'0\'}}--><!--</p>--><!--</div>--><!--</div>--><div class=\"col-md-6 col-xs-6 col-sm-6\" ng-show=\"gift_code_obj.type==0 || gift_code_obj.type==1\"><p class=\"pull-left font-size-13\">{{gift_code_obj.name}}</p></div><div class=\"col-md-6 col-xs-6 col-sm-6\" ng-show=\"gift_code_obj.type==0 || gift_code_obj.type==1\"><p class=pull-right>-{{gift_code_obj.discount_value | currency:\"$\":\'0\'}} COP</p></div><div class=\"col-md-12 col-xs-12 col-sm-12 no-padding\"><hr class=hr-partipation></div></div><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=\"pull-left font-size-15\"><b>Total</b></p></div><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=pull-right>{{total_value_commission | currency:\"$\":\'0\'}} COP</p></div></div><div class=\"row padding-left-right-top\" layout-gt-sm=row ng-show=\"cow_event.business_type == 1\"><md-checkbox ng-model=user_participation.hide_identity aria-label=\"Checkbox 1\">Quiero que mi donación sea anónima.</md-checkbox><i class=\"fa fa-info-circle tooltip-cow-option\" tooltip-placement=left uib-tooltip=\"Tu nombre no se mostrará en la lista de participantes\" aria-hidden=true></i></div><div class=\"row padding-left-right-top\" layout-gt-sm=row ng-show=\"cow_event.business_type == 1\"><md-checkbox ng-model=user_participation.hide_total_amount aria-label=\"Checkbox 1\">Quiero ocultar el monto de mi donación.</md-checkbox><i class=\"fa fa-info-circle tooltip-cow-option\" tooltip-placement=left uib-tooltip=\"El monto que aportas no se mostrará en la lista de participantes\" aria-hidden=true></i></div></form><!--Cupón--><div class=\"row text-center margin-top-5 padding-left-right-bottom\" ng-show=\"cow_event.has_promo_code && !cow_has_gift_code\"><div class=form-group><input id=cow_link type=text name=link ng-model=gift_code class=\"form-control col-md-8 input-link-share\" placeholder=\"Tienes un código promocional?\"><div class=\"col-md-4 col-sm-6 col-xs-6 no-padding-left-right-xs-sm\"><button type=button name=button class=\"form-control font-size-13-sm-xs\" ngclipboard data-clipboard-target=#cow_link ng-click=applyCoupon()><i class=\"fa fa-gift\" aria-hidden=true></i> Aplicar código</button></div></div></div><!--Métodos de pago--><div class=\"row text-center\"><h3 class=\"text-center margin-bottom-20\">Selecciona el método de pago</h3></div><!--EFECTY--><!--<div class=\"row padding-left-right-bottom\">--><!--<div class=\"col-md-3 col-sm-6 col-xs-6 no-padding-left-right no-outline\" ng-click=\"paymentMethodToEfecty()\">--><!--<p class=\"payment-method-title\">Efectivo</p>--><!--</div>--><!--<div class=\"col-md-9 col-sm-6 col-xs-6 \">--><!--<img class=\"img-responsive payment-method-image-efecty no-outline\"--><!--src=\"assets/images/payment-methods/efecty.png\"--><!--alt=\"payment-methods\" ng-click=\"paymentMethodToEfecty()\"--><!--ng-class=\"(efectyCollapsed)?\'filter-gray\':\'no-filter-gray\'\"/>--><!--</div>--><!--</div>--><!--<div uib-collapse=\"efectyCollapsed\" class=\"row padding-left-right-bottom\">--><!--<div class=\"col-md-11 no-padding-left\">--><!--<p>--><!--Al seleccionar este metodo de pago podrás pagar tu participación en efectivo en cualquier--><!--<a href=\"https://www.efecty.com.co/web/puntos-de-atencion\" target=\"_blank\">punto Efecty del país</a>.--><!--Ten en cuenta:--><!--</p>--><!--<ul>--><!--<li>--><!--Debes llevar tu <b>documento de identidad</b> y los datos deben corresponder con los registrados anteriormente--><!--en el formulario <b>\"Datos Responsable Pago\"</b>.--><!--</li>--><!--<li>--><!--Debes llevar la <b>Referencia de Pago</b> que te generará nuestra plataforma al confirmar el pago.--><!--</li>--><!--</ul>--><!--</div>--><!--</div>--><!--PSE--><div class=\"row padding-left-right-bottom\"><div class=\"col-md-3 col-sm-6 col-xs-6 no-padding-left-right no-outline\" ng-click=paymentMethodToPse()><p class=payment-method-title>Cuenta de Ahorros - PSE</p></div><div class=\"col-md-9 col-sm-6 col-xs-6\"><img class=\"img-responsive payment-method-image-pse no-outline\" src=assets/images/payment-methods/pse.png alt=payment-methods ng-click=paymentMethodToPse() ng-class=\"(pseCollapsed)?\'filter-gray\':\'no-filter-gray\'\"></div></div><div uib-collapse=pseCollapsed class=\"row padding-left-right-bottom\"><div class=\"col-md-11 no-padding-left\"><p>Para pagar con PSE debes <b>tener habilitada esta opción</b> con tu entidad bancaria y el monto a pagar no debe superar los <b>topes que te han habilitado</b>. El pago puede tardar hasta <b>30 minutos en verse reflejado</b>.</p></div></div><!--TC --><div class=\"row padding-left-right-bottom\"><div class=\"col-md-3 col-sm-3 col-xs-3 no-padding-left-right no-outline\" ng-click=paymentMethodToCc()><p class=payment-method-title>Tarjeta de crédito</p></div><div class=\"col-md-2 col-sm-3 col-xs-3 text-center\"><img class=\"img-responsive payment-method-image-cc no-outline\" src=assets/images/payment-methods/mastercard.png alt=payment-methods ng-click=paymentMethodToCc() ng-class=\"(ccCollapsed)?\'filter-gray\':\'no-filter-gray\'\"></div><div class=\"col-md-2 col-sm-3 col-xs-3 text-center\"><img class=\"img-responsive payment-method-image-cc no-outline\" src=assets/images/payment-methods/visa.png alt=payment-methods ng-click=paymentMethodToCc() ng-class=\"(ccCollapsed)?\'filter-gray\':\'no-filter-gray\'\"></div><div class=\"col-md-2 col-sm-3 col-xs-3 text-center\"><img class=\"img-responsive payment-method-image-cc-diners no-outline\" src=assets/images/payment-methods/diners.png alt=payment-methods ng-click=paymentMethodToCc() ng-class=\"(ccCollapsed)?\'filter-gray\':\'no-filter-gray\'\"></div></div><div uib-collapse=ccCollapsed><div ng-show=\"userCreditCards.length>0\"><h3 class=text-center>Tarjetas Guardadas</h3></div><div class=\"col-md-12 no-padding-left-right\" ng-show=\"userCreditCards.length>0\"><div class=\"col-md-8 col-md-offset-2 no-padding-left-right\"><div class=\"col-md-6 no-padding-left-right\" ng-repeat=\"credit_card in userCreditCards track by $index\"><md-list-item class=\"contact-item selected list-contact\"><img ng-if=\"credit_card.franchise==1\" src=assets/images/payment-methods/visa.png class=md-avatar alt=visa-img> <img ng-if=\"credit_card.franchise==2 || credit_card.franchise==3\" src=assets/images/payment-methods/mastercard.png class=md-avatar alt=mastercard-img> <img ng-if=\"credit_card.franchise==4\" src=assets/images/payment-methods/diners.png class=md-avatar alt=diners-img><div><p class=font-size-11>{{credit_card.card_name}}</p><p class=\"no-margin-bottom font-size-10\">**** **** **** {{credit_card.last_numbers}}</p><md-checkbox ng-model=credit_card.checked class=\"font-bold font-color-atv right-corner-item\" ng-change=checkedChanged(credit_card)></md-checkbox></div></md-list-item></div></div></div><!--<div class=\"\" ng-if=\"user && !creditCardSelected\">--><!--<h3 class=\"text-center\">Tarjeta Nueva</h3>--><!--</div>--><!--------------------------CREDIT CARD---------------><div ng-show=\"!creditCardSelected && !ccCollapsed\"><form name=ccForm novalidate><!--CARD CONTAINER--><div class=card-container><!--CARD NUMBER--><div class=card-container-input><label for=cardNumber>Número de la tarjeta</label><input type=tel placeholder=\"\" cc-format=4242424242424242 id=cardNumber cc-number cc-eager-type name=ccNumber ng-model=user_participation.card.number ng-required=true></div><!--CARD EXPIRY--><div class=card-container-input><label>Mes</label><select placeholder=MM ng-model=user_participation.card.month required><option value=\"\" selected hidden>MM</option><option ng-repeat=\"month in ccMonths\" value={{month.id}} class=font-color-black>{{month.key_type_name}}</option></select><label>Año</label><select placeholder=YY ng-model=user_participation.card.year name=ccExpYear required><option value=\"\" selected hidden>AA</option><option ng-repeat=\"year in ccYears\" value={{year.id}} class=font-color-black>{{year.key_type_name}}</option></select></div><!--CARD NAME--><div class=card-container-input><label>Nombre en la tarjeta</label><input type=text placeholder=\"\" maxlength=30 id=cardName name=ccName ng-model=user_participation.card.name ng-required=true></div><!--CARD BRAND--><div class=card-container-brand><div ng-if=\"ccForm.ccNumber.$ccEagerType==\'Diners Club\'\"><img src=assets/images/payment-methods/diners.png alt=payment-methods></div><div ng-if=\"ccForm.ccNumber.$ccEagerType==\'Visa\'\"><img src=assets/images/payment-methods/visa_white.png alt=payment-methods></div><div ng-if=\"ccForm.ccNumber.$ccEagerType==\'MasterCard\'\"><img src=assets/images/payment-methods/mastercard.png alt=payment-methods></div></div><!--CARD ATV OPACITY--><div class=card-container-logo><img src=assets/images/logo-box.png></div></div><!--FRONT CARD ERRORS--><div class=card-errors><div ng-show=\"ccForm.$submitted && !ccForm.ccNumber.$valid\"><p>Ingresa un número de tarjeta valido.</p></div><div ng-show=\"actualMonth>user_participation.card.month && actualYear==user_participation.card.year\"><p>Fecha de vencimiento inválida.</p></div><div ng-show=\"ccForm.$submitted && (!user_participation.card.month || !user_participation.card.year)\"><p>Fecha de vencimiento inválida.</p></div><div ng-show=\"ccForm.$submitted && !user_participation.card.name\"><p>Ingresa el nombre del titular de la tarjeta.</p></div><div ng-show=\"ccForm.$submitted && (ccForm.ccNumber.$ccEagerType !=\'MasterCard\' &&\n                ccForm.ccNumber.$ccEagerType !=\'Visa\' && ccForm.ccNumber.$ccEagerType !=\'Diners Club\')\"><p>Tu tarjeta debe ser Mastercard, Visa o Diners</p></div></div><!--BACK CARD CONTAINER--><div class=card-back-container ng-if=\"ccForm.ccNumber.$valid &&\n              (ccForm.ccNumber.$ccEagerType ==\'MasterCard\' || ccForm.ccNumber.$ccEagerType ==\'Visa\' ||\n              ccForm.ccNumber.$ccEagerType ==\'Diners Club\')\"><div class=card-back-container-band></div><div class=card-back-container-cvc><label>CVC (Cod. Seguridad)</label><input type=tel id=cvc cc-cvc cc-type=ccForm.ccNumber.$ccType name=ccCvc ng-model=$parent.user_participation.card.cvc ng-required=true maxlength=3 minlength=3></div><div class=card-back-container-logo><img src=assets/images/logo-box.png></div></div><div ng-show=\"ccForm.$submitted && !ccForm.ccCvc.$valid\"><p class=\"validation-messages no-margin-top\">El CVC es obligatorio y sólo debes ingresar dígitos.</p></div></form></div><!-----------------------CARD INSTALLMENTS--------------------><div class=installments-box><label>Cuotas</label><select class=\"form-control div-select-payment\" placeholder=01 ng-model=user_participation.card_installments ng-init=\"user_participation.card_installments=\'1\'\" required><option ng-repeat=\"installment in ccInstallments\" value={{installment.id}}>{{installment.key_type_name}}</option></select></div><div ng-if=\"user && !creditCardSelected\"><md-checkbox ng-model=$parent.user_participation.save_credit_card aria-label=\"Checkbox 3\">Guardar tarjeta de crédito para futuras participaciones</md-checkbox></div></div></div><!--<div ng-show=\"showSummary\" class=\"padding-15\">--><div ng-show=showSummary class=padding-15><div class=\"row text-center\"><h3 class=text-center>Confirma los Datos</h3><p><b>Revisa que toda la información ingresada sea correcta</b></p></div><div class=row><h4>Datos responsable pago</h4><p class=no-margin-bottom>Nombre: <b>{{user_participation.first_name + \' \' + user_participation.last_name}}</b></p><p class=no-margin-bottom ng-show=\"user_participation.document_type == 1 || user_participation.document_type == 2\">Documento: <b>{{user_participation.document_number}}</b></p><p class=no-margin-bottom ng-show=\"user_participation.document_type == 3 || user_participation.document_type == 4\">Documento: <b>{{user_participation.document_full_number}}</b></p><p class=no-margin-bottom>Email: <b>{{user_participation.email }}</b></p><p class=no-margin-bottom>Número celular: <b>{{user_participation.cellphone }}</b></p></div><div class=row><hr></div><div class=row><h4>Método de pago</h4><div ng-show=efectySummary><div class=\"col-md-2 no-padding-left\"><img class=\"img-responsive payment-method-image-efecty no-outline\" src=assets/images/payment-methods/efecty.png alt=payment-methods></div><div class=\"col-md-10 no-padding-left\"><ul><li>Al hacer clic en <b>Realizar pago</b> se generará tu Referencia de Pago</li><li>Debes acercarte a cualquier <a href=https://www.efecty.com.co/web/puntos-de-atencion target=_blank>punto Efecty del país</a> con la <b>Referencia de Pago</b> y el <b>Documento de Identidad</b>.</li><li>Los datos del documento de identidad deben coincidir con los registrados anteriormente en el formulario <b>Datos Responsable Pago</b>.</li></ul></div></div><div ng-show=pseSummary><div class=\"col-md-1 no-padding-left\"><img class=\"img-responsive payment-method-image-pse no-outline\" src=assets/images/payment-methods/pse.png alt=payment-methods></div><div class=\"col-md-11 no-padding-left\"><ul><li>Al hacer clic en <b>Realizar pago</b> serás redireccionado a la pasarela de pagos. No recargues ni cierres la página.</li><li>Recuerda hacer click en <b>Regresar al comercio</b> al finalizar la transaccion</li><li>Los pagos con PSE pueden tardar hasta <b>30 minutos en verse reflejados</b>.</li></ul></div></div><div ng-show=ccSummary><div class=\"col-md-1 col-xs-3 no-padding-left\"><img ng-if=\"ccForm.ccNumber.$ccEagerType==\'Diners Club\'\" class=\"img-responsive payment-method-image-card-diners\" src=assets/images/payment-methods/diners.png alt=diners-img> <img ng-if=\"ccForm.ccNumber.$ccEagerType==\'Visa\'\" class=\"img-responsive payment-method-image-card-visa\" src=assets/images/payment-methods/visa.png alt=visa-img> <img ng-if=\"ccForm.ccNumber.$ccEagerType==\'MasterCard\'\" class=\"img-responsive payment-method-image-card-mc\" src=assets/images/payment-methods/mastercard.png alt=mastercard-img></div><div class=\"col-md-11 col-xs-9 no-padding-left\"><p>**** **** **** {{ccLastNumbers}}<br>{{user_participation.card.name}}</p></div></div><div ng-show=ccTokenSummary><div class=\"col-md-1 col-xs-3 no-padding-left\"><img ng-if=\"creditCardSelected.franchise==1\" src=assets/images/payment-methods/visa.png class=\"img-responsive payment-method-image-card-visa\" alt=visa-img> <img ng-if=\"creditCardSelected.franchise==2 || creditCardSelected.franchise==3\" src=assets/images/payment-methods/mastercard.png class=\"img-responsive payment-method-image-card-mc\" alt=mastercard-img> <img ng-if=\"creditCardSelected.franchise==4\" src=assets/images/payment-methods/diners.png class=\"img-responsive payment-method-image-card-diners\" alt=diners-img></div><div class=\"col-md-11 col-xs-9 no-padding-left\"><p>**** **** **** {{creditCardSelected.last_numbers}}<br>{{creditCardSelected.card_name}}</p></div></div></div><div ng-show=!efectySummary><div class=row><hr></div><div><p class=no-margin-bottom style=\"color: grey\">Ten en cuenta que el cobro lo verás reflejado a nombre de <strong>Evolution Ideas SAS</strong></p></div><div class=row><hr></div></div><div class=row><p class=no-margin-bottom>Valor a pagar<br><b style=\"font-size: 22px\">{{total_value_commission | currency:\"$\":\'0\'}} COP</b></p></div></div><div ng-show=showSummary class=margin-top-10><md-checkbox ng-model=user_participation.send_promotional_emails aria-label=\"Checkbox 3\">Deseo recibir más información sobre los servicios de ArmaTuVaca</md-checkbox><md-checkbox ng-model=acceptTermsConditions aria-label=\"Checkbox 3\" class=no-margin>He leído y acepto los <a id=register_terms_and_conditions_link2 ui-sref=terms-and-conditions target=_blank>términos y condiciones</a> y la <a id=register_privacy_policy_link2 ui-sref=privacy-policy target=_blank>política de tratamiento de datos</a> de ArmaTuVaca.</md-checkbox><p ng-show=!acceptTermsConditions class=validation-messages>Debes aceptar para finalizar el pago</p></div><div class=\"row padding-left-right-bottom\" ng-show=payment_pending><br><p ng-show=payment_pending><strong><b><i class=\"fa fa-exclamation-triangle font-color-blue\" aria-hidden=true></i> </b></strong>&nbsp;En este momento nuestro proveedor de pagos se encuentra verificando tu transacción anterior en estado <strong>pendiente</strong>. Recuerda que si pagaste usando PSE este proceso puede tardar hasta <strong>30 minutos</strong>. Si deseas mayor información sobre el estado actual de la operación puedes enviar un correo electrónico a <strong>contacto@armatuvaca.com</strong> y/o consulta tu pago haciendo click <span ng-click=checkPreviousParticipation() style=\"text-decoration: underline;cursor: pointer\"><b>aquí</b></span>.</p><br><br></div><div class=\"row padding-15\"><a href=\"\" ng-click=goToCredibancoCow() ng-show=showPersonalDataForm class=\"return-payment-link font-color-pink\"><b><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</b></a> <a href=\"\" ng-click=backToPersonalDataForm() ng-show=showSummary class=\"return-payment-link font-color-pink\"><b><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</b></a> <button ng-click=submitPayment() class=\"btn btn-default button-action-small pull-right\" ng-show=showPersonalDataForm>Continuar</button> <button ng-click=confirmPayment() class=\"btn btn-default button-action-small pull-right\" ng-show=\"!payment_pending && showSummary\">Realizar pago</button></div></div></div></div><form-submitter></form-submitter><div class=loader-payment ng-show=payment_redirect><div class=container><h1 class=\"font-color-white text-center title-loader-payment\">Redireccionando a la plataforma de pagos</h1></div><div class=spinner-payment><div class=cube1-payment></div><div class=cube2-payment></div></div></div><div><credibanco-footer></credibanco-footer></div>");
$templateCache.put("app/views/fep/fep404/fep404.html","<div><fep-navbar></fep-navbar></div><div class=\"container-fluid text-center page-top-title-fep page-title-fep fep-piggy-background\"><h1>¡La alcancía FEP 2019 ha finalizado!</h1></div><div class=\"container-fluid background-color-white\"><div class=\"container text-center\"><div class=\"col-md-12 text-center\"><img class=\"img-responsive text-center center-item\" src=assets/images/astronaut.png alt=\"astronaut img\"></div></div></div><div><fep-footer></fep-footer></div>");
$templateCache.put("app/views/fep/fepCow/fepCow.html","<div><fep-navbar></fep-navbar></div><div class=fep-piggy-background><div class=\"container-fluid padding-top-20 overflow-hidden\"><div class=col-md-6><div class=closed-cow-bar ng-show=\"cowclosed && !fepCowCompleted\"><p class=alert-2>Cerrada</p></div><div class=main-top-content-fep><img class=fep-cow-main-img src=assets/images/fep/fep-cow-image.png ng-if=!fepCowCompleted> <img class=fep-cow-main-img src=assets/images/fep/fep-cow-completed.jpg ng-if=fepCowCompleted></div><div class=\"margin-top-10 col-md-offset-1 col-md-10\" ng-if=\"cow_event.cow_goal > 0\"><participation-bar current-value=cow_event.total_value_to_date_left goal=cow_event.cow_goal></participation-bar></div></div><div class=col-md-6><div class=\"row margin-bottom-20 text-center\"><div class=\"col-md-offset-4 col-md-4 col-md-offset-right-4\" ng-if=\"cow_event.pay_limit_date && !cow_event.closed\"><countdown-timer deadline=cow_event.pay_limit_date></countdown-timer></div><h2 class=\"text-center col-md-offset-2 col-md-8 col-md-offset-right-2\"><b>{{cow_event.name}}</b></h2><h4 class=\"text-center font-color-gray\"><b>ID Alcancía: {{cow_event.cow_event_id}}</b></h4><h4 class=\"text-center font-color-gray\"><b>Organizada por: {{cow_event.made_by}}</b></h4><h5 class=\"text-center col-md-offset-3 col-md-6 font-color-gray\" ng-show=\"cow_event.event_date && cow_event.location_name && cow_event.location_name != \'null\'\"><b class=\"col-md-3 col-md-offset-3\">Fecha: {{eventDateString}}</b> <b class=col-md-3>Lugar: {{cow_event.location_name}}</b></h5><h5 class=\"text-center font-color-gray\" ng-show=\"cow_event.event_date && !cow_event.location_name\"><b>Fecha: {{eventDateString}}</b></h5><h5 class=\"text-center font-color-gray\" ng-show=\"!cow_event.event_date && cow_event.location_name && cow_event.location_name != \'null\'\"><b>Lugar: {{cow_event.location_name}}</b></h5></div><div class=row><div class=\"text-center overflow-auto\" ta-bind ng-model=cow_event.description ng-if=cow_event.description></div><div class=\"text-center margin-bottom-20 overflow-auto background-color-white\" ng-if=!cow_event.description ng-bind-html=cow_event.cow_type.description_default></div></div></div></div><div class=container-fluid><div class=\"container margin-bottom-20\"><div><fep-cow-share cow=cow_event is-admin=adminUser></fep-cow-share></div><div class=\"row margin-top-20 background-color-white\"><div class=\"col-md-4 text-center cow-participants-fep no-outline\" ng-click=modalParticipants()><p class=p-cow-details><b ng-if=\"cow_event.participations == 1\">{{cow_event.participations}} participación</b> <b ng-if=\"cow_event.participations != 1\">{{cow_event.participations}} participaciones</b></p></div><div class=\"col-md-4 text-center cow-particiants-collect\"><p class=\"no-margin padding-top-3\"><b>Has ahorrado:</b><br><b class=font-color-fep>{{cow_event.total_value_to_date_left | currency:\"$\":\'0\'}} COP</b></p></div><div class=\"col-md-4 text-center cow-participants-fep-closed\" ng-show=\"cowclosed || fepCowCompleted\"><p class=p-cow-details-action><b>¡Abonar!</b></p></div><div class=\"col-md-4 text-center cow-participants-fep\" ng-click=goToFepCowParticipate(cow_event.cow_event_id) ng-show=\"!cowclosed && !fepCowCompleted\" hl-sticky=\"\" anchor=bottom><p class=p-cow-details-action><b>¡Abonar!</b></p></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 no-padding-left-right margin-bottom-20\" ng-if=cow_event.show_location_point><ui-gmap-google-map center=map.center zoom=map.zoom><!--MARKER--><ui-gmap-marker coords=marker.coords options=marker.options events=marker.events idkey=marker.id></ui-gmap-marker></ui-gmap-google-map></div><div class=container-fluid><div class=\"row margin-top-20 text-center\"><div class=fb-comments data-href={{cowPublicURLComplete}} data-numposts=5 data-colorscheme=light></div></div></div></div><div><fep-footer></fep-footer></div><script type=text/ng-template id=participantsModal-1><div class=\"ngdialog-message\">\n        <div class=\"text-center\" ng-if=\"ngDialogData.participants.length == 0\">\n            <h3>Por el momento no tienes ninguna participación</h3>\n            <p>\n                Invita a tus amigos a que participen en tu alcancía\n            </p>\n        </div>\n        <div class=\"text-center\" ng-if=\"ngDialogData.participants.length > 0\">\n            <div id=\"participants_list\">\n                <h3>Participaciones</h3>\n                <div ng-if=\"!ngDialogData.cow.has_options\">\n                    <p ng-repeat=\"participant in ngDialogData.participants track by $index\">\n                        {{ ($index + 1) + \". \" + participant.first_name + \' \' + participant.last_name + \' - \' +\n                        participant.total_amount}}\n                    </p>\n                </div>\n                <div ng-if=\"ngDialogData.cow.has_options\">\n                    <div ng-repeat=\"option in ngDialogData.participants track by $index\">\n                        <h4>{{option.option + \' - \' + option.option_total}}</h4>\n                        <p ng-repeat=\"participant in option.participants track by $index\">\n                            {{ ($index + 1) + \". \" + participant.first_name + \' \' + participant.last_name + \' - \' +\n                            participant.total_amount}}\n                        </p>\n                        <br>\n                    </div>\n                </div>\n            </div>\n            <button type=\"button\" name=\"button\" class=\"form-control\" ngclipboard data-clipboard-target=\"#participants_list\">\n                <i class=\"fa fa-clone\" aria-hidden=\"true\"></i>\n                Copiar lista\n            </button>\n        </div>\n    </div></script>");
$templateCache.put("app/views/fep/fepCowAdmin/fepCowAdmin.html","<div><fep-navbar></fep-navbar></div><div class=fep-piggy-background ng-show=adminUser><div class=\"container-fluid padding-top-20 overflow-hidden\"><div class=col-md-6><div class=closed-cow-bar ng-show=cowclosed_moneyrequest><p class=\"alert-4 font-size-12-xs\">Has recolectado todo el dinero disponible en esta alcancía<br>Monto recolectado: {{cow_event.total_value_cash_out | currency:\"$\":\'0\'}} COP</p></div><div class=main-top-content-fep><img class=fep-cow-main-img src=assets/images/fep/fep-cow-image.png ng-if=!fepCowCompleted> <img class=fep-cow-main-img src=assets/images/fep/fep-cow-completed.jpg ng-if=fepCowCompleted></div><div class=\"margin-top-10 col-md-offset-1 col-md-10\" ng-if=\"cow_event.cow_goal > 0\"><participation-bar current-value=cow_event.total_value_to_date_left goal=cow_event.cow_goal></participation-bar></div></div><div class=col-md-6><div class=\"row margin-bottom-20 text-center\"><div class=\"col-md-offset-4 col-md-4 col-md-offset-right-4\" ng-if=\"cow_event.pay_limit_date && !cow_event.closed\"><countdown-timer deadline=cow_event.pay_limit_date></countdown-timer></div><h2 class=\"text-center col-md-offset-2 col-md-8 col-md-offset-right-2\"><b>{{cow_event.name}}</b></h2><h4 class=\"text-center font-color-gray\"><b>ID Alcancía: {{cow_event.cow_event_id}}</b></h4><h4 class=\"text-center font-color-gray\"><b>Organizada por: {{cow_event.made_by}}</b></h4><h4 class=\"text-center font-color-gray\" ng-show=\"fepTicketBooked && userDocument\"><b>Documento registrado: {{userDocument}}</b></h4><h4 class=\"text-center font-color-gray\" ng-show=\"fepTicketBooked && !userDocument\"><b class=text-red>Aún no has registrado tu documento</b></h4></div><div class=\"row margin-bottom-20 text-center\" ng-show=\"fepTicketBooked && fepSingleTicket && fepTicketDayConfirmed\"><h4 ng-repeat=\"ticket in fepTicketsArray\" class=\"col-md-offset-2 col-md-8 col-xs-12 no-padding-left font-bold\">Boleta {{ticket.id}}: {{ticket.selectedDay}}</h4></div><div class=row ng-show=\"fepTicketBooked && fepSingleTicket && !fepTicketDayConfirmed\"><h5 class=\"col-md-offset-2 col-md-8 col-xs-12 no-padding-left background-color-white font-bold\">Elige el día para tu boleta individual: <span class=font-color-red-error>(Una vez enviada la confirmación, no podrás realizar cambios)</span></h5><form name=fepTicketDayForm id=fepTicketDayForm ng-submit=submitFepTicketDay(fepTicketDayForm.$valid) novalidate><md-input-container class=\"col-md-offset-2 col-md-8 col-md-offset-right-2 col-xs-12 no-padding-left background-color-white\" ng-repeat=\"ticket in fepTicketsArray\"><label>Boleta {{ticket.id}}</label><md-select ng-model=ticket.selectedDay ng-change=\"selectFepTicketDay(ticket.id, ticket.selectedDay)\" required><md-option ng-repeat=\"day in fepDays\" ng-value=day>{{day}}</md-option></md-select></md-input-container><button type=submit class=\"btn btn-default button-action-small-fep col-md-offset-7 col-md-3 col-xs-12 margin-bottom-20 no-margin-top\">Confirmar Días</button></form></div><div class=row><div class=\"text-center overflow-auto\" ta-bind ng-model=cow_event.description ng-if=cow_event.description></div><div class=\"text-center margin-bottom-20 overflow-auto background-color-white\" ng-if=!cow_event.description ng-bind-html=cow_event.cow_type.description_default></div></div></div></div><div class=container-fluid><div class=\"container margin-bottom-20\"><div><fep-cow-share cow=cow_event is-admin=adminUser></fep-cow-share></div><div class=\"row margin-top-20 background-color-white\"><div class=\"col-md-4 text-center cow-participants-fep no-outline\" ng-click=modalParticipants()><p class=p-cow-details><b ng-if=\"cow_event.participations == 1\">{{cow_event.participations}} participación</b> <b ng-if=\"cow_event.participations != 1\">{{cow_event.participations}} participaciones</b></p></div><div class=\"col-md-4 text-center cow-particiants-collect\"><p class=\"no-margin padding-top-3\"><b>Has ahorrado:</b><br><b class=font-color-fep>{{cow_event.total_value_to_date_left | currency:\"$\":\'0\'}} COP</b></p></div><div class=\"col-md-4 text-center cow-participants-fep-closed\" ng-show=\"cowclosed || fepCowCompleted\"><p class=p-cow-details-action><b>¡Abonar!</b></p></div><div class=\"col-md-4 text-center cow-participants-fep\" ng-click=goToFepCowParticipate(cow_event.cow_event_id) ng-show=\"!cowclosed && !fepCowCompleted\"><p class=p-cow-details-action><b>¡Abonar!</b></p></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 no-padding-left-right margin-bottom-20\" ng-if=cow_event.show_location_point><ui-gmap-google-map center=map.center zoom=map.zoom><!--MARKER--><ui-gmap-marker coords=marker.coords options=marker.options events=marker.events idkey=marker.id></ui-gmap-marker></ui-gmap-google-map></div><div class=container-fluid><div class=\"row margin-top-20 text-center\"><div class=fb-comments data-href={{cowPublicURLComplete}} data-numposts=5 data-colorscheme=light></div></div></div><div class=\"container-fluid no-padding background-color-dark-gray hidden-xs hidden-sm\" hl-sticky=\"\" anchor=bottom><div class=\"col-md-12 no-padding-left-right\"><div class=\"fep-admin-img-div text-center\"><div class=\"col-sm-9 col-xs-9 col-md-12 admin-title no-outline\" ng-click=useFepCow()><h2 class=admin-title>¡Quiero usar mi alcancía!</h2></div></div></div></div><div class=\"container-fluid background-color-dark-gray visible-xs visible-sm no-padding-left-right\" hl-sticky=\"\" anchor=bottom><div class=\"container no-padding-left-right\"><div class=\"col-sm-12 col-xs-12 no-padding-left-right\"><div class=\"col-sm-12 col-xs-12 fep-admin-img-div text-center\" ng-click=useFepCow()><h3 class=admin-title-fep>¡Quiero usar mi alcancía!</h3></div></div></div></div></div><div ng-show=!adminUser><div class=\"container-fluid text-center\"><div class=\"row page-top-title-fep page-title-fep\"><h1 class=\"font-color-fep margin-top-40-md\"><b>Administrar Alcancía FEP</b></h1></div></div><div class=\"container-fluid background-color-white\"><div class=container><h3 class=text-center>Area restringida para el administrador</h3><div class=\"row col-md-6 text-center margin-bottom-20\"><h4 class=text-center>Si no eres el administrador haz clic en el botón para ir a la pagina de invitados</h4><button class=\"btn btn-default button-action-small-fep\" ng-click=goToPublicFepCow()><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Ir a la alcancía</button></div><div class=\"row col-md-6 margin-bottom-20\"><h4 class=text-center>Si eres el administrador de esta alcancía inicia sesión</h4><div class=\"row login-form-content col-md-offset-2 col-md-8\"><div class=social-login><div><a class=\"btn btn-block btn-social btn-facebook facebook-button\" ng-click=loginFb()><span class=\"fa fa-facebook\"></span> Ingresa con Facebook</a></div><div class=google-social><a class=\"btn btn-block btn-social btn-google google-button\" ng-click=loginGg()><span class=\"fa fa-google\"></span> Ingresa con Google</a></div></div><div class=email-login><form name=loginForm ng-submit=loginUser(loginForm.$valid) novalidate><h3 class=text-center>Iniciar sesión</h3><md-input-container class=md-block flex-gt-sm=\"\"><label>Correo</label><input required name=email maxlength=100 ng-model=user.email type=email><div ng-messages=loginForm.email.$error><div ng-message=required>Por favor, digita tu correo.</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\"><label>Contraseña</label><input required name=password maxlength=100 minlength=8 ng-model=user.password type=\"{{(show_password)? \'text\': \'password\'}}\"><div ng-messages=loginForm.password.$error><div ng-message=required>Por favor, digita tu contraseña.</div><div ng-message=minlength>Tu contraseña debe ser mínimo de 8 caracteres.</div></div></md-input-container><div class=\"col-md-6 no-padding-left\"><a href=\"\" ui-sref=forgot-password>Oh no ¿Olvidaste tu contraseña?</a></div><p ng-show=errorSended class=\"text-danger login-error-msg\">{{errorMessage}}</p><button class=\"btn btn-default pull-right button-action-small-fep\" type=submit>Iniciar sesión</button></form></div></div></div></div></div></div><div><fep-footer></fep-footer></div><!-- Templates --><script type=text/ng-template id=participantsModal-1><div class=\"ngdialog-message\">\n        <div class=\"text-center\" ng-if=\"ngDialogData.participants.length == 0\">\n            <h3>Por el momento no tienes ninguna participación</h3>\n            <p>\n                Invita a tus amigos a que participen en tu alcancía\n            </p>\n        </div>\n        <div class=\"text-center\" ng-if=\"ngDialogData.participants.length > 0\">\n            <div id=\"participants_list\">\n                <h3>Participaciones</h3>\n                <div ng-if=\"!ngDialogData.cow.has_options\">\n                    <p ng-repeat=\"participant in ngDialogData.participants track by $index\">\n                        {{ ($index + 1) + \". \" + participant.first_name + \' \' + participant.last_name + \' - \' +\n                        participant.total_amount}}\n                    </p>\n                </div>\n                <div ng-if=\"ngDialogData.cow.has_options\">\n                    <div ng-repeat=\"option in ngDialogData.participants track by $index\">\n                        <h4>{{option.option + \' - \' + option.option_total}}</h4>\n                        <p ng-repeat=\"participant in option.participants track by $index\">\n                            {{ ($index + 1) + \". \" + participant.first_name + \' \' + participant.last_name + \' - \' +\n                            participant.total_amount}}\n                        </p>\n                        <br>\n                    </div>\n                </div>\n            </div>\n            <button type=\"button\" name=\"button\" class=\"form-control\" ngclipboard data-clipboard-target=\"#participants_list\">\n                <i class=\"fa fa-clone\" aria-hidden=\"true\"></i>\n                Copiar lista\n            </button>\n        </div>\n    </div></script><script type=text/ng-template id=requestCellphoneModal><div class=\"ngdialog-message\">\n        <div class=\"text-center\">\n            <i class=\"fa fa-mobile font-size-60\" aria-hidden=\"true\"></i>\n            <h3 class=\"margin-top-10\">¡{{ngDialogData.user.user.first_name}}, sácale el jugo a tu alcancía!</h3>\n            <p>\n                Agrega un número celular a tu cuenta y así podremos ayudarte\n            </p>\n            <form class=\"userCellphoneModal\" name=\"formUserCellphone\" novalidate=\"\">\n                <md-input-container class=\"col-md-offset-2 col-xs-offset-1 col-md-8 col-xs-10 margin-top-10 no-margin-bottom\" md-no-float>\n                    <input id=\"user_cellphone\" ng-model=\"user.cellphone\" name=\"userCellphone\" type=\"tel\" pattern=\"[0-9]{10,12}\"\n                           only-digits required=\"\" placeholder=\"Tu número celular\" class=\"text-center\">\n                    <div ng-messages=\"formUserCellphone.userCellphone.$error\">\n                        <div ng-message=\"required\">\n                            Debes digitar tu número celular\n                        </div>\n                        <div ng-message=\"pattern\">\n                            El número debe contener entre 10 y 12 dígitos\n                        </div>\n                    </div>\n                </md-input-container>\n                <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"submitUserCellphone(formUserCellphone.$valid)\"></a>\n            </form>\n            <p class=\"font-size-12 margin-top-10\">\n                Tu número se almacenará de acuerdo a nuestra\n                <a ui-sref=\"privacy-policy\" href=\"https://s3.amazonaws.com/alcancia.festivalestereopicnic.com/docs/PoliticaDatos.pdf\"\n                   target=\"_blank\" class=\"\">\n                    política de tratamiento de datos.\n                </a>\n            </p>\n        </div>\n    </div></script><script type=text/ng-template id=requestDocumentNumberModal><div class=\"ngdialog-message\">\n        <div class=\"text-center\">\n            <i class=\"fa fa-id-card font-size-60\" aria-hidden=\"true\"></i>\n            <h3 class=\"margin-top-10\">¡{{ngDialogData.user.user.first_name}}, si tus boletas quieres reclamar, tu documento debes registrar!</h3>\n            <p>\n                Escribe el número de tu documento de identidad con el que te acercarás a reclamar las boletas.<br>\n                <span class=\"font-color-red-error font-bold\">Debe ser el del titular de la alcancía</span>\n            </p>\n            <form class=\"userCellphoneModal\" name=\"formUserDocument\" novalidate=\"\">\n                <md-input-container class=\"col-md-offset-2 col-xs-offset-1 col-md-8 col-xs-10 margin-top-10 no-margin-bottom\" md-no-float>\n                    <input id=\"user_document\" ng-model=\"user.document\" name=\"userDocument\" type=\"tel\" pattern=\"[0-9]{6,12}\"\n                           only-digits required=\"\" placeholder=\"Tu documento\" class=\"text-center\">\n                    <div ng-messages=\"formUserDocument.userDocument.$error\">\n                        <div ng-message=\"required\">\n                            Debes digitar tu número de documento\n                        </div>\n                        <div ng-message=\"pattern\">\n                            El número debe contener entre 6 y 12 dígitos\n                        </div>\n                    </div>\n                </md-input-container>\n                <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"submitUserDocument(formUserDocument.$valid)\"></a>\n            </form>\n            <p class=\"font-size-12 margin-top-10\">\n                Tu documento se almacenará de acuerdo a nuestra\n                <a ui-sref=\"privacy-policy\" href=\"https://s3.amazonaws.com/alcancia.festivalestereopicnic.com/docs/PoliticaDatos.pdf\"\n                   target=\"_blank\" class=\"\">\n                    política de tratamiento de datos.\n                </a>\n            </p>\n        </div>\n    </div></script><script type=text/ng-template id=useFepCowInfo><div class=\"ngdialog-message\">\n        <div class=\"text-center\">\n            <img src=\"../../../assets/images/fep/logo-fep.png\" class=\"height-30 margin-bottom-20\"/>\n            <h4 class=\"margin-top-10\">¿Quieres reclamar tus boletas?</h4>\n            <h4 class=\"margin-top-10\">¿Necesitas usar el dinero de tu alcancía?</h4>\n            <h4 class=\"margin-top-10\">¿Necesitas modificar tipo o número de boletas?</h4>\n            <p class=\"font-size-13-sm-xs\">\n                Escríbenos ahora mismo un correo a fep@armatuvaca.com, detallando tu solicitud y el ID de tu alcancía\n            </p>\n            <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"closeUseFepCowModal(ngDialogId)\"></a>\n        </div>\n    </div></script><script type=text/ng-template id=confirmFepTicketDayModal><div class=\"ngdialog-message\">\n        <div class=\"text-center\">\n            <img src=\"../../../assets/images/fep/logo-fep.png\" class=\"height-30 margin-bottom-20\"/>\n            <h4 class=\"margin-top-10\">¿Estás seguro de tu elección?</h4>\n            <h4 class=\"margin-top-10 font-color-red-error\">Una vez enviada la confirmación, no podrás realizar cambios</h4>\n            <a class=\"smGlobalBtn cancelContactBtn\" ng-click=\"closeFepTicketDayModal(ngDialogId)\"></a>\n            <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"confirmFepTicketDay(ngDialogId)\"></a>\n        </div>\n    </div></script>");
$templateCache.put("app/views/fep/fepCowDeleted/fepCowDeleted.html","<div><fep-navbar></fep-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title-fep page-title-fep\"><h1 class=\"font-color-fep margin-top-40-md\"><b>Alcancía eliminada</b></h1><p></p></div></div><div class=\"container-fluid background-color-white no-padding-left-right\"><div class=\"container margin-top-bottom-20\"><div class=row><div class=text-center><p>Lamentablente esta alcancía ha sido eliminada.<br><br>No dudes en contactarnos si nos necesitas:<br><br>Correo: <a href=mailto:contacto@armatuvaca.com>contacto@armatuvaca.com</a><br><br>Teléfono: (+571) 524 9603</p></div></div></div></div><fep-footer></fep-footer>");
$templateCache.put("app/views/fep/fepCowTempLogin/fepCowTempLogin.html","<div><fep-navbar></fep-navbar></div><div class=\"container-fluid text-center page-top-title-fep page-title-fep fep-piggy-background\"><h1>Crear Alcancía Virtual</h1><p>Regístrate o inicia sesión para completar la creación de tu alcancía</p></div><div class=container ng-if=!fepCowExist><uib-tabset active=\"\" justified=true class=fep-tabs><uib-tab index=1 heading=Registro class=\"col-xs-6 xs-float-left\"><div class=\"row col-md-8 user-data-form-content col-md-offset-2 margin-bottom-20 background-color-white\"><div class=\"social-login margin-bottom-20\"><div><a id=cow_temp_register_fb class=\"btn btn-block btn-social btn-facebook facebook-button\" ng-click=loginFb()><span class=\"fa fa-facebook\"></span> Ingresa con Facebook</a></div><div class=google-social><a id=cow_temp_register_gg class=\"btn btn-block btn-social btn-google google-button\" ng-click=loginGg()><img src=assets/images/utils/google-logo.svg class=\"no-outline img-google-logo\" alt=google-maps-logo> Ingresa con Google</a></div><div class=margin-top-20><p class=small-font>Al registrarte por medio de Facebook o Google, aceptas los <a id=cow_temp_register_terms_and_conditions href=https://s3.amazonaws.com/alcancia.festivalestereopicnic.com/docs/TyC.pdf target=_blank>términos y condiciones</a> y la <a id=cow_temp_register_privacy_policy href=https://s3.amazonaws.com/alcancia.festivalestereopicnic.com/docs/PoliticaDatos.pdf target=_blank>política de tratamiento de datos</a></p><p ng-show=errorSended class=text-danger>{{errorMessage}}</p></div></div><form name=registerForm ng-submit=\"registerNewUser(registerForm.$valid && (user.password == user.confirm_password) && (user.email == user.confirm_email))\" novalidate><h3 class=\"text-center margin-bottom-40\">Regístrate con tu correo</h3><div layout-gt-sm=\"row \"><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"registerForm.first_name.$invalid && registerForm.$submitted\"><label>Nombre</label><input id=cow_temp_register_first_name required name=first_name md-maxlength=50 ng-model=user.first_name placeholder=\"Ingresa acá tu nombre\"><div ng-messages=registerForm.first_name.$error><div ng-message=required>Por favor, digita tu nombre.</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"registerForm.last_name.$invalid && registerForm.$submitted\"><label>Apellido</label><input id=cow_temp_register_last_name required name=last_name md-maxlength=100 ng-model=user.last_name placeholder=\"Ingresa acá tu apellido\"><div ng-messages=registerForm.last_name.$error><div ng-message=required>Por favor, digita tu apellido.</div></div></md-input-container></div><div class=row><div class=\"col-md-5 register-date-picker margin-bottom-20\"><label ng-class=\"(user.born_date)? \'font-color-atv\': \'font-color-gray\'\">Fecha de nacimiento</label><md-input-container class=\"margin-top-3 no-margin-bottom\"><md-datepicker id=cow_temp_register_born_date ng-model=user.born_date md-max-date=maxDate md-placeholder=DD/MM/AAAA name=born_date required></md-datepicker><div ng-messages=registerForm.born_date.$error><div ng-message=valid>Fecha invalida</div><div ng-message=required>Por favor, selecciona tu fecha de nacimiento</div><div ng-message=maxdate>Debes ser mayor de edad para registrarte</div></div></md-input-container></div></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"registerForm.email.$invalid && registerForm.$submitted\"><label>Correo</label><input id=cow_temp_register_email required name=email maxlength=100 ng-model=user.email type=email placeholder=\"Ingresa acá tu correo\"><div ng-messages=registerForm.email.$error><div ng-message=required>Por favor, digita tu correo.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"registerForm.confirm_email.$invalid && registerForm.$submitted\"><label>Confirmar correo</label><input id=cow_temp_register_confirm_email required name=confirm_email maxlength=100 ng-model=user.confirm_email type=email placeholder=\"Confirma acá tu correo\"><p ng-show=\"user.confirm_email != user.email\" class=validation-messages>Los correos deben coincidir.</p><div ng-messages=registerForm.confirm_email.$error><div ng-message=required>Por favor, confirma tu correo.</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"registerForm.password.$invalid && registerForm.$submitted\"><label>Contraseña</label><input id=cow_temp_register_password required name=password maxlength=100 minlength=8 ng-model=user.password type=\"{{(show_password)? \'text\': \'password\'}}\" placeholder=\"Ingresa acá tu contraseña\"><div ng-messages=registerForm.password.$error><div ng-message=required>Por favor, digita tu contraseña.</div><div ng-message=minlength>Tu contraseña debe ser mínimo de 8 caracteres.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"registerForm.confirm_password.$invalid && registerForm.$submitted\"><label>Confirmar contraseña</label><input id=cow_temp_register_confirm_password required name=confirm_password maxlength=100 ng-model=user.confirm_password type=\"{{(show_password)? \'text\': \'password\'}}\" placeholder=\"Confirma acá tu contraseña\"><p ng-show=\"user.confirm_password != user.password\" class=validation-messages>Las contraseñas deben ser iguales.</p><div ng-messages=registerForm.confirm_password.$error><div ng-message=required>Por favor, confirma tu contraseña.</div></div></md-input-container></div><div class=\"col-md-12 no-padding\"><div class=\"col-md-6 no-padding\"><md-checkbox id=cow_temp_register_show_password ng-model=show_password aria-label=\"Checkbox 1\">Mostrar contraseñas</md-checkbox></div></div><p class=small-font>Al hacer clic en Regístrate, aceptas los <a id=cow_temp_terms_and_conditions2 href=https://s3.amazonaws.com/alcancia.festivalestereopicnic.com/docs/TyC.pdf target=_blank>términos y condiciones</a> y la <a id=cow_temp_privacy_policy2 href=https://s3.amazonaws.com/alcancia.festivalestereopicnic.com/docs/PoliticaDatos.pdf target=_blank>política de tratamiento de datos</a></p><p ng-show=errorSended class=text-danger>{{errorMessage}}</p><button id=cow_temp_register_submit class=\"btn btn-default pull-right button-action-small-fep\" type=submit>Regístrate</button></form></div></uib-tab><uib-tab index=0 heading=Login class=\"col-xs-6 xs-float-left\"><div class=\"row login-form-content col-md-offset-2 col-md-8 margin-bottom-20 background-color-white\"><div class=social-login><div><a id=cow_temp_login_fb class=\"btn btn-block btn-social btn-facebook facebook-button\" ng-click=loginFb()><span class=\"fa fa-facebook\"></span> Ingresa con Facebook</a></div><div class=google-social><a id=cow_temp_login_gg class=\"btn btn-block btn-social btn-google google-button\" ng-click=loginGg()><img src=assets/images/utils/google-logo.svg class=\"no-outline img-google-logo\" alt=google-maps-logo> Ingresa con Google</a></div></div><div class=email-login><form name=loginForm ng-submit=loginUser(loginForm.$valid) novalidate><h3 class=text-center>Iniciar sesión</h3><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"loginForm.email.$invalid && loginForm.$submitted\"><label>Correo</label><input id=cow_temp_login_email required name=email maxlength=100 ng-model=user.email type=email placeholder=\"Ingresa acá tu correo\"><div ng-messages=loginForm.email.$error><div ng-message=required>Por favor, digita tu correo.</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"loginForm.password.$invalid && loginForm.$submitted\"><label>Contraseña</label><input id=cow_temp_login_password required name=password maxlength=100 minlength=8 ng-model=user.password type=\"{{(show_password)? \'text\': \'password\'}}\" placeholder=\"Ingresa acá tu contraseña\"><div ng-messages=loginForm.password.$error><div ng-message=required>Por favor, digita tu contraseña.</div><div ng-message=minlength>Tu contraseña debe ser mínimo de 8 caracteres.</div></div></md-input-container><div class=\"col-md-6 no-padding-left\"><a id=cow_temp_login_forgot_password href=\"\" ui-sref=forgot-password>Ohh no ¿Olvidaste tu contraseña?</a></div><p ng-show=errorSended class=\"text-danger login-error-msg\">{{errorMessage}}</p><button id=cow_temp_login_submit class=\"btn btn-default pull-right button-action-small-fep\" type=submit>Iniciar sesión</button></form></div></div></uib-tab></uib-tabset></div><div class=\"container text-center margin-bottom-20\" ng-if=fepCowExist><h3>Ya tienes una alcancía creada con este usuario</h3><h5>Haz clic en el siguiente botón para ver y administrar tu alcancía</h5><button class=\"btn btn-default button-action-small-fep\" type=button ng-click=goToFepCow()>Ver mi alcancía</button></div><div><fep-footer></fep-footer></div><script type=text/ng-template id=atvBenefitsInfoModal><div class=\"ngdialog-message\">\n        <div class=\"text-center\">\n            <img src=\"../../../assets/images/fep/logo-fep.png\" class=\"height-30 margin-bottom-20\"/>\n            <h3 class=\"margin-top-10\">¡Estás a un paso de tener tu alcancía!</h3>\n            <p class=\"font-size-13-sm-xs\">\n                Regístrate o inicia sesión para crear tu <strong> Alcancía Virtual</strong> (No olvides revisar las\n                <a href=\"https://alcancia.festivalestereopicnic.com/\" target=\"_blank\">\n                    FAQs</a>):\n            </p>\n            <ul class=\"text-left font-size-13-sm-xs\">\n                <li>Asegura tus boletas pagando el 10% del total</li>\n                <li>Paga poco a poco y completa el monto total hasta 2 semanas antes del evento</li>\n                <li>Ahorra individualmente o en grupo</li>\n                <li>Si prefieres realizar tu ahorro físico, dirígete a los puntos Tuboleta</li>\n            </ul>\n            <a class=\"smGlobalBtn confirmContactBtn\" ng-click=\"closeBenefitsInfoModal(ngDialogId)\"></a>\n        </div>\n    </div></script>");
$templateCache.put("app/views/fep/fepLogin/fepLogin.html","<div><fep-navbar></fep-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title-fep page-title-fep fep-piggy-background\"><h1 class=\"font-color-fep margin-top-40-md\"><b>Inicia Sesión</b></h1><p>Ingresa para administrar tu alcancía</p></div></div><div class=\"container login-form\" ng-if=!showNoFepCow><div class=\"row login-form-content col-md-offset-2 col-md-8\"><div class=social-login><div><a id=login_sigin_fb class=\"btn btn-block btn-social btn-facebook facebook-button\" ng-click=loginFb()><span class=\"fa fa-facebook facebook-logo-button-register\"></span> Ingresa con Facebook</a></div><div class=google-social><a id=login_sigin_gg class=\"btn btn-block btn-social btn-google google-button\" ng-click=loginGg()><img src=assets/images/utils/google-logo.svg class=\"no-outline img-google-logo\" alt=google-maps-logo> Ingresa con Google</a></div></div><div class=email-login><form name=loginForm ng-submit=loginUser(loginForm.$valid) novalidate><h3 class=text-center>Iniciar sesión</h3><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"loginForm.email.$invalid && loginForm.$submitted\"><label>Correo</label><input id=login_email required name=email maxlength=100 ng-model=user.email type=email placeholder=\"Ingresa acá tu correo\"><div ng-messages=loginForm.email.$error><div ng-message=required>Por favor, digita tu correo.</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\" md-is-error=\"loginForm.password.$invalid && loginForm.$submitted\"><label>Contraseña</label><input id=login_password required name=password maxlength=100 minlength=8 ng-model=user.password type=\"{{(show_password)? \'text\': \'password\'}}\" placeholder=\"Ingresa acá tu contraseña\"><div ng-messages=loginForm.password.$error><div ng-message=required>Por favor, digita tu contraseña.</div><div ng-message=minlength>Tu contraseña debe ser mínimo de 8 caracteres.</div></div></md-input-container><div class=\"col-md-6 no-padding-left\"><a id=login_forgot_password_link href=\"\" ui-sref=forgot-password>Ohh no ¿Olvidaste tu contraseña?</a></div><p ng-show=errorSended class=\"text-danger login-error-msg\">{{errorMessage}}</p><button id=login_btn_submit class=\"btn btn-default pull-right button-action-small-fep margin-bottom-10\" type=submit>Iniciar sesión</button></form></div></div></div><div class=\"container margin-bottom-20\" ng-if=showNoFepCow><h3 class=text-center>Aún no tienes una alcancía</h3><h4 class=text-center>Crea tu alcancía ahora mismo y asegura tus boletas del Festival Estereo Picnic 2019</h4><div class=\"text-center margin-top-bottom-40\"><a href=https://alcancia.festivalestereopicnic.com/ ><img class=\"margin-auto height-150\" src=assets/images/fep/ticket.png alt=ticket-fep></a></div></div><div><fep-footer></fep-footer></div>");
$templateCache.put("app/views/fep/fepParticipate/fepParticipate.html","<div><fep-navbar></fep-navbar></div><div class=\"main-top-content-participate-fep font-color-gray fep-piggy-background\"><div class=container><div class=\"row margin-bottom-20\"><h2 class=text-center><b>{{cow_event.name}}</b></h2><h4 class=text-center><b>Organizada por: {{cow_event.made_by}}</b></h4></div></div></div><div id=top-scroll></div><div class=\"container-fluid background-color-white\" ng-show=\"!cow_event.deleted && !cow_event.closed\"><div class=container><div class=\"row col-md-8 user-data-form-content col-md-offset-2\"><div ng-show=showPersonalDataForm><!--Datos personales    --><div class=\"row text-center\"><h3 class=\"text-center margin-bottom-20\">Datos Responsable Pago</h3></div><form name=personalInfoForm id=personalInfoForm ng-submit=submitPersonalForm(personalInfoForm.$valid) ng-show=showPersonalInfoForm novalidate><!--<form name=\"personalInfoForm\" id=\"personalInfoForm\" class=\"\"--><!--ng-submit=\"participateCow(personalInfoForm.$valid && user_participation.total_value >= minPaymentValue)\"--><!--novalidate>--><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=\"\"><label>Nombre</label><input required name=first_name placeholder=\"Nombre responsable del pago\" md-maxlength=50 ng-model=user_participation.first_name><div ng-messages=personalInfoForm.first_name.$error><div ng-message=required>Por favor digita un nombre.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm=\"\"><label>Apellido</label><input required name=last_name placeholder=\"Apellido responsable del pago\" md-maxlength=50 ng-model=user_participation.last_name><div ng-messages=personalInfoForm.last_name.$error><div ng-message=required>Por favor digita un apellido.</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-md\" flex-gt-sm=\"\"><label>Tipo de documento</label><md-select ng-model=user_participation.document_type><md-option ng-repeat=\"document in documentTypes\" value={{document.id}}>{{document.key_type_name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block no-margin-md margin-top-30-sm-xs\" flex-gt-sm=\"\" ng-show=\"user_participation.document_type == 1 || user_participation.document_type == 2\"><label>N° de documento</label><input ng-model=user_participation.document_number name=document_number type=tel pattern=[0-9]{1,15} only-digits required placeholder=\"Documento responsable del pago\"><div ng-messages=personalInfoForm.document_number.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>El número de documento debe contener entre 6 y 15 caracteres numéricos</div></div></md-input-container><md-input-container class=\"md-block no-margin-md margin-top-30-sm-xs\" flex-gt-sm=\"\" ng-show=\"user_participation.document_type == 3 || user_participation.document_type == 4\"><label>N° de documento</label><input ng-model=user_participation.document_full_number name=document_full_number pattern=\"^(?=.*\\d).{1,15}\" ng-required=\"user_participation.document_type == 3 || user_participation.document_type == 4\" ng-change=setDocumentNumber() only-alphanumeric placeholder=\"Documento responsable del pago\"><div ng-messages=personalInfoForm.document_full_number.$error multiple md-auto-hide=true><div ng-message=required>El número de documento es obligatorio</div><div ng-message=pattern>El número de documento debe contener entre 6 y 15 caracteres alfanuméricos</div></div></md-input-container><div ng-show=\"user_participation.document_type==2\"><i class=\"fa fa-info-circle tooltip-document\" tooltip-placement=bottom uib-tooltip=\"Digita el numero NIT incluyendo dígito de verificación\" aria-hidden=true></i></div></div><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\"><label>Correo electrónico</label><input required name=email placeholder=\"Correo responsable del pago\" md-maxlength=60 ng-model=user_participation.email type=email><div ng-messages=personalInfoForm.email.$error><div ng-message=required>Por favor digita el correo.</div></div></md-input-container><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\"><label>Número celular</label><input ng-model=user_participation.cellphone name=cellphone type=tel pattern=[0-9]{10,12} only-digits required placeholder=\"Celular responsable del pago\"><div ng-messages=personalInfoForm.cellphone.$error multiple md-auto-hide=true><div ng-message-exp=\"[\'required\']\">Por favor digita el número celular</div><div ng-message-exp=\"[\'pattern\']\">El número celular debe contener entre 10 y 12 números y contener solo caracteres numericos</div></div></md-input-container></div></form><div class=\"col-md-3 col-md-offset-9 col-sm-offset-5 col-sm-7 col-xs-offset-5 col-xs-7 no-padding-left-xs-sm no-padding-right margin-bottom-10\" ng-show=showPersonalInfoForm><button type=submit form=personalInfoForm name=button class=\"form-control font-size-13-sm-xs\"><i class=\"fa fa-check font-color-atv\" aria-hidden=true></i> Listo</button></div><!--Resumen datos personales--><div class=\"col-md-12 no-padding-left-right margin-bottom-10\" ng-show=!showPersonalInfoForm><div class=\"col-md-6 personal-info-payment-div\"><p class=no-margin-bottom>Nombre: <b>{{user_participation.first_name + \' \' + user_participation.last_name}}</b></p><p class=no-margin-bottom ng-show=\"user_participation.document_type == 1 || user_participation.document_type == 2\">Documento: <b>{{user_participation.document_number}}</b></p><p class=no-margin-bottom ng-show=\"user_participation.document_type == 3 || user_participation.document_type == 4\">Documento: <b>{{user_participation.document_full_number}}</b></p><p class=no-margin-bottom>Email: <b>{{user_participation.email }}</b></p><p class=no-margin-bottom>Número celular: <b>{{user_participation.cellphone }}</b></p></div></div><div class=\"col-md-5 col-md-offset-7 col-sm-offset-3 col-sm-9 col-xs-offset-3 col-xs-9 no-padding-left-xs-sm no-padding-right margin-bottom-10\" ng-show=!showPersonalInfoForm><button type=button form=personalInfoForm name=button class=\"form-control font-size-13-sm-xs\" ng-click=showPersonalInfoFormEdit()><i class=\"fa fa-pencil-square-o font-color-blue\" aria-hidden=true></i> Editar datos</button></div><div class=row ng-show=\"cow_event.is_business && cow_event.business_type == 0\"><h3 class=\"margin-bottom-20 no-margin-top text-center\">Datos Participante</h3><div class=\"padding-left-right margin-bottom-20\"><textarea rows=3 class=\"form-control no-resize\" ng-model=user_participation.message placeholder=\"Datos de quien asiste al evento (estudiante, jugador, etc)\">\n              </textarea></div></div><!--Participación--><div class=\"row text-center\"><h3 class=margin-top-bottom-20>Participación</h3><p ng-show=\"cow_event.participation_fixed && !cow_event.marketplace\" class=no-margin-bottom><i class=\"fa fa fa-exclamation-circle font-color-atv\"></i> El administrador fijó la participación en un monto fijo.</p></div><form name=participationForm id=participationForm novalidate><div class=\"row padding-left-right\" ng-show=\"cow_event.participation_fixed && !cow_event.marketplace\"><div layout=div layout-align=\"start center\"><md-select name=participant_num ng-model=user_participation.fixed_participants flex-gt-sm=5 flex-xs=5 required><md-option value=1>1</md-option><md-option value=2>2</md-option><md-option value=3>3</md-option><md-option value=4>4</md-option><md-option value=5>5</md-option><md-option value=6>6</md-option><md-option value=7>7</md-option><md-option value=8>8</md-option></md-select><p></p><p class=margin-left-55>Elige el número de participaciones que vas a pagar (Max 8)</p></div><!--<p class=\"font-size-12\">*Recuerda que se generará un cobro de--><!--{{additionalParticipantFee | currency:\"$\":\'0\'}} pesos por cada participante adicional.</p>--></div><div class=row ng-show=\"cow_event.is_business && cow_event.options && cow_event.has_options\" ng-repeat=\"participantsOptions in user_participation.participantsOptions track by participantsOptions.id\"><h4 class=\"margin-bottom-20 no-margin-top text-center\" ng-show=!cow_event.participation_fixed>Opciones</h4><h4 class=\"margin-bottom-20 no-margin-top text-center\" ng-show=cow_event.participation_fixed>Opciones participante {{$index + 1}}</h4><div class=\"col-md-6 col-md-offset-right-6 margin-top-20 margin-top-35-sm-xs\" ng-repeat=\"optionObj in cow_event.options.custom_options track by $index\"><div layout-gt-sm=row><md-input-container class=\"md-block no-margin-top no-padding-left\" flex-gt-sm=\"\"><label>{{optionObj.option_type.name}}</label><md-select ng-model=user_participation.participantsOptions[participantsOptions.id].options[$index] required ng-change=totalValueChanged() md-no-asterisk><md-option ng-repeat=\"option in optionObj.options\" value=\"{{optionObj.option_type.id+\'-\'+option.id}}\">{{option.name}}</md-option></md-select></md-input-container></div></div></div><div class=\"row padding-left-right-top\" layout-gt-sm=row><md-input-container class=\"md-block no-margin-bottom\" flex-gt-sm=\"\"><label>Monto a abonar (COP)</label><input ng-model=user_participation.total_value name=total_value ui-money-mask=0 type=tel required placeholder=$ ng-readonly=totalAmountReadOnly ng-change=totalValueChanged()><p ng-show=\"personalInfoForm.$submitted && user_participation.total_value && (user_participation.total_value < minPaymentValue)\" class=validation-messages>El monto mínimo de participación es de {{minPaymentValue | currency:\"$\":\'0\'}} COP</p><p ng-show=\"personalInfoForm.$submitted && user_participation.total_value && (user_participation.total_value > valueToGoal)\" class=validation-messages>El monto máximo de participación es de {{valueToGoal | currency:\"$\":\'0\'}} COP</p><p ng-show=\"personalInfoForm.$submitted && user_participation.total_value &&\n                                    ((valueToGoal - minPaymentValue) < user_participation.total_value) && (user_participation.total_value < valueToGoal)\" class=validation-messages>No puedes dejar un saldo menor a {{minPaymentValue | currency:\"$\":\'0\'}} COP por pagar</p></md-input-container></div><div class=\"row margin-bottom-10\" ng-if=\"user_participation.total_value >= minPaymentValue\"><div ng-show=\"user_participation.fixed_participants > 1\" ng-repeat=\"participantOptions in user_participation.participantsOptions track by participantOptions.id\"><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=\"pull-left font-size-13\">Participante {{$index + 1}}</p></div><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=pull-right>{{cow_event.participant_value_fixed + additionalValues[$index].additionalValue | currency:\"$\":\'0\'}} COP</p></div></div><div ng-show=cow_event.commission_added><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=\"pull-left font-size-13\">Costo de servicio</p></div><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=pull-right>{{commission_value | currency:\"$\":\'0\'}} COP</p></div><!--<div ng-show=\"user_participation.fixed_participants > 1\">--><!--<div class=\"col-md-6 col-xs-6 col-sm-6\">--><!--<p class=\"pull-left font-size-13\">--><!--Cobro por participante adicional (x{{user_participation.fixed_participants - 1}})--><!--</p>--><!--</div>--><!--<div class=\"col-md-6 col-xs-6 col-sm-6\">--><!--<p class=\"pull-right\">--><!--{{multiple_participants_fee | currency:\"$\":\'0\'}}--><!--</p>--><!--</div>--><!--</div>--><div class=\"col-md-6 col-xs-6 col-sm-6\" ng-show=\"gift_code_obj.type==0 || gift_code_obj.type==1\"><p class=\"pull-left font-size-13\">{{gift_code_obj.name}}</p></div><div class=\"col-md-6 col-xs-6 col-sm-6\" ng-show=\"gift_code_obj.type==0 || gift_code_obj.type==1\"><p class=pull-right>-{{gift_code_obj.discount_value | currency:\"$\":\'0\'}} COP</p></div><div class=\"col-md-12 col-xs-12 col-sm-12 no-padding\"><hr class=hr-partipation></div></div><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=\"pull-left font-size-15\"><b>Total</b></p></div><div class=\"col-md-6 col-xs-6 col-sm-6\"><p class=pull-right>{{total_value_commission | currency:\"$\":\'0\'}} COP</p></div></div></form><!--Métodos de pago--><div class=\"row text-center\"><h3 class=\"text-center margin-bottom-20\">Selecciona el método de pago</h3></div><!--PSE--><div class=\"row padding-left-right-bottom\"><div class=\"col-md-3 col-sm-6 col-xs-6 no-padding-left-right no-outline\" ng-click=paymentMethodToPse()><p class=payment-method-title>Cuenta de Ahorros - PSE</p></div><div class=\"col-md-9 col-sm-6 col-xs-6\"><img class=\"img-responsive payment-method-image-pse no-outline\" src=assets/images/payment-methods/pse.png alt=payment-methods ng-click=paymentMethodToPse() ng-class=\"(pseCollapsed)?\'filter-gray\':\'no-filter-gray\'\"></div></div><div uib-collapse=pseCollapsed class=\"row padding-left-right-bottom\"><div class=\"col-md-11 no-padding-left\"><p>Para pagar con PSE debes <b>tener habilitada esta opción</b> con tu entidad bancaria y el monto a pagar no debe superar los <b>topes que te han habilitado</b>. El pago puede tardar hasta <b>30 minutos en verse reflejado</b>.</p></div><md-checkbox ng-model=user_participation.send_promotional_emails aria-label=\"Checkbox 3\">Deseo recibir más información sobre los servicios de ArmaTuVaca</md-checkbox></div><!--TC --><div class=\"row padding-left-right-bottom\"><div class=\"col-md-3 col-sm-3 col-xs-3 no-padding-left-right no-outline\" ng-click=paymentMethodToCc()><p class=payment-method-title>Tarjeta de crédito</p></div><div class=\"col-md-2 col-sm-3 col-xs-3 text-center\"><img class=\"img-responsive payment-method-image-cc no-outline\" src=assets/images/payment-methods/mastercard.png alt=payment-methods ng-click=paymentMethodToCc() ng-class=\"(ccCollapsed)?\'filter-gray\':\'no-filter-gray\'\"></div><div class=\"col-md-2 col-sm-3 col-xs-3 text-center\"><img class=\"img-responsive payment-method-image-cc no-outline\" src=assets/images/payment-methods/visa.png alt=payment-methods ng-click=paymentMethodToCc() ng-class=\"(ccCollapsed)?\'filter-gray\':\'no-filter-gray\'\"></div><div class=\"col-md-2 col-sm-3 col-xs-3 text-center\"><img class=\"img-responsive payment-method-image-cc-diners no-outline\" src=assets/images/payment-methods/diners.png alt=payment-methods ng-click=paymentMethodToCc() ng-class=\"(ccCollapsed)?\'filter-gray\':\'no-filter-gray\'\"></div></div><div uib-collapse=ccCollapsed class=\"row padding-left-right-bottom\"><div ng-show=\"userCreditCards.length>0\"><h3 class=text-center>Tarjetas Guardadas</h3></div><div class=\"col-md-12 no-padding-left-right\" ng-show=\"userCreditCards.length>0\"><div class=\"col-md-8 col-md-offset-2 no-padding-left-right\"><div class=\"col-md-6 no-padding-left-right\" ng-repeat=\"credit_card in userCreditCards track by $index\"><md-list-item class=\"contact-item selected list-contact\"><img ng-if=\"credit_card.franchise==1\" src=assets/images/payment-methods/visa.png class=md-avatar alt=visa-img> <img ng-if=\"credit_card.franchise==2 || credit_card.franchise==3\" src=assets/images/payment-methods/mastercard.png class=md-avatar alt=mastercard-img> <img ng-if=\"credit_card.franchise==4\" src=assets/images/payment-methods/diners.png class=md-avatar alt=diners-img><div><p class=font-size-11>{{credit_card.card_name}}</p><p class=\"no-margin-bottom font-size-10\">**** **** **** {{credit_card.last_numbers}}</p><md-checkbox ng-model=credit_card.checked class=\"font-bold font-color-atv right-corner-item\" ng-change=checkedChanged(credit_card)></md-checkbox></div></md-list-item></div></div></div><div ng-if=\"user && !creditCardSelected\"><h3 class=text-center>Tarjeta Nueva</h3></div><div class=\"col-md-12 no-padding-left-right\" ng-show=\"!creditCardSelected && !ccCollapsed\"><form name=ccForm novalidate><div class=\"col-md-8 col-md-offset-2 no-padding-left-right\"><div><div class=\"div-credit-card-main col-md-12 div-credit-card\"><div class=\"col-md-12 no-padding-left-right\"><div class=\"col-md-9 col-sm-9 col-xs-12 no-padding-right\"><div class=form-group-atv-cc><label for=cardNumber class=cc-title>Número de la tarjeta</label><input type=tel class=form-control-atv-cc placeholder=\"\" cc-format=4242424242424242 id=cardNumber cc-number cc-eager-type name=ccNumber ng-model=user_participation.card.number ng-required=true></div></div></div><div class=\"col-md-12 no-padding-left-right\"><div class=\"col-md-offset-4 col-sm-offset-2 col-xs-offset-2 col-md-2 col-sm-3 col-xs-3 no-padding-left-right\"><div class=form-group-atv-cc><label class=cc-title>Mes</label><select class=\"form-control div-select-payment\" placeholder=MM ng-model=user_participation.card.month required><option value=\"\" selected hidden>MM</option><option ng-repeat=\"month in ccMonths\" value={{month.id}}>{{month.id}}</option></select></div></div><div class=\"col-md-1 col-sm-1 col-xs-1 no-padding-left-right\"><span class=span-payment-card>/</span></div><div class=\"col-md-2 col-sm-3 col-xs-3 no-padding-left-right\"><div class=form-group-atv-cc><label class=cc-title>Año</label><select class=\"form-control div-select-payment\" ng-class=\"(user_participation.card.year)?\'\':\'font-size-10\'\" placeholder=YY ng-model=user_participation.card.year name=ccExpYear required><option value=\"\" selected hidden>AA</option><option ng-repeat=\"year in ccYears\" value={{year.id}}>{{year.id}}</option></select></div></div></div><div class=\"col-md-12 no-padding-left-right\"><div class=\"col-md-9 col-sm-9 col-xs-12 no-padding-right\"><div class=form-group-atv-cc><label class=cc-title>Nombre tal como se ve en la tarjeta</label><input type=text class=form-control-atv-cc placeholder=\"\" maxlength=30 id=cardName name=ccName ng-model=user_participation.card.name ng-required=true></div></div><div class=\"col-md-3 col-sm-3 col-xs-3 text-center\" ng-if=\"ccForm.ccNumber.$ccEagerType==\'Diners Club\'\"><img class=\"img-responsive payment-method-image-card-diners\" src=assets/images/payment-methods/diners_logo.svg alt=payment-methods></div><div class=\"col-md-3 col-sm-3 col-xs-3 text-center\" ng-if=\"ccForm.ccNumber.$ccEagerType==\'Visa\'\"><img class=\"img-responsive payment-method-image-card-visa\" src=assets/images/payment-methods/visa_logo.svg alt=payment-methods></div><div class=\"col-md-3 col-sm-3 col-xs-3 text-center\" ng-if=\"ccForm.ccNumber.$ccEagerType==\'MasterCard\'\"><img class=\"img-responsive payment-method-image-card-mc\" src=assets/images/payment-methods/mc_logo.svg alt=payment-methods></div></div></div></div></div><div class=\"col-md-12 no-padding-left-right margin-top-20-sm-xs\"><div class=\"col-md-8 col-md-offset-2 no-padding-left-right\" ng-show=\"ccForm.$submitted && !ccForm.ccNumber.$valid\"><p class=\"validation-messages no-margin-top\">Ingresa un número de tarjeta válido.</p></div><div class=\"col-md-8 col-md-offset-2 no-padding-left-right\" ng-show=\"actualMonth>user_participation.card.month && actualYear==user_participation.card.year\"><p class=\"validation-messages no-margin-top\">Fecha de vencimiento inválida.</p></div><div class=\"col-md-8 col-md-offset-2 no-padding-left-right\" ng-show=\"ccForm.$submitted && (!user_participation.card.month || !user_participation.card.year)\"><p class=\"validation-messages no-margin-top\">Fecha de vencimiento inválida.</p></div><div class=\"col-md-8 col-md-offset-2 no-padding-left-right\" ng-show=\"ccForm.$submitted && !user_participation.card.name\"><p class=\"validation-messages no-margin-top\">Ingresa el nombre del titular de la tarjeta.</p></div><div class=\"col-md-8 col-md-offset-2 no-padding-left-right\" ng-show=\"ccForm.ccNumber.$ccEagerType ==\'American Express\'\"><p class=\"validation-messages no-margin-top\">Las tarjetas American Express no son válidas.</p></div></div><div class=\"col-md-8 col-md-offset-2 no-padding-left-right\" ng-if=ccForm.ccNumber.$valid><div class=\"div-credit-card-back col-md-12 no-padding-left-right\"><div><div class=\"col-md-12 no-padding-left-right div-credit-card-back-line\"></div><div class=\"col-md-12 no-padding-left-right\"><div class=\"col-sm-4 col-xs-4 col-sm-offset-8 col-xs-offset-8\"><div class=\"form-group-atv-cc pull-right\"><label class=cc-title>CVC</label><input type=tel class=form-control-atv-cc id=cvc cc-cvc cc-type=ccForm.ccNumber.$ccType name=ccCvc ng-model=$parent.user_participation.card.cvc ng-required=true maxlength=3 minlength=3></div></div></div></div><div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left-right\" ng-show=\"ccForm.$submitted && !ccForm.ccCvc.$valid\"><p class=\"validation-messages no-margin-top\">El CVC es obligatorio y sólo debes ingresar dígitos.</p></div></div></div></form></div><div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left-right\"><div class=row><div class=\"col-md-offset-2 col-md-2 col-sm-3 col-xs-3 no-padding-left-right margin-top-20-sm-xs margin-top-10\"><div class=form-group-atv-cc><label class=cc-title>Cuotas</label><select class=\"form-control div-select-payment\" placeholder=01 ng-model=user_participation.card_installments ng-init=\"user_participation.card_installments=\'1\'\" required><option ng-repeat=\"installment in ccInstallments\" value={{installment.id}}>{{installment.id}}</option></select></div></div></div></div><div class=\"col-md-12 col-sm-12 col-xs-12 margin-top-20\"><div class=row ng-if=\"user && !creditCardSelected\"><md-checkbox ng-model=$parent.user_participation.save_credit_card aria-label=\"Checkbox 3\">Guardar tarjeta de crédito para futuras participaciones</md-checkbox></div><div class=row><md-checkbox ng-model=user_participation.send_promotional_emails aria-label=\"Checkbox 3\">Deseo recibir más información sobre los servicios de ArmaTuVaca</md-checkbox></div></div></div></div><!--<div ng-show=\"showSummary\" class=\"padding-15\">--><div ng-show=showSummary class=padding-15><div class=\"row text-center\"><h3 class=\"text-center margin-bottom-20\">Resumen del pago</h3></div><div class=row><h4>Datos responsable pago</h4><p class=no-margin-bottom>Nombre: <b>{{user_participation.first_name + \' \' + user_participation.last_name}}</b></p><p class=no-margin-bottom ng-show=\"user_participation.document_type == 1 || user_participation.document_type == 2\">Documento: <b>{{user_participation.document_number}}</b></p><p class=no-margin-bottom ng-show=\"user_participation.document_type == 3 || user_participation.document_type == 4\">Documento: <b>{{user_participation.document_full_number}}</b></p><p class=no-margin-bottom>Email: <b>{{user_participation.email }}</b></p><p class=no-margin-bottom>Número celular: <b>{{user_participation.cellphone }}</b></p></div><div class=row><hr></div><div class=row><h4>Método de pago</h4><div ng-show=pseSummary><div class=\"col-md-1 no-padding-left\"><img class=\"img-responsive payment-method-image-pse no-outline\" src=assets/images/payment-methods/pse.png alt=payment-methods></div><div class=\"col-md-11 no-padding-left\"><p><!--<strong><b>--><!--<i class=\"fa fa-exclamation-triangle font-color-blue\" aria-hidden=\"true\"></i>--><!--</b>--><!--</strong> --> Al hacer clic en <b>Realizar pago</b> serás redireccionado a la pasarela de pagos. No recargues ni cierres la página.<br>Los pagos con PSE pueden tardar hasta <b>30 minutos en verse reflejados</b>.</p></div></div><div ng-show=ccSummary><div class=\"col-md-1 col-xs-3 no-padding-left\"><img ng-if=\"ccForm.ccNumber.$ccEagerType==\'Diners Club\'\" class=\"img-responsive payment-method-image-card-diners\" src=assets/images/payment-methods/diners.png alt=diners-img> <img ng-if=\"ccForm.ccNumber.$ccEagerType==\'Visa\'\" class=\"img-responsive payment-method-image-card-visa\" src=assets/images/payment-methods/visa.png alt=visa-img> <img ng-if=\"ccForm.ccNumber.$ccEagerType==\'MasterCard\'\" class=\"img-responsive payment-method-image-card-mc\" src=assets/images/payment-methods/mastercard.png alt=mastercard-img></div><div class=\"col-md-11 col-xs-9 no-padding-left\"><p>**** **** **** {{ccLastNumbers}}<br>{{user_participation.card.name}}</p></div></div><div ng-show=ccTokenSummary><div class=\"col-md-1 col-xs-3 no-padding-left\"><img ng-if=\"creditCardSelected.franchise==1\" src=assets/images/payment-methods/visa.png class=\"img-responsive payment-method-image-card-visa\" alt=visa-img> <img ng-if=\"creditCardSelected.franchise==2 || creditCardSelected.franchise==3\" src=assets/images/payment-methods/mastercard.png class=\"img-responsive payment-method-image-card-mc\" alt=mastercard-img> <img ng-if=\"creditCardSelected.franchise==4\" src=assets/images/payment-methods/diners.png class=\"img-responsive payment-method-image-card-diners\" alt=diners-img></div><div class=\"col-md-11 col-xs-9 no-padding-left\"><p>**** **** **** {{creditCardSelected.last_numbers}}<br>{{creditCardSelected.card_name}}</p></div></div></div><div class=row><hr></div><div class=row><p class=no-margin-bottom>Valor a pagar: <b>{{total_value_commission | currency:\"$\":\'0\'}} COP</b></p></div></div><div ng-show=showSummary class=margin-top-10><md-checkbox ng-model=acceptTermsConditions aria-label=\"Checkbox 3\" class=no-margin>He leído y acepto los <a id=register_terms_and_conditions_link2 href=https://s3.amazonaws.com/alcancia.festivalestereopicnic.com/docs/TyC.pdf target=_blank>términos y condiciones</a> y la <a id=register_privacy_policy_link2 href=https://s3.amazonaws.com/alcancia.festivalestereopicnic.com/docs/PoliticaDatos.pdf target=_blank>política de tratamiento de datos.</a></md-checkbox><p ng-show=!acceptTermsConditions class=validation-messages>Debes aceptar para finalizar el pago</p></div><div class=\"row padding-left-right-bottom\" ng-show=payment_pending><br><p ng-show=payment_pending><strong><b><i class=\"fa fa-exclamation-triangle font-color-blue\" aria-hidden=true></i> </b></strong>&nbsp;En este momento nuestro proveedor de pagos se encuentra verificando tu transacción anterior en estado <strong>pendiente</strong>. Recuerda que si pagaste usando PSE este proceso puede tardar hasta <strong>30 minutos</strong>. Si deseas mayor información sobre el estado actual de la operación puedes enviar un correo electrónico a <strong>contacto@armatuvaca.com</strong> y/o consulta tu pago haciendo click <span ng-click=checkPreviousParticipation() style=\"text-decoration: underline;cursor: pointer\"><b>aquí</b></span>.</p><br><br></div><div class=\"row padding-15\"><a href=\"\" ng-click=goToFepCow(cow_event.cow_event_id) ng-show=showPersonalDataForm class=\"return-payment-link font-color-pink\"><b><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</b></a> <a href=\"\" ng-click=backToPersonalDataForm() ng-show=showSummary class=\"return-payment-link font-color-pink\"><b><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</b></a> <button ng-click=submitPayment() class=\"btn btn-default button-action-small-fep pull-right\" ng-show=showPersonalDataForm>Continuar</button> <button ng-click=confirmPayment() class=\"btn btn-default button-action-small-fep pull-right\" ng-show=\"!payment_pending && showSummary\">Realizar pago</button></div></div></div></div><form-submitter></form-submitter><div class=loader-payment ng-show=payment_redirect><div class=container><h1 class=\"font-color-white text-center title-loader-payment\">Redireccionando a la plataforma de pagos</h1></div><div class=spinner-payment><div class=cube1-payment></div><div class=cube2-payment></div></div></div><div><fep-footer></fep-footer></div>");
$templateCache.put("app/views/password/forgotPassword/forgotPassword.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Recupera tu cuenta</b></h1><p>Debes estar registrado con tu correo electrónico</p></div></div><div class=container><div class=\"row col-md-6 col-md-offset-3 forgot-password-content\"><form name=formForgotPasswordEmail ng-submit=forgotPasswordEmail(formForgotPasswordEmail.$valid) novalidate><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"formForgotPasswordEmail.email.$invalid && formForgotPasswordEmail.$submitted\"><label>Correo registrado</label><input id=forgot_password_email required name=email minlength=10 maxlength=100 ng-pattern=/^.+@.+\\..+$/ ng-model=email type=email placeholder=\"Ingresa acá tu correo\"><div ng-messages=formForgotPasswordEmail.email.$error><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Por favor, digita un correo valido.</div></div></md-input-container><p ng-show=emailSended class=\"text-danger font-color-atv p-success\">{{emailSendedMessage}}</p><p ng-show=errorEmailSended class=\"text-danger forgot-pssw-error-msg\">{{errorEmailMessage}}</p><div class=\"row padding-15\"><button id=forgot_password_come_back class=\"btn btn-default button-action-small-pink pull-left\" ui-sref=login type=button><i class=\"fa fa-arrow-circle-o-left atv-icon\" aria-hidden=true></i>Volver</button> <button id=forgot_password_submit class=\"btn btn-default button-action-small pull-right\" type=submit>Enviar</button></div><!-- <button class=\"btn btn-default pull-right button-action-inherit\" type=\"submit\"></button> --></form></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/password/recoveryCellphonePassword/recoveryCellphonePassword.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center top-title-head\"><h1>Reestrablece la contraseña de tu cuenta</h1><p>Cambia la contraseña para que sigas armando vacas o creando eventos</p></div><div class=container-fluid><div class=\"container col-md-4 col-md-offset-4 recovery-email margin-bottom-20\" ng-show=show_form><form name=changePasswordForm ng-submit=\"changePassword(changePasswordForm.$valid && (password==confirm_password))\" novalidate><h3 class=text-center>Cambiar contraseña</h3><md-input-container class=md-block flex-gt-sm=\"\"><label>Contraseña</label><input required name=password maxlength=100 minlength=8 ng-model=password type=\"{{(show_password)? \'text\': \'password\'}}\"><div ng-messages=changePasswordForm.password.$error><div ng-message=required>Por favor, digita tu contraseña.</div><div ng-message=minlength>Tu contraseña debe ser mínimo de 8 caracteres.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm=\"\"><label>Confirmar nueva contraseña</label><input required name=confirm_password maxlength=100 ng-model=confirm_password type=\"{{(show_password)? \'text\': \'password\'}}\"><p ng-show=\"confirm_password != password\" class=validation-messages>Las contraseñas deben ser iguales.</p><div ng-messages=changePasswordForm.confirm_password.$error><div ng-message=required>Por favor, confirma tu nueva contraseña.</div></div></md-input-container><div class=\"col-md-12 no-padding\"><div class=\"col-md-6 no-padding\"><md-checkbox ng-model=show_password aria-label=\"Checkbox 1\">Mostrar contraseñas</md-checkbox></div></div><p ng-show=errorSended class=text-danger>{{errorMessage}}</p><div class=pull-right><button class=\"btn btn-default pull-right button-action\" type=submit>Cambiar</button></div></form></div><div class=\"container col-md-8 col-md-offset-2 margin-bottom-20\" ng-show=show_menu><h3 class=text-center>¡Cambio de contraseña exitoso!</h3><div class=col-md-6><button class=\"btn btn-default pull-right button-action\" ng-click=goToHome()>Ir al inicio</button></div><div class=col-md-6><button class=\"btn btn-default button-action\" type=submit ng-click=goToCow()>Armar una Vaca</button></div></div><div class=\"container col-md-8 col-md-offset-2 margin-bottom-20\" ng-show=show_invalid><h3 class=text-center>El token es invalido o ya ha caducado, por favor genera otro.</h3><div class=col-md-6><button class=\"btn btn-default pull-right button-action\" ng-click=goToHome()>Ir al inicio</button></div><div class=col-md-6><button class=\"btn btn-default button-action\" ng-click=goToForgotPassword()>Recuperar contraseña</button></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/password/recoveryEmailPassword/recoveryEmailPassword.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Reestrablecer contraseña</b></h1><p class=hidden-xs-sm>Cambia la contraseña para que sigas armando Vacas</p></div></div><div class=container-fluid><div class=\"container col-md-4 col-md-offset-4 recovery-email margin-bottom-20\" ng-show=show_form><form name=changePasswordForm ng-submit=\"changePassword(changePasswordForm.$valid && (password==confirm_password))\" novalidate><h3 class=text-center>Cambiar contraseña</h3><md-input-container class=\"md-block margin-top-30\" flex-gt-sm=\"\" md-is-error=\"changePasswordForm.password.$invalid && changePasswordForm.$submitted\"><label>Nueva contraseña</label><input required name=password maxlength=100 minlength=8 ng-model=password type=\"{{(show_password)? \'text\': \'password\'}}\" placeholder=\"Inserta acá tu nueva contraseña\"><div ng-messages=changePasswordForm.password.$error><div ng-message=required>Por favor, confirma tu nueva contraseña</div><div ng-message=minlength>Tu contraseña debe ser mínimo de 8 caracteres.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm=\"\" md-is-error=\"changePasswordForm.confirm_password.$invalid && changePasswordForm.$submitted\"><label>Confirmar nueva contraseña</label><input required name=confirm_password maxlength=100 ng-model=confirm_password type=\"{{(show_password)? \'text\': \'password\'}}\" placeholder=\"Inserta acá nuevamente contraseña\"><p ng-show=\"confirm_password != password\" class=validation-messages>Las contraseñas no coinciden</p><div ng-messages=changePasswordForm.confirm_password.$error><div ng-message=required>Por favor ingresa nuevamente tu contraseña</div></div></md-input-container><div class=\"col-md-12 no-padding\"><div class=\"col-md-6 no-padding\"><md-checkbox ng-model=show_password aria-label=\"Checkbox 1\">Mostrar contraseñas</md-checkbox></div></div><p ng-show=errorSended class=text-danger>{{errorMessage}}</p><div class=center-item><button class=\"btn btn-default pull-right button-action\" type=submit>Cambiar contraseña</button></div></form></div><div class=\"container col-md-8 col-md-offset-2 margin-bottom-20\" ng-show=show_menu><h3 class=text-center>¡Cambio de contraseña exitoso!</h3><div class=col-md-6><button class=\"btn btn-default pull-right button-action\" ng-click=goToHome()>Ir al inicio</button></div><div class=col-md-6><button class=\"btn btn-default button-action pull-left\" ng-click=goToForgotPassword()>Recuperar contraseña</button></div></div><div class=\"container col-md-8 col-md-offset-2 margin-bottom-20\" ng-show=show_invalid><h3 class=text-center>El token es invalido o ya se encuentra vencido, por favor genera otro.</h3><div class=\"col-md-6 hidden-xs-sm\"><button class=\"btn btn-default pull-right button-action\" ng-click=goToHome()>Ir al inicio</button></div><div class=\"col-md-6 hidden-xs-sm\"><button class=\"btn btn-default button-action pull-left\" ng-click=goToForgotPassword()>Recuperar contraseña</button></div><div class=\"col-sm-2 col-xs-12 hidden-md hidden-lg text-center\"><button class=\"btn btn-default button-action\" ng-click=goToHome()>Ir al inicio</button></div><div class=\"col-sm-2 col-xs-12 hidden-md hidden-lg text-center\"><button class=\"btn btn-default button-action\" ng-click=goToForgotPassword()>Recuperar contraseña</button></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/terms/privacyPolicy/privacyPolicy.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md no-margin-top-sm-xs\"><b>Política de Tratamiento de Datos</b></h1><p></p></div></div><div class=container-fluid><div class=\"container t-and-c-div margin-bottom-20\"><div ng-bind-html=privatePolicy.private_policy></div></div></div><div><atv-footer></atv-footer></div>");
$templateCache.put("app/views/terms/termsAndConditions/termsAndConditions.html","<div><atv-navbar></atv-navbar></div><div class=\"container-fluid text-center\"><div class=\"row page-top-title page-title\"><h1 class=\"font-color-atv margin-top-40-md\"><b>Términos y Condiciones</b></h1><p></p></div></div><div class=container-fluid><div class=\"container t-and-c-div margin-bottom-20\"><div ng-bind-html=termsAndConditions.terms_and_conditions></div></div></div><div><atv-footer></atv-footer></div>");}]);